webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	module.exports = __webpack_require__(332);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _stringify = __webpack_require__(333);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _common = __webpack_require__(419);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _components = __webpack_require__(444);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _services = __webpack_require__(895);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _constants = __webpack_require__(916);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	var _app = __webpack_require__(921);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _angularTranslate = __webpack_require__(932);
	
	var _angularTranslate2 = _interopRequireDefault(_angularTranslate);
	
	var _angularUiGrid = __webpack_require__(933);
	
	var _angularUiGrid2 = _interopRequireDefault(_angularUiGrid);
	
	var _uiSelect = __webpack_require__(935);
	
	var _uiSelect2 = _interopRequireDefault(_uiSelect);
	
	var _angularSanitize = __webpack_require__(937);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularjsBootstrapDatetimepicker = __webpack_require__(939);
	
	var _angularjsBootstrapDatetimepicker2 = _interopRequireDefault(_angularjsBootstrapDatetimepicker);
	
	var _ngmap = __webpack_require__(1080);
	
	var _ngmap2 = _interopRequireDefault(_ngmap);
	
	var _ngDialog = __webpack_require__(1082);
	
	var _ngDialog2 = _interopRequireDefault(_ngDialog);
	
	__webpack_require__(1083);
	
	var _el = __webpack_require__(1084);
	
	var _el2 = _interopRequireDefault(_el);
	
	var _en = __webpack_require__(1085);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _ar = __webpack_require__(1086);
	
	var _ar2 = _interopRequireDefault(_ar);
	
	__webpack_require__(1087);
	
	__webpack_require__(1089);
	
	__webpack_require__(1098);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* FONT AWESOME CSS LOADER */
	var app = _angular2.default.module("app", [_angularUiRouter2.default, _common2.default, _components2.default, _services2.default, _constants2.default, _angularTranslate2.default, _angularUiGrid2.default, _uiSelect2.default, _angularSanitize2.default, _angularjsBootstrapDatetimepicker2.default, _ngmap2.default, _ngDialog2.default, "ui.router.state.events", "AnimatedScroll"]).config(["URLS", "$locationProvider", "$translateProvider", "$urlRouterProvider", "$compileProvider", "Settings", function (URLS, $locationProvider, $translateProvider, $urlRouterProvider, $compileProvider, Settings) {
	  "ngInject";
	
	  /* Location */
	
	  $locationProvider.html5Mode(true).hashPrefix("!");
	
	  /* Translation */
	  $translateProvider.translations("el", _el2.default).translations("en", _en2.default).translations("ar", _ar2.default).preferredLanguage(Settings.PREF_LANGUAGE);
	
	  /* Redirect to dashboard by default */
	  $urlRouterProvider.when("/", "/dashboard");
	
	  /* Disable Debug */
	  $compileProvider.debugInfoEnabled(Settings.DEBUG);
	}]).run(["User", "$rootScope", "$window", "$state", "$stateParams", "Permissions", "$filter", "ngDialog", "Settings", function (User, $rootScope, $window, $state, $stateParams, Permissions, $filter, ngDialog, Settings) {
	  "ngInject";
	
	  var $translate = $filter("translate");
	
	  /* AdBlocker */
	  if (!canRunAds) {
	    ngDialog.open({
	      template: "errorTemplate",
	      data: {
	        message: $translate("AD_BLOCK_MESSAGE")
	      }
	    });
	  }
	
	  $rootScope.app = {
	    name: "Velos",
	    operator: Settings.OPERATOR
	  };
	
	  $rootScope.isLoading = false;
	
	  /* Bind State and State Params */
	  $rootScope.$state = $state;
	  $rootScope.$stateParams = $stateParams;
	
	  /* Permissions */
	  $rootScope.permissions = Permissions;
	
	  $rootScope.isRTL = $window.localStorage.getItem("vLanguage") && $window.localStorage.getItem("vLanguage") === "ar";
	
	  $rootScope.isEOT = Settings.OPERATOR === Settings.OPERATORS.EOT;
	  $rootScope.isSAAF = Settings.OPERATOR === Settings.OPERATORS.SAAF;
	
	  /* if responsible design */
	  $rootScope.isSmart = function () {
	    var ua = $window["navigator"]["userAgent"] || $window["navigator"]["vendor"] || $window["opera"];
	    return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/.test(ua)
	    );
	  };
	
	  /* Check if user logged in */
	  $rootScope.isUserLoggedIn = false;
	  if ($window.localStorage.getItem("token")) {
	    $rootScope.isUserLoggedIn = true;
	    $rootScope.token = $window.localStorage.getItem("token");
	    $rootScope.currentUser = JSON.parse($window.localStorage.getItem("user"));
	    $rootScope.user = User.build($rootScope.currentUser);
	  }
	
	  /* Check if user has selected Match */
	  $rootScope.currentMatchId = null;
	  $rootScope.currentMatch = null;
	  if ($window.localStorage.getItem("currentMatchId")) {
	    $rootScope.currentMatchId = $window.localStorage.getItem("currentMatchId");
	    $rootScope.currentMatch = JSON.parse($window.localStorage.getItem("currentMatch"));
	  }
	
	  $rootScope.showLeftSidebar = true;
	  $rootScope.showHeader = true;
	  $rootScope.showFooter = true;
	
	  /* Check in case user logged out or token does not exists */
	  $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
	    $window.scrollTo(0, 0);
	    var isLogin = toState.name === "login";
	    var isReset = toState.name === "reset";
	    var isRecover = toState.name === "recover";
	    var isResults = toState.name === "results";
	    var isPrivacy = toState.name === "privacy";
	    var isMatchShotsIndividualVisual = toState.name === "match-profile.shotsIndividualVisual";
	    if (isMatchShotsIndividualVisual) {
	      $rootScope.showLeftSidebar = false;
	      $rootScope.showHeader = false;
	      $rootScope.showFooter = false;
	    } else {
	      $rootScope.showLeftSidebar = true;
	      $rootScope.showHeader = true;
	      $rootScope.showFooter = true;
	    }
	    if (isLogin || isReset || isRecover || isResults || isPrivacy || isMatchShotsIndividualVisual) {
	      return;
	    }
	
	    var token = $window.localStorage.getItem("token");
	    var isUserLoggedIn = $rootScope.isUserLoggedIn;
	    if (!token || !isUserLoggedIn) {
	      $rootScope.logout();
	      event.preventDefault();
	    }
	
	    if (toState.name === "") {
	      $state.go("dashboard");
	      event.preventDefault();
	    }
	  });
	
	  /* Logout user */
	  $rootScope.logout = function () {
	    $rootScope.isUserLoggedIn = false;
	    $window.localStorage.clear();
	    $state.go("login");
	  };
	
	  /* Select Current Match*/
	  $rootScope.updateMatchData = function (matchData) {
	    $rootScope.currentMatch = matchData;
	    $rootScope.currentMatchId = matchData.match_id;
	    $window.localStorage.setItem("currentMatch", (0, _stringify2.default)($rootScope.currentMatch));
	    $window.localStorage.setItem("currentMatchId", $rootScope.currentMatchId);
	  };
	
	  /* Clear Match Data */
	  $rootScope.clearMatchData = function () {
	    delete $rootScope.currentMatchId;
	    delete $rootScope.currentMatch;
	    delete $window.localStorage.currentMatchId;
	    delete $window.localStorage.currentMatch;
	  };
	}]);
	
	if (window.localStorage.getItem("vLanguage") && window.localStorage.getItem("vLanguage") == "ar") {
	  app.component("app", __webpack_require__(1099).default);
	} else {
	  app.component("app", _app2.default);
	}

/***/ }),
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _uiMenu = __webpack_require__(420);
	
	var _uiMenu2 = _interopRequireDefault(_uiMenu);
	
	var _uiHeader = __webpack_require__(429);
	
	var _uiHeader2 = _interopRequireDefault(_uiHeader);
	
	var _uiFooter = __webpack_require__(435);
	
	var _uiFooter2 = _interopRequireDefault(_uiFooter);
	
	var _shotValidator = __webpack_require__(441);
	
	var _shotValidator2 = _interopRequireDefault(_shotValidator);
	
	var _imageWithPreview = __webpack_require__(442);
	
	var _imageWithPreview2 = _interopRequireDefault(_imageWithPreview);
	
	var _autoFocus = __webpack_require__(443);
	
	var _autoFocus2 = _interopRequireDefault(_autoFocus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var commonModule = _angular2.default.module('app.common', [_uiMenu2.default, _uiHeader2.default, _uiFooter2.default]).directive({ shotValidator: _shotValidator2.default, imageWithPreview: _imageWithPreview2.default, autoFocus: _autoFocus2.default }).name;
	
	exports.default = commonModule;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _uiMenu = __webpack_require__(421);
	
	var _uiMenu2 = _interopRequireDefault(_uiMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uiMenuModule = _angular2.default.module('uiMenu', [_angularUiRouter2.default]).component('uiMenu', _uiMenu2.default).name;
	
	exports.default = uiMenuModule;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _uiMenu = __webpack_require__(422);
	
	var _uiMenu2 = _interopRequireDefault(_uiMenu);
	
	var _uiMenu3 = __webpack_require__(423);
	
	var _uiMenu4 = _interopRequireDefault(_uiMenu3);
	
	__webpack_require__(425);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uiMenuComponent = {
		bindings: {},
		template: _uiMenu2.default,
		controller: _uiMenu4.default,
		controllerAs: 'vm'
	};
	
	exports.default = uiMenuComponent;

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	module.exports = "<ul class=\"nav\">\n    <li class=\"nav-header hidden-folded\">\n        <small class=\"text-muted\" translate>MENU</small>\n    </li>\n\n    <li ui-sref-active=\"active\"\n        ng-repeat=\"menuItem in vm.menuItems\"\n        ng-if=\"menuItem.menuItems.length == 0 && (!menuItem.permission || vm.rootScope.user.canDo(menuItem.permission))\"\n        ng-class=\"{'active': $state.includes(menuItem.route)}\">\n        <a ui-sref=\"{{menuItem.route}}\">\n            <span class=\"nav-icon\">\n                <i class=\"material-icons\" ng-bind-html=\"menuItem.materialIcon\"></i>\n            </span>\n            <span class=\"nav-text\" translate>{{menuItem.name}}</span>\n        </a>\n    </li>\n\n    <li ng-repeat=\"menuItem in vm.menuItems\"\n        ng-if=\"menuItem.menuItems.length > 0 && (!menuItem.permission || vm.rootScope.user.canDo(menuItem.permission))\"\n        ng-click=\"menuItem.visibleItems = !menuItem.visibleItems\"\n        ng-class=\"{'active' : menuItem.visibleItems}\">\n        <a>\n            <span class=\"nav-caret\">\n                <i class=\"fa fa-caret-down\"></i>\n            </span>\n            <span class=\"nav-icon\">\n                <i class=\"material-icons\" ng-bind-html=\"menuItem.materialIcon\"></i>\n            </span>\n            <span class=\"nav-text\" translate>{{menuItem.name}}</span>\n        </a>\n        <ul class=\"nav-sub\">\n            <li ng-repeat=\"child in menuItem.menuItems\"\n                ng-if=\"!child.permission || vm.rootScope.user.canDo(child.permission)\"\n                ui-sref-active=\"active\">\n                <a ui-sref=\"{{child.route}}\">\n                    <span class=\"nav-text\" translate>{{child.name}}</span>\n                </a>\n            </li>\n        </ul>\n    </li>\n\n</ul>"

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UiMenuController = function UiMenuController(Permissions, $rootScope) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, UiMenuController);
	  var vm = this;
	
	  vm.rootScope = $rootScope;
	
	  vm.menuItems = [{
	    /* DASHBOARD */
	    name: "DASHBOARD",
	    route: "dashboard",
	    materialIcon: "&#xe871;",
	    icon: "../../../assets/images/i_0.svg",
	    menuItems: []
	  }, {
	    /* MATCHES */
	    name: "MATCHES",
	    route: "matches-list",
	    materialIcon: "&#xe8e1;",
	    icon: "../../../assets/images/i_4.svg",
	    menuItems: []
	  }, {
	    /* PLAYERS */
	    name: "PLAYERS",
	    route: "players",
	    materialIcon: "&#xe7fd;",
	    icon: "../../../assets/images/i_4.svg",
	    menuItems: []
	  }, {
	    /* TEAMS */
	    name: "TEAMS",
	    route: "teams",
	    materialIcon: "&#xe7ef;",
	    icon: "../../../assets/images/i_4.svg",
	    permission: Permissions.VIEW_ALL_TEAMS,
	    menuItems: []
	  }, {
	    /* JUDGES */
	    name: "JUDGES",
	    route: "judges",
	    materialIcon: "&#xe02f;",
	    icon: "../../../assets/images/i_4.svg",
	    permission: Permissions.VIEW_ALL_JUDGES,
	    menuItems: []
	  }, {
	    /* COACHES */
	    name: "COACHES",
	    route: "coaches",
	    materialIcon: "&#xe566;",
	    icon: "../../../assets/images/i_4.svg",
	    permission: Permissions.VIEW_ALL_COACHES,
	    menuItems: []
	  }, {
	    /* STAFF */
	    name: "STAFF",
	    route: "staff",
	    materialIcon: "&#xe7fb;",
	    icon: "../../../assets/images/i_4.svg",
	    permission: Permissions.VIEW_ALL_STAFF,
	    menuItems: []
	  }, {
	    /* TRAINERS */
	    name: "TRAINERS",
	    route: "trainers",
	    materialIcon: "&#xe536;",
	    icon: "../../../assets/images/i_4.svg",
	    permission: Permissions.VIEW_ALL_TRAINERS,
	    menuItems: []
	  },
	  // {
	  //   /* TRAINING CENTER */
	  //   name: "TRAINING_CENTER",
	  //   route: "trainingCenter",
	  //   materialIcon: "&#xe88a;",
	  //   icon: "../../../assets/images/i_4.svg",
	  //   permission: Permissions.VIEW_ALL_TRAINING_ENTRIES,
	  //   menuItems: [],
	  // },
	  {
	    /* TRAINING CENTER */
	    name: "TRAINING_CENTERS",
	    route: "trainingCenters",
	    materialIcon: "&#xe88a;",
	    icon: "../../../assets/images/i_4.svg",
	    permission: Permissions.VIEW_ALL_TRAINING_ENTRIES,
	    menuItems: []
	  }, {
	    /* LEAGUES */
	    name: "LEAGUES",
	    route: "leagues",
	    materialIcon: "&#xe1b2;",
	    icon: "../../../assets/images/i_4.svg",
	    permission: Permissions.VIEW_ALL_LEAGUES,
	    menuItems: []
	  }, {
	    /* TRANSFERS */
	    name: "TRANSFERS",
	    route: "transfers",
	    materialIcon: "&#xe8d4;",
	    icon: "../../../assets/images/i_4.svg",
	    permission: Permissions.VIEW_ALL_TRANSFERS,
	    menuItems: []
	  }, {
	    /* PAYMENTS */
	    name: "PAYMENTS",
	    route: "payments",
	    materialIcon: "&#xe227;",
	    icon: "../../../assets/images/i_4.svg",
	    permission: Permissions.VIEW_FINANCIAL,
	    visibleItems: false,
	    menuItems: [{
	      name: "PAYMENT_ITEMS",
	      route: "payments-list",
	      visibleItems: false,
	      menuItems: []
	    }, {
	      name: "TEAM_PAYMENTS",
	      route: "payments-team",
	      visibleItems: false,
	      menuItems: []
	    }, {
	      name: "PLAYER_PAYMENTS",
	      route: "payments-player",
	      visibleItems: false,
	      menuItems: []
	    }, {
	      name: "TEAM_PAYMENTS_LIST",
	      route: "payments-team-list",
	      visibleItems: false,
	      permission: Permissions.VIEW_ALL_MOVEMENTS_TEAM,
	      menuItems: []
	    }, {
	      name: "PLAYER_PAYMENTS_LIST",
	      route: "payments-player-list",
	      visibleItems: false,
	      permission: Permissions.VIEW_ALL_MOVEMENTS_PLAYER,
	      menuItems: []
	    }]
	  }, {
	    /* REPORTS */
	    name: "REPORTS",
	    route: "reports",
	    materialIcon: "&#xe24d;",
	    icon: "../../../assets/images/i_4.svg",
	    permission: Permissions.VIEW_REPORTS,
	    menuItems: []
	  }, {
	    /* ROLES */
	    name: "ROLES",
	    route: "roles",
	    materialIcon: "&#xe8c0;",
	    icon: "../../../assets/images/i_4.svg",
	    permission: Permissions.EDIT_ROLES,
	    menuItems: []
	  }, {
	    /* USERS */
	    name: "USERS",
	    route: "users",
	    materialIcon: "&#xe55a;",
	    icon: "../../../assets/images/i_4.svg",
	    permission: Permissions.VIEW_USERS,
	    menuItems: []
	  }];
	};
	UiMenuController.$inject = ["Permissions", "$rootScope"];
	
	exports.default = UiMenuController;

/***/ }),
/* 424 */,
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(426);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./uiMenu.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./uiMenu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 427 */,
/* 428 */,
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _uiHeader = __webpack_require__(430);
	
	var _uiHeader2 = _interopRequireDefault(_uiHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uiHeaderModule = _angular2.default.module('uiHeader', [_angularUiRouter2.default]).component('uiHeader', _uiHeader2.default).name;
	
	exports.default = uiHeaderModule;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _uiHeader = __webpack_require__(431);
	
	var _uiHeader2 = _interopRequireDefault(_uiHeader);
	
	var _uiHeader3 = __webpack_require__(432);
	
	var _uiHeader4 = _interopRequireDefault(_uiHeader3);
	
	__webpack_require__(433);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uiHeaderComponent = {
		bindings: {},
		template: _uiHeader2.default,
		controller: _uiHeader4.default,
		controllerAs: 'vm'
	};
	
	exports.default = uiHeaderComponent;

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"navbar\">\n  <!-- Open side - Naviation on mobile -->\n  <a\n    data-toggle=\"modal\"\n    data-target=\"#aside\"\n    class=\"navbar-item pull-left hidden-lg-up\"\n  >\n    <i class=\"material-icons\">&#xe5d2;</i>\n  </a>\n  <!-- / -->\n\n  <!-- Page title - Bind to $state's title -->\n  <div class=\"navbar-item pull-left h5\" translate>\n    {{vm.state.current.data.pageTitle}}\n  </div>\n\n  <div class=\"navbar-item pull-left\" ng-if=\"$root.currentMatch\">\n    <button\n      ng-bind=\"$root.currentMatch.match_sortname\"\n      ui-sref=\"match-profile\"\n      class=\"btn btn-sm info\"\n    ></button>\n  </div>\n\n  <!-- navbar right -->\n  <ul class=\"nav navbar-nav pull-right\">\n    <li class=\"nav-item m-t-14\">\n      <h5 ng-bind=\"vm.rootScope.user.name\"></h5>\n    </li>\n    <li class=\"nav-item dropdown\">\n      <a class=\"nav-link clear\" href data-toggle=\"dropdown\">\n        <span class=\"avatar w-32\">\n          <img src=\"assets/images/no_avatar.png\" />\n          <i class=\"on b-white bottom\"></i>\n        </span>\n      </a>\n      <div class=\"dropdown-menu pull-left dropdown-menu-scale rtl-pull-left\">\n        <a\n          class=\"dropdown-item\"\n          ng-if=\"vm.vLanguage != 'en'\"\n          ng-click=\"vm.changeLanguage('en')\"\n          translate\n          >ENGLISH</a\n        >\n        <a\n          class=\"dropdown-item\"\n          ng-if=\"vm.vLanguage != 'el' && vm.rootScope.isEOT\"\n          ng-click=\"vm.changeLanguage('el')\"\n          translate\n          >ΕΛΛΗΝΙΚΑ</a\n        >\n        <a\n          class=\"dropdown-item\"\n          ng-if=\"vm.vLanguage != 'ar' && vm.rootScope.isSAAF\"\n          ng-click=\"vm.changeLanguage('ar')\"\n          translate\n          >ARABIC</a\n        >\n        <a class=\"dropdown-item\" ng-click=\"vm.rootScope.logout()\" translate\n          >LOGOUT</a\n        >\n      </div>\n    </li>\n    <li class=\"nav-item hidden-md-up\">\n      <a class=\"nav-link\" data-toggle=\"collapse\" data-target=\"#collapse\">\n        <i class=\"material-icons\">&#xe5d4;</i>\n      </a>\n    </li>\n  </ul>\n  <!-- / navbar right -->\n</div>\n"

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UiHeaderController = function UiHeaderController($rootScope, $state, $translate, $window) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, UiHeaderController);
	  var vm = this;
	
	  vm.state = $state;
	  vm.rootScope = $rootScope;
	
	  /* Language */
	  vm.vLanguage = "en";
	  if ($window.localStorage.getItem("vLanguage")) {
	    vm.vLanguage = $window.localStorage.getItem("vLanguage");
	    $translate.use(vm.vLanguage);
	  }
	
	  vm.changeLanguage = function (key) {
	    vm.vLanguage = key;
	    $translate.use(key);
	    $window.localStorage.setItem("vLanguage", key);
	    $window.location.reload();
	  };
	};
	UiHeaderController.$inject = ["$rootScope", "$state", "$translate", "$window"];
	
	exports.default = UiHeaderController;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(434);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./uiHeader.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./uiHeader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 434 */
426,
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _uiFooter = __webpack_require__(436);
	
	var _uiFooter2 = _interopRequireDefault(_uiFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uiFooterModule = _angular2.default.module('uiFooter', [_angularUiRouter2.default]).component('uiFooter', _uiFooter2.default).name;
	
	exports.default = uiFooterModule;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _uiFooter = __webpack_require__(437);
	
	var _uiFooter2 = _interopRequireDefault(_uiFooter);
	
	var _uiFooter3 = __webpack_require__(438);
	
	var _uiFooter4 = _interopRequireDefault(_uiFooter3);
	
	__webpack_require__(439);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var uiFooterComponent = {
	  bindings: {},
	  template: _uiFooter2.default,
	  controller: _uiFooter4.default,
	  controllerAs: "vm"
	};
	
	exports.default = uiFooterComponent;

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"p-a text-xs\">\n    <div class=\"pull-right text-muted\">\n        &copy; Copyright <strong>{{app.name}}</strong> <span class=\"hidden-xs-down\">- 2018</span>\n        <a ui-scroll-to=\"content\"><i class=\"fa fa-long-arrow-up p-x-sm\"></i></a>\n    </div>\n    <div class=\"nav\"></div>\n</div>\n"

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UiFooterController = function UiFooterController() {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, UiFooterController);
	  var vm = this;
	};
	
	exports.default = UiFooterController;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(440);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./uiFooter.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./uiFooter.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 440 */
426,
/* 441 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		"ngInject";
	
		return {
			require: 'ngModel',
			restrict: 'A',
			link: function link(scope, elem, attr, ngModel) {
	
				ngModel.$validators.shotValidator = function (modelValue, viewValue) {
					if (!viewValue) {
						return true;
					}
	
					if (viewValue >= 0 && viewValue <= 11) {
						return true;
					}
					if (viewValue.toLowerCase() === "m" || viewValue.toLowerCase() === "x") {
						return true;
					}
	
					return false;
				};
			}
		};
	};

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = ["fileReader", "$q", function (fileReader, $q) {
		"ngInject";
	
		var DEFAULT_MIMETYPES = 'image/png,image/jpeg';
		var NOT_AN_IMAGE = 'this-is-not-an-image';
	
		var isAnAllowedImage = function isAnAllowedImage(allowedTypes, file) {
			if (!allowedTypes) {
				allowedTypes = DEFAULT_MIMETYPES;
			}
			var allowedTypeArray = allowedTypes.split(',');
			return allowedTypeArray.some(function (allowedType) {
				if (allowedType === file.type) {
					return true;
				}
				var allowedTypeSplit = allowedType.split('/');
				var fileTypeSplit = file.type.split('/');
				return allowedTypeSplit.length === 2 && fileTypeSplit.length === 2 && allowedTypeSplit[1] === '*' && allowedTypeSplit[0] === fileTypeSplit[0];
			});
		};
		var createResolvedPromise = function createResolvedPromise() {
			var d = $q.defer();
			d.resolve();
			return d.promise;
		};
		return {
			restrict: 'A',
			require: 'ngModel',
			scope: {
				image: '=ngModel',
				allowedTypes: '@accept',
				dimensionRestrictions: '&dimensions',
				sizeRestrictions: '&size'
			},
			link: function link($scope, element, attrs, ngModel) {
				element.bind('change', function (event) {
					var file = (event.srcElement || event.target).files[0];
					// the following link recommends making a copy of the object, but as the value will only be changed
					// from the view, we don't have to worry about making a copy
					// https://docs.angularjs.org/api/ng/type/ngModel.NgModelController#$setViewValue
					ngModel.$setViewValue(file, 'change');
				});
				ngModel.$parsers.push(function (file) {
					if (!file) {
						return file;
					}
					if (!isAnAllowedImage($scope.allowedTypes, file)) {
						return NOT_AN_IMAGE;
					}
					return {
						fileReaderPromise: fileReader.readAsDataUrl(file, $scope)
					};
				});
				$scope.$watch('image', function (value) {
					if (value && typeof value === 'string') {
						$scope.image = {
							src: value,
							isPath: true
						};
					}
				});
				ngModel.$validators.image = function (modelValue, viewValue) {
					var value = modelValue || viewValue;
					return value !== NOT_AN_IMAGE;
				};
				ngModel.$asyncValidators.parsing = function (modelValue, viewValue) {
					var value = modelValue || viewValue;
					if (!value || !value.fileReaderPromise) {
						return createResolvedPromise();
					}
					// This should help keep the model value clean. At least I hope it does
					value.fileReaderPromise.finally(function () {
						delete value.fileReaderPromise;
					});
					return value.fileReaderPromise.then(function (dataUrl) {
						value.src = dataUrl;
					}, function () {
						return $q.reject('Failed to parse');
					});
				};
				ngModel.$asyncValidators.dimensions = function (modelValue, viewValue) {
					if (!attrs.dimensions) {
						return createResolvedPromise();
					}
					var value = modelValue || viewValue;
					if (!value || !value.fileReaderPromise) {
						return createResolvedPromise();
					}
					var deferred = $q.defer();
					value.fileReaderPromise.then(function (dataUrl) {
						// creating an image lets us find out its dimensions after it's loaded
						var image = document.createElement('img');
						image.addEventListener('load', function () {
							var valid = $scope.dimensionRestrictions({
								width: image.width,
								height: image.height
							});
							$scope.$apply(function () {
								if (valid) {
									deferred.resolve();
								} else {
									deferred.reject('Invalid dimensions');
								}
							});
						});
						image.addEventListener('error', function () {
							$scope.$apply(function () {
								deferred.reject('Failed to detect dimensions. Not an image!');
							});
						});
						image.src = dataUrl;
					}, function () {
						deferred.reject('Failed to detect dimensions');
					});
					return deferred.promise;
				};
				ngModel.$asyncValidators.size = function (modelValue, viewValue) {
					if (!attrs.size) {
						return createResolvedPromise();
					}
	
					var value = modelValue || viewValue;
	
					if (!value || !value.fileReaderPromise) {
						return createResolvedPromise();
					}
	
					var deferred = $q.defer();
	
					value.fileReaderPromise.then(function (dataUrl) {
	
						var image = document.createElement('img');
	
						image.addEventListener('load', function () {
							var valid = $scope.sizeRestrictions({
								size: viewValue.size
							});
	
							$scope.$apply(function () {
								if (valid) {
									deferred.resolve();
								} else {
									deferred.reject('Invalid size');
								}
							});
						});
	
						image.src = dataUrl;
					}, function () {
						deferred.reject('Failed to detect size');
					});
					return deferred.promise;
				};
			}
		};
	}];

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = ["$timeout", function ($timeout) {
		"ngInject";
	
		return {
			restrict: 'AC',
			link: function link(_scope, _element) {
				$timeout(function () {
					_element[0].focus();
				}, 0);
			}
		};
	}];

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _results = __webpack_require__(445);
	
	var _results2 = _interopRequireDefault(_results);
	
	var _dashboard = __webpack_require__(525);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _reports = __webpack_require__(531);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _login = __webpack_require__(549);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _recover = __webpack_require__(555);
	
	var _recover2 = _interopRequireDefault(_recover);
	
	var _reset = __webpack_require__(561);
	
	var _reset2 = _interopRequireDefault(_reset);
	
	var _users = __webpack_require__(567);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _paymentsList = __webpack_require__(573);
	
	var _paymentsList2 = _interopRequireDefault(_paymentsList);
	
	var _paymentsTeam = __webpack_require__(579);
	
	var _paymentsTeam2 = _interopRequireDefault(_paymentsTeam);
	
	var _paymentsPlayer = __webpack_require__(585);
	
	var _paymentsPlayer2 = _interopRequireDefault(_paymentsPlayer);
	
	var _paymentsPlayerList = __webpack_require__(591);
	
	var _paymentsPlayerList2 = _interopRequireDefault(_paymentsPlayerList);
	
	var _paymentsTeamList = __webpack_require__(597);
	
	var _paymentsTeamList2 = _interopRequireDefault(_paymentsTeamList);
	
	var _matchesList = __webpack_require__(603);
	
	var _matchesList2 = _interopRequireDefault(_matchesList);
	
	var _matchProfile = __webpack_require__(609);
	
	var _matchProfile2 = _interopRequireDefault(_matchProfile);
	
	var _matchTargets = __webpack_require__(615);
	
	var _matchTargets2 = _interopRequireDefault(_matchTargets);
	
	var _matchLeagues = __webpack_require__(621);
	
	var _matchLeagues2 = _interopRequireDefault(_matchLeagues);
	
	var _matchPrints = __webpack_require__(627);
	
	var _matchPrints2 = _interopRequireDefault(_matchPrints);
	
	var _matchEliminations = __webpack_require__(633);
	
	var _matchEliminations2 = _interopRequireDefault(_matchEliminations);
	
	var _matchFinalize = __webpack_require__(639);
	
	var _matchFinalize2 = _interopRequireDefault(_matchFinalize);
	
	var _matchRegistrations = __webpack_require__(645);
	
	var _matchRegistrations2 = _interopRequireDefault(_matchRegistrations);
	
	var _matchAddShots = __webpack_require__(651);
	
	var _matchAddShots2 = _interopRequireDefault(_matchAddShots);
	
	var _matchAddShotsVisual = __webpack_require__(657);
	
	var _matchAddShotsVisual2 = _interopRequireDefault(_matchAddShotsVisual);
	
	var _matchAddShotsIndividual = __webpack_require__(663);
	
	var _matchAddShotsIndividual2 = _interopRequireDefault(_matchAddShotsIndividual);
	
	var _matchShotsIndividualVisual = __webpack_require__(669);
	
	var _matchShotsIndividualVisual2 = _interopRequireDefault(_matchShotsIndividualVisual);
	
	var _matchAddShotsTeam = __webpack_require__(680);
	
	var _matchAddShotsTeam2 = _interopRequireDefault(_matchAddShotsTeam);
	
	var _matchAddShotsMixedTeam = __webpack_require__(686);
	
	var _matchAddShotsMixedTeam2 = _interopRequireDefault(_matchAddShotsMixedTeam);
	
	var _matchEdit = __webpack_require__(692);
	
	var _matchEdit2 = _interopRequireDefault(_matchEdit);
	
	var _leagues = __webpack_require__(703);
	
	var _leagues2 = _interopRequireDefault(_leagues);
	
	var _roles = __webpack_require__(709);
	
	var _roles2 = _interopRequireDefault(_roles);
	
	var _transfers = __webpack_require__(715);
	
	var _transfers2 = _interopRequireDefault(_transfers);
	
	var _teamsList = __webpack_require__(721);
	
	var _teamsList2 = _interopRequireDefault(_teamsList);
	
	var _teamProfile = __webpack_require__(727);
	
	var _teamProfile2 = _interopRequireDefault(_teamProfile);
	
	var _teamEdit = __webpack_require__(733);
	
	var _teamEdit2 = _interopRequireDefault(_teamEdit);
	
	var _judgesList = __webpack_require__(739);
	
	var _judgesList2 = _interopRequireDefault(_judgesList);
	
	var _judgeEdit = __webpack_require__(745);
	
	var _judgeEdit2 = _interopRequireDefault(_judgeEdit);
	
	var _judgeProfile = __webpack_require__(751);
	
	var _judgeProfile2 = _interopRequireDefault(_judgeProfile);
	
	var _coachesList = __webpack_require__(757);
	
	var _coachesList2 = _interopRequireDefault(_coachesList);
	
	var _coachEdit = __webpack_require__(763);
	
	var _coachEdit2 = _interopRequireDefault(_coachEdit);
	
	var _coachProfile = __webpack_require__(769);
	
	var _coachProfile2 = _interopRequireDefault(_coachProfile);
	
	var _staffList = __webpack_require__(775);
	
	var _staffList2 = _interopRequireDefault(_staffList);
	
	var _staffEdit = __webpack_require__(781);
	
	var _staffEdit2 = _interopRequireDefault(_staffEdit);
	
	var _staffProfile = __webpack_require__(787);
	
	var _staffProfile2 = _interopRequireDefault(_staffProfile);
	
	var _trainersList = __webpack_require__(793);
	
	var _trainersList2 = _interopRequireDefault(_trainersList);
	
	var _trainerEdit = __webpack_require__(799);
	
	var _trainerEdit2 = _interopRequireDefault(_trainerEdit);
	
	var _trainerProfile = __webpack_require__(805);
	
	var _trainerProfile2 = _interopRequireDefault(_trainerProfile);
	
	var _playersList = __webpack_require__(811);
	
	var _playersList2 = _interopRequireDefault(_playersList);
	
	var _playerEdit = __webpack_require__(817);
	
	var _playerEdit2 = _interopRequireDefault(_playerEdit);
	
	var _playerProfile = __webpack_require__(823);
	
	var _playerProfile2 = _interopRequireDefault(_playerProfile);
	
	var _playerInfo = __webpack_require__(829);
	
	var _playerInfo2 = _interopRequireDefault(_playerInfo);
	
	var _playerMatches = __webpack_require__(835);
	
	var _playerMatches2 = _interopRequireDefault(_playerMatches);
	
	var _playerPassports = __webpack_require__(841);
	
	var _playerPassports2 = _interopRequireDefault(_playerPassports);
	
	var _playerPayments = __webpack_require__(847);
	
	var _playerPayments2 = _interopRequireDefault(_playerPayments);
	
	var _playerTransfers = __webpack_require__(853);
	
	var _playerTransfers2 = _interopRequireDefault(_playerTransfers);
	
	var _playerTrainingEntries = __webpack_require__(859);
	
	var _playerTrainingEntries2 = _interopRequireDefault(_playerTrainingEntries);
	
	var _trainingCenter = __webpack_require__(865);
	
	var _trainingCenter2 = _interopRequireDefault(_trainingCenter);
	
	var _trainingCentersList = __webpack_require__(871);
	
	var _trainingCentersList2 = _interopRequireDefault(_trainingCentersList);
	
	var _trainingCenterEdit = __webpack_require__(877);
	
	var _trainingCenterEdit2 = _interopRequireDefault(_trainingCenterEdit);
	
	var _trainingCenterProfile = __webpack_require__(883);
	
	var _trainingCenterProfile2 = _interopRequireDefault(_trainingCenterProfile);
	
	var _privacy = __webpack_require__(889);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Players */
	
	/* Staff */
	
	/* Judges */
	
	/* Transfers */
	
	/* Leagues */
	
	/* Payments */
	
	/* Auth */
	var componentModule = _angular2.default.module("app.components", [_reports2.default, _results2.default, _dashboard2.default, _login2.default, _recover2.default, _reset2.default, _users2.default, _paymentsList2.default, _paymentsTeam2.default, _paymentsPlayerList2.default, _paymentsPlayer2.default, _paymentsTeamList2.default, _matchesList2.default, _matchTargets2.default, _matchLeagues2.default, _matchPrints2.default, _matchEdit2.default, _matchProfile2.default, _matchEliminations2.default, _matchFinalize2.default, _matchRegistrations2.default, _matchAddShotsVisual2.default, _matchAddShots2.default, _matchAddShotsIndividual2.default, _matchAddShotsTeam2.default, _matchAddShotsMixedTeam2.default, _matchShotsIndividualVisual2.default, _leagues2.default, _roles2.default, _transfers2.default, _teamsList2.default, _teamProfile2.default, _teamEdit2.default, _coachesList2.default, _coachProfile2.default, _coachEdit2.default, _judgesList2.default, _judgeEdit2.default, _judgeProfile2.default, _trainersList2.default, _trainerEdit2.default, _trainerProfile2.default, _playersList2.default, _playerEdit2.default, _playerProfile2.default, _playerInfo2.default, _playerMatches2.default, _playerPassports2.default, _playerPayments2.default, _playerTransfers2.default, _playerTrainingEntries2.default, _trainingCenter2.default, _staffList2.default, _staffEdit2.default, _staffProfile2.default, _trainingCentersList2.default, _trainingCenterEdit2.default, _trainingCenterProfile2.default, _privacy2.default]).name;
	/* Training Center*/
	
	/* Trainers */
	
	/* Coaches */
	
	/* Teams */
	
	/* Roles */
	
	/* Matches */
	
	/* Users */
	
	/* Reports */
	exports.default = componentModule;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _results = __webpack_require__(446);
	
	var _results2 = _interopRequireDefault(_results);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resultsModule = _angular2.default.module('results', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('results', {
			url: '/results/:id',
			component: 'results',
			data: { pageTitle: 'RESULTS' },
			params: {
				id: { squash: true, value: null }
			}
		});
	}]).component('results', _results2.default).name;
	
	exports.default = resultsModule;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _results = __webpack_require__(447);
	
	var _results2 = _interopRequireDefault(_results);
	
	var _results3 = __webpack_require__(448);
	
	var _results4 = _interopRequireDefault(_results3);
	
	__webpack_require__(523);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resultsComponent = {
	  bindings: {},
	  template: _results2.default,
	  controller: _results4.default,
	  controllerAs: "vm"
	};
	
	exports.default = resultsComponent;

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	module.exports = "<div\n  ng-if=\"vm.selectMatch === true\"\n  class=\"center-block w-xxl w-auto-xs p-y-md\"\n>\n  <div class=\"p-a-md box-color r box-shadow-z1 text-color m-a\">\n    <div class=\"m-b text-sm\" translate>Match Results</div>\n    <form name=\"resultsForm\" ng-submit=\"vm.fetchResults();\">\n      <div class=\"md-form-group float-label\">\n        <input type=\"text\" class=\"md-input\" ng-model=\"vm.matchId\" required />\n        <label translate>MATCH_ID</label>\n      </div>\n      <button\n        type=\"submit\"\n        translate\n        class=\"btn primary btn-block p-x-md\"\n        ng-disabled=\"!resultsForm.$valid\"\n      >\n        SUBMIT\n      </button>\n    </form>\n  </div>\n</div>\n<div\n  ng-if=\"vm.rootScope.isSAAF\"\n  style=\"\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 1;\n    display: flex;\n    justify-content: space-between;\n    padding-left: 20px;\n    padding-right: 20px;\n    align-items: center;\n    background: white;\n    color: #000000;\n    font-size: 36px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    box-shadow: 0px -15px 10px -15px #111;\n  \"\n>\n  <img height=\"80\" src=\"assets/images/elite_logo.png\" />\n  <div ng-bind=\"vm.activeMatch.match_name\"></div>\n  <img height=\"80\" src=\"assets/images/saaf.png\" />\n</div>\n<div\n  ng-if=\"vm.rootScope.isSAAF\"\n  style=\"position: fixed; bottom: 0; width: 100%; z-index: 1\"\n>\n  <img style=\"width: 100%; height: auto\" src=\"assets/images/sponsors5.png\" />\n</div>\n<!-- <button\n  translate\n  ng-hide=\"vm.selectMatch\"\n  ng-click=\"vm.setSelectMatch(true)\"\n  class=\"btn primary btn-block p-x-md\"\n>\n  CHANGE_MATCH\n</button> -->\n<!-- <button\n  translate\n  ng-if=\"vm.autoScrolling === false\"\n  ng-click=\"vm.setAutoScrolling(true)\"\n  class=\"btn warning btn-block p-x-md\"\n>\n  START_AUTOSCROLL\n</button>\n<button\n  translate\n  ng-if=\"vm.autoScrolling === true\"\n  ng-click=\"vm.setAutoScrolling(false)\"\n  class=\"btn danger btn-block p-x-md\"\n>\n  STOP_AUTOSCROLL\n</button> -->\n<div class=\"\" style=\"font-size: 36px; margin-top: 40px\">\n  <!-- <div style=\"font-size: 36px\"> -->\n  <div\n    ng-repeat=\"league in vm.validLeagues\"\n    ng-if=\"vm.getMatchPlayersOfLeague(league.league_id).length > 0\"\n    id=\"league-results-{{league.league_id}}\"\n    class=\"row m-b\"\n  >\n    <!-- <div class=\"col-sm-1\"></div> -->\n    <div class=\"col-sm-12\">\n      <div class=\"box white\" style=\"background: white\">\n        <div class=\"box-header light-blue-200 text-center\">\n          <h3 style=\"font-size: 36px\">{{league.leagueName}}</h3>\n        </div>\n        <div class=\"box-body\">\n          <table class=\"table table-striped b-t\" style=\"color: black\">\n            <thead>\n              <tr>\n                <th translate>RANK</th>\n                <th translate>TARGET_NAME</th>\n                <th translate>PLAYER_NAME</th>\n                <th translate>TEAM_NAME</th>\n                <th translate>TOTAL</th>\n                <th>10</th>\n                <th ng-if=\"vm.activeMatch.match_type === 'outdoor'\">X</th>\n                <th ng-if=\"vm.activeMatch.match_type === 'indoor'\">9</th>\n              </tr>\n            </thead>\n            <tbody>\n              <tr\n                ng-repeat=\"matchPlayer in vm.getMatchPlayersOfLeague(league.league_id) track by $index\"\n              >\n                <td>{{$index+1}}</td>\n                <td>{{matchPlayer.target_name}}</td>\n                <td>{{matchPlayer.playerName}}</td>\n                <td>{{matchPlayer.teamName}}</td>\n                <td>{{matchPlayer.total_score}}</td>\n                <td>{{matchPlayer['10s']}}</td>\n                <td ng-if=\"vm.activeMatch.match_type === 'outdoor'\">\n                  {{matchPlayer['Xs']}}\n                </td>\n                <td ng-if=\"vm.activeMatch.match_type === 'indoor'\">\n                  {{matchPlayer['9s']}}\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </div>\n    </div>\n    <div class=\"col-sm-1\"></div>\n  </div>\n  <div\n    id=\"scroll-bottom-id\"\n    style=\"height: 150px; background: transparent\"\n  ></div>\n</div>\n<!-- <button\n  translate\n  ng-hide=\"vm.selectMatch\"\n  ng-click=\"vm.setSelectMatch(true)\"\n  class=\"btn primary btn-block p-x-md\"\n>\n  CHANGE_MATCH\n</button>\n<button\n  translate\n  ng-if=\"vm.autoScrolling === false\"\n  ng-click=\"vm.setAutoScrolling(true)\"\n  class=\"btn warning btn-block p-x-md\"\n>\n  START_AUTOSCROLL\n</button>\n<button\n  translate\n  ng-if=\"vm.autoScrolling === true\"\n  ng-click=\"vm.setAutoScrolling(false)\"\n  class=\"btn danger btn-block p-x-md\"\n>\n  STOP_AUTOSCROLL\n</button> -->\n"

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(449);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(452);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResultsController = function ResultsController(MatchesFactory, $filter, $rootScope, $window, ngDialog, $stateParams, $location, $state, $document, $scope, animatedScroll) {
	  "ngInject";
	
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, ResultsController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	
	  vm.$onInit = function () {
	    if ($stateParams.id) {
	      vm.matchId = $stateParams.id;
	    }
	    if ($window.localStorage.getItem("resultsAutoScrolling" + vm.matchId)) {
	      vm.autoScrolling = $window.localStorage.getItem("resultsAutoScrolling" + vm.matchId) === "true";
	    } else {
	      vm.autoScrolling = false;
	    }
	    vm.selectMatch = true;
	    vm.validLeagues = [];
	    if (vm.matchId) {
	      vm.fetchResults();
	    }
	    if (vm.rootScope.isSAAF) {
	      setTimeout(function () {
	        if (!vm.autoScrolling) {
	          vm.setAutoScrolling(true);
	        }
	      }, 5000);
	    }
	  };
	
	  vm.setAutoScrolling = function (value) {
	    vm.autoScrolling = value;
	    $window.localStorage.setItem("resultsAutoScrolling" + vm.matchId, value);
	    $window.location.reload();
	  };
	
	  vm.setSelectMatch = function (value) {
	    vm.activeMatch = null;
	    vm.selectMatch = value;
	    vm.matchId = null;
	    $location.path("/results");
	  };
	
	  vm.isRegistrationOpen = function () {
	    var now = new Date();
	    var start = new Date(vm.activeMatch.registration_start);
	    var end = new Date(vm.activeMatch.registration_end);
	    return now > start && now < end;
	  };
	
	  vm.getMatchPlayersOfLeague = function (leagueId) {
	    return vm.activeMatch.matchPlayers.filter(function (m) {
	      return m.league_id === leagueId;
	    }).sort(function (a, b) {
	      if (a.total_score === b.total_score) {
	        if (a["10s"] === b["10s"]) {
	          if (vm.activeMatch.match_type === "outdoor") {
	            if (a["Xs"] === b["Xs"]) {
	              return 0;
	            }
	            return a["Xs"] > b["Xs"] ? -1 : 1;
	          } else {
	            if (a["9s"] === b["9s"]) {
	              return 0;
	            }
	            return a["9s"] > b["9s"] ? -1 : 1;
	          }
	        }
	        return a["10s"] > b["10s"] ? -1 : 1;
	      }
	      return a.total_score > b.total_score ? -1 : 1;
	    });
	  };
	
	  vm.scrollNextLeague = function (nextIndex) {
	    var duration = 2500;
	    // const duration = 50;
	    var offset = 40;
	    // const offset = 10;
	    if (vm.validLeagues[nextIndex]) {
	      var lr = vm.validLeagues[nextIndex - 1];
	      var pr = vm.getMatchPlayersOfLeague(lr.league_id).length;
	      var ll = vm.validLeagues[nextIndex];
	      var pp = vm.getMatchPlayersOfLeague(ll.league_id).length;
	      animatedScroll.scroll(document.getElementById("league-results-" + ll.league_id), {
	        duration: pr * duration,
	        offset: pr * 1 * -1,
	        easing: "easeInOutQuad"
	      }).then(function (element) {
	        setTimeout(function () {
	          vm.scrollNextLeague(nextIndex + 1);
	        }, 1500);
	      });
	    } else {
	      var _lr = vm.validLeagues[nextIndex - 1];
	      var _pr = vm.getMatchPlayersOfLeague(_lr.league_id).length;
	      animatedScroll.scroll(document.getElementById("scroll-bottom-id"), {
	        duration: _pr * duration,
	        offset: _pr * offset * -1,
	        easing: "easeInOutQuad"
	      }).then(function (element) {
	        $window.location.reload();
	      });
	    }
	  };
	
	  vm.fetchResults = function () {
	    $location.path("/results/" + vm.matchId);
	    vm.selectMatch = false;
	    var params = { include: "matchPlayers,matchLeagues" };
	    MatchesFactory.results(vm.matchId, params).then(function () {
	      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(response) {
	        var mpl;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                vm.activeMatch = response.data;
	                vm.validLeagues = vm.activeMatch.matchLeagues.filter(function (l) {
	                  return l.entries > 0;
	                });
	                if (vm.isRegistrationOpen()) {
	                  vm.activeMatch = null;
	                  ngDialog.open({
	                    template: "errorTemplate",
	                    data: {
	                      message: "Registration is still open"
	                    }
	                  });
	                } else {
	                  mpl = vm.activeMatch.matchPlayers.length;
	
	                  window.scrollTo(0, 0);
	                  if (vm.rootScope.isSAAF) {
	                    setTimeout(function () {
	                      animatedScroll.scroll(document.getElementById("scroll-bottom-id"), {
	                        duration: mpl * 3000,
	                        offset: 0,
	                        easing: "easeInOutQuad"
	                      }).then(function (element) {
	                        $window.location.reload();
	                      });
	                    }, 3000);
	                  }
	                  // if (vm.autoScrolling === true && vm.validLeagues.length > 1) {
	                  //   angular.element(document).ready(function () {
	                  //     setTimeout(() => {
	                  //       vm.scrollNextLeague(1);
	                  //     }, 2000);
	                  //   });
	                  // } else if (vm.autoScrolling === true && vm.validLeagues.length > 0) {
	                  //   let lr = vm.validLeagues[0];
	                  //   let pr = vm.getMatchPlayersOfLeague(lr.league_id).length;
	                  //   animatedScroll
	                  //     .scroll(document.getElementById("scroll-bottom-id"), {
	                  //       duration: pr * 2300,
	                  //       offset: pr * 40 * -1,
	                  //       easing: "easeInOutQuad",
	                  //     })
	                  //     .then((element) => {
	                  //       $window.location.reload();
	                  //     });
	                  // }
	                }
	
	              case 3:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }());
	  };
	};
	ResultsController.$inject = ["MatchesFactory", "$filter", "$rootScope", "$window", "ngDialog", "$stateParams", "$location", "$state", "$document", "$scope", "animatedScroll"];
	
	exports.default = ResultsController;

/***/ }),
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(524);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./results.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./results.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 524 */
426,
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _dashboard = __webpack_require__(526);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dashboardModule = _angular2.default.module('dashboard', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('dashboard', {
			url: '/dashboard',
			component: 'dashboard',
			data: { pageTitle: 'DASHBOARD' }
		});
	}]).component('dashboard', _dashboard2.default).name;
	
	exports.default = dashboardModule;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _dashboard = __webpack_require__(527);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboard3 = __webpack_require__(528);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	__webpack_require__(529);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dashboardComponent = {
		bindings: {},
		template: _dashboard2.default,
		controller: _dashboard4.default,
		controllerAs: 'vm'
	};
	
	exports.default = dashboardComponent;

/***/ }),
/* 527 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"p-a white lt box-shadow\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h4 class=\"m-b-0 _300\">\n        {{'WELCOME_TO' | translate}}{{vm.rootScope.app.name}},\n        {{vm.rootScope.user.name}}\n      </h4>\n      <div class=\"text-center\">\n        <img ng-if=\"vm.rootScope.isEOT\" src=\"assets/images/eot_logo.png\" />\n        <img ng-if=\"vm.rootScope.isSAAF\" src=\"assets/images/saaf_logo.jpeg\" />\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"padding\">\n  <div class=\"row\" ng-if=\"vm.rootScope.user.isUserTypeTeam()\">\n    <div class=\"col-sm-4\">\n      <div class=\"box p-a\">\n        <div class=\"pull-left m-r\">\n          <span class=\"avatar w-56\">\n            <img src=\"assets/images/no_avatar.png\" />\n            <i class=\"on b-white bottom\"></i>\n          </span>\n        </div>\n        <div class=\"clear m-t-1\">\n          <button\n            translate\n            ui-sref=\"team-profile({id:{{vm.rootScope.user.teamId}}})\"\n            class=\"btn btn-sm btn-info btn-rounded m-b\"\n          >\n            TEAM_PROFILE\n          </button>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardController = function DashboardController($rootScope, $filter) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, DashboardController);
		var vm = this;
	
		vm.rootScope = $rootScope;
	
		var $transalte = $filter('translate');
	};
	DashboardController.$inject = ["$rootScope", "$filter"];
	
	exports.default = DashboardController;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(530);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./dashboard.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./dashboard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, ".dashboard{color:red}", ""]);
	
	// exports


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _reports = __webpack_require__(532);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportsModule = _angular2.default.module('reports', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('reports', {
			url: '/reports',
			component: 'reports',
			data: { pageTitle: 'Reports' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_REPORTS)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('reports', _reports2.default).name;
	
	exports.default = reportsModule;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _reports = __webpack_require__(533);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _reports3 = __webpack_require__(534);
	
	var _reports4 = _interopRequireDefault(_reports3);
	
	__webpack_require__(547);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reportsComponent = {
		bindings: {},
		template: _reports2.default,
		controller: _reports4.default,
		controllerAs: 'vm'
	};
	
	exports.default = reportsComponent;

/***/ }),
/* 533 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <button class=\"btn btn-fw m-l-1\"\n                        ng-class=\"{'success' : vm.currentYear == year, 'white' : vm.currentYear != year}\"\n                        ng-click=\"vm.selectYear(year)\"\n                        ng-repeat=\"year in vm.years\">\n                    {{year}}\n                </button>\n            </div>\n            <div ng-if=\"vm.currentYear\" class=\"box-body\">\n                <button class=\"btn btn-fw m-l-1 m-t-1\"\n                        translate\n                        ng-repeat=\"report in vm.reports\"\n                        ng-class=\"{'success' : vm.currentReport == report, 'info' : vm.currentReport != report}\"\n                        ng-click=\"vm.getReport(report)\">\n                    {{report.name}}\n                </button>\n                <div ng-if=\"vm.showSelectDay\">\n                    <div class=\"form-group row m-t-1\">\n                        <label class=\"col-sm-3 form-control-label\">{{'DATE' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <div class=\"dropdown\">\n                                <a class=\"dropdown-toggle\" id=\"dateDropdown\" role=\"button\" data-toggle=\"dropdown\" data-target=\"#\" href=\"#\">\n                                    <div class=\"input-group\">\n                                    <span class=\"custom-input\">\n                                        {{ vm.selectedDay | date:'yyyy-MM' }}\n                                    </span>\n                                        <span class=\"input-group-btn\">\n                                        <button class=\"btn white\" type=\"button\" translate>PICK</button>\n                                    </span>\n                                    </div>\n                                </a>\n                                <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                                    <datetimepicker data-ng-model=\"vm.selectedDay\"\n                                                    data-datetimepicker-config=\"vm.dateConfig\"/>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn primary btn-block p-x-md m-t-1\"\n                            ng-click=\"vm.getReportWithOptions()\">SUBMIT</button>\n                </div>\n                <div ng-if=\"vm.showMatches\">\n                    <div class=\"form-inline row m-t-1\">\n                        <div class=\"col-xs-12\" style=\"overflow: auto;height:250px;\">\n                            <select multiple ng-model=\"vm.selectedMatches\" class=\"form-control col-xs-12\" style=\"height:250px;\">\n                                <option ng-repeat=\"match in vm.matches\"\n                                        ng-value=\"match.match_id\">{{match.match_name}}</option>\n                            </select>\n                        </div>\n                    </div>\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn primary btn-block p-x-md m-t-1\"\n                            ng-click=\"vm.getReportWithOptions()\">SUBMIT</button>\n                </div>\n                <div ng-if=\"vm.showAgeFilter\">\n                    <div class=\"form-group row m-t-1\">\n                        <label class=\"col-sm-3 form-control-label\">{{'AGE_FROM' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"number\" placeholder=\"1,2,3...10\" required class=\"form-control\" ng-model=\"vm.ageFilterFrom\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row m-t-1\">\n                        <label class=\"col-sm-3 form-control-label\">{{'AGE_TO' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"number\" placeholder=\"1,2,3...10\" required class=\"form-control\" ng-model=\"vm.ageFilterTo\">\n                        </div>\n                    </div>\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn primary btn-block p-x-md m-t-1\"\n                            ng-click=\"vm.getReportWithOptions()\">SUBMIT</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(535);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportsController = function ReportsController(ReportsFactory, MatchesFactory, $rootScope, $filter) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, ReportsController);
	  var vm = this;
	
	  vm.rootScope = $rootScope;
	  var $date = $filter("date");
	  vm.dateConfig = {
	    startView: "month",
	    minView: "month",
	    dropdownSelector: "#dateDropdown"
	  };
	
	  vm.$onInit = function () {
	    vm.years = [2023, 2024, "ALL"];
	    vm.currentYear = null;
	    vm.currentReport = null;
	    vm.matches = [];
	    vm.selectedMatches = [];
	    vm.showMatches = false;
	    vm.showSelectDay = false;
	    vm.showAgeFilter = false;
	    vm.ageFilterTo = null;
	    vm.ageFilterFrom = null;
	    vm.selectedDay = new Date();
	  };
	
	  vm.reports = [{
	    id: ReportsFactory.STATISTIC_REPORTS.PLAYER_REGISTER,
	    name: "REPORT_1",
	    hasOptions: true,
	    showAgeFilter: true
	  }, { id: ReportsFactory.STATISTIC_REPORTS.TEAM_REGISTER, name: "REPORT_2" }, {
	    id: ReportsFactory.STATISTIC_REPORTS.REGISTERED_REGISTER,
	    name: "REPORT_3"
	  }, {
	    id: ReportsFactory.STATISTIC_REPORTS.MATCHES_WITH_ENTRIES,
	    name: "REPORT_4"
	  }, {
	    id: ReportsFactory.STATISTIC_REPORTS.LEAGUES_ENTRIES,
	    name: "REPORT_5"
	  }, { id: ReportsFactory.STATISTIC_REPORTS.TEAM_PLAYERS, name: "REPORT_6" }, {
	    id: ReportsFactory.STATISTIC_REPORTS.PLAYER_LEAGUE,
	    name: "REPORT_7",
	    hasOptions: true,
	    selectMatch: true
	  },
	  // {
	  //   id: ReportsFactory.STATISTIC_REPORTS.MULTIWIN,
	  //   name: "REPORT_8",
	  //   hasOptions: true,
	  //   selectMatch: true,
	  // },
	  {
	    id: ReportsFactory.STATISTIC_REPORTS.TRAINING_ENTRIES,
	    name: "REPORT_9",
	    hasOptions: true,
	    selectDate: true
	  }, {
	    id: ReportsFactory.STATISTIC_REPORTS.PLAYER_LEAGUE_UNIQUE,
	    name: "REPORT_10",
	    hasOptions: true,
	    selectMatch: true
	  },
	  // {id: ReportsFactory.STATISTIC_REPORTS.GGA_PLAYERS, name: 'REPORT_11'},
	  // {id: ReportsFactory.STATISTIC_REPORTS.GGA_TEAMS, name: 'REPORT_12'},
	  {
	    id: ReportsFactory.STATISTIC_REPORTS.MEDALS,
	    name: "REPORT_13",
	    hasOptions: true,
	    selectMatch: true
	  }];
	
	  vm.selectYear = function (year) {
	    vm.currentYear = year;
	    var params = { year: year };
	    MatchesFactory.getAll(params).then(function (response) {
	      vm.matches = response.data;
	    });
	  };
	
	  vm.getReport = function (report) {
	    if (report.hasOptions) {
	      vm.currentReport = report;
	      vm.showMatches = report.selectMatch;
	      vm.showSelectDay = report.selectDate;
	      vm.showAgeFilter = report.showAgeFilter;
	      return;
	    }
	    vm.currentReport = null;
	    vm.showMatches = false;
	    vm.showSelectDay = false;
	    vm.getPDF(report, null);
	  };
	
	  vm.getReportWithOptions = function () {
	    var matchesString = "";
	    (0, _entries2.default)(vm.selectedMatches).forEach(function (_ref) {
	      var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	          key = _ref2[0],
	          value = _ref2[1];
	
	      if (matchesString === "") {
	        matchesString = matchesString + value;
	      } else {
	        matchesString = matchesString + "," + value;
	      }
	    });
	    vm.selectedDay = $date(vm.selectedDay, "yyyy-MM-dd");
	    var data = {
	      matches: matchesString,
	      selectedDay: vm.selectedDay,
	      ageFilterFrom: vm.ageFilterFrom,
	      ageFilterTo: vm.ageFilterTo
	    };
	    vm.getPDF(vm.currentReport, data);
	  };
	
	  vm.getPDF = function (report, data) {
	    var tabWindowId = window.open("about:blank", "_blank");
	    tabWindowId.document.write("<h1>Loading...</h1>");
	    ReportsFactory.statistics(report.id, vm.currentYear, data).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    }).catch(function (e) {
	      return tabWindowId.document.write("<h1>Παρουσιάστηκε κάποιο πρόβλημα.</h1>");
	    });
	  };
	};
	ReportsController.$inject = ["ReportsFactory", "MatchesFactory", "$rootScope", "$filter"];
	
	exports.default = ReportsController;

/***/ }),
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(548);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./reports.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./reports.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, ".reports{color:red}", ""]);
	
	// exports


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _login = __webpack_require__(550);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginModule = _angular2.default.module('login', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('login', {
			url: '/login',
			component: 'login',
			data: { pageTitle: 'LOGIN' },
			resolve: {
				isLoggedIn: ["$q", "$rootScope", "$state", function isLoggedIn($q, $rootScope, $state) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.isUserLoggedIn) {
						deferred.reject("Access Denied!!");
						$state.go('dashboard');
					} else {
						deferred.resolve();
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('login', _login2.default).name;
	
	exports.default = loginModule;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _login = __webpack_require__(551);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _login3 = __webpack_require__(552);
	
	var _login4 = _interopRequireDefault(_login3);
	
	__webpack_require__(553);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginComponent = {
		bindings: {},
		template: _login2.default,
		controller: _login4.default,
		controllerAs: "vm"
	};
	
	exports.default = loginComponent;

/***/ }),
/* 551 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"center-block w-xxl w-auto-xs p-y-md\">\n  <div class=\"p-a-md box-color r box-shadow-z1 text-color m-a\">\n    <div class=\"m-b text-sm\" translate>SIGN_IN</div>\n    <form name=\"loginForm\" ng-submit=\"vm.login();\">\n      <div class=\"md-form-group float-label\">\n        <input\n          type=\"text\"\n          class=\"md-input\"\n          ng-model=\"vm.loginModel.username\"\n          required\n        />\n        <label translate>USERNAME</label>\n      </div>\n      <div class=\"md-form-group float-label\">\n        <input\n          type=\"password\"\n          class=\"md-input\"\n          ng-model=\"vm.loginModel.password\"\n          required\n        />\n        <label translate>PASSWORD</label>\n      </div>\n      <div class=\"md-form-group float-label\">\n        <select class=\"form-control input-c\" ng-model=\"vm.loginModel.type\">\n          <option value=\"user\">{{'USER' | translate}}</option>\n          <option value=\"team\">{{'TEAM' | translate}}</option>\n        </select>\n      </div>\n      <button\n        type=\"submit\"\n        translate\n        class=\"btn primary btn-block p-x-md\"\n        ng-disabled=\"!loginForm.$valid\"\n      >\n        SIGN_IN\n      </button>\n    </form>\n  </div>\n  <div ng-if=\"vm.rootScope.isEOT\" class=\"p-v-lg text-center\">\n    <div class=\"m-b\">\n      <a ui-sref=\"recover\" class=\"text-primary _600\" translate\n        >FORGOT_YOUR_PASSWORD</a\n      >\n    </div>\n  </div>\n  <div class=\"p-v-lg text-center\">\n    <div class=\"m-b\">\n      <div>Language:</div>\n      <a\n        ng-if=\"vm.vLanguage != 'en'\"\n        class=\"text-primary _600 text-lg\"\n        ng-click=\"vm.changeLanguage('en')\"\n        translate\n        >English</a\n      >\n      <a\n        ng-if=\"vm.vLanguage != 'ar' && vm.rootScope.isSAAF\"\n        class=\"text-primary _600 text-lg\"\n        ng-click=\"vm.changeLanguage('ar')\"\n        translate\n        >عربي</a\n      >\n      <a\n        ng-if=\"vm.vLanguage != 'el' && vm.rootScope.isEOT\"\n        class=\"text-primary _600 text-lg\"\n        ng-click=\"vm.changeLanguage('el')\"\n        translate\n        >Ελληνικά</a\n      >\n    </div>\n  </div>\n  <div class=\"box-divider m-t-1 m-b-1\"></div>\n  <div class=\"p-v-lg text-center\">\n    <div class=\"m-b\">\n      <a ui-sref=\"results\" class=\"text-primary _600\" translate>MATCH_RESULTS</a>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(333);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginController = function LoginController(User, $rootScope, $window, AuthFactory, $state, $translate) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, LoginController);
	  var vm = this;
	
	  vm.rootScope = $rootScope;
	
	  /* init loginModel */
	  vm.$onInit = function () {
	    vm.loginModel = {
	      username: "",
	      password: "",
	      type: AuthFactory.USER_TYPES.USER
	    };
	  };
	
	  /* Language */
	  vm.vLanguage = "en";
	  if ($window.localStorage.getItem("vLanguage")) {
	    vm.vLanguage = $window.localStorage.getItem("vLanguage");
	    $translate.use(vm.vLanguage);
	  }
	
	  vm.changeLanguage = function (key) {
	    vm.vLanguage = key;
	    $translate.use(key);
	    $window.localStorage.setItem("vLanguage", key);
	    $window.location.reload();
	  };
	
	  vm.login = function () {
	    AuthFactory.login(vm.loginModel, vm.loginModel.type).then(function (response) {
	      if (response.data.token) {
	        vm.rootScope.isUserLoggedIn = true;
	        vm.rootScope.token = response.data.token;
	        $window.localStorage.setItem("token", response.data.token);
	        $window.localStorage.setItem("user", (0, _stringify2.default)(response.data.user));
	        vm.rootScope.user = User.build(response.data.user);
	        vm.rootScope.currentUser = JSON.parse($window.localStorage.getItem("user"));
	        $state.go("dashboard");
	      }
	    }).catch(function (error) {
	      vm.rootScope.isUserLoggedIn = false;
	      delete $window.localStorage.token;
	      delete $window.localStorage.user;
	    });
	  };
	};
	LoginController.$inject = ["User", "$rootScope", "$window", "AuthFactory", "$state", "$translate"];
	
	exports.default = LoginController;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(554);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./login.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./login.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, ".login{color:red}", ""]);
	
	// exports


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _recover = __webpack_require__(556);
	
	var _recover2 = _interopRequireDefault(_recover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recoverModule = _angular2.default.module('recover', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('recover', {
			url: '/recover',
			component: 'recover',
			data: { pageTitle: 'recover' },
			resolve: {
				isLoggedIn: ["$q", "$rootScope", "$state", function isLoggedIn($q, $rootScope, $state) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.isUserLoggedIn) {
						deferred.reject("Access Denied!!");
						$state.go('dashboard');
					} else {
						deferred.resolve();
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('recover', _recover2.default).name;
	
	exports.default = recoverModule;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _recover = __webpack_require__(557);
	
	var _recover2 = _interopRequireDefault(_recover);
	
	var _recover3 = __webpack_require__(558);
	
	var _recover4 = _interopRequireDefault(_recover3);
	
	__webpack_require__(559);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recoverComponent = {
	  bindings: {},
	  template: _recover2.default,
	  controller: _recover4.default,
	  controllerAs: "vm"
	};
	
	exports.default = recoverComponent;

/***/ }),
/* 557 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"center-block w-xxl w-auto-xs p-y-md\">\n    <div class=\"p-a-md box-color r box-shadow-z1 text-color m-a\">\n        <div class=\"m-b\">{{'FORGOT_YOUR_PASSWORD' | translate}}\n            <p class=\"text-xs m-t\" translate>FORGOT_PASSWORD_ENTER_EMAIL</p>\n        </div>\n        <form name=\"reset\" class=\"ng-pristine ng-valid\" ng-submit=\"vm.submit()\">\n            <div class=\"md-form-group\">\n                <input type=\"email\" id=\"email\" class=\"md-input\" required ng-model=\"vm.email\">\n                <label translate for=\"email\">YOUR_EMAIL</label>\n            </div>\n            <button type=\"submit\"\n                    ng-disabled=\"!reset.$valid\"\n                    ng-class=\"{'disabled' : !reset.$valid}\"\n                    class=\"btn primary btn-block p-x-md\" translate>SUBMIT</button>\n        </form>\n    </div>\n    <div class=\"p-v-lg text-center\">{{'RETURN_TO' | translate}}\n        <a ui-sref=\"login\" class=\"text-primary _600\" translate>SIGN_IN</a></div>\n</div>\n"

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecoverController = function RecoverController(AuthFactory, $filter, $rootScope, ngDialog, $state) {
		"ngInject";
	
		(0, _classCallCheck3.default)(this, RecoverController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		vm.rootScope = $rootScope;
	
		vm.$onInit = function () {
			vm.email = null;
		};
	
		vm.submit = function () {
			AuthFactory.recoverPassword(AuthFactory.USER_TYPES.TEAM, vm.email).then(function (response) {
				ngDialog.open({
					template: 'successTemplate',
					data: {
						message: $translate('RECOVER_SUCCESS')
					}
				});
				vm.email = null;
				$state.go('login');
			});
		};
	};
	RecoverController.$inject = ["AuthFactory", "$filter", "$rootScope", "ngDialog", "$state"];
	
	exports.default = RecoverController;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(560);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./recover.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./recover.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _reset = __webpack_require__(562);
	
	var _reset2 = _interopRequireDefault(_reset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resetModule = _angular2.default.module('reset', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('reset', {
			url: '/reset/:code',
			component: 'reset',
			data: { pageTitle: 'reset' },
			params: {
				code: null
			},
			resolve: {
				isLoggedIn: ["$q", "$rootScope", "$state", function isLoggedIn($q, $rootScope, $state) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.isUserLoggedIn) {
						deferred.reject("Access Denied!!");
						$state.go('dashboard');
					} else {
						deferred.resolve();
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('reset', _reset2.default).name;
	
	exports.default = resetModule;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reset = __webpack_require__(563);
	
	var _reset2 = _interopRequireDefault(_reset);
	
	var _reset3 = __webpack_require__(564);
	
	var _reset4 = _interopRequireDefault(_reset3);
	
	__webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resetComponent = {
	  bindings: {},
	  template: _reset2.default,
	  controller: _reset4.default,
	  controllerAs: "vm"
	};
	
	exports.default = resetComponent;

/***/ }),
/* 563 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"center-block w-xxl w-auto-xs p-y-md\">\n    <div class=\"p-a-md box-color r box-shadow-z1 text-color m-a\">\n        <div class=\"m-b text-sm\" translate>RESET_PASSWORD</div>\n        <form name=\"resetForm\" ng-submit=\"vm.submit();\">\n            <div class=\"md-form-group float-label\">\n                <input type=\"password\" class=\"md-input\" ng-minlength=\"6\"\n                       ng-model=\"vm.password\" required>\n                <label translate>NEW_PASSWORD</label>\n            </div>\n            <div class=\"md-form-group float-label\">\n                <input type=\"password\" class=\"md-input\" ng-minlength=\"6\"\n                       ng-model=\"vm.password_confirmation\" required>\n                <label translate>NEW_PASSWORD_CONFIRMATION</label>\n            </div>\n            <button type=\"submit\" translate class=\"btn primary btn-block p-x-md\"\n                    ng-disabled=\"!resetForm.$valid\">SUBMIT\n            </button>\n        </form>\n    </div>\n    <div class=\"p-v-lg text-center\">\n        <div class=\"m-b\">\n            <a ui-sref=\"login\" class=\"text-primary _600\" translate>SIGN_IN</a>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResetController = function ResetController(AuthFactory, $rootScope, $filter, $stateParams, ngDialog, $state) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, ResetController);
		var vm = this;
	
		vm.rootScope = $rootScope;
	
		vm.$onInit = function () {
			vm.password = null;
			vm.password_confirmation = null;
			vm.code = $stateParams.code;
		};
	
		vm.submit = function () {
			AuthFactory.resetPassword(AuthFactory.USER_TYPES.TEAM, vm.code, vm.password, vm.password_confirmation).then(function (response) {
				ngDialog.open({ template: 'successTemplate' });
				$state.go('login');
			});
		};
	};
	ResetController.$inject = ["AuthFactory", "$rootScope", "$filter", "$stateParams", "ngDialog", "$state"];
	
	exports.default = ResetController;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(566);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./reset.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./reset.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 566 */
560,
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _users = __webpack_require__(568);
	
	var _users2 = _interopRequireDefault(_users);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usersModule = _angular2.default.module('users', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('users', {
			url: '/users',
			component: 'users',
			data: { pageTitle: 'USERS' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_USERS)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('users', _users2.default).name;
	
	exports.default = usersModule;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _users = __webpack_require__(569);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _users3 = __webpack_require__(570);
	
	var _users4 = _interopRequireDefault(_users3);
	
	__webpack_require__(571);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usersComponent = {
	  bindings: {},
	  template: _users2.default,
	  controller: _users4.default,
	  controllerAs: "vm"
	};
	
	exports.default = usersComponent;

/***/ }),
/* 569 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <button type=\"button\"\n                        ng-if=\"!vm.showUserForm\"\n                        ng-click=\"vm.openForm()\" class=\"btn btn-sm btn-success m-b-1\">\n                    <i class=\"fa fa-plus\"></i>  {{'CREATE' | translate}}\n                </button>\n                <div class=\"table-responsive m-b-lg\" ng-if=\"!vm.showUserForm\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n                <form name=\"userForm\" ng-if=\"vm.showUserForm\" ng-submit=\"vm.submit()\">\n                    <div class=\"box-tool\">\n                        <ul class=\"nav\">\n                            <li class=\"nav-item inline\" ng-click=\"vm.closeForm()\">\n                                <a class=\"nav-link\"><i class=\"fa fa-close md-18\"></i></a>\n                            </li>\n                        </ul>\n                    </div>\n                    <div class=\"box-body\">\n                        <div class=\"b-b m-b-1 text-center\">\n                            <h3 class=\"_300 ng-binding\" ng-if=\"vm.user.id\" translate>EDIT_USER</h3>\n                            <h3 class=\"_300 ng-binding\" ng-if=\"!vm.user.id\" translate>CREATE_USER</h3>\n                        </div>\n                        <div class=\"form-group row\">\n                            <label class=\"col-sm-3 form-control-label\">{{'USERNAME' | translate}} *</label>\n                            <div class=\"col-sm-9\">\n                                <input type=\"text\" required class=\"form-control\" ng-model=\"vm.user.username\">\n                            </div>\n                        </div>\n                        <div class=\"form-group row\">\n                            <label class=\"col-sm-3 form-control-label\">{{'EMAIL' | translate}} *</label>\n                            <div class=\"col-sm-9\">\n                                <input type=\"text\" required class=\"form-control\" ng-model=\"vm.user.email\">\n                            </div>\n                        </div>\n                        <div class=\"form-group row\">\n                            <label class=\"col-sm-3 form-control-label\">{{'ROLE' | translate}} *</label>\n                            <div class=\"col-sm-8\">\n                                <ui-select required ng-model=\"vm.user.role\" theme=\"bootstrap\">\n                                    <ui-select-match class=\"ui-select-match\"\n                                            placeholder=\"{{'SELECT_ROLE' | translate}}\">\n                                        {{$select.selected.display_name}}\n                                    </ui-select-match>\n                                    <ui-select-choices class=\"ui-select-choices\"\n                                            repeat=\"item in vm.roles | filter: $select.search\">\n                                        <div ng-bind-html=\"item.display_name | highlight: $select.search\"></div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                    </div>\n                    <footer class=\"dker p-a text-left\">\n                        <button type=\"submit\"\n                                translate\n                                class=\"btn success p-x-md m-l-1\"\n                                ng-disabled=\"!userForm.$valid\">SUBMIT\n                        </button>\n                        <button type=\"button\"\n                                translate\n                                ng-click=\"vm.closeForm()\"\n                                class=\"btn p-x-md m-l-1\">CANCEL\n                        </button>\n                    </footer>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"changePasswordModal\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" translate>CHANGE_USER_PASSWORD</h5>\n            </div>\n            <div class=\"b-b m-b-1 m-t-1 text-center\">\n                <h3 class=\"_300 ng-binding\" translate ng-bind=\"vm.user.username\"></h3>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"changePasswordForm\" class=\"p-x-xs\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-4 form-control-label\">{{'NEW_PASSWORD' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"password\" name=\"password\" class=\"form-control\" ng-minlength=\"6\"\n                                   required ng-model=\"vm.password.password\"/>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-4 form-control-label\">{{'NEW_PASSWORD_CONFIRMATION' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"password\" class=\"form-control\" ng-minlength=\"6\"\n                                   required ng-model=\"vm.password.password_confirmation\"/>\n                        </div>\n                    </div>\n                    <!-- <div class=\"form-group row\">\n                        <label class=\"col-sm-4 form-control-label\">{{'AUTHORIZATION_KEY' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"password\" class=\"form-control\" required ng-model=\"vm.password.auth\"/>\n                        </div>\n                    </div> -->\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        data-dismiss=\"modal\">CANCEL\n                </button>\n                <button type=\"button\"\n                        ng-click=\"vm.changePassword();\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        ng-class=\"{'disabled' : !changePasswordForm.$valid}\"\n                        ng-disabled=\"!changePasswordForm.$valid\"\n                        data-dismiss=\"modal\">SUBMIT\n                </button>\n            </div>\n        </div><!-- /.modal-content -->\n    </div>\n</div>"

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersController = function UsersController(AuthFactory, RolesFactory, UsersFactory, $rootScope, ngDialog, $filter) {
		"ngInject";
	
		(0, _classCallCheck3.default)(this, UsersController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		vm.rootScope = $rootScope;
	
		vm.$onInit = function () {
			vm.showUserForm = false;
			vm.roles = [];
			RolesFactory.getAll().then(function (response) {
				vm.roles = response.data;
			});
			reloadData();
		};
	
		vm.gridOptions = {
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableSorting: true,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'username',
				enableFiltering: true,
				name: $translate('USERNAME')
			}, {
				field: 'email',
				enableFiltering: true,
				name: $translate('EMAIL')
			}, {
				field: 'role.display_name',
				enableFiltering: true,
				name: $translate('ROLE')
			}, {
				field: 'actions',
				enableFiltering: false,
				name: $translate('ACTIONS'),
				headerCellClass: 'text-center',
				cellTemplate: '' + '<div ' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm accent" translate ' + 'data-toggle="modal" ' + 'data-target="#changePasswordModal" ' + 'ng-click="grid.appScope.vm.changePasswordForm(row.entity)">CHANGE_PASSWORD</button> ' + '<button class="btn btn-sm btn-warning" translate ' + 'ng-click="grid.appScope.vm.openForm(row.entity)">EDIT</button> ' + '</div>' + '</div>',
				width: '320'
			}]
		};
	
		vm.submit = function () {
			vm.user.permissions = vm.userPermissions;
			if (vm.user.id) {
				UsersFactory.update(vm.user.id, vm.user).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					reloadData();
					vm.user = response.data;
				});
			} else {
				UsersFactory.create(vm.user).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					reloadData();
					vm.user = response.data;
				});
			}
		};
	
		vm.changePasswordForm = function (user) {
			vm.user = angular.copy(user, vm.user);
			vm.password = {};
		};
	
		vm.changePassword = function () {
			vm.password.id = vm.user.id;
			AuthFactory.changePassword(AuthFactory.USER_TYPES.USER, vm.password).then(function (response) {
				ngDialog.open({ template: 'successTemplate' });
			});
		};
	
		vm.openForm = function (user) {
			vm.user = {};
			vm.userPermissions = [];
			if (user) {
				angular.copy(user, vm.user);
			}
			vm.showUserForm = true;
		};
	
		vm.closeForm = function () {
			vm.showUserForm = false;
		};
	
		function reloadData() {
			UsersFactory.getAll().then(function (response) {
				vm.gridOptions.data = response.data;
			});
		}
	};
	UsersController.$inject = ["AuthFactory", "RolesFactory", "UsersFactory", "$rootScope", "ngDialog", "$filter"];
	
	exports.default = UsersController;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(572);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./users.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./users.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 572 */
426,
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _paymentsList = __webpack_require__(574);
	
	var _paymentsList2 = _interopRequireDefault(_paymentsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentsListModule = _angular2.default.module('paymentsList', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('payments-list', {
			url: '/paymentsList',
			component: 'paymentsList',
			data: { pageTitle: 'PAYMENT_ITEMS' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_FINANCIAL)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('paymentsList', _paymentsList2.default).name;
	
	exports.default = paymentsListModule;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paymentsList = __webpack_require__(575);
	
	var _paymentsList2 = _interopRequireDefault(_paymentsList);
	
	var _paymentsList3 = __webpack_require__(576);
	
	var _paymentsList4 = _interopRequireDefault(_paymentsList3);
	
	__webpack_require__(577);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentsListComponent = {
	  bindings: {},
	  template: _paymentsList2.default,
	  controller: _paymentsList4.default,
	  controllerAs: "vm"
	};
	
	exports.default = paymentsListComponent;

/***/ }),
/* 575 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-xs-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <button class=\"btn btn-sm btn-success m-b-1\"\n                        data-toggle=\"modal\"\n                        data-target=\"#paymentModel\"\n                        ng-click=\"vm.openPaymentModal()\">\n                    <i class=\"fa fa-plus\"></i> {{'ADD_NEW_PAYMENT' | translate}}\n                </button>\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"paymentModel\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" ng-if=\"!vm.payment.id\" translate>ADD_PAYMENT</h5>\n                <h5 class=\"modal-title\" ng-if=\"vm.payment.id\" translate>EDIT_PAYMENT</h5>\n            </div>\n            <div class=\"b-b m-b-1 m-t-1 text-center\" ng-if=\"vm.payment\">\n                <h3 class=\"_300 ng-binding\" translate ng-bind=\"vm.payment.name\"></h3>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"paymentForm\" class=\"p-x-xs\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-2 form-control-label\">{{'YEAR' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <ui-select required ng-model=\"vm.payment.year\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_YEAR' | translate}}\">\n                                    {{$select.selected.year}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.years | filter: $select.search\">\n                                    <div ng-bind-html=\"item.year | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-2 form-control-label\">{{'NAME' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" class=\"form-control\" required ng-model=\"vm.payment.name\"/>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-2 form-control-label\">{{'PRICE' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" class=\"form-control\" required ng-model=\"vm.payment.price\"/>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-2 form-control-label\">COMMENTS</label>\n                        <div class=\"col-sm-9\">\n                            <textarea class=\"form-control\" ng-model=\"vm.payment.comments\" rows=\"5\"></textarea>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-2 form-control-label\">REQUIRED_BY_TEAM</label>\n                        <div class=\"col-sm-2 p-t-05 p-b-05\">\n                            <label class=\"md-switch\">\n                                <input type=\"checkbox\" ng-model=\"vm.payment.required_team\">\n                                <i class=\"blue\"></i>\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-2 form-control-label\">REQUIRED_BY_PLAYER</label>\n                        <div class=\"col-sm-2 p-t-05 p-b-05\">\n                            <label class=\"md-switch\">\n                                <input type=\"checkbox\" ng-model=\"vm.payment.required_player\">\n                                <i class=\"blue\"></i>\n                            </label>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        data-dismiss=\"modal\">CANCEL\n                </button>\n                <button type=\"button\"\n                        ng-click=\"vm.submit();\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        ng-class=\"{'disabled' : !paymentForm.$valid}\"\n                        ng-disabled=\"!paymentForm.$valid\"\n                        data-dismiss=\"modal\">SUBMIT\n                </button>\n            </div>\n        </div><!-- /.modal-content -->\n    </div>\n</div>"

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentsListController = function PaymentsListController(PaymentsFactory, MiscFactory, $filter, ngDialog, $state) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, PaymentsListController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		vm.$onInit = function () {
			vm.years = [];
			MiscFactory.getYears().then(function (response) {
				vm.years = response.data;
			});
			reloadPayments();
		};
	
		vm.gridOptions = {
			enableSorting: true,
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'name',
				displayName: $translate('NAME'),
				enableFiltering: true
			}, {
				field: 'year.year',
				displayName: $translate('YEAR'),
				enableFiltering: true,
				width: '100'
			}, {
				field: 'actions',
				enableFiltering: false,
				name: $translate('ACTIONS'),
				headerCellClass: 'text-center',
				cellTemplate: '' + '<div ' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-warning" translate ' + 'data-toggle="modal" ' + 'data-target="#paymentModel" ' + 'ng-click="grid.appScope.vm.openPaymentModal(row.entity)">EDIT</button> ' + '<button class="btn btn-sm btn-danger" translate ' + 'ng-click="grid.appScope.vm.deletePayment(row.entity.id)">DELETE</button> ' + '</div>' + '</div>',
				width: '340'
			}]
		};
	
		/* Modal */
		vm.openPaymentModal = function (payment) {
			vm.payment = {};
			if (payment) {
				angular.copy(payment, vm.payment);
				vm.payment.required_team = vm.payment.required_team === 1;
				vm.payment.required_player = vm.payment.required_player === 1;
			}
		};
	
		vm.submit = function () {
			vm.payment.required_team = vm.payment.required_team ? 1 : 0;
			vm.payment.required_player = vm.payment.required_player ? 1 : 0;
			if (vm.payment.id) {
				PaymentsFactory.updatePaymentItem(vm.payment.id, vm.payment).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					reloadPayments();
				});
			} else {
				PaymentsFactory.createPaymentItem(vm.payment).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					reloadPayments();
				});
			}
		};
	
		vm.deletePayment = function (paymentId) {
			ngDialog.openConfirm({
				template: 'confirmTemplate',
				data: {
					message: $translate('CONFIRM_DELETE_PAYMENT')
				}
			}).then(function () {
				PaymentsFactory.deletePaymentItem(paymentId).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					reloadPayments();
				});
			});
		};
	
		function reloadPayments() {
			PaymentsFactory.getAll().then(function (response) {
				vm.gridOptions.data = response.data;
			});
		}
	};
	PaymentsListController.$inject = ["PaymentsFactory", "MiscFactory", "$filter", "ngDialog", "$state"];
	
	exports.default = PaymentsListController;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(578);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paymentsList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paymentsList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 578 */
560,
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _paymentsTeam = __webpack_require__(580);
	
	var _paymentsTeam2 = _interopRequireDefault(_paymentsTeam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentsTeamModule = _angular2.default.module('paymentsTeam', [_angularUiRouter2.default, 'ui.grid.pagination']).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('payments-team', {
			url: '/payments-team',
			component: 'paymentsTeam',
			data: { pageTitle: 'TEAM_PAYMENTS' },
			params: { ID: null },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_FINANCIAL)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('paymentsTeam', _paymentsTeam2.default).name;
	
	exports.default = paymentsTeamModule;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paymentsTeam = __webpack_require__(581);
	
	var _paymentsTeam2 = _interopRequireDefault(_paymentsTeam);
	
	var _paymentsTeam3 = __webpack_require__(582);
	
	var _paymentsTeam4 = _interopRequireDefault(_paymentsTeam3);
	
	__webpack_require__(583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentsTeamComponent = {
	  bindings: {},
	  template: _paymentsTeam2.default,
	  controller: _paymentsTeam4.default,
	  controllerAs: "vm"
	};
	
	exports.default = paymentsTeamComponent;

/***/ }),
/* 581 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-xs-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"paymentTeamModel\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" translate>ADD_TEAM_PAYMENT</h5>\n            </div>\n            <div class=\"b-b m-b-1 m-t-1 text-center\">\n                <h3 class=\"_300 ng-binding\" translate ng-bind=\"vm.activeTeam.name\"></h3>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"paymentForm\" class=\"p-x-xs\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'PAYMENT' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <ui-select ng-model=\"vm.teamPayment.payment\" theme=\"bootstrap\" required>\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_PAYMENT' | translate}}\">\n                                    {{$select.selected.name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.payments | filter: $select.search\">\n                                    <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'AMOUNT' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.teamPayment.amount\"/>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-3 form-control-label\">COMMENTS</label>\n                        <div class=\"col-sm-8\">\n                            <textarea class=\"form-control\" ng-model=\"vm.teamPayment.comments\" rows=\"5\"></textarea>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'DATE' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <div class=\"dropdown\">\n                                <a class=\"dropdown-toggle\" id=\"dateDropdown\" role=\"button\" data-toggle=\"dropdown\" data-target=\"#\" href=\"#\">\n                                    <div class=\"input-group\">\n                                    <span class=\"custom-input\">\n                                        {{ vm.teamPayment.payment_at | date:'yyyy-MM-dd' }}\n                                    </span>\n                                        <span class=\"input-group-btn\">\n                                        <button class=\"btn white\" type=\"button\" translate>PICK</button>\n                                    </span>\n                                    </div>\n                                </a>\n                                <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                                    <datetimepicker required data-ng-model=\"vm.teamPayment.payment_at\"\n                                                    data-datetimepicker-config=\"vm.dateConfig\"/>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        data-dismiss=\"modal\">CANCEL\n                </button>\n                <button type=\"button\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        ng-click=\"vm.addPayment();\"\n                        ng-class=\"{'disabled' : !paymentForm.$valid}\"\n                        ng-disabled=\"!paymentForm.$valid\"\n                        data-dismiss=\"modal\">SUBMIT\n                </button>\n            </div>\n        </div><!-- /.modal-content -->\n    </div>\n</div>"

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentsTeamController = function PaymentsTeamController(TeamsFactory, PaymentsFactory, $filter, ngDialog) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, PaymentsTeamController);
		var vm = this;
	
		var $translate = $filter('translate');
		var $date = $filter('date');
	
		vm.$onInit = function () {
			vm.payments = [];
			TeamsFactory.getAll().then(function (response) {
				vm.teams = response.data;
				vm.gridOptions.data = response.data;
			});
			PaymentsFactory.getAll().then(function (response) {
				vm.payments = response.data.filter(function (payment) {
					return payment.required_team === 1;
				});
			});
		};
	
		vm.gridOptions = {
			enableSorting: true,
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'code',
				name: $translate('CODE'),
				enableFiltering: false,
				width: '10%'
			}, {
				field: 'full_name',
				name: $translate('NAME'),
				enableFiltering: true
			}, {
				field: 'actions',
				enableFiltering: false,
				name: $translate('ACTIONS'),
				headerCellClass: 'text-center',
				cellTemplate: '' + '<div ' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-success" translate ' + 'data-toggle="modal" ' + 'data-target="#paymentTeamModel" ' + 'ng-click="grid.appScope.vm.openAddPaymentModel(row.entity)">ADD</button> ' + '<button class="btn btn-sm btn-info" translate ' + 'ng-click="grid.appScope.vm.getReport(row.entity.team_id)">PDF</button> ' + '</div>' + '</div>',
				width: '340'
			}]
		};
		vm.dateConfig = { startView: 'day', minView: 'day', dropdownSelector: '#dateDropdown' };
	
		vm.getReport = function (teamId) {
			var tabWindowId = window.open('about:blank', '_blank');
			PaymentsFactory.report(PaymentsFactory.PAYMENTS_RESOURCES.TEAM, teamId).then(function (response) {
				var file = new Blob([response.data], { type: 'application/pdf' });
				tabWindowId.location.href = window.URL.createObjectURL(file);
			});
		};
	
		/* Modal */
		vm.openAddPaymentModel = function (team) {
			vm.activeTeam = team;
			vm.teamPayment = {};
			vm.teamPayment.team_id = vm.activeTeam.team_id;
			vm.teamPayment.payment_at = new Date();
		};
		vm.addPayment = function () {
			vm.teamPayment.payment_at = $date(vm.teamPayment.payment_at, "yyyy-MM-dd");
			PaymentsFactory.addPayment(PaymentsFactory.PAYMENTS_RESOURCES.TEAM, vm.teamPayment).then(function (response) {
				ngDialog.open({ template: 'successTemplate' });
			});
		};
	};
	PaymentsTeamController.$inject = ["TeamsFactory", "PaymentsFactory", "$filter", "ngDialog"];
	
	exports.default = PaymentsTeamController;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(584);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paymentsTeam.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paymentsTeam.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 584 */
560,
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _paymentsPlayer = __webpack_require__(586);
	
	var _paymentsPlayer2 = _interopRequireDefault(_paymentsPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentsPlayerModule = _angular2.default.module('paymentsPlayer', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('payments-player', {
			url: '/payments-player',
			component: 'paymentsPlayer',
			data: { pageTitle: 'PLAYER_PAYMENTS' },
			params: { ID: null },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_FINANCIAL)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('paymentsPlayer', _paymentsPlayer2.default).name;
	
	exports.default = paymentsPlayerModule;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paymentsPlayer = __webpack_require__(587);
	
	var _paymentsPlayer2 = _interopRequireDefault(_paymentsPlayer);
	
	var _paymentsPlayer3 = __webpack_require__(588);
	
	var _paymentsPlayer4 = _interopRequireDefault(_paymentsPlayer3);
	
	__webpack_require__(589);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentsPlayerComponent = {
	  bindings: {},
	  template: _paymentsPlayer2.default,
	  controller: _paymentsPlayer4.default,
	  controllerAs: "vm"
	};
	
	exports.default = paymentsPlayerComponent;

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-xs-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <div class=\"form-group row\">\n                    <label translate\n                           class=\"col-sm-2 form-control-label\">TEAM</label>\n                    <div class=\"col-sm-10\">\n                        <ui-select on-select=\"vm.reloadPlayers()\" ng-model=\"vm.activeTeam\"\n                                   theme=\"bootstrap\">\n                            <ui-select-match\n                                    class=\"ui-select-match\"\n                                    placeholder=\"{{'SELECT_TEAM' | translate}}\">\n                                {{$select.selected.full_name}}\n                            </ui-select-match>\n                            <ui-select-choices\n                                    class=\"ui-select-choices\"\n                                    repeat=\"item in vm.teams | filter: $select.search\">\n                                <div ng-bind-html=\"item.full_name | highlight: $select.search\"></div>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"paymentPlayerModel\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" translate>ADD_PLAYER_PAYMENT</h5>\n            </div>\n            <div class=\"b-b m-b-1 m-t-1 text-center\">\n                <h3 class=\"_300 ng-binding\" translate ng-bind=\"vm.activePlayer.playerName\"></h3>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"paymentForm\" class=\"p-x-xs\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'PAYMENT' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <ui-select ng-model=\"vm.playerPayment.payment\" theme=\"bootstrap\" required>\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_PAYMENT' | translate}}\">\n                                    {{$select.selected.name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.payments | filter: $select.search\">\n                                    <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'AMOUNT' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.playerPayment.amount\"/>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-3 form-control-label\">COMMENTS</label>\n                        <div class=\"col-sm-8\">\n                            <textarea class=\"form-control\" ng-model=\"vm.playerPayment.comments\" rows=\"5\"></textarea>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'DATE' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <div class=\"dropdown\">\n                                <a class=\"dropdown-toggle\" id=\"dateDropdown\" role=\"button\" data-toggle=\"dropdown\" data-target=\"#\" href=\"#\">\n                                    <div class=\"input-group\">\n                                    <span class=\"custom-input\">\n                                        {{ vm.playerPayment.payment_at | date:'yyyy-MM-dd' }}\n                                    </span>\n                                        <span class=\"input-group-btn\">\n                                        <button class=\"btn white\" type=\"button\" translate>PICK</button>\n                                    </span>\n                                    </div>\n                                </a>\n                                <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                                    <datetimepicker required data-ng-model=\"vm.playerPayment.payment_at\"\n                                                    data-datetimepicker-config=\"vm.dateConfig\"/>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        ng-click=\"vm.clearSelections()\"\n                        data-dismiss=\"modal\">CANCEL\n                </button>\n                <button type=\"button\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        ng-click=\"vm.addPayment();\"\n                        ng-class=\"{'disabled' : !paymentForm.$valid}\"\n                        ng-disabled=\"!paymentForm.$valid\"\n                        data-dismiss=\"modal\">SUBMIT\n                </button>\n            </div>\n        </div><!-- /.modal-content -->\n    </div>\n</div>"

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentsPlayerController = function PaymentsPlayerController(TeamsFactory, PaymentsFactory, PlayersFactory, $filter, ngDialog) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, PaymentsPlayerController);
		var vm = this;
	
		var $translate = $filter('translate');
		var $date = $filter('date');
	
		vm.$onInit = function () {
			vm.teams = [];
			vm.payments = [];
			TeamsFactory.getAll().then(function (response) {
				vm.teams = response.data;
			});
			PaymentsFactory.getAll().then(function (response) {
				vm.payments = response.data.filter(function (payment) {
					return payment.required_player === 1 || payment.id === 24;
				});
			});
		};
	
		vm.gridOptions = {
			enableSorting: true,
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'code',
				enableFiltering: false,
				name: $translate('CODE'),
				width: '110'
			}, {
				field: 'playerName',
				name: $translate('NAME'),
				enableFiltering: true
			}, {
				field: 'actions',
				enableFiltering: false,
				name: $translate('ACTIONS'),
				headerCellClass: 'text-center',
				cellTemplate: '' + '<div ' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-success" translate ' + 'data-toggle="modal" ' + 'data-target="#paymentPlayerModel" ' + 'ng-click="grid.appScope.vm.openAddPaymentModel(row.entity)">ADD</button> ' + '<button class="btn btn-sm btn-info" translate ' + 'ng-click="grid.appScope.vm.getReport(row.entity.player_id)">PDF</button> ' + '</div>' + '</div>',
				width: '340'
			}]
		};
		vm.dateConfig = { startView: 'day', minView: 'day', dropdownSelector: '#dateDropdown' };
	
		vm.getReport = function (playerId) {
			var tabWindowId = window.open('about:blank', '_blank');
			PaymentsFactory.report(PaymentsFactory.PAYMENTS_RESOURCES.PLAYER, playerId).then(function (response) {
				var file = new Blob([response.data], { type: 'application/pdf' });
				tabWindowId.location.href = window.URL.createObjectURL(file);
			});
		};
	
		vm.reloadPlayers = function () {
			if (!vm.activeTeam.team_id) {
				return;
			}
			PlayersFactory.getAll({ team_id: vm.activeTeam.team_id }).then(function (response) {
				vm.players = response.data;
				vm.gridOptions.data = response.data;
			});
		};
	
		/* Modal */
		vm.openAddPaymentModel = function (player) {
			vm.activePlayer = player;
			vm.playerPayment = {};
			vm.playerPayment.player_id = vm.activePlayer.player_id;
			vm.playerPayment.payment_at = new Date();
		};
		vm.addPayment = function () {
			vm.playerPayment.payment_at = $date(vm.playerPayment.payment_at, "yyyy-MM-dd");
			PaymentsFactory.addPayment(PaymentsFactory.PAYMENTS_RESOURCES.PLAYER, vm.playerPayment).then(function (response) {
				ngDialog.open({ template: 'successTemplate' });
			});
		};
	};
	PaymentsPlayerController.$inject = ["TeamsFactory", "PaymentsFactory", "PlayersFactory", "$filter", "ngDialog"];
	
	exports.default = PaymentsPlayerController;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(590);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paymentsPlayer.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paymentsPlayer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 590 */
560,
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _paymentsPlayerList = __webpack_require__(592);
	
	var _paymentsPlayerList2 = _interopRequireDefault(_paymentsPlayerList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentsPlayerListModule = _angular2.default.module('paymentsPlayerList', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('payments-player-list', {
			url: '/paymentsPlayerList',
			component: 'paymentsPlayerList',
			data: { pageTitle: 'PLAYER_PAYMENTS_LIST' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_FINANCIAL) && $rootScope.user.canDo(Permissions.VIEW_ALL_MOVEMENTS_PLAYER)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('paymentsPlayerList', _paymentsPlayerList2.default).name;
	
	exports.default = paymentsPlayerListModule;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paymentsPlayerList = __webpack_require__(593);
	
	var _paymentsPlayerList2 = _interopRequireDefault(_paymentsPlayerList);
	
	var _paymentsPlayerList3 = __webpack_require__(594);
	
	var _paymentsPlayerList4 = _interopRequireDefault(_paymentsPlayerList3);
	
	__webpack_require__(595);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentsPlayerListComponent = {
	  bindings: {},
	  template: _paymentsPlayerList2.default,
	  controller: _paymentsPlayerList4.default,
	  controllerAs: "vm"
	};
	
	exports.default = paymentsPlayerListComponent;

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-xs-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <div class=\"b-b m-b-1 text-center\">\n                    <h3 class=\"_300 ng-binding\" translate>FILTERS</h3>\n                </div>\n                <div class=\"form-group row\">\n                    <label translate\n                           class=\"col-sm-2 form-control-label\">TEAM</label>\n                    <div class=\"col-sm-9\">\n                        <div class=\"input-group\">\n                            <ui-select on-select=\"vm.reloadPayments()\" ng-model=\"vm.filters.team\"\n                                       theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_TEAM' | translate}}\">\n                                    {{$select.selected.full_name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.teams | filter: $select.search\">\n                                    <div ng-bind-html=\"item.full_name | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                            <span class=\"input-group-btn\">\n                                <button ng-click=\"vm.clearFilter('team')\" class=\"btn white\">\n                                    <span class=\"fa fa-remove\"></span>\n                                </button>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group row\">\n                    <label translate\n                           class=\"col-sm-2 form-control-label\">PAYMENT</label>\n                    <div class=\"col-sm-9\">\n                        <div class=\"input-group\">\n                            <ui-select on-select=\"vm.reloadPayments()\" ng-model=\"vm.filters.payment\" theme=\"bootstrap\">\n                                <ui-select-match class=\"ui-select-match\" placeholder=\"{{'SELECT_PAYMENT' | translate}}\">\n                                    {{$select.selected.name}}\n                                </ui-select-match>\n                                <ui-select-choices class=\"ui-select-choices\"\n                                                   repeat=\"item in vm.payments | filter: $select.search\">\n                                    <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                            <span class=\"input-group-btn\">\n                                <button ng-click=\"vm.clearFilter('payment')\" class=\"btn white\">\n                                    <span class=\"fa fa-remove\"></span>\n                                </button>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group row\">\n                    <label translate class=\"col-sm-2 form-control-label\">DATE_FROM</label>\n                    <div class=\"col-sm-9\">\n                        <div class=\"dropdown\">\n                            <a class=\"dropdown-toggle\" id=\"dateFrom\" role=\"button\" data-toggle=\"dropdown\"\n                               data-target=\"#\" href=\"#\">\n                                <div class=\"input-group\">\n                                    <span class=\"custom-input\">\n                                        {{ vm.filters.dateFrom | date:'yyyy-MM-dd' }}\n                                    </span>\n                                    <span class=\"input-group-btn\">\n                                        <button class=\"btn white\" type=\"button\" translate>PICK</button>\n                                    </span>\n                                </div>\n                            </a>\n                            <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                                <datetimepicker data-ng-model=\"vm.filters.dateFrom\"\n                                                ng-change=\"vm.reloadPayments()\"\n                                                data-datetimepicker-config=\"vm.dateFromConfig\"/>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group row\">\n                    <label translate class=\"col-sm-2 form-control-label\">DATE_TO</label>\n                    <div class=\"col-sm-9\">\n                        <div class=\"dropdown\">\n                            <a class=\"dropdown-toggle\" id=\"dateTo\" role=\"button\" data-toggle=\"dropdown\" data-target=\"#\"\n                               href=\"#\">\n                                <div class=\"input-group\">\n                                    <span class=\"custom-input\">\n                                        {{ vm.filters.dateTo | date:'yyyy-MM-dd' }}\n                                    </span>\n                                    <span class=\"input-group-btn\">\n                                        <button class=\"btn white\" type=\"button\" translate>PICK</button>\n                                    </span>\n                                </div>\n                            </a>\n                            <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                                <datetimepicker data-ng-model=\"vm.filters.dateTo\"\n                                                ng-change=\"vm.reloadPayments()\"\n                                                data-datetimepicker-config=\"vm.dateToConfig\"/>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"box-divider\"></div>\n                <div class=\"box-body\">\n                    <button type=\"button\"\n                            ng-click=\"vm.printResults()\" class=\"btn btn-sm btn-info\">\n                        <i class=\"fa fa-file-pdf-o\"></i> {{'PRINT_RESULTS' | translate}}\n                    </button>\n                </div>\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"playerPaymentModal\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" translate>EDIT_TEAM_PAYMENT</h5>\n            </div>\n            <div class=\"b-b m-b-1 m-t-1 text-center\">\n                <h3 class=\"_300 ng-binding\" translate ng-bind=\"vm.playerPayment.team.teamName\"></h3>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"playerPaymentForm\" class=\"p-x-xs\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'PAYMENT' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <ui-select ng-model=\"vm.playerPayment.payment\" theme=\"bootstrap\" required>\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_PAYMENT' | translate}}\">\n                                    {{$select.selected.name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.payments | filter: $select.search\">\n                                    <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'AMOUNT' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.playerPayment.amount\"/>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">COMMENTS</label>\n                        <div class=\"col-sm-8\">\n                            <textarea class=\"form-control\" ng-model=\"vm.playerPayment.comments\" rows=\"5\"></textarea>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'DATE' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <div class=\"dropdown\">\n                                <a class=\"dropdown-toggle\" id=\"dateDropdown\" role=\"button\" data-toggle=\"dropdown\"\n                                   data-target=\"#\" href=\"#\">\n                                    <div class=\"input-group\">\n                                    <span class=\"custom-input\">\n                                        {{ vm.playerPayment.payment_at | date:'yyyy-MM-dd' }}\n                                    </span>\n                                        <span class=\"input-group-btn\">\n                                        <button class=\"btn white\" type=\"button\" translate>PICK</button>\n                                    </span>\n                                    </div>\n                                </a>\n                                <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                                    <datetimepicker required data-ng-model=\"vm.playerPayment.payment_at\"\n                                                    data-datetimepicker-config=\"vm.dateConfig\"/>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">STATUS</label>\n                        <div class=\"col-sm-2 p-t-05 p-b-05\">\n                            <label class=\"md-switch\">\n                                <input type=\"checkbox\"\n                                       ng-model=\"vm.playerPayment.status\">\n                                <i class=\"blue\"></i>\n                            </label>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        data-dismiss=\"modal\">CANCEL\n                </button>\n                <button type=\"button\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        ng-click=\"vm.updatePlayerPayment();\"\n                        ng-class=\"{'disabled' : !playerPaymentForm.$valid}\"\n                        ng-disabled=\"!playerPaymentForm.$valid\"\n                        data-dismiss=\"modal\">SUBMIT\n                </button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentsPlayerListController = function PaymentsPlayerListController(TeamsFactory, PaymentsFactory, PlayersFactory, $filter, ngDialog) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, PaymentsPlayerListController);
		var vm = this;
	
		var $translate = $filter('translate');
		var $date = $filter('date');
	
		vm.$onInit = function () {
			vm.filters = { team: null, payment: null, dateFrom: new Date(), dateTo: new Date() };
			vm.teams = [];
			vm.payments = [];
			TeamsFactory.getAll().then(function (response) {
				vm.teams = response.data;
			});
			PaymentsFactory.getAll().then(function (response) {
				vm.payments = response.data;
			});
			vm.reloadPayments();
		};
	
		vm.gridOptions = {
			enableSorting: true,
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'payment_at',
				enableFiltering: false,
				name: $translate('DATE'),
				width: '130'
			}, {
				field: 'player.playerName',
				name: $translate('PLAYER'),
				enableFiltering: true
			}, {
				field: 'player.teamName',
				name: $translate('TEAM'),
				enableFiltering: true
			}, {
				field: 'payment.name',
				name: $translate('NAME'),
				enableFiltering: true
			}, {
				field: 'amount',
				name: $translate('AMOUNT'),
				enableFiltering: true,
				width: '90'
			}, {
				field: 'comments',
				name: $translate('COMMENTS'),
				enableFiltering: true
			}, {
				field: 'actions',
				enableFiltering: false,
				name: $translate('ACTIONS'),
				headerCellClass: 'text-center',
				cellTemplate: '' + '<div ' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-warning" translate ' + 'data-toggle="modal" ' + 'data-target="#playerPaymentModal" ' + 'ng-click="grid.appScope.vm.openEditPlayerPaymentModal(row.entity)">EDIT</button> ' + '</div>' + '</div>',
				width: '130'
			}]
		};
		vm.dateFromConfig = { startView: 'day', minView: 'day', dropdownSelector: '#dateFrom' };
		vm.dateToConfig = { startView: 'day', minView: 'day', dropdownSelector: '#dateTo' };
		vm.dateConfig = { startView: 'day', minView: 'day', dropdownSelector: '#dateDropdown' };
	
		vm.openEditPlayerPaymentModal = function (playerPayment) {
			vm.playerPayment = {};
			angular.copy(playerPayment, vm.playerPayment);
			vm.playerPayment.status = vm.playerPayment.status === 1;
		};
	
		vm.updatePlayerPayment = function () {
			vm.playerPayment.payment_at = $date(vm.playerPayment.payment_at, 'yyyy-MM-dd');
			vm.playerPayment.status = vm.playerPayment.status ? 1 : 0;
			PaymentsFactory.updatePayment(vm.playerPayment.id, PaymentsFactory.PAYMENTS_RESOURCES.PLAYER, vm.playerPayment).then(function (response) {
				ngDialog.open({ template: 'successTemplate' });
				vm.reloadPayments();
			});
		};
	
		vm.printResults = function () {
			var params = getFilterParams();
			PaymentsFactory.customReport(PaymentsFactory.PAYMENTS_RESOURCES.PLAYER, params).then(function (response) {
				var file = new Blob([response.data], { type: 'application/pdf' });
				var tab = window.open();
				tab.location.href = window.URL.createObjectURL(file);
			});
		};
	
		vm.clearFilter = function (filter) {
			vm.filters[filter] = null;
			vm.reloadPayments();
		};
	
		vm.reloadPayments = function () {
			var params = getFilterParams();
			vm.gridOptions.data = [];
			PaymentsFactory.getPayments(PaymentsFactory.PAYMENTS_RESOURCES.PLAYER, params).then(function (response) {
				vm.gridOptions.data = response.data;
			});
		};
	
		function getFilterParams() {
			var params = {};
			params.page_size = 5000;
			if (vm.filters.team) {
				params.team_id = vm.filters.team.team_id;
			}
			if (vm.filters.payment) {
				params.payment_id = vm.filters.payment.id;
			}
			if (vm.filters.dateFrom) {
				params.dateFrom = $date(vm.filters.dateFrom, 'yyyy-MM-dd');
			}
			if (vm.filters.dateTo) {
				params.dateTo = $date(vm.filters.dateTo, 'yyyy-MM-dd');
			}
			return params;
		}
	};
	PaymentsPlayerListController.$inject = ["TeamsFactory", "PaymentsFactory", "PlayersFactory", "$filter", "ngDialog"];
	
	exports.default = PaymentsPlayerListController;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(596);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paymentsPlayerList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paymentsPlayerList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 596 */
560,
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _paymentsTeamList = __webpack_require__(598);
	
	var _paymentsTeamList2 = _interopRequireDefault(_paymentsTeamList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentsTeamListModule = _angular2.default.module('paymentsTeamList', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('payments-team-list', {
			url: '/paymentsTeamList',
			component: 'paymentsTeamList',
			data: { pageTitle: 'TEAM_PAYMENTS_LIST' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_FINANCIAL) && $rootScope.user.canDo(Permissions.VIEW_ALL_MOVEMENTS_TEAM)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('paymentsTeamList', _paymentsTeamList2.default).name;
	
	exports.default = paymentsTeamListModule;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paymentsTeamList = __webpack_require__(599);
	
	var _paymentsTeamList2 = _interopRequireDefault(_paymentsTeamList);
	
	var _paymentsTeamList3 = __webpack_require__(600);
	
	var _paymentsTeamList4 = _interopRequireDefault(_paymentsTeamList3);
	
	__webpack_require__(601);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentsTeamListComponent = {
	  bindings: {},
	  template: _paymentsTeamList2.default,
	  controller: _paymentsTeamList4.default,
	  controllerAs: "vm"
	};
	
	exports.default = paymentsTeamListComponent;

/***/ }),
/* 599 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-xs-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <div class=\"b-b m-b-1 text-center\">\n                    <h3 class=\"_300 ng-binding\" translate>FILTERS</h3>\n                </div>\n                <div class=\"form-group row\">\n                    <label translate\n                           class=\"col-sm-2 form-control-label\">TEAM</label>\n                    <div class=\"col-sm-9\">\n                        <div class=\"input-group\">\n                            <ui-select on-select=\"vm.reloadPayments()\" ng-model=\"vm.filters.team\"\n                                       theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_TEAM' | translate}}\">\n                                    {{$select.selected.full_name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.teams | filter: $select.search\">\n                                    <div ng-bind-html=\"item.full_name | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                            <span class=\"input-group-btn\">\n                                <button ng-click=\"vm.clearFilter('team')\" class=\"btn white\">\n                                    <span class=\"fa fa-remove\"></span>\n                                </button>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group row\">\n                    <label translate\n                           class=\"col-sm-2 form-control-label\">PAYMENT</label>\n                    <div class=\"col-sm-9\">\n                        <div class=\"input-group\">\n                            <ui-select on-select=\"vm.reloadPayments()\" ng-model=\"vm.filters.payment\" theme=\"bootstrap\">\n                                <ui-select-match class=\"ui-select-match\" placeholder=\"{{'SELECT_PAYMENT' | translate}}\">\n                                    {{$select.selected.name}}\n                                </ui-select-match>\n                                <ui-select-choices class=\"ui-select-choices\"\n                                        repeat=\"item in vm.payments | filter: $select.search\">\n                                    <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                            <span class=\"input-group-btn\">\n                                <button ng-click=\"vm.clearFilter('payment')\" class=\"btn white\">\n                                    <span class=\"fa fa-remove\"></span>\n                                </button>\n                            </span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group row\">\n                    <label translate class=\"col-sm-2 form-control-label\">DATE_FROM</label>\n                    <div class=\"col-sm-9\">\n                        <div class=\"dropdown\">\n                            <a class=\"dropdown-toggle\" id=\"dateFrom\" role=\"button\" data-toggle=\"dropdown\" data-target=\"#\" href=\"#\">\n                                <div class=\"input-group\">\n                                    <span class=\"custom-input\">\n                                        {{ vm.filters.dateFrom | date:'yyyy-MM-dd' }}\n                                    </span>\n                                    <span class=\"input-group-btn\">\n                                        <button class=\"btn white\" type=\"button\" translate>PICK</button>\n                                    </span>\n                                </div>\n                            </a>\n                            <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                                <datetimepicker data-ng-model=\"vm.filters.dateFrom\"\n                                                ng-change=\"vm.reloadPayments()\"\n                                                data-datetimepicker-config=\"vm.dateFromConfig\"/>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group row\">\n                    <label translate class=\"col-sm-2 form-control-label\">DATE_TO</label>\n                    <div class=\"col-sm-9\">\n                        <div class=\"dropdown\">\n                            <a class=\"dropdown-toggle\" id=\"dateTo\" role=\"button\" data-toggle=\"dropdown\" data-target=\"#\" href=\"#\">\n                                <div class=\"input-group\">\n                                    <span class=\"custom-input\">\n                                        {{ vm.filters.dateTo | date:'yyyy-MM-dd' }}\n                                    </span>\n                                    <span class=\"input-group-btn\">\n                                        <button class=\"btn white\" type=\"button\" translate>PICK</button>\n                                    </span>\n                                </div>\n                            </a>\n                            <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                                <datetimepicker data-ng-model=\"vm.filters.dateTo\"\n                                                ng-change=\"vm.reloadPayments()\"\n                                                data-datetimepicker-config=\"vm.dateToConfig\"/>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"box-divider\"></div>\n                <div class=\"box-body\">\n                    <button type=\"button\"\n                            ng-click=\"vm.printResults()\" class=\"btn btn-sm btn-info\">\n                        <i class=\"fa fa-file-pdf-o\"></i> {{'PRINT_RESULTS' | translate}}\n                    </button>\n                </div>\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"teamPaymentModal\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" translate>EDIT_TEAM_PAYMENT</h5>\n            </div>\n            <div class=\"b-b m-b-1 m-t-1 text-center\">\n                <h3 class=\"_300 ng-binding\" translate ng-bind=\"vm.teamPayment.team.teamName\"></h3>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"teamPaymentForm\" class=\"p-x-xs\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'PAYMENT' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <ui-select ng-model=\"vm.teamPayment.payment\" theme=\"bootstrap\" required>\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_PAYMENT' | translate}}\">\n                                    {{$select.selected.name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.payments | filter: $select.search\">\n                                    <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'AMOUNT' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.teamPayment.amount\"/>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">COMMENTS</label>\n                        <div class=\"col-sm-8\">\n                            <textarea class=\"form-control\" ng-model=\"vm.teamPayment.comments\" rows=\"5\"></textarea>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'DATE' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <div class=\"dropdown\">\n                                <a class=\"dropdown-toggle\" id=\"dateDropdown\" role=\"button\" data-toggle=\"dropdown\" data-target=\"#\" href=\"#\">\n                                    <div class=\"input-group\">\n                                    <span class=\"custom-input\">\n                                        {{ vm.teamPayment.payment_at | date:'yyyy-MM-dd' }}\n                                    </span>\n                                        <span class=\"input-group-btn\">\n                                        <button class=\"btn white\" type=\"button\" translate>PICK</button>\n                                    </span>\n                                    </div>\n                                </a>\n                                <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                                    <datetimepicker required data-ng-model=\"vm.teamPayment.payment_at\"\n                                                    data-datetimepicker-config=\"vm.dateConfig\"/>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">STATUS</label>\n                        <div class=\"col-sm-2 p-t-05 p-b-05\">\n                            <label class=\"md-switch\">\n                                <input type=\"checkbox\"\n                                       ng-model=\"vm.teamPayment.status\">\n                                <i class=\"blue\"></i>\n                            </label>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        data-dismiss=\"modal\">CANCEL\n                </button>\n                <button type=\"button\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        ng-click=\"vm.updateTeamPayment();\"\n                        ng-class=\"{'disabled' : !teamPaymentForm.$valid}\"\n                        ng-disabled=\"!teamPaymentForm.$valid\"\n                        data-dismiss=\"modal\">SUBMIT\n                </button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentsTeamListController = function PaymentsTeamListController(TeamsFactory, PaymentsFactory, PlayersFactory, $filter, ngDialog) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, PaymentsTeamListController);
		var vm = this;
	
		var $translate = $filter('translate');
		var $date = $filter('date');
	
		vm.$onInit = function () {
			vm.filters = { team: null, payment: null, dateFrom: new Date(), dateTo: new Date() };
			vm.teams = [];
			vm.payments = [];
			TeamsFactory.getAll().then(function (response) {
				vm.teams = response.data;
			});
			PaymentsFactory.getAll().then(function (response) {
				vm.payments = response.data;
			});
			vm.reloadPayments();
		};
	
		vm.gridOptions = {
			enableSorting: true,
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'payment_at',
				enableFiltering: false,
				name: $translate('DATE'),
				width: '130'
			}, {
				field: 'team.teamName',
				name: $translate('TEAM'),
				enableFiltering: true
			}, {
				field: 'payment.name',
				name: $translate('NAME'),
				enableFiltering: true
			}, {
				field: 'amount',
				name: $translate('AMOUNT'),
				enableFiltering: true,
				width: '90'
			}, {
				field: 'comments',
				name: $translate('COMMENTS'),
				enableFiltering: true
			}, {
				field: 'actions',
				enableFiltering: false,
				name: $translate('ACTIONS'),
				headerCellClass: 'text-center',
				cellTemplate: '' + '<div ' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-warning" translate ' + 'data-toggle="modal" ' + 'data-target="#teamPaymentModal" ' + 'ng-click="grid.appScope.vm.openEditTeamPaymentModal(row.entity)">EDIT</button> ' + '</div>' + '</div>',
				width: '130'
			}]
		};
		vm.dateFromConfig = { startView: 'day', minView: 'day', dropdownSelector: '#dateFrom' };
		vm.dateToConfig = { startView: 'day', minView: 'day', dropdownSelector: '#dateTo' };
		vm.dateConfig = { startView: 'day', minView: 'day', dropdownSelector: '#dateDropdown' };
	
		vm.openEditTeamPaymentModal = function (teamPayment) {
			vm.teamPayment = {};
			angular.copy(teamPayment, vm.teamPayment);
			vm.teamPayment.status = vm.teamPayment.status === 1;
		};
	
		vm.updateTeamPayment = function () {
			vm.teamPayment.payment_at = $date(vm.teamPayment.payment_at, 'yyyy-MM-dd');
			vm.teamPayment.status = vm.teamPayment.status ? 1 : 0;
			PaymentsFactory.updatePayment(vm.teamPayment.id, PaymentsFactory.PAYMENTS_RESOURCES.TEAM, vm.teamPayment).then(function (response) {
				ngDialog.open({ template: 'successTemplate' });
				vm.reloadPayments();
			});
		};
	
		vm.printResults = function () {
			var params = getFilterParams();
			PaymentsFactory.customReport(PaymentsFactory.PAYMENTS_RESOURCES.TEAM, params).then(function (response) {
				var file = new Blob([response.data], { type: 'application/pdf' });
				var tab = window.open();
				tab.location.href = window.URL.createObjectURL(file);
			});
		};
	
		vm.clearFilter = function (filter) {
			vm.filters[filter] = null;
			vm.reloadPayments();
		};
	
		vm.reloadPayments = function () {
			var params = getFilterParams();
			vm.gridOptions.data = [];
			PaymentsFactory.getPayments(PaymentsFactory.PAYMENTS_RESOURCES.TEAM, params).then(function (response) {
				vm.gridOptions.data = response.data;
			});
		};
	
		function getFilterParams() {
			var params = {};
			params.page_size = 5000;
			if (vm.filters.team) {
				params.team_id = vm.filters.team.team_id;
			}
			if (vm.filters.payment) {
				params.payment_id = vm.filters.payment.id;
			}
			if (vm.filters.dateFrom) {
				params.dateFrom = $date(vm.filters.dateFrom, 'yyyy-MM-dd');
			}
			if (vm.filters.dateTo) {
				params.dateTo = $date(vm.filters.dateTo, 'yyyy-MM-dd');
			}
			return params;
		}
	};
	PaymentsTeamListController.$inject = ["TeamsFactory", "PaymentsFactory", "PlayersFactory", "$filter", "ngDialog"];
	
	exports.default = PaymentsTeamListController;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(602);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paymentsTeamList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paymentsTeamList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 602 */
560,
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchesList = __webpack_require__(604);
	
	var _matchesList2 = _interopRequireDefault(_matchesList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchesListModule = _angular2.default.module('matchesList', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('matches-list', {
			url: '/matches-list',
			component: 'matchesList',
			data: { pageTitle: 'MATCHES' }
		});
	}]).component('matchesList', _matchesList2.default).name;
	
	exports.default = matchesListModule;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchesList = __webpack_require__(605);
	
	var _matchesList2 = _interopRequireDefault(_matchesList);
	
	var _matchesList3 = __webpack_require__(606);
	
	var _matchesList4 = _interopRequireDefault(_matchesList3);
	
	__webpack_require__(607);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchesListComponent = {
	  bindings: {},
	  template: _matchesList2.default,
	  controller: _matchesList4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchesListComponent;

/***/ }),
/* 605 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.ADD_MATCH)\">\n                <button type=\"button\"\n                        ng-click=\"vm.createMatch()\" class=\"btn btn-sm btn-success\">\n                    <i class=\"fa fa-plus\"></i> {{'CREATE' | translate}}\n                </button>\n            </div>\n            <div class=\"table-responsive m-b-lg\">\n                <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchesListController = function MatchesListController(MatchesFactory, $rootScope, $state, $filter, ngDialog) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, MatchesListController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		vm.rootScope = $rootScope;
	
		vm.$onInit = function () {
			reloadData();
		};
	
		vm.gridOptions = {
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableSorting: true,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'match_name',
				name: $translate('NAME'),
				enableFiltering: true,
				width: '40%'
			}, {
				field: 'entries',
				name: $translate('ENTRIES'),
				enableFiltering: false
			}, {
				field: 'match_date',
				name: $translate('DATE'),
				enableFiltering: false
			}, {
				field: 'match_location',
				name: $translate('LOCATION'),
				enableFiltering: false
			}, {
				field: 'actions',
				enableFiltering: false,
				name: $translate('ACTIONS'),
				headerCellClass: 'text-center',
				cellTemplate: '' + '<div class="ui-grid-cell-contents no-wrap ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button ' + 'translate ' + 'ng-if="grid.appScope.vm.rootScope.currentMatchId != row.entity.match_id" ' + 'ng-click="grid.appScope.vm.selectMatch(row.entity.match_id)" ' + 'class="btn btn-sm btn-info">ENTER</button>' + '<button ' + 'translate ' + 'class="btn btn-sm btn-warning" ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_MATCH)" ' + 'ng-click="grid.appScope.vm.editMatch(row.entity.match_id)">EDIT</button>' + '<button class="btn btn-sm btn-danger" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_MATCH)" ' + 'ng-click="grid.appScope.vm.deleteMatch(row.entity.match_id)">DELETE</button>' + '</div>' + '</div>',
				width: '310'
			}]
		};
	
		vm.hasPermission = function (permission) {
			return vm.rootScope.user.canDo(permission);
		};
	
		vm.createMatch = function () {
			vm.rootScope.clearMatchData();
			$state.go('match-edit');
		};
	
		vm.editMatch = function (matchId) {
			$state.go('match-edit', { id: matchId });
		};
	
		vm.selectMatch = function (matchId) {
			MatchesFactory.getOne(matchId).then(function (response) {
				vm.rootScope.updateMatchData(response.data);
				$state.go('match-profile', { id: vm.rootScope.currentMatchId });
			});
		};
	
		vm.deleteMatch = function (matchId) {
			ngDialog.openConfirm({
				template: 'confirmTemplate',
				data: {
					message: $translate('CONFIRM_DELETE_MATCH')
				}
			}).then(function () {
				MatchesFactory.delete(matchId).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					reloadData();
					if (vm.rootScope.currentMatchId === matchId) {
						vm.rootScope.clearMatchData();
					}
				});
			});
		};
	
		function reloadData() {
			MatchesFactory.getAll().then(function (response) {
				vm.gridOptions.data = response.data;
			});
		}
	};
	MatchesListController.$inject = ["MatchesFactory", "$rootScope", "$state", "$filter", "ngDialog"];
	
	exports.default = MatchesListController;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(608);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./matchesList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./matchesList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 608 */
560,
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchProfile = __webpack_require__(610);
	
	var _matchProfile2 = _interopRequireDefault(_matchProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchProfileModule = _angular2.default.module('matchProfile', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('match-profile', {
			url: '/match-profile',
			component: 'matchProfile',
			data: { pageTitle: '' }
		});
	}]).component('matchProfile', _matchProfile2.default).name;
	
	exports.default = matchProfileModule;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchProfile = __webpack_require__(611);
	
	var _matchProfile2 = _interopRequireDefault(_matchProfile);
	
	var _matchProfile3 = __webpack_require__(612);
	
	var _matchProfile4 = _interopRequireDefault(_matchProfile3);
	
	__webpack_require__(613);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchProfileComponent = {
	  bindings: {},
	  template: _matchProfile2.default,
	  controller: _matchProfile4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchProfileComponent;

/***/ }),
/* 611 */
/***/ (function(module, exports) {

	module.exports = "<div\n  class=\"item\"\n  ng-if=\"!vm.state.current.data.hideMatchProfile && vm.rootScope.currentMatchId\"\n>\n  <div class=\"item-bg\">\n    <img src=\"../assets/images/vegas.jpg\" class=\"blur opacity-3\" />\n  </div>\n  <div class=\"p-a-md\">\n    <div class=\"row m-t\">\n      <div class=\"col-sm-12\">\n        <a href class=\"pull-left m-r-md\">\n          <span class=\"avatar w-96\">\n            <img ng-src=\"{{vm.getMatchImage()}}\" />\n            <i class=\"on b-white\"></i>\n          </span>\n        </a>\n        <div ng-if=\"vm.match\" class=\"clear\">\n          <h4 class=\"m-a-0 m-b-xs\" ng-bind=\"vm.match.match_sortname\"></h4>\n          <div class=\"text-muted\">\n            <span class=\"m-r\" ng-bind=\"vm.match.match_host\"></span>\n            <small>\n              <i class=\"fa fa-map-marker m-r-xs\"></i>{{vm.match.match_location}}\n            </small>\n          </div>\n          <div class=\"block clearfix text-black\">\n            {{ 'REGISTRATION_OPEN_DATE' | translate }} :\n            <span\n              class=\"m-r text-muted\"\n              ng-bind=\"vm.formatDate(vm.match.registration_start) |  date:'EEEE d MMMM yyyy'\"\n            ></span>\n          </div>\n          <div class=\"block clearfix m-b text-black\">\n            {{ 'REGISTRATION_END_DATE' | translate }} :\n            <span\n              class=\"m-r text-muted\"\n              ng-bind=\"vm.formatDate(vm.match.registration_end) |  date:'EEEE d MMMM yyyy'\"\n            ></span>\n          </div>\n          <div class=\"block clearfix\">\n            <button\n              ui-sref=\"match-edit({id:vm.rootScope.currentMatchId})\"\n              ng-if=\"vm.rootScope.user.canDo(vm.rootScope.permissions.EDIT_MATCH)\"\n              translate\n              class=\"btn btn-sm btn-warning btn-rounded m-b\"\n            >\n              EDIT_GAME\n            </button>\n            <button\n              ng-show=\"vm.registrationText\"\n              translate\n              ng-class=\"{'success' : vm.isRegistrationOpen(), 'danger' : !vm.isRegistrationOpen()}\"\n              class=\"btn btn-sm btn-rounded m-b\"\n              ng-bind=\"vm.registrationText\"\n            ></button>\n            <button\n              translate\n              ng-click=\"vm.exitMatch();\"\n              class=\"btn btn-sm btn-info btn-rounded m-b\"\n            >\n              EXIT_GAME\n            </button>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<div\n  class=\"dker p-x\"\n  ng-if=\"!vm.state.current.data.hideMatchMenu && vm.rootScope.currentMatchId\"\n>\n  <div class=\"row\">\n    <div class=\"col-sm-8\">\n      <div class=\"p-y-md clearfix nav-active-primary\">\n        <ul class=\"nav nav-pills nav-sm\">\n          <li\n            class=\"nav-item match-nav-link\"\n            ng-repeat=\"section in vm.matchSections\"\n            ng-if=\"!section.permission || vm.rootScope.user.canDo(section.permission)\"\n            ng-class=\"{'active': vm.state.includes(section.state)}\"\n          >\n            <a translate class=\"nav-link\" ui-sref=\"{{section.state}}\"\n              >{{section.name}}</a\n            >\n          </li>\n          <li\n            class=\"nav-item match-nav-link\"\n            ng-if=\"vm.rootScope.user.canDo(vm.rootScope.permissions.ADD_SCORE_TO_MATCH)\"\n            ng-click=\"vm.goToVisualEliminations();\"\n          >\n            <a translate class=\"nav-link\" href=\"#\"\n              >ADD_SHOTS_VISUAL_ELIMINATIONS</a\n            >\n          </li>\n        </ul>\n      </div>\n    </div>\n    <div class=\"col-sm-4\">\n      <div class=\"p-y text-center text-sm-right\">\n        <a href class=\"inline p-x b-r text-center\">\n          <span class=\"h4 block m-a-0\" ng-bind=\"vm.match.entries\"></span>\n          <small class=\"text-xs text-muted\" translate>REGISTRATIONS</small>\n        </a>\n      </div>\n    </div>\n  </div>\n</div>\n<div class=\"padding\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <div class=\"tab-content\">\n        <div class=\"tab-pane p-v-sm active\">\n          <div ui-view></div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchProfileController = function MatchProfileController(MatchesFactory, $state, $scope, $rootScope, $window, $filter, Permissions) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, MatchProfileController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	  $state.current.data.hideSidebar = true;
	  vm.$onInit = function () {
	    vm.state = $state;
	    vm.match = {};
	    vm.matchSections = [{
	      state: "match-profile.targets",
	      name: "TARGETS",
	      permission: Permissions.EDIT_MATCH_TARGETS
	    }, {
	      state: "match-profile.leagues",
	      name: "LEAGUES",
	      permission: Permissions.EDIT_MATCH_LEAGUES
	    }, {
	      state: "match-profile.prints",
	      name: "PRINTS"
	      // permission: Permissions.MATCH_PRINTS
	    }, {
	      state: "match-profile.eliminations",
	      name: "ELIMINATION_ROUNDS",
	      permission: Permissions.MATCH_ELIMINATION_ROUNDS
	    }, {
	      state: "match-profile.finalize",
	      name: "FINALIZE_MATCH",
	      permission: Permissions.UPDATE_MATCH
	    }, { state: "match-profile.registrations", name: "REGISTRATIONS" }, {
	      state: "match-profile.addShots",
	      name: "ADD_SHOTS",
	      permission: Permissions.ADD_SCORE_TO_MATCH
	    }, {
	      state: "match-profile.addShotsIndividual",
	      name: "ADD_SHOTS_INDIVIDUAL",
	      permission: Permissions.ADD_SCORE_TO_MATCH_ELIMINATION_ROUNDS
	    }, {
	      state: "match-profile.addShotsTeam",
	      name: "ADD_SHOTS_TEAM",
	      permission: Permissions.ADD_SCORE_TO_MATCH_ELIMINATION_ROUNDS
	    }, {
	      state: "match-profile.addShotsMixedTeam",
	      name: "ADD_SHOTS_MIXED_TEAM",
	      permission: Permissions.ADD_SCORE_TO_MATCH_ELIMINATION_ROUNDS
	    }, {
	      state: "match-profile.addShotsVisual",
	      name: "ADD_SHOTS_VISUAL",
	      permission: Permissions.ADD_SCORE_TO_MATCH
	    }];
	  };
	
	  vm.goToVisualEliminations = function () {
	    window.location.href = "/match-profile/shotsIndividualVisual/" + vm.rootScope.currentMatchId;
	  };
	
	  vm.formatDate = function (date) {
	    return new Date(date);
	  };
	
	  vm.isRegistrationOpen = function () {
	    var now = new Date();
	    var start = new Date(vm.match.registration_start);
	    var end = new Date(vm.match.registration_end);
	    var isOpen = now > start && now < end;
	    if (isOpen) {
	      vm.registrationText = $translate("REGISTRATION_OPEN");
	    } else {
	      vm.registrationText = $translate("REGISTRATION_CLOSED");
	    }
	    return isOpen;
	  };
	
	  vm.getMatchImage = function () {
	    return "assets/images/target.png";
	  };
	
	  vm.exitMatch = function () {
	    vm.rootScope.clearMatchData();
	    $state.go("matches-list");
	  };
	
	  if (vm.rootScope.currentMatchId) {
	    MatchesFactory.getOne(vm.rootScope.currentMatchId).then(function (response) {
	      vm.match = response.data;
	      $rootScope.updateMatchData(response.data);
	    });
	  }
	};
	MatchProfileController.$inject = ["MatchesFactory", "$state", "$scope", "$rootScope", "$window", "$filter", "Permissions"];
	
	exports.default = MatchProfileController;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(614);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./matchProfile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./matchProfile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, ".item-bg img{left:0!important;top:0!important;margin-left:0!important;margin-top:0!important}.match-nav-link:not(.active){border:1px solid rgba(0,0,0,.12)!important;margin:2px;border-radius:7px;background:#fff}.match-nav-link.active{border:1px solid #0cc2aa!important;margin:2px;border-radius:7px}", ""]);
	
	// exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchTargets = __webpack_require__(616);
	
	var _matchTargets2 = _interopRequireDefault(_matchTargets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchTargetsModule = _angular2.default.module('matchTargets', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('match-profile.targets', {
			url: '/targets',
			component: 'matchTargets',
			data: { pageTitle: 'TARGETS' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.EDIT_MATCH_TARGETS)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('matchTargets', _matchTargets2.default).name;
	
	exports.default = matchTargetsModule;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchTargets = __webpack_require__(617);
	
	var _matchTargets2 = _interopRequireDefault(_matchTargets);
	
	var _matchTargets3 = __webpack_require__(618);
	
	var _matchTargets4 = _interopRequireDefault(_matchTargets3);
	
	__webpack_require__(619);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchTargetsComponent = {
	  bindings: {},
	  template: _matchTargets2.default,
	  controller: _matchTargets4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchTargetsComponent;

/***/ }),
/* 617 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <button class=\"btn btn-fw m-l-1 m-b-1\"\n                        translate\n                        ng-repeat=\"option in vm.targetOptions\"\n                        ng-class=\"{'success' : vm.targetOptionActive == option.id, 'white' : vm.targetOptionActive != option.id}\"\n                        ng-click=\"vm.targetOptionActive = option.id\">\n                    {{option.name}}\n                </button>\n            </div>\n            <div class=\"box-divider m-a-0\"></div>\n            <div ng-if=\"vm.targetOptionActive == 1\" class=\"box-body\">\n                <!-- PRODUCE TARGETS -->\n                <form name=\"produceTargetsForm\" ng-submit=\"vm.produceTargets();\">\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-4 form-control-label\">PLAYERS_PER_TARGET</label>\n                        <div class=\"col-sm-8\">\n                            <ui-select ng-model=\"vm.perTarget\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"Select players per target...\">\n                                    {{$select.selected}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.perTargetOptions | filter: $select.search\">\n                                    <div ng-bind-html=\"item | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn primary btn-block p-x-md\"\n                            ng-disabled=\"!produceTargetsForm.$valid\">SUBMIT</button>\n                </form>\n            </div>\n            <div ng-if=\"vm.targetOptionActive == 2\" class=\"box-body\">\n                <!-- CLEAR TARGETS -->\n                <button type=\"submit\"\n                        translate\n                        ng-click=\"vm.clearTargets();\"\n                        class=\"btn primary btn-block p-x-md\">SUBMIT</button>\n            </div>\n            <div ng-if=\"vm.targetOptionActive == 3\" class=\"box-body\">\n                <!-- PRODUCE TARGETS -->\n                <form name=\"movePlayerToTargetForm\" ng-submit=\"vm.movePlayerToTarget();\">\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-2 form-control-label\">PLAYER</label>\n                        <div class=\"col-sm-10\">\n                            <ui-select ng-model=\"vm.selectedPlayer\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_PLAYER' | translate}}\">\n                                    {{$select.selected.playerName}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.matchPlayers | filter: $select.search\">\n                                    <div ng-bind-html=\"item.playerName | highlight: $select.search\"></div>\n                                    <small ng-bind-html=\"item.teamName | highlight: $select.search\"></small>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-2 form-control-label\">TARGET</label>\n                        <div class=\"col-sm-10\">\n                            <div class=\"row\">\n                                <div class=\"col-md-3\">\n                                    <input type=\"text\"\n                                           required\n                                           ng-model=\"vm.target\"\n                                           class=\"form-control\"\n                                           placeholder=\"{{'TARGET' | translate}}\">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn primary btn-block p-x-md\"\n                            ng-disabled=\"!movePlayerToTargetForm.$valid\">SUBMIT</button>\n                </form>\n            </div>\n            <div ng-if=\"vm.targetOptionActive == 4\" class=\"box-body\">\n                <form name=\"swapTargetsForm\" ng-submit=\"vm.swapTargets();\">\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-2 form-control-label\">TARGET_ONE</label>\n                        <div class=\"col-sm-10\">\n                            <ui-select required ng-model=\"vm.swapTargetOne\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_PLAYER' | translate}}\">\n                                    {{$select.selected.target_name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.matchPlayers | filter: $select.search\">\n                                    <div ng-bind-html=\"item.target_name | highlight: $select.search\"></div>\n                                    <small ng-bind-html=\"item.playerName | highlight: $select.search\"></small>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-2 form-control-label\">TARGET_TWO</label>\n                        <div class=\"col-sm-10\">\n                            <ui-select required ng-model=\"vm.swapTargetTwo\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_PLAYER' | translate}}\">\n                                    {{$select.selected.target_name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.matchPlayers | filter: $select.search\">\n                                    <div ng-bind-html=\"item.target_name | highlight: $select.search\"></div>\n                                    <small ng-bind-html=\"item.playerName | highlight: $select.search\"></small>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn primary btn-block p-x-md\"\n                            ng-disabled=\"!swapTargetsForm.$valid\">SUBMIT</button>\n                </form>\n            </div>\n            <div ng-if=\"vm.targetOptionActive == 5\" class=\"box-body\">\n                <form name=\"moveTargetsForm\" ng-submit=\"vm.moveTargets();\">\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-2 form-control-label\">DIRECTION</label>\n                        <div class=\"col-sm-10\">\n                            <div class=\"radio\">\n                                <label>\n                                    <input type=\"radio\"\n                                           name=\"optionsRadios\"\n                                           ng-model=\"vm.direction\"\n                                           id=\"frontId\" value=\"front\">\n                                    {{'FRONT' | translate}}\n                                </label>\n                            </div>\n                            <div class=\"radio\">\n                                <label>\n                                    <input type=\"radio\"\n                                           name=\"optionsRadios\"\n                                           ng-model=\"vm.direction\"\n                                           id=\"backId\" value=\"back\">\n                                    {{'BACK' | translate}}\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-2 form-control-label\">DISTANCE</label>\n                        <div class=\"col-sm-10\">\n                            <ui-select required ng-model=\"vm.distance\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"Select a distance...\">\n                                    {{$select.selected}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.distances | filter: $select.search\">\n                                    <div ng-bind-html=\"item | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-2 form-control-label\">FROM_TARGET</label>\n                        <div class=\"col-sm-10\">\n                            <ui-select required ng-model=\"vm.fromTarget\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_TARGET' | translate}}\">\n                                    {{$select.selected}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.targetNumbers | filter: $select.search\">\n                                    <div ng-bind-html=\"item | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-2 form-control-label\">TO_TARGET</label>\n                        <div class=\"col-sm-10\">\n                            <ui-select required ng-model=\"vm.toTarget\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_TARGET' | translate}}\">\n                                    {{$select.selected}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.targetNumbers | filter: $select.search\">\n                                    <div ng-bind-html=\"item | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn primary btn-block p-x-md\"\n                            ng-disabled=\"!moveTargetsForm.$valid\">SUBMIT</button>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchTargetsController = function MatchTargetsController(MatchesFactory, $rootScope, ngDialog, $filter) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, MatchTargetsController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		/* Load Matches dat */
		vm.$onInit = function () {
			vm.rootScope = $rootScope;
			vm.targetOptions = [{ id: 1, name: 'PRODUCE_TARGETS' }, { id: 2, name: 'EMPTY_ALL_TARGETS' }, { id: 3, name: 'MOVE_PLAYER' }, { id: 4, name: 'SWAP_TARGETS' }, { id: 5, name: 'MOVE_TARGETS' }];
			vm.targetOptionActive = 0;
			reloadMatchData();
		};
	
		/* Product Targets*/
		vm.perTargetOptions = [1, 2, 3, 4];
		vm.perTarget = 4;
		vm.produceTargets = function () {
			MatchesFactory.produceTargets(vm.rootScope.currentMatchId, vm.perTarget).then(function (response) {
				ngDialog.open({ template: 'successTemplate' });
				reloadMatchData();
			});
		};
	
		/* Clear Targets */
		vm.clearTargets = function () {
			ngDialog.openConfirm({
				template: 'confirmTemplate',
				data: {
					message: $translate('CONFIRM_CLEAR_TARGETS')
				}
			}).then(function () {
				MatchesFactory.clearTargets(vm.rootScope.currentMatchId).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					reloadMatchData();
				});
			});
		};
	
		/* Move Player */
		vm.selectedPlayer = null;
		vm.target = null;
		vm.movePlayerToTarget = function () {
			MatchesFactory.movePlayerToTarget(vm.rootScope.currentMatchId, vm.selectedPlayer.player_id, vm.target).then(function (response) {
				ngDialog.open({ template: 'successTemplate' });
				reloadMatchData();
				vm.target = null;
				vm.selectedPlayer = null;
			});
		};
	
		/* Swap Targets */
		vm.swapTargetOne = null;
		vm.swapTargetTwo = null;
		vm.swapTargets = function () {
			MatchesFactory.swapTargets(vm.rootScope.currentMatchId, vm.swapTargetOne.target_name, vm.swapTargetTwo.target_name).then(function (response) {
				ngDialog.open({ template: 'successTemplate' });
				reloadMatchData();
				vm.swapTargetOne = null;
				vm.swapTargetTwo = null;
			});
		};
	
		/* Move Targets */
		vm.distance = 1;
		vm.distances = [];
		for (var i = 0; i < 21; i++) {
			vm.distances.push(i);
		}
		vm.fromTarget = null;
		vm.toTarget = null;
		vm.direction = 'front';
		vm.moveTargets = function () {
			MatchesFactory.moveTargets(vm.rootScope.currentMatchId, vm.distance, vm.fromTarget, vm.toTarget, vm.direction).then(function (response) {
				ngDialog.open({ template: 'successTemplate' });
				reloadMatchData();
				vm.fromTarget = null;
				vm.toTarget = null;
			});
		};
	
		function reloadMatchData() {
			vm.matchPlayers = [];
			vm.targetNumbers = [];
			var params = { include: 'matchPlayers' };
			MatchesFactory.getOne(vm.rootScope.currentMatchId, params).then(function (response) {
				vm.matchPlayers = response.data.matchPlayers;
				(0, _entries2.default)(vm.matchPlayers).forEach(function (entry) {
					if (entry[1].target_name == null) {
						return;
					}
					var value = entry[1].target_name.substring(0, 2);
					if (!vm.targetNumbers.includes(value)) {
						vm.targetNumbers.push(value);
					}
				});
				if (vm.targetNumbers.length > 1) {
					vm.targetNumbers.sort();
				}
			});
		}
	};
	MatchTargetsController.$inject = ["MatchesFactory", "$rootScope", "ngDialog", "$filter"];
	
	exports.default = MatchTargetsController;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(620);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchTargets.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchTargets.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, ".hidden{display:none}", ""]);
	
	// exports


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchLeagues = __webpack_require__(622);
	
	var _matchLeagues2 = _interopRequireDefault(_matchLeagues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchLeaguesModule = _angular2.default.module('matchLeagues', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('match-profile.leagues', {
			url: '/leagues',
			component: 'matchLeagues',
			data: { pageTitle: 'LEAGUES' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.EDIT_MATCH_LEAGUES)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('matchLeagues', _matchLeagues2.default).name;
	
	exports.default = matchLeaguesModule;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchLeagues = __webpack_require__(623);
	
	var _matchLeagues2 = _interopRequireDefault(_matchLeagues);
	
	var _matchLeagues3 = __webpack_require__(624);
	
	var _matchLeagues4 = _interopRequireDefault(_matchLeagues3);
	
	__webpack_require__(625);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchLeaguesComponent = {
	  bindings: {},
	  template: _matchLeagues2.default,
	  controller: _matchLeagues4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchLeaguesComponent;

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <button class=\"btn btn-fw m-l-1 m-b-1\"\n                        translate\n                        ng-repeat=\"option in vm.options\"\n                        ng-if=\"!option.permission || vm.hasPermission(option.permission)\"\n                        ng-class=\"{'success' : vm.activeOption == option.id, 'white' : vm.activeOption != option.id}\"\n                        ng-click=\"vm.selectOption(option.id);\">\n                    {{option.name}}\n                </button>\n            </div>\n            <div class=\"box-divider m-a-0\"></div>\n            <div ng-if=\"vm.activeOption == 1\" class=\"box-body\">\n                <div class=\"row\">\n                    <div class=\"col-sm-12\">\n                        <div class=\"box\">\n                            <div class=\"table-responsive m-b-lg\">\n                                <div ui-grid=\"vm.leagueGridOptions\" ui-grid-pagination></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"vm.activeOption == 2\" class=\"box-body\">\n                <div class=\"row\">\n                    <div class=\"col-sm-12\">\n                        <div class=\"box\">\n                            <div class=\"table-responsive m-b-lg\">\n                                <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div ng-if=\"vm.activeOption == 3\" class=\"box-body\">\n                <form name=\"moveLeaguesForm\" ng-submit=\"vm.moveLeagues();\">\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">SELECT_LEAGUES</label>\n                        <div class=\"col-sm-9\">\n                            <div class=\"checkbox\" ng-repeat=\"league in vm.matchLeagues\">\n                                <label class=\"ui-check ui-check-md\">\n                                    <input type=\"checkbox\"\n                                           id=\"chk-{{league.league_id}}\"\n                                           ng-model=\"vm.leaguesToMove[league.league_id]\"\n                                           ng-value=\"league.league_id\">\n                                    <i class=\"dark-white\"></i>\n                                    {{league.league_name}}\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-3 form-control-label\">NEW_MATCH</label>\n                        <div class=\"col-sm-9\">\n                            <ui-select required ng-model=\"vm.newMatch\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_MATCH' | translate}}\">\n                                    {{$select.selected.match_name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.matches | filter: $select.search\">\n                                    <div ng-bind-html=\"item.match_name | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn primary btn-block p-x-md\"\n                            ng-disabled=\"!moveLeaguesForm.$valid\">SUBMIT</button>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div id=\"changePlayerLeagueModel\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" translate>UPDATE_PLAYER_LEAGUE</h5>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"playerLeagueForm\">\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-2 form-control-label\">LEAGUE</label>\n                        <div class=\"col-sm-10\">\n                            <ui-select ng-model=\"vm.selectedLeauge\" theme=\"bootstrap\">\n                                <ui-select-match class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_LEAGUE' | translate}}\">\n                                    {{$select.selected.league_name}}\n                                </ui-select-match>\n                                <ui-select-choices class=\"ui-select-choices\"\n                                        repeat=\"item in vm.matchLeagues | filter: $select.search\">\n                                    <div ng-bind-html=\"item.league_name | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        data-dismiss=\"modal\">CANCEL\n                </button>\n                <button type=\"button\"\n                        translate\n                        data-dismiss=\"modal\"\n                        class=\"btn danger p-x-md\"\n                        ng-click=\"vm.updatePlayerLeague();\"\n                        ng-class=\"{'disabled' : !playerLeagueForm.$valid}\"\n                        ng-disabled=\"!playerLeagueForm.$valid\">SUBMIT\n                </button>\n            </div>\n        </div><!-- /.modal-content -->\n    </div>\n</div>"

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(535);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchLeaguesController = function MatchLeaguesController(MatchesFactory, LeaguesFactory, $rootScope, $filter, $state, ngDialog, Permissions, Levels) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, MatchLeaguesController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	  vm.levels = [{ id: Levels.WHITE, name: "White" }, { id: Levels.BLACK, name: "Black" }, { id: Levels.BLUE, name: "Blue" }, { id: Levels.RED, name: "Red" }, { id: Levels.YELLOW, name: "Yellow" }, { id: Levels.GREEN, name: "Green" }];
	
	  /* Load Matches dat */
	  vm.$onInit = function () {
	    $state.current.data.hideSidebar = true;
	    vm.rootScope = $rootScope;
	    vm.options = [{ id: 1, name: "MATCH_LEAGUES" }, { id: 2, name: "PLAYER_LEAGUES" }, { id: 3, name: "MOVE_MATCH", permission: Permissions.MOVE_MATCH }];
	    vm.matchPlayers = [];
	    vm.activeOption = 0;
	    vm.matches = [];
	    vm.matchLeagues = [];
	    LeaguesFactory.getAll().then(function (response) {
	      vm.leagueGridOptions.data = response.data;
	      reloadMatchData();
	    });
	    MatchesFactory.getAll().then(function (response) {
	      vm.matches = response.data;
	    });
	  };
	
	  vm.hasPermission = function (permission) {
	    return vm.rootScope.user.canDo(permission);
	  };
	
	  vm.selectOption = function (option) {
	    vm.activeOption = option;
	  };
	
	  /* Edit Match Leagues */
	  vm.leagueGridOptions = {
	    enablePaginationControls: false,
	    enableSorting: true,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "league_name",
	      enableFiltering: true,
	      name: $translate("LEAGUE_NAME")
	    }, {
	      field: "level",
	      enableFiltering: true,
	      name: $translate("LEVEL"),
	      width: "100",
	      cellTemplate: "<div class=\"ui-grid-cell-contents ui-grid-align-c\">\n\t\t\t{{grid.appScope.vm.getLevelName(row.entity)}}\n\t\t\t</div>"
	    }, {
	      field: "type",
	      enableFiltering: true,
	      name: $translate("BOW_TYPE"),
	      width: "100"
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-success" translate ' + 'ng-if="!grid.appScope.vm.isLeagueInMatch(row.entity.league_id)" ' + 'ng-click="grid.appScope.vm.addLeague(row.entity.league_id)">CREATE</button> ' + '<button class="btn btn-sm btn-danger" translate ' + 'ng-if="grid.appScope.vm.isLeagueInMatch(row.entity.league_id)" ' + 'ng-click="grid.appScope.vm.removeLeague(row.entity.league_id)">DELETE</button> ' + "</div>" + "</div>",
	      width: "150"
	    }],
	    onRegisterApi: function onRegisterApi(gridApi) {
	      vm.leaguesGridApi = gridApi;
	    }
	  };
	  vm.isLeagueInMatch = function (leagueId) {
	    return vm.matchLeagues.find(function (matchLeague) {
	      return matchLeague.league_id === leagueId;
	    });
	  };
	  vm.addLeague = function (league_id) {
	    MatchesFactory.addLeague(vm.rootScope.currentMatchId, league_id).then(function () {
	      return reloadMatchData();
	    });
	  };
	  vm.removeLeague = function (leagueId) {
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate("CONFIRM_REMOVE_LEAGUE_FROM_MATCH")
	      }
	    }).then(function () {
	      MatchesFactory.removeLeague(vm.rootScope.currentMatchId, leagueId).then(function (response) {
	        reloadMatchData();
	      });
	    });
	  };
	  vm.getLevelName = function (league) {
	    return vm.levels.find(function (l) {
	      return l.id === league.level;
	    }).name;
	  };
	
	  /* Player Leagues */
	  vm.gridOptions = {
	    enableSorting: true,
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "AA",
	      enableFiltering: false,
	      displayName: "AA",
	      width: "58",
	      cellTemplate: "" + '<div class="ui-grid-cell-contents">{{grid.renderContainers.body.visibleRowCache.indexOf(row)+(grid.options.paginationPageSize*(grid.options.paginationCurrentPage-1))+1}}</div>'
	    }, {
	      field: "playerName",
	      enableFiltering: true,
	      name: $translate("PLAYER_NAME")
	    }, {
	      field: "teamName",
	      name: $translate("TEAM_NAME"),
	      enableFiltering: false,
	      width: "170"
	    }, {
	      field: "leagueName",
	      name: $translate("LEAGUE_NAME"),
	      enableFiltering: false
	    }, {
	      field: "changeLeague",
	      enableFiltering: false,
	      name: $translate("UPDATE_PLAYER_LEAGUE"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + "<button " + 'class="btn btn-sm info" ' + "translate " + 'data-toggle="modal" ' + 'ng-click="grid.appScope.vm.opelPlayerLeagueModal(row.entity.player_id)" ' + 'data-target="#changePlayerLeagueModel">PICK</button></div>',
	      width: "170"
	    }]
	  };
	  vm.opelPlayerLeagueModal = function (playerId) {
	    vm.currentPlayerId = playerId;
	    vm.selectedLeauge = null;
	  };
	  vm.updatePlayerLeague = function () {
	    MatchesFactory.updatePlayerLeague(vm.rootScope.currentMatchId, vm.currentPlayerId, vm.selectedLeauge.league_id).then(function (response) {
	      ngDialog.open({ template: "successTemplate" });
	      reloadMatchData();
	      vm.clearSelections();
	    });
	  };
	
	  /* Move Leagues */
	  vm.leaguesToMove = [];
	  vm.newMatch = null;
	  vm.moveLeagues = function () {
	    var leagueIds = [];
	    (0, _entries2.default)(vm.leaguesToMove).forEach(function (entry) {
	      var key = entry[0];
	      var value = entry[1];
	      if (value) {
	        leagueIds.push(key);
	      }
	    });
	    if (leagueIds.length === 0) {
	      return;
	    }
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate("CONFIRM_MOVE_LEAGUES")
	      }
	    }).then(function () {
	      MatchesFactory.moveLeagues(vm.rootScope.currentMatchId, vm.newMatch.match_id, leagueIds).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        reloadMatchData();
	      });
	    });
	  };
	
	  function reloadMatchData() {
	    MatchesFactory.getOne(vm.rootScope.currentMatchId, {
	      include: "matchPlayers,matchLeagues"
	    }).then(function (response) {
	      vm.gridOptions.data = response.data.matchPlayers;
	      vm.matchLeagues = [];
	      (0, _entries2.default)(response.data.matchLeagues).forEach(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            key = _ref2[0],
	            value = _ref2[1];
	
	        vm.matchLeagues.push(value.league);
	      });
	      if (vm.leaguesGridApi) {
	        vm.leaguesGridApi.core.refresh();
	      }
	    });
	  }
	};
	MatchLeaguesController.$inject = ["MatchesFactory", "LeaguesFactory", "$rootScope", "$filter", "$state", "ngDialog", "Permissions", "Levels"];
	
	exports.default = MatchLeaguesController;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(626);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchLeagues.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchLeagues.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchPrints = __webpack_require__(628);
	
	var _matchPrints2 = _interopRequireDefault(_matchPrints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchPrintsModule = _angular2.default.module("matchPrints", [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("match-profile.prints", {
	    url: "/prints",
	    component: "matchPrints",
	    data: { pageTitle: "PRINTS" },
	    resolve: {
	      hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
	        "ngInject";
	
	        var deferred = $q.defer();
	        // if($rootScope.user.canDo(Permissions.MATCH_PRINTS)){
	        deferred.resolve();
	        // }else{
	        // 	deferred.reject("Access Denied!!");
	        // }
	        return deferred.promise;
	      }]
	    }
	  });
	}]).component("matchPrints", _matchPrints2.default).name;
	
	exports.default = matchPrintsModule;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchPrints = __webpack_require__(629);
	
	var _matchPrints2 = _interopRequireDefault(_matchPrints);
	
	var _matchPrints3 = __webpack_require__(630);
	
	var _matchPrints4 = _interopRequireDefault(_matchPrints3);
	
	__webpack_require__(631);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchPrintsComponent = {
	  bindings: {},
	  template: _matchPrints2.default,
	  controller: _matchPrints4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchPrintsComponent;

/***/ }),
/* 629 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <button class=\"btn btn-fw m-l-1 m-b-1\"\n                        translate\n                        ng-repeat=\"option in vm.options\"\n                        ng-class=\"{'success' : vm.activeOption == option.id, 'white' : vm.activeOption != option.id}\"\n                        ng-if=\"(!option.premium || vm.rootScope.user.isPremium())\"\n                        ng-click=\"vm.selectOption(option)\">\n                    {{option.name}}\n                </button>\n            </div>\n            <div class=\"box-divider m-a-0\"></div>\n            <div ng-if=\"vm.activeOption == 8\" class=\"box-body\">\n                <div class=\"b-b m-b-1 text-center\">\n                    <h3 class=\"_300 ng-binding\" translate>ELIMINATION_INDIVIDUAL</h3>\n                </div>\n                <div ng-repeat=\"league in vm.matchLeagues\" class=\"m-b-1\">\n                    <button type=\"button\"\n                            ng-if=\"league.olympic_players\"\n                            ng-click=\"vm.getEliminationsPrintPDF(league.league_id, vm.eliminationTypes.INDIVIDUAL);\"\n                            class=\"btn blue btn-block p-x-md\">{{league.leagueName}}</button>\n                    <button type=\"button\"\n                            ng-repeat=\"round in ['1/32','1/16','1/8','1/4','1/2','1/1']\"\n                            ng-if=\"league.olympic_players\"\n                            ng-click=\"vm.getEliminationsTargetBoardsPDF(league.league_id, vm.eliminationTypes.INDIVIDUAL, round);\"\n                            class=\"btn danger p-x-md m-t-1 m-r-1\">{{round}}</button>\n                </div>\n                <div class=\"b-b m-t-1 m-b-1 text-center\">\n                    <h3 class=\"_300 ng-binding\" translate>ELIMINATION_TEAM</h3>\n                </div>\n                <div ng-repeat=\"league in vm.matchLeagues\" class=\"m-b-1\">\n                    <button type=\"button\"\n                            ng-if=\"league.olympic_teams\"\n                            ng-click=\"vm.getEliminationsPrintPDF(league.league_id, vm.eliminationTypes.TEAM);\"\n                            class=\"btn green btn-block p-x-md\">{{league.leagueName}}</button>\n                    <button type=\"button\"\n                            ng-repeat=\"round in ['1/32','1/16','1/8','1/4','1/2','1/1']\"\n                            ng-if=\"league.olympic_teams\"\n                            ng-click=\"vm.getEliminationsTargetBoardsPDF(league.league_id, vm.eliminationTypes.TEAM, round);\"\n                            class=\"btn danger p-x-md m-t-1 m-r-1\">{{round}}</button>\n                </div>\n                <div class=\"b-b m-t-1 m-b-1 text-center\">\n                    <h3 class=\"_300 ng-binding\" translate>ELIMINATION_MIXED_TEAM</h3>\n                </div>\n                <div ng-repeat=\"league in vm.matchLeagues\" class=\"m-b-1\">\n                    <button type=\"button\"\n                            ng-if=\"league.olympic_mixed\"\n                            ng-click=\"vm.getEliminationsPrintPDF(league.league_id, vm.eliminationTypes.MIXED_TEAM);\"\n                            class=\"btn accent btn-block p-x-md\">\n                        {{league.leagueName}} - {{league.mixedLeagueName}}\n                    </button>\n                    <button type=\"button\"\n                            ng-repeat=\"round in ['1/32','1/16','1/8','1/4','1/2','1/1']\"\n                            ng-if=\"league.olympic_mixed\"\n                            ng-click=\"vm.getEliminationsTargetBoardsPDF(league.league_id, vm.eliminationTypes.MIXED_TEAM, round);\"\n                            class=\"btn danger p-x-md m-t-1 m-r-1\">{{round}}</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div id=\"changePlayerLeagueModel\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" translate>UPDATE_PLAYER_LEAGUE</h5>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form>\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-2 form-control-label\">LEAGUE</label>\n                        <div class=\"col-sm-10\">\n                            <ui-select ng-model=\"vm.selectedLeauge\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_LEAGUE' | translate}}\">\n                                    {{$select.selected.league_name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.matchLeagues | filter: $select.search\">\n                                    <div ng-bind-html=\"item.league_name | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        ng-click=\"vm.clearSelections()\"\n                        data-dismiss=\"modal\">CANCEL</button>\n                <button type=\"button\"\n                        ng-click=\"vm.updatePlayerLeague();\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        ng-class=\"{'disabled' : !vm.isValid()}\"\n                        ng-disable=\"!vm.isValid()\"\n                        data-dismiss=\"modal\">SUBMIT</button>\n            </div>\n        </div><!-- /.modal-content -->\n    </div>\n</div>"

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchPrintsController = function MatchPrintsController(MatchesFactory, $rootScope, Permissions) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, MatchPrintsController);
	  var vm = this;
	
	  vm.$onInit = function () {
	    vm.rootScope = $rootScope;
	    vm.eliminationTypes = MatchesFactory.MATCH_ELIMINATION_TYPES;
	    vm.matchLeagues = [];
	    vm.mixedLeagues = [];
	    vm.options = [{
	      id: 1,
	      name: "LEAGUES_LIST",
	      action: MatchesFactory.MATCH_PRINTS.LEAGUES_LIST
	    }, {
	      id: 2,
	      name: "PLAYERS_LIST",
	      action: MatchesFactory.MATCH_PRINTS.PLAYERS_LIST
	    }, {
	      id: 3,
	      name: "TEAMS_LIST",
	      action: MatchesFactory.MATCH_PRINTS.TEAMS_LIST
	    }, {
	      id: 4,
	      name: "TARGETS_LIST",
	      action: MatchesFactory.MATCH_PRINTS.TARGETS_LIST
	    }, {
	      id: 5,
	      name: "QUALIFICATION",
	      action: MatchesFactory.MATCH_PRINTS.QUALIFICATION
	    }, {
	      id: 6,
	      name: "MEDALS",
	      action: MatchesFactory.MATCH_PRINTS.MEDALS
	    }, {
	      id: 7,
	      name: "QR",
	      action: MatchesFactory.MATCH_PRINTS.QR
	    }, {
	      id: 8,
	      name: "ELIMINATION_ROUNDS"
	    }, {
	      id: 9,
	      name: "TARGETS_BOARDS",
	      action: MatchesFactory.MATCH_PRINTS.TARGETS_BOARDS
	    },
	    // {
	    // 	id: 10,
	    // 	name: 'EXCEL',
	    // 	action: MatchesFactory.MATCH_PRINTS.EXCEL,
	    // 	premium: true
	    // },
	    // {
	    // 	id: 11,
	    // 	name: 'IMPORT',
	    // 	action: MatchesFactory.MATCH_PRINTS.EXCEL_IMPORT,
	    // 	premium: true
	    // },
	    {
	      id: 12,
	      name: "TEAM_ENTRIES_LIST",
	      action: MatchesFactory.MATCH_PRINTS.TEAM_ENTRIES_LIST
	    }, {
	      id: 13,
	      name: "ATHLETES_SCORECARDS",
	      action: MatchesFactory.MATCH_PRINTS.ATHLETES_SCORECARDS
	    }, {
	      id: 14,
	      name: "ATHLETES_MATCH_CARDS",
	      action: MatchesFactory.MATCH_PRINTS.ATHLETES_MATCH_CARDS
	    }, {
	      id: 15,
	      name: "CERTIFICATES",
	      action: MatchesFactory.MATCH_PRINTS.CERTIFICATES
	    }, {
	      id: 16,
	      name: "ATHLETE_MATCH_ENTRY_CARDS",
	      action: MatchesFactory.MATCH_PRINTS.ATHLETE_MATCH_ENTRY_CARDS
	    }];
	    if (vm.rootScope.user.isUserTypeTeam()) {
	      vm.options = vm.options.filter(function (option) {
	        return option.id === 16;
	      });
	    } else if (!$rootScope.user.canDo(Permissions.MATCH_PRINTS)) {
	      vm.options = [];
	    }
	    vm.activeOption = 0;
	    MatchesFactory.getOne(vm.rootScope.currentMatchId, {
	      include: "matchLeagues"
	    }).then(function (response) {
	      var includedMixedLeauges = [];
	      vm.matchLeagues = response.data.matchLeagues;
	      (0, _entries2.default)(vm.matchLeagues).forEach(function (entry) {
	        var value = entry[1];
	        if (value.olympic_mixed > 0) {
	          if (!includedMixedLeauges.includes(value.league_id)) {
	            vm.mixedLeagues.push(value);
	            includedMixedLeauges.push(value.league.league_id);
	            includedMixedLeauges.push(value.league.mixed_league_id);
	          }
	        }
	      });
	    });
	  };
	
	  vm.selectOption = function (option) {
	    if (option.action === MatchesFactory.MATCH_PRINTS.EXCEL_IMPORT) {
	      MatchesFactory.addShotsFromExcel(vm.rootScope.currentMatchId).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	      });
	    } else if (option.action) {
	      vm.getPrintPDF(option.action);
	    } else {
	      vm.activeOption = option.id;
	    }
	  };
	
	  vm.selectedPrint = null;
	  vm.getPrintPDF = function (print) {
	    if (print) {
	      vm.selectedPrint = print;
	    }
	    var tabWindowId = window.open("about:blank", "_blank");
	    MatchesFactory.prints(vm.rootScope.currentMatchId, vm.selectedPrint).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	
	  vm.getEliminationsPrintPDF = function (leagueId, eliminationType) {
	    var tabWindowId = window.open("about:blank", "_blank");
	    MatchesFactory.printsElimination(vm.rootScope.currentMatchId, leagueId, eliminationType).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	
	  vm.getEliminationsTargetBoardsPDF = function (leagueId, eliminationType, round) {
	    var tabWindowId = window.open("about:blank", "_blank");
	    MatchesFactory.printsEliminationTargetBoards(vm.rootScope.currentMatchId, leagueId, eliminationType, round.replace("1/", "")).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	};
	MatchPrintsController.$inject = ["MatchesFactory", "$rootScope", "Permissions"];
	
	exports.default = MatchPrintsController;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(632);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchPrints.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchPrints.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 632 */
626,
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchEliminations = __webpack_require__(634);
	
	var _matchEliminations2 = _interopRequireDefault(_matchEliminations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchEliminationsModule = _angular2.default.module('matchEliminations', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('match-profile.eliminations', {
			url: '/eliminations',
			component: 'matchEliminations',
			data: { pageTitle: 'ELIMINATION_ROUNDS' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.MATCH_ELIMINATION_ROUNDS)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('matchEliminations', _matchEliminations2.default).name;
	
	exports.default = matchEliminationsModule;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchEliminations = __webpack_require__(635);
	
	var _matchEliminations2 = _interopRequireDefault(_matchEliminations);
	
	var _matchEliminations3 = __webpack_require__(636);
	
	var _matchEliminations4 = _interopRequireDefault(_matchEliminations3);
	
	__webpack_require__(637);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchEliminationsComponent = {
	  bindings: {},
	  template: _matchEliminations2.default,
	  controller: _matchEliminations4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchEliminationsComponent;

/***/ }),
/* 635 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <button class=\"btn btn-fw m-l-1 m-b-1\"\n                        translate\n                        ng-repeat=\"option in vm.options\"\n                        ng-class=\"{'success' : vm.activeOption == option.id, 'white' : vm.activeOption != option.id}\"\n                        ng-click=\"vm.selectOption(option.id);\">\n                    {{option.name}}\n                </button>\n            </div>\n            <div class=\"box-divider m-a-0\"></div>\n            <div ng-if=\"vm.activeOption == 1\" class=\"box-body\">\n                <div class=\"b-b m-b-1 m-t-1 text-center\">\n                    <h3 class=\"_300 ng-binding\" translate>ELIMINATION_INDIVIDUAL_LEAGUES</h3>\n                </div>\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.individualGridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n            <div ng-if=\"vm.activeOption == 2\" class=\"box-body\">\n                <div class=\"b-b m-b-1 m-t-1 text-center\">\n                    <h3 class=\"_300 ng-binding\" translate>ELIMINATION_TEAM_LEAGUES</h3>\n                </div>\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.teamGridOptions\" ui-grid-pagination></div>\n                </div>\n                <div class=\"b-b m-b-1 m-t-1 text-center\" ng-if=\"vm.activeLeagueName\">\n                    <h3 class=\"_300 ng-binding\" ng-bind=\"vm.activeLeagueName\"></h3>\n                </div>\n                <div class=\"table-responsive m-b-lg\" ng-if=\"vm.activeLeagueName\">\n                    <div ui-grid=\"vm.teamLeagueGridOptions\" ui-grid-pagination\n                         style=\"height: auto;\"></div>\n                </div>\n            </div>\n            <div ng-if=\"vm.activeOption == 3\" class=\"box-body\">\n                <div class=\"b-b m-b-1 m-t-1 text-center\">\n                    <h3 class=\"_300 ng-binding\" translate>ELIMINATION_MIXED_TEAM_LEAGUES</h3>\n                </div>\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.mixedTeamGridOptions\" ui-grid-pagination></div>\n                </div>\n                <div class=\"b-b m-b-1 m-t-1 text-center\" ng-if=\"vm.activeLeagueName\">\n                    <h3 class=\"_300 ng-binding\" ng-bind=\"vm.activeLeagueName\"></h3>\n                </div>\n                <div class=\"table-responsive m-b-lg\" ng-if=\"vm.activeLeagueName\">\n                    <div ui-grid=\"vm.mixedTeamLeagueGridOptions\" ui-grid-pagination\n                         style=\"height: auto;\"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div id=\"changeTeamLeaguePlayersModal\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" translate>UPDATE_TEAM_LEAGUE_PLAYERS</h5>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"teamPlayersForm\">\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">PLAYER_ONE</label>\n                        <div class=\"col-sm-9\">\n                            <ui-select required ng-model=\"vm.activeLeagueTeam.playerOne\" theme=\"bootstrap\">\n                                <ui-select-match class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_PLAYER' | translate}}\">\n                                    {{$select.selected.playerName}}\n                                </ui-select-match>\n                                <ui-select-choices class=\"ui-select-choices\"\n                                        repeat=\"item in vm.activeLeagueTeam.teamPlayers[0].players | filter: $select.search\">\n                                    <div ng-bind-html=\"item.playerName | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">PLAYER_TWO</label>\n                        <div class=\"col-sm-9\">\n                            <ui-select required ng-model=\"vm.activeLeagueTeam.playerTwo\" theme=\"bootstrap\">\n                                <ui-select-match class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_PLAYER' | translate}}\">\n                                    {{$select.selected.playerName}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.activeLeagueTeam.teamPlayers[vm.mixedLeague].players | filter: $select.search\">\n                                    <div ng-bind-html=\"item.playerName | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\" ng-if=\"vm.activeLeagueTeam.playerThree\">\n                        <label translate class=\"col-sm-3 form-control-label\">PLAYER_THREE</label>\n                        <div class=\"col-sm-9\">\n                            <ui-select required ng-model=\"vm.activeLeagueTeam.playerThree\" theme=\"bootstrap\">\n                                <ui-select-match class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_PLAYER' | translate}}\">\n                                    {{$select.selected.playerName}}\n                                </ui-select-match>\n                                <ui-select-choices class=\"ui-select-choices\"\n                                        repeat=\"item in vm.activeLeagueTeam.teamPlayers[0].players | filter: $select.search\">\n                                    <div ng-bind-html=\"item.playerName | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        ng-click=\"vm.clearSelections()\"\n                        data-dismiss=\"modal\">CANCEL</button>\n                <button type=\"button\"\n                        ng-if=\"vm.mixedLeague === 0\"\n                        ng-click=\"vm.updateTeamLeaguePlayers();\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        data-dismiss=\"modal\">SUBMIT</button>\n                <button type=\"button\"\n                        ng-if=\"vm.mixedLeague === 1\"\n                        ng-click=\"vm.updateMixedTeamLeaguePlayers();\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        data-dismiss=\"modal\">SUBMIT</button>\n            </div>\n        </div><!-- /.modal-content -->\n    </div>\n</div>\n\n<div id=\"produceTargetsModal\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" translate>PRODUCE_TARGETS</h5>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"teamPlayersForm\">\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-4 form-control-label\">ROUND</label>\n                        <div class=\"col-sm-8\">\n                            <ui-select ng-model=\"vm.activeTargetEliminationRound\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"Select round...\">\n                                    {{$select.selected}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.roundOptions | filter: $select.search\">\n                                    <div ng-bind-html=\"item | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-4 form-control-label\">PLAYERS_PER_TARGET</label>\n                        <div class=\"col-sm-8\">\n                            <ui-select ng-model=\"vm.perTarget\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"Select players per target...\">\n                                    {{$select.selected}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.perTargetOptions | filter: $select.search\">\n                                    <div ng-bind-html=\"item | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate\n                               class=\"col-sm-4 form-control-label\">STARTING_FROM_TARGET</label>\n                        <div class=\"col-sm-8\">\n                            <div class=\"row\">\n                                <div class=\"col-md-12\">\n                                    <input type=\"text\"\n                                           required\n                                           ng-model=\"vm.startingFromTarget\"\n                                           class=\"form-control\"\n                                           placeholder=\"{{'TARGET' | translate}}\">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        ng-click=\"vm.clearSelections()\"\n                        data-dismiss=\"modal\">CANCEL</button>\n                <button type=\"button\"\n                        ng-click=\"vm.produceTargets();\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        data-dismiss=\"modal\">SUBMIT</button>\n            </div>\n        </div><!-- /.modal-content -->\n    </div>\n</div>"

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchEliminationsController = function MatchEliminationsController(MatchesFactory, LeaguesFactory, $rootScope, $filter, $state, ngDialog) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, MatchEliminationsController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  /* Load Matches dat */
	  vm.$onInit = function () {
	    $state.current.data.hideSidebar = true;
	    vm.eliminationTypes = MatchesFactory.MATCH_ELIMINATION_TYPES;
	    vm.rootScope = $rootScope;
	    vm.options = [{ id: 1, name: "ELIMINATION_INDIVIDUAL" }, { id: 2, name: "ELIMINATION_TEAM" }, { id: 3, name: "ELIMINATION_MIXED_TEAM" }];
	    vm.matchLeagues = [];
	    vm.createdLeagues = {
	      individual: [],
	      team: [],
	      mixed: []
	    };
	    vm.activeOption = 0;
	    vm.perTargetOptions = [1, 2, 3, 4];
	    vm.roundOptions = [64, 32, 16, 8, 4, 2, 1];
	    vm.startingFromTarget = 1;
	    vm.perTarget = 2;
	    vm.activeTargetEliminationType = 1;
	    vm.activeTargetEliminationLeague = 1;
	    vm.activeTargetEliminationRound = 1;
	    reloadMatchData();
	  };
	
	  vm.selectOption = function (option) {
	    vm.addLeague = null;
	    vm.participants = null;
	    vm.activeOption = option;
	    vm.activeLeagueTeam = null;
	    vm.activeLeagueName = null;
	  };
	  vm.createElimination = function (leagueId, eliminationType) {
	    var entries = void 0;
	    var matchLeague = vm.matchLeagues.filter(function (obj) {
	      return obj.league_id === leagueId;
	    });
	    if (eliminationType === MatchesFactory.MATCH_ELIMINATION_TYPES.INDIVIDUAL) {
	      entries = matchLeague[0].entries;
	    } else if (eliminationType === MatchesFactory.MATCH_ELIMINATION_TYPES.TEAM) {
	      entries = matchLeague[0].teamEliminationEntries;
	    } else if (eliminationType === MatchesFactory.MATCH_ELIMINATION_TYPES.MIXED_TEAM) {
	      entries = matchLeague[0].mixedTeamEliminationEntries;
	    }
	    var participants = getParticipantsFromEntries(entries);
	    if (!entries || !participants) {
	      return;
	    }
	    MatchesFactory.createElimination(vm.rootScope.currentMatchId, leagueId, participants, eliminationType).then(function (response) {
	      ngDialog.open({ template: "successTemplate" });
	      reloadMatchData();
	    });
	  };
	  vm.deleteElimination = function (leagueId, eliminationType) {
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate("CONFIRM_DELETE_ELIMINATION_MATCH")
	      }
	    }).then(function () {
	      MatchesFactory.deleteElimination(vm.rootScope.currentMatchId, leagueId, eliminationType).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        reloadMatchData();
	      });
	    });
	  };
	  vm.nextRoundElimination = function (leagueId, eliminationType) {
	    MatchesFactory.nextRoundElimination(vm.rootScope.currentMatchId, leagueId, eliminationType).then(function (response) {
	      ngDialog.open({ template: "successTemplate" });
	      reloadMatchData();
	    });
	  };
	  vm.printPDF = function (leagueId, eliminationType) {
	    var tabWindowId = window.open("about:blank", "_blank");
	    MatchesFactory.printsElimination(vm.rootScope.currentMatchId, leagueId, eliminationType).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	  vm.printBoards = function (leagueId, eliminationType, round) {
	    var tabWindowId = window.open("about:blank", "_blank");
	    MatchesFactory.printsEliminationTargetBoards(vm.rootScope.currentMatchId, leagueId, eliminationType, round.replace("1/", "")).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	  vm.getDetails = function (leagueId, eliminationType, appendLeagueName) {
	    vm.teamLeagueGridOptions.data = [];
	    MatchesFactory.details(vm.rootScope.currentMatchId, leagueId, eliminationType).then(function (response) {
	      if (appendLeagueName) {
	        vm.activeLeagueName = response.data[0].leagueName + " - " + appendLeagueName;
	      } else {
	        vm.activeLeagueName = response.data[0].leagueName;
	      }
	      if (eliminationType === MatchesFactory.MATCH_ELIMINATION_TYPES.TEAM) {
	        vm.teamLeagueGridOptions.data = response.data;
	        vm.mixedLeague = 0;
	      } else {
	        vm.mixedTeamLeagueGridOptions.data = response.data;
	        vm.mixedLeague = 1;
	      }
	    });
	  };
	  vm.updateTeamLeaguePlayers = function () {
	    var leagueId = vm.activeLeagueTeam.league_id;
	    var teamId = vm.activeLeagueTeam.team_id;
	    var eliminationType = MatchesFactory.MATCH_ELIMINATION_TYPES.TEAM;
	    var players = [];
	    players.push(vm.activeLeagueTeam.playerOne.player_id);
	    players.push(vm.activeLeagueTeam.playerTwo.player_id);
	    players.push(vm.activeLeagueTeam.playerThree.player_id);
	    MatchesFactory.updateElimination(vm.rootScope.currentMatchId, leagueId, teamId, eliminationType, players).then(function (response) {
	      ngDialog.open({ template: "successTemplate" });
	      reloadTeamLeagueData(leagueId, eliminationType);
	    });
	  };
	  vm.updateMixedTeamLeaguePlayers = function () {
	    var leagueId = vm.activeLeagueTeam.league_1_id;
	    var teamId = vm.activeLeagueTeam.team_id;
	    var eliminationType = MatchesFactory.MATCH_ELIMINATION_TYPES.MIXED_TEAM;
	    var players = [];
	    players.push(vm.activeLeagueTeam.playerOne.player_id);
	    players.push(vm.activeLeagueTeam.playerTwo.player_id);
	    MatchesFactory.updateElimination(vm.rootScope.currentMatchId, leagueId, teamId, eliminationType, players).then(function (response) {
	      ngDialog.open({ template: "successTemplate" });
	      reloadMixedTeamLeagueData(leagueId, eliminationType);
	    });
	  };
	  vm.produceTargets = function () {
	    MatchesFactory.eliminationProduceTargets(vm.rootScope.currentMatchId, vm.activeTargetEliminationLeague.league_id, vm.activeTargetEliminationType, vm.activeTargetEliminationRound, vm.perTarget, vm.startingFromTarget).then(function (response) {
	      ngDialog.open({ template: "successTemplate" });
	      reloadMatchData();
	    });
	  };
	
	  vm.setActiveEliminationTargetsProduce = function (matchLeague, type) {
	    vm.activeTargetEliminationType = type;
	    vm.activeTargetEliminationLeague = matchLeague;
	  };
	
	  /* INDIVIDUAL */
	  vm.individualGridOptions = {
	    enableSorting: false,
	    enablePaginationControls: false,
	    enableColumnMenus: false,
	    enableFiltering: false,
	    columnDefs: [{
	      field: "leagueName",
	      enableFiltering: false,
	      name: $translate("LEAGUE_NAME")
	    }, {
	      field: "entries",
	      enableFiltering: false,
	      name: $translate("ENTRIES"),
	      width: "90"
	    }, {
	      field: "startingIndividualRound",
	      enableFiltering: false,
	      name: $translate("STARTING_ROUND"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'ng-if="row.entity.olympic_players > 0"' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + "<button " + 'class="btn btn-sm accent">{{row.entity.startingIndividualRound}}</button>' + "</div>",
	      width: "80"
	    }, {
	      field: "currentIndividualRound",
	      enableFiltering: false,
	      name: $translate("CURRENT_ROUND"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'ng-if="row.entity.olympic_players > 0"' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + "<button " + 'class="btn btn-sm indigo">{{row.entity.currentIndividualRound}}</button>' + "</div>",
	      width: "120"
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-success" translate ' + 'ng-if="!row.entity.olympic_players"' + 'ng-click="grid.appScope.vm.createElimination(row.entity.league_id,1)">CREATE</button> ' + '<button class="btn btn-sm btn-info" translate ' + 'ng-if="row.entity.olympic_players > 0"' + 'ng-click="grid.appScope.vm.nextRoundElimination(row.entity.league_id,1)">NEXT_ROUND</button> ' + '<button class="btn btn-sm btn-warning" translate ' + 'ng-if="row.entity.olympic_players > 0"' + 'ng-click="grid.appScope.vm.printPDF(row.entity.league_id,1)">PRINT_PDF</button> ' + '<button class="btn btn-sm btn-danger" translate ' + 'ng-if="row.entity.olympic_players > 0"' + 'ng-click="grid.appScope.vm.deleteElimination(row.entity.league_id,1)">DELETE</button> ' + '<button class="btn btn-sm accent" translate ' + 'ng-if="row.entity.olympic_players > 0"' + 'ng-click="grid.appScope.vm.printBoards(row.entity.league_id,1, row.entity.currentIndividualRound)">BOARDS</button> ' + "<button " + 'ng-if="row.entity.olympic_players > 0"' + 'class="btn btn-sm info" ' + 'data-toggle="modal" ' + "translate " + 'ng-click="grid.appScope.vm.setActiveEliminationTargetsProduce(row.entity, 1)" ' + 'data-target="#produceTargetsModal">TARGETS</button> ' + "</div>" + "</div>",
	      width: "410"
	    }]
	  };
	
	  /* TEAM */
	  vm.teamGridOptions = {
	    enableSorting: false,
	    enablePaginationControls: false,
	    enableColumnMenus: false,
	    enableFiltering: false,
	    columnDefs: [{
	      field: "leagueName",
	      enableFiltering: false,
	      name: $translate("LEAGUE_NAME")
	    }, {
	      field: "teamEliminationEntries",
	      enableFiltering: false,
	      name: $translate("ENTRIES"),
	      width: "90"
	    }, {
	      field: "startingTeamRound",
	      enableFiltering: false,
	      name: $translate("STARTING_ROUND"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'ng-if="row.entity.olympic_teams > 0"' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + "<button " + 'class="btn btn-sm accent">{{row.entity.startingTeamRound}}</button>' + "</div>",
	      width: "80"
	    }, {
	      field: "currentTeamRound",
	      enableFiltering: false,
	      name: $translate("CURRENT_ROUND"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'ng-if="row.entity.olympic_teams > 0"' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + "<button " + 'class="btn btn-sm indigo">{{row.entity.currentTeamRound}}</button>' + "</div>",
	      width: "120"
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-success" translate ' + 'ng-if="!row.entity.olympic_teams"' + 'ng-click="grid.appScope.vm.createElimination(row.entity.league_id,2)">CREATE</button> ' + '<button class="btn btn-sm btn-info" translate ' + 'ng-if="row.entity.olympic_teams > 0"' + 'ng-click="grid.appScope.vm.nextRoundElimination(row.entity.league_id,2)">NEXT_ROUND</button> ' + '<button class="btn btn-sm btn-warning" translate ' + 'ng-if="row.entity.olympic_teams > 0"' + 'ng-click="grid.appScope.vm.printPDF(row.entity.league_id,2)">PRINT_PDF</button> ' + '<button class="btn btn-sm indigo" translate ' + 'ng-if="row.entity.olympic_teams > 0 && grid.appScope.vm.rootScope.user.isPremium()"' + 'ng-click="grid.appScope.vm.getDetails(row.entity.league_id,2)">PLAYERS</button> ' + '<button class="btn btn-sm btn-danger" translate ' + 'ng-if="row.entity.olympic_teams > 0"' + 'ng-click="grid.appScope.vm.deleteElimination(row.entity.league_id,2)">DELETE</button> ' + '<button class="btn btn-sm accent" translate ' + 'ng-if="row.entity.olympic_teams > 0"' + 'ng-click="grid.appScope.vm.printBoards(row.entity.league_id,2, row.entity.currentTeamRound)">BOARDS</button> ' + "</div>" + "</div>",
	      width: "440"
	    }]
	  };
	  vm.teamLeagueGridOptions = {
	    enableSorting: false,
	    enablePaginationControls: false,
	    enableColumnMenus: false,
	    enableFiltering: false,
	    columnDefs: [{
	      field: "teamName",
	      enableFiltering: false,
	      name: $translate("TEAM_NAME"),
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents">{{row.entity.team.teamName}}</div>'
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + "<button " + 'class="btn btn-sm info" ' + 'data-toggle="modal" ' + "translate " + 'ng-click="grid.appScope.vm.activeLeagueTeam = row.entity" ' + 'data-target="#changeTeamLeaguePlayersModal">EDIT</button></div>',
	      width: "340"
	    }]
	  };
	
	  /* MIXED TEAM */
	  vm.mixedTeamGridOptions = {
	    enableSorting: false,
	    enablePaginationControls: false,
	    enableColumnMenus: false,
	    enableFiltering: false,
	    columnDefs: [{
	      field: "leagueName",
	      enableFiltering: false,
	      name: $translate("LEAGUE_NAME"),
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents p-t-5">{{row.entity.leagueName}} - {{row.entity.mixedLeagueNameAppendName}}</div>'
	    }, {
	      field: "mixedTeamEliminationEntries",
	      enableFiltering: false,
	      name: "Entries",
	      width: "90"
	    }, {
	      field: "startingMixedTeamRound",
	      enableFiltering: false,
	      name: $translate("STARTING_ROUND"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'ng-if="row.entity.olympic_mixed > 0"' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + "<button " + 'class="btn btn-sm accent">{{row.entity.startingMixedTeamRound}}</button>' + "</div>",
	      width: "80"
	    }, {
	      field: "currentMixedTeamRound",
	      enableFiltering: false,
	      name: $translate("CURRENT_ROUND"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'ng-if="row.entity.olympic_mixed > 0"' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + "<button " + 'class="btn btn-sm indigo">{{row.entity.currentMixedTeamRound}}</button>' + "</div>",
	      width: "120"
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-success" translate ' + 'ng-if="!row.entity.olympic_mixed"' + 'ng-click="grid.appScope.vm.createElimination(row.entity.league_id,3)">CREATE</button> ' + '<button class="btn btn-sm btn-info" translate ' + 'ng-if="row.entity.olympic_mixed > 0"' + 'ng-click="grid.appScope.vm.nextRoundElimination(row.entity.league_id,3)">NEXT_ROUND</button> ' + '<button class="btn btn-sm btn-warning" translate ' + 'ng-if="row.entity.olympic_mixed > 0"' + 'ng-click="grid.appScope.vm.printPDF(row.entity.league_id,3)">PRINT_PDF</button> ' + '<button class="btn btn-sm indigo" translate ' + 'ng-if="row.entity.olympic_mixed > 0 && grid.appScope.vm.rootScope.user.isPremium()"' + 'ng-click="grid.appScope.vm.getDetails(row.entity.league_id,3,row.entity.mixedLeagueNameAppendName)">PLAYERS</button> ' + '<button class="btn btn-sm btn-danger" translate ' + 'ng-if="row.entity.olympic_mixed > 0"' + 'ng-click="grid.appScope.vm.deleteElimination(row.entity.league_id,3)">DELETE</button> ' + '<button class="btn btn-sm accent" translate ' + 'ng-if="row.entity.olympic_mixed > 0"' + 'ng-click="grid.appScope.vm.printBoards(row.entity.league_id,3, row.entity.currentMixedTeamRound)">BOARDS</button> ' + "</div>" + "</div>",
	      width: "440"
	    }]
	  };
	  vm.mixedTeamLeagueGridOptions = {
	    enableSorting: false,
	    enablePaginationControls: false,
	    enableColumnMenus: false,
	    enableFiltering: false,
	    columnDefs: [{
	      field: "teamName",
	      enableFiltering: false,
	      name: $translate("TEAM_NAME"),
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents">{{row.entity.team.teamName}}</div>'
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + "<button " + 'class="btn btn-sm info" ' + 'data-toggle="modal" ' + "translate " + 'ng-click="grid.appScope.vm.activeLeagueTeam = row.entity" ' + 'data-target="#changeTeamLeaguePlayersModal">EDIT</button></div>',
	      width: "340"
	    }]
	  };
	
	  function reloadMatchData() {
	    vm.matchLeagues = [];
	    vm.createdLeagues = {
	      individual: [],
	      team: [],
	      mixed: []
	    };
	    MatchesFactory.getOne(vm.rootScope.currentMatchId, {
	      include: "matchLeagues"
	    }).then(function (response) {
	      var includedMixedLeagues = [];
	      vm.matchLeagues = response.data.matchLeagues;
	      vm.matchOlympicTeamDetails = response.data.matchOlympicTeamDetails;
	      (0, _entries2.default)(vm.matchLeagues).forEach(function (entry) {
	        var value = entry[1];
	        /* INDIVIDUAL */
	        if (value.olympic_players || value.entries > 3) {
	          vm.createdLeagues.individual.push(value);
	        }
	        /* TEAM */
	        if (value.olympic_teams || value.teamEliminationEntries > 3) {
	          vm.createdLeagues.team.push(value);
	        }
	        /* MIXED TEAM */
	        if (value.olympic_mixed || value.mixedTeamEliminationEntries > 3) {
	          if (!includedMixedLeagues.includes(value.league_id)) {
	            vm.createdLeagues.mixed.push(value);
	            includedMixedLeagues.push(value.league_id);
	            includedMixedLeagues.push(value.league.mixed_league_id);
	          }
	        }
	        vm.individualGridOptions.data = vm.createdLeagues.individual;
	        vm.teamGridOptions.data = vm.createdLeagues.team;
	        vm.mixedTeamGridOptions.data = vm.createdLeagues.mixed;
	      });
	    });
	  }
	
	  function reloadTeamLeagueData(leagueId, eliminationType) {
	    MatchesFactory.details(vm.rootScope.currentMatchId, leagueId, eliminationType).then(function (response) {
	      vm.teamLeagueGridOptions.data = response.data;
	    });
	  }
	
	  function reloadMixedTeamLeagueData(leagueId, eliminationType) {
	    MatchesFactory.details(vm.rootScope.currentMatchId, leagueId, eliminationType).then(function (response) {
	      vm.mixedTeamLeagueGridOptions.data = response.data;
	    });
	  }
	
	  function getParticipantsFromEntries(entries) {
	    var matchType = vm.rootScope.currentMatch.match_type;
	    if (entries < 4) {
	      return false;
	    } else if (entries === 4) {
	      return 4;
	    } else if (entries <= 8) {
	      return 8;
	    } else if (entries <= 16) {
	      return 16;
	    } else if (entries <= 32 || matchType === MatchesFactory.MATCH_TYPES.INDOOR) {
	      return 32;
	    } else if (entries <= 64) {
	      return 32;
	    }
	  }
	};
	MatchEliminationsController.$inject = ["MatchesFactory", "LeaguesFactory", "$rootScope", "$filter", "$state", "ngDialog"];
	
	exports.default = MatchEliminationsController;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(638);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchEliminations.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchEliminations.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 638 */
626,
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchFinalize = __webpack_require__(640);
	
	var _matchFinalize2 = _interopRequireDefault(_matchFinalize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchFinalizeModule = _angular2.default.module('matchFinalize', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('match-profile.finalize', {
			url: '/finalize',
			component: 'matchFinalize',
			data: { pageTitle: 'FINALIZE_MATCH' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.UPDATE_MATCH)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('matchFinalize', _matchFinalize2.default).name;
	
	exports.default = matchFinalizeModule;

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchFinalize = __webpack_require__(641);
	
	var _matchFinalize2 = _interopRequireDefault(_matchFinalize);
	
	var _matchFinalize3 = __webpack_require__(642);
	
	var _matchFinalize4 = _interopRequireDefault(_matchFinalize3);
	
	__webpack_require__(643);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchFinalizeComponent = {
	  bindings: {},
	  template: _matchFinalize2.default,
	  controller: _matchFinalize4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchFinalizeComponent;

/***/ }),
/* 641 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <button class=\"btn btn-fw m-l-1 m-b-1\"\n                        translate\n                        ng-repeat=\"option in vm.options\"\n                        ng-class=\"{'success' : vm.activeOption == option.id, 'white' : vm.activeOption != option.id}\"\n                        ng-click=\"vm.finalize(option.actionId);\">\n                    {{option.name}}\n                </button>\n            </div>\n            <div class=\"box-divider m-a-0\"></div>\n            <div ng-if=\"vm.updateMatchGridOptions.data.length > 0\" class=\"box-body\">\n                <div class=\"b-b m-b-1 m-t-1 text-center\">\n                    <h3 class=\"_300 ng-binding\" translate>TARGETS_WITH_EMPTY_SHOTS</h3>\n                </div>\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.updateMatchGridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchFinalizeController = function MatchFinalizeController(MatchesFactory, $rootScope, $filter, ngDialog) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, MatchFinalizeController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		/* Load Matches dat */
		vm.$onInit = function () {
			vm.rootScope = $rootScope;
			vm.options = [{ id: 1, name: 'FINALIZE_ROUND_ONE', actionId: MatchesFactory.MATCH_STATES.MATCH_STATE_ROUND_ONE }, { id: 2, name: 'FINALIZE_ROUND_TWO', actionId: MatchesFactory.MATCH_STATES.MATCH_STATE_ROUND_TWO }, { id: 3, name: 'FINALIZE_MATCH', actionId: MatchesFactory.MATCH_STATES.MATCH_STATE_END }];
		};
	
		vm.updateMatchGridOptions = {
			enableSorting: false,
			enablePaginationControls: false,
			enableColumnMenus: false,
			enableFiltering: false,
			columnDefs: [{
				field: 'targetName',
				enableFiltering: false,
				name: $translate('TARGET_NAME')
			}, {
				field: 'playerName',
				enableFiltering: false,
				name: $translate('PLAYER_NAME')
			}, {
				field: 'teamName',
				enableFiltering: false,
				name: $translate('TEAM_NAME')
			}]
		};
	
		vm.finalize = function (state) {
			MatchesFactory.finalize(vm.rootScope.currentMatchId, state).then(function (response) {
				ngDialog.open({ template: 'successTemplate' });
				vm.updateMatchGridOptions.data = response.data;
			});
		};
	};
	MatchFinalizeController.$inject = ["MatchesFactory", "$rootScope", "$filter", "ngDialog"];
	
	exports.default = MatchFinalizeController;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(644);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchFinalize.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchFinalize.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 644 */
626,
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchRegistrations = __webpack_require__(646);
	
	var _matchRegistrations2 = _interopRequireDefault(_matchRegistrations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchRegistrationsModule = _angular2.default.module('matchRegistrations', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('match-profile.registrations', {
			url: '/registrations',
			component: 'matchRegistrations',
			data: { pageTitle: 'REGISTRATIONS' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.ADD_PLAYER_TO_MATCH)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('matchRegistrations', _matchRegistrations2.default).name;
	
	exports.default = matchRegistrationsModule;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchRegistrations = __webpack_require__(647);
	
	var _matchRegistrations2 = _interopRequireDefault(_matchRegistrations);
	
	var _matchRegistrations3 = __webpack_require__(648);
	
	var _matchRegistrations4 = _interopRequireDefault(_matchRegistrations3);
	
	__webpack_require__(649);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchRegistrationsComponent = {
	  bindings: {},
	  template: _matchRegistrations2.default,
	  controller: _matchRegistrations4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchRegistrationsComponent;

/***/ }),
/* 647 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-sm-12\">\n    <div class=\"box\">\n      <div class=\"box-body\">\n        <button\n          class=\"btn btn-fw m-l-1 m-b-1\"\n          translate\n          ng-repeat=\"option in vm.options\"\n          ng-if=\"!option.permission || vm.rootScope.user.canDo(option.permission)\"\n          ng-class=\"{'success' : vm.activeOption == option.id, 'white' : vm.activeOption != option.id}\"\n          ng-click=\"vm.selectOption(option.id);\"\n        >\n          {{option.name}}\n        </button>\n      </div>\n      <div class=\"box-divider m-a-0\"></div>\n      <div ng-if=\"vm.activeOption == 1\" class=\"box-body\">\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <h5 ng-if=\"!vm.isRegistrationOpen()\" class=\"m-b-1\" translate>\n              REGISTRATION_IS_CLOSED\n            </h5>\n            <div\n              ng-if=\"vm.isRegistrationOpen() || vm.rootScope.user.canDo(vm.rootScope.permissions.OVERRIDE_MATCH_FILTERS)\"\n            >\n              <form\n                ng-if=\"vm.rootScope.user.canDo(vm.rootScope.permissions.VIEW_ALL_TEAMS)\n                            && vm.rootScope.user.canDo(vm.rootScope.permissions.VIEW_ALL_PLAYERS)\"\n              >\n                <div class=\"form-group row\">\n                  <label translate class=\"col-sm-2 form-control-label\"\n                    >TEAM</label\n                  >\n                  <div class=\"col-sm-10\">\n                    <ui-select\n                      on-select=\"vm.reloadPlayers()\"\n                      ng-model=\"vm.activeTeam\"\n                      theme=\"bootstrap\"\n                    >\n                      <ui-select-match\n                        class=\"ui-select-match\"\n                        placeholder=\"{{'SELECT_TEAM' | translate}}\"\n                      >\n                        {{$select.selected.full_name}}\n                      </ui-select-match>\n                      <ui-select-choices\n                        class=\"ui-select-choices\"\n                        repeat=\"item in vm.teams | filter: $select.search\"\n                      >\n                        <div\n                          ng-bind-html=\"item.full_name | highlight: $select.search\"\n                        ></div>\n                      </ui-select-choices>\n                    </ui-select>\n                  </div>\n                </div>\n              </form>\n              <form ng-if=\"vm.activeTeam\">\n                <div class=\"form-group row\">\n                  <label translate class=\"col-sm-4 form-control-label\"\n                    >LOAD_FINANCIAL_OK_PLAYERS</label\n                  >\n                  <div class=\"col-sm-8\">\n                    <label class=\"ui-switch ui-switch-md info m-t-xs\">\n                      <input\n                        type=\"checkbox\"\n                        ng-change=\"vm.reloadPlayers()\"\n                        ng-model=\"vm.filters.hasPaid\"\n                      />\n                      <i></i>\n                    </label>\n                  </div>\n                </div>\n              </form>\n              <form ng-if=\"vm.activeTeam\">\n                <div class=\"form-group row\">\n                  <label\n                    translate\n                    class=\"col-sm-4 form-control-label\"\n                    for=\"teamCaptain\"\n                    >CAPTAIN</label\n                  >\n                  <div class=\"col-sm-8\">\n                    <input\n                      type=\"text\"\n                      id=\"teamCaptain\"\n                      ng-model=\"vm.matchTeam.captain\"\n                    />\n                  </div>\n                </div>\n                <div class=\"form-group row\">\n                  <label\n                    translate\n                    class=\"col-sm-4 form-control-label\"\n                    for=\"teamCompanion\"\n                    >COMPANION</label\n                  >\n                  <div class=\"col-sm-8\">\n                    <input\n                      type=\"text\"\n                      id=\"teamCompanion\"\n                      ng-model=\"vm.matchTeam.companion\"\n                    />\n                  </div>\n                </div>\n                <div class=\"form-group row\">\n                  <label\n                    translate\n                    class=\"col-sm-4 form-control-label\"\n                    for=\"teamCoach\"\n                    >COACH</label\n                  >\n                  <div class=\"col-sm-8\">\n                    <input\n                      type=\"text\"\n                      id=\"teamCoach\"\n                      ng-model=\"vm.matchTeam.coach\"\n                    />\n                  </div>\n                </div>\n                <button\n                  class=\"btn btn-fw btn-success m-l-1 m-b-1\"\n                  translate\n                  ng-click=\"vm.saveMatchTeam();\"\n                >\n                  SAVE_MATCH_TEAM_INFO\n                </button>\n              </form>\n              <div class=\"b-b m-b-1 m-t-1 text-center\">\n                <h3\n                  class=\"_300 ng-binding\"\n                  translate\n                  ng-bind=\"vm.activeTeam.full_name\"\n                ></h3>\n              </div>\n              <div class=\"table-responsive m-b-lg\" ng-if=\"vm.activeTeam\">\n                <div\n                  ui-grid=\"vm.addPlayersGridOptions\"\n                  ui-grid-pagination\n                ></div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div ng-if=\"vm.activeOption == 2\" class=\"box-body\">\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <div class=\"table-responsive m-b-lg\">\n              <div\n                ui-grid=\"vm.matchPlayersGridOptions\"\n                ui-grid-pagination\n              ></div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <div ng-if=\"vm.activeOption == 3\" class=\"box-body\">\n        <div class=\"row\">\n          <div class=\"col-sm-12\">\n            <div class=\"box-body\">\n              <button\n                type=\"button\"\n                ng-if=\"vm.activeTeam.team_id\"\n                ng-click=\"vm.printRegistrations()\"\n                class=\"btn btn-sm btn-info\"\n              >\n                <i class=\"fa fa-file-pdf-o\"></i> {{'PRINT_REGISTRATIONS_PDF' |\n                translate}}\n              </button>\n            </div>\n            <div class=\"table-responsive m-b-lg\">\n              <div\n                ui-grid=\"vm.matchPlayersInfoGridOptions\"\n                ui-grid-pagination\n              ></div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n<div id=\"playerMatchModal\" class=\"modal black-overlay\" data-backdrop=\"false\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\" translate>ADD_PLAYER_TO_MATCH</h5>\n      </div>\n      <div class=\"b-b m-b-1 m-t-1 text-center\">\n        <h3\n          class=\"_300 ng-binding\"\n          translate\n          ng-bind=\"vm.currentPlayer.playerName\"\n        ></h3>\n      </div>\n      <div class=\"modal-body text-center p-lg\">\n        <form\n          name=\"addPlayerForm\"\n          class=\"p-x-xs\"\n          ng-if=\"vm.currentPlayer.matchEligibility.isEligible\n                      || vm.hasPermission(vm.rootScope.permissions.OVERRIDE_MATCH_FILTERS)\"\n        >\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-2 form-control-label\">LEAGUE</label>\n            <div class=\"col-sm-9\">\n              <ui-select\n                required\n                ng-model=\"vm.selectedLeague\"\n                theme=\"bootstrap\"\n              >\n                <ui-select-match\n                  class=\"ui-select-match\"\n                  placeholder=\"{{'SELECT_LEAGUE' | translate}}\"\n                >\n                  {{$select.selected.league_name}}\n                </ui-select-match>\n                <ui-select-choices\n                  class=\"ui-select-choices\"\n                  repeat=\"item in vm.playerLeagues | filter: $select.search\"\n                >\n                  <div\n                    ng-bind-html=\"item.league_name | highlight: $select.search\"\n                  ></div>\n                </ui-select-choices>\n              </ui-select>\n            </div>\n          </div>\n          <!-- <div ng-if=\"(vm.selectedLeague.type === 'recurve' || vm.selectedLeague.type === 'compound')\n                    && vm.rootScope.currentMatch.match_type === 'indoor'\"\n                         class=\"form-group row\">\n                        <label translate class=\"col-sm-2 form-control-label\">A_TARGET</label>\n                        <div class=\"col-sm-2 p-t-05 p-b-05\">\n                            <label class=\"md-switch\">\n                                <input type=\"checkbox\" ng-model=\"vm.a_target\">\n                                <i class=\"blue\"></i>\n                            </label>\n                        </div>\n                    </div> -->\n          <div class=\"form-group row\">\n            <label class=\"col-sm-2 form-control-label\" translate\n              >paraArchery</label\n            >\n            <div class=\"col-sm-2 p-t-05 p-b-05\">\n              <label class=\"md-switch\">\n                <input type=\"checkbox\" ng-model=\"vm.amea\" />\n                <i class=\"blue\"></i>\n              </label>\n            </div>\n          </div>\n        </form>\n        <div ng-if=\"!vm.currentPlayer.matchEligibility.isEligible\">\n          <div>\n            <h5 translate>MATCH_ELIGIBILITY_EXPLAIN_TEXT</h5>\n          </div>\n          <ul class=\"list m-a-0 no-radius\">\n            <li\n              class=\"list-item\"\n              ng-repeat=\"reason in vm.currentPlayer.matchEligibility.reasons \"\n            >\n              <div class=\"list-body\">\n                <i class=\"fa fa-remove text-danger m-r-xs\"></i> {{reason.name}}\n              </div>\n            </li>\n          </ul>\n        </div>\n      </div>\n      <div class=\"modal-footer\">\n        <button\n          type=\"button\"\n          translate\n          class=\"btn dark-white p-x-md\"\n          ng-click=\"vm.clearSelections()\"\n          data-dismiss=\"modal\"\n        >\n          CANCEL\n        </button>\n        <button\n          type=\"button\"\n          ng-click=\"vm.addPlayerToMatch();\"\n          translate\n          class=\"btn danger p-x-md\"\n          ng-class=\"{'disabled' : !vm.isAddPlayerValid()}\"\n          ng-disable=\"!vm.isAddPlayerValid()\"\n          data-dismiss=\"modal\"\n        >\n          SUBMIT\n        </button>\n      </div>\n    </div>\n    <!-- /.modal-content -->\n  </div>\n</div>\n"

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchRegistrationsController = function MatchRegistrationsController(MatchesFactory, PlayersFactory, TeamsFactory, $rootScope, $filter, $state, ngDialog, Permissions) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, MatchRegistrationsController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		vm.rootScope = $rootScope;
	
		vm.$onInit = function () {
			vm.players = [];
			vm.matchPlayers = [];
			vm.matchPlayersIds = [];
			vm.options = [{ id: 1, name: 'ADD_REMOVE_PLAYERS' }, { id: 3, name: 'CURRENT_PLAYERS' }];
			vm.filters = {};
			vm.filters.hasPaid = false;
			vm.teams = [];
			vm.activeTeam = null;
			if (vm.rootScope.user.isUserTypeTeam()) {
				vm.activeTeam = vm.rootScope.currentUser;
				vm.reloadPlayers();
			} else if (vm.rootScope.user.isPremium() || vm.rootScope.user.canDo(Permissions.VIEW_ALL_TEAMS)) {
				if (vm.rootScope.user.isPremium()) {
					vm.options.push({ id: 2, name: 'REMOVE_PLAYERS' });
				}
				TeamsFactory.getAll().then(function (response) {
					vm.teams = response.data;
				});
			}
			vm.filters = {
				sex: null,
				paymentsFulfilled: null
			};
			vm.sexes = [{ value: 'M', name: $translate('MALE') }, { value: 'F', name: $translate('FEMALE') }];
			/* add - edit player match */
			vm.playerLeagues = null;
			vm.matchTeam = {};
			reloadMatchData();
		};
	
		vm.hasPermission = function (permission) {
			return vm.rootScope.user.canDo(permission);
		};
	
		vm.selectOption = function (option) {
			vm.activeOption = option;
			$state.current.data.hideSidebar = true;
		};
	
		vm.isPlayerRegistered = function (playerId) {
			return vm.matchPlayersIds.includes(playerId);
		};
	
		vm.isRegistrationOpen = function () {
			var now = new Date();
			var start = new Date(vm.rootScope.currentMatch.registration_start);
			var end = new Date(vm.rootScope.currentMatch.registration_end);
			return now > start && now < end;
		};
	
		vm.addPlayersGridOptions = {
			enableSorting: true,
			enablePaginationControls: false,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'playerName',
				enableFiltering: true,
				name: $translate('PLAYER_NAME')
			}, {
				field: 'actions',
				enableFiltering: false,
				name: $translate('ACTIONS'),
				headerCellClass: 'text-center',
				cellTemplate: '' + '<div ' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-success" translate ' + 'data-toggle="modal" ' + 'data-target="#playerMatchModal" ' + 'ng-class="{disabled : !row.entity.matchEligibility.isEligible}" ' + 'ng-click="grid.appScope.vm.openAddPlayerModel(row.entity.player_id)" ' + 'ng-if="!grid.appScope.vm.isPlayerRegistered(row.entity.player_id)">ADD</button> ' + '<button class="btn btn-sm btn-warning" translate ' + 'data-toggle="modal" ' + 'data-target="#playerMatchModal" ' + 'ng-click="grid.appScope.vm.openEditPlayerModel(row.entity.player_id)" ' + 'ng-if="grid.appScope.vm.isPlayerRegistered(row.entity.player_id)">EDIT</button> ' + '<button class="btn btn-sm btn-danger" translate ' + 'ng-click="grid.appScope.vm.removePlayer(row.entity.player_id)" ' + 'ng-if="grid.appScope.vm.isPlayerRegistered(row.entity.player_id)">REMOVE</button> ' + '</div>' + '</div>',
				width: '340'
			}],
			onRegisterApi: function onRegisterApi(gridApi) {
				vm.addPlayersGridApi = gridApi;
			}
		};
	
		vm.matchPlayersGridOptions = {
			enableSorting: true,
			enablePaginationControls: false,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'playerName',
				enableFiltering: true,
				name: $translate('PLAYER_NAME')
			}, {
				field: 'teamName',
				enableFiltering: true,
				name: $translate('TEAM_NAME')
			}, {
				field: 'leagueName',
				enableFiltering: true,
				name: $translate('LEAGUE_NAME')
			}, {
				field: 'actions',
				enableFiltering: false,
				name: $translate('ACTIONS'),
				headerCellClass: 'text-center',
				cellTemplate: '' + '<div ' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-danger" translate ' + 'ng-click="grid.appScope.vm.removePlayer(row.entity.player_id)">REMOVE</button> ' + '</div>' + '</div>',
				width: '110'
			}]
		};
	
		vm.matchPlayersInfoGridOptions = {
			enableSorting: true,
			enablePaginationControls: false,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'playerName',
				enableFiltering: true,
				name: $translate('PLAYER_NAME')
			}, {
				field: 'teamName',
				enableFiltering: true,
				name: $translate('TEAM_NAME')
			}, {
				field: 'leagueName',
				enableFiltering: true,
				name: $translate('LEAGUE_NAME')
			}]
		};
	
		vm.clearSelections = function () {
			vm.currentMatchPlayer = null;
			vm.currentPlayer = null;
			vm.selectedLeague = null;
			vm.amea = false;
			vm.a_target = false;
		};
	
		/* Add Player */
		vm.openAddPlayerModel = function (playerId) {
			vm.currentPlayer = vm.players.find(function (player) {
				return player.player_id === playerId;
			});
			vm.playerLeagues = vm.currentPlayer.matchEligibility.leagues;
			vm.selectedLeague = null;
			vm.amea = false;
			vm.a_target = false;
		};
		vm.isAddPlayerValid = function () {
			return vm.selectedLeague;
		};
		vm.addPlayerToMatch = function () {
			var leagueId = vm.selectedLeague.league_id;
			var playerId = vm.currentPlayer.player_id;
			var teamId = vm.currentPlayer.team_id;
			var data = {
				amea: vm.amea,
				a_target: vm.a_target
			};
			if (vm.currentMatchPlayer) {
				MatchesFactory.updatePlayerLeague(vm.rootScope.currentMatchId, playerId, leagueId, data).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					vm.clearSelections();
					reloadMatchData();
				});
			} else {
				MatchesFactory.addPlayer(vm.rootScope.currentMatchId, playerId, leagueId, teamId, data).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					vm.clearSelections();
					reloadMatchData();
				});
			}
		};
	
		/* Edit Player */
		vm.openEditPlayerModel = function (playerId) {
			vm.currentPlayer = vm.players.find(function (player) {
				return player.player_id === playerId;
			});
			vm.currentMatchPlayer = vm.matchPlayers.find(function (player) {
				return player.player_id === playerId;
			});
			vm.playerLeagues = vm.currentPlayer.matchEligibility.leagues;
			vm.amea = vm.currentMatchPlayer.amea === 1;
			vm.a_target = vm.currentMatchPlayer.a_target === 1;
			vm.selectedLeague = vm.playerLeagues.find(function (league) {
				return league.league_id === vm.currentMatchPlayer.league_id;
			});
		};
	
		/* Remove Player */
		vm.removePlayer = function (playerId) {
			ngDialog.openConfirm({
				template: 'confirmTemplate',
				data: {
					message: $translate('CONFIRM_REMOVE_PLAYER_FROM_MATCH')
				}
			}).then(function () {
				MatchesFactory.removePlayer(vm.rootScope.currentMatchId, playerId).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					reloadMatchData();
				});
			});
		};
	
		/* Print */
		vm.printRegistrations = function () {
			vm.doanloading = true;
			var teamId = vm.activeTeam.team_id;
			//TODO
			if (vm.rootScope.currentUser.team_id) {
				teamId = vm.rootScope.currentUser.team_id;
			}
			var tabWindowId = window.open('about:blank', '_blank');
			MatchesFactory.printsEntries(vm.rootScope.currentMatchId, teamId).then(function (response) {
				var file = new Blob([response.data], { type: 'application/pdf' });
				tabWindowId.location.href = window.URL.createObjectURL(file);
			});
		};
	
		/* Save Match Team Info */
		vm.saveMatchTeam = function () {
			var data = {
				captain: vm.matchTeam.captain,
				coach: vm.matchTeam.coach,
				companion: vm.matchTeam.companion
			};
			MatchesFactory.updateTeamInformation(vm.rootScope.currentMatchId, vm.rootScope.currentUser.team_id, data).then(function (response) {
				ngDialog.open({ template: 'successTemplate' });
			});
		};
	
		function reloadMatchData() {
			var data = { include: 'matchPlayers,matchTeams' };
			if (vm.rootScope.user.isUserTypeTeam()) {
				data.team_id = vm.rootScope.currentUser.team_id;
			}
			MatchesFactory.getOne(vm.rootScope.currentMatchId, data).then(function (response) {
				vm.matchPlayers = response.data.matchPlayers;
				vm.matchPlayersGridOptions.data = vm.matchPlayers;
				vm.matchPlayersInfoGridOptions.data = vm.matchPlayers;
				vm.matchPlayersIds = [];
				(0, _entries2.default)(vm.matchPlayers).forEach(function (entry) {
					vm.matchPlayersIds.push(entry[1].player_id);
				});
				if (vm.addPlayersGridApi) {
					vm.addPlayersGridApi.core.refresh();
				}
	
				if (response.data.matchTeams.length > 0) {
					vm.matchTeam = response.data.matchTeams[0];
				}
			});
		}
	
		vm.reloadPlayers = function () {
			var params = {};
			/* Has Paid For Year Filter */
			if (vm.filters.hasPaid) {
				params.has_paid = 1;
			}
			params.team_id = vm.activeTeam.team_id;
			params.match_id = vm.rootScope.currentMatchId;
			PlayersFactory.getAll(params).then(function (response) {
				vm.players = response.data;
				vm.addPlayersGridOptions.data = vm.players;
			});
		};
	};
	MatchRegistrationsController.$inject = ["MatchesFactory", "PlayersFactory", "TeamsFactory", "$rootScope", "$filter", "$state", "ngDialog", "Permissions"];
	
	exports.default = MatchRegistrationsController;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(650);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchRegistrations.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchRegistrations.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 650 */
626,
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchAddShots = __webpack_require__(652);
	
	var _matchAddShots2 = _interopRequireDefault(_matchAddShots);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchAddShotsModule = _angular2.default.module('matchAddShots', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('match-profile.addShots', {
			url: '/addShots',
			component: 'matchAddShots',
			data: { pageTitle: 'ADD_SHOTS' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.ADD_SCORE_TO_MATCH)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('matchAddShots', _matchAddShots2.default).name;
	
	exports.default = matchAddShotsModule;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchAddShots = __webpack_require__(653);
	
	var _matchAddShots2 = _interopRequireDefault(_matchAddShots);
	
	var _matchAddShots3 = __webpack_require__(654);
	
	var _matchAddShots4 = _interopRequireDefault(_matchAddShots3);
	
	__webpack_require__(655);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchAddShotsComponent = {
	  bindings: {},
	  template: _matchAddShots2.default,
	  controller: _matchAddShots4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchAddShotsComponent;

/***/ }),
/* 653 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-9\">\n        <div class=\"box\">\n            <form name=\"addShotsForm\" ng-if=\"vm.activeRound && vm.activeMatchPlayer\" ng-submit=\"vm.addShots()\">\n                <div class=\"box-body\">\n                    <div class=\"b-b m-b-1 text-center\" ng-if=\"vm.activeMatchPlayer\">\n                        <h3 class=\"_300 ng-binding\">\n                            {{vm.activeMatchPlayer.target_name}} - {{vm.activeMatchPlayer.playerName}}\n                        </h3>\n                    </div>\n                    <div class=\"form-group m-b-0\">\n                        <div class=\"row row-sm m-b-sm\">\n                            <div class=\"{{header.class}} text-center\" ng-repeat=\"header in vm.shotsHeaders\">\n                                <span translate class=\"fina-scores-row-label text-center\" ng-bind=\"header.name\"></span>\n                            </div>\n                        </div>\n                        <div class=\"row row-sm m-b-sm\" ng-repeat=\"(shotNo,shot) in vm.shots\">\n                            <div class=\"col-xs-1\">\n                                <span class=\"label label-lg shot-label\">{{shotNo}}</span>\n                            </div>\n                            <div class=\"col-xs-2\" ng-repeat=\"(arrowNo, arrow) in shot.arrows\">\n                                <input type=\"text\"\n                                       id=\"shotInput\"\n                                       required\n                                       shot-validator\n                                       ng-class=\"\"\n                                       class=\"shot-input form-control\"\n                                       ng-change=\"vm.calculateArrows()\"\n                                       ng-model=\"vm.shots[shotNo].arrows[arrowNo]\">\n                            </div>\n                            <div class=\"col-xs-1\" ng-repeat=\"stat in shot.stats\">\n                                <input type=\"text\" disabled ng-model=\"stat\" class=\"shot-input form-control\">\n                            </div>\n                        </div>\n                        <div class=\"row row-sm\">\n                            <div class=\"col-xs-8\">\n                                <span translate class=\"fina-scores-row-label text-center\">FINAl_SCORES_ROW</span>\n                            </div>\n                            <div class=\"col-xs-1\" >\n                                <input type=\"text\" disabled ng-value=\"vm.activeRound.round_score\" class=\"shot-input form-control\">\n                            </div>\n                            <div class=\"col-xs-1\" >\n                                <input type=\"text\" disabled ng-value=\"vm.activeRound.Xs\" class=\"shot-input form-control\">\n                            </div>\n                            <div class=\"col-xs-1\" >\n                                <input type=\"text\" disabled ng-value=\"vm.activeRound['10s']\" class=\"shot-input form-control\">\n                            </div>\n                            <div class=\"col-xs-1\" >\n                                <input type=\"text\" disabled ng-value=\"vm.activeRound['9s']\" class=\"shot-input form-control\">\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <footer class=\"dker p-a text-left\">\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn success p-x-md m-l-1\"\n                            ng-disabled=\"!addShotsForm.$valid\">SUBMIT\n                    </button>\n                    <button type=\"button\"\n                            translate\n                            ng-click=\"vm.clearRoundShots()\"\n                            class=\"btn danger p-x-md m-l-1 m-r-1\">CLEAR_ROUND\n                    </button>\n                </footer>\n            </form>\n        </div>\n    </div>\n    <div class=\"col-sm-3\">\n        <div class=\"box\">\n            <div class=\"box-header text-center\">\n                <h4 translate>TARGETS</h4>\n            </div>\n            <div class=\"box-divider m-a-0\"></div>\n            <div class=\"form-group row m-t-05\">\n                <div class=\"col-sm-12 p-l-2 p-r-2 p-t-0 text-center\">\n                    <ui-select on-select=\"vm.selectTargetNumber()\"\n                               ng-model=\"vm.activeTargetNumber\" theme=\"bootstrap\">\n                        <ui-select-match\n                                class=\"ui-select-match\"\n                                placeholder=\"{{'SELECT_TARGET' | translate}}\">\n                            {{$select.selected}}\n                        </ui-select-match>\n                        <ui-select-choices\n                                class=\"ui-select-choices\"\n                                repeat=\"item in vm.targetNumbers | filter: $select.search\">\n                            <div ng-bind-html=\"item | highlight: $select.search\"></div>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n            </div>\n            <ul class=\"list no-border p-b\">\n                <li ng-repeat=\"matchPlayer in vm.activeMatchPlayers\"\n                    ng-click=\"vm.selectMatchPlayer(matchPlayer.match_player_id)\"\n                    ng-class=\"{'list-item-active' : vm.activeMatchPlayer.match_player_id === matchPlayer.match_player_id}\"\n                    class=\"list-item div-hover-grey cursor-pointer\">\n                    <a class=\"list-left\">\n                        <span class=\"w-40 circle green avatar\">{{matchPlayer.targetPosition}}</span>\n                    </a>\n                    <div class=\"list-body\">\n                        <div><a ng-bind=\"matchPlayer.playerName\"></a></div>\n                        <small class=\"text-muted text-ellipsis\" ng-bind=\"matchPlayer.teamName\"></small>\n                    </div>\n                </li>\n            </ul>\n        </div>\n        <div class=\"box\">\n            <div class=\"box-header text-center\">\n                <h4 translate>ROUNDS</h4>\n            </div>\n            <ul class=\"list no-border p-b\">\n                <li ng-repeat=\"round in [1,2]\"\n                    ng-click=\"vm.selectRound(round)\"\n                    ng-class=\"{'list-item-active' : vm.activeRoundIdentifier == round}\"\n                    class=\"list-item div-hover-grey cursor-pointer\">\n                    <a class=\"list-left\">\n                        <span class=\"w-40 circle info avatar\"\n                              ng-class=\"{'opacity-05' : vm.activeRoundIdentifier != round}\">\n                            {{round}}\n                        </span>\n                    </a>\n                    <div class=\"list-body m-t-05\">\n                        <div ng-if=\"round == 1\"><a translate>ROUND_ONE</a></div>\n                        <div ng-if=\"round == 2\"><a translate>ROUND_TWO</a></div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchAddShotsController = function MatchAddShotsController(MatchesFactory, $rootScope, $filter, $state) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, MatchAddShotsController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		vm.rootScope = $rootScope;
		vm.$onInit = function () {
			$state.current.data.hideSidebar = true;
			$state.current.data.hideMatchProfile = true;
			$state.current.data.hideMatchMenu = true;
			vm.activeRoundIdentifier = 1;
			vm.activeTargetNumber = null;
			vm.shots = {};
			vm.targetNumbers = [];
			vm.activeMatchPlayers = [];
			vm.shotsHeaders = [{ name: '#', class: 'col-xs-1' }, { name: 'Βέλος 1ο', class: 'col-xs-2' }, { name: 'Βέλος 2ο', class: 'col-xs-2' }, { name: 'Βέλος 3ο', class: 'col-xs-2' }, { name: 'Shot', class: 'col-xs-1' }, { name: 'Inc.', class: 'col-xs-1' }, { name: 'Χs', class: 'col-xs-1' }, { name: '10s', class: 'col-xs-1' }, { name: '9s', class: 'col-xs-1' }];
			vm.maxShots = 13;
			if (vm.rootScope.currentMatch.match_type === MatchesFactory.MATCH_TYPES.INDOOR) {
				vm.maxShots = 11;
			}
			vm.moveToNextTarget = false;
			reloadMatchData();
		};
	
		vm.selectRound = function (identifier) {
			vm.activeRoundIdentifier = identifier;
			if (vm.activeMatchPlayer) {
				reloadRound();
			}
		};
		vm.selectTargetNumber = function () {
			vm.activeMatchPlayers = [];
			(0, _entries2.default)(vm.matchPlayers).forEach(function (entry) {
				var value = entry[1];
				if (value.targetNumber !== vm.activeTargetNumber) {
					return;
				}
				vm.activeMatchPlayers.push(value);
			});
		};
		vm.selectMatchPlayer = function (matchPlayerId) {
			var params = { match_player_id: matchPlayerId, include: 'matchPlayers,matchPlayers.rounds' };
			MatchesFactory.getOne(vm.rootScope.currentMatchId, params).then(function (response) {
				vm.activeMatchPlayer = response.data.matchPlayers[0];
				reloadRound();
			});
		};
		vm.addShots = function () {
			var shots = {};
			for (var i = 1; i < vm.maxShots; i++) {
				shots[i] = vm.shots[i].arrows;
			}
			MatchesFactory.addShots(vm.activeRound.round_id, { shots: shots }).then(function (response) {
				var activeMatchPlayerId = vm.activeMatchPlayer.match_player_id;
				var currentIndex = vm.matchPlayers.findIndex(function (matchPlayer) {
					return matchPlayer.match_player_id === activeMatchPlayerId;
				});
				var nextMatchPlayer = vm.matchPlayers[currentIndex + 1];
				if (!nextMatchPlayer) {
					return;
				}
				if (vm.activeTargetNumber !== nextMatchPlayer.targetNumber) {
					vm.activeTargetNumber = nextMatchPlayer.targetNumber;
				}
				vm.selectTargetNumber();
				vm.selectMatchPlayer(nextMatchPlayer.match_player_id);
			});
		};
		vm.clearRoundShots = function () {
			MatchesFactory.clear(vm.activeRound.round_id).then(function (response) {
				vm.selectMatchPlayer(vm.activeMatchPlayer.match_player_id);
			});
		};
		vm.calculateArrows = function () {
			for (var i = 1; i < vm.maxShots; i++) {
				var shotScore = 0;
				var nines = 0;
				var xs = 0;
				var tens = 0;
				for (var j = 1; j < 4; j++) {
					if (!vm.shots[i].arrows[j]) {
						continue;
					}
					if (parseInt(vm.shots[i].arrows[j]) === 10) {
						tens++;
					}
					if (parseInt(vm.shots[i].arrows[j]) === 9) {
						nines++;
					}
					if (parseInt(vm.shots[i].arrows[j]) === 0) {
						vm.shots[i].arrows[j] = 'm';
					}
					if (parseInt(vm.shots[i].arrows[j]) === 11) {
						vm.shots[i].arrows[j] = 'x';
					}
					if (vm.shots[i].arrows[j].toLowerCase() === 'x') {
						xs++;
						tens++;
						shotScore += 10;
					}
	
					if (vm.shots[i].arrows[j].toLowerCase() !== 'm' && vm.shots[i].arrows[j].toLowerCase() !== 'x') {
						shotScore = shotScore + parseInt(vm.shots[i].arrows[j]);
					}
				}
	
				vm.shots[i].stats.xs = xs;
				vm.shots[i].stats.tens = tens;
				vm.shots[i].stats.nines = nines;
				vm.shots[i].stats.score = shotScore;
				if (vm.shots[i - 1]) {
					vm.shots[i].stats.incrementScore = vm.shots[i].stats.score + vm.shots[i - 1].stats.incrementScore;
				} else {
					vm.shots[i].stats.incrementScore = vm.shots[i].stats.score;
				}
			}
		};
	
		function reloadRound() {
			angular.element('#shotInput').focus();
			vm.activeRound = null;
			vm.activeRound = vm.activeMatchPlayer.rounds.find(function (round) {
				return round.round === vm.activeRoundIdentifier;
			});
			for (var i = 1; i < vm.maxShots; i++) {
				vm.shots[i] = {
					arrows: {
						1: vm.activeRound['arrow_' + i + '_1'],
						2: vm.activeRound['arrow_' + i + '_2'],
						3: vm.activeRound['arrow_' + i + '_3']
					},
					stats: {
						score: 0,
						incrementScore: 0,
						xs: 0,
						tens: 0,
						nines: 0
					}
				};
			}
			vm.calculateArrows();
		}
	
		function reloadMatchData() {
			var data = { include: 'matchPlayers' };
			MatchesFactory.getOne(vm.rootScope.currentMatchId, data).then(function (response) {
				vm.matchPlayers = response.data.matchPlayers;
				vm.matchPlayers.sort(function (a, b) {
					if (a.target_name < b.target_name) return -1;
					if (a.target_name > b.target_name) return 1;
					return 0;
				});
				(0, _entries2.default)(vm.matchPlayers).forEach(function (entry) {
					var value = entry[1].targetNumber;
					if (!vm.targetNumbers.includes(value)) {
						vm.targetNumbers.push(value);
					}
				});
				vm.targetNumbers.sort();
				if (vm.activeMatchPlayer) {
					var activeMatchPlayerId = vm.activeMatchPlayer.match_player_id;
					vm.activeMatchPlayer = null;
					vm.selectMatchPlayer(activeMatchPlayerId);
				}
			});
		}
	};
	MatchAddShotsController.$inject = ["MatchesFactory", "$rootScope", "$filter", "$state"];
	
	exports.default = MatchAddShotsController;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(656);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchAddShots.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchAddShots.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, ".fina-scores-row-label{padding-top:4px;font-weight:700;font-size:15px}input.ng-invalid-shot-validator{color:red;border-color:red;border-radius:0}", ""]);
	
	// exports


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchAddShotsVisual = __webpack_require__(658);
	
	var _matchAddShotsVisual2 = _interopRequireDefault(_matchAddShotsVisual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchAddShotsVisualModule = _angular2.default.module('matchAddShotsVisual', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('match-profile.addShotsVisual', {
			url: '/addShotsVisual',
			component: 'matchAddShotsVisual',
			data: { pageTitle: 'ADD_SHOTS_VISUAL' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.ADD_SCORE_TO_MATCH)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('matchAddShotsVisual', _matchAddShotsVisual2.default).name;
	
	exports.default = matchAddShotsVisualModule;

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchAddShotsVisual = __webpack_require__(659);
	
	var _matchAddShotsVisual2 = _interopRequireDefault(_matchAddShotsVisual);
	
	var _matchAddShotsVisual3 = __webpack_require__(660);
	
	var _matchAddShotsVisual4 = _interopRequireDefault(_matchAddShotsVisual3);
	
	__webpack_require__(661);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchAddShotsVisualVisualComponent = {
	  bindings: {},
	  template: _matchAddShotsVisual2.default,
	  controller: _matchAddShotsVisual4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchAddShotsVisualVisualComponent;

/***/ }),
/* 659 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-10\">\n        <div class=\"col-sm-1\">\n            <div class=\"box m-b-1\">\n                <div class=\"box-body\">\n                    <div class=\"row row-sm\">\n                        <div class=\"col-xs-8\">\n                            <span translate class=\"fina-scores-row-label text-center\">\n                                Target\n                            </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-sm-11\">\n            <div class=\"box m-b-1\">\n                <div class=\"box-body\">\n                    <div class=\"row row-sm\">\n                        <div ng-repeat=\"shot in vm.ends\"\n                             class=\"col-xs-1\">\n                            <span translate class=\"fina-scores-row-label text-center\">\n                                {{shot}}\n                            </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-sm-1\">\n            <div class=\"box\">\n                <div class=\"box-body\">\n                    <div ng-repeat=\"matchPlayer in vm.matchPlayers\" class=\"row row-sm visualize-row\">\n                        <div class=\"col-xs-8 sidebar-vis-text\">\n                            <span translate class=\"fina-scores-row-label text-center\">\n                                {{matchPlayer.target_name}}\n                            </span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"col-sm-11\">\n            <div class=\"box\">\n                <div class=\"box-body\">\n                    <div ng-repeat=\"matchPlayer in vm.matchPlayers\" class=\"row row-sm visualize-row\">\n                        <div ng-repeat=\"shot in vm.ends\"\n                             class=\"col-xs-1\">\n                            <span class=\"w-16 circle avatar\"\n                                  ng-class=\"vm.isEndCompleted(matchPlayer.target_name, shot)\"></span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"col-sm-2\">\n        <div class=\"box\">\n            <div class=\"box-header text-center\">\n                <h4 translate>ROUNDS</h4>\n            </div>\n            <ul class=\"list no-border p-b\">\n                <li ng-repeat=\"round in [1,2]\"\n                    ng-click=\"vm.selectRound(round)\"\n                    ng-class=\"{'list-item-active' : vm.activeRoundIdentifier == round}\"\n                    class=\"list-item div-hover-grey cursor-pointer\">\n                    <a class=\"list-left\">\n                        <span class=\"w-40 circle info avatar\"\n                              ng-class=\"{'opacity-05' : vm.activeRoundIdentifier != round}\">\n                            {{round}}\n                        </span>\n                    </a>\n                    <div class=\"list-body m-t-05\">\n                        <div ng-if=\"round == 1\"><a translate>ROUND_ONE</a></div>\n                        <div ng-if=\"round == 2\"><a translate>ROUND_TWO</a></div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchAddShotsVisualController = function MatchAddShotsVisualController(MatchesFactory, $rootScope, $filter, $state) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, MatchAddShotsVisualController);
		var vm = this;
	
		vm.rootScope = $rootScope;
		vm.$onInit = function () {
			$state.current.data.hideSidebar = true;
			$state.current.data.hideMatchProfile = true;
			$state.current.data.hideMatchMenu = true;
			vm.activeRoundIdentifier = 1;
			vm.ends = [1, 2, 3, 4, 5, 6];
			if (vm.rootScope.currentMatch.match_type === MatchesFactory.MATCH_TYPES.INDOOR) {
				vm.ends = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
			}
			reloadMatchData();
		};
	
		vm.isEndCompleted = function (targetName, shotEnd) {
			var mP = vm.matchPlayers.find(function (m) {
				return m.target_name === targetName;
			});
			var round = mP.rounds.find(function (r) {
				return r.round === vm.activeRoundIdentifier;
			});
			if (vm.rootScope.currentMatch.match_type === MatchesFactory.MATCH_TYPES.INDOOR) {
				return round['arrow_' + shotEnd + '_1'] && round['arrow_' + shotEnd + '_2'] && round['arrow_' + shotEnd + '_3'] ? 'success' : 'danger';
			} else {
				var arOne = 1;
				var arTwo = 2;
				if (shotEnd === 2) {
					arOne = 3;
					arTwo = 4;
				} else if (shotEnd === 3) {
					arOne = 5;
					arTwo = 6;
				} else if (shotEnd === 4) {
					arOne = 7;
					arTwo = 8;
				} else if (shotEnd === 5) {
					arOne = 9;
					arTwo = 10;
				} else if (shotEnd === 6) {
					arOne = 11;
					arTwo = 12;
				}
				return round['arrow_' + arOne + '_1'] && round['arrow_' + arOne + '_2'] && round['arrow_' + arOne + '_3'] && round['arrow_' + arTwo + '_1'] && round['arrow_' + arTwo + '_2'] && round['arrow_' + arTwo + '_3'] ? 'success' : 'danger';
			}
		};
	
		vm.selectRound = function (identifier) {
			vm.activeRoundIdentifier = identifier;
		};
	
		function reloadMatchData() {
			var data = { include: 'matchPlayers,matchPlayers.rounds' };
			MatchesFactory.getOne(vm.rootScope.currentMatchId, data, true).then(function (response) {
				vm.matchPlayers = response.data.matchPlayers;
				vm.matchPlayers.sort(function (a, b) {
					if (a.target_name < b.target_name) return -1;
					if (a.target_name > b.target_name) return 1;
					return 0;
				});
				setTimeout(reloadMatchData, 2000);
			});
		}
	};
	MatchAddShotsVisualController.$inject = ["MatchesFactory", "$rootScope", "$filter", "$state"];
	
	exports.default = MatchAddShotsVisualController;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(662);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchAddShotsVisual.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchAddShotsVisual.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, ".fina-scores-row-label{padding-top:4px;font-weight:700;font-size:15px}.visualize-row{height:30px;border-bottom:1px solid #d0c8c8}.visualize-row div,.visualize-row div span{padding:0!important;margin:0!important}.visualize-row div span.circle{margin-top:7px!important}.visualize-row div.sidebar-vis-text{margin-top:3px!important;text-align:center}input.ng-invalid-shot-validator{color:red;border-color:red;border-radius:0}", ""]);
	
	// exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchAddShotsIndividual = __webpack_require__(664);
	
	var _matchAddShotsIndividual2 = _interopRequireDefault(_matchAddShotsIndividual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchAddShotsIndividualModule = _angular2.default.module('matchAddShotsIndividual', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('match-profile.addShotsIndividual', {
			url: '/addShotsIndividual',
			component: 'matchAddShotsIndividual',
			data: { pageTitle: 'ADD_SHOTS_INDIVIDUAL' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.ADD_SCORE_TO_MATCH_ELIMINATION_ROUNDS)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('matchAddShotsIndividual', _matchAddShotsIndividual2.default).name;
	
	exports.default = matchAddShotsIndividualModule;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchAddShotsIndividual = __webpack_require__(665);
	
	var _matchAddShotsIndividual2 = _interopRequireDefault(_matchAddShotsIndividual);
	
	var _matchAddShotsIndividual3 = __webpack_require__(666);
	
	var _matchAddShotsIndividual4 = _interopRequireDefault(_matchAddShotsIndividual3);
	
	__webpack_require__(667);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchAddShotsIndividualComponent = {
	  bindings: {},
	  template: _matchAddShotsIndividual2.default,
	  controller: _matchAddShotsIndividual4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchAddShotsIndividualComponent;

/***/ }),
/* 665 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-sm-9\">\n    <div\n      class=\"row row-sm\"\n      ng-if=\"vm.eliminationMatches && !vm.activeEliminationMatch\"\n    >\n      <div class=\"col-xs-12\" ng-if=\"vm.rounds.length > 0\">\n        <div class=\"b-b m-b-1 text-center\">\n          <h4\n            class=\"_300 ng-binding\"\n            ng-bind=\"vm.activeLeague.league_name\"\n          ></h4>\n          <div\n            class=\"col-xs-2 list-item box r m-b cursor-pointer\"\n            ng-repeat=\"round in vm.rounds\"\n            ng-class=\"{'list-item-active' : vm.activeRound == round}\"\n            ng-click=\"vm.selectRound(round)\"\n          >\n            <span\n              class=\"w-40 circle info avatar\"\n              ng-class=\"{'opacity-05' : vm.activeRound != round}\"\n            >\n              {{round}}\n            </span>\n          </div>\n        </div>\n      </div>\n      <div\n        class=\"col-xs-12 cursor-pointer\"\n        ng-repeat=\"eliminationMatch in vm.eliminationMatches\"\n        ng-click=\"vm.selectEliminationMatch(eliminationMatch.olympic_match_id);\"\n      >\n        <div class=\"col-xs-6 list-item box r m-b cursor-pointer\">\n          <a class=\"list-left\">\n            <span\n              class=\"w-40 circle green\"\n              ng-if=\"eliminationMatch.winner === eliminationMatch.playerOne.player_id\"\n              ng-bind=\"eliminationMatch.winner_score\"\n            ></span>\n            <span\n              class=\"w-40 circle red\"\n              ng-if=\"eliminationMatch.winner === eliminationMatch.playerTwo.player_id\"\n              ng-bind=\"eliminationMatch.loser_score\"\n            ></span>\n            <span\n              class=\"w-40 circle white border-b-1\"\n              ng-if=\"!eliminationMatch.winner\"\n              ng-bind=\"eliminationMatch.player_1_score\"\n            ></span>\n          </a>\n          <div class=\"list-body text-right\" ng-if=\"eliminationMatch.playerOne\">\n            <div class=\"text-ellipsis\">\n              <a ng-bind=\"eliminationMatch.playerOne.playerName\"></a>\n            </div>\n            <small\n              class=\"text-muted text-ellipsis\"\n              ng-bind=\"eliminationMatch.playerOne.teamName\"\n            ></small>\n          </div>\n        </div>\n        <div class=\"col-xs-6 list-item box r m-b\">\n          <a class=\"list-left\">\n            <span\n              class=\"w-40 circle green\"\n              ng-if=\"eliminationMatch.winner === eliminationMatch.playerTwo.player_id\"\n              ng-bind=\"eliminationMatch.winner_score\"\n            ></span>\n            <span\n              class=\"w-40 circle red\"\n              ng-if=\"eliminationMatch.winner === eliminationMatch.playerOne.player_id\"\n              ng-bind=\"eliminationMatch.loser_score\"\n            ></span>\n            <span\n              class=\"w-40 circle white border-b-1\"\n              ng-if=\"!eliminationMatch.winner\"\n              ng-bind=\"eliminationMatch.player_2_score\"\n            ></span>\n          </a>\n          <div class=\"list-body\" ng-if=\"eliminationMatch.playerTwo\">\n            <div class=\"text-ellipsis\">\n              <a ng-bind=\"eliminationMatch.playerTwo.playerName\"></a>\n            </div>\n            <small\n              class=\"text-muted text-ellipsis\"\n              ng-bind=\"eliminationMatch.playerTwo.teamName\"\n            ></small>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"box\" ng-if=\"vm.activeEliminationMatch\">\n      <div class=\"box-tool\">\n        <ul class=\"nav\">\n          <li\n            class=\"nav-item inline\"\n            ng-click=\"vm.activeEliminationMatch = null;\"\n          >\n            <a class=\"nav-link\"><i class=\"fa fa-close md-18\"></i></a>\n          </li>\n        </ul>\n      </div>\n      <form name=\"addShotsForm\" ng-submit=\"vm.addShots()\">\n        <div class=\"box-body\">\n          <div class=\"b-b m-b-1 text-center\">\n            <h3 class=\"_300 ng-binding\">\n              {{vm.activeEliminationMatch.playerOne.playerName}} -\n              {{vm.activeEliminationMatch.playerTwo.playerName}}\n            </h3>\n          </div>\n          <div class=\"form-group m-b-0\">\n            <div class=\"row row-sm m-b-sm\">\n              <div\n                class=\"{{header.class}} text-center\"\n                ng-repeat=\"header in vm.shotsHeaders\"\n              >\n                <span\n                  translate\n                  class=\"fina-scores-row-label text-center\"\n                  ng-bind=\"header.name\"\n                ></span>\n              </div>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"form-group col-xs-6\">\n              <div\n                class=\"row m-b-sm\"\n                ng-repeat=\"(shotNo,shot) in vm.roundOneShots\"\n              >\n                <div class=\"col-xs-2\">\n                  <span class=\"label label-lg shot-label\">{{shotNo}}</span>\n                </div>\n                <div\n                  class=\"col-xs-2\"\n                  ng-repeat=\"(arrowNo, arrow) in shot.arrows\"\n                >\n                  <input\n                    type=\"text\"\n                    shot-validator\n                    ng-class=\"\"\n                    class=\"shot-input form-control\"\n                    ng-change=\"vm.calculateArrows()\"\n                    ng-model=\"vm.roundOneShots[shotNo].arrows[arrowNo]\"\n                  />\n                </div>\n                <div class=\"col-xs-2\" ng-repeat=\"stat in shot.stats\">\n                  <input\n                    type=\"text\"\n                    disabled\n                    ng-model=\"stat\"\n                    class=\"shot-input form-control\"\n                  />\n                </div>\n              </div>\n              <div class=\"row m-b-sm\">\n                <div class=\"col-xs-4\">\n                  <span class=\"label label-lg shot-label\" translate\n                    >FINAL_SHOT</span\n                  >\n                </div>\n                <div class=\"col-xs-2\">\n                  <input\n                    type=\"text\"\n                    shot-validator\n                    ng-class=\"\"\n                    class=\"shot-input form-control\"\n                    ng-change=\"vm.calculateArrows()\"\n                    ng-model=\"vm.roundOneFinalShot\"\n                  />\n                </div>\n                <div class=\"col-xs-2\">\n                  <input\n                    type=\"text\"\n                    shot-validator\n                    ng-class=\"\"\n                    class=\"shot-input form-control\"\n                    ng-change=\"vm.calculateArrows()\"\n                    ng-model=\"vm.roundOneFinalShotTwo\"\n                  />\n                </div>\n                <div class=\"col-sm-4\">\n                  <label class=\"md-switch\">\n                    <input\n                      type=\"checkbox\"\n                      ng-model=\"vm.roundOneCloseToCenter\"\n                    />\n                    <i class=\"blue\"></i> Closer to Center\n                  </label>\n                </div>\n              </div>\n              <div class=\"row m-b-sm\">\n                <div class=\"col-xs-12\">\n                  <button\n                    type=\"button\"\n                    translate\n                    ng-click=\"vm.forfeited(vm.activeEliminationMatch.playerOne)\"\n                    class=\"btn info p-x-md m-l-1 m-r-1\"\n                  >\n                    FORFEITED\n                  </button>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group col-xs-6\">\n              <div\n                class=\"row m-b-sm\"\n                ng-repeat=\"(shotNo,shot) in vm.roundTwoShots\"\n              >\n                <div class=\"col-xs-2\">\n                  <span class=\"label label-lg shot-label\">{{shotNo}}</span>\n                </div>\n                <div\n                  class=\"col-xs-2\"\n                  ng-repeat=\"(arrowNo, arrow) in shot.arrows\"\n                >\n                  <input\n                    type=\"text\"\n                    shot-validator\n                    ng-class=\"\"\n                    class=\"shot-input form-control\"\n                    ng-change=\"vm.calculateArrows()\"\n                    ng-model=\"vm.roundTwoShots[shotNo].arrows[arrowNo]\"\n                  />\n                </div>\n                <div class=\"col-xs-2\" ng-repeat=\"stat in shot.stats\">\n                  <input\n                    type=\"text\"\n                    disabled\n                    ng-model=\"stat\"\n                    class=\"shot-input form-control\"\n                  />\n                </div>\n              </div>\n              <div class=\"row m-b-sm\">\n                <div class=\"col-xs-4\">\n                  <span class=\"label label-lg shot-label\" translate\n                    >FINAL_SHOT</span\n                  >\n                </div>\n                <div class=\"col-xs-2\">\n                  <input\n                    type=\"text\"\n                    shot-validator\n                    ng-class=\"\"\n                    class=\"shot-input form-control\"\n                    ng-change=\"vm.calculateArrows()\"\n                    ng-model=\"vm.roundTwoFinalShot\"\n                  />\n                </div>\n                <div class=\"col-xs-2\">\n                  <input\n                    type=\"text\"\n                    shot-validator\n                    ng-class=\"\"\n                    class=\"shot-input form-control\"\n                    ng-change=\"vm.calculateArrows()\"\n                    ng-model=\"vm.roundTwoFinalShotTwo\"\n                  />\n                </div>\n                <div class=\"col-sm-4\">\n                  <label class=\"md-switch\">\n                    <input\n                      type=\"checkbox\"\n                      ng-model=\"vm.roundTwoCloseToCenter\"\n                    />\n                    <i class=\"blue\"></i> Closer to Center\n                  </label>\n                </div>\n              </div>\n              <div class=\"row m-b-sm\">\n                <div class=\"col-xs-12\">\n                  <button\n                    type=\"button\"\n                    translate\n                    ng-click=\"vm.forfeited(vm.activeEliminationMatch.playerTwo)\"\n                    class=\"btn info p-x-md m-l-1 m-r-1\"\n                  >\n                    FORFEITED\n                  </button>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div class=\"row row-sm\">\n            <div class=\"col-xs-4\">\n              <span translate class=\"fina-scores-row-label text-center\"\n                >FINAl_SCORES_ROW</span\n              >\n            </div>\n            <div class=\"col-xs-1\">\n              <input\n                type=\"text\"\n                disabled\n                ng-value=\"vm.roundOneScore\"\n                class=\"shot-input form-control\"\n              />\n            </div>\n            <div\n              class=\"col-xs-1\"\n              ng-if=\"vm.activeEliminationMatch.winnerPlayer.player_id === vm.activeEliminationMatch.playerOne.player_id\"\n            >\n              <i class=\"fa fa-check-circle shot-check-icon\" style=\"\"></i>\n            </div>\n            <div class=\"col-xs-1\"></div>\n            <div class=\"col-xs-4\">\n              <span translate class=\"fina-scores-row-label text-center\"\n                >FINAl_SCORES_ROW</span\n              >\n            </div>\n            <div class=\"col-xs-1\">\n              <input\n                type=\"text\"\n                disabled\n                ng-value=\"vm.roundTwoScore\"\n                class=\"shot-input form-control\"\n              />\n            </div>\n            <div\n              class=\"col-xs-1\"\n              ng-if=\"vm.activeEliminationMatch.winnerPlayer.player_id === vm.activeEliminationMatch.playerTwo.player_id\"\n            >\n              <i class=\"fa fa-check-circle shot-check-icon\" style=\"\"></i>\n            </div>\n          </div>\n        </div>\n        <footer class=\"dker p-a text-left\">\n          <button\n            type=\"submit\"\n            translate\n            class=\"btn success p-x-md m-l-1\"\n            ng-disabled=\"!addShotsForm.$valid\"\n          >\n            SUBMIT\n          </button>\n          <button\n            type=\"button\"\n            translate\n            ng-click=\"vm.clearRoundShots()\"\n            class=\"btn danger p-x-md m-l-1 m-r-1\"\n          >\n            CLEAR_ROUND\n          </button>\n          <button\n            type=\"button\"\n            translate\n            ng-click=\"vm.goToVisual()\"\n            class=\"btn accent p-x-md m-r-1\"\n          >\n            VISUAL\n          </button>\n          <button\n            type=\"button\"\n            translate\n            ng-click=\"vm.refresh()\"\n            class=\"btn info p-x-md m-r-1\"\n          >\n            REFRESH\n          </button>\n        </footer>\n      </form>\n    </div>\n  </div>\n  <div class=\"col-sm-3\">\n    <div class=\"box\">\n      <div class=\"box-header text-center\">\n        <h4 translate>SELECT_LEAGUE</h4>\n      </div>\n      <ul class=\"list no-border p-b\">\n        <li\n          ng-repeat=\"league in vm.leagues\"\n          ng-click=\"vm.selectLeague(league)\"\n          ng-class=\"{'list-item-active' : vm.activeLeague == league}\"\n          class=\"list-item div-hover-grey cursor-pointer\"\n        >\n          <a class=\"list-left\">\n            <span\n              class=\"w-40 circle info avatar\"\n              ng-class=\"{'opacity-05' : vm.activeLeague != league}\"\n            >\n              {{league.currentIndividualRound}}\n            </span>\n          </a>\n          <div class=\"list-body\">\n            <div><a>{{league.league_name}}</a></div>\n          </div>\n        </li>\n      </ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchAddShotsIndividualController = function MatchAddShotsIndividualController(MatchesFactory, LeaguesFactory, $rootScope, $filter, $state) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, MatchAddShotsIndividualController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	  vm.$onInit = function () {
	    $state.current.data.hideSidebar = true;
	    $state.current.data.hideMatchProfile = true;
	    $state.current.data.hideMatchMenu = true;
	    vm.leagues = [];
	    vm.activeLeague = null;
	    vm.roundsTemplate = ["1/32", "1/16", "1/8", "1/4", "1/2", "1/1"];
	    vm.rounds = [];
	    vm.activeRound = null;
	    vm.activeEliminationMatches = [];
	    vm.activeEliminationMatch = null;
	    vm.roundOneShots = {};
	    vm.roundTwoShots = {};
	    vm.shotsHeaders = [{ name: "#", class: "col-xs-1" }, { name: "1ο", class: "col-xs-1" }, { name: "2ο", class: "col-xs-1" }, { name: "3ο", class: "col-xs-1" }, { name: "Shot", class: "col-xs-1" }, { name: "Score", class: "col-xs-1" }, { name: "#", class: "col-xs-1" }, { name: "1ο", class: "col-xs-1" }, { name: "2ο", class: "col-xs-1" }, { name: "3ο", class: "col-xs-1" }, { name: "Shot", class: "col-xs-1" }, { name: "Score", class: "col-xs-1" }];
	    vm.maxShots = 6;
	    vm.moveToNextTarget = false;
	    /* Fetch Leagues with Individual Matches */
	    MatchesFactory.getOne(vm.rootScope.currentMatchId, {
	      include: "matchLeagues"
	    }).then(function (response) {
	      (0, _entries2.default)(response.data.matchLeagues).forEach(function (entry) {
	        var value = entry[1];
	        if (value.olympic_players && value.olympic_players > 0) {
	          value.league.currentIndividualRound = value.currentIndividualRound;
	          vm.leagues.push(value.league);
	        }
	      });
	    });
	  };
	
	  vm.isLeagueCompound = function () {
	    return vm.activeLeague.type === LeaguesFactory.LEAGUE_TYPES.COMPOUND;
	  };
	
	  vm.isLeagueRecurve = function () {
	    return vm.activeLeague.type === LeaguesFactory.LEAGUE_TYPES.RECURVE;
	  };
	
	  vm.isLeagueField = function () {
	    return vm.activeLeague.type === LeaguesFactory.LEAGUE_TYPES.FIELD;
	  };
	
	  vm.selectLeague = function (league) {
	    vm.activeLeague = league;
	    vm.rounds = [];
	    vm.rounds = vm.roundsTemplate;
	    vm.activeRound = league.currentIndividualRound;
	    vm.activeEliminationMatch = null;
	    // let found = false;
	    // for(let i = 0; i < vm.roundsTemplate; i++){
	    // if(found || vm.roundsTemplate[i] === vm.activeLeague.currentIndividualRound){
	    // 	found = true;
	    // 	vm.rounds.push(vm.roundsTemplate[i]);
	    // }
	    // }
	    reloadLeagueEliminationMatches(false);
	  };
	  vm.selectRound = function (round) {
	    vm.activeRound = round;
	    reloadLeagueEliminationMatches();
	  };
	  vm.refresh = function () {
	    reloadLeagueEliminationMatches(true);
	  };
	  vm.goToVisual = function () {
	    window.open("/match-profile/shotsIndividualVisual/" + vm.rootScope.currentMatchId + "/" + vm.activeLeague.league_id + "/" + vm.activeEliminationMatch.olympic_match_id, "_blank");
	  };
	  vm.selectEliminationMatch = function (eliminationMatchId) {
	    vm.activeEliminationMatch = vm.eliminationMatches.find(function (eliminationMatch) {
	      return eliminationMatch.olympic_match_id === eliminationMatchId;
	    });
	    vm.roundOneShots = {};
	    vm.roundTwoShots = {};
	    vm.roundOneFinalShot = null;
	    vm.roundTwoFinalShot = null;
	    vm.roundOneFinalShotTwo = null;
	    vm.roundTwoFinalShotTwo = null;
	    vm.roundOneCloseToCenter = null;
	    vm.roundTwoCloseToCenter = null;
	    vm.activeRoundOne = vm.activeEliminationMatch.rounds[0];
	    vm.activeRoundTwo = vm.activeEliminationMatch.rounds[1];
	    if (vm.isLeagueCompound()) {
	      if (vm.activeRoundOne.points === "bye" || vm.activeRoundTwo.points === "bye") {
	        vm.activeRoundOne.displayScore = vm.activeRoundOne.points;
	        vm.activeRoundTwo.displayScore = vm.activeRoundTwo.points;
	      } else {
	        vm.activeRoundOne.displayScore = parseInt(vm.activeRoundOne.points);
	        vm.activeRoundTwo.displayScore = parseInt(vm.activeRoundTwo.points);
	        if (vm.activeRoundOne.arrow_f) {
	          vm.activeRoundOne.displayScore += parseInt(vm.activeRoundOne.arrow_f);
	        }
	        if (vm.activeRoundTwo.arrow_f) {
	          vm.activeRoundTwo.displayScore += parseInt(vm.activeRoundTwo.arrow_f);
	        }
	      }
	    } else {
	      vm.activeRoundOne.displayScore = vm.activeRoundOne.points;
	      vm.activeRoundTwo.displayScore = vm.activeRoundTwo.points;
	    }
	    for (var i = 1; i < vm.maxShots; i++) {
	      vm.roundOneShots[i] = {
	        arrows: {
	          1: vm.activeRoundOne["arrow_" + i + "_1"],
	          2: vm.activeRoundOne["arrow_" + i + "_2"],
	          3: vm.activeRoundOne["arrow_" + i + "_3"]
	        },
	        stats: {
	          endScore: 0,
	          score: 0
	        }
	      };
	      vm.roundTwoShots[i] = {
	        arrows: {
	          1: vm.activeRoundTwo["arrow_" + i + "_1"],
	          2: vm.activeRoundTwo["arrow_" + i + "_2"],
	          3: vm.activeRoundTwo["arrow_" + i + "_3"]
	        },
	        stats: {
	          endScore: 0,
	          score: 0
	        }
	      };
	    }
	    vm.roundOneFinalShot = vm.activeRoundOne["arrow_f"];
	    vm.roundTwoFinalShot = vm.activeRoundTwo["arrow_f"];
	    vm.roundOneFinalShotTwo = vm.activeRoundOne["arrow_f_2"];
	    vm.roundTwoFinalShotTwo = vm.activeRoundTwo["arrow_f_2"];
	    vm.roundOneCloseToCenter = vm.activeRoundOne["closer_to_center"] === 1;
	    vm.roundTwoCloseToCenter = vm.activeRoundTwo["closer_to_center"] === 1;
	    vm.calculateArrows();
	  };
	  vm.addShots = function () {
	    var roundOneShots = {};
	    var roundTwoShots = {};
	    for (var i = 1; i < vm.maxShots; i++) {
	      roundOneShots[i] = vm.roundOneShots[i].arrows;
	      roundTwoShots[i] = vm.roundTwoShots[i].arrows;
	    }
	    var roundOneId = vm.activeRoundOne.olympic_round_id;
	    var roundTwoId = vm.activeRoundTwo.olympic_round_id;
	    var rounds = [{
	      roundId: roundOneId,
	      shots: roundOneShots
	    }, {
	      roundId: roundTwoId,
	      shots: roundTwoShots
	    }];
	    var finalShots = [{
	      roundId: roundOneId,
	      shot: vm.roundOneFinalShot,
	      shot_2: vm.roundOneFinalShotTwo,
	      closer_to_center: vm.roundOneCloseToCenter
	    }, {
	      roundId: roundTwoId,
	      shot: vm.roundTwoFinalShot,
	      shot_2: vm.roundTwoFinalShotTwo,
	      closer_to_center: vm.roundTwoCloseToCenter
	    }];
	    MatchesFactory.addShotsElimination(vm.activeEliminationMatch.olympic_match_id, MatchesFactory.MATCH_ELIMINATION_TYPES.INDIVIDUAL, {
	      rounds: rounds,
	      finalShots: finalShots
	    }).then(function (response) {
	      reloadLeagueEliminationMatches();
	    });
	  };
	  vm.clearRoundShots = function () {
	    MatchesFactory.clearShotsElimination(vm.activeEliminationMatch.olympic_match_id, MatchesFactory.MATCH_ELIMINATION_TYPES.INDIVIDUAL).then(function (response) {
	      reloadLeagueEliminationMatches();
	    });
	  };
	  vm.calculateArrows = function () {
	    vm.roundOneScore = 0;
	    vm.roundTwoScore = 0;
	    for (var i = 1; i < 4; i++) {
	      vm.roundOneShots[i].stats.score = 0;
	      vm.roundTwoShots[i].stats.score = 0;
	    }
	    for (var _i = 1; _i <= vm.maxShots; _i++) {
	      var shotOneScore = 0;
	      var shotTwoScore = 0;
	      if (_i === vm.maxShots) {
	        shotOneScore = parseInt(vm.roundOneFinalShot);
	        shotTwoScore = parseInt(vm.roundTwoFinalShot);
	      } else {
	        for (var j = 1; j < 4; j++) {
	          if (!vm.roundOneShots[_i].arrows[j]) {
	            continue;
	          }
	
	          /* Round One */
	          if (vm.roundOneShots[_i].arrows[j] == 0) {
	            vm.roundOneShots[_i].arrows[j] = "m";
	          }
	          if (vm.roundOneShots[_i].arrows[j].toLowerCase() !== "m") {
	            shotOneScore = shotOneScore + parseInt(vm.roundOneShots[_i].arrows[j]);
	          }
	          /* Round Two */
	          if (!vm.roundTwoShots[_i].arrows[j]) {
	            continue;
	          }
	          if (vm.roundTwoShots[_i].arrows[j] == 0) {
	            vm.roundTwoShots[_i].arrows[j] = "m";
	          }
	          if (vm.roundTwoShots[_i].arrows[j].toLowerCase() !== "m") {
	            shotTwoScore = shotTwoScore + parseInt(vm.roundTwoShots[_i].arrows[j]);
	          }
	        }
	        vm.roundOneShots[_i].stats.endScore = shotOneScore;
	        vm.roundTwoShots[_i].stats.endScore = shotTwoScore;
	        if (!vm.roundOneShots[_i].arrows[3]) {
	          continue;
	        }
	        if (!vm.roundTwoShots[_i].arrows[3]) {
	          continue;
	        }
	      }
	      /* RECURVE SCORING */
	      if (vm.isLeagueRecurve() || vm.isLeagueField()) {
	        // if(vm.activeLeague.type === LeaguesFactory.LEAGUE_TYPES.RECURVE){
	        /* iF shoot off */
	        if (_i === vm.maxShots) {
	          if (vm.roundOneFinalShot && vm.roundTwoFinalShot) {
	            if (shotOneScore > shotTwoScore) {
	              vm.roundOneScore += 2;
	            } else if (shotOneScore < shotTwoScore) {
	              vm.roundTwoScore += 2;
	            }
	          }
	        } else {
	          if (shotOneScore > shotTwoScore) {
	            vm.roundOneShots[_i].stats.score = 2;
	            vm.roundOneScore += 2;
	          } else if (shotOneScore < shotTwoScore) {
	            vm.roundTwoShots[_i].stats.score = 2;
	            vm.roundTwoScore += 2;
	          } else if (shotOneScore && shotTwoScore) {
	            vm.roundOneShots[_i].stats.score = 1;
	            vm.roundOneScore++;
	            vm.roundTwoShots[_i].stats.score = 1;
	            vm.roundTwoScore++;
	          }
	        }
	      } else {
	        /* COMPOUND SCORING */
	        /* iF shoot off */
	        if (_i === vm.maxShots) {
	          if (vm.roundOneFinalShot && vm.roundTwoFinalShot) {
	            vm.roundOneScore += shotOneScore;
	            vm.roundTwoScore += shotTwoScore;
	          }
	        } else {
	          vm.roundOneScore += shotOneScore;
	          vm.roundOneShots[_i].stats.score = vm.roundOneScore;
	          vm.roundTwoScore += shotTwoScore;
	          vm.roundTwoShots[_i].stats.score = vm.roundTwoScore;
	        }
	      }
	    }
	  };
	  vm.forfeited = function (player) {
	    MatchesFactory.forfeitElimination(vm.activeEliminationMatch.olympic_match_id, MatchesFactory.MATCH_ELIMINATION_TYPES.INDIVIDUAL, player.player_id).then(function (response) {
	      reloadLeagueEliminationMatches();
	    });
	  };
	
	  function reloadLeagueEliminationMatches() {
	    var reloadActiveMatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    var data = {
	      include: "matchOlympicIndividual",
	      league_id: vm.activeLeague.league_id,
	      round: vm.activeRound
	    };
	    vm.eliminationMatches = [];
	    MatchesFactory.getOne(vm.rootScope.currentMatchId, data).then(function (response) {
	      vm.eliminationMatches = response.data.matchOlympicIndividual;
	      if (vm.activeEliminationMatch && reloadActiveMatch) {
	        var activeEliminationMatchId = vm.activeEliminationMatch.olympic_match_id;
	        vm.activeEliminationMatch = null;
	        vm.selectEliminationMatch(activeEliminationMatchId);
	      }
	    });
	  }
	};
	MatchAddShotsIndividualController.$inject = ["MatchesFactory", "LeaguesFactory", "$rootScope", "$filter", "$state"];
	
	exports.default = MatchAddShotsIndividualController;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(668);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchAddShotsIndividual.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchAddShotsIndividual.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 668 */
626,
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchShotsIndividualVisual = __webpack_require__(670);
	
	var _matchShotsIndividualVisual2 = _interopRequireDefault(_matchShotsIndividualVisual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchShotsIndividualVisualModule = _angular2.default.module("matchShotsIndividualVisual", [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("match-profile.shotsIndividualVisual", {
	    url: "/shotsIndividualVisual/:matchId/:leagueId/:olympicMatchId",
	    component: "matchShotsIndividualVisual",
	    data: { pageTitle: "ADD_SHOTS_INDIVIDUAL" },
	    params: {
	      matchId: { squash: true, value: null },
	      olympicMatchId: { squash: true, value: null },
	      leagueId: { squash: true, value: null }
	    },
	    resolve: {
	      hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
	        "ngInject";
	
	        var deferred = $q.defer();
	        //   if (
	        //     $rootScope.user.canDo(
	        //       Permissions.ADD_SCORE_TO_MATCH_ELIMINATION_ROUNDS
	        //     )
	        //   ) {
	        deferred.resolve();
	        //   } else {
	        //     deferred.reject("Access Denied!!");
	        //   }
	        return deferred.promise;
	      }]
	    }
	  });
	}]).component("matchShotsIndividualVisual", _matchShotsIndividualVisual2.default).name;
	
	exports.default = matchShotsIndividualVisualModule;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchShotsIndividualVisual = __webpack_require__(671);
	
	var _matchShotsIndividualVisual2 = _interopRequireDefault(_matchShotsIndividualVisual);
	
	var _matchShotsIndividualVisual3 = __webpack_require__(672);
	
	var _matchShotsIndividualVisual4 = _interopRequireDefault(_matchShotsIndividualVisual3);
	
	__webpack_require__(678);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchShotsIndividualVisualComponent = {
	  bindings: {},
	  template: _matchShotsIndividualVisual2.default,
	  controller: _matchShotsIndividualVisual4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchShotsIndividualVisualComponent;

/***/ }),
/* 671 */
/***/ (function(module, exports) {

	module.exports = "<div ng-attr-id=\"vm.activeEliminationMatch.olympic_match_id\">\n  <div\n    ng-if=\"vm.rootScope.isSAAF\"\n    style=\"\n      /* position: fixed; */\n      /* top: 0; */\n      width: 100%;\n      z-index: 1;\n      display: flex;\n      justify-content: space-between;\n      padding-left: 20px;\n      padding-right: 20px;\n      align-items: center;\n      background: white;\n      color: #000000;\n      font-size: 36px;\n      padding-top: 10px;\n      padding-bottom: 10px;\n      box-shadow: 0px -15px 10px -15px #111;\n    \"\n  >\n    <img height=\"80\" src=\"assets/images/elite_logo.png\" />\n    <div ng-bind=\"vm.activeMatch.match_name\"></div>\n    <img height=\"80\" src=\"assets/images/saaf.png\" />\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <div class=\"row text-center p-t-1\">\n        <h4\n          class=\"_300 ng-binding\"\n          ng-bind=\"vm.activeEliminationMatch.leagueName\"\n        ></h4>\n      </div>\n      <div class=\"box\" ng-if=\"vm.activeEliminationMatch\">\n        <form name=\"addShotsForm\" ng-submit=\"vm.addShots()\">\n          <div class=\"box-body\">\n            <div class=\"row m-b-2\">\n              <div class=\"col-sm-6\">\n                <div\n                  style=\"\n                    display: flex;\n                    flex-direction: column;\n                    justify-content: center;\n                    align-items: center;\n                    text-align: center;\n                  \"\n                >\n                  <img\n                    height=\"100\"\n                    width=\"100\"\n                    style=\"border-radius: 75px\"\n                    ng-src=\"{{vm.getPlayerImage(vm.activeEliminationMatch.playerOne.img)}}\"\n                  />\n                  <div style=\"font-size: 30px; text-align: center\">\n                    <span\n                      ng-if=\"vm.playerOneTarget()\"\n                      style=\"\n                        font-size: 40px;\n                        font-weight: bold;\n                        text-align: center;\n                        padding-left: 10px;\n                        color: red;\n                        border: 1px solid rgba(136, 140, 145, 0.68);\n                      \"\n                      >{{vm.playerOneTarget()}}\n                    </span>\n                    {{vm.activeEliminationMatch.playerOne.playerName}}\n                    <div style=\"font-size: 20px\">\n                      {{vm.activeEliminationMatch.playerOne.teamName}}\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"col-sm-6\">\n                <div\n                  style=\"\n                    display: flex;\n                    flex-direction: column;\n                    justify-content: center;\n                    align-items: center;\n                    text-align: center;\n                  \"\n                >\n                  <img\n                    height=\"100\"\n                    width=\"100\"\n                    style=\"border-radius: 75px\"\n                    ng-src=\"{{vm.getPlayerImage(vm.activeEliminationMatch.playerTwo.img)}}\"\n                  />\n                  <div style=\"font-size: 30px; text-align: center\">\n                    <span\n                      ng-if=\"vm.playerTwoTarget()\"\n                      style=\"\n                        font-size: 40px;\n                        font-weight: bold;\n                        text-align: center;\n                        padding-left: 10px;\n                        color: red;\n                        border: 1px solid rgba(136, 140, 145, 0.68);\n                      \"\n                      >{{vm.playerTwoTarget()}}\n                    </span>\n                    {{vm.activeEliminationMatch.playerTwo.playerName}}\n                    <div style=\"font-size: 20px\">\n                      {{vm.activeEliminationMatch.playerTwo.teamName}}\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group m-b-0\">\n              <div class=\"row row-sm m-b-sm\">\n                <div\n                  class=\"{{header.class}} text-center\"\n                  ng-repeat=\"header in vm.shotsHeaders\"\n                >\n                  <span\n                    translate\n                    class=\"fina-scores-row-label text-center\"\n                    ng-bind=\"header.name\"\n                  ></span>\n                </div>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div class=\"form-group col-xs-6\">\n                <div\n                  class=\"row m-b-sm\"\n                  ng-repeat=\"(shotNo,shot) in vm.roundOneShots\"\n                >\n                  <div class=\"col-xs-2 text-center\">\n                    <span class=\"label label-lg shot-label visual-shot-label\"\n                      >{{shotNo}}</span\n                    >\n                  </div>\n                  <div\n                    class=\"col-xs-2 text-center\"\n                    style=\"font-size: 30px\"\n                    ng-repeat=\"(arrowNo, arrow) in shot.arrows\"\n                  >\n                    <span class=\"label label-lg shot-label visual-shot-label\">\n                      {{vm.roundOneShots[shotNo].arrows[arrowNo]}}\n                    </span>\n                  </div>\n                  <div\n                    class=\"col-xs-2 text-center\"\n                    ng-repeat=\"stat in shot.stats\"\n                  >\n                    <span class=\"label label-lg shot-label visual-shot-label\">\n                      {{stat}}\n                    </span>\n                  </div>\n                </div>\n                <div class=\"row m-b-sm\">\n                  <div class=\"col-xs-4\">\n                    <span\n                      class=\"label label-lg shot-label\"\n                      style=\"font-size: 25px !important\"\n                      translate\n                      >FINAL_SHOT</span\n                    >\n                  </div>\n                  <div class=\"col-xs-2\">\n                    <span class=\"label label-lg shot-label visual-shot-label\">\n                      {{vm.roundOneFinalShot}}\n                    </span>\n                  </div>\n                  <div class=\"col-xs-2\">\n                    <span class=\"label label-lg shot-label visual-shot-label\">\n                      {{vm.roundOneFinalShotTwo}}\n                    </span>\n                  </div>\n                </div>\n              </div>\n              <div class=\"form-group col-xs-6\">\n                <div\n                  class=\"row m-b-sm\"\n                  ng-repeat=\"(shotNo,shot) in vm.roundTwoShots\"\n                >\n                  <div class=\"col-xs-2 text-center\">\n                    <span class=\"label label-lg shot-label visual-shot-label\"\n                      >{{shotNo}}</span\n                    >\n                  </div>\n                  <div\n                    class=\"col-xs-2\"\n                    ng-repeat=\"(arrowNo, arrow) in shot.arrows\"\n                  >\n                    <span class=\"label label-lg shot-label visual-shot-label\">\n                      {{vm.roundTwoShots[shotNo].arrows[arrowNo]}}\n                    </span>\n                  </div>\n                  <div class=\"col-xs-2\" ng-repeat=\"stat in shot.stats\">\n                    <span class=\"label label-lg shot-label visual-shot-label\">\n                      {{stat}}\n                    </span>\n                  </div>\n                </div>\n                <div class=\"row m-b-sm\">\n                  <div class=\"col-xs-4\">\n                    <span\n                      class=\"label label-lg shot-label\"\n                      style=\"font-size: 25px !important\"\n                      translate\n                      >FINAL_SHOT</span\n                    >\n                  </div>\n                  <div class=\"col-xs-2\">\n                    <span class=\"label label-lg shot-label visual-shot-label\">\n                      {{vm.roundTwoFinalShot}}\n                    </span>\n                  </div>\n                  <div class=\"col-xs-2\">\n                    <span class=\"label label-lg shot-label visual-shot-label\">\n                      {{vm.roundTwoFinalShotTwo}}\n                    </span>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"row row-sm\">\n              <div class=\"col-xs-4\">\n                <span\n                  translate\n                  class=\"fina-scores-row-label text-center\"\n                  style=\"font-size: 30px !important\"\n                  >FINAl_SCORES_ROW</span\n                >\n              </div>\n              <div class=\"col-xs-1\">\n                <span class=\"label label-lg shot-label visual-shot-label\">\n                  {{vm.roundOneScore}}\n                </span>\n              </div>\n              <div\n                class=\"col-xs-1\"\n                ng-if=\"vm.activeEliminationMatch.winnerPlayer.player_id === vm.activeEliminationMatch.playerOne.player_id\"\n              >\n                <i class=\"fa fa-check-circle shot-check-icon\"></i>\n              </div>\n              <div class=\"col-xs-1\"></div>\n              <div class=\"col-xs-4\">\n                <span\n                  translate\n                  class=\"fina-scores-row-label text-center\"\n                  style=\"font-size: 30px !important\"\n                  >FINAl_SCORES_ROW</span\n                >\n              </div>\n              <div class=\"col-xs-1\">\n                <span class=\"label label-lg shot-label visual-shot-label\">\n                  {{vm.roundTwoScore}}\n                </span>\n              </div>\n              <div\n                class=\"col-xs-1\"\n                ng-if=\"vm.activeEliminationMatch.winnerPlayer.player_id === vm.activeEliminationMatch.playerTwo.player_id\"\n              >\n                <i class=\"fa fa-check-circle shot-check-icon\" style=\"\"></i>\n              </div>\n            </div>\n          </div>\n        </form>\n      </div>\n    </div>\n  </div>\n  <div ng-if=\"vm.rootScope.isSAAF\" style=\"width: 100%; z-index: 1\">\n    <img style=\"width: 100%; height: auto\" src=\"assets/images/sponsors5.png\" />\n  </div>\n</div>\n"

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(449);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _toConsumableArray2 = __webpack_require__(673);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _asyncToGenerator2 = __webpack_require__(452);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchShotsIndividualVisualController = function MatchShotsIndividualVisualController(MatchesFactory, LeaguesFactory, $rootScope, $filter, $state, $stateParams, URLS, $window, $timeout, $scope) {
	  "ngInject";
	
	  var _this = this;
	
	  (0, _classCallCheck3.default)(this, MatchShotsIndividualVisualController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	  vm.$onInit = function () {
	    if ($stateParams.matchId) {
	      vm.matchId = parseInt($stateParams.matchId);
	    }
	    if ($stateParams.olympicMatchId) {
	      vm.olympicMatchId = parseInt($stateParams.olympicMatchId);
	    }
	    if ($stateParams.leagueId) {
	      vm.leagueId = parseInt($stateParams.leagueId);
	    }
	    $state.current.data.hideSidebar = true;
	    $state.current.data.hideMatchProfile = true;
	    $state.current.data.hideMatchMenu = true;
	    vm.leagues = [];
	    vm.matchLeagues = [];
	    vm.activeLeague = null;
	    vm.roundsTemplate = ["1/32", "1/16", "1/8", "1/4", "1/2", "1/1"];
	    vm.rounds = [];
	    vm.activeRound = null;
	
	    vm.activeEliminationMatches = [];
	    vm.activeEliminationMatch = null;
	    vm.roundOneShots = {};
	    vm.roundTwoShots = {};
	    vm.shotsHeaders = [{ name: "#", class: "col-xs-1" }, { name: "1ο", class: "col-xs-1" }, { name: "2ο", class: "col-xs-1" }, { name: "3ο", class: "col-xs-1" }, { name: "Shot", class: "col-xs-1" }, { name: "Score", class: "col-xs-1" }, { name: "#", class: "col-xs-1" }, { name: "1ο", class: "col-xs-1" }, { name: "2ο", class: "col-xs-1" }, { name: "3ο", class: "col-xs-1" }, { name: "Shot", class: "col-xs-1" }, { name: "Score", class: "col-xs-1" }];
	    vm.maxShots = 6;
	    reloadLeagueEliminationMatch();
	    if (vm.olympicMatchId) {
	      setInterval(function () {
	        reloadLeagueEliminationMatch();
	      }, 3000);
	    }
	  };
	
	  vm.getPlayerImage = function (img) {
	    if (img) {
	      return URLS.IMAGES_URL + "/players/" + img;
	    } else {
	      return "assets/images/no_avatar.png";
	    }
	  };
	
	  vm.isLeagueCompound = function () {
	    return vm.activeEliminationMatch.leagueType === LeaguesFactory.LEAGUE_TYPES.COMPOUND;
	  };
	
	  vm.isLeagueRecurve = function () {
	    return vm.activeEliminationMatch.leagueType === LeaguesFactory.LEAGUE_TYPES.RECURVE;
	  };
	
	  vm.isLeagueField = function () {
	    return vm.activeEliminationMatch.leagueType === LeaguesFactory.LEAGUE_TYPES.FIELD;
	  };
	
	  vm.selectEliminationMatch = function (olympicMatchId) {
	    vm.activeEliminationMatch = vm.eliminationMatches.find(function (el) {
	      return el.olympic_match_id === olympicMatchId;
	    });
	    vm.reUpdateAfterEliminationMatchChange();
	  };
	
	  vm.reUpdateAfterEliminationMatchChange = function () {
	    vm.roundOneShots = {};
	    vm.roundTwoShots = {};
	    vm.roundOneFinalShot = null;
	    vm.roundTwoFinalShot = null;
	    vm.roundOneFinalShotTwo = null;
	    vm.roundTwoFinalShotTwo = null;
	    vm.roundOneCloseToCenter = null;
	    vm.roundTwoCloseToCenter = null;
	    vm.activeRoundOne = vm.activeEliminationMatch.rounds[0];
	    vm.activeRoundTwo = vm.activeEliminationMatch.rounds[1];
	    if (vm.isLeagueCompound()) {
	      if (vm.activeRoundOne.points === "bye" || vm.activeRoundTwo.points === "bye") {
	        vm.activeRoundOne.displayScore = vm.activeRoundOne.points;
	        vm.activeRoundTwo.displayScore = vm.activeRoundTwo.points;
	      } else {
	        vm.activeRoundOne.displayScore = parseInt(vm.activeRoundOne.points);
	        vm.activeRoundTwo.displayScore = parseInt(vm.activeRoundTwo.points);
	        if (vm.activeRoundOne.arrow_f) {
	          vm.activeRoundOne.displayScore += parseInt(vm.activeRoundOne.arrow_f);
	        }
	        if (vm.activeRoundTwo.arrow_f) {
	          vm.activeRoundTwo.displayScore += parseInt(vm.activeRoundTwo.arrow_f);
	        }
	      }
	    } else {
	      vm.activeRoundOne.displayScore = vm.activeRoundOne.points;
	      vm.activeRoundTwo.displayScore = vm.activeRoundTwo.points;
	    }
	    for (var i = 1; i < vm.maxShots; i++) {
	      vm.roundOneShots[i] = {
	        arrows: {
	          1: vm.activeRoundOne["arrow_" + i + "_1"],
	          2: vm.activeRoundOne["arrow_" + i + "_2"],
	          3: vm.activeRoundOne["arrow_" + i + "_3"]
	        },
	        stats: {
	          endScore: 0,
	          score: 0
	        }
	      };
	      vm.roundTwoShots[i] = {
	        arrows: {
	          1: vm.activeRoundTwo["arrow_" + i + "_1"],
	          2: vm.activeRoundTwo["arrow_" + i + "_2"],
	          3: vm.activeRoundTwo["arrow_" + i + "_3"]
	        },
	        stats: {
	          endScore: 0,
	          score: 0
	        }
	      };
	    }
	    vm.roundOneFinalShot = vm.activeRoundOne["arrow_f"];
	    vm.roundTwoFinalShot = vm.activeRoundTwo["arrow_f"];
	    vm.roundOneFinalShotTwo = vm.activeRoundOne["arrow_f_2"];
	    vm.roundTwoFinalShotTwo = vm.activeRoundTwo["arrow_f_2"];
	    vm.roundOneCloseToCenter = vm.activeRoundOne["closer_to_center"] === 1;
	    vm.roundTwoCloseToCenter = vm.activeRoundTwo["closer_to_center"] === 1;
	    vm.calculateArrows();
	  };
	
	  vm.calculateArrows = function () {
	    vm.roundOneScore = 0;
	    vm.roundTwoScore = 0;
	    for (var i = 1; i < 4; i++) {
	      vm.roundOneShots[i].stats.score = 0;
	      vm.roundTwoShots[i].stats.score = 0;
	    }
	    for (var _i = 1; _i <= vm.maxShots; _i++) {
	      var shotOneScore = 0;
	      var shotTwoScore = 0;
	      if (_i === vm.maxShots) {
	        shotOneScore = parseInt(vm.roundOneFinalShot);
	        shotTwoScore = parseInt(vm.roundTwoFinalShot);
	      } else {
	        for (var j = 1; j < 4; j++) {
	          if (!vm.roundOneShots[_i].arrows[j]) {
	            continue;
	          }
	
	          /* Round One */
	          if (vm.roundOneShots[_i].arrows[j] == 0) {
	            vm.roundOneShots[_i].arrows[j] = "m";
	          }
	          if (vm.roundOneShots[_i].arrows[j].toLowerCase() !== "m") {
	            shotOneScore = shotOneScore + parseInt(vm.roundOneShots[_i].arrows[j]);
	          }
	          /* Round Two */
	          if (!vm.roundTwoShots[_i].arrows[j]) {
	            continue;
	          }
	          if (vm.roundTwoShots[_i].arrows[j] == 0) {
	            vm.roundTwoShots[_i].arrows[j] = "m";
	          }
	          if (vm.roundTwoShots[_i].arrows[j].toLowerCase() !== "m") {
	            shotTwoScore = shotTwoScore + parseInt(vm.roundTwoShots[_i].arrows[j]);
	          }
	        }
	        vm.roundOneShots[_i].stats.endScore = shotOneScore;
	        vm.roundTwoShots[_i].stats.endScore = shotTwoScore;
	        if (!vm.roundOneShots[_i].arrows[3]) {
	          continue;
	        }
	        if (!vm.roundTwoShots[_i].arrows[3]) {
	          continue;
	        }
	      }
	      /* RECURVE SCORING */
	      if (vm.isLeagueRecurve() || vm.isLeagueField()) {
	        // if(vm.activeLeague.type === LeaguesFactory.LEAGUE_TYPES.RECURVE){
	        /* iF shoot off */
	        if (_i === vm.maxShots) {
	          if (vm.roundOneFinalShot && vm.roundTwoFinalShot) {
	            if (shotOneScore > shotTwoScore) {
	              vm.roundOneScore += 2;
	            } else if (shotOneScore < shotTwoScore) {
	              vm.roundTwoScore += 2;
	            }
	          }
	        } else {
	          if (shotOneScore > shotTwoScore) {
	            vm.roundOneShots[_i].stats.score = 2;
	            vm.roundOneScore += 2;
	          } else if (shotOneScore < shotTwoScore) {
	            vm.roundTwoShots[_i].stats.score = 2;
	            vm.roundTwoScore += 2;
	          } else if (shotOneScore && shotTwoScore) {
	            vm.roundOneShots[_i].stats.score = 1;
	            vm.roundOneScore++;
	            vm.roundTwoShots[_i].stats.score = 1;
	            vm.roundTwoScore++;
	          }
	        }
	      } else {
	        /* COMPOUND SCORING */
	        /* iF shoot off */
	        if (_i === vm.maxShots) {
	          if (vm.roundOneFinalShot && vm.roundTwoFinalShot) {
	            vm.roundOneScore += shotOneScore;
	            vm.roundTwoScore += shotTwoScore;
	          }
	        } else {
	          vm.roundOneScore += shotOneScore;
	          vm.roundOneShots[_i].stats.score = vm.roundOneScore;
	          vm.roundTwoScore += shotTwoScore;
	          vm.roundTwoShots[_i].stats.score = vm.roundTwoScore;
	        }
	      }
	    }
	  };
	
	  vm.selectEliminationMatchAndRemove = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	    var eliminationMatchId, activeEliminationMatchResponse;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            if (!(vm.eliminationMatches.length > 0)) {
	              _context.next = 9;
	              break;
	            }
	
	            eliminationMatchId = vm.eliminationMatches[0].olympic_match_id;
	            _context.next = 4;
	            return MatchesFactory.getOne(vm.matchId, {
	              include: "matchOlympicIndividual,matchLeagues",
	              league_id: vm.leagueId,
	              olympic_match_id: eliminationMatchId
	            }, true);
	
	          case 4:
	            activeEliminationMatchResponse = _context.sent;
	
	
	            $scope.$apply(function () {
	              vm.activeEliminationMatch = activeEliminationMatchResponse.data.matchOlympicIndividual.find(function (m) {
	                return m.olympic_match_id === eliminationMatchId;
	              });
	              vm.reUpdateAfterEliminationMatchChange();
	              vm.eliminationMatches = [].concat((0, _toConsumableArray3.default)(vm.eliminationMatches.slice(1)));
	            });
	
	            $timeout(function () {
	              vm.selectEliminationMatchAndRemove();
	            }, 10000);
	            _context.next = 10;
	            break;
	
	          case 9:
	            $window.location.reload();
	
	          case 10:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, _this);
	  }));
	
	  vm.playerOneTarget = function () {
	    var target = "";
	    if (vm.activeEliminationMatch) {
	      var round = vm.activeEliminationMatch.rounds.find(function (r) {
	        return r.player_id === vm.activeEliminationMatch.playerOne.player_id;
	      });
	      if (round) {
	        return round.target_name;
	      }
	    }
	    return target;
	  };
	
	  vm.playerTwoTarget = function () {
	    var target = "";
	    if (vm.activeEliminationMatch) {
	      var round = vm.activeEliminationMatch.rounds.find(function (r) {
	        return r.player_id === vm.activeEliminationMatch.playerTwo.player_id;
	      });
	      if (round) {
	        return round.target_name;
	      }
	    }
	    return target;
	  };
	
	  function reloadLeagueEliminationMatch() {
	    var data = {
	      include: "matchOlympicIndividual,matchLeagues"
	    };
	    if (!!vm.leagueId) {
	      data.league_id = vm.leagueId;
	    }
	    if (!!vm.olympicMatchId) {
	      data.olympic_match_id = vm.olympicMatchId;
	    }
	    vm.eliminationMatches = [];
	    MatchesFactory.getOne(vm.matchId, data, true).then(function (response) {
	      vm.activeMatch = response.data;
	      vm.eliminationMatches = [].concat((0, _toConsumableArray3.default)(response.data.matchOlympicIndividual));
	      vm.matchLeagues = [].concat((0, _toConsumableArray3.default)(response.data.matchLeagues));
	      if (vm.olympicMatchId) {
	        vm.selectEliminationMatch(vm.olympicMatchId);
	      } else {
	        vm.eliminationMatches = [];
	        vm.matchLeagues.map(function (league) {
	          if (!!league.currentIndividualRound) {
	            vm.eliminationMatches = [].concat((0, _toConsumableArray3.default)(vm.eliminationMatches), (0, _toConsumableArray3.default)(response.data.matchOlympicIndividual.filter(function (m) {
	              return m.round === league.currentIndividualRound && m.league_id === league.league_id && m.player_1_score !== "bye" && m.player_2_score !== "bye";
	            })));
	          }
	        });
	        vm.selectEliminationMatchAndRemove();
	      }
	    });
	  }
	};
	MatchShotsIndividualVisualController.$inject = ["MatchesFactory", "LeaguesFactory", "$rootScope", "$filter", "$state", "$stateParams", "URLS", "$window", "$timeout", "$scope"];
	
	exports.default = MatchShotsIndividualVisualController;

/***/ }),
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(679);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchShotsIndividualVisual.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchShotsIndividualVisual.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 679 */
626,
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchAddShotsTeam = __webpack_require__(681);
	
	var _matchAddShotsTeam2 = _interopRequireDefault(_matchAddShotsTeam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchAddShotsTeamModule = _angular2.default.module('matchAddShotsTeam', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('match-profile.addShotsTeam', {
			url: '/addShotsTeam',
			component: 'matchAddShotsTeam',
			data: { pageTitle: 'ADD_SHOTS_TEAM' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.ADD_SCORE_TO_MATCH_ELIMINATION_ROUNDS)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('matchAddShotsTeam', _matchAddShotsTeam2.default).name;
	
	exports.default = matchAddShotsTeamModule;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchAddShotsTeam = __webpack_require__(682);
	
	var _matchAddShotsTeam2 = _interopRequireDefault(_matchAddShotsTeam);
	
	var _matchAddShotsTeam3 = __webpack_require__(683);
	
	var _matchAddShotsTeam4 = _interopRequireDefault(_matchAddShotsTeam3);
	
	__webpack_require__(684);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchAddShotsTeamComponent = {
	  bindings: {},
	  template: _matchAddShotsTeam2.default,
	  controller: _matchAddShotsTeam4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchAddShotsTeamComponent;

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-10\">\n        <div class=\"row row-sm\" ng-if=\"vm.eliminationMatches && !vm.activeEliminationMatch\">\n            <div class=\"col-xs-12\" ng-if=\"vm.rounds.length > 0\">\n                <div class=\"b-b m-b-1 text-center\">\n                    <h4 class=\"_300 ng-binding\" ng-bind=\"vm.activeLeague.league_name\"></h4>\n                    <div class=\"col-xs-2 list-item box r m-b cursor-pointer\"\n                         ng-repeat=\"round in vm.rounds\"\n                         ng-class=\"{'list-item-active' : vm.activeRound == round}\"\n                         ng-click=\"vm.selectRound(round)\">\n                        <span class=\"w-40 circle info avatar\"\n                              ng-class=\"{'opacity-05' : vm.activeRound != round}\">\n                            {{round}}\n                        </span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-xs-12 cursor-pointer\"\n                 ng-repeat=\"eliminationMatch in vm.eliminationMatches\"\n                 ng-click=\"vm.selectEliminationMatch(eliminationMatch.olympic_match_team_id);\">\n                <div class=\"col-xs-6 list-item box r m-b cursor-pointer\">\n                    <a class=\"list-left\">\n                        <span class=\"w-40 circle green\"\n                              ng-if=\"eliminationMatch.winner === eliminationMatch.teamOne.team.team_id\"\n                              ng-bind=\"eliminationMatch.winner_score\"></span>\n                        <span class=\"w-40 circle red\"\n                              ng-if=\"eliminationMatch.winner === eliminationMatch.teamTwo.team.team_id\"\n                              ng-bind=\"eliminationMatch.loser_score\"></span>\n                        <span class=\"w-40 circle white border-b-1\"\n                              ng-if=\"!eliminationMatch.winner\"\n                              ng-bind=\"eliminationMatch.team_1_score\"></span>\n                    </a>\n                    <div class=\"list-body\" ng-if=\"eliminationMatch.teamOne.team\">\n                        <div class=\"\"><a ng-bind=\"eliminationMatch.teamOne.team.teamName\"></a></div>\n                    </div>\n                </div>\n                <div class=\"col-xs-6 list-item box r m-b\">\n                    <a class=\"list-left\">\n                        <span class=\"w-40 circle green\"\n                              ng-if=\"eliminationMatch.winner === eliminationMatch.teamTwo.team.team_id\"\n                              ng-bind=\"eliminationMatch.winner_score\"></span>\n                        <span class=\"w-40 circle red\"\n                              ng-if=\"eliminationMatch.winner === eliminationMatch.teamOne.team.team_id\"\n                              ng-bind=\"eliminationMatch.loser_score\"></span>\n                        <span class=\"w-40 circle white border-b-1\"\n                              ng-if=\"!eliminationMatch.winner\"\n                              ng-bind=\"eliminationMatch.team_2_score\"></span>\n                    </a>\n                    <div class=\"list-body\" ng-if=\"eliminationMatch.teamTwo.team\">\n                        <div class=\"\"><a ng-bind=\"eliminationMatch.teamTwo.team.teamName\"></a></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"box\" ng-if=\"vm.activeEliminationMatch\">\n            <div class=\"box-tool\">\n                <ul class=\"nav\">\n                    <li class=\"nav-item inline\" ng-click=\"vm.activeEliminationMatch = null;\">\n                        <a class=\"nav-link\"><i class=\"fa fa-close md-18\"></i></a>\n                    </li>\n                </ul>\n            </div>\n            <form name=\"addShotsForm\" ng-submit=\"vm.addShots()\">\n                <div class=\"box-body\">\n                    <div class=\"b-b m-b-1 text-center\">\n                        <h3 class=\"_300 ng-binding\">\n                            {{vm.activeEliminationMatch.teamOne.team.teamName}} -\n                            {{vm.activeEliminationMatch.teamTwo.team.teamName}}\n                        </h3>\n                    </div>\n                    <div class=\"row playersBoxDivContainer\">\n                        <div class=\"col-sm-5 playersBoxDiv\">\n                            {{vm.activeEliminationMatch.teamOne.playerOne.playerName}} <br/>\n                            {{vm.activeEliminationMatch.teamOne.playerTwo.playerName}} <br/>\n                            {{vm.activeEliminationMatch.teamOne.playerThree.playerName}}\n                        </div>\n                        <div class=\"col-sm-2\"></div>\n                        <div class=\"col-sm-5 playersBoxDiv\">\n                            {{vm.activeEliminationMatch.teamTwo.playerOne.playerName}} <br/>\n                            {{vm.activeEliminationMatch.teamTwo.playerTwo.playerName}} <br/>\n                            {{vm.activeEliminationMatch.teamTwo.playerThree.playerName}}\n                        </div>\n                    </div>\n                    <div class=\"form-group m-b-0\">\n                        <div class=\"row row-sm m-b-sm\">\n                            <div class=\"{{header.class}} text-center\" ng-repeat=\"header in vm.shotsHeaders\">\n                                <span translate class=\"fina-scores-row-label text-center\" ng-bind=\"header.name\"></span>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"form-group col-xs-6\">\n                            <div class=\"row m-b-sm\" ng-repeat=\"(shotNo,shot) in vm.roundOneShots\">\n                                <div class=\"col-xs-2\">\n                                    <span class=\"label label-lg shot-label\"\n                                          ng-if=\"shotNo != 9 && (shotNo % 2 !== 0)\">\n                                        {{(shotNo % 2 !== 0) ? (shotNo/2) + 0.5 : ''}}\n                                    </span>\n                                    <span class=\"label label-lg shot-label\"\n                                          translate\n                                          ng-if=\"shotNo == 9\">FINAL_SHOT</span>\n                                </div>\n                                <div class=\"col-xs-2\" ng-repeat=\"(arrowNo, arrow) in shot.arrows\">\n                                    <input type=\"text\"\n                                           shot-validator\n                                           ng-class=\"\"\n                                           class=\"shot-input form-control\"\n                                           ng-change=\"vm.calculateArrows()\"\n                                           ng-model=\"vm.roundOneShots[shotNo].arrows[arrowNo]\">\n                                </div>\n                                <div class=\"col-xs-2\" ng-repeat=\"stat in shot.stats\">\n                                    <input type=\"text\" disabled ng-model=\"stat\" class=\"shot-input form-control\">\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group col-xs-6\">\n                            <div class=\"row m-b-sm\" ng-repeat=\"(shotNo,shot) in vm.roundTwoShots\">\n                                <div class=\"col-xs-2\">\n                                    <span class=\"label label-lg shot-label\"\n                                          ng-if=\"shotNo != 9 && (shotNo % 2 !== 0)\">\n                                        {{(shotNo % 2 !== 0) ? (shotNo/2) + 0.5 : ''}}\n                                    </span>\n                                    <span class=\"label label-lg shot-label\"\n                                          translate\n                                          ng-if=\"shotNo == 9\">FINAL_SHOT</span>\n                                </div>\n                                <div class=\"col-xs-2\" ng-repeat=\"(arrowNo, arrow) in shot.arrows\">\n                                    <input type=\"text\"\n                                           shot-validator\n                                           ng-class=\"\"\n                                           class=\"shot-input form-control\"\n                                           ng-change=\"vm.calculateArrows()\"\n                                           ng-model=\"vm.roundTwoShots[shotNo].arrows[arrowNo]\">\n                                </div>\n                                <div class=\"col-xs-2\" ng-repeat=\"stat in shot.stats\">\n                                    <input type=\"text\" disabled ng-model=\"stat\" class=\"shot-input form-control\">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row row-sm\">\n                        <div class=\"col-xs-4\">\n                            <span translate class=\"fina-scores-row-label text-center\">FINAl_SCORES_ROW</span>\n                        </div>\n                        <div class=\"col-xs-1\">\n                            <input type=\"text\" disabled\n                                   ng-value=\"vm.roundOneScore\"\n                                   class=\"shot-input form-control\">\n                        </div>\n                        <div class=\"col-xs-1\"\n                             ng-if=\"vm.activeEliminationMatch.winnerTeam.team_id === vm.activeEliminationMatch.teamOne.team_id\">\n                            <i class=\"fa fa-check-circle shot-check-icon\" style=\"\"></i>\n                        </div>\n                        <div class=\"col-xs-1\"></div>\n                        <div class=\"col-xs-4\">\n                            <span translate class=\"fina-scores-row-label text-center\">FINAl_SCORES_ROW</span>\n                        </div>\n                        <div class=\"col-xs-1\">\n                            <input type=\"text\" disabled\n                                   ng-value=\"vm.roundTwoScore\"\n                                   class=\"shot-input form-control\">\n                        </div>\n                        <div class=\"col-xs-1\"\n                             ng-if=\"vm.activeEliminationMatch.winnerTeam.team_id === vm.activeEliminationMatch.teamTwo.team_id\">\n                            <i class=\"fa fa-check-circle shot-check-icon\" style=\"\"></i>\n                        </div>\n                    </div>\n                </div>\n                <footer class=\"dker p-a text-left\">\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn success p-x-md m-l-1\"\n                            ng-disabled=\"!addShotsForm.$valid\">SUBMIT\n                    </button>\n                    <button type=\"button\"\n                            translate\n                            ng-click=\"vm.clearRoundShots()\"\n                            class=\"btn danger p-x-md m-l-1 m-r-1\">CLEAR_ROUND\n                    </button>\n                </footer>\n            </form>\n        </div>\n    </div>\n    <div class=\"col-sm-2\">\n        <div class=\"box\">\n            <div class=\"box-header text-center\">\n                <h4 translate>SELECT_LEAGUE</h4>\n            </div>\n            <ul class=\"list no-border p-b\">\n                <li ng-repeat=\"league in vm.leagues\"\n                    ng-click=\"vm.selectLeague(league)\"\n                    ng-class=\"{'list-item-active' : vm.activeLeague == league}\"\n                    class=\"list-item div-hover-grey cursor-pointer\">\n                    <a class=\"list-left\">\n                        <span class=\"w-40 circle info avatar\"\n                              ng-class=\"{'opacity-05' : vm.activeLeague != league}\">\n                            {{league.currentTeamRound}}\n                        </span>\n                    </a>\n                    <div class=\"list-body\">\n                        <div><a>{{league.league_name}}</a></div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchAddShotsTeamController = function MatchAddShotsTeamController(MatchesFactory, LeaguesFactory, $rootScope, $filter, $state) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, MatchAddShotsTeamController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		vm.rootScope = $rootScope;
		vm.$onInit = function () {
			$state.current.data.hideSidebar = true;
			$state.current.data.hideMatchProfile = true;
			$state.current.data.hideMatchMenu = true;
			vm.leagues = [];
			vm.activeLeague = null;
			vm.roundsTemplate = ['1/32', '1/16', '1/8', '1/4', '1/2', '1/1'];
			vm.rounds = [];
			vm.activeRound = null;
			vm.activeEliminationMatches = [];
			vm.activeEliminationMatch = null;
			vm.roundOneShots = {};
			vm.roundTwoShots = {};
			vm.shotsHeaders = [{ name: '#', class: 'col-xs-1' }, { name: '1ο', class: 'col-xs-1' }, { name: '2ο', class: 'col-xs-1' }, { name: '3ο', class: 'col-xs-1' }, { name: 'Shot', class: 'col-xs-1' }, { name: 'Score', class: 'col-xs-1' }, { name: '#', class: 'col-xs-1' }, { name: '1ο', class: 'col-xs-1' }, { name: '2ο', class: 'col-xs-1' }, { name: '3ο', class: 'col-xs-1' }, { name: 'Shot', class: 'col-xs-1' }, { name: 'Score', class: 'col-xs-1' }];
			vm.maxShots = 10;
			vm.moveToNextTarget = false;
			/* Fetch Leagues with Team Matches */
			MatchesFactory.getOne(vm.rootScope.currentMatchId, { include: 'matchLeagues' }).then(function (response) {
				(0, _entries2.default)(response.data.matchLeagues).forEach(function (entry) {
					var value = entry[1];
					if (value.olympic_teams && value.olympic_teams > 0) {
						value.league.currentTeamRound = value.currentTeamRound;
						vm.leagues.push(value.league);
					}
				});
			});
		};
	
		vm.isLeagueCompound = function () {
			return vm.activeLeague.type === LeaguesFactory.LEAGUE_TYPES.COMPOUND;
		};
		vm.selectLeague = function (league) {
			vm.activeLeague = league;
			vm.rounds = [];
			vm.rounds = vm.roundsTemplate;
			vm.activeRound = league.currentTeamRound;
			vm.activeEliminationMatch = null;
			// let found = false;
			// for(let i = 0; i < vm.roundsTemplate; i++){
			// if(found || vm.roundsTemplate[i] === vm.activeLeague.currentTeamRound){
			// 	found = true;
			// 	vm.rounds.push(vm.roundsTemplate[i]);
			// }
			// }
			reloadLeagueEliminationMatches(false);
		};
		vm.selectRound = function (round) {
			vm.activeRound = round;
			reloadLeagueEliminationMatches();
		};
		vm.selectEliminationMatch = function (eliminationMatchId) {
			vm.activeEliminationMatch = vm.eliminationMatches.find(function (eliminationMatch) {
				return eliminationMatch.olympic_match_team_id === eliminationMatchId;
			});
			vm.roundOneShots = {};
			vm.roundTwoShots = {};
			vm.activeRoundOne = vm.activeEliminationMatch.rounds[0];
			vm.activeRoundTwo = vm.activeEliminationMatch.rounds[1];
			vm.activeRoundOne.displayScore = vm.activeRoundOne.points;
			vm.activeRoundTwo.displayScore = vm.activeRoundTwo.points;
			for (var i = 1; i < vm.maxShots; i++) {
				vm.roundOneShots[i] = {
					arrows: {
						1: vm.activeRoundOne['arrow_' + i + '_1'],
						2: vm.activeRoundOne['arrow_' + i + '_2'],
						3: vm.activeRoundOne['arrow_' + i + '_3']
					},
					stats: {
						endScore: 0,
						score: 0
					}
				};
				vm.roundTwoShots[i] = {
					arrows: {
						1: vm.activeRoundTwo['arrow_' + i + '_1'],
						2: vm.activeRoundTwo['arrow_' + i + '_2'],
						3: vm.activeRoundTwo['arrow_' + i + '_3']
					},
					stats: {
						endScore: 0,
						score: 0
					}
				};
			}
			vm.calculateArrows();
		};
		vm.addShots = function () {
			var roundOneShots = {};
			var roundTwoShots = {};
			for (var i = 1; i < vm.maxShots; i++) {
				roundOneShots[i] = vm.roundOneShots[i].arrows;
				roundTwoShots[i] = vm.roundTwoShots[i].arrows;
			}
			var roundOneId = vm.activeRoundOne.olympic_round_team_id;
			var roundTwoId = vm.activeRoundTwo.olympic_round_team_id;
			var rounds = [{
				roundId: roundOneId,
				shots: roundOneShots
			}, {
				roundId: roundTwoId,
				shots: roundTwoShots
			}];
			MatchesFactory.addShotsElimination(vm.activeEliminationMatch.olympic_match_team_id, MatchesFactory.MATCH_ELIMINATION_TYPES.TEAM, {
				rounds: rounds
			}).then(function (response) {
				reloadLeagueEliminationMatches();
			});
		};
		vm.clearRoundShots = function () {
			MatchesFactory.clearShotsElimination(vm.activeEliminationMatch.olympic_match_team_id, MatchesFactory.MATCH_ELIMINATION_TYPES.TEAM).then(function (response) {
				reloadLeagueEliminationMatches();
			});
		};
		vm.calculateArrows = function () {
			vm.roundOneScore = 0;
			vm.roundTwoScore = 0;
			for (var i = 1; i < vm.maxShots; i++) {
				if (i % 2 === 0) {
					vm.roundOneShots[i].stats.score = 0;
					vm.roundTwoShots[i].stats.score = 0;
				} else {
					delete vm.roundOneShots[i].stats.score;
					delete vm.roundTwoShots[i].stats.score;
				}
			}
			for (var _i = 1; _i < vm.maxShots; _i++) {
				var shotOneScore = 0;
				var shotTwoScore = 0;
				for (var j = 1; j < 7; j++) {
					if (!vm.roundOneShots[_i].arrows[j]) {
						continue;
					}
	
					/* Round One */
					if (vm.roundOneShots[_i].arrows[j] == 0) {
						vm.roundOneShots[_i].arrows[j] = 'm';
					}
					if (vm.roundOneShots[_i].arrows[j].toLowerCase() !== 'm') {
						shotOneScore = shotOneScore + parseInt(vm.roundOneShots[_i].arrows[j]);
					}
					/* Round Two */
					if (!vm.roundTwoShots[_i].arrows[j]) {
						continue;
					}
					if (vm.roundTwoShots[_i].arrows[j] == 0) {
						vm.roundTwoShots[_i].arrows[j] = 'm';
					}
					if (vm.roundTwoShots[_i].arrows[j].toLowerCase() !== 'm') {
						shotTwoScore = shotTwoScore + parseInt(vm.roundTwoShots[_i].arrows[j]);
					}
				}
				vm.roundOneShots[_i].stats.endScore = shotOneScore;
				vm.roundTwoShots[_i].stats.endScore = shotTwoScore;
				if (_i % 2 !== 0 && _i !== vm.maxShots - 1) {
					continue;
				}
				/* RECURVE SCORING */
				if (vm.activeLeague.type === LeaguesFactory.LEAGUE_TYPES.RECURVE) {
					/* If shoot off */
					if (_i === vm.maxShots - 1) {
						if (shotOneScore > shotTwoScore) {
							vm.roundOneShots[_i].stats.score = 2;
							vm.roundTwoShots[_i].stats.score = 0;
							vm.roundOneScore += 2;
						} else if (shotOneScore < shotTwoScore) {
							vm.roundTwoShots[_i].stats.score = 2;
							vm.roundOneShots[_i].stats.score = 0;
							vm.roundTwoScore += 2;
						}
					} else {
						if (shotOneScore + vm.roundOneShots[_i - 1].stats.endScore > shotTwoScore + vm.roundTwoShots[_i - 1].stats.endScore) {
							vm.roundOneShots[_i].stats.score = shotOneScore + vm.roundOneShots[_i - 1].stats.endScore + "/" + 2;
							vm.roundTwoShots[_i].stats.score = shotTwoScore + vm.roundTwoShots[_i - 1].stats.endScore + "/" + 0;
							vm.roundOneScore += 2;
						} else if (shotOneScore + vm.roundOneShots[_i - 1].stats.endScore < shotTwoScore + vm.roundTwoShots[_i - 1].stats.endScore) {
							vm.roundTwoShots[_i].stats.score = shotTwoScore + vm.roundTwoShots[_i - 1].stats.endScore + "/" + 2;
							vm.roundOneShots[_i].stats.score = shotOneScore + vm.roundOneShots[_i - 1].stats.endScore + "/" + 0;
							vm.roundTwoScore += 2;
						} else if (shotOneScore + vm.roundOneShots[_i - 1].stats.endScore && shotTwoScore + vm.roundTwoShots[_i - 1].stats.endScore) {
							vm.roundOneShots[_i].stats.score = shotOneScore + vm.roundOneShots[_i - 1].stats.endScore + "/" + 1;
							vm.roundOneScore++;
							vm.roundTwoShots[_i].stats.score = shotTwoScore + vm.roundTwoShots[_i - 1].stats.endScore + "/" + 1;
							vm.roundTwoScore++;
						}
					}
				} else {
					/* If shoot off */
					if (_i === vm.maxShots - 1) {
						vm.roundOneScore += shotOneScore;
						vm.roundOneShots[_i].stats.score = shotOneScore;
						vm.roundTwoScore += shotTwoScore;
						vm.roundTwoShots[_i].stats.score = shotTwoScore;
					} else {
						/* COMPOUND SCORING */
						vm.roundOneScore += shotOneScore;
						vm.roundOneScore += vm.roundOneShots[_i - 1].stats.endScore;
						var tempOneScore = shotOneScore + vm.roundOneShots[_i - 1].stats.endScore;
						vm.roundOneShots[_i].stats.score = tempOneScore + "/" + vm.roundOneScore;
						vm.roundTwoScore += shotTwoScore;
						vm.roundTwoScore += vm.roundTwoShots[_i - 1].stats.endScore;
						var tempTwoScore = shotTwoScore + vm.roundTwoShots[_i - 1].stats.endScore;
						vm.roundTwoShots[_i].stats.score = tempTwoScore + "/" + vm.roundTwoScore;
					}
				}
			}
		};
		function reloadLeagueEliminationMatches() {
			var reloadActiveMatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
			var data = {
				include: 'matchOlympicTeam',
				league_id: vm.activeLeague.league_id,
				round: vm.activeRound
			};
			vm.eliminationMatches = [];
			MatchesFactory.getOne(vm.rootScope.currentMatchId, data).then(function (response) {
				vm.eliminationMatches = response.data.matchOlympicTeam;
				if (vm.activeEliminationMatch && reloadActiveMatch) {
					var activeEliminationMatchId = vm.activeEliminationMatch.olympic_match_team_id;
					vm.activeEliminationMatch = null;
					vm.selectEliminationMatch(activeEliminationMatchId);
				}
			});
		}
	};
	MatchAddShotsTeamController.$inject = ["MatchesFactory", "LeaguesFactory", "$rootScope", "$filter", "$state"];
	
	exports.default = MatchAddShotsTeamController;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(685);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchAddShotsTeam.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchAddShotsTeam.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, ".playersBoxDivContainer{margin-bottom:25px}.playersBoxDiv{padding:5px;border:1px solid #8e8e8e;border-radius:3%;text-align:center}", ""]);
	
	// exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchAddShotsMixedTeam = __webpack_require__(687);
	
	var _matchAddShotsMixedTeam2 = _interopRequireDefault(_matchAddShotsMixedTeam);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchAddShotsMixedTeamModule = _angular2.default.module('matchAddShotsMixedTeam', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('match-profile.addShotsMixedTeam', {
			url: '/addShotsMixedTeam',
			component: 'matchAddShotsMixedTeam',
			data: { pageTitle: 'ADD_SHOTS_MIXED_TEAM' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.ADD_SCORE_TO_MATCH_ELIMINATION_ROUNDS)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('matchAddShotsMixedTeam', _matchAddShotsMixedTeam2.default).name;
	
	exports.default = matchAddShotsMixedTeamModule;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchAddShotsMixedTeam = __webpack_require__(688);
	
	var _matchAddShotsMixedTeam2 = _interopRequireDefault(_matchAddShotsMixedTeam);
	
	var _matchAddShotsMixedTeam3 = __webpack_require__(689);
	
	var _matchAddShotsMixedTeam4 = _interopRequireDefault(_matchAddShotsMixedTeam3);
	
	__webpack_require__(690);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchAddShotsMixedTeamComponent = {
	  bindings: {},
	  template: _matchAddShotsMixedTeam2.default,
	  controller: _matchAddShotsMixedTeam4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchAddShotsMixedTeamComponent;

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-10\">\n        <div class=\"row row-sm\" ng-if=\"vm.eliminationMatches && !vm.activeEliminationMatch\">\n            <div class=\"col-xs-12\" ng-if=\"vm.rounds.length > 0\">\n                <div class=\"b-b m-b-1 text-center\">\n                    <h4 class=\"_300 ng-binding\" ng-bind=\"vm.activeLeagueOne.league_name\"></h4>\n                    <div class=\"col-xs-2 list-item box r m-b cursor-pointer\"\n                         ng-repeat=\"round in vm.rounds\"\n                         ng-class=\"{'list-item-active' : vm.activeRound == round}\"\n                         ng-click=\"vm.selectRound(round)\">\n                        <span class=\"w-40 circle info avatar\"\n                              ng-class=\"{'opacity-05' : vm.activeRound != round}\">\n                            {{round}}\n                        </span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-xs-12 cursor-pointer\"\n                 ng-repeat=\"eliminationMatch in vm.eliminationMatches\"\n                 ng-click=\"vm.selectEliminationMatch(eliminationMatch.olympic_match_mixed_id);\">\n                <div class=\"col-xs-6 list-item box r m-b cursor-pointer\">\n                    <a class=\"list-left\">\n                        <span class=\"w-40 circle green\"\n                              ng-if=\"eliminationMatch.winner === eliminationMatch.teamOne.team.team_id\"\n                              ng-bind=\"eliminationMatch.winner_score\"></span>\n                        <span class=\"w-40 circle red\"\n                              ng-if=\"eliminationMatch.winner === eliminationMatch.teamTwo.team.team_id\"\n                              ng-bind=\"eliminationMatch.loser_score\"></span>\n                        <span class=\"w-40 circle white border-b-1\"\n                              ng-if=\"!eliminationMatch.winner\"\n                              ng-bind=\"eliminationMatch.team_1_score\"></span>\n                    </a>\n                    <div class=\"list-body\" ng-if=\"eliminationMatch.teamOne.team\">\n                        <div class=\"\"><a ng-bind=\"eliminationMatch.teamOne.team.teamName\"></a></div>\n                    </div>\n                </div>\n                <div class=\"col-xs-6 list-item box r m-b\">\n                    <a class=\"list-left\">\n                        <span class=\"w-40 circle green\"\n                              ng-if=\"eliminationMatch.winner === eliminationMatch.teamTwo.team.team_id\"\n                              ng-bind=\"eliminationMatch.winner_score\"></span>\n                        <span class=\"w-40 circle red\"\n                              ng-if=\"eliminationMatch.winner === eliminationMatch.teamOne.team.team_id\"\n                              ng-bind=\"eliminationMatch.loser_score\"></span>\n                        <span class=\"w-40 circle white border-b-1\"\n                              ng-if=\"!eliminationMatch.winner\"\n                              ng-bind=\"eliminationMatch.team_2_score\"></span>\n                    </a>\n                    <div class=\"list-body\" ng-if=\"eliminationMatch.teamTwo.team\">\n                        <div class=\"\"><a ng-bind=\"eliminationMatch.teamTwo.team.teamName\"></a></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"box\" ng-if=\"vm.activeEliminationMatch\">\n            <div class=\"box-tool\">\n                <ul class=\"nav\">\n                    <li class=\"nav-item inline\" ng-click=\"vm.activeEliminationMatch = null;\">\n                        <a class=\"nav-link\"><i class=\"fa fa-close md-18\"></i></a>\n                    </li>\n                </ul>\n            </div>\n            <form name=\"addShotsForm\" ng-submit=\"vm.addShots()\">\n                <div class=\"box-body\">\n                    <div class=\"b-b m-b-1 text-center\">\n                        <h3 class=\"_300 ng-binding\">\n                            {{vm.activeEliminationMatch.teamOne.team.teamName}} -\n                            {{vm.activeEliminationMatch.teamTwo.team.teamName}}\n                        </h3>\n                    </div>\n                    <div class=\"row playersBoxDivContainer\">\n                        <div class=\"col-sm-5 playersBoxDiv\">\n                            {{vm.activeEliminationMatch.teamOne.playerOne.playerName}} <br/>\n                            {{vm.activeEliminationMatch.teamOne.playerTwo.playerName}}\n                        </div>\n                        <div class=\"col-sm-2\"></div>\n                        <div class=\"col-sm-5 playersBoxDiv\">\n                            {{vm.activeEliminationMatch.teamTwo.playerOne.playerName}} <br/>\n                            {{vm.activeEliminationMatch.teamTwo.playerTwo.playerName}}\n                        </div>\n                    </div>\n                    <div class=\"form-group m-b-0\">\n                        <div class=\"row row-sm m-b-sm\">\n                            <div class=\"{{header.class}} text-center\" ng-repeat=\"header in vm.shotsHeaders\">\n                                <span translate class=\"fina-scores-row-label text-center\" ng-bind=\"header.name\"></span>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row\">\n                        <div class=\"form-group col-xs-6\">\n                            <div class=\"row m-b-sm\" ng-repeat=\"(shotNo,shot) in vm.roundOneShots\">\n                                <div class=\"col-xs-2\">\n                                    <span class=\"label label-lg shot-label\"\n                                          ng-bind=\"shotNo\"\n                                          ng-if=\"shotNo != 5\"></span>\n                                    <span class=\"label label-lg shot-label\"\n                                          translate\n                                          ng-if=\"shotNo == 5\">FINAL_SHOT</span>\n                                </div>\n                                <div class=\"col-xs-2\" ng-repeat=\"(arrowNo, arrow) in shot.arrows\">\n                                    <input type=\"text\"\n                                           shot-validator\n                                           ng-class=\"\"\n                                           class=\"shot-input form-control\"\n                                           ng-change=\"vm.calculateArrows()\"\n                                           ng-model=\"vm.roundOneShots[shotNo].arrows[arrowNo]\">\n                                </div>\n                                <div class=\"col-xs-2\" ng-repeat=\"stat in shot.stats\">\n                                    <input type=\"text\" disabled ng-model=\"stat\" class=\"shot-input form-control\">\n                                </div>\n                            </div>\n                        </div>\n                        <div class=\"form-group col-xs-6\">\n                            <div class=\"row m-b-sm\" ng-repeat=\"(shotNo,shot) in vm.roundTwoShots\">\n                                <div class=\"col-xs-2\">\n                                    <span class=\"label label-lg shot-label\"\n                                          ng-bind=\"shotNo\"\n                                          ng-if=\"shotNo != 5\"></span>\n                                    <span class=\"label label-lg shot-label\"\n                                          translate\n                                          ng-if=\"shotNo == 5\">FINAL_SHOT</span>\n                                </div>\n                                <div class=\"col-xs-2\" ng-repeat=\"(arrowNo, arrow) in shot.arrows\">\n                                    <input type=\"text\"\n                                           shot-validator\n                                           ng-class=\"\"\n                                           class=\"shot-input form-control\"\n                                           ng-change=\"vm.calculateArrows()\"\n                                           ng-model=\"vm.roundTwoShots[shotNo].arrows[arrowNo]\">\n                                </div>\n                                <div class=\"col-xs-2\" ng-repeat=\"stat in shot.stats\">\n                                    <input type=\"text\" disabled ng-model=\"stat\" class=\"shot-input form-control\">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"row row-sm\">\n                        <div class=\"col-xs-4\">\n                            <span translate class=\"fina-scores-row-label text-center\">FINAl_SCORES_ROW</span>\n                        </div>\n                        <div class=\"col-xs-1\">\n                            <input type=\"text\" disabled\n                                   ng-value=\"vm.activeRoundOne.displayScore\"\n                                   class=\"shot-input form-control\">\n                        </div>\n                        <div class=\"col-xs-1\"\n                             ng-if=\"vm.activeEliminationMatch.winnerTeam.team_id === vm.activeEliminationMatch.teamOne.team_id\">\n                            <i class=\"fa fa-check-circle shot-check-icon\" style=\"\"></i>\n                        </div>\n                        <div class=\"col-xs-1\"></div>\n                        <div class=\"col-xs-4\">\n                            <span translate class=\"fina-scores-row-label text-center\">FINAl_SCORES_ROW</span>\n                        </div>\n                        <div class=\"col-xs-1\">\n                            <input type=\"text\" disabled\n                                   ng-value=\"vm.activeRoundTwo.displayScore\"\n                                   class=\"shot-input form-control\">\n                        </div>\n                        <div class=\"col-xs-1\"\n                             ng-if=\"vm.activeEliminationMatch.winnerTeam.team_id === vm.activeEliminationMatch.teamTwo.team_id\">\n                            <i class=\"fa fa-check-circle shot-check-icon\" style=\"\"></i>\n                        </div>\n                    </div>\n                </div>\n                <footer class=\"dker p-a text-left\">\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn success p-x-md m-l-1\"\n                            ng-disabled=\"!addShotsForm.$valid\">SUBMIT\n                    </button>\n                    <button type=\"button\"\n                            translate\n                            ng-click=\"vm.clearRoundShots()\"\n                            class=\"btn danger p-x-md m-l-1 m-r-1\">CLEAR_ROUND\n                    </button>\n                </footer>\n            </form>\n        </div>\n    </div>\n    <div class=\"col-sm-2\">\n        <div class=\"box\">\n            <div class=\"box-header text-center\">\n                <h4 translate>SELECT_LEAGUE</h4>\n            </div>\n            <ul class=\"list no-border p-b\">\n                <li ng-repeat=\"league in vm.leagues\"\n                    ng-click=\"vm.selectLeague(league, league.mixed_league_id)\"\n                    ng-class=\"{'list-item-active' : vm.activeLeagueOne == league}\"\n                    class=\"list-item div-hover-grey cursor-pointer\">\n                    <a class=\"list-left\">\n                        <span class=\"w-40 circle info avatar\"\n                              ng-class=\"{'opacity-05' : vm.activeLeague != league}\">\n                            {{league.currentMixedTeamRound}}\n                        </span>\n                    </a>\n                    <div class=\"list-body\">\n                        <div><a>{{league.league_name}}</a></div>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchAddShotsMixedTeamController = function MatchAddShotsMixedTeamController(MatchesFactory, LeaguesFactory, $rootScope, $filter, $state) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, MatchAddShotsMixedTeamController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		vm.rootScope = $rootScope;
		vm.$onInit = function () {
			$state.current.data.hideSidebar = true;
			$state.current.data.hideMatchProfile = true;
			$state.current.data.hideMatchMenu = true;
			vm.leagues = [];
			vm.activeLeagueOne = null;
			vm.roundsTemplate = ['1/32', '1/16', '1/8', '1/4', '1/2', '1/1'];
			vm.rounds = [];
			vm.activeRound = null;
			vm.activeEliminationMatches = [];
			vm.activeEliminationMatch = null;
			vm.roundOneShots = {};
			vm.roundTwoShots = {};
			vm.shotsHeaders = [{ name: '#', class: 'col-xs-1' }, { name: '1ο', class: 'col-xs-1' }, { name: '2ο', class: 'col-xs-1' }, { name: '3ο', class: 'col-xs-1' }, { name: '4ο', class: 'col-xs-1' }, { name: 'Shot', class: 'col-xs-1' }, { name: '', class: 'col-xs-1' }, { name: '1ο', class: 'col-xs-1' }, { name: '2ο', class: 'col-xs-1' }, { name: '3ο', class: 'col-xs-1' }, { name: '4ο', class: 'col-xs-1' }, { name: 'Shot', class: 'col-xs-1' }];
			vm.maxShots = 6;
			vm.moveToNextTarget = false;
			/* Fetch Leagues with Team Matches */
			MatchesFactory.getOne(vm.rootScope.currentMatchId, { include: 'matchLeagues' }).then(function (response) {
				(0, _entries2.default)(response.data.matchLeagues).forEach(function (entry) {
					var value = entry[1];
					if (value.olympic_mixed && value.olympic_mixed > 0) {
						value.league.currentMixedTeamRound = value.currentMixedTeamRound;
						value.league.league_name += " - " + value.mixedLeagueNameAppendName;
						var exists = vm.leagues.find(function (league) {
							return league.league_id === value.league.league_id || league.league_id === value.league.mixed_league_id;
						});
						if (!exists) {
							vm.leagues.push(value.league);
						}
					}
				});
			});
		};
	
		vm.isLeagueCompound = function () {
			return vm.activeLeagueOne.type === LeaguesFactory.LEAGUE_TYPES.COMPOUND;
		};
		vm.selectLeague = function (leagueOne) {
			vm.activeLeagueOne = leagueOne;
			vm.rounds = [];
			vm.rounds = vm.roundsTemplate;
			vm.activeRound = leagueOne.currentMixedTeamRound;
			vm.activeEliminationMatch = null;
			// let found = false;
			// for(let i = 0; i < vm.roundsTemplate; i++){
			// if(found || vm.roundsTemplate[i] === vm.activeLeague.currentMixedTeamRound){
			// 	found = true;
			// 	vm.rounds.push(vm.roundsTemplate[i]);
			// }
			// }
			reloadLeagueEliminationMatches(false);
		};
		vm.selectRound = function (round) {
			vm.activeRound = round;
			reloadLeagueEliminationMatches();
		};
		vm.selectEliminationMatch = function (eliminationMatchId) {
			vm.activeEliminationMatch = vm.eliminationMatches.find(function (eliminationMatch) {
				return eliminationMatch.olympic_match_mixed_id === eliminationMatchId;
			});
			vm.roundOneShots = {};
			vm.roundTwoShots = {};
			vm.activeRoundOne = vm.activeEliminationMatch.rounds[0];
			vm.activeRoundTwo = vm.activeEliminationMatch.rounds[1];
			vm.activeRoundOne.displayScore = vm.activeRoundOne.points;
			vm.activeRoundTwo.displayScore = vm.activeRoundTwo.points;
			for (var i = 1; i < vm.maxShots; i++) {
				vm.roundOneShots[i] = {
					arrows: {
						1: vm.activeRoundOne['arrow_' + i + '_1'],
						2: vm.activeRoundOne['arrow_' + i + '_2'],
						3: vm.activeRoundOne['arrow_' + i + '_3'],
						4: vm.activeRoundOne['arrow_' + i + '_4']
					},
					stats: {
						score: 0
					}
				};
				vm.roundTwoShots[i] = {
					arrows: {
						1: vm.activeRoundTwo['arrow_' + i + '_1'],
						2: vm.activeRoundTwo['arrow_' + i + '_2'],
						3: vm.activeRoundTwo['arrow_' + i + '_3'],
						4: vm.activeRoundTwo['arrow_' + i + '_4']
					},
					stats: {
						score: 0
					}
				};
			}
			vm.calculateArrows();
		};
		vm.addShots = function () {
			var roundOneShots = {};
			var roundTwoShots = {};
			for (var i = 1; i < vm.maxShots; i++) {
				roundOneShots[i] = vm.roundOneShots[i].arrows;
				roundTwoShots[i] = vm.roundTwoShots[i].arrows;
			}
			var roundOneId = vm.activeRoundOne.olympic_round_mixed_id;
			var roundTwoId = vm.activeRoundTwo.olympic_round_mixed_id;
			var rounds = [{
				roundId: roundOneId,
				shots: roundOneShots
			}, {
				roundId: roundTwoId,
				shots: roundTwoShots
			}];
			MatchesFactory.addShotsElimination(vm.activeEliminationMatch.olympic_match_mixed_id, MatchesFactory.MATCH_ELIMINATION_TYPES.MIXED_TEAM, {
				rounds: rounds
			}).then(function (response) {
				reloadLeagueEliminationMatches();
			});
		};
		vm.clearRoundShots = function () {
			MatchesFactory.clearShotsElimination(vm.activeEliminationMatch.olympic_match_mixed_id, MatchesFactory.MATCH_ELIMINATION_TYPES.MIXED_TEAM).then(function (response) {
				reloadLeagueEliminationMatches();
			});
		};
		vm.calculateArrows = function () {
			vm.roundOneScore = 0;
			vm.roundTwoScore = 0;
			for (var i = 1; i < vm.maxShots; i++) {
				vm.roundOneShots[i].stats.score = 0;
				vm.roundTwoShots[i].stats.score = 0;
			}
			for (var _i = 1; _i < vm.maxShots; _i++) {
				var shotOneScore = 0;
				var shotTwoScore = 0;
				for (var j = 1; j < 5; j++) {
					if (!vm.roundOneShots[_i].arrows[j]) {
						continue;
					}
					if (!vm.roundTwoShots[_i].arrows[j]) {
						continue;
					}
	
					/* Round One */
					if (vm.roundOneShots[_i].arrows[j] == 0) {
						vm.roundOneShots[_i].arrows[j] = 'm';
					}
					if (vm.roundOneShots[_i].arrows[j].toLowerCase() !== 'm') {
						shotOneScore = shotOneScore + parseInt(vm.roundOneShots[_i].arrows[j]);
					}
					/* Round Two */
					if (vm.roundTwoShots[_i].arrows[j] == 0) {
						vm.roundTwoShots[_i].arrows[j] = 'm';
					}
					if (vm.roundTwoShots[_i].arrows[j].toLowerCase() !== 'm') {
						shotTwoScore = shotTwoScore + parseInt(vm.roundTwoShots[_i].arrows[j]);
					}
				}
				/* RECURVE SCORING */
				if (!vm.isLeagueCompound()) {
					if (shotOneScore > shotTwoScore) {
						vm.roundOneShots[_i].stats.score = shotOneScore + "/" + 2;
						vm.roundTwoShots[_i].stats.score = shotTwoScore + "/" + 0;
						vm.roundOneScore += 2;
					} else if (shotOneScore < shotTwoScore) {
						vm.roundTwoShots[_i].stats.score = shotTwoScore + "/" + 2;
						vm.roundOneShots[_i].stats.score = shotOneScore + "/" + 0;
						vm.roundTwoScore += 2;
					} else if (shotOneScore && shotTwoScore) {
						vm.roundOneShots[_i].stats.score = shotOneScore + "/" + 1;
						vm.roundOneScore++;
						vm.roundTwoShots[_i].stats.score = shotTwoScore + "/" + 1;
						vm.roundTwoScore++;
					}
				} else {
					/* COMPOUND SCORING */
					vm.roundOneScore += shotOneScore;
					vm.roundOneShots[_i].stats.score = _i !== 1 ? shotOneScore + "/" + vm.roundOneScore : shotOneScore;
					vm.roundTwoScore += shotTwoScore;
					vm.roundTwoShots[_i].stats.score = _i !== 1 ? shotTwoScore + "/" + vm.roundTwoScore : shotTwoScore;
				}
			}
		};
	
		function reloadLeagueEliminationMatches() {
			var reloadActiveMatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
			var data = {
				include: 'matchOlympicMixedTeam',
				league_id: vm.activeLeagueOne.league_id,
				round: vm.activeRound
			};
			vm.eliminationMatches = [];
			MatchesFactory.getOne(vm.rootScope.currentMatchId, data).then(function (response) {
				vm.eliminationMatches = response.data.matchOlympicMixedTeam;
				if (vm.activeEliminationMatch && reloadActiveMatch) {
					var activeEliminationMatchId = vm.activeEliminationMatch.olympic_match_mixed_id;
					vm.activeEliminationMatch = null;
					vm.selectEliminationMatch(activeEliminationMatchId);
				}
			});
		}
	};
	MatchAddShotsMixedTeamController.$inject = ["MatchesFactory", "LeaguesFactory", "$rootScope", "$filter", "$state"];
	
	exports.default = MatchAddShotsMixedTeamController;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(691);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchAddShotsMixedTeam.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./matchAddShotsMixedTeam.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 691 */
685,
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _matchEdit = __webpack_require__(693);
	
	var _matchEdit2 = _interopRequireDefault(_matchEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchEditModule = _angular2.default.module('matchEdit', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('match-edit', {
			url: '/matches/edit/:id',
			component: 'matchEdit',
			data: { pageTitle: 'EDIT_MATCH' },
			params: {
				id: { squash: true, value: null }
			},
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.EDIT_MATCH)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('matchEdit', _matchEdit2.default).name;
	
	exports.default = matchEditModule;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _matchEdit = __webpack_require__(694);
	
	var _matchEdit2 = _interopRequireDefault(_matchEdit);
	
	var _matchEdit3 = __webpack_require__(695);
	
	var _matchEdit4 = _interopRequireDefault(_matchEdit3);
	
	__webpack_require__(701);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var matchEditComponent = {
	  bindings: {},
	  template: _matchEdit2.default,
	  controller: _matchEdit4.default,
	  controllerAs: "vm"
	};
	
	exports.default = matchEditComponent;

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-sm-12\">\n    <div class=\"box\">\n      <div class=\"b-b m-b-1 p-t-1 p-b-1 text-center\">\n        <h3 class=\"_300 ng-binding\" ng-if=\"!vm.match.match_id\" translate>\n          CREATE_MATCH\n        </h3>\n        <h3 class=\"_300 ng-binding\" ng-if=\"vm.match.match_id\" translate>\n          EDIT_MATCH\n        </h3>\n      </div>\n      <form name=\"editMatchForm\" ng-submit=\"vm.submitMatch()\">\n        <div class=\"box-body\">\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'MATCH_CODE' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-model=\"vm.match.match_code\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'MATCH_NAME' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-model=\"vm.match.match_name\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'MATCH_DATE' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <div class=\"dropdown\">\n                <a\n                  class=\"dropdown-toggle\"\n                  id=\"matchDate\"\n                  role=\"button\"\n                  data-toggle=\"dropdown\"\n                  data-target=\"#\"\n                  href=\"#\"\n                >\n                  <div class=\"input-group\">\n                    <span class=\"custom-input\">\n                      {{ vm.match.match_date | date:'yyyy-MM-dd' }}\n                    </span>\n                    <span class=\"input-group-btn\">\n                      <button class=\"btn white\" type=\"button\" translate>\n                        PICK\n                      </button>\n                    </span>\n                  </div>\n                </a>\n                <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                  <datetimepicker\n                    data-ng-model=\"vm.match.match_date\"\n                    data-datetimepicker-config=\"vm.matchDatePicker\"\n                  />\n                </ul>\n              </div>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'MATCH_END_DATE' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <div class=\"dropdown\">\n                <a\n                  class=\"dropdown-toggle\"\n                  id=\"matchEndDate\"\n                  role=\"button\"\n                  data-toggle=\"dropdown\"\n                  data-target=\"#\"\n                  href=\"#\"\n                >\n                  <div class=\"input-group\">\n                    <span class=\"custom-input\">\n                      {{ vm.match.match_end_date | date:'yyyy-MM-dd' }}\n                    </span>\n                    <span class=\"input-group-btn\">\n                      <button class=\"btn white\" type=\"button\" translate>\n                        PICK\n                      </button>\n                    </span>\n                  </div>\n                </a>\n                <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                  <datetimepicker\n                    data-ng-model=\"vm.match.match_end_date\"\n                    data-datetimepicker-config=\"vm.matchDatePicker\"\n                  />\n                </ul>\n              </div>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'MATCH_REGISTRATION_START' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <div class=\"dropdown\">\n                <a\n                  class=\"dropdown-toggle\"\n                  id=\"registrationStart\"\n                  role=\"button\"\n                  data-toggle=\"dropdown\"\n                  data-target=\"#\"\n                  href=\"#\"\n                >\n                  <div class=\"input-group\">\n                    <span class=\"custom-input\">\n                      {{ vm.match.registration_start | date:'yyyy-MM-dd' }}\n                    </span>\n                    <span class=\"input-group-btn\">\n                      <button class=\"btn white\" type=\"button\" translate>\n                        PICK\n                      </button>\n                    </span>\n                  </div>\n                </a>\n                <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                  <datetimepicker\n                    data-ng-model=\"vm.match.registration_start\"\n                    data-datetimepicker-config=\"vm.matchRegistrationStartDatePicker\"\n                  />\n                </ul>\n              </div>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'MATCH_REGISTRATION_END' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <div class=\"dropdown\">\n                <a\n                  class=\"dropdown-toggle\"\n                  id=\"registrationEnd\"\n                  role=\"button\"\n                  data-toggle=\"dropdown\"\n                  data-target=\"#\"\n                  href=\"#\"\n                >\n                  <div class=\"input-group\">\n                    <span class=\"custom-input\">\n                      {{ vm.match.registration_end | date:'yyyy-MM-dd HH:mm' }}\n                    </span>\n                    <span class=\"input-group-btn\">\n                      <button class=\"btn white\" type=\"button\" translate>\n                        PICK\n                      </button>\n                    </span>\n                  </div>\n                </a>\n                <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                  <datetimepicker\n                    data-ng-model=\"vm.match.registration_end\"\n                    data-datetimepicker-config=\"vm.matchRegistrationEndDatePicker\"\n                  />\n                </ul>\n              </div>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'MATCH_SORT_NAME' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-model=\"vm.match.match_sortname\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'MATCH_HOST' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-model=\"vm.match.match_host\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'MATCH_LOCATION' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-model=\"vm.match.match_location\"\n              />\n            </div>\n          </div>\n          <div ng-if=\"vm.rootScope.isSAAF\" class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'MATCH_CITY' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-model=\"vm.match.match_city\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'JUDGES' | translate}}</label\n            >\n            <div class=\"col-sm-9\">\n              <ui-select\n                multiple\n                ng-model=\"vm.selectedJudges\"\n                theme=\"bootstrap\"\n              >\n                <ui-select-match\n                  class=\"ui-select-match\"\n                  placeholder=\"{{'SELECT_JUDGES' | translate}}\"\n                >\n                  {{$item.judgeName}}\n                </ui-select-match>\n                <ui-select-choices\n                  class=\"ui-select-choices\"\n                  repeat=\"item in vm.judges | filter: $select.search\"\n                >\n                  <div\n                    ng-bind-html=\"item.judgeName | highlight: $select.search\"\n                  ></div>\n                </ui-select-choices>\n              </ui-select>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\"\n              >MATCH_ENTRIES_LIMIT</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"number\"\n                min=\"0\"\n                class=\"form-control\"\n                ng-model=\"vm.match.entries_limit\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\"\n              >MATCH_OFFICIAL</label\n            >\n            <div class=\"col-sm-9\">\n              <label class=\"ui-switch ui-switch-md info m-t-xs\">\n                <input\n                  type=\"checkbox\"\n                  ng-checked=\"vm.match.official === 1\"\n                  ng-model=\"vm.match.official\"\n                />\n                <i></i>\n              </label>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\"\n              >MATCH_CUP</label\n            >\n            <div class=\"col-sm-9\">\n              <label class=\"ui-switch ui-switch-md info m-t-xs\">\n                <input\n                  type=\"checkbox\"\n                  ng-checked=\"vm.match.cup === 1\"\n                  ng-model=\"vm.match.cup\"\n                />\n                <i></i>\n              </label>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\"\n              >MATCH_CHAMPIONSHIP</label\n            >\n            <div class=\"col-sm-9\">\n              <label class=\"ui-switch ui-switch-md info m-t-xs\">\n                <input\n                  type=\"checkbox\"\n                  ng-checked=\"vm.match.championship === 1\"\n                  ng-model=\"vm.match.championship\"\n                />\n                <i></i>\n              </label>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'MATCH_TYPE' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <div class=\"radio-inline\">\n                <label class=\"ui-check\">\n                  <input\n                    type=\"radio\"\n                    required\n                    ng-model=\"vm.match.match_type\"\n                    name=\"matchType\"\n                    id=\"matchTypeOutdoor\"\n                    value=\"outdoor\"\n                  />\n                  <i class=\"dark-white\"></i>\n                  {{'OUTDOOR' | translate}}\n                </label>\n              </div>\n              <div class=\"radio-inline\">\n                <label class=\"ui-check\">\n                  <input\n                    type=\"radio\"\n                    required\n                    ng-model=\"vm.match.match_type\"\n                    name=\"matchType\"\n                    id=\"matchTypeIndoor\"\n                    value=\"indoor\"\n                  />\n                  <i class=\"dark-white\"></i>\n                  {{'INDOOR' | translate}}\n                </label>\n              </div>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\"\n              >MOBILE_SCORING_ROUND_1_OPEN</label\n            >\n            <div class=\"col-sm-9\">\n              <label class=\"ui-switch ui-switch-md info m-t-xs\">\n                <input\n                  type=\"checkbox\"\n                  ng-checked=\"vm.match.round_1_mobile_open === 1\"\n                  ng-model=\"vm.match.round_1_mobile_open\"\n                />\n                <i></i>\n              </label>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\"\n              >MOBILE_SCORING_ROUND_2_OPEN</label\n            >\n            <div class=\"col-sm-9\">\n              <label class=\"ui-switch ui-switch-md info m-t-xs\">\n                <input\n                  type=\"checkbox\"\n                  ng-checked=\"vm.match.round_2_mobile_open === 1\"\n                  ng-model=\"vm.match.round_2_mobile_open\"\n                />\n                <i></i>\n              </label>\n            </div>\n          </div>\n        </div>\n        <footer class=\"dker p-a text-left\">\n          <button\n            type=\"submit\"\n            translate\n            class=\"btn success p-x-md m-l-1\"\n            ng-disabled=\"!editMatchForm.$valid\"\n          >\n            SUBMIT\n          </button>\n        </footer>\n      </form>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _slicedToArray2 = __webpack_require__(535);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchEditController = function MatchEditController(MatchesFactory, JudgesFactory, $rootScope, $state, $filter, ngDialog, $stateParams) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, MatchEditController);
	  var vm = this;
	
	  var $date = $filter("date");
	
	  vm.matchId = $stateParams.id;
	
	  vm.$onInit = function () {
	    vm.rootScope = $rootScope;
	    vm.match = {};
	    vm.judges = [];
	    vm.selectedJudges = [];
	    JudgesFactory.getAll().then(function (response) {
	      vm.judges = response.data;
	      if (vm.matchId) {
	        MatchesFactory.getOne(vm.matchId, { include: "matchJudges" }).then(function (response) {
	          vm.match = response.data;
	          vm.match.official = vm.match.official === 1;
	          vm.match.round_1_mobile_open = vm.match.round_1_mobile_open === 1;
	          vm.match.round_2_mobile_open = vm.match.round_2_mobile_open === 1;
	          vm.match.cup = vm.match.cup === 1;
	          vm.match.championship = vm.match.championship === 1;
	          if (vm.match.hasOwnProperty("matchJudges")) {
	            vm.selectedJudges = [];
	            (0, _entries2.default)(vm.match.matchJudges).forEach(function (_ref) {
	              var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	                  key = _ref2[0],
	                  value = _ref2[1];
	
	              var judge = vm.judges.filter(function (judge) {
	                if (judge.id === value.judge_id) {
	                  return judge;
	                }
	              });
	              if (judge.length === 0) {
	                return;
	              }
	              vm.selectedJudges.push(judge[0]);
	            });
	          }
	        });
	      }
	    });
	  };
	
	  var dateTimePickerDefaultConfig = {
	    startView: "day",
	    minView: "day"
	  };
	  vm.matchDatePicker = (0, _assign2.default)(dateTimePickerDefaultConfig, {
	    dropdownSelector: "#matchDate"
	  });
	  vm.matchRegistrationStartDatePicker = (0, _assign2.default)(dateTimePickerDefaultConfig, { dropdownSelector: "#registrationStart" });
	  vm.matchRegistrationEndDatePicker = {
	    startView: "day",
	    minView: "hour",
	    dropdownSelector: "#registrationEnd"
	  };
	
	  vm.submitMatch = function () {
	    vm.match.match_date = $date(vm.match.match_date, "yyyy-MM-dd");
	    vm.match.match_end_date = $date(vm.match.match_end_date, "yyyy-MM-dd");
	    vm.match.registration_start = $date(vm.match.registration_start, "yyyy-MM-dd");
	    vm.match.registration_end = $date(vm.match.registration_end, "yyyy-MM-dd HH:mm");
	    vm.match.official = vm.match.official ? 1 : 0;
	    vm.match.round_1_mobile_open = vm.match.round_1_mobile_open ? 1 : 0;
	    vm.match.round_2_mobile_open = vm.match.round_2_mobile_open ? 1 : 0;
	    vm.match.cup = vm.match.cup ? 1 : 0;
	    vm.match.championship = vm.match.championship ? 1 : 0;
	    vm.match.matchJudges = vm.selectedJudges;
	    if (vm.match.match_id) {
	      /* UPDATE MATCH */
	      MatchesFactory.update(vm.match.match_id, vm.match).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        $state.reload();
	      });
	    } else {
	      /* NEW MATCH */
	      MatchesFactory.add(vm.match).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        $state.go("match-edit", { id: response.data.match_id });
	      });
	    }
	  };
	};
	MatchEditController.$inject = ["MatchesFactory", "JudgesFactory", "$rootScope", "$state", "$filter", "ngDialog", "$stateParams"];
	
	exports.default = MatchEditController;

/***/ }),
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(702);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./matchEdit.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./matchEdit.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, ".dropdown-toggle:after{content:none!important}.custom-input{border-radius:0;display:block;width:100%;padding:.5rem .75rem;font-size:1rem;line-height:1.25;color:#55595c;background-color:#fff;background-image:none;background-clip:padding-box;border:1px solid rgba(0,0,0,.15)}", ""]);
	
	// exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _leagues = __webpack_require__(704);
	
	var _leagues2 = _interopRequireDefault(_leagues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var leaguesModule = _angular2.default.module('leagues', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('leagues', {
			url: '/leagues',
			component: 'leagues',
			data: { pageTitle: 'LEAGUES' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_ALL_LEAGUES)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('leagues', _leagues2.default).name;
	
	exports.default = leaguesModule;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _leagues = __webpack_require__(705);
	
	var _leagues2 = _interopRequireDefault(_leagues);
	
	var _leagues3 = __webpack_require__(706);
	
	var _leagues4 = _interopRequireDefault(_leagues3);
	
	__webpack_require__(707);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var leaguesComponent = {
	  bindings: {},
	  template: _leagues2.default,
	  controller: _leagues4.default,
	  controllerAs: "vm"
	};
	
	exports.default = leaguesComponent;

/***/ }),
/* 705 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-sm-12\">\n    <div class=\"box\">\n      <div class=\"box-body\">\n        <button\n          type=\"button\"\n          ng-if=\"!vm.showLeagueForm && vm.hasPermission(vm.rootScope.permissions.ADD_LEAGUE)\"\n          ng-click=\"vm.openForm()\"\n          class=\"btn btn-sm btn-success m-b-1\"\n        >\n          <i class=\"fa fa-plus\"></i> {{'CREATE' | translate}}\n        </button>\n        <div class=\"table-responsive m-b-lg\" ng-if=\"!vm.showLeagueForm\">\n          <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n        </div>\n        <form\n          name=\"leagueForm\"\n          ng-if=\"vm.showLeagueForm\"\n          ng-submit=\"vm.submit()\"\n        >\n          <div class=\"box-tool\">\n            <ul class=\"nav\">\n              <li class=\"nav-item inline\" ng-click=\"vm.closeForm()\">\n                <a class=\"nav-link\"><i class=\"fa fa-close md-18\"></i></a>\n              </li>\n            </ul>\n          </div>\n          <div class=\"box-body\">\n            <div class=\"b-b m-b-1 text-center\">\n              <h3 class=\"_300 ng-binding\" ng-if=\"vm.league.league_id\" translate>\n                EDIT_LEAGUE\n              </h3>\n              <h3\n                class=\"_300 ng-binding\"\n                ng-if=\"!vm.league.league_id\"\n                translate\n              >\n                CREATE_LEAGUE\n              </h3>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'LEAGUE_NAME' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.league.league_name\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'LEAGUE_SORT_NAME' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.league.league_sort_name\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'MIXED_LEAGUE' | translate}}</label\n              >\n              <div class=\"col-sm-9\">\n                <ui-select ng-model=\"vm.mixedLeague\" theme=\"bootstrap\">\n                  <ui-select-match\n                    class=\"ui-select-match\"\n                    placeholder=\"{{'SELECT_MIXED_LEAGUE' | translate}}\"\n                  >\n                    {{$select.selected.league_name}}\n                  </ui-select-match>\n                  <ui-select-choices\n                    class=\"ui-select-choices\"\n                    repeat=\"item in vm.leagues | filter: $select.search\"\n                  >\n                    <div\n                      ng-bind-html=\"item.league_name | highlight: $select.search\"\n                    ></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div ng-if=\"vm.rootScope.isSAAF\" class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'LEVEL' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <ui-select ng-model=\"vm.level\" theme=\"bootstrap\">\n                  <ui-select-match\n                    class=\"ui-select-match\"\n                    placeholder=\"{{'SELECT_LEVEL' | translate}}\"\n                  >\n                    {{$select.selected.name}}\n                  </ui-select-match>\n                  <ui-select-choices\n                    class=\"ui-select-choices\"\n                    repeat=\"item in vm.levels | filter: $select.search\"\n                  >\n                    <div\n                      ng-bind-html=\"item.name | highlight: $select.search\"\n                    ></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >LEAGUE_ORDER</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.league.league_priority\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >DISTANCE_OUTDOOR</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.league.distance_outdoor\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >DISTANCE_INDOOR</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.league.distance_indoor\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >LIMIT_OUTDOOR</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.league.limit_outdoor\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >LIMIT_INDOOR</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.league.limit_indoor\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\">AGE</label>\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.league.age\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >BOW_TYPE</label\n              >\n              <div class=\"col-sm-9\">\n                <div class=\"radio-inline\">\n                  <label class=\"ui-check\">\n                    <input\n                      type=\"radio\"\n                      id=\"leagueTypeRecurve\"\n                      ng-model=\"vm.league.type\"\n                      name=\"leagueType\"\n                      value=\"recurve\"\n                    />\n                    <i class=\"dark-white\"></i>{{'RECURVE' | translate}}\n                  </label>\n                </div>\n                <div class=\"radio-inline\">\n                  <label class=\"ui-check\">\n                    <input\n                      type=\"radio\"\n                      id=\"leagueTypeCompound\"\n                      ng-model=\"vm.league.type\"\n                      name=\"leagueType\"\n                      value=\"compound\"\n                    />\n                    <i class=\"dark-white\"></i>{{'COMPOUND' | translate}}\n                  </label>\n                </div>\n                <div class=\"radio-inline\">\n                  <label class=\"ui-check\">\n                    <input\n                      type=\"radio\"\n                      id=\"leagueTypeBare\"\n                      ng-model=\"vm.league.type\"\n                      name=\"leagueType\"\n                      value=\"bare\"\n                    />\n                    <i class=\"dark-white\"></i>{{'BARE' | translate}}\n                  </label>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >LEAGUE_SEX</label\n              >\n              <div class=\"col-sm-9\">\n                <div class=\"radio-inline\">\n                  <label class=\"ui-check\">\n                    <input\n                      type=\"radio\"\n                      required\n                      id=\"leagueSexMale\"\n                      ng-model=\"vm.league.sex\"\n                      name=\"leagueSex\"\n                      value=\"M\"\n                    />\n                    <i class=\"dark-white\"></i>{{'MALE' | translate}}\n                  </label>\n                </div>\n                <div class=\"radio-inline\">\n                  <label class=\"ui-check\">\n                    <input\n                      type=\"radio\"\n                      required\n                      id=\"leagueSexFemale\"\n                      ng-model=\"vm.league.sex\"\n                      name=\"leagueSex\"\n                      value=\"F\"\n                    />\n                    <i class=\"dark-white\"></i>{{'FEMALE' | translate}}\n                  </label>\n                </div>\n              </div>\n            </div>\n          </div>\n          <footer class=\"dker p-a text-left\">\n            <button\n              type=\"submit\"\n              translate\n              class=\"btn success p-x-md m-l-1\"\n              ng-disabled=\"!leagueForm.$valid\"\n            >\n              SUBMIT\n            </button>\n            <button\n              type=\"button\"\n              translate\n              ng-click=\"vm.closeForm()\"\n              class=\"btn p-x-md m-l-1\"\n            >\n              CANCEL\n            </button>\n          </footer>\n        </form>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeaguesController = function LeaguesController(LeaguesFactory, $rootScope, $filter, ngDialog, Levels) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, LeaguesController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	  vm.mixedLeague = {};
	  vm.level = { id: Levels.WHITE, name: "White" };
	  vm.levels = [{ id: Levels.WHITE, name: "White" }, { id: Levels.BLACK, name: "Black" }, { id: Levels.BLUE, name: "Blue" }, { id: Levels.RED, name: "Red" }, { id: Levels.YELLOW, name: "Yellow" }, { id: Levels.GREEN, name: "Green" }];
	
	  vm.$onInit = function () {
	    vm.showLeagueForm = false;
	    reloadLeagues();
	  };
	
	  vm.hasPermission = function (permission) {
	    return vm.rootScope.user.canDo(permission);
	  };
	
	  vm.gridOptions = {
	    enableSorting: true,
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "league_name",
	      enableFiltering: true,
	      name: $translate("LEAGUE_NAME")
	    }, {
	      visible: $rootScope.isSAAF,
	      field: "level",
	      enableFiltering: true,
	      name: $translate("LEVEL"),
	      width: "100",
	      cellTemplate: "<div class=\"ui-grid-cell-contents ui-grid-align-c\">\n\t\t\t{{grid.appScope.vm.getLevelName(row.entity)}}\n\t\t\t</div>"
	    }, {
	      field: "league_priority",
	      enableFiltering: true,
	      name: $translate("LEAGUE_ORDER"),
	      width: "100"
	    }, {
	      field: "type",
	      enableFiltering: true,
	      name: $translate("BOW_TYPE"),
	      width: "100"
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-warning" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_LEAGUE)" ' + 'ng-click="grid.appScope.vm.openForm(row.entity)">EDIT</button> ' + '<button class="btn btn-sm btn-danger" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_LEAGUE)" ' + 'ng-click="grid.appScope.vm.deleteLeague(row.entity.league_id)">DELETE</button> ' + "</div>" + "</div>",
	      width: "240"
	    }]
	  };
	
	  vm.submit = function () {
	    vm.league.level = vm.level.id;
	    if (vm.mixedLeague) {
	      vm.league.mixed_league_id = vm.mixedLeague.league_id;
	    }
	    if (vm.league.league_id) {
	      LeaguesFactory.update(vm.league.league_id, vm.league).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        reloadLeagues();
	        vm.league = response.data;
	      });
	    } else {
	      LeaguesFactory.create(vm.league).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        reloadLeagues();
	        vm.league = response.data;
	      });
	    }
	  };
	
	  vm.deleteLeague = function (leagueId) {
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate("CONFIRM_DELETE_LEAGUE")
	      }
	    }).then(function () {
	      LeaguesFactory.delete(leagueId).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        reloadLeagues();
	      });
	    });
	  };
	
	  vm.openForm = function (league) {
	    vm.league = {};
	    if (league) {
	      angular.copy(league, vm.league);
	      vm.level = vm.levels.find(function (l) {
	        return l.id === vm.league.level;
	      });
	      if (league.mixed_league_id) {
	        vm.mixedLeague = vm.leagues.find(function (l) {
	          return l.league_id === league.mixed_league_id;
	        });
	      } else {
	        vm.mixedLeague = {};
	      }
	    }
	    vm.showLeagueForm = true;
	  };
	
	  vm.closeForm = function () {
	    vm.showLeagueForm = false;
	  };
	
	  vm.getLevelName = function (league) {
	    return vm.levels.find(function (l) {
	      return l.id === league.level;
	    }).name;
	  };
	
	  function reloadLeagues() {
	    LeaguesFactory.getAll().then(function (response) {
	      vm.leagues = response.data;
	      vm.gridOptions.data = response.data;
	    });
	  }
	};
	LeaguesController.$inject = ["LeaguesFactory", "$rootScope", "$filter", "ngDialog", "Levels"];
	
	exports.default = LeaguesController;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(708);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./leagues.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./leagues.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 708 */
426,
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _roles = __webpack_require__(710);
	
	var _roles2 = _interopRequireDefault(_roles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rolesModule = _angular2.default.module('roles', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('roles', {
			url: '/roles',
			component: 'roles',
			data: { pageTitle: 'ROLES' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.EDIT_ROLES)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('roles', _roles2.default).name;
	
	exports.default = rolesModule;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _roles = __webpack_require__(711);
	
	var _roles2 = _interopRequireDefault(_roles);
	
	var _roles3 = __webpack_require__(712);
	
	var _roles4 = _interopRequireDefault(_roles3);
	
	__webpack_require__(713);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rolesComponent = {
	  bindings: {},
	  template: _roles2.default,
	  controller: _roles4.default,
	  controllerAs: "vm"
	};
	
	exports.default = rolesComponent;

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <button type=\"button\"\n                        ng-if=\"!vm.showRoleForm\"\n                        ng-click=\"vm.openForm()\" class=\"btn btn-sm btn-success m-b-1\">\n                    <i class=\"fa fa-plus\"></i>  {{'CREATE' | translate}}\n                </button>\n                <div class=\"table-responsive m-b-lg\" ng-if=\"!vm.showRoleForm\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n                <form name=\"roleForm\" ng-if=\"vm.showRoleForm\" ng-submit=\"vm.submit()\">\n                    <div class=\"box-tool\">\n                        <ul class=\"nav\">\n                            <li class=\"nav-item inline\" ng-click=\"vm.closeForm()\">\n                                <a class=\"nav-link\"><i class=\"fa fa-close md-18\"></i></a>\n                            </li>\n                        </ul>\n                    </div>\n                    <div class=\"box-body\">\n                        <div class=\"b-b m-b-1 text-center\">\n                            <h3 class=\"_300 ng-binding\" ng-if=\"vm.role.id\" translate>EDIT_ROLE</h3>\n                            <h3 class=\"_300 ng-binding\" ng-if=\"!vm.role.id\" translate>CREATE_ROLE</h3>\n                        </div>\n                        <div class=\"form-group row\">\n                            <label class=\"col-sm-3 form-control-label\">{{'NAME' | translate}} *</label>\n                            <div class=\"col-sm-9\">\n                                <input type=\"text\" required class=\"form-control\" ng-model=\"vm.role.name\">\n                            </div>\n                        </div>\n                        <div class=\"form-group row\">\n                            <label class=\"col-sm-3 form-control-label\">{{'DISPLAY_NAME' | translate}} *</label>\n                            <div class=\"col-sm-9\">\n                                <input type=\"text\" required class=\"form-control\" ng-model=\"vm.role.display_name\">\n                            </div>\n                        </div>\n                        <div class=\"form-group row\">\n                            <label class=\"col-sm-3 form-control-label\">{{'DESCRIPTION' | translate}}</label>\n                            <div class=\"col-sm-9\">\n                                <input type=\"text\" class=\"form-control\" ng-model=\"vm.role.description\">\n                            </div>\n                        </div>\n                        <div class=\"form-group row\">\n                            <label translate class=\"col-sm-3 form-control-label\">SELECT_PERMISSIONS</label>\n                            <div class=\"col-sm-9\">\n                                <div class=\"checkbox\" ng-repeat=\"permission in vm.permissions\">\n                                    <label class=\"ui-check ui-check-md\">\n                                        <input type=\"checkbox\"\n                                               id=\"chk-{{permission.display_name}}\"\n                                               ng-model=\"vm.rolePermissions[permission.id]\"\n                                               ng-value=\"permission.id\">\n                                        <i class=\"dark-white\"></i>\n                                        {{permission.display_name}}\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <footer class=\"dker p-a text-left\">\n                        <button type=\"submit\"\n                                translate\n                                class=\"btn success p-x-md m-l-1\"\n                                ng-disabled=\"!roleForm.$valid\">SUBMIT\n                        </button>\n                        <button type=\"button\"\n                                translate\n                                ng-click=\"vm.closeForm()\"\n                                class=\"btn p-x-md m-l-1\">CANCEL\n                        </button>\n                    </footer>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(535);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RolesController = function RolesController(RolesFactory, $rootScope, $state, $filter, ngDialog) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, RolesController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	
	  vm.$onInit = function () {
	    vm.showRoleForm = false;
	    vm.permissions = [];
	    vm.rolePermissions = [];
	    RolesFactory.getAllPermissions().then(function (response) {
	      vm.permissions = response.map(function (p) {
	        return {
	          id: p.id,
	          description: p.description,
	          display_name: $translate(p.name)
	        };
	      });
	    });
	    reloadData();
	  };
	
	  vm.gridOptions = {
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableSorting: true,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "display_name",
	      enableFiltering: true,
	      name: $translate("DISPLAY_NAME")
	    }, {
	      field: "description",
	      enableFiltering: true,
	      name: $translate("DESCRIPTION")
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-warning" translate ' + 'ng-click="grid.appScope.vm.openForm(row.entity)">EDIT</button> ' + "</div>" + "</div>",
	      width: "140"
	    }]
	  };
	
	  vm.submit = function () {
	    vm.role.permissions = vm.rolePermissions;
	    if (vm.role.id) {
	      RolesFactory.update(vm.role.id, vm.role).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        reloadData();
	        vm.role = response.data;
	      });
	    } else {
	      RolesFactory.create(vm.role).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        reloadData();
	        vm.role = response.data;
	      });
	    }
	  };
	
	  vm.openForm = function (role) {
	    vm.role = {};
	    vm.rolePermissions = [];
	    if (role) {
	      angular.copy(role, vm.role);
	      (0, _entries2.default)(vm.role.perms).forEach(function (_ref) {
	        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
	            key = _ref2[0],
	            value = _ref2[1];
	
	        vm.rolePermissions[value.id] = true;
	      });
	    }
	    vm.showRoleForm = true;
	  };
	
	  vm.closeForm = function () {
	    vm.showRoleForm = false;
	  };
	
	  function reloadData() {
	    RolesFactory.getAll().then(function (response) {
	      vm.gridOptions.data = response.data;
	    });
	  }
	};
	RolesController.$inject = ["RolesFactory", "$rootScope", "$state", "$filter", "ngDialog"];
	
	exports.default = RolesController;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(714);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./roles.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./roles.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 714 */
426,
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _transfers = __webpack_require__(716);
	
	var _transfers2 = _interopRequireDefault(_transfers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transfersModule = _angular2.default.module('transfers', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('transfers', {
			url: '/transfers',
			component: 'transfers',
			data: { pageTitle: 'TRANSFERS' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_ALL_TRANSFERS)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('transfers', _transfers2.default).name;
	
	exports.default = transfersModule;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _transfers = __webpack_require__(717);
	
	var _transfers2 = _interopRequireDefault(_transfers);
	
	var _transfers3 = __webpack_require__(718);
	
	var _transfers4 = _interopRequireDefault(_transfers3);
	
	__webpack_require__(719);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transfersComponent = {
	  bindings: {},
	  template: _transfers2.default,
	  controller: _transfers4.default,
	  controllerAs: "vm"
	};
	
	exports.default = transfersComponent;

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div id=\"transferModal\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" ng-if=\"vm.transfer.transfer_id\" translate>EDIT_TRANSFER_PLAYER</h5>\n            </div>\n            <div class=\"b-b m-b-1 m-t-1 text-center\">\n                <h3 class=\"_300 ng-binding\" translate ng-bind=\"vm.transfer.player.playerName\"></h3>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"transferForm\" class=\"p-x-xs\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'NEW_TEAM' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <ui-select ng-model=\"vm.transfer.newTeam\" theme=\"bootstrap\" required>\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_NEW_TEAM' | translate}}\">\n                                    {{$select.selected.teamName}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.teams | filter: $select.search\">\n                                    <div ng-bind-html=\"item.teamName | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'DATE' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <div class=\"dropdown\">\n                                <a class=\"dropdown-toggle\" id=\"dateDropdown\" role=\"button\" data-toggle=\"dropdown\"\n                                   data-target=\"#\" href=\"#\">\n                                    <div class=\"input-group\">\n                                    <span class=\"custom-input\">\n                                        {{ vm.transfer.date | date:'yyyy-MM-dd' }}\n                                    </span>\n                                        <span class=\"input-group-btn\">\n                                        <button class=\"btn white\" type=\"button\" translate>PICK</button>\n                                    </span>\n                                    </div>\n                                </a>\n                                <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                                    <datetimepicker required data-ng-model=\"vm.transfer.date\"\n                                                    data-datetimepicker-config=\"vm.dateConfig\"/>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">COMMENTS</label>\n                        <div class=\"col-sm-8\">\n                            <textarea class=\"form-control\" ng-model=\"vm.transfer.comments\" rows=\"5\"></textarea>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        data-dismiss=\"modal\">CANCEL\n                </button>\n                <button type=\"button\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        ng-click=\"vm.submit();\"\n                        ng-class=\"{'disabled' : !transferForm.$valid}\"\n                        ng-disabled=\"!transferForm.$valid\"\n                        data-dismiss=\"modal\">SUBMIT\n                </button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransfersController = function TransfersController(TransfersFactory, TeamsFactory, PlayersFactory, $filter, ngDialog, $stateParams, $state, $rootScope) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, TransfersController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		var $date = $filter('date');
	
		vm.rootScope = $rootScope;
	
		vm.$onInit = function () {
			vm.transfer = {};
			vm.teams = [];
			TeamsFactory.getAll({ page_size: 2000 }).then(function (response) {
				vm.teams = response.data;
			});
			TransfersFactory.getAll({ page_size: 2000 }).then(function (response) {
				vm.gridOptions.data = response.data;
			});
		};
	
		vm.dateConfig = { startView: 'day', minView: 'day', dropdownSelector: '#dateDropdown' };
	
		vm.gridOptions = {
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableSorting: true,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'date',
				enableFiltering: false,
				name: $translate('DATE'),
				width: '120'
			}, {
				field: 'player.playerName',
				enableFiltering: true,
				name: $translate('PLAYER')
			}, {
				field: 'oldTeam.teamName',
				enableFiltering: true,
				name: $translate('OLD_TEAM')
			}, {
				field: 'newTeam.teamName',
				enableFiltering: true,
				name: $translate('NEW_TEAM')
			}, {
				field: 'comments',
				enableFiltering: false,
				name: $translate('COMMENTS')
			}, {
				field: 'actions',
				enableFiltering: false,
				name: $translate('ACTIONS'),
				headerCellClass: 'text-center',
				cellTemplate: '' + '<div ' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-warning" translate ' + 'data-toggle="modal" ' + 'data-target="#transferModal" ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.MAKE_PLAYER_TRANSFER)" ' + 'ng-click="grid.appScope.vm.openTransferModal(row.entity)">EDIT</button> ' + '</div>' + '</div>',
				width: '130'
			}]
		};
	
		vm.hasPermission = function (permission) {
			return vm.rootScope.user.canDo(permission);
		};
	
		vm.openTransferModal = function (transfer) {
			vm.transfer = {};
			angular.copy(transfer, vm.transfer);
		};
	
		vm.submit = function () {
			vm.transfer.date = $date(vm.transfer.date, 'yyyy-MM-dd');
			TransfersFactory.update(vm.transfer.transfer_id, vm.transfer).then(function (response) {
				ngDialog.open({ template: 'successTemplate' });
				$state.reload();
			});
		};
	};
	TransfersController.$inject = ["TransfersFactory", "TeamsFactory", "PlayersFactory", "$filter", "ngDialog", "$stateParams", "$state", "$rootScope"];
	
	exports.default = TransfersController;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(720);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./transfers.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./transfers.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 720 */
426,
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _teamsList = __webpack_require__(722);
	
	var _teamsList2 = _interopRequireDefault(_teamsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamsModule = _angular2.default.module('teamsList', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('teams', {
			url: '/teams',
			component: 'teamsList',
			data: { pageTitle: 'TEAMS' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_ALL_TEAMS)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('teamsList', _teamsList2.default).name;
	
	exports.default = teamsModule;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamsList = __webpack_require__(723);
	
	var _teamsList2 = _interopRequireDefault(_teamsList);
	
	var _teamsList3 = __webpack_require__(724);
	
	var _teamsList4 = _interopRequireDefault(_teamsList3);
	
	__webpack_require__(725);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamsListComponent = {
	  bindings: {},
	  template: _teamsList2.default,
	  controller: _teamsList4.default,
	  controllerAs: "vm"
	};
	
	exports.default = teamsListComponent;

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.ADD_TEAM)\">\n                <button ui-sref=\"team-edit\" class=\"btn btn-sm btn-success\">\n                    <i class=\"fa fa-plus\"></i> {{'CREATE' | translate}}\n                </button>\n            </div>\n            <div class=\"table-responsive m-b-lg\">\n                <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamsListController = function TeamsListController(TeamsFactory, $rootScope, $filter, $state, ngDialog, URLS) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, TeamsListController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	
	  vm.$onInit = function () {
	    reloadTeams();
	  };
	
	  vm.gridOptions = {
	    enableSorting: true,
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "image",
	      name: "",
	      enableFiltering: false,
	      cellTemplate: '<div class="ui-grid-cell-contents ui-grid-align-c p-t-0">' + '<span class="avatar w-32">' + '<img ng-src="{{grid.appScope.vm.getTeamImage(row.entity)}}">' + '<i class="on b-white bottom"></i>' + "</span>" + "</div>",
	      width: "80"
	    }, {
	      field: "full_name",
	      name: $translate("NAME"),
	      enableFiltering: true
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + '<div class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<a href class="btn btn-sm btn-info m-l-1" translate ' + 'ng-click="grid.appScope.vm.goToProfile(row.entity.team_id)">PROFILE</a>' + '<button class="btn btn-sm btn-warning m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TEAM)" ' + 'ng-click="grid.appScope.vm.goToEdit(row.entity.team_id)">EDIT</button>' + '<button class="btn btn-sm btn-danger m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_TEAM)" ' + 'ng-click="grid.appScope.vm.deleteTeam(row.entity.team_id)">DELETE</button>' + "</div>" + "</div>",
	      width: "325"
	    }]
	  };
	
	  vm.hasPermission = function (permission) {
	    if (vm.rootScope.user.isUserTypeTeam()) {
	      return vm.rootScope.user.isTeam(vm.teamId) && vm.rootScope.user.canDo(permission);
	    } else {
	      return vm.rootScope.user.canDo(permission);
	    }
	  };
	
	  vm.getTeamImage = function (entity) {
	    if (entity.img) {
	      return URLS.IMAGES_URL + "/teams/" + entity.img;
	    } else {
	      return "assets/images/no_avatar.png";
	    }
	  };
	
	  vm.goToProfile = function (teamId) {
	    $state.go("team-profile", { id: teamId });
	  };
	
	  vm.goToEdit = function (teamId) {
	    $state.go("team-edit", { id: teamId });
	  };
	
	  vm.deleteTeam = function (teamId) {
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate("CONFIRM_DELETE_TEAM")
	      }
	    }).then(function () {
	      TeamsFactory.delete(teamId).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        reloadTeams();
	      });
	    });
	  };
	
	  function reloadTeams() {
	    TeamsFactory.getAll().then(function (response) {
	      vm.gridOptions.data = response.data;
	    });
	  }
	};
	TeamsListController.$inject = ["TeamsFactory", "$rootScope", "$filter", "$state", "ngDialog", "URLS"];
	
	exports.default = TeamsListController;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(726);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./teamsList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./teamsList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 726 */
560,
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _teamProfile = __webpack_require__(728);
	
	var _teamProfile2 = _interopRequireDefault(_teamProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamProfileModule = _angular2.default.module('teamProfile', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('team-profile', {
			url: '/teams/{id}/profile',
			component: 'teamProfile',
			data: { pageTitle: 'TEAM_PROFILE' }
		});
	}]).component('teamProfile', _teamProfile2.default).name;
	
	exports.default = teamProfileModule;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamProfile = __webpack_require__(729);
	
	var _teamProfile2 = _interopRequireDefault(_teamProfile);
	
	var _teamProfile3 = __webpack_require__(730);
	
	var _teamProfile4 = _interopRequireDefault(_teamProfile3);
	
	__webpack_require__(731);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamProfileComponent = {
	  bindings: {},
	  template: _teamProfile2.default,
	  controller: _teamProfile4.default,
	  controllerAs: "vm"
	};
	
	exports.default = teamProfileComponent;

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"item\" ng-if=\"vm.team.team_id\">\n    <div class=\"item-bg\">\n        <img ng-src=\"{{vm.getTeamImage()}}\" class=\"blur opacity-3\">\n    </div>\n    <div class=\"p-a-md\">\n        <div class=\"row m-t\">\n            <div class=\"col-sm-12\">\n                <a href class=\"pull-left m-r-md\">\n                    <span class=\"avatar w-96\">\n                      <img ng-src=\"{{vm.getTeamImage()}}\" />\n                      <i class=\"on b-white\"></i>\n                    </span>\n                </a>\n                <div ng-if=\"vm.team\" class=\"clear\">\n                    <h4 class=\"m-a-0 m-b-xs\" ng-bind=\"vm.team.full_name\"></h4>\n                    <div class=\"text-muted m-b-1\">\n                        <i class=\"fa fa-map-marker m-r-xs\"></i>\n                        <span class=\"m-r\">\n                            {{vm.team.address}}, {{vm.team.city}}\n                        </span>\n                    </div>\n                    <div class=\"block clearfix\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.EDIT_TEAM)\">\n                        <button translate\n                                ui-sref=\"team-edit({id:{{vm.team.team_id}}})\"\n                                class=\"btn btn-sm btn-warning btn-rounded m-b\">EDIT_TEAM\n                        </button>\n                    </div>\n                    <div class=\"block clearfix\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.CHANGE_TEAM_PASSWORD)\">\n                        <button translate\n                                data-toggle=\"modal\"\n                                data-target=\"#changePasswordModal\"\n                                ng-click=\"vm.password = null\"\n                                class=\"btn btn-sm accent btn-rounded m-b\">CHANGE_PASSWORD\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"padding\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <div class=\"box\">\n                <div class=\"box-body\">\n                    <button class=\"btn btn-fw m-l-1\"\n                            translate\n                            ng-repeat=\"option in vm.options\"\n                            ng-class=\"{'success' : vm.activeOption == option.id, 'white' : vm.activeOption != option.id}\"\n                            ng-click=\"vm.activeOption = option.id\">\n                        {{option.name}}\n                    </button>\n                </div>\n                <div class=\"box-divider m-a-0\"></div>\n                <div ng-if=\"vm.activeOption == 1\" class=\"box-body\">\n                    <div class=\"row m-b\">\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>PHONE</small>\n                            <div class=\"_500\" ng-bind=\"vm.team.phone\"></div>\n                        </div>\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>FAX</small>\n                            <div class=\"_500\" ng-bind=\"vm.team.fax\"></div>\n                        </div>\n                    </div>\n                    <div class=\"row m-b\">\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>ADMIN</small>\n                            <div class=\"_500\" ng-bind=\"vm.team.admin\"></div>\n                        </div>\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>EMAIL</small>\n                            <div class=\"_500\" ng-bind=\"vm.team.email\"></div>\n                        </div>\n                    </div>\n                    <div class=\"row m-b\">\n                        <div class=\"col-xs-12\">\n                            <small class=\"text-muted\" translate>ABOUT</small>\n                            <div ng-bind-html=\"vm.team.profile_text\"></div>\n                        </div>\n                    </div>\n                    <div class=\"row m-b\" ng-if=\"vm.team.lat && vm.team.lng\">\n                        <div class=\"col-xs-12\">\n                            <small class=\"text-muted\" translate>LOCATION</small>\n                            <ng-map center=\"[{{vm.team.lat}}, {{vm.team.lng}}]\" zoom=\"7\">\n                                <marker id=\"teamMarker\"\n                                        centered=\"true\"\n                                        position=\"{{vm.team.lat}}, {{vm.team.lng}}\"\n                                        draggable=\"true\"\n                                        on-dragend=\"vm.getCurrentLocation()\"></marker>\n                            </ng-map>\n                        </div>\n                    </div>\n                </div>\n                <div ng-if=\"vm.activeOption == 2\" class=\"box-body\">\n                <button type=\"button\"\n                    ng-if=\"vm.hasPermission(vm.rootScope.permissions.VALIDATE_PASSPORT)\"\n                    ng-click=\"vm.printCards()\"\n                    class=\"btn btn-sm btn-info m-b-1\">\n                    <i class=\"fa fa-plus\"></i> {{'ATHLETE_CARDS' | translate}}\n                </button>\n                <div class=\"box-divider m-a-0\"></div>\n                    <div class=\"table-responsive m-b-lg\">\n                        <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"changePasswordModal\" class=\"modal black-overlay\"\n     data-backdrop=\"false\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.CHANGE_TEAM_PASSWORD)\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" translate>CHANGE_TEAM_PASSWORD</h5>\n            </div>\n            <div class=\"b-b m-b-1 m-t-1 text-center\">\n                <h3 class=\"_300 ng-binding\" translate ng-bind=\"vm.team.teamName\"></h3>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"changePasswordForm\" class=\"p-x-xs\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-4 form-control-label\">{{'NEW_PASSWORD' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"password\" name=\"password\" class=\"form-control\" ng-minlength=\"6\"\n                                   required ng-model=\"vm.password.password\"/>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-4 form-control-label\">{{'NEW_PASSWORD_CONFIRMATION' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"password\" class=\"form-control\" ng-minlength=\"6\"\n                                   required ng-model=\"vm.password.password_confirmation\"/>\n                        </div>\n                    </div>\n                    <!-- <div class=\"form-group row\">\n                        <label class=\"col-sm-4 form-control-label\">{{'AUTHORIZATION_KEY' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"password\" class=\"form-control\" required ng-model=\"vm.password.auth\"/>\n                        </div>\n                    </div> -->\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        data-dismiss=\"modal\">CANCEL\n                </button>\n                <button type=\"button\"\n                        ng-click=\"vm.changePassword();\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        ng-class=\"{'disabled' : !changePasswordForm.$valid}\"\n                        ng-disabled=\"!changePasswordForm.$valid\"\n                        data-dismiss=\"modal\">SUBMIT\n                </button>\n            </div>\n        </div><!-- /.modal-content -->\n    </div>\n</div>"

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamProfileController = function TeamProfileController(TeamsFactory, AuthFactory, PlayersFactory, $rootScope, $stateParams, $filter, $state, ngDialog, URLS) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, TeamProfileController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	
	  vm.$onInit = function () {
	    vm.options = [{ id: 1, name: "INFORMATION" }, { id: 2, name: "PLAYERS" }];
	    vm.activeOption = 1;
	    vm.teamId = $stateParams.id;
	    vm.team = {};
	    vm.password = {};
	    vm.defaultLat = 39.04157914096756;
	    vm.defaultLng = 23.112951828125006;
	    if (vm.teamId) {
	      TeamsFactory.getOne(vm.teamId, {
	        include: "players,state,county,region"
	      }).then(function (response) {
	        vm.team = response.data;
	        if (!vm.team.lat || !vm.team.lng) {
	          vm.team.lat = vm.defaultLat;
	          vm.team.lng = vm.defaultLng;
	        }
	        vm.gridOptions.data = vm.team.players;
	      });
	    }
	  };
	
	  vm.gridOptions = {
	    enableSorting: true,
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "playerName",
	      name: $translate("NAME"),
	      enableFiltering: true
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + '<div class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<a href class="btn btn-sm primary" translate ' + 'ng-click="grid.appScope.vm.goToPlayerProfile(row.entity.player_id)">PROFILE</a>' + '<button class="btn btn-sm accent m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.VALIDATE_PASSPORT)" ' + 'ng-click="grid.appScope.vm.getPlayerCard(row.entity.player_id)">DOWNLOAD_CARD</button>' + "</div>" + "</div>",
	      width: "400"
	    }]
	  };
	
	  vm.printCards = function () {
	    var tabWindowId = window.open("about:blank", "_blank");
	    TeamsFactory.playerCards(vm.teamId).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	
	  vm.hasPermission = function (permission) {
	    if (vm.rootScope.user.isUserTypeTeam()) {
	      return vm.rootScope.user.isTeam(vm.teamId) && vm.rootScope.user.canDo(permission);
	    } else {
	      return vm.rootScope.user.canDo(permission);
	    }
	  };
	
	  vm.changePassword = function () {
	    vm.password.id = vm.teamId;
	    AuthFactory.changePassword(AuthFactory.USER_TYPES.TEAM, vm.password).then(function (response) {
	      ngDialog.open({ template: "successTemplate" });
	    });
	  };
	
	  vm.getTeamImage = function () {
	    if (vm.team.img) {
	      return URLS.IMAGES_URL + "/teams/" + vm.team.img;
	    } else {
	      return "assets/images/no_avatar.png";
	    }
	  };
	
	  vm.goToPlayerProfile = function (playerId) {
	    $state.go("player-profile", { id: playerId });
	  };
	
	  vm.getPlayerCard = function (playerId) {
	    var tabWindowId = window.open("about:blank", "_blank");
	    PlayersFactory.card(playerId).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	
	  vm.getPlayerTrainingCard = function (playerId) {
	    var tabWindowId = window.open("about:blank", "_blank");
	    PlayersFactory.trainCard(playerId).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	};
	TeamProfileController.$inject = ["TeamsFactory", "AuthFactory", "PlayersFactory", "$rootScope", "$stateParams", "$filter", "$state", "ngDialog", "URLS"];
	
	exports.default = TeamProfileController;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(732);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./teamProfile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./teamProfile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 732 */
560,
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _teamEdit = __webpack_require__(734);
	
	var _teamEdit2 = _interopRequireDefault(_teamEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamEditModule = _angular2.default.module('teamEdit', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('team-edit', {
			url: '/teams/edit/:id',
			component: 'teamEdit',
			data: { pageTitle: 'EDIT_TEAM' },
			params: {
				id: { squash: true, value: null }
			},
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", "$stateParams", function hasPermission($q, $rootScope, Permissions, $stateParams) {
					'ngInject';
	
					var deferred = $q.defer();
	
					if ($rootScope.user.isUserTypeTeam() && $rootScope.user.isTeam($stateParams.id) && $rootScope.user.canDo(Permissions.EDIT_TEAM)) {
						deferred.resolve();
					} else if (!$rootScope.user.isUserTypeTeam() && $rootScope.user.canDo(Permissions.EDIT_TEAM)) {
						deferred.resolve();
					} else {
						deferred.reject("Access denied!");
					}
	
					return deferred.promise;
				}]
			}
		});
	}]).component('teamEdit', _teamEdit2.default).name;
	
	exports.default = teamEditModule;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _teamEdit = __webpack_require__(735);
	
	var _teamEdit2 = _interopRequireDefault(_teamEdit);
	
	var _teamEdit3 = __webpack_require__(736);
	
	var _teamEdit4 = _interopRequireDefault(_teamEdit3);
	
	__webpack_require__(737);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var teamEditComponent = {
	  bindings: {},
	  template: _teamEdit2.default,
	  controller: _teamEdit4.default,
	  controllerAs: "vm"
	};
	
	exports.default = teamEditComponent;

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-sm-12\">\n    <div class=\"box\">\n      <div class=\"b-b m-b-1 p-t-1 p-b-1 text-center\">\n        <h3 class=\"_300 ng-binding\" ng-if=\"!vm.teamId\" translate>\n          CREATE_TEAM\n        </h3>\n        <h3 class=\"_300 ng-binding\" ng-if=\"vm.teamId\" translate>EDIT_TEAM</h3>\n      </div>\n      <form name=\"teamForm\" ng-submit=\"vm.submit()\">\n        <div ng-if=\"vm.rootScope.isSAAF\" class=\"box-body\">\n          <div ng-if=\"!vm.rootScope.user.isUserTypeTeam()\">\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'CODE' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.team.code\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'FULL_NAME' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.team.full_name\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'NAME' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.team.name\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'SORT_NAME' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.team.sort_name\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'REGION' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <ui-select ng-model=\"vm.team.region\" theme=\"bootstrap\">\n                  <ui-select-match\n                    class=\"ui-select-match\"\n                    placeholder=\"{{'SELECT_REGION' | translate}}\"\n                  >\n                    {{$select.selected.region_name}}\n                  </ui-select-match>\n                  <ui-select-choices\n                    class=\"ui-select-choices\"\n                    repeat=\"item in vm.regions | filter: $select.search\"\n                  >\n                    <div\n                      ng-bind-html=\"item.region_name | highlight: $select.search\"\n                    ></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'REGISTRATION_DATE' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <div class=\"dropdown\">\n                  <a\n                    class=\"dropdown-toggle\"\n                    id=\"registrationDate\"\n                    role=\"button\"\n                    data-toggle=\"dropdown\"\n                    data-target=\"#\"\n                    href=\"#\"\n                  >\n                    <div class=\"input-group\">\n                      <span class=\"custom-input\">\n                        {{ vm.team.registration_date | date:'yyyy-MM-dd' }}\n                      </span>\n                      <span class=\"input-group-btn\">\n                        <button class=\"btn white\" type=\"button\" translate>\n                          PICK\n                        </button>\n                      </span>\n                    </div>\n                  </a>\n                  <ul\n                    class=\"dropdown-menu\"\n                    role=\"menu\"\n                    aria-labelledby=\"dLabel\"\n                  >\n                    <datetimepicker\n                      data-ng-model=\"vm.team.registration_date\"\n                      data-datetimepicker-config=\"vm.datePickerConfig\"\n                    />\n                  </ul>\n                </div>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'EMAIL' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-model=\"vm.team.email\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'PHONE' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-model=\"vm.team.phone\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\">IMAGE</label>\n            <div class=\"col-sm-9\">\n              <div class=\"form-file m-b-1\">\n                <input\n                  type=\"file\"\n                  name=\"myImage\"\n                  image-with-preview\n                  ng-model=\"vm.team.image\"\n                  accept=\"image/jpeg,image/jpg,image/png\"\n                  size=\"size < 2097152\"\n                />\n                <button class=\"btn white\" translate>SELECT_FILE</button>\n              </div>\n              <span class=\"error\" ng-show=\"teamForm.myImage.$error.image\">\n                Not a JPEG or a PNG!\n              </span>\n              <span class=\"error\" ng-show=\"teamForm.myImage.$error.size\">\n                Invalid dimensions! Expecting a landscape image smaller than\n                1800x400.\n              </span>\n              <img\n                width=\"150\"\n                ng-show=\"vm.team.image.src\"\n                ng-src=\"{{vm.team.image.src}}\"\n              />\n              <img\n                width=\"150\"\n                ng-hide=\"vm.team.image.src\"\n                ng-src=\"{{vm.getTeamImage()}}\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\"\n              >MAP_LOCATION</label\n            >\n            <div class=\"col-sm-9\" ng-if=\"vm.team.lat\">\n              <ng-map center=\"[{{vm.team.lat}}, {{vm.team.lng}}]\" zoom=\"7\">\n                <marker\n                  id=\"teamMarker\"\n                  centered=\"true\"\n                  position=\"{{vm.team.lat}}, {{vm.team.lng}}\"\n                  draggable=\"true\"\n                  on-dragend=\"vm.getCurrentLocation()\"\n                ></marker>\n              </ng-map>\n            </div>\n          </div>\n        </div>\n        <div ng-if=\"vm.rootScope.isEOT\" class=\"box-body\">\n          <div ng-if=\"!vm.rootScope.user.isUserTypeTeam()\">\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'CODE' | translate}}</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  disabled\n                  class=\"form-control\"\n                  ng-model=\"vm.team.code\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'FULL_NAME' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.team.full_name\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'NAME' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.team.name\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'SORT_NAME' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.team.sort_name\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'ADMIN' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.team.admin\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'IDENTIFY_CODE' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.team.identify_code\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'REGION' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <ui-select ng-model=\"vm.team.region\" theme=\"bootstrap\">\n                  <ui-select-match\n                    class=\"ui-select-match\"\n                    placeholder=\"{{'SELECT_REGION' | translate}}\"\n                  >\n                    {{$select.selected.region_name}}\n                  </ui-select-match>\n                  <ui-select-choices\n                    class=\"ui-select-choices\"\n                    repeat=\"item in vm.regions | filter: $select.search\"\n                  >\n                    <div\n                      ng-bind-html=\"item.region_name | highlight: $select.search\"\n                    ></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'STATE' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <ui-select ng-model=\"vm.team.state\" theme=\"bootstrap\">\n                  <ui-select-match\n                    class=\"ui-select-match\"\n                    placeholder=\"{{'SELECT_STATE' | translate}}\"\n                  >\n                    {{$select.selected.state_name}}\n                  </ui-select-match>\n                  <ui-select-choices\n                    class=\"ui-select-choices\"\n                    repeat=\"item in vm.states | filter: $select.search\"\n                  >\n                    <div\n                      ng-bind-html=\"item.state_name | highlight: $select.search\"\n                    ></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'COUNTY' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <ui-select ng-model=\"vm.team.county\" theme=\"bootstrap\">\n                  <ui-select-match\n                    class=\"ui-select-match\"\n                    placeholder=\"{{'SELECT_COUNTY' | translate}}\"\n                  >\n                    {{$select.selected.county_name}}\n                  </ui-select-match>\n                  <ui-select-choices\n                    class=\"ui-select-choices\"\n                    repeat=\"item in vm.counties | filter: $select.search\"\n                  >\n                    <div\n                      ng-bind-html=\"item.county_name | highlight: $select.search\"\n                    ></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'ADDRESS' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.team.address\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'CITY' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.team.city\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >POSTAL_CODE</label\n              >\n              <div class=\"col-sm-9\">\n                <input type=\"text\" class=\"form-control\" ng-model=\"vm.team.pc\" />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\">FAX</label>\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.team.fax\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\">WEB</label>\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.team.web\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\">VAT</label>\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.team.afm\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\">DOY</label>\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.team.doy\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >HAS_COACH</label\n              >\n              <div class=\"col-sm-9\">\n                <label class=\"ui-switch ui-switch-md info m-t-xs\">\n                  <input type=\"checkbox\" ng-model=\"vm.team.has_coach\" />\n                  <i></i>\n                </label>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'COACH' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  required\n                  class=\"form-control\"\n                  ng-model=\"vm.team.coach_name\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >COACH_EMAIL</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.team.coach_email\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'REGISTRATION_DATE' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <div class=\"dropdown\">\n                  <a\n                    class=\"dropdown-toggle\"\n                    id=\"registrationDate\"\n                    role=\"button\"\n                    data-toggle=\"dropdown\"\n                    data-target=\"#\"\n                    href=\"#\"\n                  >\n                    <div class=\"input-group\">\n                      <span class=\"custom-input\">\n                        {{ vm.team.registration_date | date:'yyyy-MM-dd' }}\n                      </span>\n                      <span class=\"input-group-btn\">\n                        <button class=\"btn white\" type=\"button\" translate>\n                          PICK\n                        </button>\n                      </span>\n                    </div>\n                  </a>\n                  <ul\n                    class=\"dropdown-menu\"\n                    role=\"menu\"\n                    aria-labelledby=\"dLabel\"\n                  >\n                    <datetimepicker\n                      data-ng-model=\"vm.team.registration_date\"\n                      data-datetimepicker-config=\"vm.datePickerConfig\"\n                    />\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'CONTRACT_DATE' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <div class=\"dropdown\">\n                  <a\n                    class=\"dropdown-toggle\"\n                    id=\"contractDate\"\n                    role=\"button\"\n                    data-toggle=\"dropdown\"\n                    data-target=\"#\"\n                    href=\"#\"\n                  >\n                    <div class=\"input-group\">\n                      <span class=\"custom-input\">\n                        {{ vm.team.contract_date | date:'yyyy-MM-dd' }}\n                      </span>\n                      <span class=\"input-group-btn\">\n                        <button class=\"btn white\" type=\"button\" translate>\n                          PICK\n                        </button>\n                      </span>\n                    </div>\n                  </a>\n                  <ul\n                    class=\"dropdown-menu\"\n                    role=\"menu\"\n                    aria-labelledby=\"dLabel\"\n                  >\n                    <datetimepicker\n                      data-ng-model=\"vm.team.contract_date\"\n                      data-datetimepicker-config=\"vm.datePickerContractConfig\"\n                    />\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'IDENTIFY_DATE' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <div class=\"dropdown\">\n                  <a\n                    class=\"dropdown-toggle\"\n                    id=\"identifyDate\"\n                    role=\"button\"\n                    data-toggle=\"dropdown\"\n                    data-target=\"#\"\n                    href=\"#\"\n                  >\n                    <div class=\"input-group\">\n                      <span class=\"custom-input\">\n                        {{ vm.team.identify_date | date:'yyyy-MM-dd' }}\n                      </span>\n                      <span class=\"input-group-btn\">\n                        <button class=\"btn white\" type=\"button\" translate>\n                          PICK\n                        </button>\n                      </span>\n                    </div>\n                  </a>\n                  <ul\n                    class=\"dropdown-menu\"\n                    role=\"menu\"\n                    aria-labelledby=\"dLabel\"\n                  >\n                    <datetimepicker\n                      data-ng-model=\"vm.team.identify_date\"\n                      data-datetimepicker-config=\"vm.datePickerIdentifyConfig\"\n                    />\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >OFFICIAL</label\n              >\n              <div class=\"col-sm-9\">\n                <label class=\"ui-switch ui-switch-md info m-t-xs\">\n                  <input type=\"checkbox\" ng-model=\"vm.team.official\" />\n                  <i></i>\n                </label>\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'EMAIL' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-model=\"vm.team.email\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'PHONE' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-model=\"vm.team.phone\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\">IMAGE</label>\n            <div class=\"col-sm-9\">\n              <div class=\"form-file m-b-1\">\n                <input\n                  type=\"file\"\n                  name=\"myImage\"\n                  image-with-preview\n                  ng-model=\"vm.team.image\"\n                  accept=\"image/jpeg,image/jpg,image/png\"\n                  size=\"size < 2097152\"\n                />\n                <button class=\"btn white\" translate>SELECT_FILE</button>\n              </div>\n              <span class=\"error\" ng-show=\"teamForm.myImage.$error.image\">\n                Not a JPEG or a PNG!\n              </span>\n              <span class=\"error\" ng-show=\"teamForm.myImage.$error.size\">\n                Invalid dimensions! Expecting a landscape image smaller than\n                1800x400.\n              </span>\n              <img\n                width=\"150\"\n                ng-show=\"vm.team.image.src\"\n                ng-src=\"{{vm.team.image.src}}\"\n              />\n              <img\n                width=\"150\"\n                ng-hide=\"vm.team.image.src\"\n                ng-src=\"{{vm.getTeamImage()}}\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\"\n              >MAP_LOCATION</label\n            >\n            <div class=\"col-sm-9\">\n              <ng-map center=\"[{{vm.team.lat}}, {{vm.team.lng}}]\" zoom=\"7\">\n                <marker\n                  id=\"teamMarker\"\n                  centered=\"true\"\n                  position=\"{{vm.team.lat}}, {{vm.team.lng}}\"\n                  draggable=\"true\"\n                  on-dragend=\"vm.getCurrentLocation()\"\n                ></marker>\n              </ng-map>\n            </div>\n          </div>\n        </div>\n        <footer class=\"dker p-a text-left\">\n          <button\n            type=\"submit\"\n            translate\n            class=\"btn success p-x-md m-l-1\"\n            ng-disabled=\"!teamForm.$valid\"\n          >\n            SUBMIT\n          </button>\n          <button\n            type=\"button\"\n            translate\n            ng-if=\"vm.teamId\"\n            ng-click=\"vm.goToProfile()\"\n            class=\"btn info p-x-md m-l-1\"\n          >\n            GO_TO_PROFILE\n          </button>\n        </footer>\n      </form>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamEditController = function TeamEditController(TeamsFactory, MiscFactory, $rootScope, $filter, $state, $stateParams, ngDialog, URLS) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, TeamEditController);
	  var vm = this;
	
	  var $date = $filter("date");
	
	  vm.teamId = $stateParams.id;
	  vm.rootScope = $rootScope;
	
	  vm.$onInit = function () {
	    vm.team = {};
	    vm.regions = [];
	    MiscFactory.getRegions().then(function (response) {
	      vm.regions = response.data;
	    });
	    var defaultLat = 24.7251918;
	    var defaultLng = 46.8225288;
	    if (vm.teamId) {
	      TeamsFactory.getOne(vm.teamId, { include: "region" }).then(function (response) {
	        vm.team = response.data;
	        if (!vm.team.lat || !vm.team.lng) {
	          vm.team.lat = defaultLat;
	          vm.team.lng = defaultLng;
	        }
	      });
	    } else {
	      vm.team.lat = defaultLat;
	      vm.team.lng = defaultLng;
	    }
	  };
	
	  var dateTimePickerDefaultConfig = {
	    startView: "day",
	    minView: "day"
	  };
	  vm.datePickerConfig = (0, _assign2.default)(dateTimePickerDefaultConfig, {
	    dropdownSelector: "#registrationDate"
	  });
	
	  /* On marker drag end */
	  vm.getCurrentLocation = function (event) {
	    vm.team.lat = event.latLng.lat();
	    vm.team.lng = event.latLng.lng();
	  };
	
	  vm.submit = function () {
	    if (!vm.rootScope.user.isUserTypeTeam()) {
	      vm.team.registration_date = $date(vm.team.registration_date, "yyyy-MM-dd");
	    }
	    if (vm.team.team_id) {
	      TeamsFactory.update(vm.team.team_id, vm.team).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        $state.reload();
	      });
	    } else {
	      TeamsFactory.create(vm.team).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        $state.go("team-edit", { id: response.data.team_id });
	      });
	    }
	  };
	
	  vm.getTeamImage = function () {
	    if (vm.team.img) {
	      return URLS.IMAGES_URL + "/teams/" + vm.team.img;
	    } else {
	      return "assets/images/no_avatar.png";
	    }
	  };
	
	  vm.goToProfile = function () {
	    $state.go("team-profile", { id: vm.teamId });
	  };
	};
	TeamEditController.$inject = ["TeamsFactory", "MiscFactory", "$rootScope", "$filter", "$state", "$stateParams", "ngDialog", "URLS"];
	
	exports.default = TeamEditController;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(738);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./teamEdit.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./teamEdit.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 738 */
560,
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _judgesList = __webpack_require__(740);
	
	var _judgesList2 = _interopRequireDefault(_judgesList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var judgesModule = _angular2.default.module('judgesList', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('judges', {
			url: '/judges',
			component: 'judgesList',
			data: { pageTitle: 'JUDGES' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_ALL_JUDGES)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('judgesList', _judgesList2.default).name;
	
	exports.default = judgesModule;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _judgesList = __webpack_require__(741);
	
	var _judgesList2 = _interopRequireDefault(_judgesList);
	
	var _judgesList3 = __webpack_require__(742);
	
	var _judgesList4 = _interopRequireDefault(_judgesList3);
	
	__webpack_require__(743);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var judgesListComponent = {
	  bindings: {},
	  template: _judgesList2.default,
	  controller: _judgesList4.default,
	  controllerAs: "vm"
	};
	
	exports.default = judgesListComponent;

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.ADD_JUDGE)\">\n                <button ui-sref=\"judge-edit\" class=\"btn btn-sm btn-success\">\n                    <i class=\"fa fa-plus\"></i> {{'CREATE' | translate}}\n                </button>\n            </div>\n            <div class=\"table-responsive m-b-lg\">\n                <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JudgesListController = function JudgesListController(JudgesFactory, $rootScope, $filter, $state, ngDialog, URLS) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, JudgesListController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.levels = [{
	    value: 0,
	    name: $translate("JUDGE_STAFF")
	  }, {
	    value: 1,
	    name: $translate("JUDGE_INTERNATIONAL")
	  }, {
	    value: 2,
	    name: $translate("JUDGE_NATIONAL")
	  }, {
	    value: 3,
	    name: $translate("JUDGE_CANDIDATE")
	  }];
	
	  vm.rootScope = $rootScope;
	
	  vm.$onInit = function () {
	    reloadJudges();
	  };
	
	  vm.gridOptions = {
	    enableSorting: true,
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "image",
	      name: "",
	      enableFiltering: false,
	      cellTemplate: '<div class="ui-grid-cell-contents ui-grid-align-c p-t-0">' + '<span class="avatar w-32">' + '<img ng-src="{{grid.appScope.vm.getJudgeImage(row.entity)}}">' + '<i class="on b-white bottom"></i>' + "</span>" + "</div>",
	      width: "80"
	    }, {
	      field: "code",
	      enableFiltering: false,
	      name: $translate("CODE"),
	      width: "110"
	    }, {
	      field: "judgeName",
	      name: $translate("NAME"),
	      enableFiltering: true
	    }, {
	      field: "judgeLevel",
	      name: $translate("JUDGE_LEVEL"),
	      enableFiltering: true,
	      cellTemplate: "" + '<div class="ui-grid-cell-contents p-t-5">' + '<div ng-bind="grid.appScope.vm.getJudgeLevel(row.entity)"></div>' + "</div>"
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + '<div class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<a href class="btn btn-sm btn-info m-l-1" translate ' + 'ng-click="grid.appScope.vm.goToProfile(row.entity.id)">PROFILE</a>' + '<button class="btn btn-sm btn-warning m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_JUDGE)" ' + 'ng-click="grid.appScope.vm.goToEdit(row.entity.id)">EDIT</button>' + '<button class="btn btn-sm btn-danger m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_JUDGE)" ' + 'ng-click="grid.appScope.vm.deleteJudge(row.entity.id)">DELETE</button>' + '<button class="btn btn-sm accent m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.VALIDATE_PASSPORT)" ' + 'ng-click="grid.appScope.vm.getJudgeCard(row.entity.id)">DOWNLOAD_CARD</button>' + "</div>" + "</div>",
	      width: "405"
	    }]
	  };
	
	  vm.getJudgeCard = function (judge) {
	    var tabWindowId = window.open("about:blank", "_blank");
	    JudgesFactory.card(judge).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	
	  vm.getJudgeLevel = function (judge) {
	    return vm.levels.find(function (l) {
	      return l.value === judge.level;
	    }).name;
	  };
	
	  vm.hasPermission = function (permission) {
	    return vm.rootScope.user.canDo(permission);
	  };
	
	  vm.getJudgeImage = function (entity) {
	    if (entity.img) {
	      return URLS.IMAGES_URL + "/judges/" + entity.img;
	    } else {
	      return "assets/images/no_avatar.png";
	    }
	  };
	
	  vm.goToProfile = function (judgeId) {
	    $state.go("judge-profile", { id: judgeId });
	  };
	
	  vm.goToEdit = function (judgeId) {
	    $state.go("judge-edit", { id: judgeId });
	  };
	
	  vm.deleteJudge = function (judgeId) {
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate("CONFIRM_DELETE_JUDGE")
	      }
	    }).then(function () {
	      JudgesFactory.delete(judgeId).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        reloadJudges();
	      });
	    });
	  };
	
	  function reloadJudges() {
	    JudgesFactory.getAll().then(function (response) {
	      vm.gridOptions.data = response.data;
	    });
	  }
	};
	JudgesListController.$inject = ["JudgesFactory", "$rootScope", "$filter", "$state", "ngDialog", "URLS"];
	
	exports.default = JudgesListController;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(744);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./judgesList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./judgesList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 744 */
560,
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _judgeEdit = __webpack_require__(746);
	
	var _judgeEdit2 = _interopRequireDefault(_judgeEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var judgeEditModule = _angular2.default.module('judgeEdit', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('judge-edit', {
			url: '/judges/edit/:id',
			component: 'judgeEdit',
			data: { pageTitle: 'EDIT_JUDGE' },
			params: {
				id: { squash: true, value: null }
			},
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", "$stateParams", function hasPermission($q, $rootScope, Permissions, $stateParams) {
					'ngInject';
	
					var deferred = $q.defer();
	
					if ($rootScope.user.canDo(Permissions.EDIT_JUDGE)) {
						deferred.resolve();
					} else {
						deferred.reject("Access denied!");
					}
	
					return deferred.promise;
				}]
			}
		});
	}]).component('judgeEdit', _judgeEdit2.default).name;
	
	exports.default = judgeEditModule;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _judgeEdit = __webpack_require__(747);
	
	var _judgeEdit2 = _interopRequireDefault(_judgeEdit);
	
	var _judgeEdit3 = __webpack_require__(748);
	
	var _judgeEdit4 = _interopRequireDefault(_judgeEdit3);
	
	__webpack_require__(749);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var judgeEditComponent = {
	  bindings: {},
	  template: _judgeEdit2.default,
	  controller: _judgeEdit4.default,
	  controllerAs: "vm"
	};
	
	exports.default = judgeEditComponent;

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"b-b m-b-1 p-t-1 p-b-1 text-center\">\n                <h3 class=\"_300 ng-binding\" ng-if=\"!vm.judgeId\" translate>CREATE_JUDGE</h3>\n                <h3 class=\"_300 ng-binding\" ng-if=\"vm.judgeId\" translate>EDIT_JUDGE</h3>\n            </div>\n            <form name=\"judgeForm\" ng-submit=\"vm.submit()\">\n                <div class=\"box-body\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'FIRST_NAME' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.judge.first_name\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'LAST_NAME' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.judge.last_name\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'FATHER' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.judge.father\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\" ng-if=\"vm.judgeId\">\n                        <label class=\"col-sm-3 form-control-label\">{{'CODE' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" disabled class=\"form-control\" ng-model=\"vm.judge.code\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'EMAIL' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.judge.email\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'PHONE' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.judge.phone\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'JUDGE_LEVEL' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <ui-select ng-model=\"vm.judge.level\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_LEVEL' | translate}}\">\n                                    {{$select.selected.name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.levels | filter: $select.search\">\n                                    <div ng-bind-html=\"item.name | highlight: $select.search\" translate></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'NOTES' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <textarea class=\"form-control\" ng-model=\"vm.judge.notes\" rows=\"5\"></textarea>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">IMAGE</label>\n                        <div class=\"col-sm-9\">\n                            <div class=\"form-file m-b-1\">\n                                <input type=\"file\" name=\"myImage\" image-with-preview\n                                       ng-model=\"vm.judge.image\"\n                                       accept=\"image/jpeg,image/jpg,image/png\"\n                                       size=\"size < 2097152\">\n                                <button class=\"btn white\" translate>SELECT_FILE</button>\n                            </div>\n                            <span class=\"error\" ng-show=\"judgeForm.myImage.$error.image\">\n                                Not a JPEG or a PNG!\n                            </span>\n                            <span class=\"error\" ng-show=\"judgeForm.myImage.$error.size\">\n                                Invalid dimensions! Expecting a landscape image smaller than 1800x400.\n                            </span>\n                            <img width=\"150\"\n                                 ng-show=\"vm.judge.img.src\"\n                                 ng-src=\"{{vm.judge.img.src}}\"/>\n                            <img width=\"150\"\n                                 ng-hide=\"vm.judge.img.src\"\n                                 ng-src=\"{{vm.getJudgeImage()}}\"/>\n                        </div>\n                    </div>\n                </div>\n                <footer class=\"dker p-a text-left\">\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn success p-x-md m-l-1\"\n                            ng-disabled=\"!judgeForm.$valid\">SUBMIT\n                    </button>\n                    <button type=\"button\"\n                            translate\n                            ng-if=\"vm.judgeId\"\n                            ng-click=\"vm.goToProfile()\"\n                            class=\"btn info p-x-md m-l-1\">GO_TO_PROFILE\n                    </button>\n                </footer>\n            </form>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JudgeEditController = function JudgeEditController(JudgesFactory, MiscFactory, $rootScope, $filter, $state, $stateParams, ngDialog, URLS) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, JudgeEditController);
		var vm = this;
	
		vm.judgeId = $stateParams.id;
		vm.rootScope = $rootScope;
	
		var $translate = $filter('translate');
	
		vm.levels = [{
			value: 0,
			name: $translate('JUDGE_STAFF')
		}, {
			value: 1,
			name: $translate('JUDGE_INTERNATIONAL')
		}, {
			value: 2,
			name: $translate('JUDGE_NATIONAL')
		}, {
			value: 3,
			name: $translate('JUDGE_CANDIDATE')
		}];
	
		vm.$onInit = function () {
			vm.judge = {};
			if (vm.judgeId) {
				JudgesFactory.getOne(vm.judgeId).then(function (response) {
					vm.judge = response.data;
					vm.judge.level = vm.levels.find(function (l) {
						return l.value === vm.judge.level;
					});
				});
			}
		};
	
		vm.submit = function () {
			vm.judge.level = vm.judge.level.value;
			if (vm.judge.id) {
				/* UPDATE MATCH */
				JudgesFactory.update(vm.judge.id, vm.judge).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					$state.reload();
				});
			} else {
				/* NEW MATCH */
				JudgesFactory.create(vm.judge).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					$state.go('judge-edit', { id: response.data.id });
				});
			}
		};
	
		vm.getJudgeImage = function () {
			if (vm.judge.img) {
				return URLS.IMAGES_URL + "/judges/" + vm.judge.img;
			} else {
				return 'assets/images/no_avatar.png';
			}
		};
	
		vm.goToProfile = function () {
			$state.go('judge-profile', { id: vm.judgeId });
		};
	};
	JudgeEditController.$inject = ["JudgesFactory", "MiscFactory", "$rootScope", "$filter", "$state", "$stateParams", "ngDialog", "URLS"];
	
	exports.default = JudgeEditController;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(750);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./judgeEdit.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./judgeEdit.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 750 */
560,
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _judgeProfile = __webpack_require__(752);
	
	var _judgeProfile2 = _interopRequireDefault(_judgeProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var judgeProfileModule = _angular2.default.module('judgeProfile', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('judge-profile', {
			url: '/judges/{id}/profile',
			component: 'judgeProfile',
			data: { pageTitle: 'JUDGE_PROFILE' }
		});
	}]).component('judgeProfile', _judgeProfile2.default).name;
	
	exports.default = judgeProfileModule;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _judgeProfile = __webpack_require__(753);
	
	var _judgeProfile2 = _interopRequireDefault(_judgeProfile);
	
	var _judgeProfile3 = __webpack_require__(754);
	
	var _judgeProfile4 = _interopRequireDefault(_judgeProfile3);
	
	__webpack_require__(755);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var judgeProfileComponent = {
	  bindings: {},
	  template: _judgeProfile2.default,
	  controller: _judgeProfile4.default,
	  controllerAs: "vm"
	};
	
	exports.default = judgeProfileComponent;

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"item\" ng-if=\"vm.judge.id\">\n    <div class=\"item-bg\">\n        <img ng-src=\"{{vm.getJudgeImage()}}\" class=\"blur opacity-3\">\n    </div>\n    <div class=\"p-a-md\">\n        <div class=\"row m-t\">\n            <div class=\"col-sm-12\">\n                <a href class=\"pull-left m-r-md\">\n                    <span class=\"avatar w-96\">\n                      <img ng-src=\"{{vm.getJudgeImage()}}\" />\n                      <i class=\"on b-white\"></i>\n                    </span>\n                </a>\n                <div ng-if=\"vm.judge\" class=\"clear\">\n                    <h4 class=\"m-a-0 m-b-xs\" ng-bind=\"vm.judge.judgeName\"></h4>\n                    <div class=\"block clearfix\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.EDIT_JUDGE)\">\n                        <button translate\n                                ui-sref=\"judge-edit({id:{{vm.judge.id}}})\"\n                                class=\"btn btn-sm btn-warning btn-rounded m-b\">EDIT_JUDGE\n                        </button>\n                    </div>\n                    <div class=\"block clearfix\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.VALIDATE_PASSPORT)\">\n                        <button translate\n                                ng-click=\"vm.getJudgeCard()\"\n                                class=\"btn btn-sm accent btn-rounded m-b\">DOWNLOAD_CARD\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"padding\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <div class=\"box\">\n                <div class=\"box-body\">\n                    <button class=\"btn btn-fw m-l-1\"\n                            translate\n                            ng-repeat=\"option in vm.options\"\n                            ng-class=\"{'success' : vm.activeOption == option.id, 'white' : vm.activeOption != option.id}\"\n                            ng-click=\"vm.activeOption = option.id\">\n                        {{option.name}}\n                    </button>\n                </div>\n                <div class=\"box-divider m-a-0\"></div>\n                <div ng-if=\"vm.activeOption == 1\" class=\"box-body\">\n                    <div class=\"row m-b\">\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>FIRST_NAME</small>\n                            <div class=\"_500\" ng-bind=\"vm.judge.first_name\"></div>\n                        </div>\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>LAST_NAME</small>\n                            <div class=\"_500\" ng-bind=\"vm.judge.last_name\"></div>\n                        </div>\n                    </div>\n                    <div class=\"row m-b\">\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>PHONE</small>\n                            <div class=\"_500\" ng-bind=\"vm.judge.phone\"></div>\n                        </div>\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>EMAIL</small>\n                            <div class=\"_500\" ng-bind=\"vm.judge.email\"></div>\n                        </div>\n                    </div>\n                </div>\n                <div ng-if=\"vm.activeOption == 2\" class=\"box-body\">\n                    <div class=\"table-responsive m-b-lg\">\n                        <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JudgeProfileController = function JudgeProfileController(JudgesFactory, AuthFactory, PlayersFactory, $rootScope, $stateParams, $filter, $state, ngDialog, URLS) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, JudgeProfileController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		vm.rootScope = $rootScope;
	
		vm.$onInit = function () {
			vm.options = [{ id: 1, name: 'INFORMATION' }, { id: 2, name: 'MATCHES' }];
			vm.activeOption = 1;
			vm.judgeId = $stateParams.id;
			vm.judge = {};
			if (vm.judgeId) {
				JudgesFactory.getOne(vm.judgeId).then(function (response) {
					vm.judge = response.data;
					vm.gridOptions.data = vm.judge.matches;
				});
			}
		};
	
		vm.gridOptions = {
			enableSorting: true,
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'matchSortName',
				name: $translate('NAME'),
				enableFiltering: true
			}, {
				field: 'matchDate',
				name: $translate('DATE'),
				enableFiltering: true,
				width: '200'
			}]
		};
	
		vm.hasPermission = function (permission) {
			return vm.rootScope.user.canDo(permission);
		};
	
		vm.goToMatchProfile = function (matchId) {
			$state.go('match-profile', { id: matchId });
		};
	
		vm.getJudgeImage = function () {
			if (vm.judge.img) {
				return URLS.IMAGES_URL + "/judges/" + vm.judge.img;
			} else {
				return 'assets/images/no_avatar.png';
			}
		};
	
		vm.getJudgeCard = function () {
			var tabWindowId = window.open('about:blank', '_blank');
			JudgesFactory.card(vm.judgeId).then(function (response) {
				var file = new Blob([response.data], { type: 'application/pdf' });
				tabWindowId.location.href = window.URL.createObjectURL(file);
			});
		};
	};
	JudgeProfileController.$inject = ["JudgesFactory", "AuthFactory", "PlayersFactory", "$rootScope", "$stateParams", "$filter", "$state", "ngDialog", "URLS"];
	
	exports.default = JudgeProfileController;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(756);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./judgeProfile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./judgeProfile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 756 */
560,
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _coachesList = __webpack_require__(758);
	
	var _coachesList2 = _interopRequireDefault(_coachesList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var coachesModule = _angular2.default.module('coachesList', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('coaches', {
			url: '/coaches',
			component: 'coachesList',
			data: { pageTitle: 'COACHES' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_ALL_COACHES)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('coachesList', _coachesList2.default).name;
	
	exports.default = coachesModule;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coachesList = __webpack_require__(759);
	
	var _coachesList2 = _interopRequireDefault(_coachesList);
	
	var _coachesList3 = __webpack_require__(760);
	
	var _coachesList4 = _interopRequireDefault(_coachesList3);
	
	__webpack_require__(761);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var coachesListComponent = {
	  bindings: {},
	  template: _coachesList2.default,
	  controller: _coachesList4.default,
	  controllerAs: "vm"
	};
	
	exports.default = coachesListComponent;

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.ADD_COACH)\">\n                <button ui-sref=\"coach-edit\" class=\"btn btn-sm btn-success\">\n                    <i class=\"fa fa-plus\"></i> {{'CREATE' | translate}}\n                </button>\n            </div>\n            <div class=\"table-responsive m-b-lg\">\n                <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CoachesListController = function CoachesListController(CoachesFactory, $rootScope, $filter, $state, ngDialog, URLS) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, CoachesListController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	
	  vm.levels = [{
	    value: 0,
	    name: $translate("COACH_0_LEVEL")
	  }, {
	    value: 1,
	    name: $translate("COACH_A_LEVEL")
	  }, {
	    value: 2,
	    name: $translate("COACH_B_LEVEL")
	  }, {
	    value: 3,
	    name: $translate("COACH_C_LEVEL")
	  }];
	
	  vm.$onInit = function () {
	    reloadCoaches();
	  };
	
	  vm.gridOptions = {
	    enableSorting: true,
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "image",
	      name: "",
	      enableFiltering: false,
	      cellTemplate: '<div class="ui-grid-cell-contents ui-grid-align-c p-t-0">' + '<span class="avatar w-32">' + '<img ng-src="{{grid.appScope.vm.getCoachImage(row.entity)}}">' + '<i class="on b-white bottom"></i>' + "</span>" + "</div>",
	      width: "80"
	    }, {
	      field: "code",
	      enableFiltering: false,
	      name: $translate("CODE"),
	      width: "110"
	    }, {
	      field: "coachName",
	      name: $translate("NAME"),
	      enableFiltering: true
	    }, {
	      field: "coachLevel",
	      name: $translate("COACH_LEVEL"),
	      enableFiltering: true,
	      cellTemplate: "" + '<div class="ui-grid-cell-contents p-t-5">' + '<div ng-bind="grid.appScope.vm.getCoachLevel(row.entity)"></div>' + "</div>"
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + '<div class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<a href class="btn btn-sm btn-info m-l-1" translate ' + 'ng-click="grid.appScope.vm.goToProfile(row.entity.id)">PROFILE</a>' + '<button class="btn btn-sm btn-warning m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_COACH)" ' + 'ng-click="grid.appScope.vm.goToEdit(row.entity.id)">EDIT</button>' + '<button class="btn btn-sm btn-danger m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_COACH)" ' + 'ng-click="grid.appScope.vm.deleteCoach(row.entity.id)">DELETE</button>' + '<button class="btn btn-sm accent m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.VALIDATE_PASSPORT)" ' + 'ng-click="grid.appScope.vm.getCoachCard(row.entity.id)">DOWNLOAD_CARD</button>' + "</div>" + "</div>",
	      width: "400"
	    }]
	  };
	
	  vm.getCoachCard = function (coach) {
	    var tabWindowId = window.open("about:blank", "_blank");
	    CoachesFactory.card(coach).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	
	  vm.getCoachLevel = function (coach) {
	    return vm.levels.find(function (l) {
	      return l.value === coach.level;
	    }).name;
	  };
	
	  vm.hasPermission = function (permission) {
	    return vm.rootScope.user.canDo(permission);
	  };
	
	  vm.getCoachImage = function (entity) {
	    if (entity.img) {
	      return URLS.IMAGES_URL + "/coaches/" + entity.img;
	    } else {
	      return "assets/images/no_avatar.png";
	    }
	  };
	
	  vm.goToProfile = function (coachId) {
	    $state.go("coach-profile", { id: coachId });
	  };
	
	  vm.goToEdit = function (coachId) {
	    $state.go("coach-edit", { id: coachId });
	  };
	
	  vm.deleteCoach = function (coachId) {
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate("CONFIRM_DELETE_COACH")
	      }
	    }).then(function () {
	      CoachesFactory.delete(coachId).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        reloadCoaches();
	      });
	    });
	  };
	
	  function reloadCoaches() {
	    CoachesFactory.getAll().then(function (response) {
	      vm.gridOptions.data = response.data;
	    });
	  }
	};
	CoachesListController.$inject = ["CoachesFactory", "$rootScope", "$filter", "$state", "ngDialog", "URLS"];
	
	exports.default = CoachesListController;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(762);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./coachesList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./coachesList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 762 */
560,
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _coachEdit = __webpack_require__(764);
	
	var _coachEdit2 = _interopRequireDefault(_coachEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var coachEditModule = _angular2.default.module('coachEdit', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('coach-edit', {
			url: '/coaches/edit/:id',
			component: 'coachEdit',
			data: { pageTitle: 'EDIT_COACH' },
			params: {
				id: { squash: true, value: null }
			},
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", "$stateParams", function hasPermission($q, $rootScope, Permissions, $stateParams) {
					'ngInject';
	
					var deferred = $q.defer();
	
					if ($rootScope.user.canDo(Permissions.EDIT_COACH)) {
						deferred.resolve();
					} else {
						deferred.reject("Access denied!");
					}
	
					return deferred.promise;
				}]
			}
		});
	}]).component('coachEdit', _coachEdit2.default).name;
	
	exports.default = coachEditModule;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coachEdit = __webpack_require__(765);
	
	var _coachEdit2 = _interopRequireDefault(_coachEdit);
	
	var _coachEdit3 = __webpack_require__(766);
	
	var _coachEdit4 = _interopRequireDefault(_coachEdit3);
	
	__webpack_require__(767);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var coachEditComponent = {
	  bindings: {},
	  template: _coachEdit2.default,
	  controller: _coachEdit4.default,
	  controllerAs: "vm"
	};
	
	exports.default = coachEditComponent;

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"b-b m-b-1 p-t-1 p-b-1 text-center\">\n                <h3 class=\"_300 ng-binding\" ng-if=\"!vm.coachId\" translate>CREATE_COACH</h3>\n                <h3 class=\"_300 ng-binding\" ng-if=\"vm.coachId\" translate>EDIT_COACH</h3>\n            </div>\n            <form name=\"coachForm\" ng-submit=\"vm.submit()\">\n                <div class=\"box-body\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'FIRST_NAME' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.coach.first_name\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'LAST_NAME' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.coach.last_name\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'FATHER' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.coach.father\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\" ng-if=\"vm.coachId\">\n                        <label class=\"col-sm-3 form-control-label\">{{'CODE' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" disabled class=\"form-control\" ng-model=\"vm.coach.code\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'EMAIL' | translate}}</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"vm.coach.email\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'PHONE' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.coach.phone\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'NOTES' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <textarea class=\"form-control\" ng-model=\"vm.coach.notes\" rows=\"5\"></textarea>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'COACH_LEVEL' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <ui-select ng-model=\"vm.coach.level\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_LEVEL' | translate}}\">\n                                    {{$select.selected.name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.levels | filter: $select.search\">\n                                    <div ng-bind-html=\"item.name | highlight: $select.search\" translate></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'GGA_NUMBER' | translate}}</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" class=\"form-control\" ng-model=\"vm.coach.gga_number\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'DATE_FILED' | translate}}</label>\n                        <div class=\"col-sm-9\">\n                            <div class=\"dropdown\">\n                                <a class=\"dropdown-toggle\" id=\"date_filed\" role=\"button\"\n                                   data-toggle=\"dropdown\" data-target=\"#\" href=\"#\">\n                                    <div class=\"input-group\">\n                                        <span class=\"custom-input\">\n                                            {{ vm.coach.date_filed | date:'yyyy-MM-dd' }}\n                                        </span>\n                                        <span class=\"input-group-btn\">\n                                            <button class=\"btn white\" type=\"button\" translate>PICK</button>\n                                        </span>\n                                    </div>\n                                </a>\n                                <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                                    <datetimepicker\n                                            data-ng-model=\"vm.coach.date_filed\"\n                                            data-datetimepicker-config=\"vm.datePickerBirthConfig\"/>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">ACTIVE</label>\n                        <div class=\"col-sm-9\">\n                            <label class=\"ui-switch ui-switch-md info m-t-xs\">\n                                <input type=\"checkbox\" ng-model=\"vm.coach.active\">\n                                <i></i>\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">IMAGE</label>\n                        <div class=\"col-sm-9\">\n                            <div class=\"form-file m-b-1\">\n                                <input type=\"file\" name=\"myImage\" image-with-preview\n                                       ng-model=\"vm.coach.image\"\n                                       accept=\"image/jpeg,image/jpg,image/png\"\n                                       size=\"size < 2097152\">\n                                <button class=\"btn white\" translate>SELECT_FILE</button>\n                            </div>\n                            <span class=\"error\" ng-show=\"coachForm.myImage.$error.image\">\n                                Not a JPEG or a PNG!\n                            </span>\n                            <span class=\"error\" ng-show=\"coachForm.myImage.$error.size\">\n                                Invalid dimensions! Expecting a landscape image smaller than 1800x400.\n                            </span>\n                            <img width=\"150\"\n                                 ng-show=\"vm.coach.img.src\"\n                                 ng-src=\"{{vm.coach.img.src}}\"/>\n                            <img width=\"150\"\n                                 ng-hide=\"vm.coach.img.src\"\n                                 ng-src=\"{{vm.getCoachImage()}}\"/>\n                        </div>\n                    </div>\n                </div>\n                <footer class=\"dker p-a text-left\">\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn success p-x-md m-l-1\"\n                            ng-disabled=\"!coachForm.$valid\">SUBMIT\n                    </button>\n                    <button type=\"button\"\n                            translate\n                            ng-if=\"vm.coachId\"\n                            ng-click=\"vm.goToProfile()\"\n                            class=\"btn info p-x-md m-l-1\">GO_TO_PROFILE\n                    </button>\n                </footer>\n            </form>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CoachEditController = function CoachEditController(CoachesFactory, MiscFactory, $rootScope, $filter, $state, $stateParams, ngDialog, URLS) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, CoachEditController);
		var vm = this;
	
		var $date = $filter('date');
	
		var $translate = $filter('translate');
	
		vm.levels = [{
			value: 0,
			name: $translate('COACH_0_LEVEL')
		}, {
			value: 1,
			name: $translate('COACH_A_LEVEL')
		}, {
			value: 2,
			name: $translate('COACH_B_LEVEL')
		}, {
			value: 3,
			name: $translate('COACH_C_LEVEL')
		}];
	
		var dateTimePickerDefaultConfig = {
			startView: 'day',
			minView: 'day'
		};
	
		vm.coachId = $stateParams.id;
		vm.rootScope = $rootScope;
		vm.datePickerBirthConfig = (0, _assign2.default)(dateTimePickerDefaultConfig, { dropdownSelector: '#date_filed' });
	
		vm.$onInit = function () {
			vm.coach = {};
			if (vm.coachId) {
				CoachesFactory.getOne(vm.coachId).then(function (response) {
					vm.coach = response.data;
					vm.coach.active = vm.coach.active === 1;
					vm.coach.level = vm.levels.find(function (l) {
						return l.value === vm.coach.level;
					});
				});
			}
		};
	
		vm.submit = function () {
			vm.coach.active = vm.coach.active ? 1 : 0;
			vm.coach.level = vm.coach.level.value;
			vm.coach.date_filed = $date(vm.coach.date_filed, 'yyyy-MM-dd');
			if (vm.coach.id) {
				/* UPDATE MATCH */
				CoachesFactory.update(vm.coach.id, vm.coach).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					$state.reload();
				});
			} else {
				/* NEW MATCH */
				CoachesFactory.create(vm.coach).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					$state.go('coach-edit', { id: response.data.id });
				});
			}
		};
	
		vm.getCoachImage = function () {
			if (vm.coach.img) {
				return URLS.IMAGES_URL + "/coaches/" + vm.coach.img;
			} else {
				return 'assets/images/no_avatar.png';
			}
		};
	
		vm.goToProfile = function () {
			$state.go('coach-profile', { id: vm.coachId });
		};
	};
	CoachEditController.$inject = ["CoachesFactory", "MiscFactory", "$rootScope", "$filter", "$state", "$stateParams", "ngDialog", "URLS"];
	
	exports.default = CoachEditController;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(768);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./coachEdit.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./coachEdit.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 768 */
560,
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _coachProfile = __webpack_require__(770);
	
	var _coachProfile2 = _interopRequireDefault(_coachProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var coachProfileModule = _angular2.default.module('coachProfile', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('coach-profile', {
			url: '/coaches/{id}/profile',
			component: 'coachProfile',
			data: { pageTitle: 'COACH_PROFILE' }
		});
	}]).component('coachProfile', _coachProfile2.default).name;
	
	exports.default = coachProfileModule;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coachProfile = __webpack_require__(771);
	
	var _coachProfile2 = _interopRequireDefault(_coachProfile);
	
	var _coachProfile3 = __webpack_require__(772);
	
	var _coachProfile4 = _interopRequireDefault(_coachProfile3);
	
	__webpack_require__(773);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var coachProfileComponent = {
	  bindings: {},
	  template: _coachProfile2.default,
	  controller: _coachProfile4.default,
	  controllerAs: "vm"
	};
	
	exports.default = coachProfileComponent;

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"item\" ng-if=\"vm.coach.id\">\n    <div class=\"item-bg\">\n        <img ng-src=\"{{vm.getCoachImage()}}\" class=\"blur opacity-3\">\n    </div>\n    <div class=\"p-a-md\">\n        <div class=\"row m-t\">\n            <div class=\"col-sm-12\">\n                <a href class=\"pull-left m-r-md\">\n                    <span class=\"avatar w-96\">\n                      <img ng-src=\"{{vm.getCoachImage()}}\" />\n                      <i class=\"on b-white\"></i>\n                    </span>\n                </a>\n                <div ng-if=\"vm.coach\" class=\"clear\">\n                    <h4 class=\"m-a-0 m-b-xs\" ng-bind=\"vm.coach.coachName\"></h4>\n                    <div class=\"block clearfix\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.EDIT_COACH)\">\n                        <button translate\n                                ui-sref=\"coach-edit({id:{{vm.coach.id}}})\"\n                                class=\"btn btn-sm btn-warning btn-rounded m-b\">EDIT_COACH\n                        </button>\n                    </div>\n                    <div class=\"block clearfix\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.VALIDATE_PASSPORT)\">\n                        <button translate\n                                ng-click=\"vm.getCoachCard()\"\n                                class=\"btn btn-sm accent btn-rounded m-b\">DOWNLOAD_CARD\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"padding\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <div class=\"box\">\n                <div class=\"box-body\">\n                    <button class=\"btn btn-fw m-l-1\"\n                            translate\n                            ng-repeat=\"option in vm.options\"\n                            ng-class=\"{'success' : vm.activeOption == option.id, 'white' : vm.activeOption != option.id}\"\n                            ng-click=\"vm.activeOption = option.id\">\n                        {{option.name}}\n                    </button>\n                </div>\n                <div class=\"box-divider m-a-0\"></div>\n                <div ng-if=\"vm.activeOption == 1\" class=\"box-body\">\n                    <div class=\"row m-b\">\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>FIRST_NAME</small>\n                            <div class=\"_500\" ng-bind=\"vm.coach.first_name\"></div>\n                        </div>\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>LAST_NAME</small>\n                            <div class=\"_500\" ng-bind=\"vm.coach.last_name\"></div>\n                        </div>\n                    </div>\n                    <div class=\"row m-b\">\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>PHONE</small>\n                            <div class=\"_500\" ng-bind=\"vm.coach.phone\"></div>\n                        </div>\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>EMAIL</small>\n                            <div class=\"_500\" ng-bind=\"vm.coach.email\"></div>\n                        </div>\n                    </div>\n                </div>\n                <div ng-if=\"vm.activeOption == 2\" class=\"box-body\">\n                    <div class=\"table-responsive m-b-lg\">\n                        <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CoachProfileController = function CoachProfileController(CoachesFactory, AuthFactory, PlayersFactory, $rootScope, $stateParams, $filter, $state, ngDialog, URLS) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, CoachProfileController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		vm.rootScope = $rootScope;
	
		vm.$onInit = function () {
			vm.options = [{ id: 1, name: 'INFORMATION' }];
			vm.activeOption = 1;
			vm.coachId = $stateParams.id;
			vm.coach = {};
			if (vm.coachId) {
				CoachesFactory.getOne(vm.coachId).then(function (response) {
					vm.coach = response.data;
				});
			}
		};
	
		vm.hasPermission = function (permission) {
			return vm.rootScope.user.canDo(permission);
		};
	
		vm.getCoachImage = function () {
			if (vm.coach.img) {
				return URLS.IMAGES_URL + "/coaches/" + vm.coach.img;
			} else {
				return 'assets/images/no_avatar.png';
			}
		};
	
		vm.getCoachCard = function () {
			var tabWindowId = window.open('about:blank', '_blank');
			CoachesFactory.card(vm.coachId).then(function (response) {
				var file = new Blob([response.data], { type: 'application/pdf' });
				tabWindowId.location.href = window.URL.createObjectURL(file);
			});
		};
	};
	CoachProfileController.$inject = ["CoachesFactory", "AuthFactory", "PlayersFactory", "$rootScope", "$stateParams", "$filter", "$state", "ngDialog", "URLS"];
	
	exports.default = CoachProfileController;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(774);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./coachProfile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./coachProfile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 774 */
560,
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _staffList = __webpack_require__(776);
	
	var _staffList2 = _interopRequireDefault(_staffList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var staffModule = _angular2.default.module("staffList", [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("staff", {
	    url: "/staff",
	    component: "staffList",
	    data: { pageTitle: "STAFF" },
	    resolve: {
	      hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
	        "ngInject";
	
	        var deferred = $q.defer();
	        if ($rootScope.user.canDo(Permissions.VIEW_ALL_STAFF)) {
	          deferred.resolve();
	        } else {
	          deferred.reject("Access Denied!!");
	        }
	        return deferred.promise;
	      }]
	    }
	  });
	}]).component("staffList", _staffList2.default).name;
	
	exports.default = staffModule;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _staffList = __webpack_require__(777);
	
	var _staffList2 = _interopRequireDefault(_staffList);
	
	var _staffList3 = __webpack_require__(778);
	
	var _staffList4 = _interopRequireDefault(_staffList3);
	
	__webpack_require__(779);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var staffListComponent = {
	  bindings: {},
	  template: _staffList2.default,
	  controller: _staffList4.default,
	  controllerAs: "vm"
	};
	
	exports.default = staffListComponent;

/***/ }),
/* 777 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.ADD_STAFF)\">\n                <button ui-sref=\"staff-edit\" class=\"btn btn-sm btn-success\">\n                    <i class=\"fa fa-plus\"></i> {{'CREATE' | translate}}\n                </button>\n            </div>\n            <div class=\"table-responsive m-b-lg\">\n                <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StaffListController = function StaffListController(StaffFactory, $rootScope, $filter, $state, ngDialog, URLS) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, StaffListController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	
	  vm.$onInit = function () {
	    reloadStaff();
	  };
	
	  vm.gridOptions = {
	    enableSorting: true,
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "image",
	      name: "",
	      enableFiltering: false,
	      cellTemplate: '<div class="ui-grid-cell-contents ui-grid-align-c p-t-0">' + '<span class="avatar w-32">' + '<img ng-src="{{grid.appScope.vm.getStaffImage(row.entity)}}">' + '<i class="on b-white bottom"></i>' + "</span>" + "</div>",
	      width: "80"
	    }, {
	      field: "code",
	      enableFiltering: false,
	      name: $translate("CODE"),
	      width: "110"
	    }, {
	      field: "staffName",
	      name: $translate("NAME"),
	      enableFiltering: true
	    }, {
	      field: "type",
	      name: $translate("TYPE"),
	      enableFiltering: true
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + '<div class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<a href class="btn btn-sm btn-info m-l-1" translate ' + 'ng-click="grid.appScope.vm.goToProfile(row.entity.id)">PROFILE</a>' + '<button class="btn btn-sm btn-warning m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_STAFF)" ' + 'ng-click="grid.appScope.vm.goToEdit(row.entity.id)">EDIT</button>' + '<button class="btn btn-sm btn-danger m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_STAFF)" ' + 'ng-click="grid.appScope.vm.deleteStaff(row.entity.id)">DELETE</button>' + '<button class="btn btn-sm accent m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.VALIDATE_PASSPORT)" ' + 'ng-click="grid.appScope.vm.getCard(row.entity.id)">DOWNLOAD_CARD</button>' + "</div>" + "</div>",
	      width: "400"
	    }]
	  };
	
	  vm.getCard = function (staff) {
	    var tabWindowId = window.open("about:blank", "_blank");
	    StaffFactory.card(staff).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	
	  vm.hasPermission = function (permission) {
	    return vm.rootScope.user.canDo(permission);
	  };
	
	  vm.getStaffImage = function (entity) {
	    if (entity.img) {
	      return URLS.IMAGES_URL + "/staff/" + entity.img;
	    } else {
	      return "assets/images/no_avatar.png";
	    }
	  };
	
	  vm.goToProfile = function (staffId) {
	    $state.go("staff-profile", { id: staffId });
	  };
	
	  vm.goToEdit = function (staffId) {
	    $state.go("staff-edit", { id: staffId });
	  };
	
	  vm.deleteStaff = function (staffId) {
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate("CONFIRM_DELETE_STAFF")
	      }
	    }).then(function () {
	      StaffFactory.delete(staffId).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        reloadStaff();
	      });
	    });
	  };
	
	  function reloadStaff() {
	    StaffFactory.getAll().then(function (response) {
	      vm.gridOptions.data = response.data;
	    });
	  }
	};
	StaffListController.$inject = ["StaffFactory", "$rootScope", "$filter", "$state", "ngDialog", "URLS"];
	
	exports.default = StaffListController;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(780);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./staffList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./staffList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 780 */
560,
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _staffEdit = __webpack_require__(782);
	
	var _staffEdit2 = _interopRequireDefault(_staffEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var staffEditModule = _angular2.default.module('staffEdit', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('staff-edit', {
			url: '/staff/edit/:id',
			component: 'staffEdit',
			data: { pageTitle: 'EDIT_STAFF' },
			params: {
				id: { squash: true, value: null }
			},
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", "$stateParams", function hasPermission($q, $rootScope, Permissions, $stateParams) {
					'ngInject';
	
					var deferred = $q.defer();
	
					if ($rootScope.user.canDo(Permissions.EDIT_STAFF)) {
						deferred.resolve();
					} else {
						deferred.reject("Access denied!");
					}
	
					return deferred.promise;
				}]
			}
		});
	}]).component('staffEdit', _staffEdit2.default).name;
	
	exports.default = staffEditModule;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _staffEdit = __webpack_require__(783);
	
	var _staffEdit2 = _interopRequireDefault(_staffEdit);
	
	var _staffEdit3 = __webpack_require__(784);
	
	var _staffEdit4 = _interopRequireDefault(_staffEdit3);
	
	__webpack_require__(785);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var staffEditComponent = {
	  bindings: {},
	  template: _staffEdit2.default,
	  controller: _staffEdit4.default,
	  controllerAs: "vm"
	};
	
	exports.default = staffEditComponent;

/***/ }),
/* 783 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"b-b m-b-1 p-t-1 p-b-1 text-center\">\n                <h3 class=\"_300 ng-binding\" ng-if=\"!vm.staffId\" translate>CREATE_STAFF</h3>\n                <h3 class=\"_300 ng-binding\" ng-if=\"vm.staffId\" translate>EDIT_STAFF</h3>\n            </div>\n            <form name=\"staffForm\" ng-submit=\"vm.submit()\">\n                <div class=\"box-body\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'FIRST_NAME' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.staff.first_name\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'LAST_NAME' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.staff.last_name\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'TYPE' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.staff.type\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\" ng-if=\"vm.staffId\">\n                        <label class=\"col-sm-3 form-control-label\">{{'CODE' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" disabled class=\"form-control\" ng-model=\"vm.staff.code\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'EMAIL' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.staff.email\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'PHONE' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.staff.phone\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">IMAGE</label>\n                        <div class=\"col-sm-9\">\n                            <div class=\"form-file m-b-1\">\n                                <input type=\"file\" name=\"myImage\" image-with-preview\n                                       ng-model=\"vm.staff.image\"\n                                       accept=\"image/jpeg,image/jpg,image/png\"\n                                       size=\"size < 2097152\">\n                                <button class=\"btn white\" translate>SELECT_FILE</button>\n                            </div>\n                            <span class=\"error\" ng-show=\"staffForm.myImage.$error.image\">\n                                Not a JPEG or a PNG!\n                            </span>\n                            <span class=\"error\" ng-show=\"staffForm.myImage.$error.size\">\n                                Invalid dimensions! Expecting a landscape image smaller than 1800x400.\n                            </span>\n                            <img width=\"150\"\n                                 ng-show=\"vm.staff.img.src\"\n                                 ng-src=\"{{vm.staff.img.src}}\"/>\n                            <img width=\"150\"\n                                 ng-hide=\"vm.staff.img.src\"\n                                 ng-src=\"{{vm.getStaffImage()}}\" />\n                        </div>\n                    </div>\n                </div>\n                <footer class=\"dker p-a text-left\">\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn success p-x-md m-l-1\"\n                            ng-disabled=\"!staffForm.$valid\">SUBMIT</button>\n                    <button type=\"button\"\n                            translate\n                            ng-if=\"vm.staffId\"\n                            ng-click=\"vm.goToProfile()\"\n                            class=\"btn info p-x-md m-l-1\">GO_TO_PROFILE</button>\n                </footer>\n            </form>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StaffEditController = function StaffEditController(StaffFactory, MiscFactory, $rootScope, $filter, $state, $stateParams, ngDialog, URLS) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, StaffEditController);
		var vm = this;
	
		vm.staffId = $stateParams.id;
		vm.rootScope = $rootScope;
	
		vm.$onInit = function () {
			vm.staff = {};
			if (vm.staffId) {
				StaffFactory.getOne(vm.staffId).then(function (response) {
					vm.staff = response.data;
				});
			}
		};
	
		vm.submit = function () {
			if (vm.staff.id) {
				/* UPDATE MATCH */
				StaffFactory.update(vm.staff.id, vm.staff).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					$state.reload();
				});
			} else {
				/* NEW MATCH */
				StaffFactory.create(vm.staff).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					$state.go('staff-edit', { id: response.data.id });
				});
			}
		};
	
		vm.getStaffImage = function () {
			if (vm.staff.img) {
				return URLS.IMAGES_URL + "/staff/" + vm.staff.img;
			} else {
				return 'assets/images/no_avatar.png';
			}
		};
	
		vm.goToProfile = function () {
			$state.go('staff-profile', { id: vm.staffId });
		};
	};
	StaffEditController.$inject = ["StaffFactory", "MiscFactory", "$rootScope", "$filter", "$state", "$stateParams", "ngDialog", "URLS"];
	
	exports.default = StaffEditController;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(786);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./staffEdit.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./staffEdit.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 786 */
560,
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _staffProfile = __webpack_require__(788);
	
	var _staffProfile2 = _interopRequireDefault(_staffProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var staffProfileModule = _angular2.default.module('staffProfile', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('staff-profile', {
			url: '/staff/{id}/profile',
			component: 'staffProfile',
			data: { pageTitle: 'STAFF_PROFILE' }
		});
	}]).component('staffProfile', _staffProfile2.default).name;
	
	exports.default = staffProfileModule;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _staffProfile = __webpack_require__(789);
	
	var _staffProfile2 = _interopRequireDefault(_staffProfile);
	
	var _staffProfile3 = __webpack_require__(790);
	
	var _staffProfile4 = _interopRequireDefault(_staffProfile3);
	
	__webpack_require__(791);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var staffProfileComponent = {
	  bindings: {},
	  template: _staffProfile2.default,
	  controller: _staffProfile4.default,
	  controllerAs: "vm"
	};
	
	exports.default = staffProfileComponent;

/***/ }),
/* 789 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"item\" ng-if=\"vm.staff.id\">\n    <div class=\"item-bg\">\n        <img ng-src=\"{{vm.getStaffImage()}}\" class=\"blur opacity-3\">\n    </div>\n    <div class=\"p-a-md\">\n        <div class=\"row m-t\">\n            <div class=\"col-sm-12\">\n                <a href class=\"pull-left m-r-md\">\n                    <span class=\"avatar w-96\">\n                      <img ng-src=\"{{vm.getStaffImage()}}\" />\n                      <i class=\"on b-white\"></i>\n                    </span>\n                </a>\n                <div ng-if=\"vm.staff\" class=\"clear\">\n                    <h4 class=\"m-a-0 m-b-xs\" ng-bind=\"vm.staff.staffName\"></h4>\n                    <div class=\"block clearfix\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.EDIT_STAFF)\">\n                        <button translate\n                                ui-sref=\"staff-edit({id:{{vm.staff.id}}})\"\n                                class=\"btn btn-sm btn-warning btn-rounded m-b\">EDIT_STAFF\n                        </button>\n                    </div>\n                    <div class=\"block clearfix\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.VALIDATE_PASSPORT)\">\n                        <button translate\n                                ng-click=\"vm.getStaffCard()\"\n                                class=\"btn btn-sm accent btn-rounded m-b\">DOWNLOAD_CARD\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"padding\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <div class=\"box\">\n                <div class=\"box-body\">\n                    <button class=\"btn btn-fw m-l-1\"\n                            translate\n                            ng-repeat=\"option in vm.options\"\n                            ng-class=\"{'success' : vm.activeOption == option.id, 'white' : vm.activeOption != option.id}\"\n                            ng-click=\"vm.activeOption = option.id\">\n                        {{option.name}}\n                    </button>\n                </div>\n                <div class=\"box-divider m-a-0\"></div>\n                <div ng-if=\"vm.activeOption == 1\" class=\"box-body\">\n                    <div class=\"row m-b\">\n                        <div class=\"col-xs-12\">\n                            <small class=\"text-muted\" translate>TYPE</small>\n                            <div class=\"_500\" ng-bind=\"vm.staff.type\"></div>\n                        </div>\n                    </div>\n                    <div class=\"row m-b\">\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>FIRST_NAME</small>\n                            <div class=\"_500\" ng-bind=\"vm.staff.first_name\"></div>\n                        </div>\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>LAST_NAME</small>\n                            <div class=\"_500\" ng-bind=\"vm.staff.last_name\"></div>\n                        </div>\n                    </div>\n                    <div class=\"row m-b\">\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>PHONE</small>\n                            <div class=\"_500\" ng-bind=\"vm.staff.phone\"></div>\n                        </div>\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>EMAIL</small>\n                            <div class=\"_500\" ng-bind=\"vm.staff.email\"></div>\n                        </div>\n                    </div>\n                </div>\n                <div ng-if=\"vm.activeOption == 2\" class=\"box-body\">\n                    <div class=\"table-responsive m-b-lg\">\n                        <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StaffProfileController = function StaffProfileController(StaffFactory, AuthFactory, PlayersFactory, $rootScope, $stateParams, $filter, $state, ngDialog, URLS) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, StaffProfileController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		vm.rootScope = $rootScope;
	
		vm.$onInit = function () {
			vm.options = [{ id: 1, name: 'INFORMATION' }];
			vm.activeOption = 1;
			vm.staffId = $stateParams.id;
			vm.staff = {};
			if (vm.staffId) {
				StaffFactory.getOne(vm.staffId).then(function (response) {
					vm.staff = response.data;
				});
			}
		};
	
		vm.hasPermission = function (permission) {
			return vm.rootScope.user.canDo(permission);
		};
	
		vm.getStaffImage = function () {
			if (vm.staff.img) {
				return URLS.IMAGES_URL + "/staff/" + vm.staff.img;
			} else {
				return 'assets/images/no_avatar.png';
			}
		};
	
		vm.getStaffCard = function () {
			var tabWindowId = window.open('about:blank', '_blank');
			StaffFactory.card(vm.staffId).then(function (response) {
				var file = new Blob([response.data], { type: 'application/pdf' });
				tabWindowId.location.href = window.URL.createObjectURL(file);
			});
		};
	};
	StaffProfileController.$inject = ["StaffFactory", "AuthFactory", "PlayersFactory", "$rootScope", "$stateParams", "$filter", "$state", "ngDialog", "URLS"];
	
	exports.default = StaffProfileController;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(792);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./staffProfile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./staffProfile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 792 */
560,
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _trainersList = __webpack_require__(794);
	
	var _trainersList2 = _interopRequireDefault(_trainersList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainersModule = _angular2.default.module('trainersList', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('trainers', {
			url: '/trainers',
			component: 'trainersList',
			data: { pageTitle: 'TRAINERS' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_ALL_TRAINERS)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('trainersList', _trainersList2.default).name;
	
	exports.default = trainersModule;

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trainersList = __webpack_require__(795);
	
	var _trainersList2 = _interopRequireDefault(_trainersList);
	
	var _trainersList3 = __webpack_require__(796);
	
	var _trainersList4 = _interopRequireDefault(_trainersList3);
	
	__webpack_require__(797);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainersListComponent = {
	  bindings: {},
	  template: _trainersList2.default,
	  controller: _trainersList4.default,
	  controllerAs: "vm"
	};
	
	exports.default = trainersListComponent;

/***/ }),
/* 795 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.ADD_TRAINER)\">\n                <button ui-sref=\"trainer-edit\" class=\"btn btn-sm btn-success\">\n                    <i class=\"fa fa-plus\"></i> {{'CREATE' | translate}}\n                </button>\n            </div>\n            <div class=\"table-responsive m-b-lg\">\n                <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrainersListController = function TrainersListController(TrainersFactory, $rootScope, $filter, $state, ngDialog, URLS) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, TrainersListController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	
	  vm.levels = [{
	    value: 0,
	    name: $translate("TRAINER_0_LEVEL")
	  }, {
	    value: 1,
	    name: $translate("TRAINER_1_LEVEL")
	  }, {
	    value: 2,
	    name: $translate("TRAINER_2_LEVEL")
	  }, {
	    value: 3,
	    name: $translate("TRAINER_3_LEVEL")
	  }, {
	    value: 4,
	    name: $translate("CL1")
	  }, {
	    value: 5,
	    name: $translate("CL2")
	  }];
	
	  vm.$onInit = function () {
	    reloadTrainers();
	  };
	
	  vm.gridOptions = {
	    enableSorting: true,
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "image",
	      name: "",
	      enableFiltering: false,
	      cellTemplate: '<div class="ui-grid-cell-contents ui-grid-align-c p-t-0">' + '<span class="avatar w-32">' + '<img ng-src="{{grid.appScope.vm.getTrainerImage(row.entity)}}">' + '<i class="on b-white bottom"></i>' + "</span>" + "</div>",
	      width: "80"
	    }, {
	      field: "code",
	      enableFiltering: false,
	      name: $translate("CODE"),
	      width: "110"
	    }, {
	      field: "trainerName",
	      name: $translate("NAME"),
	      enableFiltering: true
	    }, {
	      field: "level",
	      name: $translate("TRAINER_LEVEL"),
	      enableFiltering: true,
	      cellTemplate: "" + '<div class="ui-grid-cell-contents p-t-5">' + '<div ng-bind="grid.appScope.vm.getLevel(row.entity)"></div>' + "</div>"
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + '<div class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<a href class="btn btn-sm btn-info m-l-1" translate ' + 'ng-click="grid.appScope.vm.goToProfile(row.entity.id)">PROFILE</a>' + '<button class="btn btn-sm btn-warning m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINER)" ' + 'ng-click="grid.appScope.vm.goToEdit(row.entity.id)">EDIT</button>' + '<button class="btn btn-sm btn-danger m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_TRAINER)" ' + 'ng-click="grid.appScope.vm.deleteTrainer(row.entity.id)">DELETE</button>' + '<button class="btn btn-sm accent m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.VALIDATE_PASSPORT)" ' + 'ng-click="grid.appScope.vm.getCard(row.entity.id)">DOWNLOAD_CARD</button>' + "</div>" + "</div>",
	      width: "405"
	    }]
	  };
	
	  vm.getCard = function (staff) {
	    var tabWindowId = window.open("about:blank", "_blank");
	    TrainersFactory.card(staff).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	
	  vm.getLevel = function (staff) {
	    return vm.levels.find(function (l) {
	      return l.value === staff.level;
	    }).name;
	  };
	
	  vm.hasPermission = function (permission) {
	    return vm.rootScope.user.canDo(permission);
	  };
	
	  vm.getTrainerImage = function (entity) {
	    if (entity.img) {
	      return URLS.IMAGES_URL + "/trainers/" + entity.img;
	    } else {
	      return "assets/images/no_avatar.png";
	    }
	  };
	
	  vm.goToProfile = function (trainerId) {
	    $state.go("trainer-profile", { id: trainerId });
	  };
	
	  vm.goToEdit = function (trainerId) {
	    $state.go("trainer-edit", { id: trainerId });
	  };
	
	  vm.deleteTrainer = function (trainerId) {
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate("CONFIRM_DELETE_TRAINER")
	      }
	    }).then(function () {
	      TrainersFactory.delete(trainerId).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        reloadTrainers();
	      });
	    });
	  };
	
	  function reloadTrainers() {
	    TrainersFactory.getAll().then(function (response) {
	      vm.gridOptions.data = response.data;
	    });
	  }
	};
	TrainersListController.$inject = ["TrainersFactory", "$rootScope", "$filter", "$state", "ngDialog", "URLS"];
	
	exports.default = TrainersListController;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(798);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./trainersList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./trainersList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 798 */
560,
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _trainerEdit = __webpack_require__(800);
	
	var _trainerEdit2 = _interopRequireDefault(_trainerEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainerEditModule = _angular2.default.module('trainerEdit', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('trainer-edit', {
			url: '/trainers/edit/:id',
			component: 'trainerEdit',
			data: { pageTitle: 'EDIT_TRAINER' },
			params: {
				id: { squash: true, value: null }
			},
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", "$stateParams", function hasPermission($q, $rootScope, Permissions, $stateParams) {
					'ngInject';
	
					var deferred = $q.defer();
	
					if ($rootScope.user.canDo(Permissions.EDIT_TRAINER)) {
						deferred.resolve();
					} else {
						deferred.reject("Access denied!");
					}
	
					return deferred.promise;
				}]
			}
		});
	}]).component('trainerEdit', _trainerEdit2.default).name;
	
	exports.default = trainerEditModule;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trainerEdit = __webpack_require__(801);
	
	var _trainerEdit2 = _interopRequireDefault(_trainerEdit);
	
	var _trainerEdit3 = __webpack_require__(802);
	
	var _trainerEdit4 = _interopRequireDefault(_trainerEdit3);
	
	__webpack_require__(803);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainerEditComponent = {
	  bindings: {},
	  template: _trainerEdit2.default,
	  controller: _trainerEdit4.default,
	  controllerAs: "vm"
	};
	
	exports.default = trainerEditComponent;

/***/ }),
/* 801 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"b-b m-b-1 p-t-1 p-b-1 text-center\">\n                <h3 class=\"_300 ng-binding\" ng-if=\"!vm.trainerId\" translate>CREATE_TRAINER</h3>\n                <h3 class=\"_300 ng-binding\" ng-if=\"vm.trainerId\" translate>EDIT_TRAINER</h3>\n            </div>\n            <form name=\"trainerForm\" ng-submit=\"vm.submit()\">\n                <div class=\"box-body\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'FIRST_NAME' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.trainer.first_name\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'LAST_NAME' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.trainer.last_name\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'FATHER' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.trainer.father\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\" ng-if=\"vm.trainerId\">\n                        <label class=\"col-sm-3 form-control-label\">{{'CODE' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" disabled class=\"form-control\" ng-model=\"vm.trainer.code\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'EMAIL' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.trainer.email\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'PHONE' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.trainer.phone\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'TRAINER_LEVEL' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <ui-select ng-model=\"vm.trainer.level\" theme=\"bootstrap\">\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_LEVEL' | translate}}\">\n                                    {{$select.selected.name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.levels | filter: $select.search\">\n                                    <div ng-bind-html=\"item.name | highlight: $select.search\" translate></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'NOTES' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <textarea class=\"form-control\" ng-model=\"vm.trainer.notes\" rows=\"5\"></textarea>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">IMAGE</label>\n                        <div class=\"col-sm-9\">\n                            <div class=\"form-file m-b-1\">\n                                <input type=\"file\" name=\"myImage\" image-with-preview\n                                       ng-model=\"vm.trainer.image\"\n                                       accept=\"image/jpeg,image/jpg,image/png\"\n                                       size=\"size < 2097152\">\n                                <button class=\"btn white\" translate>SELECT_FILE</button>\n                            </div>\n                            <span class=\"error\" ng-show=\"trainerForm.myImage.$error.image\">\n                                Not a JPEG or a PNG!\n                            </span>\n                            <span class=\"error\" ng-show=\"trainerForm.myImage.$error.size\">\n                                Invalid dimensions! Expecting a landscape image smaller than 1800x400.\n                            </span>\n                            <img width=\"150\"\n                                 ng-show=\"vm.trainer.img.src\"\n                                 ng-src=\"{{vm.trainer.img.src}}\"/>\n                            <img width=\"150\"\n                                 ng-hide=\"vm.trainer.img.src\"\n                                 ng-src=\"{{vm.getTrainerImage()}}\" />\n                        </div>\n                    </div>\n                </div>\n                <footer class=\"dker p-a text-left\">\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn success p-x-md m-l-1\"\n                            ng-disabled=\"!trainerForm.$valid\">SUBMIT</button>\n                    <button type=\"button\"\n                            translate\n                            ng-if=\"vm.trainerId\"\n                            ng-click=\"vm.goToProfile()\"\n                            class=\"btn info p-x-md m-l-1\">GO_TO_PROFILE</button>\n                </footer>\n            </form>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrainerEditController = function TrainerEditController(TrainersFactory, MiscFactory, $rootScope, $filter, $state, $stateParams, ngDialog, URLS) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, TrainerEditController);
		var vm = this;
	
		vm.trainerId = $stateParams.id;
		vm.rootScope = $rootScope;
	
		var $translate = $filter('translate');
	
		vm.levels = [{
			value: 0,
			name: $translate('TRAINER_0_LEVEL')
		}, {
			value: 1,
			name: $translate('TRAINER_1_LEVEL')
		}, {
			value: 2,
			name: $translate('TRAINER_2_LEVEL')
		}, {
			value: 3,
			name: $translate('TRAINER_3_LEVEL')
		}, {
			value: 4,
			name: $translate('CL1')
		}, {
			value: 5,
			name: $translate('CL2')
		}];
	
		vm.$onInit = function () {
			vm.trainer = {};
			if (vm.trainerId) {
				TrainersFactory.getOne(vm.trainerId).then(function (response) {
					vm.trainer = response.data;
					vm.trainer.level = vm.levels.find(function (l) {
						return l.value === vm.trainer.level;
					});
				});
			}
		};
	
		vm.submit = function () {
			vm.trainer.level = vm.trainer.level.value;
			if (vm.trainer.id) {
				/* UPDATE MATCH */
				TrainersFactory.update(vm.trainer.id, vm.trainer).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					$state.reload();
				});
			} else {
				/* NEW MATCH */
				TrainersFactory.create(vm.trainer).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					$state.go('trainer-edit', { id: response.data.id });
				});
			}
		};
	
		vm.getTrainerImage = function () {
			if (vm.trainer.img) {
				return URLS.IMAGES_URL + "/trainers/" + vm.trainer.img;
			} else {
				return 'assets/images/no_avatar.png';
			}
		};
	
		vm.goToProfile = function () {
			$state.go('trainer-profile', { id: vm.trainerId });
		};
	};
	TrainerEditController.$inject = ["TrainersFactory", "MiscFactory", "$rootScope", "$filter", "$state", "$stateParams", "ngDialog", "URLS"];
	
	exports.default = TrainerEditController;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(804);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./trainerEdit.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./trainerEdit.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 804 */
560,
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _trainerProfile = __webpack_require__(806);
	
	var _trainerProfile2 = _interopRequireDefault(_trainerProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainerProfileModule = _angular2.default.module('trainerProfile', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('trainer-profile', {
			url: '/trainers/{id}/profile',
			component: 'trainerProfile',
			data: { pageTitle: 'TRAINER_PROFILE' }
		});
	}]).component('trainerProfile', _trainerProfile2.default).name;
	
	exports.default = trainerProfileModule;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trainerProfile = __webpack_require__(807);
	
	var _trainerProfile2 = _interopRequireDefault(_trainerProfile);
	
	var _trainerProfile3 = __webpack_require__(808);
	
	var _trainerProfile4 = _interopRequireDefault(_trainerProfile3);
	
	__webpack_require__(809);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainerProfileComponent = {
	  bindings: {},
	  template: _trainerProfile2.default,
	  controller: _trainerProfile4.default,
	  controllerAs: "vm"
	};
	
	exports.default = trainerProfileComponent;

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"item\" ng-if=\"vm.trainer.id\">\n    <div class=\"item-bg\">\n        <img ng-src=\"{{vm.getTrainerImage()}}\" class=\"blur opacity-3\">\n    </div>\n    <div class=\"p-a-md\">\n        <div class=\"row m-t\">\n            <div class=\"col-sm-12\">\n                <a href class=\"pull-left m-r-md\">\n                    <span class=\"avatar w-96\">\n                      <img ng-src=\"{{vm.getTrainerImage()}}\" />\n                      <i class=\"on b-white\"></i>\n                    </span>\n                </a>\n                <div ng-if=\"vm.trainer\" class=\"clear\">\n                    <h4 class=\"m-a-0 m-b-xs\" ng-bind=\"vm.trainer.trainerName\"></h4>\n                    <div class=\"block clearfix\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.EDIT_TRAINER)\">\n                        <button translate\n                                ui-sref=\"trainer-edit({id:{{vm.trainer.id}}})\"\n                                class=\"btn btn-sm btn-warning btn-rounded m-b\">EDIT_TRAINER\n                        </button>\n                    </div>\n                    <div class=\"block clearfix\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.VALIDATE_PASSPORT)\">\n                        <button translate\n                                ng-click=\"vm.getTrainerCard()\"\n                                class=\"btn btn-sm accent btn-rounded m-b\">DOWNLOAD_CARD\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"padding\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <div class=\"box\">\n                <div class=\"box-body\">\n                    <button class=\"btn btn-fw m-l-1\"\n                            translate\n                            ng-repeat=\"option in vm.options\"\n                            ng-class=\"{'success' : vm.activeOption == option.id, 'white' : vm.activeOption != option.id}\"\n                            ng-click=\"vm.activeOption = option.id\">\n                        {{option.name}}\n                    </button>\n                </div>\n                <div class=\"box-divider m-a-0\"></div>\n                <div ng-if=\"vm.activeOption == 1\" class=\"box-body\">\n                    <div class=\"row m-b\">\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>FIRST_NAME</small>\n                            <div class=\"_500\" ng-bind=\"vm.trainer.first_name\"></div>\n                        </div>\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>LAST_NAME</small>\n                            <div class=\"_500\" ng-bind=\"vm.trainer.last_name\"></div>\n                        </div>\n                    </div>\n                    <div class=\"row m-b\">\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>PHONE</small>\n                            <div class=\"_500\" ng-bind=\"vm.trainer.phone\"></div>\n                        </div>\n                        <div class=\"col-xs-6\">\n                            <small class=\"text-muted\" translate>EMAIL</small>\n                            <div class=\"_500\" ng-bind=\"vm.trainer.email\"></div>\n                        </div>\n                    </div>\n                </div>\n                <div ng-if=\"vm.activeOption == 2\" class=\"box-body\">\n                    <div class=\"table-responsive m-b-lg\">\n                        <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrainerProfileController = function TrainerProfileController(TrainersFactory, AuthFactory, PlayersFactory, $rootScope, $stateParams, $filter, $state, ngDialog, URLS) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, TrainerProfileController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		vm.rootScope = $rootScope;
	
		vm.$onInit = function () {
			vm.options = [{ id: 1, name: 'INFORMATION' }];
			vm.activeOption = 1;
			vm.trainerId = $stateParams.id;
			vm.trainer = {};
			if (vm.trainerId) {
				TrainersFactory.getOne(vm.trainerId).then(function (response) {
					vm.trainer = response.data;
				});
			}
		};
	
		vm.hasPermission = function (permission) {
			return vm.rootScope.user.canDo(permission);
		};
	
		vm.getTrainerImage = function () {
			if (vm.trainer.img) {
				return URLS.IMAGES_URL + "/trainers/" + vm.trainer.img;
			} else {
				return 'assets/images/no_avatar.png';
			}
		};
	
		vm.getTrainerCard = function () {
			var tabWindowId = window.open('about:blank', '_blank');
			TrainersFactory.card(vm.trainerId).then(function (response) {
				var file = new Blob([response.data], { type: 'application/pdf' });
				tabWindowId.location.href = window.URL.createObjectURL(file);
			});
		};
	};
	TrainerProfileController.$inject = ["TrainersFactory", "AuthFactory", "PlayersFactory", "$rootScope", "$stateParams", "$filter", "$state", "ngDialog", "URLS"];
	
	exports.default = TrainerProfileController;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(810);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./trainerProfile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./trainerProfile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 810 */
560,
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _playersList = __webpack_require__(812);
	
	var _playersList2 = _interopRequireDefault(_playersList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playersListModule = _angular2.default.module('playersList', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('players', {
			url: '/players',
			component: 'playersList',
			data: { pageTitle: 'PLAYERS' }
		});
	}]).component('playersList', _playersList2.default).name;
	
	exports.default = playersListModule;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _playersList = __webpack_require__(813);
	
	var _playersList2 = _interopRequireDefault(_playersList);
	
	var _playersList3 = __webpack_require__(814);
	
	var _playersList4 = _interopRequireDefault(_playersList3);
	
	__webpack_require__(815);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playersListComponent = {
	  bindings: {},
	  template: _playersList2.default,
	  controller: _playersList4.default,
	  controllerAs: "vm"
	};
	
	exports.default = playersListComponent;

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row playersList\">\n  <div class=\"col-xs-12\">\n    <div class=\"box\">\n      <div class=\"box-body\">\n        <button\n          ui-sref=\"player-edit\"\n          ng-if=\"vm.rootScope.user.canDo(vm.rootScope.permissions.ADD_PLAYER)\"\n          class=\"btn btn-sm btn-success\"\n        >\n          <i class=\"fa fa-plus\"></i> {{'CREATE' | translate}}\n        </button>\n        <button\n          ng-if=\"vm.hasPermission(vm.rootScope.permissions.VIEW_ALL_PLAYERS)\n                && vm.rootScope.user.canDo(vm.rootScope.permissions.VIEW_ALL_TEAMS)\"\n          ng-click=\"vm.activeTeam = null;vm.reloadPlayers()\"\n          class=\"btn btn-sm btn-info\"\n        >\n          <i class=\"fa fa-warning\"></i> {{'LOAD_ALL_PLAYERS' | translate}}\n        </button>\n      </div>\n      <div class=\"box-body\">\n        <div\n          class=\"form-group row\"\n          ng-if=\"vm.rootScope.user.canDo(vm.rootScope.permissions.VIEW_ALL_PLAYERS)\n                 && vm.rootScope.user.canDo(vm.rootScope.permissions.VIEW_ALL_TEAMS)\"\n        >\n          <label translate class=\"col-sm-2 form-control-label\">TEAM</label>\n          <div class=\"col-sm-10\">\n            <ui-select\n              on-select=\"vm.reloadPlayers()\"\n              ng-model=\"vm.activeTeam\"\n              theme=\"bootstrap\"\n            >\n              <ui-select-match\n                class=\"ui-select-match\"\n                placeholder=\"{{'SELECT_TEAM' | translate}}\"\n              >\n                {{$select.selected.full_name}}\n              </ui-select-match>\n              <ui-select-choices\n                class=\"ui-select-choices\"\n                repeat=\"item in vm.teams | filter: $select.search\"\n              >\n                <div\n                  ng-bind-html=\"item.full_name | highlight: $select.search\"\n                ></div>\n              </ui-select-choices>\n            </ui-select>\n          </div>\n        </div>\n        <div class=\"form-group row\">\n          <label translate class=\"col-sm-4 form-control-label\"\n            >LOAD_FINANCIAL_OK_PLAYERS</label\n          >\n          <div class=\"col-sm-8\">\n            <label class=\"ui-switch ui-switch-md info m-t-xs\">\n              <input\n                type=\"checkbox\"\n                ng-change=\"vm.reloadPlayers()\"\n                ng-model=\"vm.filters.hasPaid\"\n              />\n              <i></i>\n            </label>\n          </div>\n        </div>\n      </div>\n      <div class=\"table-responsive m-b-lg\">\n        <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n      </div>\n    </div>\n  </div>\n</div>\n<div\n  id=\"playerTrainingEntriesModal\"\n  class=\"modal black-overlay\"\n  data-backdrop=\"false\"\n>\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h5 class=\"modal-title\" translate>ADD_TRAINING_ENTRIES</h5>\n      </div>\n      <div class=\"b-b m-b-1 m-t-1 text-center\">\n        <h3\n          class=\"_300 ng-binding\"\n          translate\n          ng-bind=\"vm.player.playerName\"\n        ></h3>\n      </div>\n      <div class=\"modal-body text-center p-lg\">\n        <form name=\"newEntriesForm\" class=\"p-x-xs\">\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'HOW_MANY' | translate}} *</label\n            >\n            <div class=\"col-sm-8\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-model=\"vm.newEntries.amount\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'TRAINING_CENTER' | translate}} *</label\n            >\n            <div class=\"col-sm-8\">\n              <ui-select\n                ng-model=\"vm.newEntries.trainingCenter\"\n                theme=\"bootstrap\"\n              >\n                <ui-select-match\n                  class=\"ui-select-match\"\n                  placeholder=\"{{'SELECT_TRAINING_CENTER' | translate}}\"\n                >\n                  {{$select.selected.title}}\n                </ui-select-match>\n                <ui-select-choices\n                  class=\"ui-select-choices\"\n                  repeat=\"item in vm.trainingCenters | filter: $select.search\"\n                >\n                  <div\n                    ng-bind-html=\"item.title | highlight: $select.search\"\n                  ></div>\n                </ui-select-choices>\n              </ui-select>\n            </div>\n          </div>\n        </form>\n      </div>\n      <div class=\"modal-footer\">\n        <button\n          type=\"button\"\n          translate\n          class=\"btn dark-white p-x-md\"\n          data-dismiss=\"modal\"\n        >\n          CANCEL\n        </button>\n        <button\n          type=\"button\"\n          translate\n          class=\"btn danger p-x-md\"\n          ng-click=\"vm.addNewEntries();\"\n          ng-class=\"{'disabled' : !newEntriesForm.$valid}\"\n          ng-disabled=\"!newEntriesForm.$valid\"\n          data-dismiss=\"modal\"\n        >\n          SUBMIT\n        </button>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayersListController = function PlayersListController(TeamsFactory, PaymentsFactory, PlayersFactory, TrainingEntriesFactory, TrainingCentersFactory, $filter, ngDialog, $state, $rootScope, URLS) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, PlayersListController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	
	  vm.$onInit = function () {
	    vm.activeTeam = null;
	    vm.teams = [];
	    vm.filters = {};
	    vm.filters.hasPaid = false;
	    vm.trainingCenters = [];
	    if (vm.rootScope.user.isUserTypeTeam()) {
	      vm.activeTeam = vm.rootScope.currentUser;
	      vm.reloadPlayers();
	    } else {
	      TeamsFactory.getAll().then(function (response) {
	        vm.teams = response.data;
	      });
	    }
	    TrainingCentersFactory.getAll().then(function (response) {
	      vm.trainingCenters = response.data;
	    });
	  };
	
	  vm.gridOptions = {
	    enableSorting: true,
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "image",
	      name: "",
	      enableFiltering: false,
	      cellTemplate: '<div class="ui-grid-cell-contents ui-grid-align-c p-t-0">' + '<span class="avatar w-32">' + '<img class="{{grid.appScope.vm.getPlayerHighestLevelClass(row.entity)}}" ng-src="{{grid.appScope.vm.getPlayerImage(row.entity)}}">' + '<i class="on b-white bottom"></i>' + "</span>" + "</div>",
	      width: "80"
	    }, {
	      field: "code",
	      enableFiltering: false,
	      name: $translate("CODE"),
	      width: "90"
	    }, {
	      field: "playerName",
	      name: $translate("NAME"),
	      enableFiltering: true
	    }, {
	      field: "teamName",
	      name: $translate("TEAM"),
	      enableFiltering: true
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + '<div class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<a href class="btn btn-sm btn-info m-l-1" translate ' + 'ng-click="grid.appScope.vm.goToProfile(row.entity.player_id)">PROFILE</a>' + '<a href class="btn btn-sm btn-warning m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_PLAYER)" ' + 'ng-click="grid.appScope.vm.goToEdit(row.entity.player_id)">EDIT</a>' + '<button class="btn btn-sm btn-danger m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_PLAYER)" ' + 'ng-click="grid.appScope.vm.deletePlayer(row.entity.player_id)">DELETE</button>' + '<button class="btn btn-sm btn-dark m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.VALIDATE_PASSPORT)" ' + 'ng-click="grid.appScope.vm.getCard(row.entity.player_id)">DOWNLOAD_CARD</button>' + '<button class="btn btn-sm accent m-l-1" translate ' + 'data-toggle="modal" ' + 'data-target="#playerTrainingEntriesModal" ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.ADD_TRAINING_ENTRY)" ' + 'ng-click="grid.appScope.vm.openAddTrainingEntriesModal(row.entity.player_id)">ADD_TRAINING_ENTRIES</button>' + "</div>" + "</div>",
	      width: "520"
	    }]
	  };
	
	  vm.openAddTrainingEntriesModal = function (playerId) {
	    vm.newEntries = {
	      player_id: playerId
	    };
	  };
	
	  vm.addNewEntries = function () {
	    TrainingEntriesFactory.create({
	      amount: vm.newEntries.amount,
	      training_center_id: vm.newEntries.trainingCenter.id,
	      player_id: vm.newEntries.player_id
	    }).then(function (response) {
	      ngDialog.open({ template: "successTemplate" });
	    });
	  };
	
	  vm.getCard = function (player) {
	    var tabWindowId = window.open("about:blank", "_blank");
	    PlayersFactory.card(player).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	
	  vm.hasPermission = function (permission) {
	    if (vm.rootScope.user.isUserTypeTeam()) {
	      return vm.rootScope.user.isTeam(vm.activeTeam.team_id) && vm.rootScope.user.canDo(permission);
	    } else {
	      return vm.rootScope.user.canDo(permission);
	    }
	  };
	
	  vm.getPlayerHighestLevelClass = function (player) {
	    if (player.compound_level > player.recurve_level) {
	      return "level-indicator level-" + player.compound_level;
	    }
	    return "level-indicator level-" + player.recurve_level;
	  };
	
	  vm.getPlayerImage = function (entity) {
	    if (entity.img) {
	      return URLS.IMAGES_URL + "/players/" + entity.img;
	    } else {
	      return "assets/images/no_avatar.png";
	    }
	  };
	
	  vm.deletePlayer = function (playerId) {
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate("CONFIRM_DELETE_PLAYER")
	      }
	    }).then(function () {
	      PlayersFactory.delete(playerId).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        vm.reloadPlayers();
	      });
	    });
	  };
	
	  vm.goToProfile = function (playerId) {
	    $state.go("player-profile.info", { id: playerId });
	  };
	
	  vm.goToEdit = function (playerId) {
	    $state.go("player-edit", { id: playerId });
	  };
	
	  vm.reloadPlayers = function () {
	    var params = {};
	    /* Active Team Filter */
	    if (vm.activeTeam) {
	      params.team_id = vm.activeTeam.team_id;
	    } else if (!vm.hasPermission(vm.rootScope.permissions.VIEW_ALL_PLAYERS)) {
	      return;
	    }
	    /* Has Paid For Year Filter */
	    if (vm.filters.hasPaid) {
	      params.has_paid = 1;
	    }
	    /* Page Size */
	    params.page_size = 9000;
	    PlayersFactory.getAll(params).then(function (response) {
	      vm.players = response.data;
	      vm.gridOptions.data = response.data;
	    });
	  };
	};
	PlayersListController.$inject = ["TeamsFactory", "PaymentsFactory", "PlayersFactory", "TrainingEntriesFactory", "TrainingCentersFactory", "$filter", "ngDialog", "$state", "$rootScope", "URLS"];
	
	exports.default = PlayersListController;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(816);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./playersList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./playersList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, ".level-indicator{border-radius:50%}.level-1{border:2px solid #fff}.level-2{border:2px solid #000}.level-3{border:2px solid #0004ff}.level-4{border:2px solid red}.level-5{border:2px solid #ff0}.level-6{border:2px solid green}", ""]);
	
	// exports


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _playerEdit = __webpack_require__(818);
	
	var _playerEdit2 = _interopRequireDefault(_playerEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerEditModule = _angular2.default.module('playerEdit', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('player-edit', {
			url: '/players/edit/:id',
			component: 'playerEdit',
			data: { pageTitle: 'EDIT_PLAYER' },
			params: {
				id: { squash: true, value: null }
			},
			resolve: {
				hasPermission: ["PlayersFactory", "$q", "$rootScope", "Permissions", "$stateParams", function hasPermission(PlayersFactory, $q, $rootScope, Permissions, $stateParams) {
					'ngInject';
	
					var deferred = $q.defer();
	
					if ($rootScope.user.isUserTypeTeam() && $rootScope.user.canDo(Permissions.EDIT_PLAYER)) {
						PlayersFactory.getOne($stateParams.id).then(function (response) {
							if ($rootScope.user.isTeam(response.data.team_id)) {
								deferred.resolve();
							} else {
								deferred.reject("Access denied!");
							}
						}).catch(function (error) {
							deferred.reject("Access denied!");
						});
					} else if (!$rootScope.user.isUserTypeTeam() && $rootScope.user.canDo(Permissions.EDIT_PLAYER)) {
						deferred.resolve();
					} else {
						deferred.reject("Access denied!");
					}
	
					return deferred.promise;
				}]
			}
		});
	}]).component('playerEdit', _playerEdit2.default).name;
	
	exports.default = playerEditModule;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _playerEdit = __webpack_require__(819);
	
	var _playerEdit2 = _interopRequireDefault(_playerEdit);
	
	var _playerEdit3 = __webpack_require__(820);
	
	var _playerEdit4 = _interopRequireDefault(_playerEdit3);
	
	__webpack_require__(821);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerEditComponent = {
	  bindings: {},
	  template: _playerEdit2.default,
	  controller: _playerEdit4.default,
	  controllerAs: "vm"
	};
	
	exports.default = playerEditComponent;

/***/ }),
/* 819 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n  <div class=\"col-sm-12\">\n    <div class=\"box\">\n      <div class=\"b-b m-b-1 p-t-1 p-b-1 text-center\">\n        <h3 class=\"_300 ng-binding\" ng-if=\"!vm.playerId\" translate>\n          CREATE_PLAYER\n        </h3>\n        <h3 class=\"_300 ng-binding\" ng-if=\"vm.playerId\" translate>\n          EDIT_PLAYER\n        </h3>\n      </div>\n      <form name=\"playerForm\" ng-submit=\"vm.submit()\">\n        <div ng-if=\"vm.rootScope.isSAAF\" class=\"box-body\">\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'CODE' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-model=\"vm.player.code\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'RECURVE_LEVEL' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <ui-select ng-model=\"vm.recurveLevel\" theme=\"bootstrap\">\n                <ui-select-match\n                  class=\"ui-select-match\"\n                  placeholder=\"{{'SELECT_RECURVE_LEVEL' | translate}}\"\n                >\n                  {{$select.selected.name}}\n                </ui-select-match>\n                <ui-select-choices\n                  class=\"ui-select-choices\"\n                  repeat=\"item in vm.levels | filter: $select.search\"\n                >\n                  <div\n                    ng-bind-html=\"item.name | highlight: $select.search\"\n                  ></div>\n                </ui-select-choices>\n              </ui-select>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'COMPOUND_LEVEL' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <ui-select ng-model=\"vm.compoundLevel\" theme=\"bootstrap\">\n                <ui-select-match\n                  class=\"ui-select-match\"\n                  placeholder=\"{{'SELECT_COMPOUND_LEVEL' | translate}}\"\n                >\n                  {{$select.selected.name}}\n                </ui-select-match>\n                <ui-select-choices\n                  class=\"ui-select-choices\"\n                  repeat=\"item in vm.levels | filter: $select.search\"\n                >\n                  <div\n                    ng-bind-html=\"item.name | highlight: $select.search\"\n                  ></div>\n                </ui-select-choices>\n              </ui-select>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'FIRST_NAME' | translate}}</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                class=\"form-control\"\n                ng-disabled=\"vm.rootScope.user.isUserTypeTeam()\"\n                ng-model=\"vm.player.fname\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'LAST_NAME' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-disabled=\"vm.rootScope.user.isUserTypeTeam()\"\n                ng-model=\"vm.player.lname\"\n              />\n            </div>\n          </div>\n\n          <div ng-if=\"!vm.rootScope.user.isUserTypeTeam()\">\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'TEAM' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <ui-select\n                  ng-model=\"vm.player.team\"\n                  ng-disabled=\"vm.playerId\"\n                  ng-readonly=\"vm.playerId\"\n                  theme=\"bootstrap\"\n                >\n                  <ui-select-match\n                    class=\"ui-select-match\"\n                    placeholder=\"{{'SELECT_TEAM' | translate}}\"\n                  >\n                    {{$select.selected.teamName}}\n                  </ui-select-match>\n                  <ui-select-choices\n                    class=\"ui-select-choices\"\n                    repeat=\"item in vm.teams | filter: $select.search\"\n                  >\n                    <div\n                      ng-bind-html=\"item.teamName | highlight: $select.search\"\n                    ></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >{{'SEX' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <div class=\"radio-inline\">\n                  <label class=\"ui-check\">\n                    <input\n                      type=\"radio\"\n                      required\n                      id=\"sexMale\"\n                      ng-model=\"vm.player.sex\"\n                      name=\"sex\"\n                      value=\"M\"\n                    />\n                    <i class=\"dark-white\"></i>{{'MALE' | translate}}\n                  </label>\n                </div>\n                <div class=\"radio-inline\">\n                  <label class=\"ui-check\">\n                    <input\n                      type=\"radio\"\n                      required\n                      id=\"sexFemale\"\n                      ng-model=\"vm.player.sex\"\n                      name=\"sex\"\n                      value=\"F\"\n                    />\n                    <i class=\"dark-white\"></i>{{'FEMALE' | translate}}\n                  </label>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >FATHER</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.player.father\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >MOTHER</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.player.mother\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'REGISTRATION_DATE' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <div class=\"dropdown\">\n                  <a\n                    class=\"dropdown-toggle\"\n                    id=\"registrationDate\"\n                    role=\"button\"\n                    data-toggle=\"dropdown\"\n                    data-target=\"#\"\n                    href=\"#\"\n                  >\n                    <div class=\"input-group\">\n                      <span class=\"custom-input\">\n                        {{ vm.player.registration_date | date:'yyyy-MM-dd' }}\n                      </span>\n                      <span class=\"input-group-btn\">\n                        <button class=\"btn white\" type=\"button\" translate>\n                          PICK\n                        </button>\n                      </span>\n                    </div>\n                  </a>\n                  <ul\n                    class=\"dropdown-menu\"\n                    role=\"menu\"\n                    aria-labelledby=\"dLabel\"\n                  >\n                    <datetimepicker\n                      data-ng-model=\"vm.player.registration_date\"\n                      data-datetimepicker-config=\"vm.datePickerRegistrationConfig\"\n                    />\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'BIRTH_DATE' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <div class=\"dropdown\">\n                  <a\n                    class=\"dropdown-toggle\"\n                    id=\"birthDate\"\n                    role=\"button\"\n                    data-toggle=\"dropdown\"\n                    data-target=\"#\"\n                    href=\"#\"\n                  >\n                    <div class=\"input-group\">\n                      <span class=\"custom-input\">\n                        {{ vm.player.birth | date:'yyyy-MM-dd' }}\n                      </span>\n                      <span class=\"input-group-btn\">\n                        <button class=\"btn white\" type=\"button\" translate>\n                          PICK\n                        </button>\n                      </span>\n                    </div>\n                  </a>\n                  <ul\n                    class=\"dropdown-menu\"\n                    role=\"menu\"\n                    aria-labelledby=\"dLabel\"\n                  >\n                    <datetimepicker\n                      data-ng-model=\"vm.player.birth\"\n                      data-datetimepicker-config=\"vm.datePickerBirthConfig\"\n                    />\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >BIRTH_PLACE</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.player.birth_place\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'NATIONALITY' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <ui-select ng-model=\"vm.player.nationality\" theme=\"bootstrap\">\n                  <ui-select-match\n                    class=\"ui-select-match\"\n                    placeholder=\"{{'SELECT_NATIONALITY' | translate}}\"\n                  >\n                    {{$select.selected.nationality_name}}\n                  </ui-select-match>\n                  <ui-select-choices\n                    class=\"ui-select-choices\"\n                    repeat=\"item in vm.nationalities | filter: $select.search\"\n                  >\n                    <div\n                      ng-bind-html=\"item.nationality_name | highlight: $select.search\"\n                    ></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'CITIZENSHIP' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <ui-select ng-model=\"vm.player.citizenship\" theme=\"bootstrap\">\n                  <ui-select-match\n                    class=\"ui-select-match\"\n                    placeholder=\"{{'SELECT_CITIZENSHIP' | translate}}\"\n                  >\n                    {{$select.selected.nationality_name}}\n                  </ui-select-match>\n                  <ui-select-choices\n                    class=\"ui-select-choices\"\n                    repeat=\"item in vm.nationalities | filter: $select.search\"\n                  >\n                    <div\n                      ng-bind-html=\"item.nationality_name | highlight: $select.search\"\n                    ></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >EXPATRIATE</label\n              >\n              <div class=\"col-sm-9\">\n                <label class=\"ui-switch ui-switch-md info m-t-xs\">\n                  <input type=\"checkbox\" ng-model=\"vm.player.expatriate\" />\n                  <i></i>\n                </label>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'ADT' | translate}}</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.player.adt\"\n                />\n              </div>\n            </div>\n          </div>\n\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'PHONE' | translate}}</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                class=\"form-control\"\n                ng-model=\"vm.player.phone\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\">EMAIL</label>\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                class=\"form-control\"\n                ng-model=\"vm.player.email\"\n              />\n            </div>\n          </div>\n\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\">IMAGE</label>\n            <div class=\"col-sm-9\">\n              <div class=\"form-file m-b-1\">\n                <input\n                  type=\"file\"\n                  name=\"myImage\"\n                  image-with-preview\n                  ng-model=\"vm.player.image\"\n                  accept=\"image/jpeg,image/jpg,image/png\"\n                  size=\"size < 2097152\"\n                />\n                <button class=\"btn white\" translate>SELECT_FILE</button>\n              </div>\n              <span class=\"error\" ng-show=\"playerForm.myImage.$error.image\">\n                Not a JPEG or a PNG!\n              </span>\n              <span class=\"error\" ng-show=\"playerForm.myImage.$error.size\">\n                Invalid dimensions! Expecting a landscape image smaller than\n                1800x400.\n              </span>\n              <img\n                width=\"150\"\n                ng-show=\"vm.player.image.src\"\n                ng-src=\"{{vm.player.image.src}}\"\n              />\n              <img\n                width=\"150\"\n                ng-hide=\"vm.player.image.src\"\n                ng-src=\"{{vm.getPlayerImage()}}\"\n              />\n            </div>\n          </div>\n        </div>\n        <div ng-if=\"vm.rootScope.isEOT\" class=\"box-body\">\n          <div class=\"form-group row\" ng-if=\"vm.playerId\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'CODE' | translate}}</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                disabled\n                class=\"form-control\"\n                ng-model=\"vm.player.code\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'FIRST_NAME' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-disabled=\"vm.rootScope.user.isUserTypeTeam()\"\n                ng-model=\"vm.player.fname\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'LAST_NAME' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                required\n                class=\"form-control\"\n                ng-disabled=\"vm.rootScope.user.isUserTypeTeam()\"\n                ng-model=\"vm.player.lname\"\n              />\n            </div>\n          </div>\n\n          <div ng-if=\"!vm.rootScope.user.isUserTypeTeam()\">\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'TEAM' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <ui-select\n                  ng-model=\"vm.player.team\"\n                  ng-disabled=\"vm.playerId\"\n                  ng-readonly=\"vm.playerId\"\n                  theme=\"bootstrap\"\n                >\n                  <ui-select-match\n                    class=\"ui-select-match\"\n                    placeholder=\"{{'SELECT_STATE' | translate}}\"\n                  >\n                    {{$select.selected.teamName}}\n                  </ui-select-match>\n                  <ui-select-choices\n                    class=\"ui-select-choices\"\n                    repeat=\"item in vm.teams | filter: $select.search\"\n                  >\n                    <div\n                      ng-bind-html=\"item.teamName | highlight: $select.search\"\n                    ></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >{{'SEX' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <div class=\"radio-inline\">\n                  <label class=\"ui-check\">\n                    <input\n                      type=\"radio\"\n                      required\n                      id=\"sexMale\"\n                      ng-model=\"vm.player.sex\"\n                      name=\"sex\"\n                      value=\"M\"\n                    />\n                    <i class=\"dark-white\"></i>{{'MALE' | translate}}\n                  </label>\n                </div>\n                <div class=\"radio-inline\">\n                  <label class=\"ui-check\">\n                    <input\n                      type=\"radio\"\n                      required\n                      id=\"sexFemale\"\n                      ng-model=\"vm.player.sex\"\n                      name=\"sex\"\n                      value=\"F\"\n                    />\n                    <i class=\"dark-white\"></i>{{'FEMALE' | translate}}\n                  </label>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >FATHER</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.player.father\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >MOTHER</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.player.mother\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'REGISTRATION_DATE' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <div class=\"dropdown\">\n                  <a\n                    class=\"dropdown-toggle\"\n                    id=\"registrationDate\"\n                    role=\"button\"\n                    data-toggle=\"dropdown\"\n                    data-target=\"#\"\n                    href=\"#\"\n                  >\n                    <div class=\"input-group\">\n                      <span class=\"custom-input\">\n                        {{ vm.player.registration_date | date:'yyyy-MM-dd' }}\n                      </span>\n                      <span class=\"input-group-btn\">\n                        <button class=\"btn white\" type=\"button\" translate>\n                          PICK\n                        </button>\n                      </span>\n                    </div>\n                  </a>\n                  <ul\n                    class=\"dropdown-menu\"\n                    role=\"menu\"\n                    aria-labelledby=\"dLabel\"\n                  >\n                    <datetimepicker\n                      data-ng-model=\"vm.player.registration_date\"\n                      data-datetimepicker-config=\"vm.datePickerRegistrationConfig\"\n                    />\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'BIRTH_DATE' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <div class=\"dropdown\">\n                  <a\n                    class=\"dropdown-toggle\"\n                    id=\"birthDate\"\n                    role=\"button\"\n                    data-toggle=\"dropdown\"\n                    data-target=\"#\"\n                    href=\"#\"\n                  >\n                    <div class=\"input-group\">\n                      <span class=\"custom-input\">\n                        {{ vm.player.birth | date:'yyyy-MM-dd' }}\n                      </span>\n                      <span class=\"input-group-btn\">\n                        <button class=\"btn white\" type=\"button\" translate>\n                          PICK\n                        </button>\n                      </span>\n                    </div>\n                  </a>\n                  <ul\n                    class=\"dropdown-menu\"\n                    role=\"menu\"\n                    aria-labelledby=\"dLabel\"\n                  >\n                    <datetimepicker\n                      data-ng-model=\"vm.player.birth\"\n                      data-datetimepicker-config=\"vm.datePickerBirthConfig\"\n                    />\n                  </ul>\n                </div>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >BIRTH_PLACE</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.player.birth_place\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'NATIONALITY' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <ui-select ng-model=\"vm.player.nationality\" theme=\"bootstrap\">\n                  <ui-select-match\n                    class=\"ui-select-match\"\n                    placeholder=\"{{'SELECT_NATIONALITY' | translate}}\"\n                  >\n                    {{$select.selected.nationality_name}}\n                  </ui-select-match>\n                  <ui-select-choices\n                    class=\"ui-select-choices\"\n                    repeat=\"item in vm.nationalities | filter: $select.search\"\n                  >\n                    <div\n                      ng-bind-html=\"item.nationality_name | highlight: $select.search\"\n                    ></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'CITIZENSHIP' | translate}} *</label\n              >\n              <div class=\"col-sm-9\">\n                <ui-select ng-model=\"vm.player.citizenship\" theme=\"bootstrap\">\n                  <ui-select-match\n                    class=\"ui-select-match\"\n                    placeholder=\"{{'SELECT_CITIZENSHIP' | translate}}\"\n                  >\n                    {{$select.selected.nationality_name}}\n                  </ui-select-match>\n                  <ui-select-choices\n                    class=\"ui-select-choices\"\n                    repeat=\"item in vm.nationalities | filter: $select.search\"\n                  >\n                    <div\n                      ng-bind-html=\"item.nationality_name | highlight: $select.search\"\n                    ></div>\n                  </ui-select-choices>\n                </ui-select>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >EXPATRIATE</label\n              >\n              <div class=\"col-sm-9\">\n                <label class=\"ui-switch ui-switch-md info m-t-xs\">\n                  <input type=\"checkbox\" ng-model=\"vm.player.expatriate\" />\n                  <i></i>\n                </label>\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label class=\"col-sm-3 form-control-label\"\n                >{{'ADT' | translate}}</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.player.adt\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\"\n                >PASSPORT</label\n              >\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.player.passport\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\">AMKA</label>\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.player.amka\"\n                />\n              </div>\n            </div>\n            <div class=\"form-group row\">\n              <label translate class=\"col-sm-3 form-control-label\">ΑΦΜ</label>\n              <div class=\"col-sm-9\">\n                <input\n                  type=\"text\"\n                  class=\"form-control\"\n                  ng-model=\"vm.player.afm\"\n                />\n              </div>\n            </div>\n            <!--                        <div class=\"form-group row\">-->\n            <!--                            <label translate class=\"col-sm-3 form-control-label\">ACTIVE</label>-->\n            <!--                            <div class=\"col-sm-9\">-->\n            <!--                                <label class=\"ui-switch ui-switch-md info m-t-xs\">-->\n            <!--                                    <input type=\"checkbox\" ng-model=\"vm.player.active\">-->\n            <!--                                    <i></i>-->\n            <!--                                </label>-->\n            <!--                            </div>-->\n            <!--                        </div>-->\n          </div>\n\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'STATE' | translate}} *</label\n            >\n            <div class=\"col-sm-9\">\n              <ui-select ng-model=\"vm.player.state\" theme=\"bootstrap\">\n                <ui-select-match\n                  class=\"ui-select-match\"\n                  placeholder=\"{{'SELECT_STATE' | translate}}\"\n                >\n                  {{$select.selected.state_name}}\n                </ui-select-match>\n                <ui-select-choices\n                  class=\"ui-select-choices\"\n                  repeat=\"item in vm.states | filter: $select.search\"\n                >\n                  <div\n                    ng-bind-html=\"item.state_name | highlight: $select.search\"\n                  ></div>\n                </ui-select-choices>\n              </ui-select>\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\">ADDRESS</label>\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                class=\"form-control\"\n                ng-model=\"vm.player.address\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\">CITY</label>\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                class=\"form-control\"\n                ng-model=\"vm.player.city\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\"\n              >POSTAL_CODE</label\n            >\n            <div class=\"col-sm-9\">\n              <input type=\"text\" class=\"form-control\" ng-model=\"vm.player.pc\" />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label class=\"col-sm-3 form-control-label\"\n              >{{'PHONE' | translate}}</label\n            >\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                class=\"form-control\"\n                ng-model=\"vm.player.phone\"\n              />\n            </div>\n          </div>\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\">EMAIL</label>\n            <div class=\"col-sm-9\">\n              <input\n                type=\"text\"\n                class=\"form-control\"\n                ng-model=\"vm.player.email\"\n              />\n            </div>\n          </div>\n\n          <div class=\"form-group row\">\n            <label translate class=\"col-sm-3 form-control-label\">IMAGE</label>\n            <div class=\"col-sm-9\">\n              <div class=\"form-file m-b-1\">\n                <input\n                  type=\"file\"\n                  name=\"myImage\"\n                  image-with-preview\n                  ng-model=\"vm.player.image\"\n                  accept=\"image/jpeg,image/jpg,image/png\"\n                  size=\"size < 2097152\"\n                />\n                <button class=\"btn white\" translate>SELECT_FILE</button>\n              </div>\n              <span class=\"error\" ng-show=\"playerForm.myImage.$error.image\">\n                Not a JPEG or a PNG!\n              </span>\n              <span class=\"error\" ng-show=\"playerForm.myImage.$error.size\">\n                Invalid dimensions! Expecting a landscape image smaller than\n                1800x400.\n              </span>\n              <img\n                width=\"150\"\n                ng-show=\"vm.player.image.src\"\n                ng-src=\"{{vm.player.image.src}}\"\n              />\n              <img\n                width=\"150\"\n                ng-hide=\"vm.player.image.src\"\n                ng-src=\"{{vm.getPlayerImage()}}\"\n              />\n            </div>\n          </div>\n        </div>\n        <footer class=\"dker p-a text-left\">\n          <button\n            type=\"submit\"\n            translate\n            class=\"btn success p-x-md m-l-1\"\n            ng-disabled=\"!playerForm.$valid\"\n          >\n            SUBMIT\n          </button>\n          <button\n            type=\"button\"\n            translate\n            ng-if=\"vm.playerId\"\n            ng-click=\"vm.goToProfile()\"\n            class=\"btn info p-x-md m-l-1\"\n          >\n            GO_TO_PROFILE\n          </button>\n        </footer>\n      </form>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerEditController = function PlayerEditController(TeamsFactory, PlayersFactory, MiscFactory, $rootScope, $filter, $state, $stateParams, ngDialog, URLS, Levels) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, PlayerEditController);
	  var vm = this;
	
	  var $date = $filter("date");
	
	  vm.playerId = $stateParams.id;
	  vm.rootScope = $rootScope;
	  vm.recurveLevel = { id: Levels.WHITE, name: "White" };
	  vm.compoundLevel = { id: Levels.WHITE, name: "White" };
	  vm.levels = [{ id: Levels.WHITE, name: "White" }, { id: Levels.BLACK, name: "Black" }, { id: Levels.BLUE, name: "Blue" }, { id: Levels.RED, name: "Red" }, { id: Levels.YELLOW, name: "Yellow" }, { id: Levels.GREEN, name: "Green" }];
	
	  vm.$onInit = function () {
	    vm.player = {};
	    vm.counties = [];
	    vm.teams = [];
	    vm.nationalities = [];
	    MiscFactory.getStates().then(function (response) {
	      vm.states = response.data;
	    });
	    MiscFactory.getCounties().then(function (response) {
	      vm.counties = response.data;
	    });
	    MiscFactory.getNationalities().then(function (response) {
	      vm.nationalities = response.data;
	    });
	    if (vm.playerId) {
	      PlayersFactory.getOne(vm.playerId, {
	        include: "team,citizenship,nationality"
	      }).then(function (response) {
	        vm.player = response.data;
	        vm.player.expatriate = vm.player.expatriate === 1;
	        vm.player.active = vm.player.active === 1;
	        vm.recurveLevel = vm.levels.find(function (l) {
	          return l.id === vm.player.recurve_level;
	        });
	        vm.compoundLevel = vm.levels.find(function (l) {
	          return l.id === vm.player.compound_level;
	        });
	      });
	    }
	    if (!vm.rootScope.user.isUserTypeTeam()) {
	      TeamsFactory.getAll().then(function (response) {
	        vm.teams = response.data;
	      });
	    }
	  };
	
	  var dateTimePickerDefaultConfig = {
	    startView: "day",
	    minView: "day"
	  };
	  vm.datePickerRegistrationConfig = (0, _assign2.default)(dateTimePickerDefaultConfig, { dropdownSelector: "#registrationDate" });
	  vm.datePickerBirthConfig = (0, _assign2.default)(dateTimePickerDefaultConfig, {
	    dropdownSelector: "#birthDate"
	  });
	
	  vm.submit = function () {
	    if (!vm.rootScope.user.isUserTypeTeam()) {
	      if (vm.recurveLevel) {
	        vm.player.recurve_level = vm.recurveLevel.id;
	      }
	      if (vm.compoundLevel) {
	        vm.player.compound_level = vm.compoundLevel.id;
	      }
	      vm.player.registration_date = $date(vm.player.registration_date, "yyyy-MM-dd");
	      vm.player.birth = $date(vm.player.birth, "yyyy-MM-dd");
	      vm.player.active = vm.player.active ? 1 : 0;
	      vm.player.expatriate = vm.player.expatriate ? 1 : 0;
	    }
	    if (vm.player.player_id) {
	      /* UPDATE PLAYER */
	      PlayersFactory.update(vm.player.player_id, vm.player).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        $state.reload();
	      });
	    } else {
	      /* NEW PLAYER */
	      PlayersFactory.create(vm.player).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        $state.go("player-edit", { id: response.data.player_id });
	      });
	    }
	  };
	
	  vm.getPlayerImage = function () {
	    if (vm.player.img) {
	      return URLS.IMAGES_URL + "/players/" + vm.player.img;
	    } else {
	      return "assets/images/no_avatar.png";
	    }
	  };
	
	  vm.goToProfile = function () {
	    $state.go("player-profile", { id: vm.playerId });
	  };
	};
	PlayerEditController.$inject = ["TeamsFactory", "PlayersFactory", "MiscFactory", "$rootScope", "$filter", "$state", "$stateParams", "ngDialog", "URLS", "Levels"];
	
	exports.default = PlayerEditController;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(822);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./playerEdit.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./playerEdit.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 822 */
560,
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _playerProfile = __webpack_require__(824);
	
	var _playerProfile2 = _interopRequireDefault(_playerProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerProfileModule = _angular2.default.module('playerProfile', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('player-profile', {
			url: '/players/{id}/profile',
			component: 'playerProfile',
			data: { pageTitle: 'PLAYER_PROFILE' }
		});
	}]).component('playerProfile', _playerProfile2.default).name;
	
	exports.default = playerProfileModule;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _playerProfile = __webpack_require__(825);
	
	var _playerProfile2 = _interopRequireDefault(_playerProfile);
	
	var _playerProfile3 = __webpack_require__(826);
	
	var _playerProfile4 = _interopRequireDefault(_playerProfile3);
	
	__webpack_require__(827);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerProfileComponent = {
	  bindings: {},
	  template: _playerProfile2.default,
	  controller: _playerProfile4.default,
	  controllerAs: "vm"
	};
	
	exports.default = playerProfileComponent;

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"item\" ng-if=\"vm.player.player_id\">\n    <div class=\"item-bg\">\n        <img ng-src=\"{{vm.getPlayerImage()}}\" class=\"blur opacity-3\">\n    </div>\n    <div class=\"p-a-md\">\n        <div class=\"row m-t\">\n            <div class=\"col-sm-12\">\n                <a href class=\"pull-left m-r-md\">\n                    <span class=\"avatar w-96 profile-image-container\">\n                      <img ng-src=\"{{vm.getPlayerImage()}}\" class=\"{{vm.getPlayerHighestLevelClass()}}\"  />\n                      <i class=\"on b-white\"></i>\n                    </span>\n                </a>\n                <div ng-if=\"vm.player\" class=\"clear\">\n                    <h4 class=\"m-a-0 m-b-xs\" ng-bind=\"vm.player.playerName\"></h4>\n                    <div class=\"text-muted m-b-1\">\n                        <i class=\"fa fa-map-marker m-r-xs\"></i>\n                        <span class=\"m-r\">\n                            {{vm.player.address}}, {{vm.player.city}}\n                        </span>\n                    </div>\n                    <div class=\"block clearfix\">\n                        <button translate\n                                ui-sref=\"team-profile({id:{{vm.player.team_id}}})\"\n                                class=\"btn btn-sm btn-info btn-rounded m-b\"\n                                ng-bind=\"vm.player.teamName\">\n                        </button>\n                    </div>\n                    <div class=\"block clearfix\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.EDIT_PLAYER)\">\n                        <button translate\n                                ui-sref=\"player-edit({id:{{vm.player.player_id}}})\"\n                                class=\"btn btn-sm btn-warning btn-rounded m-b\">EDIT_PLAYER\n                        </button>\n                    </div>\n                    <div class=\"block clearfix\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.VALIDATE_PASSPORT)\">\n                        <button translate\n                                ng-click=\"vm.getCard()\"\n                                class=\"btn btn-sm accent btn-rounded m-b\">DOWNLOAD_CARD\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"dker p-x\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <div class=\"p-y-md clearfix nav-active-primary\">\n                <ul class=\"nav nav-pills nav-sm\">\n                    <li class=\"nav-item\"\n                        ng-repeat=\"component in vm.components\"\n                        ng-if=\"!component.permission || vm.rootScope.user.canDo(component.permission)\"\n                        ng-class=\"{'active': vm.state.includes(component.state)}\">\n                        <a class=\"nav-link\"\n                           translate\n                           ui-sref=\"{{component.state}}\">{{component.name}}</a>\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"padding\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <div class=\"tab-content\">\n                <div class=\"tab-pane p-v-sm active\">\n                    <div ui-view></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerProfileController = function PlayerProfileController(PlayersFactory, $rootScope, $stateParams, $filter, $state, URLS) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, PlayerProfileController);
	  var vm = this;
	
	  vm.rootScope = $rootScope;
	
	  vm.state = $state;
	
	  vm.$onInit = function () {
	    vm.components = [{ state: "player-profile.info", name: "INFORMATION" }, { state: "player-profile.matches", name: "MATCHES" }, {
	      state: "player-profile.transfers",
	      name: "TRANSFERS",
	      permission: vm.rootScope.permissions.VIEW_ALL_TRANSFERS
	    }, {
	      state: "player-profile.payments",
	      name: "PAYMENTS",
	      permission: vm.rootScope.permissions.VIEW_ALL_MOVEMENTS_PLAYER
	    }, { state: "player-profile.trainingEntries", name: "TRAINING_ENTRIES" }];
	    vm.playerId = $stateParams.id;
	    vm.player = {};
	    if (vm.playerId) {
	      PlayersFactory.getOne(vm.playerId, {
	        include: "team,state,citizenship,nationality"
	      }).then(function (response) {
	        vm.player = response.data;
	      });
	    }
	    $state.go("player-profile.info");
	  };
	
	  vm.hasPermission = function (permission) {
	    if (vm.rootScope.user.isUserTypeTeam()) {
	      return vm.rootScope.user.isTeam(vm.player.team_id) && vm.rootScope.user.canDo(permission);
	    } else {
	      return vm.rootScope.user.canDo(permission);
	    }
	  };
	
	  vm.getPlayerImage = function () {
	    if (vm.player.img) {
	      return URLS.IMAGES_URL + "/players/" + vm.player.img;
	    } else {
	      return "assets/images/no_avatar.png";
	    }
	  };
	
	  vm.getCard = function () {
	    var tabWindowId = window.open("about:blank", "_blank");
	    PlayersFactory.card(vm.player.player_id).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	
	  vm.getPlayerHighestLevelClass = function () {
	    if (vm.player.compound_level > vm.player.recurve_level) {
	      return "level-indicator level-" + vm.player.compound_level;
	    }
	    return "level-indicator level-" + vm.player.recurve_level;
	  };
	};
	PlayerProfileController.$inject = ["PlayersFactory", "$rootScope", "$stateParams", "$filter", "$state", "URLS"];
	
	exports.default = PlayerProfileController;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(828);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./playerProfile.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./playerProfile.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, ".level-1{border:3px solid #fff}.level-2{border:3px solid #000}.level-3{border:3px solid #0004ff}.level-4{border:3px solid red}.level-5{border:3px solid #ff0}.level-6{border:3px solid green}", ""]);
	
	// exports


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _playerInfo = __webpack_require__(830);
	
	var _playerInfo2 = _interopRequireDefault(_playerInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerInfoModule = _angular2.default.module('playerInfo', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('player-profile.info', {
			url: '/info',
			component: 'playerInfo',
			data: { pageTitle: 'INFORMATION' }
		});
	}]).component('playerInfo', _playerInfo2.default).name;
	
	exports.default = playerInfoModule;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _playerInfo = __webpack_require__(831);
	
	var _playerInfo2 = _interopRequireDefault(_playerInfo);
	
	var _playerInfo3 = __webpack_require__(832);
	
	var _playerInfo4 = _interopRequireDefault(_playerInfo3);
	
	__webpack_require__(833);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerInfoComponent = {
	  bindings: {},
	  template: _playerInfo2.default,
	  controller: _playerInfo4.default,
	  controllerAs: "vm"
	};
	
	exports.default = playerInfoComponent;

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <div class=\"row m-b\" ng-if=\"vm.player.recurve_level\">\n                    <div class=\"col-xs-6\">\n                        <small class=\"text-muted\" translate>RECURVE_LEVEL</small>\n                        <div class=\"_500\" ng-bind=\"vm.getRecurveLevelName()\"></div>\n                    </div>\n                    <div class=\"col-xs-6\">\n                        <small class=\"text-muted\" translate>COMPOUND_LEVEL</small>\n                        <div class=\"_500\" ng-bind=\"vm.getCompoundLevelName()\"></div>\n                    </div>\n                </div>\n                <div class=\"row m-b\">\n                    <div class=\"col-xs-6\">\n                        <small class=\"text-muted\" translate>FATHER</small>\n                        <div class=\"_500\" ng-bind=\"vm.player.father\"></div>\n                    </div>\n                    <div class=\"col-xs-6\">\n                        <small class=\"text-muted\" translate>MOTHER</small>\n                        <div class=\"_500\" ng-bind=\"vm.player.mother\"></div>\n                    </div>\n                </div>\n                <div class=\"row m-b\">\n                    <div class=\"col-xs-6\">\n                        <small class=\"text-muted\" translate>PHONE</small>\n                        <div class=\"_500\" ng-bind=\"vm.player.phone\"></div>\n                    </div>\n                    <div class=\"col-xs-6\">\n                        <small class=\"text-muted\" translate>EMAIL</small>\n                        <div class=\"_500\" ng-bind=\"vm.player.email\"></div>\n                    </div>\n                </div>\n                <div class=\"row m-b\">\n                    <div class=\"col-xs-6\">\n                        <small class=\"text-muted\" translate>BIRTH</small>\n                        <div class=\"_500\">{{vm.player.birth | date: 'EEEE d MMMM yyyy'}}</div>\n                    </div>\n                    <div class=\"col-xs-6\">\n                        <small class=\"text-muted\" translate>CODE</small>\n                        <div class=\"_500\" ng-bind=\"vm.player.code\"></div>\n                    </div>\n                </div>\n                <div class=\"row m-b\">\n                    <div class=\"col-xs-12\">\n                        <small class=\"text-muted\" translate>ABOUT</small>\n                        <div ng-bind-html=\"vm.player.profile_text\"></div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerInfoController = function PlayerInfoController(PlayersFactory, $rootScope, $stateParams, Levels) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, PlayerInfoController);
	  var vm = this;
	
	  vm.rootScope = $rootScope;
	  vm.levels = [{ id: Levels.WHITE, name: "White" }, { id: Levels.BLACK, name: "Black" }, { id: Levels.BLUE, name: "Blue" }, { id: Levels.RED, name: "Red" }, { id: Levels.YELLOW, name: "Yellow" }, { id: Levels.GREEN, name: "Green" }];
	
	  vm.$onInit = function () {
	    vm.playerId = $stateParams.id;
	    vm.player = {};
	    if (vm.playerId) {
	      PlayersFactory.getOne(vm.playerId, {
	        include: "team,state,citizenship,nationality"
	      }).then(function (response) {
	        vm.player = response.data;
	      });
	    }
	  };
	
	  vm.getCompoundLevelName = function () {
	    return vm.levels.find(function (l) {
	      return l.id === vm.player.compound_level;
	    }).name;
	  };
	
	  vm.getRecurveLevelName = function () {
	    return vm.levels.find(function (l) {
	      return l.id === vm.player.recurve_level;
	    }).name;
	  };
	};
	PlayerInfoController.$inject = ["PlayersFactory", "$rootScope", "$stateParams", "Levels"];
	
	exports.default = PlayerInfoController;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(834);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./playerInfo.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./playerInfo.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 834 */
626,
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _playerMatches = __webpack_require__(836);
	
	var _playerMatches2 = _interopRequireDefault(_playerMatches);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerMatchesModule = _angular2.default.module('playerMatches', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('player-profile.matches', {
			url: '/matches',
			component: 'playerMatches',
			data: { pageTitle: 'PLAYER_MATCHES' }
		});
	}]).component('playerMatches', _playerMatches2.default).name;
	
	exports.default = playerMatchesModule;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _playerMatches = __webpack_require__(837);
	
	var _playerMatches2 = _interopRequireDefault(_playerMatches);
	
	var _playerMatches3 = __webpack_require__(838);
	
	var _playerMatches4 = _interopRequireDefault(_playerMatches3);
	
	__webpack_require__(839);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerMatchesComponent = {
	  bindings: {},
	  template: _playerMatches2.default,
	  controller: _playerMatches4.default,
	  controllerAs: "vm"
	};
	
	exports.default = playerMatchesComponent;

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <div class=\"box-divider m-a-0\"></div>\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerMatchesController = function PlayerMatchesController(PlayersFactory, ReportsFactory, $rootScope, $filter, $stateParams) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, PlayerMatchesController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	
	  vm.playerId = $stateParams.id;
	
	  vm.$onInit = function () {
	    var params = {
	      include: "matches"
	    };
	    PlayersFactory.getOne(vm.playerId, params).then(function (response) {
	      vm.gridOptions.data = response.data.matches;
	    });
	  };
	
	  vm.gridOptions = {
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableSorting: true,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "matchSortName",
	      name: $translate("NAME"),
	      enableFiltering: true
	    }, {
	      field: "leagueSortName",
	      name: $translate("LEAGUE"),
	      enableFiltering: false
	    }, {
	      field: "matchDate",
	      name: $translate("DATE"),
	      enableFiltering: false,
	      width: "120"
	    }, {
	      field: "teamName",
	      name: $translate("TEAM"),
	      enableFiltering: false
	    }, {
	      field: "total_score",
	      name: $translate("SCORE"),
	      enableFiltering: false,
	      width: "80"
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-info" translate ' + 'ng-click="grid.appScope.vm.report(row.entity.match_id)">' + "PRINT</button> " + "</div>" + "</div>",
	      width: "130"
	    }]
	  };
	
	  vm.report = function (matchId) {
	    var tabWindowId = window.open("about:blank", "_blank");
	    ReportsFactory.playerMatchQualification(matchId, vm.playerId).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	};
	PlayerMatchesController.$inject = ["PlayersFactory", "ReportsFactory", "$rootScope", "$filter", "$stateParams"];
	
	exports.default = PlayerMatchesController;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(840);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./playerMatches.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./playerMatches.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 840 */
626,
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _playerPassports = __webpack_require__(842);
	
	var _playerPassports2 = _interopRequireDefault(_playerPassports);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerPassportsModule = _angular2.default.module('playerPassports', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('player-profile.passports', {
			url: '/players/{id}/profile/passports',
			component: 'playerPassports',
			data: { pageTitle: 'PLAYER_MATCHES' }
		});
	}]).component('playerPassports', _playerPassports2.default).name;
	
	exports.default = playerPassportsModule;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _playerPassports = __webpack_require__(843);
	
	var _playerPassports2 = _interopRequireDefault(_playerPassports);
	
	var _playerPassports3 = __webpack_require__(844);
	
	var _playerPassports4 = _interopRequireDefault(_playerPassports3);
	
	__webpack_require__(845);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerPassportsComponent = {
	  bindings: {},
	  template: _playerPassports2.default,
	  controller: _playerPassports4.default,
	  controllerAs: "vm"
	};
	
	exports.default = playerPassportsComponent;

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	module.exports = "<div>\n  <h1>{{ $ctrl.name }}</h1>\n</div>\n"

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerPassportsController = function PlayerPassportsController() {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, PlayerPassportsController);
	  var vm = this;
	};
	
	exports.default = PlayerPassportsController;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(846);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./playerPassports.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./playerPassports.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 846 */
626,
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _playerPayments = __webpack_require__(848);
	
	var _playerPayments2 = _interopRequireDefault(_playerPayments);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerPaymentsModule = _angular2.default.module('playerPayments', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('player-profile.payments', {
			url: '/payments',
			component: 'playerPayments',
			data: { pageTitle: 'PAYMENTS' }
		});
	}]).component('playerPayments', _playerPayments2.default).name;
	
	exports.default = playerPaymentsModule;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _playerPayments = __webpack_require__(849);
	
	var _playerPayments2 = _interopRequireDefault(_playerPayments);
	
	var _playerPayments3 = __webpack_require__(850);
	
	var _playerPayments4 = _interopRequireDefault(_playerPayments3);
	
	__webpack_require__(851);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerPaymentsComponent = {
	  bindings: {},
	  template: _playerPayments2.default,
	  controller: _playerPayments4.default,
	  controllerAs: "vm"
	};
	
	exports.default = playerPaymentsComponent;

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <button type=\"button\"\n                        data-toggle=\"modal\"\n                        data-target=\"#playerPaymentModal\"\n                        ng-click=\"vm.openEditPlayerPaymentModal({})\" class=\"btn btn-sm btn-success m-b-1\">\n                    <i class=\"fa fa-plus\"></i> {{'ADD_PAYMENT' | translate}}\n                </button>\n                <button type=\"button\"\n                        ng-click=\"vm.getPlayerPaymentReport({})\" class=\"btn btn-sm btn-info m-b-1\">\n                    <i class=\"fa fa-file-pdf-o\"></i> {{'PLAYER_PAYMENT_REPORT' | translate}}\n                </button>\n                <div class=\"box-divider m-a-0\"></div>\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"playerPaymentModal\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" ng-if=\"!vm.playerPayment.payment_id\" translate>ADD_PAYMENT</h5>\n                <h5 class=\"modal-title\" ng-if=\"vm.playerPayment.payment_id\" translate>EDIT_PLAYER_PAYMENT</h5>\n            </div>\n            <div class=\"b-b m-b-1 m-t-1 text-center\">\n                <h3 class=\"_300 ng-binding\" translate ng-bind=\"vm.playerPayment.player.playerName\"></h3>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"playerPaymentForm\" class=\"p-x-xs\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'PAYMENT' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <ui-select ng-model=\"vm.playerPayment.payment\" theme=\"bootstrap\" required>\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_PAYMENT' | translate}}\">\n                                    {{$select.selected.name}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.payments | filter: $select.search\">\n                                    <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'AMOUNT' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.playerPayment.amount\"/>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">COMMENTS</label>\n                        <div class=\"col-sm-8\">\n                            <textarea class=\"form-control\" ng-model=\"vm.playerPayment.comments\" rows=\"5\"></textarea>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'DATE' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <div class=\"dropdown\">\n                                <a class=\"dropdown-toggle\" id=\"dateDropdown\" role=\"button\" data-toggle=\"dropdown\"\n                                   data-target=\"#\" href=\"#\">\n                                    <div class=\"input-group\">\n                                    <span class=\"custom-input\">\n                                        {{ vm.playerPayment.payment_at | date:'yyyy-MM-dd' }}\n                                    </span>\n                                        <span class=\"input-group-btn\">\n                                        <button class=\"btn white\" type=\"button\" translate>PICK</button>\n                                    </span>\n                                    </div>\n                                </a>\n                                <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                                    <datetimepicker required data-ng-model=\"vm.playerPayment.payment_at\"\n                                                    data-datetimepicker-config=\"vm.dateConfig\"/>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">STATUS</label>\n                        <div class=\"col-sm-2 p-t-05 p-b-05\">\n                            <label class=\"md-switch\">\n                                <input type=\"checkbox\"\n                                       ng-model=\"vm.playerPayment.status\">\n                                <i class=\"blue\"></i>\n                            </label>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        data-dismiss=\"modal\">CANCEL\n                </button>\n                <button type=\"button\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        ng-click=\"vm.updatePlayerPayment();\"\n                        ng-class=\"{'disabled' : !playerPaymentForm.$valid}\"\n                        ng-disabled=\"!playerPaymentForm.$valid\"\n                        data-dismiss=\"modal\">SUBMIT\n                </button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerPaymentsController = function PlayerPaymentsController(PaymentsFactory, PlayersFactory, $filter, ngDialog, $stateParams, $state) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, PlayerPaymentsController);
		var vm = this;
	
		var $translate = $filter('translate');
		var $date = $filter('date');
	
		vm.$onInit = function () {
			vm.playerId = $stateParams.id;
			vm.player = {};
			vm.payments = [];
			PaymentsFactory.getAll().then(function (response) {
				vm.payments = response.data;
			});
			var params = {
				include: 'payments'
			};
			PlayersFactory.getOne(vm.playerId, params).then(function (response) {
				vm.player = response.data;
				vm.gridOptions.data = response.data.payments;
			});
		};
	
		vm.gridOptions = {
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableSorting: true,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'payment_at',
				enableFiltering: false,
				name: $translate('DATE'),
				width: '130'
			}, {
				field: 'payment.name',
				name: $translate('NAME'),
				enableFiltering: true
			}, {
				field: 'amount',
				name: $translate('AMOUNT'),
				enableFiltering: true,
				width: '90'
			}, {
				field: 'comments',
				name: $translate('COMMENTS'),
				enableFiltering: true
			}, {
				field: 'actions',
				enableFiltering: false,
				name: $translate('ACTIONS'),
				headerCellClass: 'text-center',
				cellTemplate: '' + '<div ' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-warning" translate ' + 'data-toggle="modal" ' + 'data-target="#playerPaymentModal" ' + 'ng-click="grid.appScope.vm.openEditPlayerPaymentModal(row.entity)">EDIT</button> ' + '</div>' + '</div>',
				width: '130'
			}]
		};
	
		vm.dateConfig = { startView: 'day', minView: 'day', dropdownSelector: '#dateDropdown' };
	
		vm.openEditPlayerPaymentModal = function (playerPayment) {
			vm.playerPayment = {};
			angular.copy(playerPayment, vm.playerPayment);
			vm.playerPayment.status = vm.playerPayment.status === 1;
		};
	
		vm.updatePlayerPayment = function () {
			vm.playerPayment.player_id = vm.playerId;
			vm.playerPayment.payment_at = $date(vm.playerPayment.payment_at, 'yyyy-MM-dd');
			vm.playerPayment.status = vm.playerPayment.status ? 1 : 0;
			if (vm.playerPayment.id) {
				PaymentsFactory.updatePayment(vm.playerPayment.id, PaymentsFactory.PAYMENTS_RESOURCES.PLAYER, vm.playerPayment).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					$state.reload();
				});
			} else {
	
				PaymentsFactory.addPayment(PaymentsFactory.PAYMENTS_RESOURCES.PLAYER, vm.playerPayment).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					$state.reload();
				});
			}
		};
	
		vm.getPlayerPaymentReport = function () {
			var params = {
				player_id: vm.playerId
			};
			var tabWindowId = window.open('about:blank', '_blank');
			PaymentsFactory.customReport(PaymentsFactory.PAYMENTS_RESOURCES.PLAYER, params).then(function (response) {
				var file = new Blob([response.data], { type: 'application/pdf' });
				tabWindowId.location.href = window.URL.createObjectURL(file);
			});
		};
	};
	PlayerPaymentsController.$inject = ["PaymentsFactory", "PlayersFactory", "$filter", "ngDialog", "$stateParams", "$state"];
	
	exports.default = PlayerPaymentsController;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(852);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./playerPayments.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./playerPayments.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 852 */
626,
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _playerTransfers = __webpack_require__(854);
	
	var _playerTransfers2 = _interopRequireDefault(_playerTransfers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerTransfersModule = _angular2.default.module('playerTransfers', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('player-profile.transfers', {
			url: '/transfers',
			component: 'playerTransfers',
			data: { pageTitle: 'TRANSFERS' }
		});
	}]).component('playerTransfers', _playerTransfers2.default).name;
	
	exports.default = playerTransfersModule;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _playerTransfers = __webpack_require__(855);
	
	var _playerTransfers2 = _interopRequireDefault(_playerTransfers);
	
	var _playerTransfers3 = __webpack_require__(856);
	
	var _playerTransfers4 = _interopRequireDefault(_playerTransfers3);
	
	__webpack_require__(857);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerTransfersComponent = {
	  bindings: {},
	  template: _playerTransfers2.default,
	  controller: _playerTransfers4.default,
	  controllerAs: "vm"
	};
	
	exports.default = playerTransfersComponent;

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <button type=\"button\"\n                        data-toggle=\"modal\"\n                        data-target=\"#transferModal\"\n                        ng-if=\"vm.hasPermission(vm.rootScope.permissions.MAKE_PLAYER_TRANSFER)\"\n                        ng-click=\"vm.openTransferModal()\"\n                        class=\"btn btn-sm btn-success m-b-1\">\n                    <i class=\"fa fa-plus\"></i> {{'TRANSFER' | translate}}\n                </button>\n                <div class=\"box-divider m-a-0\"></div>\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"transferModal\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" ng-if=\"!vm.transfer.transfer_id\" translate>NEW_TRANSFER_PLAYER</h5>\n                <h5 class=\"modal-title\" ng-if=\"vm.transfer.transfer_id\" translate>EDIT_TRANSFER_PLAYER</h5>\n            </div>\n            <div class=\"b-b m-b-1 m-t-1 text-center\">\n                <h3 class=\"_300 ng-binding\" translate ng-bind=\"vm.player.playerName\"></h3>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"transferForm\" class=\"p-x-xs\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'NEW_TEAM' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <ui-select ng-model=\"vm.transfer.newTeam\" theme=\"bootstrap\" required>\n                                <ui-select-match\n                                        class=\"ui-select-match\"\n                                        placeholder=\"{{'SELECT_NEW_TEAM' | translate}}\">\n                                    {{$select.selected.teamName}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                        class=\"ui-select-choices\"\n                                        repeat=\"item in vm.teams | filter: $select.search\">\n                                    <div ng-bind-html=\"item.teamName | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'DATE' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <div class=\"dropdown\">\n                                <a class=\"dropdown-toggle\" id=\"dateDropdown\" role=\"button\" data-toggle=\"dropdown\"\n                                   data-target=\"#\" href=\"#\">\n                                    <div class=\"input-group\">\n                                    <span class=\"custom-input\">\n                                        {{ vm.transfer.date | date:'yyyy-MM-dd' }}\n                                    </span>\n                                        <span class=\"input-group-btn\">\n                                        <button class=\"btn white\" type=\"button\" translate>PICK</button>\n                                    </span>\n                                    </div>\n                                </a>\n                                <ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\">\n                                    <datetimepicker required data-ng-model=\"vm.transfer.date\"\n                                                    data-datetimepicker-config=\"vm.dateConfig\"/>\n                                </ul>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label translate class=\"col-sm-3 form-control-label\">COMMENTS</label>\n                        <div class=\"col-sm-8\">\n                            <textarea class=\"form-control\" ng-model=\"vm.transfer.comments\" rows=\"5\"></textarea>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        data-dismiss=\"modal\">CANCEL\n                </button>\n                <button type=\"button\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        ng-click=\"vm.submit();\"\n                        ng-class=\"{'disabled' : !transferForm.$valid}\"\n                        ng-disabled=\"!transferForm.$valid\"\n                        data-dismiss=\"modal\">SUBMIT\n                </button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerTransfersController = function PlayerTransfersController(TransfersFactory, TeamsFactory, PlayersFactory, $filter, ngDialog, $stateParams, $state, $rootScope) {
		'ngInject';
	
		(0, _classCallCheck3.default)(this, PlayerTransfersController);
		var vm = this;
	
		var $translate = $filter('translate');
	
		var $date = $filter('date');
	
		vm.rootScope = $rootScope;
	
		vm.$onInit = function () {
			vm.playerId = $stateParams.id;
			vm.player = {};
			vm.transfer = {};
			vm.teams = [];
			var params = {
				include: 'transfers'
			};
			TeamsFactory.getAll({ page_size: 2000 }).then(function (response) {
				vm.teams = response.data;
			});
			PlayersFactory.getOne(vm.playerId, params).then(function (response) {
				vm.player = response.data;
				vm.gridOptions.data = response.data.transfers;
			});
		};
	
		vm.dateConfig = { startView: 'day', minView: 'day', dropdownSelector: '#dateDropdown' };
	
		vm.gridOptions = {
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableSorting: true,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [{
				field: 'date',
				enableFiltering: false,
				name: $translate('DATE'),
				width: '120'
			}, {
				field: 'oldTeam.teamName',
				enableFiltering: true,
				name: $translate('OLD_TEAM')
			}, {
				field: 'newTeam.teamName',
				enableFiltering: true,
				name: $translate('NEW_TEAM')
			}, {
				field: 'comments',
				enableFiltering: false,
				name: $translate('COMMENTS')
			}, {
				field: 'actions',
				enableFiltering: false,
				name: $translate('ACTIONS'),
				headerCellClass: 'text-center',
				cellTemplate: '' + '<div ' + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-warning" translate ' + 'data-toggle="modal" ' + 'data-target="#transferModal" ' + 'ng-click="grid.appScope.vm.openTransferModal(row.entity)">EDIT</button> ' + '</div>' + '</div>',
				width: '130'
			}]
		};
	
		vm.hasPermission = function (permission) {
			return vm.rootScope.user.canDo(permission);
		};
	
		vm.openTransferModal = function (transfer) {
			vm.transfer = {};
			if (transfer) {
				vm.transfer = transfer;
			} else {
				vm.transfer.date = new Date();
			}
		};
	
		vm.submit = function () {
			vm.transfer.player_id = vm.playerId;
			vm.transfer.date = $date(vm.transfer.date, 'yyyy-MM-dd');
			if (vm.transfer.transfer_id) {
				TransfersFactory.update(vm.transfer.transfer_id, vm.transfer).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					$state.reload();
				});
			} else {
				TransfersFactory.create(vm.transfer).then(function (response) {
					ngDialog.open({ template: 'successTemplate' });
					$state.reload();
				});
			}
		};
	};
	PlayerTransfersController.$inject = ["TransfersFactory", "TeamsFactory", "PlayersFactory", "$filter", "ngDialog", "$stateParams", "$state", "$rootScope"];
	
	exports.default = PlayerTransfersController;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(858);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./playerTransfers.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./playerTransfers.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 858 */
626,
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _playerTrainingEntries = __webpack_require__(860);
	
	var _playerTrainingEntries2 = _interopRequireDefault(_playerTrainingEntries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerTrainingEntriesModule = _angular2.default.module('playerTrainingEntries', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('player-profile.trainingEntries', {
			url: '/trainingEntries',
			component: 'playerTrainingEntries',
			data: { pageTitle: 'TRAINING_ENTRIES' }
		});
	}]).component('playerTrainingEntries', _playerTrainingEntries2.default).name;
	
	exports.default = playerTrainingEntriesModule;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _playerTrainingEntries = __webpack_require__(861);
	
	var _playerTrainingEntries2 = _interopRequireDefault(_playerTrainingEntries);
	
	var _playerTrainingEntries3 = __webpack_require__(862);
	
	var _playerTrainingEntries4 = _interopRequireDefault(_playerTrainingEntries3);
	
	__webpack_require__(863);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerTrainingEntriesComponent = {
	  bindings: {},
	  template: _playerTrainingEntries2.default,
	  controller: _playerTrainingEntries4.default,
	  controllerAs: "vm"
	};
	
	exports.default = playerTrainingEntriesComponent;

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <button type=\"button\"\n                        data-toggle=\"modal\"\n                        data-target=\"#playerPaymentModal\"\n                        ng-if=\"vm.hasPermission(vm.rootScope.permissions.ADD_TRAINING_ENTRY)\"\n                        ng-click=\"vm.openAddTrainingEntriesModal({})\" class=\"btn btn-sm btn-success m-b-1\">\n                    <i class=\"fa fa-plus\"></i> {{'ADD_TRAINING_ENTRIES' | translate}}\n                </button>\n<!--                <button type=\"button\"-->\n<!--                        ng-click=\"vm.getPlayerTrainingCard({})\" class=\"btn btn-sm btn-info m-b-1\">-->\n<!--                    <i class=\"fa fa-file-pdf-o\"></i> {{'DOWNLOAD_TRAINING_CARD' | translate}}-->\n<!--                </button>-->\n<!--                <button type=\"button\"-->\n<!--                        ng-click=\"vm.forceStartTrainingEntry({})\" class=\"btn btn-sm btn-magenta m-b-1\">{{'START_ENTRY' | translate}}</button>-->\n                <div class=\"box-divider m-a-0\"></div>\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div id=\"playerPaymentModal\" class=\"modal black-overlay\" data-backdrop=\"false\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h5 class=\"modal-title\" translate>ADD_TRAINING_ENTRIES</h5>\n            </div>\n            <div class=\"b-b m-b-1 m-t-1 text-center\">\n                <h3 class=\"_300 ng-binding\" translate ng-bind=\"vm.player.playerName\"></h3>\n            </div>\n            <div class=\"modal-body text-center p-lg\">\n                <form name=\"newEntriesForm\" class=\"p-x-xs\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'HOW_MANY' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <input type=\"text\" required class=\"form-control\"\n                                   ng-model=\"vm.newEntries.amount\"/>\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'TEAM' | translate}} *</label>\n                        <div class=\"col-sm-8\">\n                            <ui-select ng-model=\"vm.newEntries.trainingCenter\"\n                                       theme=\"bootstrap\">\n                                <ui-select-match class=\"ui-select-match\"\n                                                 placeholder=\"{{'SELECT_TRAINING_CENTER' | translate}}\">\n                                    {{$select.selected.title}}\n                                </ui-select-match>\n                                <ui-select-choices class=\"ui-select-choices\"\n                                                   repeat=\"item in vm.trainingCenters | filter: $select.search\">\n                                    <div ng-bind-html=\"item.title | highlight: $select.search\"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                </form>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\"\n                        translate\n                        class=\"btn dark-white p-x-md\"\n                        data-dismiss=\"modal\">CANCEL\n                </button>\n                <button type=\"button\"\n                        translate\n                        class=\"btn danger p-x-md\"\n                        ng-click=\"vm.addNewEntries();\"\n                        ng-class=\"{'disabled' : !newEntriesForm.$valid}\"\n                        ng-disabled=\"!newEntriesForm.$valid\"\n                        data-dismiss=\"modal\">SUBMIT\n                </button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayerTrainingEntries = function PlayerTrainingEntries(TrainingEntriesFactory, TrainingCentersFactory, PlayersFactory, $filter, ngDialog, $stateParams, $rootScope) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, PlayerTrainingEntries);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  var ACTIONS = {
	    START: 1,
	    END: 2,
	    PAUSE: 3,
	    UNPAUSE: 4,
	    DELETE: 5
	  };
	
	  vm.rootScope = $rootScope;
	
	  vm.$onInit = function () {
	    vm.playerId = $stateParams.id;
	    vm.player = {};
	    vm.trainingCenters = [];
	    vm.reloadEntries();
	    TrainingCentersFactory.getAll().then(function (response) {
	      vm.trainingCenters = response.data;
	    });
	  };
	
	  vm.gridOptions = {
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableSorting: true,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "id",
	      enableFiltering: false,
	      name: "ID",
	      width: "70"
	    }, {
	      field: "status",
	      enableFiltering: false,
	      name: $translate("STATUS"),
	      width: "100",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-success m-l-0" disabled translate ' + 'ng-if="row.entity.started_at === null" ' + ">AVAILABLE</button>" + '<button class="btn btn-sm btn-info m-l-0" disabled translate ' + 'ng-if="row.entity.started_at !== null && row.entity.ended_at === null && row.entity.paused === 0" ' + ">ACTIVE</button>" + '<button class="btn btn-sm btn-danger m-l-0" disabled translate ' + 'ng-if="row.entity.ended_at !== null" ' + ">ENDED</button>" + '<button class="btn btn-sm btn-warning m-l-0" disabled translate ' + 'ng-if="row.entity.paused === 1" ' + ">PAUSED</button>" + "</div>" + "</div>"
	    }, {
	      field: "trainingCenterTitle",
	      enableFiltering: false,
	      name: $translate("TRAINING_CENTER"),
	      width: "200"
	    }, {
	      field: "started_at",
	      enableFiltering: false,
	      name: $translate("STARTED_DATE"),
	      width: "180"
	    }, {
	      field: "ended_at",
	      enableFiltering: false,
	      name: $translate("ENDED_DATE"),
	      width: "180"
	    }, {
	      field: "created_at",
	      enableFiltering: false,
	      name: $translate("CREATED_AT"),
	      width: "180"
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm accent m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' + '&& row.entity.started_at === null" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,1)">START</button>' + '<button class="btn btn-sm btn-warning m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' + '&& row.entity.paused === 0 && row.entity.ended_at === null && row.entity.started_at !== null" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,3)">PAUSE</button>' + '<button class="btn btn-sm btn-success m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' + '&& row.entity.paused === 1" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,4)">UNPAUSE</button>' + '<button class="btn btn-sm btn-primary m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' + '&& row.entity.ended_at === null && row.entity.started_at !== null" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,2)">END</button>' + '<button class="btn btn-sm btn-danger m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_TRAINING_ENTRY) ' + '&& row.entity.ended_at === null" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,5)">DELETE</button>' + "</div>" + "</div>"
	    }]
	  };
	
	  vm.hasPermission = function (permission) {
	    return vm.rootScope.user.canDo(permission);
	  };
	
	  vm.openAddTrainingEntriesModal = function () {
	    vm.newEntries = {};
	  };
	
	  vm.addNewEntries = function () {
	    TrainingEntriesFactory.create({
	      amount: vm.newEntries.amount,
	      training_center_id: vm.newEntries.trainingCenter.id,
	      player_id: vm.playerId
	    }).then(function (response) {
	      ngDialog.open({ template: "successTemplate" });
	      vm.reloadEntries();
	    });
	  };
	
	  vm.actionTrainingEntry = function (trainingEntryId, action) {
	    var question = void 0;
	    switch (action) {
	      case ACTIONS.START:
	        question = "START_TRAINING_ENTRY";
	        break;
	      case ACTIONS.END:
	        question = "END_TRAINING_ENTRY";
	        break;
	      case ACTIONS.PAUSE:
	        question = "PAUSE_TRAINING_ENTRY";
	        break;
	      case ACTIONS.UNPAUSE:
	        question = "UNPAUSE_TRAINING_ENTRY";
	        break;
	      case ACTIONS.DELETE:
	        question = "DELETE_TRAINING_ENTRY";
	        break;
	    }
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate(question)
	      }
	    }).then(function () {
	      var promise = void 0;
	      switch (action) {
	        case ACTIONS.START:
	          promise = TrainingEntriesFactory.start(trainingEntryId);
	          break;
	        case ACTIONS.END:
	          promise = TrainingEntriesFactory.end(trainingEntryId);
	          break;
	        case ACTIONS.PAUSE:
	          promise = TrainingEntriesFactory.pause(trainingEntryId);
	          break;
	        case ACTIONS.UNPAUSE:
	          promise = TrainingEntriesFactory.unpause(trainingEntryId);
	          break;
	        case ACTIONS.DELETE:
	          promise = TrainingEntriesFactory.delete(trainingEntryId);
	          break;
	      }
	      promise.then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        vm.reloadEntries();
	      });
	    });
	  };
	
	  vm.forceStartTrainingEntry = function () {
	    PlayersFactory.startTrainingEntry(vm.playerId).then(function (response) {
	      ngDialog.open({ template: "successTemplate" });
	      vm.reloadEntries();
	    });
	  };
	
	  vm.getPlayerTrainingCard = function () {
	    var tabWindowId = window.open("about:blank", "_blank");
	    PlayersFactory.trainCard(vm.playerId).then(function (response) {
	      var file = new Blob([response.data], { type: "application/pdf" });
	      tabWindowId.location.href = window.URL.createObjectURL(file);
	    });
	  };
	
	  vm.reloadEntries = function () {
	    PlayersFactory.getOne(vm.playerId, {
	      include: "trainingEntries"
	    }).then(function (response) {
	      vm.player = response.data;
	      vm.gridOptions.data = response.data.trainingEntries;
	    });
	  };
	};
	PlayerTrainingEntries.$inject = ["TrainingEntriesFactory", "TrainingCentersFactory", "PlayersFactory", "$filter", "ngDialog", "$stateParams", "$rootScope"];
	
	exports.default = PlayerTrainingEntries;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(864);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./playerTrainingEntries.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./playerTrainingEntries.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 864 */
626,
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _trainingCenter = __webpack_require__(866);
	
	var _trainingCenter2 = _interopRequireDefault(_trainingCenter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainingCenterModule = _angular2.default.module('trainingCenter', [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
		'ngInject';
	
		$stateProvider.state('trainingCenter', {
			url: '/trainingCenter',
			component: 'trainingCenter',
			data: { pageTitle: 'TRAINING_CENTER' },
			resolve: {
				hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
					'ngInject';
	
					var deferred = $q.defer();
					if ($rootScope.user.canDo(Permissions.VIEW_ALL_TRAINING_ENTRIES)) {
						deferred.resolve();
					} else {
						deferred.reject("Access Denied!!");
					}
					return deferred.promise;
				}]
			}
		});
	}]).component('trainingCenter', _trainingCenter2.default).name;
	
	exports.default = trainingCenterModule;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trainingCenter = __webpack_require__(867);
	
	var _trainingCenter2 = _interopRequireDefault(_trainingCenter);
	
	var _trainingCenter3 = __webpack_require__(868);
	
	var _trainingCenter4 = _interopRequireDefault(_trainingCenter3);
	
	__webpack_require__(869);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainingCenterComponent = {
	  bindings: {},
	  template: _trainingCenter2.default,
	  controller: _trainingCenter4.default,
	  controllerAs: "vm"
	};
	
	exports.default = trainingCenterComponent;

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"item\">\n    <div class=\"item-bg\">\n        <img src=\"../assets/images/vegas.jpg\" class=\"blur opacity-3\">\n    </div>\n    <div class=\"p-a-md\">\n        <div class=\"row m-t\">\n            <div class=\"col-sm-12\">\n                <a href class=\"pull-left m-r-md\">\n                    <span class=\"avatar w-96\">\n                      <img ng-src=\"../assets/images/target.png\"/>\n                      <i class=\"on b-white\"></i>\n                    </span>\n                </a>\n                <div class=\"clear\">\n                    <h4 class=\"m-a-0 m-b-xs\" translate>OAKA_TRAINING_CENTER</h4>\n                    <div class=\"text-muted m-b-1\">\n                        <i class=\"fa fa-map-marker m-r-xs\"></i>\n                        <span class=\"m-r\">Ο.Α.Κ.Α.</span>\n                    </div>\n                    <div class=\"block clearfix\">\n                        <button class=\"btn btn-sm btn-info btn-rounded m-b\">\n                            {{vm.trainingEntries.length}} {{ 'CURRENT_ACTIVE_INSIDE' | translate}}\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrainingCenterController = function TrainingCenterController(TrainingEntriesFactory, TeamsFactory, URLS, PlayersFactory, $filter, ngDialog, $stateParams, $state, $rootScope) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, TrainingCenterController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  var $date = $filter("date");
	
	  var ACTIONS = {
	    START: 1,
	    END: 2,
	    PAUSE: 3,
	    UNPAUSE: 4,
	    DELETE: 5
	  };
	
	  vm.rootScope = $rootScope;
	
	  vm.$onInit = function () {
	    vm.trainingEntries = [];
	    vm.reloadEntries();
	  };
	
	  vm.gridOptions = {
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableSorting: true,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "id",
	      enableFiltering: false,
	      name: "ID",
	      width: "70"
	    }, {
	      field: "status",
	      enableFiltering: false,
	      name: $translate("STATUS"),
	      width: "170",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-success m-l-0" disabled translate ' + 'ng-if="row.entity.started_at === null" ' + ">AVAILABLE</button>" + '<button class="btn btn-sm btn-info m-l-0" disabled translate ' + 'ng-if="row.entity.started_at !== null && row.entity.ended_at === null && row.entity.paused === 0" ' + ">ACTIVE</button>" + '<button class="btn btn-sm btn-danger m-l-0" disabled translate ' + 'ng-if="row.entity.ended_at !== null" ' + ">ENDED</button>" + '<button class="btn btn-sm btn-warning m-l-0" disabled translate ' + 'ng-if="row.entity.paused === 1" ' + ">PAUSED</button>" + "</div>" + "</div>"
	    }, {
	      field: "image",
	      name: "",
	      enableFiltering: false,
	      cellTemplate: '<div class="ui-grid-cell-contents ui-grid-align-c p-t-0">' + '<span class="avatar w-32">' + '<img ng-src="{{grid.appScope.vm.getImage(row.entity)}}" alt="">' + '<i class="on b-white bottom"></i>' + "</span>" + "</div>",
	      width: "80"
	    }, {
	      field: "name",
	      enableFiltering: true,
	      name: $translate("NAME"),
	      cellTemplate: '<div class="ui-grid-cell-contents ui-grid-align-c">{{grid.appScope.vm.getName(row.entity)}}</div>'
	    }, {
	      field: "started_at",
	      enableFiltering: false,
	      name: $translate("STARTED_DATE"),
	      width: "180"
	    }, {
	      field: "ended_at",
	      enableFiltering: false,
	      name: $translate("ENDED_DATE"),
	      width: "180"
	    }, {
	      field: "created_at",
	      enableFiltering: false,
	      name: $translate("CREATED_AT"),
	      width: "180"
	    }, {
	      field: "updated_at",
	      enableFiltering: false,
	      name: $translate("UPDATED_AT"),
	      width: "180"
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-white m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' + '&& row.entity.started_at === null" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,1)">START</button>' + '<button class="btn btn-sm btn-warning m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' + '&& row.entity.paused === 0 && row.entity.ended_at === null && row.entity.started_at !== null" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,3)">PAUSE</button>' + '<button class="btn btn-sm btn-success m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' + '&& row.entity.paused === 1" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,4)">UNPAUSE</button>' + '<button class="btn btn-sm btn-primary m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' + '&& row.entity.ended_at === null && row.entity.started_at !== null" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,2)">END</button>' + '<button class="btn btn-sm btn-danger m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_TRAINING_ENTRY) ' + '&& row.entity.ended_at === null" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,5)">DELETE</button>' + "</div>" + "</div>"
	    }]
	  };
	
	  vm.actionTrainingEntry = function (trainingEntryId, action) {
	    var question = void 0;
	    switch (action) {
	      case ACTIONS.START:
	        question = "START_TRAINING_ENTRY";
	        break;
	      case ACTIONS.END:
	        question = "END_TRAINING_ENTRY";
	        break;
	      case ACTIONS.PAUSE:
	        question = "PAUSE_TRAINING_ENTRY";
	        break;
	      case ACTIONS.UNPAUSE:
	        question = "UNPAUSE_TRAINING_ENTRY";
	        break;
	      case ACTIONS.DELETE:
	        question = "DELETE_TRAINING_ENTRY";
	        break;
	    }
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate(question)
	      }
	    }).then(function () {
	      var promise = void 0;
	      switch (action) {
	        case ACTIONS.START:
	          promise = TrainingEntriesFactory.start(trainingEntryId);
	          break;
	        case ACTIONS.END:
	          promise = TrainingEntriesFactory.end(trainingEntryId);
	          break;
	        case ACTIONS.PAUSE:
	          promise = TrainingEntriesFactory.pause(trainingEntryId);
	          break;
	        case ACTIONS.UNPAUSE:
	          promise = TrainingEntriesFactory.unpause(trainingEntryId);
	          break;
	        case ACTIONS.DELETE:
	          promise = TrainingEntriesFactory.delete(trainingEntryId);
	          break;
	      }
	      promise.then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        vm.reloadEntries();
	      });
	    });
	  };
	
	  vm.hasPermission = function (permission) {
	    return vm.rootScope.user.canDo(permission);
	  };
	
	  vm.getName = function (entity) {
	    if (entity.player) {
	      return entity.player.playerName;
	    } else if (entity.coach) {
	      return entity.coach.coachName;
	    } else {
	      return "";
	    }
	  };
	
	  vm.getImage = function (entity) {
	    if (entity.player && entity.player.img) {
	      return URLS.IMAGES_URL + "/players/" + entity.player.img;
	    } else if (entity.coach && entity.coach.img) {
	      return URLS.IMAGES_URL + "/coaches/" + entity.coach.img;
	    } else {
	      return "assets/images/no_avatar.png";
	    }
	  };
	
	  vm.reloadEntries = function () {
	    TrainingEntriesFactory.getAll({ page_size: 2000, open: true }).then(function (response) {
	      vm.trainingEntries = response.data;
	      vm.gridOptions.data = response.data;
	    });
	  };
	};
	TrainingCenterController.$inject = ["TrainingEntriesFactory", "TeamsFactory", "URLS", "PlayersFactory", "$filter", "ngDialog", "$stateParams", "$state", "$rootScope"];
	
	exports.default = TrainingCenterController;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(870);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./trainingCenter.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./trainingCenter.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 870 */
426,
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _trainingCentersList = __webpack_require__(872);
	
	var _trainingCentersList2 = _interopRequireDefault(_trainingCentersList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainingCentersModule = _angular2.default.module("trainingCentersList", [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("trainingCenters", {
	    url: "/trainingCenters",
	    component: "trainingCentersList",
	    data: { pageTitle: "trainingCenters" },
	    resolve: {
	      hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
	        "ngInject";
	
	        var deferred = $q.defer();
	        if ($rootScope.user.canDo(Permissions.VIEW_ALL_TRAINING_ENTRIES)) {
	          deferred.resolve();
	        } else {
	          deferred.reject("Access Denied!!");
	        }
	        return deferred.promise;
	      }]
	    }
	  });
	}]).component("trainingCentersList", _trainingCentersList2.default).name;
	
	exports.default = trainingCentersModule;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trainingCentersList = __webpack_require__(873);
	
	var _trainingCentersList2 = _interopRequireDefault(_trainingCentersList);
	
	var _trainingCentersList3 = __webpack_require__(874);
	
	var _trainingCentersList4 = _interopRequireDefault(_trainingCentersList3);
	
	__webpack_require__(875);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainingCentersListComponent = {
	  bindings: {},
	  template: _trainingCentersList2.default,
	  controller: _trainingCentersList4.default,
	  controllerAs: "vm"
	};
	
	exports.default = trainingCentersListComponent;

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\" ng-if=\"vm.hasPermission(vm.rootScope.permissions.ADD_TRAINING_CENTER)\">\n                <button ui-sref=\"trainingCenter-edit\" class=\"btn btn-sm btn-success\">\n                    <i class=\"fa fa-plus\"></i> {{'CREATE' | translate}}\n                </button>\n            </div>\n            <div class=\"table-responsive m-b-lg\">\n                <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrainingCentersListController = function TrainingCentersListController(TrainingCentersFactory, $rootScope, $filter, $state, ngDialog, URLS) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, TrainingCentersListController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  vm.rootScope = $rootScope;
	
	  vm.$onInit = function () {
	    reloadStaff();
	  };
	
	  vm.gridOptions = {
	    enableSorting: true,
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "title",
	      enableFiltering: true,
	      name: $translate("TITLE")
	    }, {
	      field: "description",
	      name: $translate("DESCRIPTION"),
	      enableFiltering: true
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + '<div class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<a href class="btn btn-sm btn-info m-l-1" translate ' + 'ng-click="grid.appScope.vm.goToProfile(row.entity.id)">PROFILE</a>' + '<button class="btn btn-sm btn-warning m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_STAFF)" ' + 'ng-click="grid.appScope.vm.goToEdit(row.entity.id)">EDIT</button>' + '<button class="btn btn-sm btn-danger m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_STAFF)" ' + 'ng-click="grid.appScope.vm.deleteStaff(row.entity.id)">DELETE</button>' + "</div>" + "</div>",
	      width: "405"
	    }]
	  };
	
	  vm.hasPermission = function (permission) {
	    return vm.rootScope.user.canDo(permission);
	  };
	
	  vm.goToProfile = function (staffId) {
	    $state.go("trainingCenter-profile", { id: staffId });
	  };
	
	  vm.goToEdit = function (staffId) {
	    $state.go("trainingCenter-edit", { id: staffId });
	  };
	
	  vm.deleteStaff = function (staffId) {
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate("CONFIRM_DELETE_TRAINING_CENTER")
	      }
	    }).then(function () {
	      TrainingCentersFactory.delete(staffId).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        reloadStaff();
	      });
	    });
	  };
	
	  function reloadStaff() {
	    TrainingCentersFactory.getAll().then(function (response) {
	      vm.gridOptions.data = response.data;
	    });
	  }
	};
	TrainingCentersListController.$inject = ["TrainingCentersFactory", "$rootScope", "$filter", "$state", "ngDialog", "URLS"];
	
	exports.default = TrainingCentersListController;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(876);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./trainingCentersList.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./trainingCentersList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 876 */
560,
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _trainingCenterEdit = __webpack_require__(878);
	
	var _trainingCenterEdit2 = _interopRequireDefault(_trainingCenterEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainingCenterEditModule = _angular2.default.module("trainingCenterEdit", [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("trainingCenter-edit", {
	    url: "/trainingCenters/:id/edit",
	    component: "trainingCenterEdit",
	    data: { pageTitle: "EDIT_TRAINING_CENTER" },
	    params: {
	      id: { squash: true, value: null }
	    },
	    resolve: {
	      hasPermission: ["$q", "$rootScope", "Permissions", "$stateParams", function hasPermission($q, $rootScope, Permissions, $stateParams) {
	        "ngInject";
	
	        var deferred = $q.defer();
	
	        if ($rootScope.user.canDo(Permissions.EDIT_TRAINING_CENTER)) {
	          deferred.resolve();
	        } else {
	          deferred.reject("Access denied!");
	        }
	
	        return deferred.promise;
	      }]
	    }
	  });
	}]).component("trainingCenterEdit", _trainingCenterEdit2.default).name;
	
	exports.default = trainingCenterEditModule;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trainingCenterEdit = __webpack_require__(879);
	
	var _trainingCenterEdit2 = _interopRequireDefault(_trainingCenterEdit);
	
	var _trainingCenterEdit3 = __webpack_require__(880);
	
	var _trainingCenterEdit4 = _interopRequireDefault(_trainingCenterEdit3);
	
	__webpack_require__(881);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainingCenterEditComponent = {
	  bindings: {},
	  template: _trainingCenterEdit2.default,
	  controller: _trainingCenterEdit4.default,
	  controllerAs: "vm"
	};
	
	exports.default = trainingCenterEditComponent;

/***/ }),
/* 879 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"b-b m-b-1 p-t-1 p-b-1 text-center\">\n                <h3 class=\"_300 ng-binding\" ng-if=\"!vm.trainingCenter.id\" translate>CREATE_TRAINING_CENTER</h3>\n                <h3 class=\"_300 ng-binding\" ng-if=\"vm.trainingCenter.id\" translate>EDIT_TRAINING_CENTER</h3>\n            </div>\n            <form name=\"trainingCenterForm\" ng-submit=\"vm.submit()\">\n                <div class=\"box-body\">\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'TITLE' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.trainingCenter.title\">\n                        </div>\n                    </div>\n                    <div class=\"form-group row\">\n                        <label class=\"col-sm-3 form-control-label\">{{'DESCRIPTION' | translate}} *</label>\n                        <div class=\"col-sm-9\">\n                            <input type=\"text\" required class=\"form-control\" ng-model=\"vm.trainingCenter.description\">\n                        </div>\n                    </div>\n                </div>\n                <footer class=\"dker p-a text-left\">\n                    <button type=\"submit\"\n                            translate\n                            class=\"btn success p-x-md m-l-1\"\n                            ng-disabled=\"!trainingCenterForm.$valid\">SUBMIT</button>\n                    <button type=\"button\"\n                            translate\n                            ng-if=\"vm.trainingCenter.id\"\n                            ng-click=\"vm.goToProfile()\"\n                            class=\"btn info p-x-md m-l-1\">GO_TO_PROFILE</button>\n                </footer>\n            </form>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StaffEditController = function StaffEditController(TrainingCentersFactory, $rootScope, $state, $stateParams, ngDialog) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, StaffEditController);
	  var vm = this;
	
	  vm.trainingCenterId = $stateParams.id;
	  vm.rootScope = $rootScope;
	
	  vm.$onInit = function () {
	    vm.trainingCenter = {
	      id: $stateParams.id
	    };
	    if (vm.trainingCenter.id) {
	      TrainingCentersFactory.getOne(vm.trainingCenter.id).then(function (response) {
	        vm.trainingCenter = response.data;
	      });
	    }
	  };
	
	  vm.submit = function () {
	    if (vm.trainingCenter.id) {
	      TrainingCentersFactory.update(vm.trainingCenter.id, vm.trainingCenter).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        $state.reload();
	      });
	    } else {
	      TrainingCentersFactory.create(vm.trainingCenter).then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        $state.go("trainingCenter-edit", { id: response.data.id });
	      });
	    }
	  };
	
	  vm.goToProfile = function () {
	    $state.go("trainingCenter-profile", { id: vm.trainingCenter.id });
	  };
	};
	StaffEditController.$inject = ["TrainingCentersFactory", "$rootScope", "$state", "$stateParams", "ngDialog"];
	
	exports.default = StaffEditController;

/***/ }),
/* 881 */
[1102, 882],
/* 882 */
560,
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _trainingCenterProfile = __webpack_require__(884);
	
	var _trainingCenterProfile2 = _interopRequireDefault(_trainingCenterProfile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainingCenterProfileModule = _angular2.default.module("trainingCenterProfile", [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("trainingCenter-profile", {
	    url: "/trainingCenters/:id/profile",
	    component: "trainingCenterProfile",
	    data: { pageTitle: "TRAINING_CENTER" },
	    params: {
	      id: { squash: true }
	    },
	    resolve: {
	      hasPermission: ["$q", "$rootScope", "Permissions", function hasPermission($q, $rootScope, Permissions) {
	        "ngInject";
	
	        var deferred = $q.defer();
	        if ($rootScope.user.canDo(Permissions.VIEW_ALL_TRAINING_ENTRIES)) {
	          deferred.resolve();
	        } else {
	          deferred.reject("Access Denied!!");
	        }
	        return deferred.promise;
	      }]
	    }
	  });
	}]).component("trainingCenterProfile", _trainingCenterProfile2.default).name;
	
	exports.default = trainingCenterProfileModule;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _trainingCenterProfile = __webpack_require__(885);
	
	var _trainingCenterProfile2 = _interopRequireDefault(_trainingCenterProfile);
	
	var _trainingCenterProfile3 = __webpack_require__(886);
	
	var _trainingCenterProfile4 = _interopRequireDefault(_trainingCenterProfile3);
	
	__webpack_require__(887);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trainingCenterProfileComponent = {
	  bindings: {},
	  template: _trainingCenterProfile2.default,
	  controller: _trainingCenterProfile4.default,
	  controllerAs: "vm"
	};
	
	exports.default = trainingCenterProfileComponent;

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"item\">\n    <div class=\"item-bg\">\n        <img src=\"../assets/images/vegas.jpg\" class=\"blur opacity-3\">\n    </div>\n    <div class=\"p-a-md\">\n        <div class=\"row m-t\">\n            <div class=\"col-sm-12\">\n                <a href class=\"pull-left m-r-md\">\n                    <span class=\"avatar w-96\">\n                      <img ng-src=\"../assets/images/target.png\"/>\n                      <i class=\"on b-white\"></i>\n                    </span>\n                </a>\n                <div class=\"clear\">\n                    <h4 class=\"m-a-0 m-b-2\">{{vm.trainingCenter.title}}</h4>\n                    <div class=\"block clearfix\">\n                        <button class=\"btn btn-sm btn-info btn-rounded m-b\">\n                            {{vm.trainingEntries.length}} {{ 'CURRENT_ACTIVE_INSIDE' | translate}}\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"row\">\n    <div class=\"col-sm-12\">\n        <div class=\"box\">\n            <div class=\"box-body\">\n                <div class=\"table-responsive m-b-lg\">\n                    <div ui-grid=\"vm.gridOptions\" ui-grid-pagination></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrainingCenterController = function TrainingCenterController(TrainingEntriesFactory, TrainingCentersFactory, URLS, $filter, ngDialog, $stateParams, $rootScope) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, TrainingCenterController);
	  var vm = this;
	
	  var $translate = $filter("translate");
	
	  var ACTIONS = {
	    START: 1,
	    END: 2,
	    PAUSE: 3,
	    UNPAUSE: 4,
	    DELETE: 5
	  };
	
	  vm.rootScope = $rootScope;
	
	  vm.$onInit = function () {
	    vm.trainingCenter = {
	      id: $stateParams.id
	    };
	    vm.trainingEntries = [];
	    TrainingCentersFactory.getOne(vm.trainingCenter.id).then(function (response) {
	      vm.trainingCenter = response.data;
	    });
	    vm.reloadEntries();
	  };
	
	  vm.gridOptions = {
	    paginationPageSizes: [50, 100, 150],
	    paginationPageSize: 50,
	    enableSorting: true,
	    enableColumnMenus: false,
	    enableFiltering: true,
	    columnDefs: [{
	      field: "status",
	      enableFiltering: false,
	      name: $translate("STATUS"),
	      width: "100",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-success m-l-0" disabled translate ' + 'ng-if="row.entity.started_at === null" ' + ">AVAILABLE</button>" + '<button class="btn btn-sm btn-info m-l-0" disabled translate ' + 'ng-if="row.entity.started_at !== null && row.entity.ended_at === null && row.entity.paused === 0" ' + ">ACTIVE</button>" + '<button class="btn btn-sm btn-danger m-l-0" disabled translate ' + 'ng-if="row.entity.ended_at !== null" ' + ">ENDED</button>" + '<button class="btn btn-sm btn-warning m-l-0" disabled translate ' + 'ng-if="row.entity.paused === 1" ' + ">PAUSED</button>" + "</div>" + "</div>"
	    }, {
	      field: "image",
	      name: "",
	      enableFiltering: false,
	      cellTemplate: '<div class="ui-grid-cell-contents ui-grid-align-c p-t-0">' + '<span class="avatar w-32">' + '<img ng-src="{{grid.appScope.vm.getImage(row.entity)}}" alt="">' + '<i class="on b-white bottom"></i>' + "</span>" + "</div>",
	      width: "80"
	    }, {
	      field: "name",
	      enableFiltering: true,
	      name: $translate("NAME"),
	      cellTemplate: '<div class="ui-grid-cell-contents ui-grid-align-c">{{grid.appScope.vm.getName(row.entity)}}</div>'
	    }, {
	      field: "started_at",
	      enableFiltering: false,
	      name: $translate("STARTED_DATE"),
	      width: "180"
	    }, {
	      field: "ended_at",
	      enableFiltering: false,
	      name: $translate("ENDED_DATE"),
	      width: "180"
	    }, {
	      field: "actions",
	      enableFiltering: false,
	      name: $translate("ACTIONS"),
	      headerCellClass: "text-center",
	      cellTemplate: "" + "<div " + 'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' + '<div class="buttons">' + '<button class="btn btn-sm btn-white m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' + '&& row.entity.started_at === null" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,1)">START</button>' + '<button class="btn btn-sm btn-warning m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' + '&& row.entity.paused === 0 && row.entity.ended_at === null && row.entity.started_at !== null" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,3)">PAUSE</button>' + '<button class="btn btn-sm btn-success m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' + '&& row.entity.paused === 1" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,4)">UNPAUSE</button>' + '<button class="btn btn-sm btn-primary m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' + '&& row.entity.ended_at === null && row.entity.started_at !== null" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,2)">END</button>' + '<button class="btn btn-sm btn-danger m-l-1" translate ' + 'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_TRAINING_ENTRY) ' + '&& row.entity.ended_at === null" ' + 'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,5)">DELETE</button>' + "</div>" + "</div>"
	    }]
	  };
	
	  vm.actionTrainingEntry = function (trainingEntryId, action) {
	    var question = void 0;
	    switch (action) {
	      case ACTIONS.START:
	        question = "START_TRAINING_ENTRY";
	        break;
	      case ACTIONS.END:
	        question = "END_TRAINING_ENTRY";
	        break;
	      case ACTIONS.PAUSE:
	        question = "PAUSE_TRAINING_ENTRY";
	        break;
	      case ACTIONS.UNPAUSE:
	        question = "UNPAUSE_TRAINING_ENTRY";
	        break;
	      case ACTIONS.DELETE:
	        question = "DELETE_TRAINING_ENTRY";
	        break;
	    }
	    ngDialog.openConfirm({
	      template: "confirmTemplate",
	      data: {
	        message: $translate(question)
	      }
	    }).then(function () {
	      var promise = void 0;
	      switch (action) {
	        case ACTIONS.START:
	          promise = TrainingEntriesFactory.start(trainingEntryId);
	          break;
	        case ACTIONS.END:
	          promise = TrainingEntriesFactory.end(trainingEntryId);
	          break;
	        case ACTIONS.PAUSE:
	          promise = TrainingEntriesFactory.pause(trainingEntryId);
	          break;
	        case ACTIONS.UNPAUSE:
	          promise = TrainingEntriesFactory.unpause(trainingEntryId);
	          break;
	        case ACTIONS.DELETE:
	          promise = TrainingEntriesFactory.delete(trainingEntryId);
	          break;
	      }
	      promise.then(function (response) {
	        ngDialog.open({ template: "successTemplate" });
	        vm.reloadEntries();
	      });
	    });
	  };
	
	  vm.hasPermission = function (permission) {
	    return vm.rootScope.user.canDo(permission);
	  };
	
	  vm.getName = function (entity) {
	    if (entity.player) {
	      return entity.player.playerName;
	    } else if (entity.coach) {
	      return entity.coach.coachName;
	    } else if (entity.staff) {
	      return entity.staff.staffName;
	    } else if (entity.trainer) {
	      return entity.trainer.trainerName;
	    } else {
	      return "";
	    }
	  };
	
	  vm.getImage = function (entity) {
	    if (entity.player && entity.player.img) {
	      return URLS.IMAGES_URL + "/players/" + entity.player.img;
	    } else if (entity.coach && entity.coach.img) {
	      return URLS.IMAGES_URL + "/coaches/" + entity.coach.img;
	    } else if (entity.staff && entity.staff.img) {
	      return URLS.IMAGES_URL + "/staff/" + entity.staff.img;
	    } else if (entity.trainer && entity.trainer.img) {
	      return URLS.IMAGES_URL + "/trainers/" + entity.trainer.img;
	    } else {
	      return "assets/images/no_avatar.png";
	    }
	  };
	
	  vm.reloadEntries = function () {
	    TrainingEntriesFactory.getAll({
	      page_size: 2000,
	      open: true,
	      training_center_id: vm.trainingCenter.id
	    }).then(function (response) {
	      vm.trainingEntries = response.data;
	      vm.gridOptions.data = response.data;
	    });
	  };
	};
	TrainingCenterController.$inject = ["TrainingEntriesFactory", "TrainingCentersFactory", "URLS", "$filter", "ngDialog", "$stateParams", "$rootScope"];
	
	exports.default = TrainingCenterController;

/***/ }),
/* 887 */
[1102, 888],
/* 888 */
560,
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(338);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _privacy = __webpack_require__(890);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var privacyModule = _angular2.default.module("privacy", [_angularUiRouter2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state("privacy", {
	    url: "/{path:privacy|policy}",
	    component: "privacy",
	    data: { pageTitle: "Privacy" }
	  });
	}]).component("privacy", _privacy2.default).name;
	
	exports.default = privacyModule;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _privacy = __webpack_require__(891);
	
	var _privacy2 = _interopRequireDefault(_privacy);
	
	var _privacy3 = __webpack_require__(892);
	
	var _privacy4 = _interopRequireDefault(_privacy3);
	
	__webpack_require__(893);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var privacyComponent = {
	  bindings: {},
	  template: _privacy2.default,
	  controller: _privacy4.default,
	  controllerAs: "vm"
	};
	
	exports.default = privacyComponent;

/***/ }),
/* 891 */
/***/ (function(module, exports) {

	module.exports = "<strong>Privacy Policy</strong>\n<p>\n  This privacy policy applies to the\n  <span ng-if=\"vm.rootScope.isEOT\">EOT Velos</span>\n  <span ng-if=\"vm.rootScope.isSAAF\">SAAF Velos</span> app (hereby referred to as\n  \"Application\") for mobile devices that was created by Lefteris Lalos (hereby\n  referred to as \"Service Provider\") as a Free service. This service is intended\n  for use \"AS IS\".\n</p>\n<br /><strong>Information Collection and Use</strong>\n<p>\n  The Application collects information when you download and use it. This\n  information may include information such as\n</p>\n<ul>\n  <li>Your device's Internet Protocol address (e.g. IP address)</li>\n  <li>\n    The pages of the Application that you visit, the time and date of your\n    visit, the time spent on those pages\n  </li>\n  <li>The time spent on the Application</li>\n  <li>The operating system you use on your mobile device</li>\n</ul>\n<p></p>\n<br />\n<p>\n  The Application does not gather precise information about the location of your\n  mobile device.\n</p>\n<div style=\"display: none\">\n  <p>\n    The Application collects your device's location, which helps the Service\n    Provider determine your approximate geographical location and make use of in\n    below ways:\n  </p>\n  <ul>\n    <li>\n      Geolocation Services: The Service Provider utilizes location data to\n      provide features such as personalized content, relevant recommendations,\n      and location-based services.\n    </li>\n    <li>\n      Analytics and Improvements: Aggregated and anonymized location data helps\n      the Service Provider to analyze user behavior, identify trends, and\n      improve the overall performance and functionality of the Application.\n    </li>\n    <li>\n      Third-Party Services: Periodically, the Service Provider may transmit\n      anonymized location data to external services. These services assist them\n      in enhancing the Application and optimizing their offerings.\n    </li>\n  </ul>\n</div>\n<br />\n<p>\n  The Service Provider may use the information you provided to contact you from\n  time to time to provide you with important information, required notices and\n  marketing promotions.\n</p>\n<br />\n<p>\n  For a better experience, while using the Application, the Service Provider may\n  require you to provide us with certain personally identifiable information.\n  The information that the Service Provider request will be retained by them and\n  used as described in this privacy policy.\n</p>\n<br /><strong>Third Party Access</strong>\n<p>\n  Only aggregated, anonymized data is periodically transmitted to external\n  services to aid the Service Provider in improving the Application and their\n  service. The Service Provider may share your information with third parties in\n  the ways that are described in this privacy statement.\n</p>\n<div>\n  <br />\n  <p>\n    Please note that the Application utilizes third-party services that have\n    their own Privacy Policy about handling data. Below are the links to the\n    Privacy Policy of the third-party service providers used by the Application:\n  </p>\n  <ul>\n    <li>\n      <a\n        href=\"https://www.google.com/policies/privacy/\"\n        target=\"_blank\"\n        rel=\"noopener noreferrer\"\n        >Google Play Services</a\n      >\n    </li>\n    <!---->\n    <li>\n      <a\n        href=\"https://firebase.google.com/support/privacy\"\n        target=\"_blank\"\n        rel=\"noopener noreferrer\"\n        >Google Analytics for Firebase</a\n      >\n    </li>\n    <li>\n      <a\n        href=\"https://firebase.google.com/support/privacy/\"\n        target=\"_blank\"\n        rel=\"noopener noreferrer\"\n        >Firebase Crashlytics</a\n      >\n    </li>\n    <!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!----><!---->\n  </ul>\n</div>\n<br />\n<p>\n  The Service Provider may disclose User Provided and Automatically Collected\n  Information:\n</p>\n<ul>\n  <li>\n    as required by law, such as to comply with a subpoena, or similar legal\n    process;\n  </li>\n  <li>\n    when they believe in good faith that disclosure is necessary to protect\n    their rights, protect your safety or the safety of others, investigate\n    fraud, or respond to a government request;\n  </li>\n  <li>\n    with their trusted services providers who work on their behalf, do not have\n    an independent use of the information we disclose to them, and have agreed\n    to adhere to the rules set forth in this privacy statement.\n  </li>\n</ul>\n<p></p>\n<br /><strong>Opt-Out Rights</strong>\n<p>\n  You can stop all collection of information by the Application easily by\n  uninstalling it. You may use the standard uninstall processes as may be\n  available as part of your mobile device or via the mobile application\n  marketplace or network.\n</p>\n<br /><strong>Data Retention Policy</strong>\n<p>\n  The Service Provider will retain User Provided data for as long as you use the\n  Application and for a reasonable time thereafter. If you'd like them to delete\n  User Provided Data that you have provided via the Application, please contact\n  them at\n  <span ng-if=\"vm.rootScope.isEOT\">info@archery.org.gr</span>\n  <span ng-if=\"vm.rootScope.isSAAF\">info@saaf.sa</span> and they will respond in\n  a reasonable time.\n</p>\n<br /><strong>Children</strong>\n<p>\n  The Service Provider does not use the Application to knowingly solicit data\n  from or market to children under the age of 13.\n</p>\n<div>\n  <br />\n  <p>\n    The Application does not address anyone under the age of 13. The Service\n    Provider does not knowingly collect personally identifiable information from\n    children under 13 years of age. In the case the Service Provider discover\n    that a child under 13 has provided personal information, the Service\n    Provider will immediately delete this from their servers. If you are a\n    parent or guardian and you are aware that your child has provided us with\n    personal information, please contact the Service Provider (\n    <span ng-if=\"vm.rootScope.isEOT\">info@archery.org.gr</span>\n    <span ng-if=\"vm.rootScope.isSAAF\">info@saaf.sa</span>) so that they will be\n    able to take the necessary actions.\n  </p>\n</div>\n<!----><br /><strong>Security</strong>\n<p>\n  The Service Provider is concerned about safeguarding the confidentiality of\n  your information. The Service Provider provides physical, electronic, and\n  procedural safeguards to protect information the Service Provider processes\n  and maintains.\n</p>\n<br /><strong>Changes</strong>\n<p>\n  This Privacy Policy may be updated from time to time for any reason. The\n  Service Provider will notify you of any changes to the Privacy Policy by\n  updating this page with the new Privacy Policy. You are advised to consult\n  this Privacy Policy regularly for any changes, as continued use is deemed\n  approval of all changes.\n</p>\n<br />\n<p>This privacy policy is effective as of 2024-09-04</p>\n<br /><strong>Your Consent</strong>\n<p>\n  By using the Application, you are consenting to the processing of your\n  information as set forth in this Privacy Policy now and as amended by us.\n</p>\n<br /><strong>Contact Us</strong>\n<p>\n  If you have any questions regarding privacy while using the Application, or\n  have questions about the practices, please contact the Service Provider via\n  email at\n  <span ng-if=\"vm.rootScope.isEOT\">info@archery.org.gr</span>\n  <span ng-if=\"vm.rootScope.isSAAF\">info@saaf.sa</span>.\n</p>\n<hr />\n<p>\n  This privacy policy page was generated by\n  <a\n    href=\"https://app-privacy-policy-generator.nisrulz.com/\"\n    target=\"_blank\"\n    rel=\"noopener noreferrer\"\n    >App Privacy Policy Generator</a\n  >\n</p>\n"

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(424);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrivacyController = function PrivacyController($rootScope) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, PrivacyController);
	  var vm = this;
	
	  vm.rootScope = $rootScope;
	};
	PrivacyController.$inject = ["$rootScope"];
	
	exports.default = PrivacyController;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(894);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./privacy.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./privacy.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	
	
	// module
	exports.push([module.id, ".login{color:red}", ""]);
	
	// exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _http = __webpack_require__(896);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _auth = __webpack_require__(897);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _matches = __webpack_require__(898);
	
	var _matches2 = _interopRequireDefault(_matches);
	
	var _reports = __webpack_require__(899);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _payments = __webpack_require__(900);
	
	var _payments2 = _interopRequireDefault(_payments);
	
	var _teams = __webpack_require__(901);
	
	var _teams2 = _interopRequireDefault(_teams);
	
	var _judges = __webpack_require__(902);
	
	var _judges2 = _interopRequireDefault(_judges);
	
	var _coaches = __webpack_require__(903);
	
	var _coaches2 = _interopRequireDefault(_coaches);
	
	var _staff = __webpack_require__(904);
	
	var _staff2 = _interopRequireDefault(_staff);
	
	var _trainers = __webpack_require__(905);
	
	var _trainers2 = _interopRequireDefault(_trainers);
	
	var _leagues = __webpack_require__(906);
	
	var _leagues2 = _interopRequireDefault(_leagues);
	
	var _players = __webpack_require__(907);
	
	var _players2 = _interopRequireDefault(_players);
	
	var _misc = __webpack_require__(908);
	
	var _misc2 = _interopRequireDefault(_misc);
	
	var _fileReader = __webpack_require__(909);
	
	var _fileReader2 = _interopRequireDefault(_fileReader);
	
	var _transfers = __webpack_require__(910);
	
	var _transfers2 = _interopRequireDefault(_transfers);
	
	var _roles = __webpack_require__(911);
	
	var _roles2 = _interopRequireDefault(_roles);
	
	var _user = __webpack_require__(912);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _users = __webpack_require__(913);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _trainingEntries = __webpack_require__(914);
	
	var _trainingEntries2 = _interopRequireDefault(_trainingEntries);
	
	var _trainingCenters = __webpack_require__(915);
	
	var _trainingCenters2 = _interopRequireDefault(_trainingCenters);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var servicesModule = _angular2.default.module("app.services", [_http2.default, _auth2.default, _matches2.default, _reports2.default, _payments2.default, _teams2.default, _judges2.default, _coaches2.default, _trainers2.default, _leagues2.default, _players2.default, _misc2.default, _fileReader2.default, _transfers2.default, _user2.default, _roles2.default, _users2.default, _trainingEntries2.default, _staff2.default, _trainingCenters2.default]).name;
	
	exports.default = servicesModule;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_HEADERS = {
	  // 'Accept': 'application/json',
	  // 'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	var HttpFactory = _angular2.default.module("HttpFactory", []).factory("HttpFactory", ["$rootScope", "$http", "$q", "ngDialog", function ($rootScope, $http, $q, ngDialog) {
	  "ngInject";
	
	  return {
	    downloadFIle: function downloadFIle(url, params) {
	      var fileName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "velos-print.pdf";
	
	      var defer = $q.defer();
	      var req = {
	        url: url,
	        method: "GET"
	      };
	
	      if (params) {
	        req.params = params;
	      }
	
	      /* Headers */
	      req.headers = (0, _assign2.default)({
	        "X-Accept-Language": window.localStorage.getItem("vLanguage") || "en"
	      }, DEFAULT_HEADERS);
	      if ($rootScope.token) {
	        req.headers.Authorization = "Bearer " + $rootScope.token;
	      }
	      req.responseType = "blob";
	
	      $rootScope.isLoading = true;
	      $http(req).then(function (response) {
	        var url = window.URL.createObjectURL(new Blob([response.data]));
	        var link = document.createElement("a");
	        link.href = url;
	        link.setAttribute("download", fileName); //or any other extension
	        document.body.appendChild(link);
	        link.click();
	        defer.resolve(response.data);
	        $rootScope.isLoading = false;
	      }).catch(function (error) {
	        $rootScope.isLoading = false;
	        ngDialog.open({
	          template: "errorTemplate",
	          data: {
	            message: error.data.message
	          }
	        });
	        if (error.status === 401) {
	          $rootScope.logout();
	        }
	        defer.reject(error);
	      });
	    },
	    getPDF: function getPDF(url, params) {
	      var req = {
	        url: url,
	        method: "GET",
	        responseType: "arraybuffer"
	      };
	
	      if (params) {
	        req.params = params;
	      }
	
	      /* Headers */
	      req.headers = (0, _assign2.default)({
	        "X-language": window.localStorage.getItem("vLanguage") || "en"
	      }, DEFAULT_HEADERS);
	      if ($rootScope.token) {
	        req.headers.Authorization = "Bearer " + $rootScope.token;
	      }
	
	      return $http.get(url, req);
	    },
	    get: function get(url, params) {
	      var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var req = {
	        url: url,
	        method: "GET"
	      };
	
	      if (params) {
	        req.params = params;
	      }
	
	      return this.makeRequest(req, silent);
	    },
	    post: function post(url, body) {
	      var req = {
	        url: url,
	        method: "POST"
	      };
	      if (body) {
	        req.data = body;
	      }
	      return this.makeRequest(req);
	    },
	    put: function put(url, body) {
	      var req = {
	        url: url,
	        method: "PUT"
	      };
	      if (body) {
	        req.data = body;
	      }
	      return this.makeRequest(req);
	    },
	    delete: function _delete(url) {
	      var req = {
	        url: url,
	        method: "DELETE"
	      };
	      return this.makeRequest(req);
	    },
	    makeRequest: function makeRequest(req) {
	      var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var defer = $q.defer();
	
	      /* Headers */
	      req.headers = (0, _assign2.default)({
	        "X-language": window.localStorage.getItem("vLanguage") || "en"
	      }, DEFAULT_HEADERS);
	      if ($rootScope.token) {
	        req.headers.Authorization = "Bearer " + $rootScope.token;
	      }
	
	      console.log(req);
	      $rootScope.isLoading = !silent;
	      $http(req).then(function (response) {
	        console.log(response.data);
	        defer.resolve(response.data);
	        $rootScope.isLoading = false;
	      }).catch(function (error) {
	        console.log(error);
	        $rootScope.isLoading = false;
	        ngDialog.open({
	          template: "errorTemplate",
	          data: {
	            message: error.data.message
	          }
	        });
	        if (error.status === 401) {
	          $rootScope.logout();
	        }
	        defer.reject(error);
	      });
	
	      return defer.promise;
	    },
	
	    buildUrl: function buildUrl(url, keyValueReplace) {
	      (0, _entries2.default)(keyValueReplace).forEach(function (entry) {
	        var key = entry[0];
	        var value = entry[1];
	        url = url.replace("{" + key + "}", value);
	      });
	      return url;
	    }
	  };
	}]).name;
	
	exports.default = HttpFactory;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthFactory = _angular2.default.module('AuthFactory', []).factory('AuthFactory', ["$rootScope", "HttpFactory", "URLS", function ($rootScope, HttpFactory, URLS) {
		'ngInject';
	
		var USER_TYPES = {
			USER: "user",
			TEAM: "team"
		};
		return {
			USER_TYPES: USER_TYPES,
			login: function login(data, userType) {
				var url = HttpFactory.buildUrl(URLS.LOGIN, {
					userType: userType
				});
	
				return HttpFactory.post(url, data);
			},
			recoverPassword: function recoverPassword(userType, email) {
				var url = HttpFactory.buildUrl(URLS.RECOVER_PASSWORD, {
					userType: userType
				});
				var body = {
					email: email
				};
				return HttpFactory.post(url, body);
			},
			resetPassword: function resetPassword(userType, code, password, password_confirmation) {
				var url = HttpFactory.buildUrl(URLS.RESET_PASSWORD, {
					userType: userType
				});
				var body = {
					code: code,
					password: password,
					password_confirmation: password_confirmation
				};
				return HttpFactory.post(url, body);
			},
			changePassword: function changePassword(userType, data) {
				var url = HttpFactory.buildUrl(URLS.CHANGE_PASSWORD, {
					userType: userType
				});
	
				return HttpFactory.post(url, data);
			}
		};
	}]).name;
	
	exports.default = AuthFactory;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchesFactory = _angular2.default.module("MatchesFactory", []).factory("MatchesFactory", ["$rootScope", "HttpFactory", "URLS", function ($rootScope, HttpFactory, URLS) {
	  "ngInject";
	
	  var MATCH_STATES = {
	    MATCH_STATE_ROUND_ONE: 1,
	    MATCH_STATE_ROUND_TWO: 2,
	    MATCH_STATE_END: 3
	  };
	  var MATCH_TYPES = {
	    INDOOR: "indoor",
	    OUTDOOR: "outdoor"
	  };
	  var MATCH_MOVE_TARGETS_DIRECTION = {
	    FRONT: "front",
	    BACK: "back"
	  };
	  var MATCH_PRINTS = {
	    LEAGUES_LIST: "leaguesList",
	    PLAYERS_LIST: "playersList",
	    TARGETS_LIST: "targetsList",
	    TEAMS_LIST: "teamsList",
	    QUALIFICATION: "qualification",
	    QR: "qr",
	    MEDALS: "medals",
	    ELIMINATION_ROUNDS: "medals",
	    TARGETS_BOARDS: "targetsBoards",
	    EXCEL: "excel",
	    EXCEL_IMPORT: "addShotsFromExcel",
	    TEAM_ENTRIES_LIST: "teamsEntriesList",
	    ATHLETES_SCORECARDS: "scorecards",
	    ATHLETES_MATCH_CARDS: "athleteMatchCards",
	    CERTIFICATES: "certs",
	    ATHLETE_MATCH_ENTRY_CARDS: "athleteMatchEntryCards"
	  };
	  var MATCH_ELIMINATION_TYPES = {
	    INDIVIDUAL: 1,
	    TEAM: 2,
	    MIXED_TEAM: 3
	  };
	  return {
	    MATCH_STATES: MATCH_STATES,
	    MATCH_TYPES: MATCH_TYPES,
	    MATCH_MOVE_TARGETS_DIRECTION: MATCH_MOVE_TARGETS_DIRECTION,
	    MATCH_PRINTS: MATCH_PRINTS,
	    MATCH_ELIMINATION_TYPES: MATCH_ELIMINATION_TYPES,
	    getAll: function getAll(params) {
	      var url = URLS.MATCHES;
	      var parameters = (0, _assign2.default)({ page_size: 2000 }, params);
	      return HttpFactory.get(url, parameters);
	    },
	    getOne: function getOne(matchId, params) {
	      var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var url = URLS.MATCHES + "/" + matchId;
	      var parameters = (0, _assign2.default)({}, params);
	      return HttpFactory.get(url, parameters, silent);
	    },
	    add: function add(data) {
	      var url = URLS.MATCHES;
	      return HttpFactory.post(url, data);
	    },
	    update: function update(matchId, data) {
	      var url = URLS.MATCHES + "/" + matchId;
	      return HttpFactory.put(url, data);
	    },
	    delete: function _delete(matchId) {
	      var url = URLS.MATCHES + "/" + matchId;
	      return HttpFactory.delete(url);
	    },
	    /* SCORING */
	    addShots: function addShots(roundId, data) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_ADD_SHOTS, {
	        roundId: roundId
	      });
	
	      /* data =>
	      for shotNumber from 1 - 12
	      shots => [
	      'shotNumber' => [
	      1: VALUE,
	      2: VALUE,
	      3: VALUE,
	      ]
	      ]
	      */
	      return HttpFactory.post(url, data);
	    },
	    addShotsFromExcel: function addShotsFromExcel(matchId, data) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_ADD_SHOTS_FROM_EXCEL, {
	        matchId: matchId
	      });
	
	      return HttpFactory.get(url, data);
	    },
	    clear: function clear(roundId) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_CLEAR_SHOTS, {
	        roundId: roundId
	      });
	      return HttpFactory.post(url);
	    },
	    finalize: function finalize(matchId, state) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_FINALIZE, {
	        matchId: matchId,
	        state: state
	      });
	
	      return HttpFactory.post(url);
	    },
	    /* LEAGUES */
	    addLeague: function addLeague(matchId, leagueId) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_ADD_LEAGUE, {
	        matchId: matchId
	      });
	
	      /* data => league_id */
	      return HttpFactory.post(url, { league_id: leagueId });
	    },
	    removeLeague: function removeLeague(matchId, leagueId) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_REMOVE_LEAGUE, {
	        matchId: matchId
	      });
	
	      /* data => league_id */
	      return HttpFactory.post(url, { league_id: leagueId });
	    },
	    moveLeagues: function moveLeagues(matchId, newMatchId, leagueIds) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_MOVE_LEAGUES, {
	        matchId: matchId
	      });
	
	      /* data =>
	      new_match_id
	      matchLeagues = [] | league ids to move
	      */
	      return HttpFactory.post(url, {
	        new_match_id: newMatchId,
	        matchLeagues: leagueIds
	      });
	    },
	    /* PLAYERS */
	    addPlayer: function addPlayer(matchId, playerId, leagueId, teamId, data) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_ADD_PLAYER, {
	        matchId: matchId,
	        playerId: playerId,
	        leagueId: leagueId,
	        teamId: teamId
	      });
	      return HttpFactory.post(url, data);
	    },
	    removePlayer: function removePlayer(matchId, playerId) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_REMOVE_PLAYER, {
	        matchId: matchId,
	        playerId: playerId
	      });
	
	      return HttpFactory.delete(url);
	    },
	    checkInPlayer: function checkInPlayer(matchId, playerId) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_CHECK_IN_PLAYER, {
	        matchId: matchId,
	        playerId: playerId
	      });
	
	      return HttpFactory.put(url);
	    },
	    updatePlayerLeague: function updatePlayerLeague(matchId, playerId, leagueId, data) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_UPDATE_PLAYER_LEAGUE, {
	        matchId: matchId,
	        playerId: playerId,
	        leagueId: leagueId
	      });
	
	      return HttpFactory.put(url, data);
	    },
	    updateTeamInformation: function updateTeamInformation(matchId, teamId, data) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_UPDATE_TEAM_INFO, {
	        matchId: matchId,
	        teamId: teamId
	      });
	
	      return HttpFactory.put(url, data);
	    },
	    /* TARGETS */
	    produceTargets: function produceTargets(matchId, perTarget) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_PRODUCE_TARGETS, {
	        matchId: matchId
	      });
	
	      /* data => perTarget | int [2,3,4] */
	      return HttpFactory.post(url, { perTarget: perTarget });
	    },
	    clearTargets: function clearTargets(matchId) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_CLEAR_TARGETS, {
	        matchId: matchId
	      });
	
	      return HttpFactory.post(url);
	    },
	    movePlayerToTarget: function movePlayerToTarget(matchId, playerId, targetName) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_MOVE_PLAYER_TO_TARGET, {
	        matchId: matchId,
	        playerId: playerId
	      });
	
	      /* data => target_name | string */
	      return HttpFactory.post(url, { target_name: targetName });
	    },
	    swapTargets: function swapTargets(matchId, targetNameOne, targetNameTwo) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_SWAP_TARGETS, {
	        matchId: matchId
	      });
	
	      /* data =>
	      target_name_one | string
	      target_name_two | string
	      */
	      return HttpFactory.post(url, {
	        target_name_one: targetNameOne,
	        target_name_two: targetNameTwo
	      });
	    },
	    moveTargets: function moveTargets(matchId, distance, fromTarget, toTarget, direction) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_MOVE_TARGETS, {
	        matchId: matchId
	      });
	
	      /* data =>
	      distance | int
	      fromTarget | int
	      toTarget | int
	      direction | MATCH_MOVE_TARGETS_DIRECTION
	      */
	      return HttpFactory.post(url, {
	        distance: distance,
	        fromTarget: fromTarget,
	        toTarget: toTarget,
	        direction: direction
	      });
	    },
	    /* PRINTS */
	    prints: function prints(matchId, print) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_PRINTS, {
	        matchId: matchId,
	        print: print
	      });
	
	      return HttpFactory.getPDF(url);
	    },
	    printsEntries: function printsEntries(matchId, teamId) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_PRINTS_ENTRIES, {
	        matchId: matchId,
	        teamId: teamId
	      });
	
	      return HttpFactory.getPDF(url);
	    },
	    printsElimination: function printsElimination(matchId, leagueId, eliminationType) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_PRINTS_ELIMINATION, {
	        matchId: matchId,
	        leagueId: leagueId,
	        eliminationType: eliminationType
	      });
	
	      return HttpFactory.getPDF(url);
	    },
	    printsEliminationTargetBoards: function printsEliminationTargetBoards(matchId, leagueId, eliminationType, round) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_PRINTS_ELIMINATION_TARGET_BOARDS, {
	        matchId: matchId,
	        leagueId: leagueId,
	        eliminationType: eliminationType,
	        round: round
	      });
	
	      return HttpFactory.getPDF(url);
	    },
	    eliminationProduceTargets: function eliminationProduceTargets(matchId, leagueId, eliminationType, round, perTarget, startFrom) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_PRINTS_ELIMINATION_PRODUCE_TARGETS, {
	        matchId: matchId,
	        leagueId: leagueId,
	        eliminationType: eliminationType,
	        round: round
	      });
	
	      return HttpFactory.post(url, { perTarget: perTarget, startFrom: startFrom });
	    },
	    /* ELIMINATIONS */
	    createElimination: function createElimination(matchId, leagueId, participants, eliminationType) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION, {
	        matchId: matchId,
	        leagueId: leagueId,
	        eliminationType: eliminationType
	      });
	
	      /* data =>
	      participants
	      */
	      return HttpFactory.post(url, { participants: participants });
	    },
	    details: function details(matchId, leagueId, eliminationType) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION, {
	        matchId: matchId,
	        leagueId: leagueId,
	        eliminationType: eliminationType
	      });
	
	      return HttpFactory.get(url);
	    },
	    nextRoundElimination: function nextRoundElimination(matchId, leagueId, eliminationType) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION_NEXT_ROUND, {
	        matchId: matchId,
	        leagueId: leagueId,
	        eliminationType: eliminationType
	      });
	
	      return HttpFactory.post(url);
	    },
	    deleteElimination: function deleteElimination(matchId, leagueId, eliminationType) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION, {
	        matchId: matchId,
	        leagueId: leagueId,
	        eliminationType: eliminationType
	      });
	
	      return HttpFactory.delete(url);
	    },
	    updateElimination: function updateElimination(matchId, leagueId, teamId, eliminationType, players) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION_UPDATE, {
	        matchId: matchId,
	        leagueId: leagueId,
	        teamId: teamId,
	        eliminationType: eliminationType
	      });
	
	      /* data => players | array of size 2-3 */
	      return HttpFactory.put(url, { players: players });
	    },
	    addShotsElimination: function addShotsElimination(matchOlympicId, eliminationType, data) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION_ADD_SHOTS, {
	        matchOlympicId: matchOlympicId,
	        eliminationType: eliminationType
	      });
	
	      /* data =>
	      for round where Key is roundId =>
	      for shotNumber from 1 - 12
	      shots => [
	      'shotNumber' => [
	      1: VALUE,
	      2: VALUE,
	      3: VALUE,
	      ]
	      ]
	      */
	      return HttpFactory.post(url, data);
	    },
	    clearShotsElimination: function clearShotsElimination(matchOlympicId, eliminationType) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION_CLEAR_SHOTS, {
	        matchOlympicId: matchOlympicId,
	        eliminationType: eliminationType
	      });
	
	      return HttpFactory.post(url);
	    },
	    forfeitElimination: function forfeitElimination(matchOlympicId, eliminationType, playerId) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_ELIMINATION_FORFEIT, {
	        matchOlympicId: matchOlympicId,
	        playerId: playerId,
	        eliminationType: eliminationType
	      });
	
	      return HttpFactory.post(url);
	    },
	    results: function results(matchId, params) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_RESULTS, {
	        matchId: matchId
	      });
	      var parameters = (0, _assign2.default)({}, params);
	      return HttpFactory.get(url, parameters);
	    }
	  };
	}]).name;
	
	exports.default = MatchesFactory;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReportsFactory = _angular2.default.module("ReportsFactory", []).factory("ReportsFactory", ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
	  "ngInject";
	
	  var STATISTIC_REPORTS_ENUM = {
	    PLAYER_REGISTER: 1,
	    TEAM_REGISTER: 2,
	    REGISTERED_REGISTER: 3,
	    MATCHES_WITH_ENTRIES: 4,
	    LEAGUES_ENTRIES: 5,
	    TEAM_PLAYERS: 6,
	    PLAYER_LEAGUE: 7,
	    MULTIWIN: 8,
	    TRAINING_ENTRIES: 9,
	    PLAYER_LEAGUE_UNIQUE: 10,
	    GGA_PLAYERS: 11,
	    GGA_TEAMS: 12,
	    MEDALS: 13
	  };
	  var PAYMENTS_REPORTS_ENUM = {
	    TEAM: 1,
	    PLAYER: 2
	  };
	  return {
	    STATISTIC_REPORTS: STATISTIC_REPORTS_ENUM,
	    PAYMENTS_REPORTS_ENUM: PAYMENTS_REPORTS_ENUM,
	    statistics: function statistics(reportEnum, year, data) {
	      var url = HttpFactory.buildUrl(URLS.REPORTS_STATISTICS, {
	        year: year,
	        report: reportEnum
	      });
	
	      /* data =>
	      matches (array)
	      */
	      return HttpFactory.getPDF(url, data);
	    },
	    payments: function payments(reportEnum, data) {
	      var url = HttpFactory.buildUrl(URLS.REPORTS_PAYMENTS, {
	        report: reportEnum
	      });
	
	      /* data =>
	      paymentIds (array)
	      teamId int
	      playerId int
	      dateFrom Date
	      dateTo Date
	      */
	      return HttpFactory.getPDF(url, data);
	    },
	    playerMatchQualification: function playerMatchQualification(matchId, playerId) {
	      var url = HttpFactory.buildUrl(URLS.MATCHES_PLAYER_QUALIFICATION, {
	        matchId: matchId,
	        playerId: playerId
	      });
	
	      return HttpFactory.getPDF(url);
	    }
	  };
	}]).name;
	
	exports.default = ReportsFactory;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentsFactory = _angular2.default.module('PaymentsFactory', []).factory('PaymentsFactory', ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
		'ngInject';
	
		var PAYMENTS_RESOURCES = {
			TEAM: "team",
			PLAYER: "player"
		};
		return {
			PAYMENTS_RESOURCES: PAYMENTS_RESOURCES,
			getAll: function getAll(params) {
				var parameters = (0, _assign2.default)({}, params);
				return HttpFactory.get(URLS.PAYMENTS, parameters);
			},
			createPaymentItem: function createPaymentItem(data) {
				/* data =>
	   year_id
	   name
	   price
	   comments
	   required_team
	   required_player
	   */
				return HttpFactory.post(URLS.PAYMENTS, data);
			},
			updatePaymentItem: function updatePaymentItem(paymentId, data) {
				/* data =>
	   year_id
	   name
	   price
	   comments
	   required_team
	   required_player
	   */
				return HttpFactory.put(URLS.PAYMENTS + "/" + paymentId, data);
			},
			deletePaymentItem: function deletePaymentItem(paymentId) {
				return HttpFactory.delete(URLS.PAYMENTS + "/" + paymentId);
			},
			getPayments: function getPayments(resource, params) {
				var url = HttpFactory.buildUrl(URLS.PAYMENTS_RESOURCE, {
					resource: resource
				});
	
				var parameters = (0, _assign2.default)({ page_size: 2000 }, params);
	
				/* data =>
	   payment_id
	   player_id
	   team_id
	   dateFrom
	   dateTo
	   */
				return HttpFactory.get(url, parameters);
			},
			addPayment: function addPayment(resource, data) {
				var url = HttpFactory.buildUrl(URLS.PAYMENTS_RESOURCE, {
					resource: resource
				});
	
				/* data =>
	   payment_id
	   player_id || team_id
	   amount
	   comments
	   payment_at
	   */
				return HttpFactory.post(url, data);
			},
			updatePayment: function updatePayment(id, resource, data) {
				var url = HttpFactory.buildUrl(URLS.PAYMENTS_RESOURCE, {
					resource: resource
				});
				url = url + "/" + id;
				return HttpFactory.put(url, data);
			},
			report: function report(resource, id) {
				var url = HttpFactory.buildUrl(URLS.PAYMENTS_SINGLE_REPORT, {
					resource: resource,
					id: id
				});
	
				return HttpFactory.getPDF(url);
			},
			customReport: function customReport(resource, filters) {
				var url = HttpFactory.buildUrl(URLS.PAYMENTS_CUSTOM_REPORT, {
					resource: resource
				});
	
				return HttpFactory.getPDF(url, filters);
			}
		};
	}]).name;
	
	exports.default = PaymentsFactory;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TeamsFactory = _angular2.default.module("TeamsFactory", []).factory("TeamsFactory", ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
	  "ngInject";
	
	  return {
	    getAll: function getAll(params) {
	      var parameters = (0, _assign2.default)({ page_size: 2000 }, params);
	      return HttpFactory.get(URLS.TEAMS, parameters);
	    },
	    getOne: function getOne(teamId, params) {
	      var url = URLS.TEAMS + "/" + teamId;
	      var parameters = (0, _assign2.default)({}, params);
	      return HttpFactory.get(url, parameters);
	    },
	    create: function create(data) {
	      return HttpFactory.post(URLS.TEAMS, data);
	    },
	    update: function update(teamId, data) {
	      var url = URLS.TEAMS + "/" + teamId;
	      return HttpFactory.put(url, data);
	    },
	    delete: function _delete(teamId) {
	      var url = URLS.TEAMS + "/" + teamId;
	      return HttpFactory.delete(url);
	    },
	    playerCards: function playerCards(teamId) {
	      var url = HttpFactory.buildUrl(URLS.TEAM_PLAYERS_CARDS, {
	        teamId: teamId
	      });
	      return HttpFactory.getPDF(url);
	    }
	  };
	}]).name;
	
	exports.default = TeamsFactory;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var JudgesFactory = _angular2.default.module('JudgesFactory', []).factory('JudgesFactory', ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
		'ngInject';
	
		return {
			getAll: function getAll(params) {
				var parameters = (0, _assign2.default)({ page_size: 2000 }, params);
				return HttpFactory.get(URLS.JUDGES, parameters);
			},
			getOne: function getOne(judgeId, params) {
				var url = URLS.JUDGES + "/" + judgeId;
				var parameters = (0, _assign2.default)({}, params);
				return HttpFactory.get(url, parameters);
			},
			create: function create(data) {
				return HttpFactory.post(URLS.JUDGES, data);
			},
			update: function update(judgeId, data) {
				var url = URLS.JUDGES + "/" + judgeId;
				return HttpFactory.put(url, data);
			},
			delete: function _delete(judgeId) {
				var url = URLS.JUDGES + "/" + judgeId;
				return HttpFactory.delete(url);
			},
			card: function card(judgeId) {
				var url = HttpFactory.buildUrl(URLS.JUDGES_CARD_PDF, { judgeId: judgeId });
				return HttpFactory.getPDF(url);
			}
		};
	}]).name;
	
	exports.default = JudgesFactory;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CoachesFactory = _angular2.default.module('CoachesFactory', []).factory('CoachesFactory', ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
		'ngInject';
	
		return {
			getAll: function getAll(params) {
				var parameters = (0, _assign2.default)({ page_size: 2000 }, params);
				return HttpFactory.get(URLS.COACHES, parameters);
			},
			getOne: function getOne(coachId, params) {
				var url = URLS.COACHES + "/" + coachId;
				var parameters = (0, _assign2.default)({}, params);
				return HttpFactory.get(url, parameters);
			},
			create: function create(data) {
				return HttpFactory.post(URLS.COACHES, data);
			},
			update: function update(coachId, data) {
				var url = URLS.COACHES + "/" + coachId;
				return HttpFactory.put(url, data);
			},
			delete: function _delete(coachId) {
				var url = URLS.COACHES + "/" + coachId;
				return HttpFactory.delete(url);
			},
			card: function card(coachId) {
				var url = HttpFactory.buildUrl(URLS.COACHES_CARD_PDF, { coachId: coachId });
				return HttpFactory.getPDF(url);
			}
		};
	}]).name;
	
	exports.default = CoachesFactory;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StaffFactory = _angular2.default.module('StaffFactory', []).factory('StaffFactory', ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
		'ngInject';
	
		return {
			getAll: function getAll(params) {
				var parameters = (0, _assign2.default)({ page_size: 2000 }, params);
				return HttpFactory.get(URLS.STAFF, parameters);
			},
			getOne: function getOne(staffId, params) {
				var url = URLS.STAFF + "/" + staffId;
				var parameters = (0, _assign2.default)({}, params);
				return HttpFactory.get(url, parameters);
			},
			create: function create(data) {
				return HttpFactory.post(URLS.STAFF, data);
			},
			update: function update(staffId, data) {
				var url = URLS.STAFF + "/" + staffId;
				return HttpFactory.put(url, data);
			},
			delete: function _delete(staffId) {
				var url = URLS.STAFF + "/" + staffId;
				return HttpFactory.delete(url);
			},
			card: function card(staffId) {
				var url = HttpFactory.buildUrl(URLS.STAFF_CARD_PDF, { staffId: staffId });
				return HttpFactory.getPDF(url);
			}
		};
	}]).name;
	
	exports.default = StaffFactory;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrainersFactory = _angular2.default.module('TrainersFactory', []).factory('TrainersFactory', ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
		'ngInject';
	
		return {
			getAll: function getAll(params) {
				var parameters = (0, _assign2.default)({ page_size: 2000 }, params);
				return HttpFactory.get(URLS.TRAINERS, parameters);
			},
			getOne: function getOne(trainerId, params) {
				var url = URLS.TRAINERS + "/" + trainerId;
				var parameters = (0, _assign2.default)({}, params);
				return HttpFactory.get(url, parameters);
			},
			create: function create(data) {
				return HttpFactory.post(URLS.TRAINERS, data);
			},
			update: function update(trainerId, data) {
				var url = URLS.TRAINERS + "/" + trainerId;
				return HttpFactory.put(url, data);
			},
			delete: function _delete(trainerId) {
				var url = URLS.TRAINERS + "/" + trainerId;
				return HttpFactory.delete(url);
			},
			card: function card(trainerId) {
				var url = HttpFactory.buildUrl(URLS.TRAINERS_CARD_PDF, { trainerId: trainerId });
				return HttpFactory.getPDF(url);
			}
		};
	}]).name;
	
	exports.default = TrainersFactory;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LeaguesFactory = _angular2.default.module('LeaguesFactory', []).factory('LeaguesFactory', ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
		'ngInject';
	
		var LEAGUE_TYPES = {
			RECURVE: "recurve",
			COMPOUND: "compound",
			FIELD: "field"
		};
		return {
			LEAGUE_TYPES: LEAGUE_TYPES,
			getAll: function getAll(params) {
				var parameters = (0, _assign2.default)({}, params);
				return HttpFactory.get(URLS.LEAGUES, parameters);
			},
			getOne: function getOne(leagueId) {
				var url = URLS.LEAGUES + "/" + leagueId;
				return HttpFactory.get(url);
			},
			create: function create(data) {
				return HttpFactory.post(URLS.LEAGUES, data);
			},
			update: function update(leagueId, data) {
				var url = URLS.LEAGUES + "/" + leagueId;
				return HttpFactory.put(url, data);
			},
			delete: function _delete(leagueId) {
				var url = URLS.LEAGUES + "/" + leagueId;
				return HttpFactory.delete(url);
			}
		};
	}]).name;
	
	exports.default = LeaguesFactory;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlayersFactory = _angular2.default.module('PlayersFactory', []).factory('PlayersFactory', ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
		'ngInject';
	
		return {
			getAll: function getAll(params) {
				var parameters = (0, _assign2.default)({ page_size: 400 }, params);
				return HttpFactory.get(URLS.PLAYERS, parameters);
			},
			getOne: function getOne(playerId, params) {
				var url = URLS.PLAYERS + "/" + playerId;
				return HttpFactory.get(url, params);
			},
			create: function create(data) {
				return HttpFactory.post(URLS.PLAYERS, data);
			},
			update: function update(playerId, data) {
				var url = URLS.PLAYERS + "/" + playerId;
				return HttpFactory.put(url, data);
			},
			delete: function _delete(playerId) {
				var url = URLS.PLAYERS + "/" + playerId;
				return HttpFactory.delete(url);
			},
			card: function card(playerId) {
				var url = HttpFactory.buildUrl(URLS.PLAYERS_CARD_PDF, { playerId: playerId });
				return HttpFactory.getPDF(url);
			},
			trainCard: function trainCard(playerId) {
				var url = HttpFactory.buildUrl(URLS.PLAYERS_TRAINING_CARD_PDF, { playerId: playerId });
				return HttpFactory.getPDF(url);
			},
			startTrainingEntry: function startTrainingEntry(playerId) {
				var url = URLS.PLAYERS + "/" + playerId + "/startTrainingEntry";
				return HttpFactory.post(url);
			}
		};
	}]).name;
	
	exports.default = PlayersFactory;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MiscFactory = _angular2.default.module('MiscFactory', []).factory('MiscFactory', ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
		'ngInject';
	
		return {
			getYears: function getYears() {
				return HttpFactory.get(URLS.YEARS);
			},
			getStates: function getStates() {
				return HttpFactory.get(URLS.STATES);
			},
			getCounties: function getCounties() {
				return HttpFactory.get(URLS.COUNTIES);
			},
			getRegions: function getRegions() {
				return HttpFactory.get(URLS.REGIONS);
			},
			getNationalities: function getNationalities() {
				return HttpFactory.get(URLS.NATIONALITIES);
			}
		};
	}]).name;
	
	exports.default = MiscFactory;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fileReader = _angular2.default.module('fileReader', []).factory('fileReader', ["$q", function ($q) {
		'ngInject';
	
		var onLoad = function onLoad(reader, deferred, scope) {
			return function () {
				scope.$apply(function () {
					deferred.resolve(reader.result);
				});
			};
		};
	
		var onError = function onError(reader, deferred, scope) {
			return function () {
				scope.$apply(function () {
					deferred.reject(reader.result);
				});
			};
		};
	
		var getReader = function getReader(deferred, scope) {
			var reader = new FileReader();
			reader.onload = onLoad(reader, deferred, scope);
			reader.onerror = onError(reader, deferred, scope);
			return reader;
		};
	
		var readAsDataURL = function readAsDataURL(file, scope) {
			var deferred = $q.defer();
	
			var reader = getReader(deferred, scope);
			reader.readAsDataURL(file);
	
			return deferred.promise;
		};
	
		return {
			readAsDataUrl: readAsDataURL
		};
	}]).name;
	
	exports.default = fileReader;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransfersFactory = _angular2.default.module('TransfersFactory', []).factory('TransfersFactory', ["$http", "HttpFactory", "URLS", function ($http, HttpFactory, URLS) {
		'ngInject';
	
		return {
			getAll: function getAll(params) {
				var parameters = (0, _assign2.default)({ page_size: 2000 }, params);
				return HttpFactory.get(URLS.TRANSFERS, parameters);
			},
			create: function create(data) {
				return HttpFactory.post(URLS.TRANSFERS, data);
			},
			update: function update(transferId, data) {
				return HttpFactory.put(URLS.TRANSFERS + "/" + transferId, data);
			},
			delete: function _delete(transferId) {
				return HttpFactory.delete(URLS.TRANSFERS + "/" + transferId);
			}
		};
	}]).name;
	
	exports.default = TransfersFactory;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RolesFactory = _angular2.default.module('RolesFactory', []).factory('RolesFactory', ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
		'ngInject';
	
		return {
			getAll: function getAll(params) {
				var parameters = (0, _assign2.default)({}, params);
				return HttpFactory.get(URLS.ROLES, parameters);
			},
			getAllPermissions: function getAllPermissions() {
				return HttpFactory.get(URLS.PERMISSIONS);
			},
			getOne: function getOne(roleId) {
				var url = URLS.ROLES + "/" + roleId;
				return HttpFactory.get(url);
			},
			create: function create(data) {
				return HttpFactory.post(URLS.ROLES, data);
			},
			update: function update(roleId, data) {
				var url = URLS.ROLES + "/" + roleId;
				return HttpFactory.put(url, data);
			},
			delete: function _delete(roleId) {
				var url = URLS.ROLES + "/" + roleId;
				return HttpFactory.delete(url);
			}
		};
	}]).name;
	
	exports.default = RolesFactory;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray2 = __webpack_require__(535);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(542);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserFactory = _angular2.default.module('User', []).factory('User', ["AuthFactory", function (AuthFactory) {
		'ngInject';
	
		/**
	  * Constructor, with class name
	  */
	
		function User(data) {
			var _this = this;
	
			var self = this;
	
			self.premium = data.premium;
			self.role = data.role.display_name;
			self.permissions = [];
			(0, _entries2.default)(data.role.perms).forEach(function (_ref) {
				var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
				    key = _ref2[0],
				    value = _ref2[1];
	
				self.permissions.push(value.name);
			});
			self.userType = AuthFactory.USER_TYPES.USER;
			self.teamId = null;
			self.name = data.username;
			if (data.team_id) {
				self.name = data.name;
				self.userType = AuthFactory.USER_TYPES.TEAM;
				self.teamId = data.team_id;
			}
	
			/* Get Name */
			self.getName = function () {
				return self.name;
			};
	
			/* Check permission */
			self.canDo = function (permission) {
				return _this.permissions.includes(permission);
			};
	
			/* If User is Team */
			self.isUserTypeTeam = function () {
				return _this.userType === AuthFactory.USER_TYPES.TEAM;
			};
	
			/* if is specific team */
			self.isTeam = function (teamId) {
				return _this.teamId == teamId;
			};
	
			/* Check if the user is premium */
			self.isPremium = function () {
				return _this.premium === 1;
			};
		}
	
		/**
	  * Static method, assigned to class
	  * Instance ('this') is not available in static context
	  */
		User.build = function (data) {
			return new User(data);
		};
	
		/**
	  * Return the constructor function
	  */
		return User;
	}]).name;
	
	exports.default = UserFactory;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersFactory = _angular2.default.module('UsersFactory', []).factory('UsersFactory', ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
		'ngInject';
	
		return {
			getAll: function getAll() {
				return HttpFactory.get(URLS.USERS, { page_size: 300 });
			},
			getOne: function getOne(userId) {
				var url = URLS.USERS + "/" + userId;
				return HttpFactory.get(url);
			},
			create: function create(data) {
				return HttpFactory.post(URLS.USERS, data);
			},
			update: function update(userId, data) {
				var url = URLS.USERS + "/" + userId;
				return HttpFactory.put(url, data);
			},
			delete: function _delete(userId) {
				var url = URLS.USERS + "/" + userId;
				return HttpFactory.delete(url);
			}
		};
	}]).name;
	
	exports.default = UsersFactory;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrainingEntriesFactory = _angular2.default.module('TrainingEntriesFactory', []).factory('TrainingEntriesFactory', ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
		'ngInject';
	
		return {
			getAll: function getAll(params) {
				var parameters = (0, _assign2.default)({ page_size: 2000 }, params);
				return HttpFactory.get(URLS.TRAINING_ENTRIES, parameters);
			},
			getOne: function getOne(trainingEntryId, params) {
				var url = URLS.TRAINING_ENTRIES + "/" + trainingEntryId;
				var parameters = (0, _assign2.default)({}, params);
				return HttpFactory.get(url, parameters);
			},
			create: function create(data) {
				return HttpFactory.post(URLS.TRAINING_ENTRIES, data);
			},
			update: function update(trainingEntryId, data) {
				var url = URLS.TRAINING_ENTRIES + "/" + trainingEntryId;
				return HttpFactory.put(url, data);
			},
			delete: function _delete(trainingEntryId) {
				var url = URLS.TRAINING_ENTRIES + "/" + trainingEntryId;
				return HttpFactory.delete(url);
			},
			start: function start(trainingEntryId) {
				var url = URLS.TRAINING_ENTRIES + "/" + trainingEntryId + '/start';
				return HttpFactory.post(url);
			},
			end: function end(trainingEntryId) {
				var url = URLS.TRAINING_ENTRIES + "/" + trainingEntryId + '/end';
				return HttpFactory.post(url);
			},
			pause: function pause(trainingEntryId) {
				var url = URLS.TRAINING_ENTRIES + "/" + trainingEntryId + '/pause';
				return HttpFactory.post(url);
			},
			unpause: function unpause(trainingEntryId) {
				var url = URLS.TRAINING_ENTRIES + "/" + trainingEntryId + '/unpause';
				return HttpFactory.post(url);
			}
		};
	}]).name;
	
	exports.default = TrainingEntriesFactory;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(696);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrainingCentersFactory = _angular2.default.module("TrainingCentersFactory", []).factory("TrainingCentersFactory", ["$rootScope", "$http", "HttpFactory", "URLS", function ($rootScope, $http, HttpFactory, URLS) {
	  "ngInject";
	
	  return {
	    getAll: function getAll(params) {
	      var parameters = (0, _assign2.default)({ page_size: 2000 }, params);
	      return HttpFactory.get(URLS.TRAINING_CENTERS, parameters);
	    },
	    getOne: function getOne(trainingEntryId, params) {
	      var url = URLS.TRAINING_CENTERS + "/" + trainingEntryId;
	      var parameters = (0, _assign2.default)({}, params);
	      return HttpFactory.get(url, parameters);
	    },
	    create: function create(data) {
	      return HttpFactory.post(URLS.TRAINING_CENTERS, data);
	    },
	    update: function update(trainingEntryId, data) {
	      var url = URLS.TRAINING_CENTERS + "/" + trainingEntryId;
	      return HttpFactory.put(url, data);
	    },
	    delete: function _delete(trainingEntryId) {
	      var url = URLS.TRAINING_CENTERS + "/" + trainingEntryId;
	      return HttpFactory.delete(url);
	    }
	  };
	}]).name;
	
	exports.default = TrainingCentersFactory;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _URLS = __webpack_require__(917);
	
	var _URLS2 = _interopRequireDefault(_URLS);
	
	var _permissions = __webpack_require__(918);
	
	var _permissions2 = _interopRequireDefault(_permissions);
	
	var _levels = __webpack_require__(919);
	
	var _levels2 = _interopRequireDefault(_levels);
	
	var _settings = __webpack_require__(920);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var constantsModule = _angular2.default.module("app.constants", [_URLS2.default, _permissions2.default, _levels2.default, _settings2.default]).name;
	
	exports.default = constantsModule;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var URLS = _angular2.default.module("URLS", []).constant("URLS", function () {
	  "ngInject";
	
	  var t = {};
	  var PRODUCTION = "https://api.saaf.events";
	  var TESTING = "http://velos-api.lefterislalos.com";
	  var DOCKER = "http://127.0.0.1:8000";
	  var BASE_URL = window.env.API_ENDPOINT || PRODUCTION;
	  t.DEBUG = false;
	
	  t.BASE_URL = BASE_URL;
	
	  /* BASE URL */
	  t.BASE_URL = BASE_URL;
	
	  /* IMAGES */
	  t.IMAGES_URL = BASE_URL + "/storage/images";
	
	  /* AUTH */
	  t.AUTH = BASE_URL + "/auth";
	  t.LOGIN = t.AUTH + "/login/{userType}";
	  t.RECOVER_PASSWORD = t.AUTH + "/recovery/{userType}";
	  t.RESET_PASSWORD = t.AUTH + "/reset/{userType}";
	  t.CHANGE_PASSWORD = t.AUTH + "/changePassword/{userType}";
	
	  /* USERS */
	  t.USERS = BASE_URL + "/users";
	
	  /* TEAMS */
	  t.TEAMS = BASE_URL + "/teams";
	  t.MATCHES_PRINTS_ENTRIES = t.TEAMS + "/{teamId}/prints/teamEntries/{matchId}";
	  t.TEAM_PLAYERS_CARDS = t.TEAMS + "/{teamId}/prints/players/cards";
	
	  /* JUDGES */
	  t.JUDGES = BASE_URL + "/judges";
	  t.JUDGES_CARD_PDF = t.JUDGES + "/{judgeId}/card";
	
	  /* COACHES */
	  t.COACHES = BASE_URL + "/coaches";
	  t.COACHES_CARD_PDF = t.COACHES + "/{coachId}/card";
	
	  /* STAFF */
	  t.STAFF = BASE_URL + "/staffs";
	  t.STAFF_CARD_PDF = t.STAFF + "/{staffId}/card";
	
	  /* TRAINERS */
	  t.TRAINERS = BASE_URL + "/trainers";
	  t.TRAINERS_CARD_PDF = t.TRAINERS + "/{trainerId}/card";
	
	  /* PLAYERS */
	  t.PLAYERS = BASE_URL + "/players";
	  t.PLAYERS_CARD_PDF = t.PLAYERS + "/{playerId}/card";
	  t.PLAYERS_TRAINING_CARD_PDF = t.PLAYERS + "/{playerId}/trainCard";
	  t.MATCHES_PLAYER_QUALIFICATION = t.PLAYERS + "/{playerId}/prints/qualification/{matchId}";
	
	  /* TRAINING ENTRIES */
	  t.TRAINING_ENTRIES = BASE_URL + "/trainingEntries";
	
	  /* TRAINING CENTERS */
	  t.TRAINING_CENTERS = BASE_URL + "/trainingCenters";
	
	  /* TRANSFERS */
	  t.TRANSFERS = t.PLAYERS + "/transfers";
	
	  /* LEAGUES */
	  t.LEAGUES = BASE_URL + "/leagues";
	
	  /* ROLES */
	  t.ROLES = BASE_URL + "/roles";
	
	  /* PERMISSIONS */
	  t.PERMISSIONS = BASE_URL + "/permissions";
	
	  /* MATCHES */
	  t.MATCHES = BASE_URL + "/matches";
	
	  /* MATCHES SCORING */
	  t.MATCHES_ADD_SHOTS = t.MATCHES + "/{roundId}/addShots";
	  t.MATCHES_ADD_SHOTS_FROM_EXCEL = t.MATCHES + "/{matchId}/addShotsFromExcel";
	  t.MATCHES_CLEAR_SHOTS = t.MATCHES + "/{roundId}/clear";
	  t.MATCHES_FINALIZE = t.MATCHES + "/{matchId}/finalizeQualification/{state}";
	
	  /* MATCHES LEAGUES */
	  t.MATCHES_ADD_LEAGUE = t.MATCHES + "/{matchId}/addLeague";
	  t.MATCHES_REMOVE_LEAGUE = t.MATCHES + "/{matchId}/removeLeague";
	  t.MATCHES_MOVE_LEAGUES = t.MATCHES + "/{matchId}/moveLeagues";
	
	  /* MATCHES PLAYERS */
	  t.MATCHES_ADD_PLAYER = t.MATCHES + "/{matchId}/players/{playerId}/{leagueId}/{teamId}";
	  t.MATCHES_REMOVE_PLAYER = t.MATCHES + "/{matchId}/players/{playerId}";
	  t.MATCHES_CHECK_IN_PLAYER = t.MATCHES + "/{matchId}/checkInPlayer/{playerId}";
	  t.MATCHES_UPDATE_PLAYER_LEAGUE = t.MATCHES + "/{matchId}/updatePlayerLeague/{playerId}/{leagueId}";
	  t.MATCHES_UPDATE_TEAM_INFO = t.MATCHES + "/{matchId}/updateTeamInformation/{teamId}";
	
	  /* MATCHES TARGETS */
	  t.MATCHES_PRODUCE_TARGETS = t.MATCHES + "/{matchId}/produceTargets";
	  t.MATCHES_CLEAR_TARGETS = t.MATCHES + "/{matchId}/clearTargets";
	  t.MATCHES_MOVE_TARGETS = t.MATCHES + "/{matchId}/moveTargets";
	  t.MATCHES_MOVE_PLAYER_TO_TARGET = t.MATCHES + "/{matchId}/movePlayerToTarget/{playerId}";
	  t.MATCHES_SWAP_TARGETS = t.MATCHES + "/{matchId}/swapTargets";
	  t.MATCHES_SWAP_PLAYERS_TARGETS = t.MATCHES + "/{matchId}/swapPlayersTargets/{playerOne}/{playerTwo}";
	  t.MATCHES_RESULTS = t.MATCHES + "/{matchId}/results";
	
	  /* MATCH PRINTS */
	  t.MATCHES_PRINTS = t.MATCHES + "/{matchId}/prints/{print}";
	  t.MATCHES_PRINTS_ELIMINATION = t.MATCHES + "/{matchId}/prints/eliminations/{leagueId}/{eliminationType}";
	  t.MATCHES_PRINTS_ELIMINATION_TARGET_BOARDS = t.MATCHES + "/{matchId}/prints/eliminations/{leagueId}/{eliminationType}/{round}/targetsBoards";
	  t.MATCHES_PRINTS_ELIMINATION_PRODUCE_TARGETS = t.MATCHES + "/{matchId}/eliminations/{leagueId}/{eliminationType}/{round}/produceTargets";
	
	  /* MATCHES ELIMINATION*/
	  t.MATCHES_ELIMINATION = t.MATCHES + "/{matchId}/eliminations/{leagueId}/{eliminationType}";
	  t.MATCHES_ELIMINATION_NEXT_ROUND = t.MATCHES_ELIMINATION + "/nextRound";
	  t.MATCHES_ELIMINATION_UPDATE = t.MATCHES_ELIMINATION + "/{teamId}";
	  t.MATCHES_ELIMINATION_ADD_SHOTS = t.MATCHES + "/eliminations/{matchOlympicId}/{eliminationType}/addShots";
	  t.MATCHES_ELIMINATION_CLEAR_SHOTS = t.MATCHES + "/eliminations/{matchOlympicId}/{eliminationType}/clear";
	  t.MATCHES_ELIMINATION_FORFEIT = t.MATCHES + "/eliminations/{matchOlympicId}/{eliminationType}/forfeit/{playerId}";
	
	  /* REPORTS */
	  t.REPORTS = BASE_URL + "/reports";
	  t.REPORTS_STATISTICS = t.REPORTS + "/statistics/{year}/{report}";
	  t.REPORTS_PAYMENTS = t.REPORTS + "/payments/{report}";
	
	  /* PAYMENTS */
	  t.PAYMENTS = BASE_URL + "/payments";
	  t.PAYMENTS_RESOURCE = t.PAYMENTS + "/{resource}";
	  t.PAYMENTS_SINGLE_REPORT = t.PAYMENTS + "/{resource}/report/{id}";
	  t.PAYMENTS_CUSTOM_REPORT = t.PAYMENTS + "/{resource}/customReport";
	
	  /* YEARS */
	  t.YEARS = BASE_URL + "/years";
	
	  /* STATES */
	  t.STATES = BASE_URL + "/states";
	
	  /* COUNTIES */
	  t.COUNTIES = BASE_URL + "/counties";
	
	  /* REGIONS */
	  t.REGIONS = BASE_URL + "/regions";
	
	  /* NATIONALITIES */
	  t.NATIONALITIES = BASE_URL + "/nationalities";
	
	  return t;
	}()).name;
	
	exports.default = URLS;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Permissions = _angular2.default.module("Permissions", []).constant("Permissions", function () {
	  var t = {};
	
	  /* GENERAL */
	  t.EDIT_ROLES = "editRoles";
	  t.VALIDATE_PASSPORT = "passportValidate";
	  t.CHANGE_TEAM_PASSWORD = "changeTeamPassword";
	  t.OVERRIDE_MATCH_FILTERS = "overrideMatchFilters";
	
	  /* USERS */
	  t.VIEW_USERS = "viewUsers";
	  t.EDIT_USERS = "editUsers";
	
	  t.VIEW_REPORTS = "viewReports";
	
	  /* TRANSFERS */
	  t.VIEW_ALL_TRANSFERS = "viewAllTransfers";
	  t.PLAYER_TRANSFERS = "playerTransfers";
	  t.MAKE_PLAYER_TRANSFER = "makePlayerTransfer";
	
	  /* FINANCIAL */
	  t.VIEW_FINANCIAL = "viewFinancial";
	  t.ADD_PAYMENT = "addPaymentReason";
	  t.ADD_PAYMENT_TEAM = "addPaymentTeam";
	  t.ADD_PAYMENT_PLAYER = "addPaymentPlayer";
	  t.VIEW_ALL_MOVEMENTS_TEAM = "viewAllMovementsTeams";
	  t.VIEW_ALL_MOVEMENTS_PLAYER = "viewAllMovementsPlayers";
	  t.CANCEL_PAYMENT = "cancelPayment";
	
	  /* PLAYERS */
	  t.VIEW_ALL_PLAYERS = "viewAllPlayers";
	  t.ADD_PLAYER = "addPlayer";
	  t.EDIT_PLAYER = "editPlayer";
	  t.DELETE_PLAYER = "deletePlayer";
	
	  /* MATCHES */
	  t.ADD_MATCH = "addGame";
	  t.EDIT_MATCH = "editGame";
	  t.DELETE_MATCH = "deleteGame";
	
	  /* TEAMS */
	  t.VIEW_ALL_TEAMS = "viewAllTeams";
	  t.ADD_TEAM = "addTeam";
	  t.EDIT_TEAM = "editTeam";
	  t.DELETE_TEAM = "deleteTeam";
	
	  /* LEAGUES */
	  t.VIEW_ALL_LEAGUES = "viewAllLeagues";
	  t.ADD_LEAGUE = "addLeague";
	  t.EDIT_LEAGUE = "editLeague";
	  t.DELETE_LEAGUE = "deleteLeague";
	
	  /* MATCH SPECIFIC */
	  t.EDIT_MATCH_TARGETS = "editGameTargets";
	  t.EDIT_MATCH_LEAGUES = "editGameLeagues";
	  t.EDIT_MATCH_PLAYER_LEAGUE = "editGamePlayerLeague";
	  t.ADD_PLAYER_TO_MATCH = "addPlayersToMatch";
	  t.ADD_DISABLED_PLAYER_TO_MATCH = "addDisabledPlayers";
	  t.ADD_SCORE_TO_MATCH = "addShotsToGame";
	  t.REMOVE_PLAYER_FROM_MATCH = "removePlayersFromMatch";
	  t.UPDATE_MATCH = "gameUpdate";
	  t.MOVE_MATCH = "moveGame";
	  t.CHECK_IN_PLAYER_TO_MATCH = "checkInPlayerToMatch";
	  t.MATCH_PRINTS = "matchPrints";
	
	  /* MATCH ELIMINATION ROUNDS */
	  t.MATCH_ELIMINATION_ROUNDS = "olympic";
	  t.ADD_SCORE_TO_MATCH_ELIMINATION_ROUNDS = "addShotsToOlympic";
	
	  /* COACHES */
	  t.VIEW_ALL_COACHES = "viewAllCoaches";
	  t.ADD_COACH = "addCoach";
	  t.EDIT_COACH = "editCoach";
	  t.DELETE_COACH = "deleteCoach";
	
	  /* STAFF */
	  t.VIEW_ALL_STAFF = "viewAllStaff";
	  t.ADD_STAFF = "addStaff";
	  t.EDIT_STAFF = "editStaff";
	  t.DELETE_STAFF = "deleteStaff";
	
	  /* JUDGES */
	  t.VIEW_ALL_JUDGES = "viewAllJudges";
	  t.ADD_JUDGE = "addJudge";
	  t.EDIT_JUDGE = "editJudge";
	  t.DELETE_JUDGE = "deleteJudge";
	
	  /* TRAINERS */
	  t.VIEW_ALL_TRAINERS = "viewAllTrainers";
	  t.ADD_TRAINER = "addTrainer";
	  t.EDIT_TRAINER = "editTrainer";
	  t.DELETE_TRAINER = "deleteTrainer";
	
	  /* TRAINING ENTRIES */
	  t.VIEW_ALL_TRAINING_ENTRIES = "viewAllTrainingEntries";
	  t.ADD_TRAINING_ENTRY = "addTrainingEntry";
	  t.EDIT_TRAINING_ENTRY = "editTrainingEntry";
	  t.DELETE_TRAINING_ENTRY = "deleteTrainingEntry";
	
	  t.VIEW_TRAINING_CENTERS = "viewAllTrainingCenters";
	  t.ADD_TRAINING_CENTER = "addTrainingCenter";
	  t.EDIT_TRAINING_CENTER = "editTrainingCenter";
	  t.DELETE_TRAINING_CENTER = "deleteTrainingCenter";
	
	  return t;
	}()).name;
	
	exports.default = Permissions;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Levels = _angular2.default.module("Levels", []).constant("Levels", function () {
	  var t = {};
	
	  /* GENERAL */
	  t.WHITE = 1;
	  t.BLACK = 2;
	  t.BLUE = 3;
	  t.RED = 4;
	  t.YELLOW = 5;
	  t.GREEN = 6;
	
	  return t;
	}()).name;
	
	exports.default = Levels;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(336);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Settings = _angular2.default.module("Settings", []).constant("Settings", function () {
	  "ngInject";
	
	  var operatorTypes = {
	    EOT: "eot",
	    SAAF: "saaf"
	  };
	
	  var Settings = {
	    DEBUG: window.env.DEBUG || false,
	    PREF_LANGUAGE: window.env.PREF_LANGUAGE || "en",
	    OPERATOR: window.env.APP_OPERATOR || operatorTypes.SAAF,
	    OPERATORS: operatorTypes
	  };
	
	  return Settings;
	}()).name;
	
	exports.default = Settings;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(922);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(923);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default
	};
	
	exports.default = appComponent;

/***/ }),
/* 922 */
/***/ (function(module, exports) {

	module.exports = "<!-- Place all UI elements intended to be present across all routes in this file -->\n<div\n  id=\"aside\"\n  class=\"app-aside modal fade nav-dropdown\"\n  ng-if=\"$root.showLeftSidebar\"\n  ng-class=\"{'hide':!$root.isUserLoggedIn || !$root.showLeftSidebar}\"\n>\n  <!-- fluid app aside -->\n  <div class=\"left navside dark dk\" layout=\"column\">\n    <div flex class=\"hide-scroll\">\n      <nav class=\"scroll nav-light\">\n        <ui-menu></ui-menu>\n      </nav>\n    </div>\n  </div>\n</div>\n\n<div\n  id=\"content\"\n  class=\"app-content box-shadow-z0\"\n  ng-class=\"{'dark':!$root.isUserLoggedIn, 'app-rtl': $root.isRTL}\"\n  role=\"main\"\n>\n  <div\n    class=\"app-header white box-shadow\"\n    ng-if=\"$root.showHeader\"\n    ng-class=\"{'hide':!$root.isUserLoggedIn}\"\n  >\n    <ui-header></ui-header>\n  </div>\n  <div\n    class=\"app-footer\"\n    ng-if=\"$root.showFooter\"\n    ng-class=\"{'hide':!$root.isUserLoggedIn}\"\n  >\n    <ui-footer></ui-footer>\n  </div>\n  <div class=\"loading-bg-overlay\" ng-if=\"$root.isLoading\"></div>\n  <div ui-view class=\"app-body\" id=\"view\"></div>\n</div>\n"

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(924);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	exports.i(__webpack_require__(925), "");
	exports.i(__webpack_require__(930), "");
	exports.i(__webpack_require__(931), "");
	
	// module
	exports.push([module.id, "body{height:100%;font:62.5% Roboto,sans-serif}.p-t-05{padding-top:.5rem}.p-b-05{padding-bottom:.5rem}.div-hover-grey:hover,.list-item-active{background:rgba(229,233,238,.68)}.cursor-pointer{cursor:pointer}.shot-input{font-weight:700;text-align:center;padding:.3rem!important}.opacity-05{opacity:.5}.m-t-05{margin-top:.5rem}.shot-label{font-size:15px!important;padding:7px 11px!important;color:#000!important;border:1px solid hsla(213,4%,55%,.68);background-color:#fff!important}.visual-shot-label{font-size:29px!important;min-width:57px;min-height:34px}.shot-check-icon{color:green;font-size:22px!important;padding-top:4px}.border-b-1{border:1px solid #000}.material-icons{font-family:Material Icons;font-weight:400;font-style:normal;font-size:18px;display:inline-block;width:1em;height:1em;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;vertical-align:-4px;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:\"liga\"}.ui-grid-pager-control button{padding:0 0 0 5px}.ui-grid-pager-control input{margin-right:4px;padding:0;text-align:center}.ui-grid-align-c{text-align:center}.p-t-5{padding-top:5px!important}.ngdialog.ngdialog-theme-default .ngdialog-content{max-width:300px!important;width:auto!important;background:#fff;border-color:hsla(210,8%,51%,.13);padding:0}.modal-error-icon{font-size:40px;color:red}.modal-success-icon{font-size:40px;color:#6cc788}.modal .ui-switch-md input:checked+i:after{margin-left:0!important}.m-t-14{margin-top:14px}.loading-bg-overlay{width:100%;height:100%;position:absolute;top:58px;z-index:1000;background-color:rgba(0,0,0,.4)}.ui-grid{height:82vh}.ui-grid-viewport .ui-grid-cell-contents:not(.no-wrap){word-wrap:break-word;white-space:normal!important}.ui-grid-cell-contents .buttons button{margin-left:.5rem}.ui-grid-cell,.ui-grid-row{height:auto!important}.ui-grid-row div[role=row]{display:flex;align-content:stretch}/*!\n * Bootstrap v4.0.0-alpha.4 (http://getbootstrap.com)\n * Copyright 2011-2016 The Bootstrap Authors\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v4.0.0 | MIT License | github.com/necolas/normalize.css */article,aside,details,figcaption,figure,footer,header,main,menu,nav,section,summary{display:block}progress{vertical-align:baseline}a:active,a:hover{outline-width:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}mark{background-color:#ff0}img{border-style:none}hr{overflow:visible}button,input,select,textarea{font:inherit}button,input,select{overflow:visible}[type=button],[type=reset],[type=submit],button{cursor:pointer}[disabled]{cursor:default}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}button:-moz-focusring,input:-moz-focusring{outline:1px dotted ButtonText}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;white-space:normal}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}@media print{*,:after,:before,:first-letter,:first-line{text-shadow:none!important;box-shadow:none!important}a,a:visited{text-decoration:underline}abbr[title]:after{content:\" (\" attr(title) \")\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.tag{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}@-ms-viewport{width:device-width}html{font-size:16px;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:1rem;line-height:1.5;color:#373a3c;background-color:#fff}[tabindex=\"-1\"]:focus{outline:none!important}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem}p{margin-top:0;margin-bottom:1rem}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #818a91}address{font-style:normal;line-height:inherit}address,dl,ol,ul{margin-bottom:1rem}dl,ol,ul{margin-top:0}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}a{color:#0275d8}a:focus,a:hover{color:#014c8c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}a:not([href]):not([tabindex]),a:not([href]):not([tabindex]):focus,a:not([href]):not([tabindex]):hover{color:inherit;text-decoration:none}a:not([href]):not([tabindex]):focus{outline:none}figure{margin:0 0 1rem}img{vertical-align:middle}[role=button]{cursor:pointer}[role=button],a,area,button,input,label,select,summary,textarea{touch-action:manipulation}table{background-color:transparent}caption{padding-top:.75rem;padding-bottom:.75rem;color:#818a91;caption-side:bottom}caption,th{text-align:left}label{display:inline-block;margin-bottom:.5rem}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}button,input,select,textarea{margin:0;line-height:inherit;border-radius:0}input[type=checkbox]:disabled,input[type=radio]:disabled{cursor:not-allowed}input[type=date],input[type=datetime-local],input[type=month],input[type=time]{-webkit-appearance:listbox}textarea{resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit}input[type=search]{-webkit-appearance:none}output{display:inline-block}[hidden]{display:none!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-bottom:.5rem;font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1,h1{font-size:2.5rem}.h2,h2{font-size:2rem}.h3,h3{font-size:1.75rem}.h4,h4{font-size:1.5rem}.h5,h5{font-size:1.25rem}.h6,h6{font-size:1rem}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:6rem;font-weight:300}.display-2{font-size:5.5rem;font-weight:300}.display-3{font-size:4.5rem;font-weight:300}.display-4{font-size:3.5rem;font-weight:300}hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small,small{font-size:80%;font-weight:400}.mark,mark{padding:.2em;background-color:#fcf8e3}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:5px}.initialism{font-size:90%;text-transform:uppercase}.blockquote{padding:.5rem 1rem;margin-bottom:1rem;font-size:1.25rem;border-left:.25rem solid #eceeef}.blockquote-footer{display:block;font-size:80%;color:#818a91}.blockquote-footer:before{content:\"\\2014   \\A0\"}.blockquote-reverse{padding-right:1rem;padding-left:0;text-align:right;border-right:.25rem solid #eceeef;border-left:0}.blockquote-reverse .blockquote-footer:before{content:\"\"}.blockquote-reverse .blockquote-footer:after{content:\"\\A0   \\2014\"}dl.row>dd+dt{clear:left}.carousel-inner>.carousel-item>a>img,.carousel-inner>.carousel-item>img,.img-fluid{display:block;max-width:100%;height:auto}.img-rounded{border-radius:.3rem}.img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #ddd;border-radius:.25rem;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#818a91}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}code{color:#bd4147;background-color:#f7f7f9;border-radius:.25rem}code,kbd{padding:.2rem .4rem;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:.2rem}kbd kbd{padding:0;font-size:100%;font-weight:700}pre{display:block;margin-top:0;margin-bottom:1rem;font-size:90%;color:#373a3c}pre code{padding:0;font-size:inherit;color:inherit;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}.container:after{content:\"\";display:table;clear:both}@media (min-width:544px){.container{max-width:576px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:940px}}@media (min-width:1200px){.container{max-width:1140px}}.container-fluid{margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}.container-fluid:after{content:\"\";display:table;clear:both}.row{margin-left:-15px;margin-right:-15px}.row:after{content:\"\";display:table;clear:both}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1{float:left;width:8.33333%}.col-xs-2{float:left;width:16.66667%}.col-xs-3{float:left;width:25%}.col-xs-4{float:left;width:33.33333%}.col-xs-5{float:left;width:41.66667%}.col-xs-6{float:left;width:50%}.col-xs-7{float:left;width:58.33333%}.col-xs-8{float:left;width:66.66667%}.col-xs-9{float:left;width:75%}.col-xs-10{float:left;width:83.33333%}.col-xs-11{float:left;width:91.66667%}.col-xs-12{float:left;width:100%}.pull-xs-0{right:auto}.pull-xs-1{right:8.33333%}.pull-xs-2{right:16.66667%}.pull-xs-3{right:25%}.pull-xs-4{right:33.33333%}.pull-xs-5{right:41.66667%}.pull-xs-6{right:50%}.pull-xs-7{right:58.33333%}.pull-xs-8{right:66.66667%}.pull-xs-9{right:75%}.pull-xs-10{right:83.33333%}.pull-xs-11{right:91.66667%}.pull-xs-12{right:100%}.push-xs-0{left:auto}.push-xs-1{left:8.33333%}.push-xs-2{left:16.66667%}.push-xs-3{left:25%}.push-xs-4{left:33.33333%}.push-xs-5{left:41.66667%}.push-xs-6{left:50%}.push-xs-7{left:58.33333%}.push-xs-8{left:66.66667%}.push-xs-9{left:75%}.push-xs-10{left:83.33333%}.push-xs-11{left:91.66667%}.push-xs-12{left:100%}.offset-xs-1{margin-left:8.33333%}.offset-xs-2{margin-left:16.66667%}.offset-xs-3{margin-left:25%}.offset-xs-4{margin-left:33.33333%}.offset-xs-5{margin-left:41.66667%}.offset-xs-6{margin-left:50%}.offset-xs-7{margin-left:58.33333%}.offset-xs-8{margin-left:66.66667%}.offset-xs-9{margin-left:75%}.offset-xs-10{margin-left:83.33333%}.offset-xs-11{margin-left:91.66667%}@media (min-width:544px){.col-sm-1{float:left;width:8.33333%}.col-sm-2{float:left;width:16.66667%}.col-sm-3{float:left;width:25%}.col-sm-4{float:left;width:33.33333%}.col-sm-5{float:left;width:41.66667%}.col-sm-6{float:left;width:50%}.col-sm-7{float:left;width:58.33333%}.col-sm-8{float:left;width:66.66667%}.col-sm-9{float:left;width:75%}.col-sm-10{float:left;width:83.33333%}.col-sm-11{float:left;width:91.66667%}.col-sm-12{float:left;width:100%}.pull-sm-0{right:auto}.pull-sm-1{right:8.33333%}.pull-sm-2{right:16.66667%}.pull-sm-3{right:25%}.pull-sm-4{right:33.33333%}.pull-sm-5{right:41.66667%}.pull-sm-6{right:50%}.pull-sm-7{right:58.33333%}.pull-sm-8{right:66.66667%}.pull-sm-9{right:75%}.pull-sm-10{right:83.33333%}.pull-sm-11{right:91.66667%}.pull-sm-12{right:100%}.push-sm-0{left:auto}.push-sm-1{left:8.33333%}.push-sm-2{left:16.66667%}.push-sm-3{left:25%}.push-sm-4{left:33.33333%}.push-sm-5{left:41.66667%}.push-sm-6{left:50%}.push-sm-7{left:58.33333%}.push-sm-8{left:66.66667%}.push-sm-9{left:75%}.push-sm-10{left:83.33333%}.push-sm-11{left:91.66667%}.push-sm-12{left:100%}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.33333%}.offset-sm-2{margin-left:16.66667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.33333%}.offset-sm-5{margin-left:41.66667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.33333%}.offset-sm-8{margin-left:66.66667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.33333%}.offset-sm-11{margin-left:91.66667%}}@media (min-width:768px){.col-md-1{float:left;width:8.33333%}.col-md-2{float:left;width:16.66667%}.col-md-3{float:left;width:25%}.col-md-4{float:left;width:33.33333%}.col-md-5{float:left;width:41.66667%}.col-md-6{float:left;width:50%}.col-md-7{float:left;width:58.33333%}.col-md-8{float:left;width:66.66667%}.col-md-9{float:left;width:75%}.col-md-10{float:left;width:83.33333%}.col-md-11{float:left;width:91.66667%}.col-md-12{float:left;width:100%}.pull-md-0{right:auto}.pull-md-1{right:8.33333%}.pull-md-2{right:16.66667%}.pull-md-3{right:25%}.pull-md-4{right:33.33333%}.pull-md-5{right:41.66667%}.pull-md-6{right:50%}.pull-md-7{right:58.33333%}.pull-md-8{right:66.66667%}.pull-md-9{right:75%}.pull-md-10{right:83.33333%}.pull-md-11{right:91.66667%}.pull-md-12{right:100%}.push-md-0{left:auto}.push-md-1{left:8.33333%}.push-md-2{left:16.66667%}.push-md-3{left:25%}.push-md-4{left:33.33333%}.push-md-5{left:41.66667%}.push-md-6{left:50%}.push-md-7{left:58.33333%}.push-md-8{left:66.66667%}.push-md-9{left:75%}.push-md-10{left:83.33333%}.push-md-11{left:91.66667%}.push-md-12{left:100%}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.33333%}.offset-md-2{margin-left:16.66667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.33333%}.offset-md-5{margin-left:41.66667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.33333%}.offset-md-8{margin-left:66.66667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.33333%}.offset-md-11{margin-left:91.66667%}}@media (min-width:992px){.col-lg-1{float:left;width:8.33333%}.col-lg-2{float:left;width:16.66667%}.col-lg-3{float:left;width:25%}.col-lg-4{float:left;width:33.33333%}.col-lg-5{float:left;width:41.66667%}.col-lg-6{float:left;width:50%}.col-lg-7{float:left;width:58.33333%}.col-lg-8{float:left;width:66.66667%}.col-lg-9{float:left;width:75%}.col-lg-10{float:left;width:83.33333%}.col-lg-11{float:left;width:91.66667%}.col-lg-12{float:left;width:100%}.pull-lg-0{right:auto}.pull-lg-1{right:8.33333%}.pull-lg-2{right:16.66667%}.pull-lg-3{right:25%}.pull-lg-4{right:33.33333%}.pull-lg-5{right:41.66667%}.pull-lg-6{right:50%}.pull-lg-7{right:58.33333%}.pull-lg-8{right:66.66667%}.pull-lg-9{right:75%}.pull-lg-10{right:83.33333%}.pull-lg-11{right:91.66667%}.pull-lg-12{right:100%}.push-lg-0{left:auto}.push-lg-1{left:8.33333%}.push-lg-2{left:16.66667%}.push-lg-3{left:25%}.push-lg-4{left:33.33333%}.push-lg-5{left:41.66667%}.push-lg-6{left:50%}.push-lg-7{left:58.33333%}.push-lg-8{left:66.66667%}.push-lg-9{left:75%}.push-lg-10{left:83.33333%}.push-lg-11{left:91.66667%}.push-lg-12{left:100%}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.33333%}.offset-lg-2{margin-left:16.66667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.33333%}.offset-lg-5{margin-left:41.66667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.33333%}.offset-lg-8{margin-left:66.66667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.33333%}.offset-lg-11{margin-left:91.66667%}}@media (min-width:1200px){.col-xl-1{float:left;width:8.33333%}.col-xl-2{float:left;width:16.66667%}.col-xl-3{float:left;width:25%}.col-xl-4{float:left;width:33.33333%}.col-xl-5{float:left;width:41.66667%}.col-xl-6{float:left;width:50%}.col-xl-7{float:left;width:58.33333%}.col-xl-8{float:left;width:66.66667%}.col-xl-9{float:left;width:75%}.col-xl-10{float:left;width:83.33333%}.col-xl-11{float:left;width:91.66667%}.col-xl-12{float:left;width:100%}.pull-xl-0{right:auto}.pull-xl-1{right:8.33333%}.pull-xl-2{right:16.66667%}.pull-xl-3{right:25%}.pull-xl-4{right:33.33333%}.pull-xl-5{right:41.66667%}.pull-xl-6{right:50%}.pull-xl-7{right:58.33333%}.pull-xl-8{right:66.66667%}.pull-xl-9{right:75%}.pull-xl-10{right:83.33333%}.pull-xl-11{right:91.66667%}.pull-xl-12{right:100%}.push-xl-0{left:auto}.push-xl-1{left:8.33333%}.push-xl-2{left:16.66667%}.push-xl-3{left:25%}.push-xl-4{left:33.33333%}.push-xl-5{left:41.66667%}.push-xl-6{left:50%}.push-xl-7{left:58.33333%}.push-xl-8{left:66.66667%}.push-xl-9{left:75%}.push-xl-10{left:83.33333%}.push-xl-11{left:91.66667%}.push-xl-12{left:100%}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.33333%}.offset-xl-2{margin-left:16.66667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.33333%}.offset-xl-5{margin-left:41.66667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.33333%}.offset-xl-8{margin-left:66.66667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.33333%}.offset-xl-11{margin-left:91.66667%}}.table{width:100%;max-width:100%;margin-bottom:1rem}.table td,.table th{padding:.75rem;vertical-align:top;border-top:1px solid #eceeef}.table thead th{vertical-align:bottom;border-bottom:2px solid #eceeef}.table tbody+tbody{border-top:2px solid #eceeef}.table .table{background-color:#fff}.table-sm td,.table-sm th{padding:.3rem}.table-bordered,.table-bordered td,.table-bordered th{border:1px solid #eceeef}.table-bordered thead td,.table-bordered thead th{border-bottom-width:2px}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-active,.table-active>td,.table-active>th,.table-hover .table-active:hover,.table-hover .table-active:hover>td,.table-hover .table-active:hover>th,.table-hover tbody tr:hover{background-color:rgba(0,0,0,.075)}.table-success,.table-success>td,.table-success>th{background-color:#dff0d8}.table-hover .table-success:hover,.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#d0e9c6}.table-info,.table-info>td,.table-info>th{background-color:#d9edf7}.table-hover .table-info:hover,.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#c4e3f3}.table-warning,.table-warning>td,.table-warning>th{background-color:#fcf8e3}.table-hover .table-warning:hover,.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#faf2cc}.table-danger,.table-danger>td,.table-danger>th{background-color:#f2dede}.table-hover .table-danger:hover,.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#ebcccc}.thead-inverse th{color:#fff;background-color:#373a3c}.thead-default th{color:#55595c;background-color:#eceeef}.table-inverse{color:#eceeef;background-color:#373a3c}.table-inverse td,.table-inverse th,.table-inverse thead th{border-color:#55595c}.table-inverse.table-bordered{border:0}.table-responsive{display:block;width:100%;min-height:.01%;overflow-x:auto}.table-reflow thead{float:left}.table-reflow tbody{display:block;white-space:nowrap}.table-reflow td,.table-reflow th{border-top:1px solid #eceeef;border-left:1px solid #eceeef}.table-reflow td:last-child,.table-reflow th:last-child{border-right:1px solid #eceeef}.table-reflow tbody:last-child tr:last-child td,.table-reflow tbody:last-child tr:last-child th,.table-reflow tfoot:last-child tr:last-child td,.table-reflow tfoot:last-child tr:last-child th,.table-reflow thead:last-child tr:last-child td,.table-reflow thead:last-child tr:last-child th{border-bottom:1px solid #eceeef}.table-reflow tr{float:left}.table-reflow tr td,.table-reflow tr th{display:block!important;border:1px solid #eceeef}.form-control{display:block;width:100%;padding:.5rem .75rem;font-size:1rem;line-height:1.25;color:#55595c;background-color:#fff;background-image:none;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:focus{color:#55595c;background-color:#fff;border-color:#66afe9;outline:none}.form-control::placeholder{color:#999;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#eceeef;opacity:1}.form-control:disabled{cursor:not-allowed}select.form-control:not([size]):not([multiple]){height:2.5rem}select.form-control:focus::-ms-value{color:#55595c;background-color:#fff}.form-control-file,.form-control-range{display:block}.col-form-label{padding-top:.5rem;padding-bottom:.5rem;margin-bottom:0}.col-form-label-lg{padding-top:.75rem;padding-bottom:.75rem;font-size:1.25rem}.col-form-label-sm{padding-top:.25rem;padding-bottom:.25rem;font-size:.875rem}.col-form-legend{font-size:1rem}.col-form-legend,.form-control-static{padding-top:.5rem;padding-bottom:.5rem;margin-bottom:0}.form-control-static{min-height:2.5rem}.form-control-static.form-control-lg,.form-control-static.form-control-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-right:0;padding-left:0}.form-control-sm,.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.input-group-sm>.input-group-btn>select.btn:not([size]):not([multiple]),.input-group-sm>select.form-control:not([size]):not([multiple]),.input-group-sm>select.input-group-addon:not([size]):not([multiple]),select.form-control-sm:not([size]):not([multiple]){height:1.8125rem}.form-control-lg,.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{padding:.75rem 1.5rem;font-size:1.25rem;border-radius:.3rem}.input-group-lg>.input-group-btn>select.btn:not([size]):not([multiple]),.input-group-lg>select.form-control:not([size]):not([multiple]),.input-group-lg>select.input-group-addon:not([size]):not([multiple]),select.form-control-lg:not([size]):not([multiple]){height:3.16667rem}.form-group{margin-bottom:1rem}.form-text{display:block;margin-top:.25rem}.form-check{position:relative;display:block;margin-bottom:.75rem}.form-check+.form-check{margin-top:-.25rem}.form-check.disabled .form-check-label{color:#818a91;cursor:not-allowed}.form-check-label{padding-left:1.25rem;margin-bottom:0;cursor:pointer}.form-check-input{position:absolute;margin-top:.25rem;margin-left:-1.25rem}.form-check-input:only-child{position:static}.form-check-inline{position:relative;display:inline-block;padding-left:1.25rem;margin-bottom:0;vertical-align:middle;cursor:pointer}.form-check-inline+.form-check-inline{margin-left:.75rem}.form-check-inline.disabled{cursor:not-allowed}.form-control-feedback{margin-top:.25rem}.form-control-danger,.form-control-success,.form-control-warning{padding-right:2.25rem;background-repeat:no-repeat;background-position:center right .625rem;background-size:1.25rem 1.25rem}.has-success .custom-control,.has-success .form-check-inline,.has-success .form-check-label,.has-success .form-control-feedback,.has-success .form-control-label{color:#5cb85c}.has-success .form-control{border-color:#5cb85c}.has-success .input-group-addon{color:#5cb85c;border-color:#5cb85c;background-color:#eaf6ea}.has-success .form-control-feedback{color:#5cb85c}.has-success .form-control-success{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%235cb85c' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\")}.has-warning .custom-control,.has-warning .form-check-inline,.has-warning .form-check-label,.has-warning .form-control-feedback,.has-warning .form-control-label{color:#f0ad4e}.has-warning .form-control{border-color:#f0ad4e}.has-warning .input-group-addon{color:#f0ad4e;border-color:#f0ad4e;background-color:#fff}.has-warning .form-control-feedback{color:#f0ad4e}.has-warning .form-control-warning{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23f0ad4e' d='M4.4 5.324h-.8v-2.46h.8zm0 1.42h-.8V5.89h.8zM3.76.63L.04 7.075c-.115.2.016.425.26.426h7.397c.242 0 .372-.226.258-.426C6.726 4.924 5.47 2.79 4.253.63c-.113-.174-.39-.174-.494 0z'/%3E%3C/svg%3E\")}.has-danger .custom-control,.has-danger .form-check-inline,.has-danger .form-check-label,.has-danger .form-control-feedback,.has-danger .form-control-label{color:#d9534f}.has-danger .form-control{border-color:#d9534f}.has-danger .input-group-addon{color:#d9534f;border-color:#d9534f;background-color:#fdf7f7}.has-danger .form-control-feedback{color:#d9534f}.has-danger .form-control-danger{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23d9534f' viewBox='-2 -2 7 7'%3E%3Cpath stroke='%23d9534f' d='M0 0l3 3m0-3L0 3'/%3E%3Ccircle r='.5'/%3E%3Ccircle cx='3' r='.5'/%3E%3Ccircle cy='3' r='.5'/%3E%3Ccircle cx='3' cy='3' r='.5'/%3E%3C/svg%3E\")}@media (min-width:544px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .form-check,.form-inline .form-control-label{margin-bottom:0;vertical-align:middle}.form-inline .form-check{display:inline-block;margin-top:0}.form-inline .form-check-label{padding-left:0}.form-inline .form-check-input{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}.collapsing{height:0;overflow:hidden;transition-timing-function:ease;transition-duration:.35s;transition-property:height}.collapsing,.dropdown,.dropup{position:relative}.dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.3em;vertical-align:middle;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-left:.3em solid transparent}.dropdown-toggle:focus{outline:0}.dropup .dropdown-toggle:after{border-top:0;border-bottom:.3em solid}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:1rem;color:#373a3c;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-divider{height:1px;margin:.5rem 0;overflow:hidden;background-color:#e5e5e5}.dropdown-item{display:block;width:100%;padding:3px 20px;clear:both;font-weight:400;color:#373a3c;text-align:inherit;white-space:nowrap;background:none;border:0}.dropdown-item:focus,.dropdown-item:hover{color:#2b2d2f;text-decoration:none;background-color:#f5f5f5}.dropdown-item.active,.dropdown-item.active:focus,.dropdown-item.active:hover{color:#fff;text-decoration:none;background-color:#0275d8;outline:0}.dropdown-item.disabled,.dropdown-item.disabled:focus,.dropdown-item.disabled:hover{color:#818a91}.dropdown-item.disabled:focus,.dropdown-item.disabled:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:\"progid:DXImageTransform.Microsoft.gradient(enabled = false)\"}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:5px 20px;font-size:.875rem;color:#818a91;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:.3em solid}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-.5rem}.btn-toolbar:after{content:\"\";display:table;clear:both}.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:.5rem}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn+.dropdown-toggle-split:after{margin-left:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:1.125rem;padding-left:1.125rem}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:.3em .3em 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 .3em .3em}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after{content:\"\";display:table;clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;width:100%;display:table;border-collapse:separate}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:active,.input-group .form-control:focus,.input-group .form-control:hover{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.25;color:#55595c;text-align:center;background-color:#eceeef;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.input-group-addon.form-control-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.input-group-addon.form-control-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:.75rem 1.5rem;font-size:1.25rem;border-radius:.3rem}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:not(:last-child),.input-group-btn:not(:first-child)>.btn-group:not(:last-child)>.btn,.input-group-btn:not(:first-child)>.btn:not(:last-child):not(.dropdown-toggle),.input-group-btn:not(:last-child)>.btn,.input-group-btn:not(:last-child)>.btn-group>.btn,.input-group-btn:not(:last-child)>.dropdown-toggle,.input-group .form-control:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:not(:last-child){border-right:0}.input-group-addon:not(:first-child),.input-group-btn:not(:first-child)>.btn,.input-group-btn:not(:first-child)>.btn-group>.btn,.input-group-btn:not(:first-child)>.dropdown-toggle,.input-group-btn:not(:last-child)>.btn-group:not(:first-child)>.btn,.input-group-btn:not(:last-child)>.btn:not(:first-child),.input-group .form-control:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.form-control+.input-group-addon:not(:first-child){border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:3}.input-group-btn:not(:last-child)>.btn,.input-group-btn:not(:last-child)>.btn-group{margin-right:-1px}.input-group-btn:not(:first-child)>.btn,.input-group-btn:not(:first-child)>.btn-group{z-index:2;margin-left:-1px}.input-group-btn:not(:first-child)>.btn-group:active,.input-group-btn:not(:first-child)>.btn-group:focus,.input-group-btn:not(:first-child)>.btn-group:hover,.input-group-btn:not(:first-child)>.btn:active,.input-group-btn:not(:first-child)>.btn:focus,.input-group-btn:not(:first-child)>.btn:hover{z-index:3}.custom-control{position:relative;display:inline;padding-left:1.5rem;cursor:pointer}.custom-control+.custom-control{margin-left:1rem}.custom-control-input{position:absolute;z-index:-1;opacity:0}.custom-control-input:checked~.custom-control-indicator{color:#fff;background-color:#0074d9}.custom-control-input:focus~.custom-control-indicator{box-shadow:0 0 0 .075rem #fff,0 0 0 .2rem #0074d9}.custom-control-input:active~.custom-control-indicator{color:#fff;background-color:#84c6ff}.custom-control-input:disabled~.custom-control-indicator{cursor:not-allowed;background-color:#eee}.custom-control-input:disabled~.custom-control-description{color:#767676;cursor:not-allowed}.custom-control-indicator{position:absolute;top:.0625rem;left:0;display:block;width:1rem;height:1rem;pointer-events:none;user-select:none;background-color:#ddd;background-repeat:no-repeat;background-position:50%;background-size:50% 50%}.custom-checkbox .custom-control-indicator{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-indicator{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-indicator{background-color:#0074d9;background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\")}.custom-radio .custom-control-indicator{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-indicator{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.custom-controls-stacked .custom-control{display:inline}.custom-controls-stacked .custom-control:after{display:block;margin-bottom:.25rem;content:\"\"}.custom-controls-stacked .custom-control+.custom-control{margin-left:0}.custom-select{display:inline-block;max-width:100%;padding:.375rem 1.75rem .375rem .75rem;padding-right:.75rem\\9;color:#55595c;vertical-align:middle;background:#fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right .75rem center;background-image:none\\9;background-size:8px 10px;border:1px solid rgba(0,0,0,.15);border-radius:.25rem;-moz-appearance:none;-webkit-appearance:none}.custom-select:focus{border-color:#51a7e8;outline:none}.custom-select:focus::-ms-value{color:#55595c;background-color:#fff}.custom-select:disabled{color:#818a91;cursor:not-allowed;background-color:#eceeef}.custom-select::-ms-expand{opacity:0}.custom-select-sm{padding-top:.375rem;padding-bottom:.375rem;font-size:75%}.custom-file{position:relative;display:inline-block;max-width:100%;height:2.5rem;cursor:pointer}.custom-file-input{min-width:14rem;max-width:100%;margin:0;filter:alpha(opacity=0);opacity:0}.custom-file-control{position:absolute;top:0;right:0;left:0;z-index:5;height:2.5rem;padding:.5rem 1rem;line-height:1.5;color:#555;user-select:none;background-color:#fff;border:1px solid #ddd;border-radius:.25rem}.custom-file-control:lang(en):after{content:\"Choose file...\"}.custom-file-control:before{position:absolute;top:-1px;right:-1px;bottom:-1px;z-index:6;display:block;height:2.5rem;padding:.5rem 1rem;line-height:1.5;color:#555;background-color:#eee;border:1px solid #ddd;border-radius:0 .25rem .25rem 0}.custom-file-control:lang(en):before{content:\"Browse\"}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav-link{display:inline-block}.nav-link:focus,.nav-link:hover{text-decoration:none}.nav-link.disabled{color:#818a91}.nav-link.disabled,.nav-link.disabled:focus,.nav-link.disabled:hover{color:#818a91;cursor:not-allowed;background-color:transparent}.nav-inline .nav-item{display:inline-block}.nav-inline .nav-item+.nav-item,.nav-inline .nav-link+.nav-link{margin-left:1rem}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs:after{content:\"\";display:table;clear:both}.nav-tabs .nav-item{float:left;margin-bottom:-1px}.nav-tabs .nav-item+.nav-item{margin-left:.2rem}.nav-tabs .nav-link{display:block;padding:.5em 1em;border:1px solid transparent;border-top-right-radius:.25rem;border-top-left-radius:.25rem}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:#eceeef #eceeef #ddd}.nav-tabs .nav-link.disabled,.nav-tabs .nav-link.disabled:focus,.nav-tabs .nav-link.disabled:hover{color:#818a91;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.open .nav-link,.nav-tabs .nav-item.open .nav-link:focus,.nav-tabs .nav-item.open .nav-link:hover,.nav-tabs .nav-link.active,.nav-tabs .nav-link.active:focus,.nav-tabs .nav-link.active:hover{color:#55595c;background-color:#fff;border-color:#ddd #ddd transparent}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.nav-pills:after{content:\"\";display:table;clear:both}.nav-pills .nav-item{float:left}.nav-pills .nav-item+.nav-item{margin-left:.2rem}.nav-pills .nav-link{display:block;padding:.5em 1em;border-radius:.25rem}.nav-pills .nav-item.open .nav-link,.nav-pills .nav-item.open .nav-link:focus,.nav-pills .nav-item.open .nav-link:hover,.nav-pills .nav-link.active,.nav-pills .nav-link.active:focus,.nav-pills .nav-link.active:hover{color:#fff;cursor:default;background-color:#0275d8}.nav-stacked .nav-item{display:block;float:none}.nav-stacked .nav-item+.nav-item{margin-top:.2rem;margin-left:0}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;padding:.5rem 1rem}.navbar:after{content:\"\";display:table;clear:both}@media (min-width:544px){.navbar{border-radius:.25rem}}.navbar-full{z-index:1000}@media (min-width:544px){.navbar-full{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:544px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0}.navbar-fixed-bottom{bottom:0}.navbar-sticky-top{position:sticky;top:0;z-index:1030;width:100%}@media (min-width:544px){.navbar-sticky-top{border-radius:0}}.navbar-brand{float:left;padding-top:.25rem;padding-bottom:.25rem;margin-right:1rem;font-size:1.25rem}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}.navbar-divider{float:left;width:1px;padding-top:.425rem;padding-bottom:.425rem;margin-right:1rem;margin-left:1rem;overflow:hidden}.navbar-divider:before{content:\"\\A0\"}.navbar-toggler{padding:.5rem .75rem;font-size:1.25rem;line-height:1;background:none;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none}.navbar-nav .nav-item{float:left}.navbar-nav .nav-link{display:block;padding-top:.425rem;padding-bottom:.425rem}.navbar-nav .nav-item+.nav-item,.navbar-nav .nav-link+.nav-link{margin-left:1rem}.navbar-light .navbar-brand,.navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.8)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.6)}.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .active>.nav-link:focus,.navbar-light .navbar-nav .active>.nav-link:hover,.navbar-light .navbar-nav .nav-link.active,.navbar-light .navbar-nav .nav-link.active:focus,.navbar-light .navbar-nav .nav-link.active:hover,.navbar-light .navbar-nav .nav-link.open,.navbar-light .navbar-nav .nav-link.open:focus,.navbar-light .navbar-nav .nav-link.open:hover,.navbar-light .navbar-nav .open>.nav-link,.navbar-light .navbar-nav .open>.nav-link:focus,.navbar-light .navbar-nav .open>.nav-link:hover{color:rgba(0,0,0,.8)}.navbar-light .navbar-divider{background-color:rgba(0,0,0,.075)}.navbar-dark .navbar-brand,.navbar-dark .navbar-brand:focus,.navbar-dark .navbar-brand:hover{color:#fff}.navbar-dark .navbar-nav .nav-link{color:hsla(0,0%,100%,.5)}.navbar-dark .navbar-nav .nav-link:focus,.navbar-dark .navbar-nav .nav-link:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .active>.nav-link:focus,.navbar-dark .navbar-nav .active>.nav-link:hover,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.active:focus,.navbar-dark .navbar-nav .nav-link.active:hover,.navbar-dark .navbar-nav .nav-link.open,.navbar-dark .navbar-nav .nav-link.open:focus,.navbar-dark .navbar-nav .nav-link.open:hover,.navbar-dark .navbar-nav .open>.nav-link,.navbar-dark .navbar-nav .open>.nav-link:focus,.navbar-dark .navbar-nav .open>.nav-link:hover{color:#fff}.navbar-dark .navbar-divider{background-color:hsla(0,0%,100%,.075)}.navbar-toggleable-xs:after{content:\"\";display:table;clear:both}@media (max-width:543px){.navbar-toggleable-xs .navbar-nav .nav-item{float:none;margin-left:0}}@media (min-width:544px){.navbar-toggleable-xs{display:block!important}}.navbar-toggleable-sm:after{content:\"\";display:table;clear:both}@media (max-width:767px){.navbar-toggleable-sm .navbar-nav .nav-item{float:none;margin-left:0}}@media (min-width:768px){.navbar-toggleable-sm{display:block!important}}.navbar-toggleable-md:after{content:\"\";display:table;clear:both}@media (max-width:991px){.navbar-toggleable-md .navbar-nav .nav-item{float:none;margin-left:0}}@media (min-width:992px){.navbar-toggleable-md{display:block!important}}.card{position:relative;display:block;margin-bottom:.75rem;background-color:#fff;border-radius:.25rem;border:1px solid rgba(0,0,0,.125)}.card-block{padding:1.25rem}.card-block:after{content:\"\";display:table;clear:both}.card-title{margin-bottom:.75rem}.card-subtitle{margin-top:-.375rem}.card-subtitle,.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:1.25rem}.card>.list-group:first-child .list-group-item:first-child{border-top-right-radius:.25rem;border-top-left-radius:.25rem}.card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.card-header{padding:.75rem 1.25rem;background-color:#f5f5f5;border-bottom:1px solid rgba(0,0,0,.125)}.card-header:after{content:\"\";display:table;clear:both}.card-header:first-child{border-radius:.25rem .25rem 0 0}.card-footer{padding:.75rem 1.25rem;background-color:#f5f5f5;border-top:1px solid rgba(0,0,0,.125)}.card-footer:after{content:\"\";display:table;clear:both}.card-footer:last-child{border-radius:0 0 .25rem .25rem}.card-header-tabs{margin-bottom:-.75rem;border-bottom:0}.card-header-pills,.card-header-tabs{margin-right:-.625rem;margin-left:-.625rem}.card-primary{background-color:#0275d8;border-color:#0275d8}.card-primary .card-footer,.card-primary .card-header{background-color:transparent}.card-success{background-color:#5cb85c;border-color:#5cb85c}.card-success .card-footer,.card-success .card-header{background-color:transparent}.card-info{background-color:#5bc0de;border-color:#5bc0de}.card-info .card-footer,.card-info .card-header{background-color:transparent}.card-warning{background-color:#f0ad4e;border-color:#f0ad4e}.card-warning .card-footer,.card-warning .card-header{background-color:transparent}.card-danger{background-color:#d9534f;border-color:#d9534f}.card-danger .card-footer,.card-danger .card-header,.card-outline-primary{background-color:transparent}.card-outline-primary{border-color:#0275d8}.card-outline-secondary{background-color:transparent;border-color:#ccc}.card-outline-info{background-color:transparent;border-color:#5bc0de}.card-outline-success{background-color:transparent;border-color:#5cb85c}.card-outline-warning{background-color:transparent;border-color:#f0ad4e}.card-outline-danger{background-color:transparent;border-color:#d9534f}.card-inverse .card-footer,.card-inverse .card-header{border-color:hsla(0,0%,100%,.2)}.card-inverse .card-blockquote,.card-inverse .card-footer,.card-inverse .card-header,.card-inverse .card-title{color:#fff}.card-inverse .card-blockquote .blockquote-footer,.card-inverse .card-link,.card-inverse .card-subtitle,.card-inverse .card-text{color:hsla(0,0%,100%,.65)}.card-inverse .card-link:focus,.card-inverse .card-link:hover{color:#fff}.card-blockquote{padding:0;margin-bottom:0;border-left:0}.card-img{border-radius:.25rem}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem}.card-img-top{border-top-right-radius:.25rem;border-top-left-radius:.25rem}.card-img-bottom{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}@media (min-width:544px){.card-deck{display:table;width:100%;margin-bottom:.75rem;table-layout:fixed;border-spacing:1.25rem 0}.card-deck .card{display:table-cell;margin-bottom:0;vertical-align:top}.card-deck-wrapper{margin-right:-1.25rem;margin-left:-1.25rem}}@media (min-width:544px){.card-group{display:table;width:100%;table-layout:fixed}.card-group .card{display:table-cell;vertical-align:top}.card-group .card+.card{margin-left:0;border-left:0}.card-group .card:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.card-group .card:first-child .card-img-top{border-top-right-radius:0}.card-group .card:first-child .card-img-bottom{border-bottom-right-radius:0}.card-group .card:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.card-group .card:last-child .card-img-top{border-top-left-radius:0}.card-group .card:last-child .card-img-bottom{border-bottom-left-radius:0}.card-group .card:not(:first-child):not(:last-child),.card-group .card:not(:first-child):not(:last-child) .card-img-bottom,.card-group .card:not(:first-child):not(:last-child) .card-img-top{border-radius:0}}@media (min-width:544px){.card-columns{column-count:3;column-gap:1.25rem}.card-columns .card{width:100%}}.breadcrumb{padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#eceeef;border-radius:.25rem}.breadcrumb:after{content:\"\";display:table;clear:both}.breadcrumb-item{float:left}.breadcrumb-item+.breadcrumb-item:before{display:inline-block;padding-right:.5rem;padding-left:.5rem;color:#818a91;content:\"/\"}.breadcrumb-item+.breadcrumb-item:hover:before{text-decoration:underline;text-decoration:none}.breadcrumb-item.active{color:#818a91}.pagination{display:inline-block;padding-left:0;margin-top:1rem;margin-bottom:1rem;border-radius:.25rem}.page-item{display:inline}.page-item:first-child .page-link{margin-left:0;border-bottom-left-radius:.25rem;border-top-left-radius:.25rem}.page-item:last-child .page-link{border-bottom-right-radius:.25rem;border-top-right-radius:.25rem}.page-item.active .page-link,.page-item.active .page-link:focus,.page-item.active .page-link:hover{z-index:2;color:#fff;cursor:default;background-color:#0275d8;border-color:#0275d8}.page-item.disabled .page-link,.page-item.disabled .page-link:focus,.page-item.disabled .page-link:hover{color:#818a91;pointer-events:none;cursor:not-allowed;background-color:#fff;border-color:#ddd}.page-link{position:relative;float:left;padding:.5rem .75rem;margin-left:-1px;color:#0275d8;text-decoration:none;background-color:#fff;border:1px solid #ddd}.page-link:focus,.page-link:hover{color:#014c8c;background-color:#eceeef;border-color:#ddd}.pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem}.pagination-lg .page-item:first-child .page-link{border-bottom-left-radius:.3rem;border-top-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link{border-bottom-right-radius:.3rem;border-top-right-radius:.3rem}.pagination-sm .page-link{padding:.275rem .75rem;font-size:.875rem}.pagination-sm .page-item:first-child .page-link{border-bottom-left-radius:.2rem;border-top-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link{border-bottom-right-radius:.2rem;border-top-right-radius:.2rem}.tag{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.tag:empty{display:none}.btn .tag{position:relative;top:-1px}a.tag:focus,a.tag:hover{color:#fff;text-decoration:none;cursor:pointer}.tag-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.tag-default{background-color:#818a91}.tag-default[href]:focus,.tag-default[href]:hover{background-color:#687077}.tag-primary{background-color:#0275d8}.tag-primary[href]:focus,.tag-primary[href]:hover{background-color:#025aa5}.tag-success{background-color:#5cb85c}.tag-success[href]:focus,.tag-success[href]:hover{background-color:#449d44}.tag-info{background-color:#5bc0de}.tag-info[href]:focus,.tag-info[href]:hover{background-color:#31b0d5}.tag-warning{background-color:#f0ad4e}.tag-warning[href]:focus,.tag-warning[href]:hover{background-color:#ec971f}.tag-danger{background-color:#d9534f}.tag-danger[href]:focus,.tag-danger[href]:hover{background-color:#c9302c}.jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#eceeef;border-radius:.3rem}@media (min-width:544px){.jumbotron{padding:4rem 2rem}}.jumbotron-hr{border-top-color:#d0d5d8}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{padding:1rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:2rem}.alert-dismissible .close{position:relative;top:-.125rem;right:-1rem;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d0e9c6;color:#3c763d}.alert-success hr{border-top-color:#c1e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bcdff1;color:#31708f}.alert-info hr{border-top-color:#a6d5ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faf2cc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7ecb5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebcccc;color:#a94442}.alert-danger hr{border-top-color:#e4b9b9}.alert-danger .alert-link{color:#843534}.progress{display:block;width:100%;height:1rem;margin-bottom:1rem}.progress[value]{background-color:#eee;border:0;appearance:none;border-radius:.25rem}.progress[value]::-ms-fill{background-color:#0074d9;border:0}.progress[value]::-moz-progress-bar{background-color:#0074d9;border-bottom-left-radius:.25rem;border-top-left-radius:.25rem}.progress[value]::-webkit-progress-value{background-color:#0074d9;border-bottom-left-radius:.25rem;border-top-left-radius:.25rem}.progress[value=\"100\"]::-moz-progress-bar{border-bottom-right-radius:.25rem;border-top-right-radius:.25rem}.progress[value=\"100\"]::-webkit-progress-value{border-bottom-right-radius:.25rem;border-top-right-radius:.25rem}.progress[value]::-webkit-progress-bar{background-color:#eee;border-radius:.25rem}.progress[value],base::-moz-progress-bar{background-color:#eee;border-radius:.25rem}@media screen and (min-width:0\\0){.progress{background-color:#eee;border-radius:.25rem}.progress-bar{display:inline-block;height:1rem;text-indent:-999rem;background-color:#0074d9;border-bottom-left-radius:.25rem;border-top-left-radius:.25rem}.progress[width=\"100%\"]{border-bottom-right-radius:.25rem;border-top-right-radius:.25rem}}.progress-striped[value]::-webkit-progress-value{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-striped[value]::-moz-progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-striped[value]::-ms-fill{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}@media screen and (min-width:0\\0){.progress-bar-striped{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}}.progress-animated[value]::-webkit-progress-value{animation:progress-bar-stripes 2s linear infinite}.progress-animated[value]::-moz-progress-bar{animation:progress-bar-stripes 2s linear infinite}@media screen and (min-width:0\\0){.progress-animated .progress-bar-striped{animation:progress-bar-stripes 2s linear infinite}}.progress-success[value]::-webkit-progress-value{background-color:#5cb85c}.progress-success[value]::-moz-progress-bar{background-color:#5cb85c}.progress-success[value]::-ms-fill{background-color:#5cb85c}@media screen and (min-width:0\\0){.progress-success .progress-bar{background-color:#5cb85c}}.progress-info[value]::-webkit-progress-value{background-color:#5bc0de}.progress-info[value]::-moz-progress-bar{background-color:#5bc0de}.progress-info[value]::-ms-fill{background-color:#5bc0de}@media screen and (min-width:0\\0){.progress-info .progress-bar{background-color:#5bc0de}}.progress-warning[value]::-webkit-progress-value{background-color:#f0ad4e}.progress-warning[value]::-moz-progress-bar{background-color:#f0ad4e}.progress-warning[value]::-ms-fill{background-color:#f0ad4e}@media screen and (min-width:0\\0){.progress-warning .progress-bar{background-color:#f0ad4e}}.progress-danger[value]::-webkit-progress-value{background-color:#d9534f}.progress-danger[value]::-moz-progress-bar{background-color:#d9534f}.progress-danger[value]::-ms-fill{background-color:#d9534f}@media screen and (min-width:0\\0){.progress-danger .progress-bar{background-color:#d9534f}}.media,.media-body{overflow:hidden}.media-body{width:10000px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right{padding-left:10px}.media-left{padding-right:10px}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:0}.list-group-item{position:relative;display:block;padding:.75rem 1.25rem;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:.25rem;border-top-left-radius:.25rem}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#818a91;cursor:not-allowed;background-color:#eceeef}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#818a91}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;text-decoration:none;background-color:#0275d8;border-color:#0275d8}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#a8d6fe}.list-group-flush .list-group-item{border-radius:0}.list-group-item-action{width:100%;color:#555;text-align:inherit}.list-group-item-action .list-group-item-heading{color:#333}.list-group-item-action:focus,.list-group-item-action:hover{color:#555;text-decoration:none;background-color:#f5f5f5}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9{padding-bottom:42.85714%}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.embed-responsive-1by1{padding-bottom:100%}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;outline:0;-webkit-overflow-scrolling:touch}.modal.fade .modal-dialog{transition:transform .3s ease-out;transform:translateY(-25%)}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.in{opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after{content:\"\";display:table;clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.5}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after{content:\"\";display:table;clear:both}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:544px){.modal-dialog{max-width:600px;margin:30px auto}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg{max-width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.in{opacity:.9}.tooltip.bs-tether-element-attached-bottom,.tooltip.tooltip-top{padding:5px 0;margin-top:-3px}.tooltip.bs-tether-element-attached-bottom .tooltip-arrow,.tooltip.tooltip-top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.bs-tether-element-attached-left,.tooltip.tooltip-right{padding:0 5px;margin-left:3px}.tooltip.bs-tether-element-attached-left .tooltip-arrow,.tooltip.tooltip-right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.bs-tether-element-attached-top,.tooltip.tooltip-bottom{padding:5px 0;margin-top:3px}.tooltip.bs-tether-element-attached-top .tooltip-arrow,.tooltip.tooltip-bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bs-tether-element-attached-right,.tooltip.tooltip-left{padding:0 5px;margin-left:-3px}.tooltip.bs-tether-element-attached-right .tooltip-arrow,.tooltip.tooltip-left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;padding:1px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover.bs-tether-element-attached-bottom,.popover.popover-top{margin-top:-10px}.popover.bs-tether-element-attached-bottom .popover-arrow,.popover.popover-top .popover-arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.bs-tether-element-attached-bottom .popover-arrow:after,.popover.popover-top .popover-arrow:after{bottom:1px;margin-left:-10px;content:\"\";border-top-color:#fff;border-bottom-width:0}.popover.bs-tether-element-attached-left,.popover.popover-right{margin-left:10px}.popover.bs-tether-element-attached-left .popover-arrow,.popover.popover-right .popover-arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.bs-tether-element-attached-left .popover-arrow:after,.popover.popover-right .popover-arrow:after{bottom:-10px;left:1px;content:\"\";border-right-color:#fff;border-left-width:0}.popover.bs-tether-element-attached-top,.popover.popover-bottom{margin-top:10px}.popover.bs-tether-element-attached-top .popover-arrow,.popover.popover-bottom .popover-arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:rgba(0,0,0,.25)}.popover.bs-tether-element-attached-top .popover-arrow:after,.popover.popover-bottom .popover-arrow:after{top:1px;margin-left:-10px;content:\"\";border-top-width:0;border-bottom-color:#fff}.popover.bs-tether-element-attached-right,.popover.popover-left{margin-left:-10px}.popover.bs-tether-element-attached-right .popover-arrow,.popover.popover-left .popover-arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:rgba(0,0,0,.25)}.popover.bs-tether-element-attached-right .popover-arrow:after,.popover.popover-left .popover-arrow:after{right:1px;bottom:-10px;content:\"\";border-right-width:0;border-left-color:#fff}.popover-title{padding:8px 14px;margin:0;font-size:1rem;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:.2375rem .2375rem 0 0}.popover-title:empty{display:none}.popover-content{padding:9px 14px}.popover-arrow,.popover-arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover-arrow{border-width:11px}.popover-arrow:after{content:\"\";border-width:10px}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.carousel-item{position:relative;display:none;transition:left .6s ease-in-out}.carousel-inner>.carousel-item>a>img,.carousel-inner>.carousel-item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.carousel-item{transition:transform .6s ease-in-out;backface-visibility:hidden;perspective:1000px}.carousel-inner>.carousel-item.active.right,.carousel-inner>.carousel-item.next{left:0;transform:translate3d(100%,0,0)}.carousel-inner>.carousel-item.active.left,.carousel-inner>.carousel-item.prev{left:0;transform:translate3d(-100%,0,0)}.carousel-inner>.carousel-item.active,.carousel-inner>.carousel-item.next.left,.carousel-inner>.carousel-item.prev.right{left:0;transform:translateZ(0)}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);opacity:.5}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{right:0;left:auto;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;width:20px;height:20px;margin-top:-10px;font-family:serif;line-height:1}.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media (min-width:544px){.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-15px;font-size:30px}.carousel-control .icon-prev{margin-left:-15px}.carousel-control .icon-next{margin-right:-15px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.bg-faded{background-color:#f7f7f9}.bg-primary{color:#fff!important;background-color:#0275d8!important}a.bg-primary:focus,a.bg-primary:hover{background-color:#025aa5!important}.bg-success{color:#fff!important;background-color:#5cb85c!important}a.bg-success:focus,a.bg-success:hover{background-color:#449d44!important}.bg-info{color:#fff!important;background-color:#5bc0de!important}a.bg-info:focus,a.bg-info:hover{background-color:#31b0d5!important}.bg-warning{color:#fff!important;background-color:#f0ad4e!important}a.bg-warning:focus,a.bg-warning:hover{background-color:#ec971f!important}.bg-danger{color:#fff!important;background-color:#d9534f!important}a.bg-danger:focus,a.bg-danger:hover{background-color:#c9302c!important}.bg-inverse{color:#fff!important;background-color:#373a3c!important}a.bg-inverse:focus,a.bg-inverse:hover{background-color:#1f2021!important}.clearfix:after{content:\"\";display:table;clear:both}.d-block{display:block!important}.d-inline-block{display:inline-block!important}.d-inline{display:inline!important}.pull-xs-left{float:left!important}.pull-xs-right{float:right!important}.pull-xs-none{float:none!important}@media (min-width:544px){.pull-sm-left{float:left!important}.pull-sm-right{float:right!important}.pull-sm-none{float:none!important}}@media (min-width:768px){.pull-md-left{float:left!important}.pull-md-right{float:right!important}.pull-md-none{float:none!important}}@media (min-width:992px){.pull-lg-left{float:left!important}.pull-lg-right{float:right!important}.pull-lg-none{float:none!important}}@media (min-width:1200px){.pull-xl-left{float:left!important}.pull-xl-right{float:right!important}.pull-xl-none{float:none!important}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.w-100{width:100%!important}.m-x-auto{margin-right:auto!important;margin-left:auto!important}.m-a-0{margin:0!important}.m-t-0{margin-top:0!important}.m-r-0{margin-right:0!important}.m-b-0{margin-bottom:0!important}.m-l-0,.m-x-0{margin-left:0!important}.m-x-0{margin-right:0!important}.m-y-0{margin-top:0!important;margin-bottom:0!important}.m-a-1{margin:1rem!important}.m-t-1{margin-top:1rem!important}.m-r-1{margin-right:1rem!important}.m-b-1{margin-bottom:1rem!important}.m-l-1,.m-x-1{margin-left:1rem!important}.m-x-1{margin-right:1rem!important}.m-y-1{margin-top:1rem!important;margin-bottom:1rem!important}.m-a-2{margin:1.5rem!important}.m-t-2{margin-top:1.5rem!important}.m-r-2{margin-right:1.5rem!important}.m-b-2{margin-bottom:1.5rem!important}.m-l-2,.m-x-2{margin-left:1.5rem!important}.m-x-2{margin-right:1.5rem!important}.m-y-2{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.m-a-3{margin:3rem!important}.m-t-3{margin-top:3rem!important}.m-r-3{margin-right:3rem!important}.m-b-3{margin-bottom:3rem!important}.m-l-3,.m-x-3{margin-left:3rem!important}.m-x-3{margin-right:3rem!important}.m-y-3{margin-top:3rem!important;margin-bottom:3rem!important}.p-a-0{padding:0!important}.p-t-0{padding-top:0!important}.p-r-0{padding-right:0!important}.p-b-0{padding-bottom:0!important}.p-l-0,.p-x-0{padding-left:0!important}.p-x-0{padding-right:0!important}.p-y-0{padding-top:0!important;padding-bottom:0!important}.p-a-1{padding:1rem!important}.p-t-1{padding-top:1rem!important}.p-r-1{padding-right:1rem!important}.p-b-1{padding-bottom:1rem!important}.p-l-1,.p-x-1{padding-left:1rem!important}.p-x-1{padding-right:1rem!important}.p-y-1{padding-top:1rem!important;padding-bottom:1rem!important}.p-a-2{padding:1.5rem!important}.p-t-2{padding-top:1.5rem!important}.p-r-2{padding-right:1.5rem!important}.p-b-2{padding-bottom:1.5rem!important}.p-l-2,.p-x-2{padding-left:1.5rem!important}.p-x-2{padding-right:1.5rem!important}.p-y-2{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.p-a-3{padding:3rem!important}.p-t-3{padding-top:3rem!important}.p-r-3{padding-right:3rem!important}.p-b-3{padding-bottom:3rem!important}.p-l-3,.p-x-3{padding-left:3rem!important}.p-x-3{padding-right:3rem!important}.p-y-3{padding-top:3rem!important;padding-bottom:3rem!important}.pos-f-t{position:fixed;top:0;right:0;left:0;z-index:1030}.text-justify{text-align:justify!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-xs-left{text-align:left!important}.text-xs-right{text-align:right!important}.text-xs-center{text-align:center!important}@media (min-width:544px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-normal{font-weight:400}.font-weight-bold{font-weight:700}.font-italic{font-style:italic}.text-muted{color:#818a91!important}a.text-muted:focus,a.text-muted:hover{color:#687077!important}.text-primary{color:#0275d8!important}a.text-primary:focus,a.text-primary:hover{color:#025aa5!important}.text-success{color:#5cb85c!important}a.text-success:focus,a.text-success:hover{color:#449d44!important}.text-info{color:#5bc0de!important}a.text-info:focus,a.text-info:hover{color:#31b0d5!important}.text-warning{color:#f0ad4e!important}a.text-warning:focus,a.text-warning:hover{color:#ec971f!important}.text-danger{color:#d9534f!important}a.text-danger:focus,a.text-danger:hover{color:#c9302c!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.invisible{visibility:hidden!important}.hidden-xs-up{display:none!important}@media (max-width:543px){.hidden-xs-down{display:none!important}}@media (min-width:544px){.hidden-sm-up{display:none!important}}@media (max-width:767px){.hidden-sm-down{display:none!important}}@media (min-width:768px){.hidden-md-up{display:none!important}}@media (max-width:991px){.hidden-md-down{display:none!important}}@media (min-width:992px){.hidden-lg-up{display:none!important}}@media (max-width:1199px){.hidden-lg-down{display:none!important}}@media (min-width:1200px){.hidden-xl-up{display:none!important}}.hidden-xl-down,.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}.btn{display:inline-block;font-weight:400;line-height:1.25;text-align:center;white-space:nowrap;vertical-align:middle;cursor:pointer;user-select:none;border:1px solid transparent;padding:.5rem 1rem;font-size:1rem;border-radius:.25rem}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0}.btn.disabled,.btn:disabled{cursor:not-allowed;opacity:.65}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#0275d8;border-color:#0275d8}.btn-primary.focus,.btn-primary:focus,.btn-primary:hover{color:#fff;background-color:#025aa5;border-color:#01549b}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle{color:#fff;background-color:#025aa5;border-color:#01549b;background-image:none}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover{color:#fff;background-color:#014682;border-color:#01315a}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary:disabled.focus,.btn-primary:disabled:focus,.btn-primary:disabled:hover{background-color:#0275d8;border-color:#0275d8}.btn-secondary{color:#373a3c;background-color:#fff;border-color:#ccc}.btn-secondary.focus,.btn-secondary:focus,.btn-secondary:hover{color:#373a3c;background-color:#e6e6e6;border-color:#adadad}.btn-secondary.active,.btn-secondary:active,.open>.btn-secondary.dropdown-toggle{color:#373a3c;background-color:#e6e6e6;border-color:#adadad;background-image:none}.btn-secondary.active.focus,.btn-secondary.active:focus,.btn-secondary.active:hover,.btn-secondary:active.focus,.btn-secondary:active:focus,.btn-secondary:active:hover,.open>.btn-secondary.dropdown-toggle.focus,.open>.btn-secondary.dropdown-toggle:focus,.open>.btn-secondary.dropdown-toggle:hover{color:#373a3c;background-color:#d4d4d4;border-color:#8c8c8c}.btn-secondary.disabled.focus,.btn-secondary.disabled:focus,.btn-secondary.disabled:hover,.btn-secondary:disabled.focus,.btn-secondary:disabled:focus,.btn-secondary:disabled:hover{background-color:#fff;border-color:#ccc}.btn-info{color:#fff;background-color:#5bc0de;border-color:#5bc0de}.btn-info.focus,.btn-info:focus,.btn-info:hover{color:#fff;background-color:#31b0d5;border-color:#2aabd2}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;border-color:#2aabd2;background-image:none}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1f7e9a}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info:disabled.focus,.btn-info:disabled:focus,.btn-info:disabled:hover{background-color:#5bc0de;border-color:#5bc0de}.btn-success{color:#fff;background-color:#5cb85c;border-color:#5cb85c}.btn-success.focus,.btn-success:focus,.btn-success:hover{color:#fff;background-color:#449d44;border-color:#419641}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;border-color:#419641;background-image:none}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#2d672d}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success:disabled.focus,.btn-success:disabled:focus,.btn-success:disabled:hover{background-color:#5cb85c;border-color:#5cb85c}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#f0ad4e}.btn-warning.focus,.btn-warning:focus,.btn-warning:hover{color:#fff;background-color:#ec971f;border-color:#eb9316}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#ec971f;border-color:#eb9316;background-image:none}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#b06d0f}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning:disabled.focus,.btn-warning:disabled:focus,.btn-warning:disabled:hover{background-color:#f0ad4e;border-color:#f0ad4e}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d9534f}.btn-danger.focus,.btn-danger:focus,.btn-danger:hover{color:#fff;background-color:#c9302c;border-color:#c12e2a}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#c9302c;border-color:#c12e2a;background-image:none}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#8b211e}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger:disabled.focus,.btn-danger:disabled:focus,.btn-danger:disabled:hover{background-color:#d9534f;border-color:#d9534f}.btn-outline-primary{color:#0275d8;background-image:none;background-color:transparent;border-color:#0275d8}.btn-outline-primary.active,.btn-outline-primary.focus,.btn-outline-primary:active,.btn-outline-primary:focus,.btn-outline-primary:hover,.open>.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#0275d8;border-color:#0275d8}.btn-outline-primary.active.focus,.btn-outline-primary.active:focus,.btn-outline-primary.active:hover,.btn-outline-primary:active.focus,.btn-outline-primary:active:focus,.btn-outline-primary:active:hover,.open>.btn-outline-primary.dropdown-toggle.focus,.open>.btn-outline-primary.dropdown-toggle:focus,.open>.btn-outline-primary.dropdown-toggle:hover{color:#fff;background-color:#014682;border-color:#01315a}.btn-outline-primary.disabled.focus,.btn-outline-primary.disabled:focus,.btn-outline-primary.disabled:hover,.btn-outline-primary:disabled.focus,.btn-outline-primary:disabled:focus,.btn-outline-primary:disabled:hover{border-color:#43a7fd}.btn-outline-secondary{color:#ccc;background-image:none;background-color:transparent;border-color:#ccc}.btn-outline-secondary.active,.btn-outline-secondary.focus,.btn-outline-secondary:active,.btn-outline-secondary:focus,.btn-outline-secondary:hover,.open>.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#ccc;border-color:#ccc}.btn-outline-secondary.active.focus,.btn-outline-secondary.active:focus,.btn-outline-secondary.active:hover,.btn-outline-secondary:active.focus,.btn-outline-secondary:active:focus,.btn-outline-secondary:active:hover,.open>.btn-outline-secondary.dropdown-toggle.focus,.open>.btn-outline-secondary.dropdown-toggle:focus,.open>.btn-outline-secondary.dropdown-toggle:hover{color:#fff;background-color:#a1a1a1;border-color:#8c8c8c}.btn-outline-secondary.disabled.focus,.btn-outline-secondary.disabled:focus,.btn-outline-secondary.disabled:hover,.btn-outline-secondary:disabled.focus,.btn-outline-secondary:disabled:focus,.btn-outline-secondary:disabled:hover{border-color:#fff}.btn-outline-info{color:#5bc0de;background-image:none;background-color:transparent;border-color:#5bc0de}.btn-outline-info.active,.btn-outline-info.focus,.btn-outline-info:active,.btn-outline-info:focus,.btn-outline-info:hover,.open>.btn-outline-info.dropdown-toggle{color:#fff;background-color:#5bc0de;border-color:#5bc0de}.btn-outline-info.active.focus,.btn-outline-info.active:focus,.btn-outline-info.active:hover,.btn-outline-info:active.focus,.btn-outline-info:active:focus,.btn-outline-info:active:hover,.open>.btn-outline-info.dropdown-toggle.focus,.open>.btn-outline-info.dropdown-toggle:focus,.open>.btn-outline-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1f7e9a}.btn-outline-info.disabled.focus,.btn-outline-info.disabled:focus,.btn-outline-info.disabled:hover,.btn-outline-info:disabled.focus,.btn-outline-info:disabled:focus,.btn-outline-info:disabled:hover{border-color:#b0e1ef}.btn-outline-success{color:#5cb85c;background-image:none;background-color:transparent;border-color:#5cb85c}.btn-outline-success.active,.btn-outline-success.focus,.btn-outline-success:active,.btn-outline-success:focus,.btn-outline-success:hover,.open>.btn-outline-success.dropdown-toggle{color:#fff;background-color:#5cb85c;border-color:#5cb85c}.btn-outline-success.active.focus,.btn-outline-success.active:focus,.btn-outline-success.active:hover,.btn-outline-success:active.focus,.btn-outline-success:active:focus,.btn-outline-success:active:hover,.open>.btn-outline-success.dropdown-toggle.focus,.open>.btn-outline-success.dropdown-toggle:focus,.open>.btn-outline-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#2d672d}.btn-outline-success.disabled.focus,.btn-outline-success.disabled:focus,.btn-outline-success.disabled:hover,.btn-outline-success:disabled.focus,.btn-outline-success:disabled:focus,.btn-outline-success:disabled:hover{border-color:#a3d7a3}.btn-outline-warning{color:#f0ad4e;background-image:none;background-color:transparent;border-color:#f0ad4e}.btn-outline-warning.active,.btn-outline-warning.focus,.btn-outline-warning:active,.btn-outline-warning:focus,.btn-outline-warning:hover,.open>.btn-outline-warning.dropdown-toggle{color:#fff;background-color:#f0ad4e;border-color:#f0ad4e}.btn-outline-warning.active.focus,.btn-outline-warning.active:focus,.btn-outline-warning.active:hover,.btn-outline-warning:active.focus,.btn-outline-warning:active:focus,.btn-outline-warning:active:hover,.open>.btn-outline-warning.dropdown-toggle.focus,.open>.btn-outline-warning.dropdown-toggle:focus,.open>.btn-outline-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#b06d0f}.btn-outline-warning.disabled.focus,.btn-outline-warning.disabled:focus,.btn-outline-warning.disabled:hover,.btn-outline-warning:disabled.focus,.btn-outline-warning:disabled:focus,.btn-outline-warning:disabled:hover{border-color:#f8d9ac}.btn-outline-danger{color:#d9534f;background-image:none;background-color:transparent;border-color:#d9534f}.btn-outline-danger.active,.btn-outline-danger.focus,.btn-outline-danger:active,.btn-outline-danger:focus,.btn-outline-danger:hover,.open>.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#d9534f;border-color:#d9534f}.btn-outline-danger.active.focus,.btn-outline-danger.active:focus,.btn-outline-danger.active:hover,.btn-outline-danger:active.focus,.btn-outline-danger:active:focus,.btn-outline-danger:active:hover,.open>.btn-outline-danger.dropdown-toggle.focus,.open>.btn-outline-danger.dropdown-toggle:focus,.open>.btn-outline-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#8b211e}.btn-outline-danger.disabled.focus,.btn-outline-danger.disabled:focus,.btn-outline-danger.disabled:hover,.btn-outline-danger:disabled.focus,.btn-outline-danger:disabled:focus,.btn-outline-danger:disabled:hover{border-color:#eba5a3}.btn-link{font-weight:400;color:#0275d8;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link:disabled{background-color:transparent}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#014c8c;text-decoration:underline;background-color:transparent}.btn-link:disabled:focus,.btn-link:disabled:hover{color:#818a91;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:.75rem 1.5rem;font-size:1.25rem;border-radius:.3rem}.btn-group-sm>.btn,.btn-sm{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:.5rem}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}/*!\n * ui-select\n * http://github.com/angular-ui/ui-select\n * Version: 0.19.8 - 2017-04-18T05:43:43.881Z\n * License: MIT\n */.ui-select-highlight{font-weight:700}.ui-select-offscreen{clip:rect(0 0 0 0)!important;width:1px!important;height:1px!important;border:0!important;margin:0!important;padding:0!important;overflow:hidden!important;position:absolute!important;outline:0!important;left:0!important;top:0!important}.ui-select-choices-row:hover{background-color:#f5f5f5}.ng-dirty.ng-invalid>a.select2-choice{border-color:#d44950}.select2-result-single{padding-left:0}.select2-locked>.select2-search-choice-close,.select-locked>.ui-select-match-close{display:none}body>.select2-container.open{z-index:9999}.ui-select-container.select2.direction-up .ui-select-match,.ui-select-container[theme=select2].direction-up .ui-select-match{border-radius:4px;border-top-left-radius:0;border-top-right-radius:0}.ui-select-container.select2.direction-up .ui-select-dropdown,.ui-select-container[theme=select2].direction-up .ui-select-dropdown{border-radius:4px;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-width:1px;border-top-style:solid;box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-4px}.ui-select-container.select2.direction-up .ui-select-dropdown .select2-search,.ui-select-container[theme=select2].direction-up .ui-select-dropdown .select2-search{margin-top:4px}.ui-select-container.select2.direction-up.select2-dropdown-open .ui-select-match,.ui-select-container[theme=select2].direction-up.select2-dropdown-open .ui-select-match{border-bottom-color:#5897fb}.ui-select-container[theme=select2] .ui-select-dropdown .ui-select-search-hidden,.ui-select-container[theme=select2] .ui-select-dropdown .ui-select-search-hidden input{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0}.selectize-input.selectize-focus{border-color:#007fbb!important}.selectize-control.single>.selectize-input>input{width:100%}.selectize-control.multi>.selectize-input>input{margin:0!important}.selectize-control>.selectize-dropdown{width:100%}.ng-dirty.ng-invalid>div.selectize-input{border-color:#d44950}.ui-select-container[theme=selectize].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-2px}.ui-select-container[theme=selectize] input.ui-select-search-hidden{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0;width:0}.btn-default-focus{color:#333;background-color:#ebebeb;border-color:#adadad;text-decoration:none;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.ui-select-bootstrap .ui-select-toggle{position:relative}.ui-select-bootstrap .ui-select-toggle>.caret{position:absolute;height:10px;top:50%;right:10px;margin-top:-2px}.input-group>.ui-select-bootstrap.dropdown{position:static}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control{border-radius:4px;border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control.direction-up{border-radius:4px!important;border-top-right-radius:0!important;border-bottom-right-radius:0!important}.ui-select-bootstrap .ui-select-search-hidden{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0}.ui-select-bootstrap>.ui-select-match>.btn{text-align:left!important}.ui-select-bootstrap>.ui-select-match>.caret{position:absolute;top:45%;right:15px}.ui-select-bootstrap>.ui-select-choices,.ui-select-bootstrap>.ui-select-no-choice{width:100%;height:auto;max-height:200px;overflow-x:hidden;margin-top:-1px}body>.ui-select-bootstrap.open{z-index:1000}.ui-select-multiple.ui-select-bootstrap{height:auto;padding:3px 3px 0}.ui-select-multiple.ui-select-bootstrap input.ui-select-search{background-color:transparent!important;border:none;outline:none;height:1.666666em;margin-bottom:3px}.ui-select-multiple.ui-select-bootstrap .ui-select-match .close{font-size:1.6em;line-height:.75}.ui-select-multiple.ui-select-bootstrap .ui-select-match-item{outline:0;margin:0 3px 3px 0}.ui-select-multiple .ui-select-match-item{position:relative}.ui-select-multiple .ui-select-match-item.dropping .ui-select-match-close{pointer-events:none}.ui-select-multiple:hover .ui-select-match-item.dropping-before:before{content:\"\";position:absolute;top:0;right:100%;height:100%;margin-right:2px;border-left:1px solid #428bca}.ui-select-multiple:hover .ui-select-match-item.dropping-after:after{content:\"\";position:absolute;top:0;left:100%;height:100%;margin-left:2px;border-right:1px solid #428bca}.ui-select-bootstrap .ui-select-choices-row>span{cursor:pointer;display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.ui-select-bootstrap .ui-select-choices-row>span:focus,.ui-select-bootstrap .ui-select-choices-row>span:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.ui-select-bootstrap .ui-select-choices-row.active>span{color:#fff;text-decoration:none;outline:0;background-color:#428bca}.ui-select-bootstrap .ui-select-choices-row.active.disabled>span,.ui-select-bootstrap .ui-select-choices-row.disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.ui-select-match.ng-hide-add,.ui-select-search.ng-hide-add{display:none!important}.ui-select-bootstrap.ng-dirty.ng-invalid>button.btn.ui-select-match{border-color:#d44950}.ui-select-container[theme=bootstrap].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25)}.ui-select-bootstrap .ui-select-match-text{width:100%;padding-right:1em}.ui-select-bootstrap .ui-select-match-text span{display:inline-block;width:100%;overflow:hidden}.ui-select-bootstrap .ui-select-toggle>a.btn{position:absolute;height:10px;right:10px;margin-top:-2px}.ui-select-refreshing.glyphicon{position:absolute;right:0;padding:8px 27px}@keyframes ui-select-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.ui-select-spin{animation:ui-select-spin 2s infinite linear}.ui-select-refreshing.ng-animate{-webkit-animation:none 0s}.b-r-#fff{border-right-color:#fff}/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}.ui-grid,.ui-grid-cell,.ui-grid-footer-panel,.ui-grid-header,.ui-grid-header-cell,input[type=text].ui-grid-filter-input{border-color:hsla(210,4%,55%,.15)}.card .ui-grid{border-width:0;border-top-width:1px}.ui-grid-row:nth-child(2n) .ui-grid-cell{background-color:rgba(0,0,0,.025);border-bottom:1px solid hsla(210,4%,55%,.15);border-top:1px solid hsla(210,4%,55%,.15)}.ui-grid-row:nth-child(odd) .ui-grid-cell{background-color:transparent}.ui-grid-header-cell:not(:last-child) .ui-grid-vertical-bar{background-color:rgba(0,0,0,.025)}.ui-grid-footer-panel,.ui-grid-top-panel,input[type=text].ui-grid-filter-input{background:transparent}.ui-grid-cell,.ui-grid-row{min-height:36px}.ui-grid-cell-contents{padding:8px 15px}.ui-grid-column-menu-button{top:5px}.ui-grid-canvas,.ui-grid-header-canvas{width:100%!important}.ui-grid-menu .ui-grid-menu-inner{color:#333}/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\n\nCopyright (c) 2015 Daniel Eden\n*/.animated{animation-duration:1s;animation-fill-mode:both}.animated.infinite{animation-iteration-count:infinite}.animated.hinge{animation-duration:2s}.animated.bounceIn,.animated.bounceOut,.animated.flipOutX,.animated.flipOutY{animation-duration:.75s}@keyframes bounce{0%,20%,53%,80%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1);transform:translateZ(0)}40%,43%{transition-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-30px,0)}70%{transition-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-15px,0)}90%{transform:translate3d(0,-4px,0)}}.bounce{animation-name:bounce;transform-origin:center bottom}@keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.flash{animation-name:flash}@keyframes pulse{0%{transform:scaleX(1)}50%{transform:scale3d(1.05,1.05,1.05)}to{transform:scaleX(1)}}.pulse{animation-name:pulse}@keyframes rubberBand{0%{transform:scaleX(1)}30%{transform:scale3d(1.25,.75,1)}40%{transform:scale3d(.75,1.25,1)}50%{transform:scale3d(1.15,.85,1)}65%{transform:scale3d(.95,1.05,1)}75%{transform:scale3d(1.05,.95,1)}to{transform:scaleX(1)}}.rubberBand{animation-name:rubberBand}@keyframes shake{0%,to{transform:translateZ(0)}10%,30%,50%,70%,90%{transform:translate3d(-10px,0,0)}20%,40%,60%,80%{transform:translate3d(10px,0,0)}}.shake{animation-name:shake}@keyframes swing{20%{transform:rotate(15deg)}40%{transform:rotate(-10deg)}60%{transform:rotate(5deg)}80%{transform:rotate(-5deg)}to{transform:rotate(0deg)}}.swing{transform-origin:top center;animation-name:swing}@keyframes tada{0%{transform:scaleX(1)}10%,20%{transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{transform:scaleX(1)}}.tada{animation-name:tada}@keyframes wobble{0%{transform:none}15%{transform:translate3d(-25%,0,0) rotate(-5deg)}30%{transform:translate3d(20%,0,0) rotate(3deg)}45%{transform:translate3d(-15%,0,0) rotate(-3deg)}60%{transform:translate3d(10%,0,0) rotate(2deg)}75%{transform:translate3d(-5%,0,0) rotate(-1deg)}to{transform:none}}.wobble{animation-name:wobble}@keyframes bounceIn{0%,20%,40%,60%,80%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:scale3d(.3,.3,.3)}20%{transform:scale3d(1.1,1.1,1.1)}40%{transform:scale3d(.9,.9,.9)}60%{opacity:1;transform:scale3d(1.03,1.03,1.03)}80%{transform:scale3d(.97,.97,.97)}to{opacity:1;transform:scaleX(1)}}.bounceIn{animation-name:bounceIn}@keyframes bounceInDown{0%,60%,75%,90%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}.bounceInDown{animation-name:bounceInDown}@keyframes bounceInLeft{0%,60%,75%,90%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}.bounceInLeft{animation-name:bounceInLeft}@keyframes bounceInRight{0%,60%,75%,90%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}.bounceInRight{animation-name:bounceInRight}@keyframes bounceInUp{0%,60%,75%,90%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}.bounceInUp{animation-name:bounceInUp}@keyframes bounceOut{20%{transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;transform:scale3d(1.1,1.1,1.1)}to{opacity:0;transform:scale3d(.3,.3,.3)}}.bounceOut{animation-name:bounceOut}@keyframes bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.bounceOutDown{animation-name:bounceOutDown}@keyframes bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}to{opacity:0;transform:translate3d(-2000px,0,0)}}.bounceOutLeft{animation-name:bounceOutLeft}@keyframes bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}to{opacity:0;transform:translate3d(2000px,0,0)}}.bounceOutRight{animation-name:bounceOutRight}@keyframes bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}.bounceOutUp{animation-name:bounceOutUp}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{animation-name:fadeIn}@keyframes fadeInDown{0%{opacity:0;transform:translate3d(0,-100%,0)}to{opacity:1;transform:none}}.fadeInDown{animation-name:fadeInDown}@keyframes fadeInDownBig{0%{opacity:0;transform:translate3d(0,-2000px,0)}to{opacity:1;transform:none}}.fadeInDownBig{animation-name:fadeInDownBig}@keyframes fadeInLeft{0%{opacity:0;transform:translate3d(-100%,0,0)}to{opacity:1;transform:none}}.fadeInLeft{animation-name:fadeInLeft}@keyframes fadeInLeftBig{0%{opacity:0;transform:translate3d(-2000px,0,0)}to{opacity:1;transform:none}}.fadeInLeftBig{animation-name:fadeInLeftBig}@keyframes fadeInRight{0%{opacity:0;transform:translate3d(100%,0,0)}to{opacity:1;transform:none}}.fadeInRight{animation-name:fadeInRight}@keyframes fadeInRightBig{0%{opacity:0;transform:translate3d(2000px,0,0)}to{opacity:1;transform:none}}.fadeInRightBig{animation-name:fadeInRightBig}@keyframes fadeInUp{0%{opacity:0;transform:translate3d(0,100%,0)}to{opacity:1;transform:none}}.fadeInUp{animation-name:fadeInUp}@keyframes fadeInUpBig{0%{opacity:0;transform:translate3d(0,2000px,0)}to{opacity:1;transform:none}}.fadeInUpBig{animation-name:fadeInUpBig}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{animation-name:fadeOut}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;transform:translate3d(0,100%,0)}}.fadeOutDown{animation-name:fadeOutDown}@keyframes fadeOutDownBig{0%{opacity:1}to{opacity:0;transform:translate3d(0,2000px,0)}}.fadeOutDownBig{animation-name:fadeOutDownBig}@keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;transform:translate3d(-100%,0,0)}}.fadeOutLeft{animation-name:fadeOutLeft}@keyframes fadeOutLeftBig{0%{opacity:1}to{opacity:0;transform:translate3d(-2000px,0,0)}}.fadeOutLeftBig{animation-name:fadeOutLeftBig}@keyframes fadeOutRight{0%{opacity:1}to{opacity:0;transform:translate3d(100%,0,0)}}.fadeOutRight{animation-name:fadeOutRight}@keyframes fadeOutRightBig{0%{opacity:1}to{opacity:0;transform:translate3d(2000px,0,0)}}.fadeOutRightBig{animation-name:fadeOutRightBig}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;transform:translate3d(0,-100%,0)}}.fadeOutUp{animation-name:fadeOutUp}@keyframes fadeOutUpBig{0%{opacity:1}to{opacity:0;transform:translate3d(0,-2000px,0)}}.fadeOutUpBig{animation-name:fadeOutUpBig}@keyframes flip{0%{transform:perspective(400px) rotateY(-1turn);animation-timing-function:ease-out}40%{transform:perspective(400px) translateZ(150px) rotateY(-190deg);animation-timing-function:ease-out}50%{transform:perspective(400px) translateZ(150px) rotateY(-170deg);animation-timing-function:ease-in}80%{transform:perspective(400px) scale3d(.95,.95,.95);animation-timing-function:ease-in}to{transform:perspective(400px);animation-timing-function:ease-in}}.animated.flip{-webkit-backface-visibility:visible;backface-visibility:visible;animation-name:flip}@keyframes flipInX{0%{transform:perspective(400px) rotateX(90deg);transition-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);transition-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}.flipInX{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;animation-name:flipInX}@keyframes flipInY{0%{transform:perspective(400px) rotateY(90deg);transition-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateY(-20deg);transition-timing-function:ease-in}60%{transform:perspective(400px) rotateY(10deg);opacity:1}80%{transform:perspective(400px) rotateY(-5deg)}to{transform:perspective(400px)}}.flipInY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;animation-name:flipInY}@keyframes flipOutX{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateX(-20deg);opacity:1}to{transform:perspective(400px) rotateX(90deg);opacity:0}}.flipOutX{animation-name:flipOutX;-webkit-backface-visibility:visible!important;backface-visibility:visible!important}@keyframes flipOutY{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateY(-15deg);opacity:1}to{transform:perspective(400px) rotateY(90deg);opacity:0}}.flipOutY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;animation-name:flipOutY}@keyframes lightSpeedIn{0%{transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{transform:skewX(20deg);opacity:1}80%{transform:skewX(-5deg);opacity:1}to{transform:none;opacity:1}}.lightSpeedIn{animation-name:lightSpeedIn;animation-timing-function:ease-out}@keyframes lightSpeedOut{0%{opacity:1}to{transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}.lightSpeedOut{animation-name:lightSpeedOut;animation-timing-function:ease-in}@keyframes rotateIn{0%{transform-origin:center;transform:rotate(-200deg);opacity:0}to{transform-origin:center;transform:none;opacity:1}}.rotateIn{animation-name:rotateIn}@keyframes rotateInDownLeft{0%{transform-origin:left bottom;transform:rotate(-45deg);opacity:0}to{transform-origin:left bottom;transform:none;opacity:1}}.rotateInDownLeft{animation-name:rotateInDownLeft}@keyframes rotateInDownRight{0%{transform-origin:right bottom;transform:rotate(45deg);opacity:0}to{transform-origin:right bottom;transform:none;opacity:1}}.rotateInDownRight{animation-name:rotateInDownRight}@keyframes rotateInUpLeft{0%{transform-origin:left bottom;transform:rotate(45deg);opacity:0}to{transform-origin:left bottom;transform:none;opacity:1}}.rotateInUpLeft{animation-name:rotateInUpLeft}@keyframes rotateInUpRight{0%{transform-origin:right bottom;transform:rotate(-90deg);opacity:0}to{transform-origin:right bottom;transform:none;opacity:1}}.rotateInUpRight{animation-name:rotateInUpRight}@keyframes rotateOut{0%{transform-origin:center;opacity:1}to{transform-origin:center;transform:rotate(200deg);opacity:0}}.rotateOut{animation-name:rotateOut}@keyframes rotateOutDownLeft{0%{transform-origin:left bottom;opacity:1}to{transform-origin:left bottom;transform:rotate(45deg);opacity:0}}.rotateOutDownLeft{animation-name:rotateOutDownLeft}@keyframes rotateOutDownRight{0%{transform-origin:right bottom;opacity:1}to{transform-origin:right bottom;transform:rotate(-45deg);opacity:0}}.rotateOutDownRight{animation-name:rotateOutDownRight}@keyframes rotateOutUpLeft{0%{transform-origin:left bottom;opacity:1}to{transform-origin:left bottom;transform:rotate(-45deg);opacity:0}}.rotateOutUpLeft{animation-name:rotateOutUpLeft}@keyframes rotateOutUpRight{0%{transform-origin:right bottom;opacity:1}to{transform-origin:right bottom;transform:rotate(90deg);opacity:0}}.rotateOutUpRight{animation-name:rotateOutUpRight}@keyframes hinge{0%{transform-origin:top left;animation-timing-function:ease-in-out}20%,60%{transform:rotate(80deg);transform-origin:top left;animation-timing-function:ease-in-out}40%,80%{transform:rotate(60deg);transform-origin:top left;animation-timing-function:ease-in-out;opacity:1}to{transform:translate3d(0,700px,0);opacity:0}}.hinge{animation-name:hinge}@keyframes rollIn{0%{opacity:0;transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;transform:none}}.rollIn{animation-name:rollIn}@keyframes rollOut{0%{opacity:1}to{opacity:0;transform:translate3d(100%,0,0) rotate(120deg)}}.rollOut{animation-name:rollOut}@keyframes zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}.zoomIn{animation-name:zoomIn}@keyframes zoomInDown{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInDown{animation-name:zoomInDown}@keyframes zoomInLeft{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInLeft{animation-name:zoomInLeft}@keyframes zoomInRight{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInRight{animation-name:zoomInRight}@keyframes zoomInUp{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInUp{animation-name:zoomInUp}@keyframes zoomOut{0%{opacity:1}50%{opacity:0;transform:scale3d(.3,.3,.3)}to{opacity:0}}.zoomOut{animation-name:zoomOut}@keyframes zoomOutDown{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutDown{animation-name:zoomOutDown}@keyframes zoomOutLeft{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;transform:scale(.1) translate3d(-2000px,0,0);transform-origin:left center}}.zoomOutLeft{animation-name:zoomOutLeft}@keyframes zoomOutRight{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;transform:scale(.1) translate3d(2000px,0,0);transform-origin:right center}}.zoomOutRight{animation-name:zoomOutRight}@keyframes zoomOutUp{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutUp{animation-name:zoomOutUp}@keyframes slideInDown{0%{transform:translate3d(0,-100%,0);visibility:visible}to{transform:translateZ(0)}}.slideInDown{animation-name:slideInDown}@keyframes slideInLeft{0%{transform:translate3d(-100%,0,0);visibility:visible}to{transform:translateZ(0)}}.slideInLeft{animation-name:slideInLeft}@keyframes slideInRight{0%{transform:translate3d(100%,0,0);visibility:visible}to{transform:translateZ(0)}}.slideInRight{animation-name:slideInRight}@keyframes slideInUp{0%{transform:translate3d(0,100%,0);visibility:visible}to{transform:translateZ(0)}}.slideInUp{animation-name:slideInUp}@keyframes slideOutDown{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,100%,0)}}.slideOutDown{animation-name:slideOutDown}@keyframes slideOutLeft{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(-100%,0,0)}}.slideOutLeft{animation-name:slideOutLeft}@keyframes slideOutRight{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(100%,0,0)}}.slideOutRight{animation-name:slideOutRight}@keyframes slideOutUp{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,-100%,0)}}.slideOutUp{animation-name:slideOutUp}html{background-color:#e0e0e0}body{color:rgba(0,0,0,.87);font-size:.875rem;background-color:#f0f0f0;-webkit-font-smoothing:antialiased}:focus{outline:0!important}a{cursor:pointer;outline:0}a,a:focus,a:hover{color:inherit;text-decoration:none}button,pre{color:inherit}pre{background-color:#f8f8f8}blockquote,pre{border-color:hsla(210,8%,51%,.13)}small{font-size:90%}sup{position:relative;top:-1em;font-size:75%}.pull-center{position:absolute;left:50%}.close{font-size:1.3rem}.img-responsive{width:100%;height:auto}.text-center{text-align:center}.text-left{text-align:left}.text-right{text-align:right}.pull-left{float:left}.pull-right{float:right}.center-block{margin:0 auto}@media (max-width:767px){.pull-none-sm{float:none!important}}@media (max-width:543px){.pull-none-xs{float:none!important}}.label{display:inline-block;padding:.25em .5em;font-size:75%;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;font-weight:700;background-color:#b8b8b8;color:#fff;border-radius:.2rem}.label.no-bg{background-color:transparent;color:inherit}.label.up{position:relative;top:-10px;min-width:4px;min-height:4px;display:inline-block}.label-lg{font-size:1.33rem;padding:5px 9px}.label-sm{padding:.15em .35em}.label-xs{padding:.1em .25em}.list-group-item.active>.label,.nav-pills>.active>a>.label{color:rgba(0,0,0,.87)}.btn .label{position:relative;top:-1px}.btn{font-weight:500;outline:0!important}.btn:not([disabled]).active,.btn:not([disabled]):focus,.btn:not([disabled]):hover{box-shadow:inset 0 -10rem 0 hsla(0,0%,62%,.2)}.btn>i.pull-left,.btn>i.pull-right{line-height:1.5}.btn.rounded{padding-left:1.2em;padding-right:1.2em}.btn-md{padding:.4695rem .75rem;font-size:.9rem}.btn-xs{padding:.2195rem .5rem;font-size:.8rem}.btn-outline{border-width:1px;background-color:transparent;box-shadow:none!important}.btn.b-primary:focus,.btn.b-primary:hover,.btn.primary:focus,.btn.primary:hover{color:hsla(0,0%,100%,.87)!important;background-color:#0cc2aa}.btn.accent:focus,.btn.accent:hover,.btn.b-accent:focus,.btn.b-accent:hover{color:hsla(0,0%,100%,.87)!important;background-color:#a88add}.btn.b-warn:focus,.btn.b-warn:hover,.btn.warn:focus,.btn.warn:hover{color:hsla(0,0%,100%,.87)!important;background-color:#fcc100}.btn.b-success:focus,.btn.b-success:hover,.btn.success:focus,.btn.success:hover{color:hsla(0,0%,100%,.87)!important;background-color:#6cc788}.btn.b-info:focus,.btn.b-info:hover,.btn.info:focus,.btn.info:hover{color:hsla(0,0%,100%,.87)!important;background-color:#6887ff}.btn.b-warning:focus,.btn.b-warning:hover,.btn.warning:focus,.btn.warning:hover{color:hsla(0,0%,100%,.87)!important;background-color:#f77a99}.btn.b-danger:focus,.btn.b-danger:hover,.btn.danger:focus,.btn.danger:hover{color:hsla(0,0%,100%,.87)!important;background-color:#f44455}.btn.b-dark:focus,.btn.b-dark:hover,.btn.dark:focus,.btn.dark:hover{color:hsla(0,0%,100%,.87)!important;background-color:#2e3e4e}.btn.b-black:focus,.btn.b-black:hover,.btn.black:focus,.btn.black:hover{color:hsla(0,0%,100%,.87)!important;background-color:#2a2b3c}.btn.b-white:focus,.btn.b-white:hover{color:rgba(0,0,0,.87)!important;background-color:#fff}.btn.b-light:focus,.btn.b-light:hover{color:rgba(0,0,0,.87)!important;background-color:#f8f8f8}.btn-icon{text-align:center;padding:0!important;width:2.375rem;height:2.375rem;line-height:2.375rem;position:relative;overflow:hidden}.btn-icon i{position:absolute;top:0;width:100%;height:100%;display:block;line-height:inherit;border-radius:inherit;transition:all .3s}.btn-icon.btn-xs{width:1.5rem;height:1.5rem;line-height:1.5rem}.btn-group-sm>.btn-icon.btn,.btn-icon.btn-sm{width:1.775rem;height:1.775rem;line-height:1.775rem}.btn-group-lg>.btn-icon.btn,.btn-icon.btn-lg{width:3.167rem;height:3.167rem;line-height:3.167rem}.btn-icon.btn-social i:last-child{top:100%}.btn-icon.btn-social.active i:first-child,.btn-icon.btn-social:focus i:first-child,.btn-icon.btn-social:hover i:first-child{top:-100%}.btn-icon.btn-social.active i:last-child,.btn-icon.btn-social:focus i:last-child,.btn-icon.btn-social:hover i:last-child{top:0;color:#fff}.btn-icon.btn-social-colored i:first-child{color:#fff}.btn.btn-default,.btn.btn-secondary,.btn.white{border-color:hsla(210,8%,51%,.13)}.btn-default{background-color:#fff;color:rgba(0,0,0,.87)}.btn-groups .btn{margin-bottom:.25rem}.btn-fw{min-width:7rem}.card{border-color:hsla(210,8%,51%,.13)}.carousel-control .glyphicon{position:absolute;top:50%;left:50%;z-index:5;display:inline-block;margin-top:-10px;margin-left:-10px}.dropdown-menu{font-size:.875rem;color:rgba(0,0,0,.87);border-radius:3px;border:1px solid rgba(0,0,0,.1);transform-origin:top left}.dropdown-menu>li:not(.dropdown-item)>a{display:block;padding:3px 20px}.dropdown-menu>li:not(.dropdown-item)>a:focus,.dropdown-menu>li:not(.dropdown-item)>a:hover{background-color:rgba(0,0,0,.065)}.dropdown-menu>.divider{height:1px;margin:.5rem 0;overflow:hidden;background-color:hsla(210,8%,51%,.13)}.dropdown-menu .active{background-color:rgba(0,0,0,.065)}.dropdown-menu.pull-left{left:auto!important;right:100%}.dropdown-menu.pull-right{left:auto;right:0;transform-origin:top right}.dropdown-menu.pull-up{top:0}.dropdown-menu.pull-down{top:100%!important;left:0!important}.dropup .dropdown-menu{transform-origin:bottom left}.dropup .dropdown-menu.pull-right{transform-origin:bottom right}.dropdown-menu.datepicker,.dropdown-menu.timepicker{padding:6px;font-size:.8rem}.dropdown-menu.datepicker .btn,.dropdown-menu.timepicker .btn{font-size:.8rem}.dropdown-menu.datepicker .btn.btn-primary,.dropdown-menu.timepicker .btn.btn-primary{background-color:#6887ff;color:#fff}.dropdown-menu.datepicker .btn:not(:hover),.dropdown-menu.timepicker .btn:not(:hover){box-shadow:0 0 1px transparent}.dropdown-item{color:inherit}.dropdown-item:focus,.dropdown-item:hover{color:inherit;background-color:rgba(0,0,0,.065)}.dropdown-divider{background-color:hsla(210,8%,51%,.13)}.dropdown-menu-scale{display:block;opacity:0;transform:scale(.8);transition:all .25s cubic-bezier(.24,.22,.015,1.56);-webkit-backface-visibility:hidden;backface-visibility:hidden;pointer-events:none}.open>.dropdown-menu-scale{opacity:1;transform:scale(1);pointer-events:auto;display:block!important}.dropdown-header{padding:8px 16px}.dropdown-submenu{position:relative}.dropdown-submenu:focus>.dropdown-menu,.dropdown-submenu:hover>.dropdown-menu{display:block}.dropdown-submenu .dropdown-menu{left:100%;top:0;margin-top:-6px;margin-left:-1px}.dropup .dropdown-submenu>.dropdown-menu{top:auto;bottom:0;margin-bottom:-6px}.popover{color:rgba(0,0,0,.87)}@media (max-width:543px){.dropdown-menu.pull-none-xs{left:0}}.form-control{border-color:hsla(210,8%,51%,.2);border-radius:0}.form-control:focus{border-color:hsla(210,8%,51%,.3)}.form-control-label{padding-top:.5rem;padding-bottom:.5rem;margin-bottom:0}.custom-select{border-color:hsla(210,8%,51%,.13)}.form-control::-webkit-input-placeholder{color:inherit;opacity:.3}.form-control::-moz-placeholder{color:inherit;opacity:.3}.form-control:-ms-input-placeholder{color:inherit;opacity:.3}.form-control-spin{position:absolute;z-index:2;right:10px;top:50%;margin-top:-7px}.input-group-addon{border-color:hsla(210,8%,51%,.2)!important;background-color:transparent;color:inherit}.form-group-stack .form-control{margin-top:-1px;position:relative;border-radius:0}.form-group-stack .form-control:active,.form-group-stack .form-control:focus{z-index:1}.form-validation .form-control.ng-dirty.ng-invalid{border-color:#f44455}.form-validation .form-control.ng-dirty.ng-valid,.form-validation .form-control.ng-dirty.ng-valid:focus{border-color:#6cc788}.form-validation .ui-checks .ng-invalid.ng-dirty+i{border-color:#f44455}.form-file{position:relative}.form-file input{position:absolute;width:100%;height:100%;opacity:0}.input-group-sm>.form-control{min-height:1.95rem}.active-checked{opacity:0}input:checked+.active-checked{opacity:1}.list-group{border-radius:3px;background:#fff}.list-group.no-radius .list-group-item{border-radius:0!important}.list-group.no-borders .list-group-item{border:none}.list-group.no-border .list-group-item{border-width:1px 0}.list-group.no-border .list-group-item:first-child{border-top-width:0}.list-group.no-border .list-group-item:last-child{border-bottom-width:0}.list-group.no-bg .list-group-item{background-color:transparent}.list-group-item,.list-group.list-group-gap{background:transparent}.list-group-item{border-color:hsla(210,8%,51%,.065);padding:12px 16px;background-clip:padding-box}.list-group-item.media{margin-top:0}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{color:inherit;background-color:rgba(0,0,0,.065);border-color:hsla(210,8%,51%,.065);border-bottom-color:hsla(210,8%,51%,.065)}.list-group-item.active:focus a,.list-group-item.active:hover a,.list-group-item.active a{color:inherit}.list-group-item:first-child{border-top-color:hsla(210,8%,51%,.13)}.list-group-item:last-child{border-bottom-color:hsla(210,8%,51%,.13)}.list-group-alt .list-group-item.active:nth-child(2n+2),.list-group-alt .list-group-item:nth-child(2n+2){background-color:rgba(0,0,0,.065)}.list-group-lg .list-group-item{padding:16px 24px}.list-group-md .list-group-item{padding-top:16px;padding-bottom:16px}.list-group-sm .list-group-item{padding:10px 12px}.list-group-gap .list-group-item{margin-bottom:5px;border-radius:3px}.list-group-gap .list-group-item:first-child{border-top-color:hsla(210,8%,51%,.065)}.list-group-gap .list-group-item:last-child{border-bottom-color:hsla(210,8%,51%,.065)}a.list-group-item{color:inherit}a.list-group-item.hover,a.list-group-item:focus,a.list-group-item:hover{color:inherit;background-color:rgba(0,0,0,.065)}.modal .left{transform:translate3d(-100%,0,0)}.modal .left,.modal .right{transition:transform .4s cubic-bezier(.25,.8,.25,1)}.modal .right{transform:translate3d(100%,0,0)}.modal .top{transform:translate3d(0,-100%,0)}.modal .bottom,.modal .top{transition:transform .4s cubic-bezier(.25,.8,.25,1)}.modal .bottom{transform:translate3d(0,100%,0)}.modal.in .bottom,.modal.in .left,.modal.in .right,.modal.in .top{transform:translateZ(0)}.modal.inactive{bottom:auto}.modal-open-aside,.modal.inactive{overflow:visible}.modal>.left{left:0;right:auto}.modal>.left,.modal>.right{position:fixed;z-index:1055;top:0;bottom:0}.modal>.right{left:auto;right:0}.modal>.top{top:0;bottom:auto}.modal>.bottom,.modal>.top{position:fixed;z-index:1055;left:0;right:0}.modal>.bottom{top:auto;bottom:0}.modal-content,.modal-footer,.modal-header{border-color:hsla(210,8%,51%,.13)}.aside,.modal-content{color:rgba(0,0,0,.87)}.aside-header,.aside-header .close{color:inherit!important;background-color:transparent!important}.aside-footer,.aside-header{border-color:hsla(210,8%,51%,.13)!important}.aside-title{font-size:1.2rem;margin:.45rem 0}.modal.animate .modal-dialog{transform:translate(0)}.modal.animate .fade-right-big{animation:fadeOutLeftBig .5s}.modal.animate .fade-left-big{animation:fadeOutRightBig .5s}.modal.animate .fade-up-big{animation:fadeOutUpBig .5s}.modal.animate .fade-down-big{animation:fadeOutDownBig .5s}.modal.animate .fade-right{animation:fadeOutLeft .5s}.modal.animate .fade-left{animation:fadeOutRight .5s}.modal.animate .fade-up{animation:fadeOutUp .5s}.modal.animate .fade-down{animation:fadeOutDown .5s}.modal.animate .flip-x{animation:flipOutX .5s}.modal.animate .flip-y{animation:flipOutY .5s}.modal.animate .zoom{animation:zoomOut .5s}.modal.animate .roll{animation:rollOut .5s}.modal.animate .bounce{animation:bounceOut .5s}.modal.animate .rotate{animation:rotateOut .5s}.modal.animate.in .fade-right-big{animation:fadeInRightBig .5s}.modal.animate.in .fade-left-big{animation:fadeInLeftBig .5s}.modal.animate.in .fade-up-big{animation:fadeInUpBig .5s}.modal.animate.in .fade-down-big{animation:fadeInDownBig .5s}.modal.animate.in .fade-right{animation:fadeInRight .5s}.modal.animate.in .fade-left{animation:fadeInLeft .5s}.modal.animate.in .fade-up{animation:fadeInUp .5s}.modal.animate.in .fade-down{animation:fadeInDown .5s}.modal.animate.in .flip-x{animation:flipInX .5s}.modal.animate.in .flip-y{animation:flipInY .5s}.modal.animate.in .zoom{animation:zoomIn .5s}.modal.animate.in .roll{animation:rollIn .5s}.modal.animate.in .bounce{animation:bounceIn .5s}.modal.animate.in .rotate{animation:rotateIn .5s}.nav,.nav-item,.nav-link{border:inherit}.nav-link{position:relative}.nav-md .nav-link{padding:.5rem 1rem}.nav-sm .nav-link{padding:.25rem .75rem}.nav-xs .nav-link{padding:.15rem .5rem;font-size:90%}.nav-rounded .nav-link{border-radius:2rem}.nav-tabs{border-bottom-width:0;position:relative;z-index:1}.nav-tabs .nav-link{background:transparent!important;color:inherit!important}.nav-tabs .nav-link.active,.nav-tabs .nav-link.active:focus,.nav-tabs .nav-link.active:hover,.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:hsla(210,8%,51%,.13);border-bottom-color:transparent}.tab-content.tab-alt .tab-pane{display:block;height:0;overflow:hidden}.tab-content.tab-alt .tab-pane.active{height:auto;overflow:visible}.nav-justified .nav-item{display:table-cell;width:1%;float:none!important;text-align:center}.nav-lists .nav-item{border-bottom:1px solid hsla(210,8%,51%,.13);background-clip:padding-box}.nav-active-border .nav-link:before{content:\"\";position:absolute;transition:all .2s ease-in-out;left:50%;right:50%;bottom:0;border-bottom-width:3px;border-bottom-style:solid;border-bottom-color:transparent}.nav-active-border .nav-link.active:before,.nav-active-border .nav-link:focus:before,.nav-active-border .nav-link:hover:before{left:0;right:0;border-bottom-color:inherit}.nav-active-border.top .nav-link:before{bottom:auto;top:0}.nav-active-border.left .nav-link{float:none}.nav-active-border.left .nav-link:before{border-bottom-width:0;right:auto;border-left-width:3px;border-left-style:solid;border-left-color:transparent;left:0;top:50%;bottom:50%}.nav-active-border.left .nav-link.active:before,.nav-active-border.left .nav-link:focus:before,.nav-active-border.left .nav-link:hover:before{top:0;bottom:0;border-left-color:inherit}.nav-active-border.left.right .nav-link:before{left:auto;right:0}.breadcrumb{background-color:rgba(0,0,0,.065)}.breadcrumb>li+li:before{content:\"/ \"}.navbar{border:none;margin:0;padding:0 1rem;flex-shrink:0;min-height:3.5rem}.navbar .up{margin:0 -.6em}.navbar .avatar{top:-2px}.navbar-item{margin-right:1rem;margin-bottom:0}.navbar-brand,.navbar-item,.navbar-nav>.nav-item>.nav-link,.navbar-nav>.nav-link{padding:0;line-height:3.5rem;white-space:nowrap}.navbar-md{min-height:4rem}.navbar-md .navbar-brand,.navbar-md .navbar-item,.navbar-md .navbar-nav>.nav-item>.nav-link,.navbar-md .navbar-nav>.nav-link{line-height:4rem}.navbar-sm{min-height:3rem}.navbar-sm .navbar-brand,.navbar-sm .navbar-item,.navbar-sm .navbar-nav>.nav-item>.nav-link,.navbar-sm .navbar-nav>.nav-link{line-height:3rem}.navbar-brand{padding:0;font-size:20px;font-weight:700}.navbar-brand:hover{text-decoration:none}.navbar-brand img,.navbar-brand svg{max-height:24px;vertical-align:-4px;display:inline-block}.navbar-brand>span{display:inline-block;line-height:.8;margin-left:10px}.navbar-brand.md img,.navbar-brand.md svg{max-height:32px;vertical-align:-8px}.navbar-brand.lg img,.navbar-brand.lg svg{max-height:48px;vertical-align:-16px}.pull-center .navbar-brand{margin-left:-50%;float:left}.navbar .collapse.in,.navbar .collapsing{clear:left;padding-bottom:1rem}.collapse.in .navbar-nav,.collapsing .navbar-nav{float:none!important}.collapse.in .navbar-nav:not(.navbar-nav-inline) .nav-item,.collapsing .navbar-nav:not(.navbar-nav-inline) .nav-item{float:none;margin:0}.collapse.in .navbar-nav:not(.navbar-nav-inline) .nav-link,.collapsing .navbar-nav:not(.navbar-nav-inline) .nav-link{display:block;line-height:2!important}.collapse.in .navbar-form,.collapsing .navbar-form{margin:0!important;padding:.5rem 0;float:none!important}.collapse.in .nav-active-border,.collapsing .nav-active-border{border-color:transparent}.collapse.in .dropdown-menu-scale,.collapsing .dropdown-menu-scale{display:none}.pager .page-item,.pager>li>a,.pager>li>span,.pagination .page-item,.pagination>li>a,.pagination>li>span{color:inherit!important;background-color:transparent!important;border-color:hsla(210,8%,51%,.13)!important}.pager .page-item:focus,.pager .page-item:hover,.pager>li>a:focus,.pager>li>a:hover,.pager>li>span:focus,.pager>li>span:hover,.pagination .page-item:focus,.pagination .page-item:hover,.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{border-color:hsla(210,8%,51%,.13);background-color:rgba(0,0,0,.065);color:inherit}.pager .page-item.active,.pager>.active>a,.pager>.active>span,.pagination .page-item.active,.pagination>.active>a,.pagination>.active>span{color:#fff!important;background-color:#0cc2aa!important;border-color:#0cc2aa!important}.pagination>li{display:inline;list-style:none}.pagination>li>a{position:relative;float:left;padding:.5rem .75rem;margin-left:-1px;line-height:1.5;color:#0275d8;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li>a:focus,.pagination>li>a:hover{color:#014c8c;background-color:#eceeef;border-color:#ddd}.pager{padding-left:0;margin-top:1rem;margin-bottom:1rem;text-align:center;list-style:none}.pager:after{content:\"\";display:table;clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:rgba(0,0,0,.065);border:1px solid hsla(210,8%,51%,.13);border-radius:500px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:rgba(0,0,0,.065)}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{cursor:inherit;background-color:rgba(0,0,0,.065)}.pager-next>a,.pager-next>span{float:right}.pager-prev>a,.pager-prev>span{float:left}.progress[value]::-webkit-progress-bar{background-color:rgba(0,0,0,.065)}.progress{border-radius:.25rem;overflow:hidden;background-color:rgba(0,0,0,.065)}.progress-bar{display:inline-block;float:left;height:100%;border-radius:.25rem;text-align:center;background-color:#0074d9;font-size:.8em;transition:width .6s ease}.progress-xxs{height:4px}.progress-xs{height:8px}.progress-sm{height:12px;font-size:.8em}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.col-0{clear:left}.row.no-gutter{margin-left:0;margin-right:0}.row.no-gutter [class*=col-]{padding-left:0;padding-right:0}.row{margin-left:-12px;margin-right:-12px}.row [class*=col-]{padding-left:12px;padding-right:12px}.row-sm{margin-left:-8px;margin-right:-8px}.row-sm [class*=col-]{padding-left:8px;padding-right:8px}.row-xs{margin-left:-4px;margin-right:-4px}.row-xs [class*=col-]{padding-left:4px;padding-right:4px}@media (max-width:991px){.row{margin-left:-8px;margin-right:-8px}.row [class*=col-]{padding-left:8px;padding-right:8px}.row-2 [class*=col]{width:50%;float:left}.row-2 .col-0{clear:none}.row-2 li:nth-child(odd){clear:left;margin-left:0}}@media (max-width:767px){.row{margin-left:-4px;margin-right:-4px}.row [class*=col-]{padding-left:4px;padding-right:4px}}.panel .table{border-color:hsla(210,8%,51%,.045)!important}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th{padding-left:16px;padding-right:16px;border-color:hsla(210,8%,51%,.045)}.table>thead>tr>th{padding:10px 16px;border-color:hsla(210,8%,51%,.045)}.table-condensed tbody>tr>td,.table-condensed tbody>tr>th,.table-condensed tfoot>tr>td,.table-condensed tfoot>tr>th,.table-condensed thead>tr>td,.table-condensed thead>tr>th{padding:5px}.table-bordered{border-color:hsla(210,8%,51%,.045)}.table-striped>tbody>tr:nth-child(odd){background-color:rgba(0,0,0,.025);background-clip:padding-box}.table-striped>thead>th{background-color:rgba(0,0,0,.025);border-right:1px solid hsla(210,8%,51%,.045)}.table-striped>thead>th:last-child{border-right:none}.table-hover tr:hover,.table td.active,.table th.active,.table tr.active{background-color:rgba(0,0,0,.065)!important}.arrow{position:absolute;z-index:10}.arrow:after,.arrow:before{position:absolute;left:0;content:\"\";display:block;width:0;height:0;border:9px solid transparent}.arrow:after{border-width:8px}.arrow.top{top:-9px;left:50%;margin-left:-9px}.arrow.top.pull-in{top:-4px}.arrow.top:before{border-bottom-color:hsla(210,8%,51%,.13);border-top-width:0}.arrow.top:after{top:1px;left:1px;border-top-color:transparent;border-right-color:transparent;border-bottom-color:inherit;border-left-color:transparent;border-top-width:0}.arrow.right{top:50%;right:0;margin-top:-9px}.arrow.right.pull-in{right:4px}.arrow.right:before{border-left-color:hsla(210,8%,51%,.13);border-right-width:0}.arrow.right:after{top:1px;left:0;border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:inherit;border-right-width:0}.arrow.bottom{bottom:0;left:50%;margin-left:-9px}.arrow.bottom.pull-in{bottom:4px}.arrow.bottom:before{border-top-color:hsla(210,8%,51%,.13);border-bottom-width:0}.arrow.bottom:after{top:0;left:1px;border-top-color:inherit;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;border-bottom-width:0}.arrow.left{top:50%;left:-9px;margin-top:-9px}.arrow.left.pull-in{left:-4px}.arrow.left:before{border-right-color:hsla(210,8%,51%,.13);border-left-width:0}.arrow.left:after{top:1px;left:1px;border-top-color:transparent;border-right-color:inherit;border-bottom-color:transparent;border-left-color:transparent;border-left-width:0}.arrow.pull-left{left:18px}.arrow.pull-right{left:auto;right:26px}.arrow.pull-top{top:18px}.arrow.pull-bottom{top:auto;bottom:26px}.arrow.b-accent:before,.arrow.b-danger:before,.arrow.b-dark:before,.arrow.b-info:before,.arrow.b-primary:before,.arrow.b-success:before,.arrow.b-warning:before{border-color:transparent}.avatar{position:relative;display:inline-block;width:40px;line-height:1;border-radius:500px;white-space:nowrap;font-weight:700}.avatar img{border-radius:500px;width:100%}.avatar i{position:absolute;left:0;top:0;width:10px;height:10px;margin:1px;border-width:2px;border-style:solid;border-radius:100%}.avatar i.bottom,.avatar i.right{left:auto;right:0}.avatar i.bottom,.avatar i.left{top:auto;bottom:0}.avatar i.on{background-color:#6cc788}.avatar i.off{background-color:#f8f8f8}.avatar i.away{background-color:#f77a99}.avatar i.busy{background-color:#f44455}.avatar.w-32 i{margin:0}.avatar.w-48 i{margin:2px}.avatar.w-56 i{margin:3px}.avatar.w-64 i{margin:4px}.avatar.w-96 i{margin:9px}.avatar.w-128 i{margin:14px}.row-col{display:table;table-layout:fixed;border-spacing:0;width:100%;height:100%}.row-col>[class*=\" col-\"],.row-col>[class*=col-]{vertical-align:top;float:none;padding:0;position:static}.row-row{display:table-row;height:100%}.row-cell{display:table-cell;vertical-align:top}.row-body{position:relative;height:100%;width:100%}.ie .row-body{display:table-cell;overflow:auto}.ie .row-body .row-inner{overflow:visible!important}.row-inner{position:absolute;top:0;bottom:0;left:0;right:0;overflow:auto;-webkit-overflow-scrolling:touch}.v-m{vertical-align:middle!important}.v-t{vertical-align:top!important}.v-b{vertical-align:bottom!important}.v-c{display:-ms-flexbox;display:flex;align-items:center}@media (min-width:992px){.row-col>[class*=\" col-lg\"],.row-col>[class*=col-lg]{display:table-cell;height:100%}}@media (min-width:768px){.row-col>[class*=\" col-md\"],.row-col>[class*=col-md]{display:table-cell;height:100%}}@media (min-width:544px){.row-col>[class*=\" col-sm\"],.row-col>[class*=col-sm]{display:table-cell;height:100%}}.row-col>[class*=\" col-xs\"],.row-col>[class*=col-xs]{display:table-cell;height:100%}@media (max-width:543px){.row-col-xs{display:block}.row-col-xs .row-body{overflow:visible!important}.row-col-xs .row-inner{position:static}}.box,.box-color{background-color:#fff;position:relative;margin-bottom:1.5rem}.box-header{position:relative;padding:1rem}.box-header h2,.box-header h3,.box-header h4{margin:0;font-size:18px;line-height:1}.box-header h3{font-size:16px}.box-header h4{font-size:15px}.box-header small{display:block;margin-top:4px;opacity:.6}.box-body,.box-footer{padding:1rem}.box-divider{border-bottom:1px solid hsla(210,8%,51%,.13);margin:0 16px;height:0}.box-tool{position:absolute;right:16px;top:14px}.box-shadow,.box-shadow .box,.box-shadow .box-color{box-shadow:0 2px 2px rgba(0,0,0,.03),0 1px 0 rgba(0,0,0,.03)}.box-shadow-z0,.box-shadow-z0 .box,.box-shadow-z0 .box-color{box-shadow:0 0 1px rgba(0,0,0,.15)}.box-shadow-z1,.box-shadow-z1 .box,.box-shadow-z1 .box-color{box-shadow:0 1px 2px rgba(0,0,0,.1),0 -1px 0 rgba(0,0,0,.02)}.box-shadow-z2,.box-shadow-z2 .box,.box-shadow-z2 .box-color{box-shadow:0 1px 2px rgba(0,0,0,.15),0 -1px 0 rgba(0,0,0,.02)}.box-shadow-z3,.box-shadow-z3 .box,.box-shadow-z3 .box-color{box-shadow:0 2px 4px rgba(0,0,0,.1),0 -1px 0 rgba(0,0,0,.02)}.box-shadow-z4,.box-shadow-z4 .box,.box-shadow-z4 .box-color{box-shadow:0 2px 5px rgba(0,0,0,.26),0 -1px 0 rgba(0,0,0,.02)}.box-radius-1x,.box-radius-1x .box,.box-radius-1x .box-color{border-radius:2px}.box-radius-2x,.box-radius-2x .box,.box-radius-2x .box-color{border-radius:3px}.box-radius-3x,.box-radius-3x .box,.box-radius-3x .box-color{border-radius:4px}.ui-check{position:relative;padding-left:20px;cursor:pointer}.ui-check input{opacity:0;position:absolute;z-index:-1}.ui-check input:checked+i:before{left:5px;top:5px;width:6px;height:6px;background-color:#0cc2aa}.ui-check input:checked+span .active{display:inherit}.ui-check input[type=radio]+i,.ui-check input[type=radio]+i:before{border-radius:50%}.ui-check input[disabled]+i,fieldset[disabled] .ui-check input+i{border-color:hsla(210,8%,56%,.2)}.ui-check input[disabled]+i:before,fieldset[disabled] .ui-check input+i:before{background-color:hsla(210,8%,56%,.2)}.ui-check>i{width:16px;height:16px;line-height:1;box-shadow:0 0 1px hsla(210,8%,51%,.35);margin-left:-20px;margin-top:-2px;display:inline-block;vertical-align:middle;margin-right:4px;background-clip:padding-box;position:relative}.ui-check>i:before{content:\"\";position:absolute;left:50%;top:50%;width:0;height:0;background-color:transparent}.ui-check>span{margin-left:-20px}.ui-check>span .active{display:none}.ui-check.ui-check-color input:checked+i:before{background-color:#fff}.ui-check-md input:checked+i:before{left:6px;top:6px}.ui-check-md>i{width:18px;height:18px}.ui-check-lg input:checked+i:before{width:12px;height:12px;left:9px;top:9px}.ui-check-lg>i{width:30px;height:30px}[layout]{box-sizing:border-box;display:-moz-flex;display:-ms-flexbox;display:flex}[layout=column]{-ms-flex-direction:column;flex-direction:column}[layout=row]{-ms-flex-direction:row;flex-direction:row}[layout-wrap]{-ms-flex-wrap:wrap;flex-wrap:wrap}[layout-fill]{margin:0;min-height:100%;width:100%}@-moz-document url-prefix(){[layout-fill]{margin:0;width:100%;min-height:auto;height:inherit}}[flex]{box-sizing:border-box;-ms-flex:1;flex:1}[flex-no-shrink]{flex-shrink:0}html{height:100%}body{height:auto;min-height:100%;position:relative}.app-aside{position:fixed!important;z-index:1030;float:left;height:100%}.app-content{box-shadow:none}.app-content:after{content:\"\";display:table;clear:both}.app-header{position:fixed;top:0;left:0;right:0;margin:inherit;z-index:1020}.app-header~.app-body{padding-top:3.5rem}.app-header.navbar-md~.app-body{padding-top:4rem}.app-header.navbar-sm~.app-body{padding-top:3rem}.app-body-inner{padding-top:inherit!important;padding-bottom:inherit!important;position:absolute;top:0;bottom:0;overflow:auto}.app-footer{position:absolute;left:0;right:0;bottom:0;z-index:1;margin:inherit}.app-footer:not(.hide)~.app-body{padding-bottom:3.125rem}.app-fixed{overflow:hidden}.app-fixed .app{height:100%}.app-fixed .app-content{position:relative;min-height:100%}.app-fixed .app-footer{margin-left:0}@media (min-width:992px){.app-aside{opacity:1;display:block!important}.app-aside,.app-aside .scroll{width:12.5rem}.app-aside.lg:not(.folded),.app-aside.lg:not(.folded) .scroll{width:13.75rem}.app-aside.lg:not(.hide)~.app-content{margin-left:13.75rem}.app-aside.sm:not(.folded),.app-aside.sm:not(.folded) .scroll{width:11.25rem}.app-aside.sm:not(.hide)~.app-content{margin-left:11.25rem}.app-aside.folded{width:4rem}.app-aside.folded:not(.hide)~.app-content{margin-left:4rem}.app-aside.folded.md{width:5rem}.app-aside.folded.md:not(.hide)~.app-content{margin-left:5rem}.app-aside:not(.hide)~.app-content{margin-left:12.5rem}.app-aside .left{position:absolute;right:0;transform:translateZ(0)}.hide-scroll{width:auto;margin-right:-17px;overflow-y:scroll;-webkit-overflow-scrolling:touch}}@media (max-width:991px){.app-aside.modal{width:100%;position:fixed;z-index:1050}.app-aside .left{position:fixed;width:304px}}@media print{.app-aside,.app-footer,.app-header,.switcher{display:none}}.ie9 .app-aside{position:static!important}.ie9 .app-aside .left{width:inherit;position:absolute}@media (max-width:991px){.app .container,body.container{max-width:100%;padding-left:0;padding-right:0}}@media (min-width:992px){body.container{box-shadow:0 1px 1px rgba(0,0,0,.1)}body.container,body.container .container{padding-left:0;padding-right:0}body.container .app-aside{left:inherit;right:auto}body.container .app-aside.lg~.app-content .app-header{width:45rem}body.container .app-aside.sm~.app-content .app-header{width:47.5rem}body.container .app-aside.folded~.app-content .app-header{width:54.75rem}body.container .app-aside.folded.md~.app-content .app-header{width:53.75rem}body.container .app-aside~.app-content .app-header{width:46.25rem}body.container .app-header{left:inherit;right:auto;margin-left:0;width:58.75rem}}@media (min-width:1200px){body.container .app-aside.lg~.app-content .app-header{width:57.5rem}body.container .app-aside.sm~.app-content .app-header{width:60rem}body.container .app-aside.folded~.app-content .app-header{width:67.25rem}body.container .app-aside.folded.md~.app-content .app-header{width:66.25rem}body.container .app-aside~.app-content .app-header{width:58.75rem}body.container .app-header{width:71.25rem}}.list{padding-left:0;padding-right:0;border-radius:3px}.list.no-border{padding-top:8px;padding-bottom:8px}.list-item{display:block;position:relative;padding:12px 16px}.list-item:after{content:\"\";display:table;clear:both}.list-item:last-child .list-body:after{border:none}.no-border .list-item{padding-top:8px;padding-bottom:8px}.no-padding .list-item{padding-left:0;padding-right:0}.list-left{float:left;padding-right:1rem}.list-left+.list-body{margin-left:56px}.list-body h3{font-size:16px;margin:0 0 3px;font-weight:400}.list-body:after{content:\"\";position:absolute;left:0;right:0;bottom:0;border-bottom:1px solid hsla(210,8%,51%,.065)}.inset .list-body:after{left:72px}.no-border .list-body:after{display:none}.pace{-webkit-pointer-events:none;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.pace-inactive{display:none}.pace .pace-progress{background:#0cc2aa;position:fixed;z-index:2000;top:0;right:100%;width:100%;height:2px}.pace .pace-activity{display:block;position:fixed;z-index:2000;top:5px;right:5px;width:14px;height:14px;border:2px solid transparent;border-top-color:#0cc2aa;border-left-color:#0cc2aa;border-radius:10px;animation:loading-bar-spinner .4s linear infinite}@keyframes loading-bar-spinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.navside{border:inherit}.navside ul{padding-left:0;padding-right:0;list-style:none}.navside [flex]{overflow:auto}.navside .nav{border:inherit}.navside .nav li{border:inherit;position:relative}.navside .nav li li a{line-height:2rem;padding-left:3.5rem}.navside .nav li li a .nav-text{padding:.4375rem 0}.navside .nav li li li a{padding-left:4.5rem}.navside .nav li li li li a{padding-left:5.5rem}.navside .nav li a{display:block;padding:0 1rem;line-height:2.25rem;position:relative}.navside .nav li a:after{content:\"\";display:table;clear:both}.navside .nav li.active,.navside .nav li a:focus,.navside .nav li a:hover{background-color:rgba(0,0,0,.065)}.navside .nav li.active>a{background-color:transparent}.navside .nav li.active>a .nav-caret i{transform:rotate(180deg)}.navside .nav-header{padding:0 1rem;line-height:2.25rem}.navside .nav-header:focus,.navside .nav-header:hover{background-color:transparent!important}.navside .nav-header:after{display:none}.navside .navbar-brand{float:none;margin-right:0}.nav-fold{padding:.75rem 1rem}.nav-text{display:block;line-height:1.125rem;padding:.5625rem 0}.nav>li>a .nav-text{font-weight:500}.nav-text small,.nav-text span{display:block}.navside .nav-text{opacity:.75}.navside .active>a>.nav-text,.navside a:focus>.nav-text,.navside a:hover>.nav-text{opacity:1}.navbar .nav-text{line-height:1;vertical-align:middle;display:inline-block;padding:0}.navbar .nav-text span.text-xs{margin-top:.25rem}.nav-icon{float:left;line-height:inherit;margin-right:1rem;top:0;min-width:1.5rem;text-align:center}.nav-icon i{position:relative}.nav-icon i img,.nav-icon i svg{display:none;position:absolute;left:0;top:0;width:100%;height:100%}.navbar .nav-icon{margin-right:.5rem}.nav-label{float:right;margin-left:1rem;font-style:normal;z-index:1}.navbar .nav-label{margin-left:.5rem}.nav-caret{float:right;margin-left:1rem;opacity:.45}.nav-caret i{transition:transform .3s ease-in-out}.navbar .nav-caret{margin-left:.5rem}.nav-sub{max-height:0;overflow:hidden;transition:max-height .4s ease 0s}.active>.nav-sub{max-height:50rem}@media (min-width:992px){.folded,.folded .scroll{width:4rem}.folded.md,.folded.md .scroll{width:5rem}.folded .hidden-folded,.folded .nav li ul{display:none}.folded .nav>li>a{text-align:center;padding-left:4px;padding-right:4px}.folded .nav>li>a .nav-caret,.folded .nav>li>a .nav-text{display:none}.folded .nav>li>a .nav-label{position:absolute;top:-6px;right:6px}.folded .nav>li>a .nav-icon{float:none;line-height:2.5rem;margin-left:0;margin-right:0;position:relative}.folded.show-text .nav>li>a .nav-text{display:block;margin-top:-18px;font-size:.85em}.folded .navbar{text-align:center;padding-left:4px;padding-right:4px}.folded .navbar-brand{float:none;margin:0}.folded .nav-stacked .nav{margin:0 12px}.folded .nav-fold{padding:8px 16px}.folded .nav-fold .pull-left{float:none!important;margin:0}.folded .nav-fold .pull-left img{width:100%;height:auto}.folded.nav-expand{transition:width .4s cubic-bezier(.25,.8,.25,1);-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow-x:hidden;overflow-y:auto;position:absolute}.folded.nav-expand.active,.folded.nav-expand.active .scroll,.folded.nav-expand:focus,.folded.nav-expand:focus .scroll,.folded.nav-expand:hover,.folded.nav-expand:hover .scroll{width:12.5rem!important}.folded.nav-expand.active>*,.folded.nav-expand:focus>*,.folded.nav-expand:hover>*{width:12.5rem}.folded.nav-expand.active .hidden-folded,.folded.nav-expand:focus .hidden-folded,.folded.nav-expand:hover .hidden-folded{display:block}.folded.nav-expand.active .hidden-folded.inline,.folded.nav-expand:focus .hidden-folded.inline,.folded.nav-expand:hover .hidden-folded.inline{display:inline-block}.folded.nav-expand.active .nav li ul,.folded.nav-expand:focus .nav li ul,.folded.nav-expand:hover .nav li ul{display:inherit}.folded.nav-expand.active .nav>li>a,.folded.nav-expand:focus .nav>li>a,.folded.nav-expand:hover .nav>li>a{text-align:left;padding-left:16px;padding-right:16px}.folded.nav-expand.active .nav>li>a .nav-caret,.folded.nav-expand.active .nav>li>a .nav-text,.folded.nav-expand:focus .nav>li>a .nav-caret,.folded.nav-expand:focus .nav>li>a .nav-text,.folded.nav-expand:hover .nav>li>a .nav-caret,.folded.nav-expand:hover .nav>li>a .nav-text{display:block}.folded.nav-expand.active .nav>li>a .nav-text,.folded.nav-expand:focus .nav>li>a .nav-text,.folded.nav-expand:hover .nav>li>a .nav-text{font-size:1em;margin:0}.folded.nav-expand.active .nav>li>a .nav-label,.folded.nav-expand:focus .nav>li>a .nav-label,.folded.nav-expand:hover .nav>li>a .nav-label{position:static}.folded.nav-expand.active .nav>li>a .nav-icon,.folded.nav-expand:focus .nav>li>a .nav-icon,.folded.nav-expand:hover .nav>li>a .nav-icon{float:left;line-height:inherit;margin-right:16px}.folded.nav-expand.active .navbar,.folded.nav-expand:focus .navbar,.folded.nav-expand:hover .navbar{text-align:left;padding-left:1rem;padding-right:1rem}.folded.nav-expand.active .nav-stacked .nav,.folded.nav-expand:focus .nav-stacked .nav,.folded.nav-expand:hover .nav-stacked .nav{margin:0 8px}.folded.nav-expand.active .nav-stacked .nav>li>a,.folded.nav-expand:focus .nav-stacked .nav>li>a,.folded.nav-expand:hover .nav-stacked .nav>li>a{padding:0 8px}.folded.nav-expand.active .nav-fold,.folded.nav-expand:focus .nav-fold,.folded.nav-expand:hover .nav-fold{padding:12px 16px}.folded.nav-expand.active .nav-fold .pull-left,.folded.nav-expand:focus .nav-fold .pull-left,.folded.nav-expand:hover .nav-fold .pull-left{float:left!important}.folded.nav-expand.active .nav-fold .pull-left img,.folded.nav-expand:focus .nav-fold .pull-left img,.folded.nav-expand:hover .nav-fold .pull-left img{height:auto}.folded.nav-expand.active .nav-fold .pull-left img.w-40,.folded.nav-expand:focus .nav-fold .pull-left img.w-40,.folded.nav-expand:hover .nav-fold .pull-left img.w-40{width:40px}.folded.nav-expand.active .nav-fold .pull-left img.w-48,.folded.nav-expand:focus .nav-fold .pull-left img.w-48,.folded.nav-expand:hover .nav-fold .pull-left img.w-48{width:48px}.folded.nav-dropdown.modal,.folded.nav-dropdown .row-body,.folded.nav-dropdown [flex],.nav-dropup.modal,.nav-dropup .row-body,.nav-dropup [flex]{overflow:visible!important}.folded.nav-dropdown .nav>li:focus>ul,.folded.nav-dropdown .nav>li:hover>ul,.nav-dropup .nav>li:focus>ul,.nav-dropup .nav>li:hover>ul{display:block}.folded.nav-dropdown .nav>li>ul,.nav-dropup .nav>li>ul{display:none;overflow:visible;max-height:999px;color:hsla(0,0%,100%,.87);background-color:rgba(0,0,0,.87);border-radius:2px;box-shadow:0 1px 3px rgba(0,0,0,.15);position:absolute;left:100%;top:0;padding:6px 0}.folded.nav-dropdown .nav>li>ul a,.nav-dropup .nav>li>ul a{padding-left:16px!important;padding-right:16px!important;min-width:160px}.folded.nav-dropdown .nav>li>ul li.active ul,.nav-dropup .nav>li>ul li.active ul{display:block}.folded.nav-dropdown .nav>li>ul .nav-text,.nav-dropup .nav>li>ul .nav-text{padding:6px 0!important}.folded.nav-dropdown .nav>li .nav-mega,.nav-dropup .nav>li .nav-mega{width:320px}.folded.nav-dropdown .nav>li .nav-mega>li,.nav-dropup .nav>li .nav-mega>li{width:160px;float:left}.folded.nav-dropdown .nav>li .nav-mega.nav-mega-3,.nav-dropup .nav>li .nav-mega.nav-mega-3{width:480px}}.nav-border .nav>li.active:after{content:\"\";position:absolute;top:0;bottom:0;border-left-color:inherit;border-left-width:3px;border-left-style:solid}.nav-stacked .nav{margin:0 8px}.nav-stacked .nav>li>a{line-height:2rem;padding:0 .5rem;margin:2px 0}.nav-stacked .nav>li>a .nav-text{padding:.4375rem 0}.nav-stacked .nav>li li a{padding-left:3rem}.nav-stacked .nav>li li li a{padding-left:4rem}.nav-stacked .nav>li li li li a{padding-left:5rem}.nav-stacked .nav>li.active>a{color:hsla(0,0%,100%,.87);background-color:#0cc2aa}.nav-stacked .nav li a{border-radius:3px}.nav-stacked .nav .nav-header{padding-left:8px;padding-right:8px}.nav-light .nav .nav-icon i img,.nav-light .nav .nav-icon i svg{display:block}.nav-center{text-align:center}.nav-center .nav-icon{display:none}.nav-center .nav-caret{position:absolute;right:10px}.nav-center .nav-label{position:absolute;padding-left:10px}.nav-center .nav a{padding-left:16px!important}.nav-center .nav-fold .pull-left{float:none!important;margin-bottom:10px;display:inline-block}.nav-active-bg .nav-link.active,.nav-active-bg .nav>li.active>a{color:rgba(0,0,0,.87)!important;background-color:#f0f0f0!important}.nav-active-dark .nav-link.active,.nav-active-dark .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#2e3e4e!important}.nav-active-black .nav-link.active,.nav-active-black .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#2a2b3c!important}.nav-active-primary .nav-link.active,.nav-active-primary .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#0cc2aa!important}.nav-active-accent .nav-link.active,.nav-active-accent .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#a88add!important}.nav-active-warn .nav-link.active,.nav-active-warn .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#fcc100!important}.nav-active-success .nav-link.active,.nav-active-success .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#6cc788!important}.nav-active-info .nav-link.active,.nav-active-info .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#6887ff!important}.nav-active-warning .nav-link.active,.nav-active-warning .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#f77a99!important}.nav-active-danger .nav-link.active,.nav-active-danger .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#f44455!important}.nav-active-light .nav-link.active,.nav-active-light .nav>li.active>a{color:rgba(0,0,0,.87)!important;background-color:#f8f8f8!important}.nav-active-white .nav-link.active,.nav-active-white .nav>li.active>a{color:rgba(0,0,0,.87)!important;background-color:#fff!important}.nav-active-red .nav-link.active,.nav-active-red .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#f44336!important}.nav-active-pink .nav-link.active,.nav-active-pink .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#e91e63!important}.nav-active-purple .nav-link.active,.nav-active-purple .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#9c27b0!important}.nav-active-deep-purple .nav-link.active,.nav-active-deep-purple .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#673ab7!important}.nav-active-indigo .nav-link.active,.nav-active-indigo .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#3f51b5!important}.nav-active-blue .nav-link.active,.nav-active-blue .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#2196f3!important}.nav-active-light-blue .nav-link.active,.nav-active-light-blue .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#03a9f4!important}.nav-active-cyan .nav-link.active,.nav-active-cyan .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#00bcd4!important}.nav-active-teal .nav-link.active,.nav-active-teal .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#009688!important}.nav-active-green .nav-link.active,.nav-active-green .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#4caf50!important}.nav-active-light-green .nav-link.active,.nav-active-light-green .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#8bc34a!important}.nav-active-lime .nav-link.active,.nav-active-lime .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#cddc39!important}.nav-active-yellow .nav-link.active,.nav-active-yellow .nav>li.active>a{color:rgba(0,0,0,.87)!important;background-color:#ffeb3b!important}.nav-active-amber .nav-link.active,.nav-active-amber .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#ffc107!important}.nav-active-orange .nav-link.active,.nav-active-orange .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#ff9800!important}.nav-active-deep-orange .nav-link.active,.nav-active-deep-orange .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#ff5722!important}.nav-active-brown .nav-link.active,.nav-active-brown .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#795548!important}.nav-active-blue-grey .nav-link.active,.nav-active-blue-grey .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#607d8b!important}.nav-active-grey .nav-link.active,.nav-active-grey .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#424242!important}.ui-icon{display:inline-block;text-align:center;height:1em;background:transparent!important}.ui-icon:before{position:relative;z-index:1}.ui-icon:after{content:\"\";border-width:1px;border-style:solid;border-color:inherit;border-radius:2em;width:2em;height:2em;top:-1.5em;display:block;position:relative;z-index:0;background-clip:padding-box}.ui-icon.b-2x:after{border-width:2px}.ui-icon.b-3x:after{border-width:3px}.ui-icon.ui-icon-sm:after{width:1.7em;height:1.7em;top:-1.35em}.ui-icon.primary:after{background-color:#0cc2aa}.ui-icon.success:after{background-color:#6cc788}.ui-icon.info:after{background-color:#6887ff}.ui-icon.warning:after{background-color:#f77a99}.ui-icon.danger:after{background-color:#f44455}.ui-icon.accent:after{background-color:#a88add}.ui-icon.dark:after{background-color:#2e3e4e}.ui-icon.light:after{background-color:#f8f8f8}.ui-icon.white:after{background-color:#fff}.item{position:relative}.item .top{top:0}.item .bottom,.item .top{position:absolute;right:0;left:0}.item .bottom{bottom:0}.item .center{top:42%}.item-overlay,.item .center{position:absolute;right:0;left:0}.item-overlay{display:none}.item-overlay.active,.item-overlay .item:focus,.item:hover .item-overlay{display:block}.item-overlay.w-full{text-align:center;top:0;bottom:0}.item-bg{position:absolute;width:100%;height:100%;overflow:hidden}.item-bg img{position:absolute;width:110%;left:50%;top:50%;margin-left:-55%;margin-top:-55%}.blur{-moz-filter:blur(3px);-o-filter:blur(3px);-ms-filter:blur(3px);filter:blur(3px)}.blur-5{-moz-filter:blur(5px);-o-filter:blur(5px);-ms-filter:blur(5px);filter:blur(5px)}.blur-5,.opacity{opacity:.5}.opacity-3{opacity:.3}.switcher{z-index:1050;position:fixed;top:78px;right:-240px;width:240px;transition:right .2s ease;border:1px solid hsla(0,0%,47%,.1);background-clip:padding-box}.switcher.active{right:-2px;z-index:1060}.switcher .sw-btn{position:absolute;left:-43px;top:-1px;padding:10px 15px;z-index:1045;border:1px solid hsla(0,0%,47%,.1);border-right-width:0;background-clip:padding-box}#sw-demo{top:118px}#sw-demo.active{top:78px}.list-icon i{margin-right:16px}.list-icon div{line-height:40px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.jqstooltip{background-color:rgba(0,0,0,.8)!important;border:1px solid #000!important;border-radius:3px;padding:5px 10px!important;box-sizing:content-box}.easyPieChart{position:relative;text-align:center}.easyPieChart>div{position:absolute;width:100%;line-height:1;top:40%}.easyPieChart>div img{margin-top:-4px}.easyPieChart canvas{vertical-align:middle}#flotTip,.flotTip{padding:4px 10px;background-color:rgba(0,0,0,.8)!important;border:1px solid #000!important;z-index:100;font-size:12px;color:#fff;border-radius:3px}.legendColorBox>div{border:none!important;margin:5px}.legendColorBox>div>div{border-radius:10px}.st-sort-ascent:before{content:\"\\25B2\"}.st-sort-descent:before{content:\"\\25BC\"}.st-selected td{background:rgba(0,0,0,.065)}.black .btn-default.form-control,.dark .btn-default.form-control,.grey .btn-default.form-control{background:transparent!important;background-color:hsla(0,0%,100%,.1)!important;color:inherit!important}.ui-select-bootstrap>.ui-select-choices{overflow-y:scroll}.box .dataTables_wrapper{padding-top:10px}.box .dataTables_wrapper>.row{margin:0}.box .dataTables_wrapper>.row>.col-sm-12{padding:0}.dataTables_wrapper.form-inline .form-control{width:auto}.footable-odd{background-color:rgba(0,0,0,.025)!important}.note-editor{border-width:0!important;overflow:visible!important;background-color:inherit}.note-toolbar .note-color .dropdown-toggle{padding-left:2px!important}.note-editor .note-editing-area .note-editable,.note-editor .note-statusbar{background-color:transparent!important;color:inherit!important}.note-toolbar{background-color:hsla(210,8%,51%,.1)}.ie .ie-show{display:block}.nav a.waves-effect{-webkit-mask-image:-webkit-radial-gradient(circle,#fff 100%,#000 0)}.sortable-placeholder{list-style:none;border:1px dashed #fff;min-height:40px}.streamline{position:relative;border-color:hsla(210,8%,51%,.13)}.streamline .sl-icon:before,.streamline .sl-item:before,.streamline:after{content:\"\";position:absolute;border-color:inherit;border-width:3px;border-style:solid;border-radius:50%;width:7px;height:7px;margin-left:-4px;top:6px;left:0}.streamline:after{top:auto;bottom:0}.sl-icon{position:absolute;left:-10px;z-index:1;border:inherit}.sl-icon>i{width:20px;height:20px;text-align:center;display:table-cell;vertical-align:middle;color:#fff}.streamline .sl-icon:before{width:20px;height:20px;border-width:10px;margin:0!important;top:0!important}.sl-item{border-color:hsla(210,8%,51%,.13);position:relative;padding-bottom:1px}.sl-item:after{content:\"\";display:table;clear:both;top:2px;bottom:auto}.sl-item.b-l{margin-left:-1px}.sl-left{float:left;position:relative;z-index:1;margin-left:-20px;margin-bottom:24px}.sl-left img{max-width:40px}.sl-left+.sl-content{margin-left:36px}.sl-content{margin-left:24px;padding-bottom:16px}.sl-author{margin-bottom:10px}.sl-date{font-size:.85em}.sl-footer{margin-bottom:10px}.ui-switch{cursor:pointer;position:relative;display:inline-block;width:32px;height:18px;border-radius:30px;background-color:#6cc788;margin:0}.ui-switch input{position:absolute;opacity:0}.ui-switch input:checked+i:before{top:50%;bottom:50%;left:50%;right:5px;border-width:0;border-radius:5px}.ui-switch input:checked+i:after{margin-left:15px}.ui-switch i:before{top:-1px;bottom:-1px;left:-1px;right:-1px;border:1px solid #f0f0f0;border-radius:30px;transition:all .2s}.ui-switch i:after,.ui-switch i:before{content:\"\";position:absolute;background-color:#fff}.ui-switch i:after{width:16px;top:1px;bottom:1px;border-radius:50%;box-shadow:1px 1px 3px rgba(0,0,0,.25);transition:margin .3s}.ui-switch-md{width:40px;height:24px}.ui-switch-md input:checked+i:after{margin-left:17px}.ui-switch-md i:after{width:22px}.ui-switch-lg{width:50px;height:30px}.ui-switch-lg input:checked+i:after{margin-left:21px}.ui-switch-lg i:after{width:28px}.timeline{margin:0;padding:0}.tl-item{display:block}.tl-item:after{content:\"\";display:table;clear:both}.visible-left{display:none}.tl-wrap{display:block;margin-left:6em;padding:15px 0 15px 20px;border-style:solid;border-color:hsla(210,8%,51%,.13);border-width:0 0 0 2px}.tl-wrap:after{content:\"\";display:table;clear:both}.tl-wrap:before{content:\"\";top:15px;margin-left:-26px;width:10px;height:10px;border-color:inherit;border-width:3px;border-radius:50%;border-style:solid;background:#f8f8f8;box-shadow:0 0 0 4px #f0f0f0}.tl-date,.tl-wrap:before{position:relative;float:left}.tl-date{top:10px;margin-left:-7.5em;display:block;width:4.5em;text-align:right}.tl-content{display:inline-block;position:relative;padding-top:10px;padding-bottom:10px}.tl-content.block{display:block;width:100%}.tl-content.panel{margin-bottom:0}.tl-header{display:block;width:12em;text-align:center;margin-left:1px}.timeline-center .tl-item{margin-left:50%}.timeline-center .tl-item .tl-wrap{margin-left:-2px}.timeline-center .tl-header{width:auto;margin-left:-1px}.timeline-center .tl-left{margin-left:0;margin-right:50%}.timeline-center .tl-left .hidden-left{display:none!important}.timeline-center .tl-left .visible-left{display:inherit}.timeline-center .tl-left .tl-wrap{float:right;margin-right:0;border-left-width:0;border-right-width:2px;padding-left:0;padding-right:20px}.timeline-center .tl-left .tl-wrap:before{float:right;margin-left:0;margin-right:-26px}.timeline-center .tl-left .tl-date{float:right;margin-left:0;margin-right:-8.5em;text-align:left}.lter{background-color:hsla(0,0%,100%,.035)}.dker{background-color:rgba(0,0,0,.035)}.light{background-color:#f8f8f8}.dark-white,.white{background-color:#fff}.dark-white{color:rgba(0,0,0,.87)}.black{color:hsla(0,0%,100%,.87);background-color:#2a2b3c}.black .lt{background-color:#2f3044}.black .dk{background-color:#252635}.black .bg{background-color:#2a2b3c}.dark{color:hsla(0,0%,100%,.87);background-color:#2e3e4e}.dark .lt{background-color:#334456}.dark .dk{background-color:#293846}.dark .bg{background-color:#2e3e4e}.grey{color:hsla(0,0%,100%,.87);background-color:#424242}.grey .lt{background-color:#484848}.grey .dk{background-color:#3c3c3c}.grey .bg{background-color:#424242}.primary{color:hsla(0,0%,100%,.87);background-color:#0cc2aa}.primary .lt{background-color:#0dceb5}.primary .dk{background-color:#0bb69f}.primary .bg{background-color:#0cc2aa}.accent{color:hsla(0,0%,100%,.87);background-color:#a88add}.accent .lt{background-color:#af94e0}.accent .dk{background-color:#a180da}.accent .bg{background-color:#a88add}.warn{color:hsla(0,0%,100%,.87);background-color:#fcc100}.warn .lt{background-color:#ffc60a}.warn .dk{background-color:#efb700}.warn .bg{background-color:#fcc100}.success{color:hsla(0,0%,100%,.87);background-color:#6cc788}.success .lt{background-color:#75cb8f}.success .dk{background-color:#63c381}.success .bg{background-color:#6cc788}.info{color:hsla(0,0%,100%,.87);background-color:#6887ff}.info .lt{background-color:#7591ff}.info .dk{background-color:#5b7dff}.info .bg{background-color:#6887ff}.warning{color:hsla(0,0%,100%,.87);background-color:#f77a99}.warning .lt{background-color:#f886a2}.warning .dk{background-color:#f66e90}.warning .bg{background-color:#f77a99}.danger{color:hsla(0,0%,100%,.87);background-color:#f44455}.danger .lt{background-color:#f55060}.danger .dk{background-color:#f3384a}.danger .bg{background-color:#f44455}.blue .lt{background-color:#2d9cf4}.blue .dk{background-color:#1590f2}.blue .bg{background-color:#2196f3}.white-overlay{background-color:hsla(0,0%,100%,.85)}.black-overlay{background-color:rgba(0,0,0,.85)}.gd-overlay{background-color:transparent!important;background-image:linear-gradient(180deg,transparent 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=0)}.bg-auto:before{content:\"\";position:absolute;width:inherit;top:0;bottom:0;background-color:inherit;border:inherit}.bg-auto.b-l:before{margin-left:-1px}.bg-auto.b-r:before{margin-right:-1px}.bg-clip{background-clip:padding-box}.no-bg{background-color:transparent!important}@media (max-width:767px){.no-bg-xs{background-color:transparent}}.dark .box,.dark .white{background-color:#354759}.dark.app{background-color:#2e3e4e}.black .box,.black .white{background-color:#313347}.black.app{background-color:#2a2b3c}.grey .box,.grey .white{background-color:#4b4b4b}.grey.app{background-color:#424242}.black .form-control,.dark .form-control,.grey .form-control{background:transparent;background-color:hsla(0,0%,100%,.1);color:inherit}.black .form-control:focus,.dark .form-control:focus,.grey .form-control:focus{border-color:hsla(0,0%,100%,.125)}.black .input-group-btn .btn,.dark .input-group-btn .btn,.grey .input-group-btn .btn{background-color:hsla(0,0%,100%,.1)!important;color:inherit!important}.black .list-group,.dark .list-group,.grey .list-group{background-color:transparent}.pos-rlt{position:relative;z-index:1}.pos-abt{position:absolute}.pos-fix{position:fixed!important}.pos-stc{position:static!important}.block{display:block}.block.hide{display:none}.pull-none{float:none}.inline{display:inline-block}.inline-16{width:16px;height:16px}.inline-24{width:24px;height:24px}.active>.auto .inline,.active>.inline,.none{display:none}.active>.auto .none,.active>.none{display:inline-block}.hide{display:none!important}.show{display:block!important}.pointer{cursor:pointer}.circle,.rounded{border-radius:500px}.clear{display:block;overflow:hidden}.no-shadow{box-shadow:none!important}@media (max-width:767px){.pos-stc-sm{position:static!important}}@media (max-width:543px){.pos-stc-xs{position:static!important}}.no-border{border-color:transparent;border-width:0}.no-borders{border-width:0!important}.b{border-color:hsla(210,8%,51%,.13);background-clip:padding-box}.b-a{border:1px solid hsla(210,8%,51%,.13)}.b-t{border-top:1px solid hsla(210,8%,51%,.13)}.b-r{border-right:1px solid hsla(210,8%,51%,.13)}.b-b{border-bottom:1px solid hsla(210,8%,51%,.13)}.b-l{border-left:1px solid hsla(210,8%,51%,.13)}.b-2x{border-width:2px}.b-3x{border-width:3px}.b-4x{border-width:4px}.b-5x{border-width:5px}.b-t-2x{border-top-width:2px!important}.b-t-3x{border-top-width:3px!important}.b-t-4x{border-top-width:4px!important}.b-t-5x{border-top-width:5px!important}.b-r-2x{border-right-width:2px!important}.b-r-3x{border-right-width:3px!important}.b-r-4x{border-right-width:4px!important}.b-r-5x{border-right-width:5px!important}.b-b-2x{border-bottom-width:2px!important}.b-b-3x{border-bottom-width:3px!important}.b-b-4x{border-bottom-width:4px!important}.b-b-5x{border-bottom-width:5px!important}.b-l-2x{border-left-width:2px!important}.b-l-3x{border-left-width:3px!important}.b-l-4x{border-left-width:4px!important}.b-l-5x{border-left-width:5px!important}.b-primary{border-color:#0cc2aa}.b-t-primary{border-top-color:#0cc2aa}.b-r-#e7f9f7{border-right-color:#0cc2aa}.b-b-primary{border-bottom-color:#0cc2aa}.b-l-primary{border-left-color:#0cc2aa}.b-accent{border-color:#a88add}.b-t-accent{border-top-color:#a88add}.b-r-#f6f3fc{border-right-color:#a88add}.b-b-accent{border-bottom-color:#a88add}.b-l-accent{border-left-color:#a88add}.b-warn{border-color:#fcc100}.b-t-warn{border-top-color:#fcc100}.b-r-#fff9e6{border-right-color:#fcc100}.b-b-warn{border-bottom-color:#fcc100}.b-l-warn{border-left-color:#fcc100}.b-success{border-color:#6cc788}.b-t-success{border-top-color:#6cc788}.b-r-#f0f9f3{border-right-color:#6cc788}.b-b-success{border-bottom-color:#6cc788}.b-l-success{border-left-color:#6cc788}.b-info{border-color:#6887ff}.b-t-info{border-top-color:#6887ff}.b-r-#f0f3ff{border-right-color:#6887ff}.b-b-info{border-bottom-color:#6887ff}.b-l-info{border-left-color:#6887ff}.b-warning{border-color:#f77a99}.b-t-warning{border-top-color:#f77a99}.b-r-#fef2f5{border-right-color:#f77a99}.b-b-warning{border-bottom-color:#f77a99}.b-l-warning{border-left-color:#f77a99}.b-danger{border-color:#f44455}.b-t-danger{border-top-color:#f44455}.b-r-#feecee{border-right-color:#f44455}.b-b-danger{border-bottom-color:#f44455}.b-l-danger{border-left-color:#f44455}.b-light{border-color:#f8f8f8}.b-t-light{border-top-color:#f8f8f8}.b-r-#fefefe{border-right-color:#f8f8f8}.b-b-light{border-bottom-color:#f8f8f8}.b-l-light{border-left-color:#f8f8f8}.b-grey{border-color:#424242}.b-t-grey{border-top-color:#424242}.b-r-#ececec{border-right-color:#424242}.b-b-grey{border-bottom-color:#424242}.b-l-grey{border-left-color:#424242}.b-dark{border-color:#2e3e4e}.b-t-dark{border-top-color:#2e3e4e}.b-r-#eaeced{border-right-color:#2e3e4e}.b-b-dark{border-bottom-color:#2e3e4e}.b-l-dark{border-left-color:#2e3e4e}.b-black{border-color:#2a2b3c}.b-t-black{border-top-color:#2a2b3c}.b-r-#eaeaec{border-right-color:#2a2b3c}.b-b-black{border-bottom-color:#2a2b3c}.b-l-black{border-left-color:#2a2b3c}.b-white{border-color:#fff}.b-t-white{border-top-color:#fff}.b-r-white{border-right-color:#fff}.b-b-white{border-bottom-color:#fff}.b-l-white{border-left-color:#fff}.b-blue{border-color:#2196f3}.b-t-blue{border-top-color:#2196f3}.b-r-#e9f5fe{border-right-color:#2196f3}.b-b-blue{border-bottom-color:#2196f3}.b-l-blue{border-left-color:#2196f3}.no-b-t{border-top-width:0}.no-b-r{border-right-width:0}.no-b-b{border-bottom-width:0}.no-b-l{border-left-width:0}.b-dashed{border-style:dashed!important}@media (max-width:991px){.no-border-sm{border-width:0}}@media (max-width:767px){.no-border-xs{border-width:0}}.hover-action{display:none}.hover-rotate{transition:all .2s ease-in-out .1s}.hover-anchor:active .hover-action,.hover-anchor:focus .hover-action,.hover-anchor:hover .hover-action{display:inherit}.hover-anchor:active .hover-rotate,.hover-anchor:focus .hover-rotate,.hover-anchor:hover .hover-rotate{transform:rotate(45deg)}.hover-top:focus,.hover-top:hover{position:relative;z-index:1000}.m-a{margin:1rem!important}.m-t{margin-top:1rem!important}.m-r{margin-right:1rem!important}.m-b{margin-bottom:1rem!important}.m-l,.m-x{margin-left:1rem!important}.m-x{margin-right:1rem!important}.m-y{margin-top:1rem!important;margin-bottom:1rem!important}.m-a-lg{margin:3rem!important}.m-t-lg{margin-top:3rem!important}.m-r-lg{margin-right:3rem!important}.m-b-lg{margin-bottom:3rem!important}.m-l-lg,.m-x-lg{margin-left:3rem!important}.m-x-lg{margin-right:3rem!important}.m-y-lg{margin-top:3rem!important;margin-bottom:3rem!important}.m-a-md{margin:1.5rem!important}.m-t-md{margin-top:1.5rem!important}.m-r-md{margin-right:1.5rem!important}.m-b-md{margin-bottom:1.5rem!important}.m-l-md,.m-x-md{margin-left:1.5rem!important}.m-x-md{margin-right:1.5rem!important}.m-y-md{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.m-a-sm{margin:.5rem!important}.m-t-sm{margin-top:.5rem!important}.m-r-sm{margin-right:.5rem!important}.m-b-sm{margin-bottom:.5rem!important}.m-l-sm,.m-x-sm{margin-left:.5rem!important}.m-x-sm{margin-right:.5rem!important}.m-y-sm{margin-top:.5rem!important;margin-bottom:.5rem!important}.m-a-xs{margin:.25rem!important}.m-t-xs{margin-top:.25rem!important}.m-r-xs{margin-right:.25rem!important}.m-b-xs{margin-bottom:.25rem!important}.m-l-xs,.m-x-xs{margin-left:.25rem!important}.m-x-xs{margin-right:.25rem!important}.m-y-xs{margin-top:.25rem!important;margin-bottom:.25rem!important}.p-a{padding:1rem!important}.p-t{padding-top:1rem!important}.p-r{padding-right:1rem!important}.p-b{padding-bottom:1rem!important}.p-l,.p-x{padding-left:1rem!important}.p-x{padding-right:1rem!important}.p-y{padding-top:1rem!important;padding-bottom:1rem!important}.p-a-lg{padding:3rem!important}.p-t-lg{padding-top:3rem!important}.p-r-lg{padding-right:3rem!important}.p-b-lg{padding-bottom:3rem!important}.p-l-lg,.p-x-lg{padding-left:3rem!important}.p-x-lg{padding-right:3rem!important}.p-y-lg{padding-top:3rem!important;padding-bottom:3rem!important}.p-a-md{padding:1.5rem!important}.p-t-md{padding-top:1.5rem!important}.p-r-md{padding-right:1.5rem!important}.p-b-md{padding-bottom:1.5rem!important}.p-l-md,.p-x-md{padding-left:1.5rem!important}.p-x-md{padding-right:1.5rem!important}.p-y-md{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.p-a-sm{padding:.5rem!important}.p-t-sm{padding-top:.5rem!important}.p-r-sm{padding-right:.5rem!important}.p-b-sm{padding-bottom:.5rem!important}.p-l-sm,.p-x-sm{padding-left:.5rem!important}.p-x-sm{padding-right:.5rem!important}.p-y-sm{padding-top:.5rem!important;padding-bottom:.5rem!important}.p-a-xs{padding:.25rem!important}.p-t-xs{padding-top:.25rem!important}.p-r-xs{padding-right:.25rem!important}.p-b-xs{padding-bottom:.25rem!important}.p-l-xs,.p-x-xs{padding-left:.25rem!important}.p-x-xs{padding-right:.25rem!important}.p-y-xs{padding-top:.25rem!important;padding-bottom:.25rem!important}.padding{padding:1.5rem}.margin{margin-bottom:1.5rem}.padding-out{margin:-1.5rem}@media (max-width:991px){.padding{padding:1rem}.padding-out{margin:-1rem}.box,.box-color,.margin{margin-bottom:1rem}}@media (max-width:767px){.padding{padding:.5rem}.padding-out{margin:-.5rem}.box,.box-color,.margin{margin-bottom:.5rem}.no-padding-xs{padding:0}}.no-radius{border-radius:0!important}.no-r-t{border-top-left-radius:0}.no-r-r,.no-r-t{border-top-right-radius:0}.no-r-b,.no-r-r{border-bottom-right-radius:0}.no-r-b,.no-r-l{border-bottom-left-radius:0}.no-r-l{border-top-left-radius:0}.r{border-radius:3px}.r-t{border-top-left-radius:3px}.r-r,.r-t{border-top-right-radius:3px}.r-b,.r-r{border-bottom-right-radius:3px}.r-b,.r-l{border-bottom-left-radius:3px}.r-l{border-top-left-radius:3px}.r-2x{border-radius:6px}.r-3x{border-radius:9px}.scrollable{overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch}.scrollable.hover,.scrollable.hover>.row-inner{overflow-y:hidden}.scrollable.hover>*{margin-top:-1px}.scrollable.hover:active,.scrollable.hover:focus,.scrollable.hover:hover{overflow:visible;overflow-y:auto}.scrollable.hover:active>.row-inner,.scrollable.hover:focus>.row-inner,.scrollable.hover:hover>.row-inner{overflow-y:auto}.smart .scrollable,.smart .scrollable>.row-inner{overflow-y:auto!important}.scroll-x,.scroll-y{overflow:hidden;-webkit-overflow-scrolling:touch}.scroll-y{overflow-y:auto}.scroll-x{overflow-x:auto}a.primary:hover{background-color:#0bb69f}a.text-primary:hover{color:#0bb69f}.text-primary,.text-primary-hover a:hover{color:#0cc2aa!important}a.warn:hover{background-color:#efb700}a.text-warn:hover{color:#efb700}.text-warn,.text-warn-hover a:hover{color:#fcc100!important}a.accent:hover{background-color:#a180da}a.text-accent:hover{color:#a180da}.text-accent,.text-accent-hover a:hover{color:#a88add!important}a.success:hover{background-color:#63c381}a.text-success:hover{color:#63c381}.text-success,.text-success-hover a:hover{color:#6cc788!important}a.info:hover{background-color:#5b7dff}a.text-info:hover{color:#5b7dff}.text-info,.text-info-hover a:hover{color:#6887ff!important}a.warning:hover{background-color:#f66e90}a.text-warning:hover{color:#f66e90}.text-warning,.text-warning-hover a:hover{color:#f77a99!important}a.danger:hover{background-color:#f3384a}a.text-danger:hover{color:#f3384a}.text-danger,.text-danger-hover a:hover{color:#f44455!important}a.dark:hover{background-color:#293846}a.text-dark:hover{color:#293846}.text-dark,.text-dark-hover a:hover{color:#2e3e4e!important}a.blue:hover{background-color:#1590f2}a.text-blue:hover{color:#1590f2}.text-blue,.text-blue-hover a:hover{color:#2196f3!important}.text-white{color:#fff!important}.text-white-lt{color:hsla(0,0%,100%,.54)}.text-white-dk{color:hsla(0,0%,100%,.87)}.text-black{color:#000}.text-black-lt{color:rgba(0,0,0,.54)}.text-black-dk{color:rgba(0,0,0,.87)}.text-muted{color:inherit!important;opacity:.6}.text-color{color:rgba(0,0,0,.87)}._100{font-weight:100}._200{font-weight:200}._300{font-weight:300}._400{font-weight:400}._500{font-weight:500}._600{font-weight:600}._700{font-weight:700}._800{font-weight:800}.text{font-size:1rem}.text-xs{font-size:.75rem}.text-sm{font-size:.8rem}.text-md{font-size:1.125rem}.text-lg{font-size:1.5rem}.text-2x{font-size:2em}.text-3x{font-size:3em}.text-4x{font-size:4em}.l-h{line-height:1.5}.l-h-1x{line-height:1}.l-h-2x{line-height:2em}.l-s-1x{letter-spacing:1px}.l-s-2x{letter-spacing:2px}.l-s-3x{letter-spacing:3px}.l-s-4x{letter-spacing:4px}.l-s-n-1x{letter-spacing:-1px}.l-s-n-2x{letter-spacing:-2px}.l-s-n-3x{letter-spacing:-3px}.l-s-n-4x{letter-spacing:-4px}.h-1x{height:1.5;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.h-2x{height:2.625rem;-webkit-line-clamp:2}.h-2x,.h-3x{overflow:hidden;display:-webkit-box}.h-3x{height:3.9375rem;-webkit-line-clamp:3}.h-4x{height:5.25rem;overflow:hidden;display:-webkit-box;-webkit-line-clamp:4}.text-u-c{text-transform:uppercase}.text-l-t{text-decoration:line-through}.text-u-l{text-decoration:underline}.text-ellipsis{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.text-shadow{text-shadow:0 1px 0 rgba(0,0,0,.1)}.w-8{width:8px;height:8px}.w-8,.w-16{display:inline-block}.w-16{width:16px;height:16px}.w-18{width:18px;height:18px}.w-18,.w-20{display:inline-block}.w-20{width:20px;height:20px}.w-24{width:24px;height:24px}.w-24,.w-32{display:inline-block;text-align:center}.w-32{width:32px;height:32px;line-height:32px}.w-40{width:40px;height:40px;line-height:40px}.w-40,.w-48{display:inline-block;text-align:center}.w-48{width:48px;height:48px;line-height:48px}.w-56{width:56px;height:56px;line-height:56px;display:inline-block;text-align:center}.w-64{width:64px}.w-96{width:96px}.w-128{width:128px}.w-xxs{width:60px}.w-xs{width:90px}.w-sm{width:120px}.w{width:180px}.w-md{width:200px}.w-lg{width:240px}.w-xl{width:280px}.w-xxl{width:320px}.w-full{width:100%}.w-auto{width:auto}.h-auto{height:auto}.h-full{height:100%}.h-v{height:100vh}.h-v-5{height:50vh}@media (max-width:767px){.w-auto-sm{width:auto}.w-full-sm{width:100%}}@media (max-width:543px){.w-auto-xs{width:auto}.w-full-xs{width:100%}}.md-btn{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;outline:none;border:0;border-radius:3px;padding:6px;display:inline-block;white-space:nowrap;text-align:center;text-transform:uppercase;font-weight:700;font-style:inherit;font-variant:inherit;font-size:inherit;font-family:inherit;line-height:inherit;text-decoration:none;cursor:pointer;overflow:hidden;transition:box-shadow .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),transform .4s cubic-bezier(.25,.8,.25,1)}.md-flat{background:transparent}.md-btn.md-flat:not([disabled]):focus,.md-btn.md-flat:not([disabled]):hover{background-color:hsla(0,0%,62%,.2)}.md-btn-circle{width:28px;height:28px;border-radius:50%;padding:2px}.md-btn.md-fab[disabled],.md-btn.md-raised[disabled],.md-btn[disabled]{color:rgba(0,0,0,.26);background-color:transparent;cursor:not-allowed}.md-fab{line-height:44px}.md-fab-offset{margin-top:-20px;margin-bottom:-20px}.md-btn:focus{outline:none}.md-btn:hover{text-decoration:none}.md-btn.md-cornered{border-radius:0}.md-btn.md-icon{padding:0;background:none}.md-btn.md-fab,.md-btn.md-raised{transform:translateZ(0)}.md-btn.md-fab{z-index:20;width:56px;height:56px;border-radius:50%;overflow:hidden;transition:.2s linear;transition-property:transform,box-shadow}.md-btn.md-fab,.md-btn.md-raised:not([disabled]){box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.md-btn.md-fab:not([disabled]):focus,.md-btn.md-fab:not([disabled]):hover,.md-btn.md-raised:not([disabled]):focus,.md-btn.md-raised:not([disabled]):hover{box-shadow:0 4px 8px 0 rgba(0,0,0,.4);transform:translate3d(0,-1px,0)}.md-fab-bottom-right{top:auto;right:20px;bottom:20px;left:auto;position:absolute}.md-fab-bottom-left{top:auto;right:auto;bottom:20px;left:20px;position:absolute}.md-fab-top-right{right:20px;left:auto}.md-fab-top-left,.md-fab-top-right{top:20px;bottom:auto;position:absolute}.md-fab-top-left{right:auto;left:20px}.md-btn.md-fab.md-mini{width:40px;height:40px;line-height:28px}.red{background-color:#f44336;color:hsla(0,0%,100%,.87)}.red-50{background-color:#ffebee}.red-50,.red-100{color:rgba(0,0,0,.87)}.red-100{background-color:#ffcdd2}.red-200{background-color:#ef9a9a}.red-200,.red-300{color:rgba(0,0,0,.87)}.red-300{background-color:#e57373}.red-400{background-color:#ef5350;color:rgba(0,0,0,.87)}.red-500{background-color:#f44336}.red-500,.red-600{color:hsla(0,0%,100%,.87)}.red-600{background-color:#e53935}.red-700{background-color:#d32f2f}.red-700,.red-800{color:hsla(0,0%,100%,.87)}.red-800{background-color:#c62828}.red-900{background-color:#b71c1c;color:hsla(0,0%,100%,.87)}.red-A100{background-color:#ff8a80;color:rgba(0,0,0,.87)}.red-A200{background-color:#ff5252}.red-A200,.red-A400{color:hsla(0,0%,100%,.87)}.red-A400{background-color:#ff1744}.red-A700{background-color:#d50000}.pink,.red-A700{color:hsla(0,0%,100%,.87)}.pink{background-color:#e91e63}.pink-50{background-color:#fce4ec}.pink-50,.pink-100{color:rgba(0,0,0,.87)}.pink-100{background-color:#f8bbd0}.pink-200{background-color:#f48fb1}.pink-200,.pink-300{color:rgba(0,0,0,.87)}.pink-300{background-color:#f06292}.pink-400{background-color:#ec407a;color:rgba(0,0,0,.87)}.pink-500{background-color:#e91e63}.pink-500,.pink-600{color:hsla(0,0%,100%,.87)}.pink-600{background-color:#d81b60}.pink-700{background-color:#c2185b}.pink-700,.pink-800{color:hsla(0,0%,100%,.87)}.pink-800{background-color:#ad1457}.pink-900{background-color:#880e4f;color:hsla(0,0%,100%,.87)}.pink-A100{background-color:#ff80ab;color:rgba(0,0,0,.87)}.pink-A200{background-color:#ff4081}.pink-A200,.pink-A400{color:hsla(0,0%,100%,.87)}.pink-A400{background-color:#f50057}.pink-A700{background-color:#c51162}.pink-A700,.purple{color:hsla(0,0%,100%,.87)}.purple{background-color:#9c27b0}.purple-50{background-color:#f3e5f5;color:rgba(0,0,0,.87)}.purple-100{background-color:#e1bee7;color:rgba(0,0,0,.87)}.purple-200{background-color:#ce93d8;color:rgba(0,0,0,.87)}.purple-300{background-color:#ba68c8}.purple-300,.purple-400{color:hsla(0,0%,100%,.87)}.purple-400{background-color:#ab47bc}.purple-500{background-color:#9c27b0}.purple-500,.purple-600{color:hsla(0,0%,100%,.87)}.purple-600{background-color:#8e24aa}.purple-700{background-color:#7b1fa2}.purple-700,.purple-800{color:hsla(0,0%,100%,.87)}.purple-800{background-color:#6a1b9a}.purple-900{background-color:#4a148c;color:hsla(0,0%,100%,.87)}.purple-A100{background-color:#ea80fc;color:rgba(0,0,0,.87)}.purple-A200{background-color:#e040fb;color:hsla(0,0%,100%,.87)}.purple-A400{background-color:#d500f9;color:hsla(0,0%,100%,.87)}.purple-A700{background-color:#a0f;color:hsla(0,0%,100%,.87)}.deep-purple{background-color:#673ab7;color:hsla(0,0%,100%,.87)}.deep-purple-50{background-color:#ede7f6;color:rgba(0,0,0,.87)}.deep-purple-100{background-color:#d1c4e9;color:rgba(0,0,0,.87)}.deep-purple-200{background-color:#b39ddb;color:rgba(0,0,0,.87)}.deep-purple-300{background-color:#9575cd;color:hsla(0,0%,100%,.87)}.deep-purple-400{background-color:#7e57c2;color:hsla(0,0%,100%,.87)}.deep-purple-500{background-color:#673ab7;color:hsla(0,0%,100%,.87)}.deep-purple-600{background-color:#5e35b1;color:hsla(0,0%,100%,.87)}.deep-purple-700{background-color:#512da8;color:hsla(0,0%,100%,.87)}.deep-purple-800{background-color:#4527a0;color:hsla(0,0%,100%,.87)}.deep-purple-900{background-color:#311b92;color:hsla(0,0%,100%,.87)}.deep-purple-A100{background-color:#b388ff;color:rgba(0,0,0,.87)}.deep-purple-A200{background-color:#7c4dff;color:hsla(0,0%,100%,.87)}.deep-purple-A400{background-color:#651fff;color:hsla(0,0%,100%,.87)}.deep-purple-A700{background-color:#6200ea;color:hsla(0,0%,100%,.87)}.indigo{background-color:#3f51b5;color:hsla(0,0%,100%,.87)}.indigo-50{background-color:#e8eaf6;color:rgba(0,0,0,.87)}.indigo-100{background-color:#c5cae9;color:rgba(0,0,0,.87)}.indigo-200{background-color:#9fa8da;color:rgba(0,0,0,.87)}.indigo-300{background-color:#7986cb}.indigo-300,.indigo-400{color:hsla(0,0%,100%,.87)}.indigo-400{background-color:#5c6bc0}.indigo-500{background-color:#3f51b5}.indigo-500,.indigo-600{color:hsla(0,0%,100%,.87)}.indigo-600{background-color:#3949ab}.indigo-700{background-color:#303f9f}.indigo-700,.indigo-800{color:hsla(0,0%,100%,.87)}.indigo-800{background-color:#283593}.indigo-900{background-color:#1a237e;color:hsla(0,0%,100%,.87)}.indigo-A100{background-color:#8c9eff;color:rgba(0,0,0,.87)}.indigo-A200{background-color:#536dfe;color:hsla(0,0%,100%,.87)}.indigo-A400{background-color:#3d5afe;color:hsla(0,0%,100%,.87)}.indigo-A700{background-color:#304ffe}.blue,.indigo-A700{color:hsla(0,0%,100%,.87)}.blue{background-color:#2196f3}.blue-50{background-color:#e3f2fd}.blue-50,.blue-100{color:rgba(0,0,0,.87)}.blue-100{background-color:#bbdefb}.blue-200{background-color:#90caf9}.blue-200,.blue-300{color:rgba(0,0,0,.87)}.blue-300{background-color:#64b5f6}.blue-400{background-color:#42a5f5;color:rgba(0,0,0,.87)}.blue-500{background-color:#2196f3}.blue-500,.blue-600{color:hsla(0,0%,100%,.87)}.blue-600{background-color:#1e88e5}.blue-700{background-color:#1976d2}.blue-700,.blue-800{color:hsla(0,0%,100%,.87)}.blue-800{background-color:#1565c0}.blue-900{background-color:#0d47a1;color:hsla(0,0%,100%,.87)}.blue-A100{background-color:#82b1ff;color:rgba(0,0,0,.87)}.blue-A200{background-color:#448aff}.blue-A200,.blue-A400{color:hsla(0,0%,100%,.87)}.blue-A400{background-color:#2979ff}.blue-A700{background-color:#2962ff}.blue-A700,.light-blue{color:hsla(0,0%,100%,.87)}.light-blue{background-color:#03a9f4}.light-blue-50{background-color:#e1f5fe;color:rgba(0,0,0,.87)}.light-blue-100{background-color:#b3e5fc;color:rgba(0,0,0,.87)}.light-blue-200{background-color:#81d4fa;color:rgba(0,0,0,.87)}.light-blue-300{background-color:#4fc3f7;color:rgba(0,0,0,.87)}.light-blue-400{background-color:#29b6f6;color:rgba(0,0,0,.87)}.light-blue-500{background-color:#03a9f4;color:hsla(0,0%,100%,.87)}.light-blue-600{background-color:#039be5;color:hsla(0,0%,100%,.87)}.light-blue-700{background-color:#0288d1;color:hsla(0,0%,100%,.87)}.light-blue-800{background-color:#0277bd;color:hsla(0,0%,100%,.87)}.light-blue-900{background-color:#01579b;color:hsla(0,0%,100%,.87)}.light-blue-A100{background-color:#80d8ff;color:rgba(0,0,0,.87)}.light-blue-A200{background-color:#40c4ff;color:rgba(0,0,0,.87)}.light-blue-A400{background-color:#00b0ff;color:rgba(0,0,0,.87)}.light-blue-A700{background-color:#0091ea}.cyan,.light-blue-A700{color:hsla(0,0%,100%,.87)}.cyan{background-color:#00bcd4}.cyan-50{background-color:#e0f7fa}.cyan-50,.cyan-100{color:rgba(0,0,0,.87)}.cyan-100{background-color:#b2ebf2}.cyan-200{background-color:#80deea}.cyan-200,.cyan-300{color:rgba(0,0,0,.87)}.cyan-300{background-color:#4dd0e1}.cyan-400{background-color:#26c6da;color:rgba(0,0,0,.87)}.cyan-500{background-color:#00bcd4}.cyan-500,.cyan-600{color:hsla(0,0%,100%,.87)}.cyan-600{background-color:#00acc1}.cyan-700{background-color:#0097a7}.cyan-700,.cyan-800{color:hsla(0,0%,100%,.87)}.cyan-800{background-color:#00838f}.cyan-900{background-color:#006064;color:hsla(0,0%,100%,.87)}.cyan-A100{background-color:#84ffff;color:rgba(0,0,0,.87)}.cyan-A200{background-color:#18ffff;color:rgba(0,0,0,.87)}.cyan-A400{background-color:#00e5ff;color:rgba(0,0,0,.87)}.cyan-A700{background-color:#00b8d4;color:rgba(0,0,0,.87)}.teal{background-color:#009688;color:hsla(0,0%,100%,.87)}.teal-50{background-color:#e0f2f1}.teal-50,.teal-100{color:rgba(0,0,0,.87)}.teal-100{background-color:#b2dfdb}.teal-200{background-color:#80cbc4}.teal-200,.teal-300{color:rgba(0,0,0,.87)}.teal-300{background-color:#4db6ac}.teal-400{background-color:#26a69a;color:rgba(0,0,0,.87)}.teal-500{background-color:#009688}.teal-500,.teal-600{color:hsla(0,0%,100%,.87)}.teal-600{background-color:#00897b}.teal-700{background-color:#00796b}.teal-700,.teal-800{color:hsla(0,0%,100%,.87)}.teal-800{background-color:#00695c}.teal-900{background-color:#004d40;color:hsla(0,0%,100%,.87)}.teal-A100{background-color:#a7ffeb;color:rgba(0,0,0,.87)}.teal-A200{background-color:#64ffda;color:rgba(0,0,0,.87)}.teal-A400{background-color:#1de9b6;color:rgba(0,0,0,.87)}.teal-A700{background-color:#00bfa5;color:rgba(0,0,0,.87)}.green{background-color:#4caf50;color:hsla(0,0%,100%,.87)}.green-50{background-color:#e8f5e9}.green-50,.green-100{color:rgba(0,0,0,.87)}.green-100{background-color:#c8e6c9}.green-200{background-color:#a5d6a7;color:rgba(0,0,0,.87)}.green-300{background-color:#81c784;color:rgba(0,0,0,.87)}.green-400{background-color:#66bb6a;color:rgba(0,0,0,.87)}.green-500{background-color:#4caf50}.green-500,.green-600{color:hsla(0,0%,100%,.87)}.green-600{background-color:#43a047}.green-700{background-color:#388e3c}.green-700,.green-800{color:hsla(0,0%,100%,.87)}.green-800{background-color:#2e7d32}.green-900{background-color:#1b5e20;color:hsla(0,0%,100%,.87)}.green-A100{background-color:#b9f6ca;color:rgba(0,0,0,.87)}.green-A200{background-color:#69f0ae;color:rgba(0,0,0,.87)}.green-A400{background-color:#00e676;color:rgba(0,0,0,.87)}.green-A700{background-color:#00c853;color:rgba(0,0,0,.87)}.light-green{background-color:#8bc34a;color:rgba(0,0,0,.87)}.light-green-50{background-color:#f1f8e9;color:rgba(0,0,0,.87)}.light-green-100{background-color:#dcedc8;color:rgba(0,0,0,.87)}.light-green-200{background-color:#c5e1a5;color:rgba(0,0,0,.87)}.light-green-300{background-color:#aed581;color:rgba(0,0,0,.87)}.light-green-400{background-color:#9ccc65;color:rgba(0,0,0,.87)}.light-green-500{background-color:#8bc34a;color:rgba(0,0,0,.87)}.light-green-600{background-color:#7cb342;color:rgba(0,0,0,.87)}.light-green-700{background-color:#689f38;color:rgba(0,0,0,.87)}.light-green-800{background-color:#558b2f;color:hsla(0,0%,100%,.87)}.light-green-900{background-color:#33691e;color:hsla(0,0%,100%,.87)}.light-green-A100{background-color:#ccff90;color:rgba(0,0,0,.87)}.light-green-A200{background-color:#b2ff59;color:rgba(0,0,0,.87)}.light-green-A400{background-color:#76ff03;color:rgba(0,0,0,.87)}.light-green-A700{background-color:#64dd17;color:rgba(0,0,0,.87)}.lime{background-color:#cddc39}.lime,.lime-50{color:rgba(0,0,0,.87)}.lime-50{background-color:#f9fbe7}.lime-100{background-color:#f0f4c3}.lime-100,.lime-200{color:rgba(0,0,0,.87)}.lime-200{background-color:#e6ee9c}.lime-300{background-color:#dce775}.lime-300,.lime-400{color:rgba(0,0,0,.87)}.lime-400{background-color:#d4e157}.lime-500{background-color:#cddc39}.lime-500,.lime-600{color:rgba(0,0,0,.87)}.lime-600{background-color:#c0ca33}.lime-700{background-color:#afb42b}.lime-700,.lime-800{color:rgba(0,0,0,.87)}.lime-800{background-color:#9e9d24}.lime-900{background-color:#827717;color:hsla(0,0%,100%,.87)}.lime-A100{background-color:#f4ff81;color:rgba(0,0,0,.87)}.lime-A200{background-color:#eeff41;color:rgba(0,0,0,.87)}.lime-A400{background-color:#c6ff00;color:rgba(0,0,0,.87)}.lime-A700{background-color:#aeea00}.lime-A700,.yellow{color:rgba(0,0,0,.87)}.yellow{background-color:#ffeb3b}.yellow-50{background-color:#fffde7;color:rgba(0,0,0,.87)}.yellow-100{background-color:#fff9c4;color:rgba(0,0,0,.87)}.yellow-200{background-color:#fff59d;color:rgba(0,0,0,.87)}.yellow-300{background-color:#fff176;color:rgba(0,0,0,.87)}.yellow-400{background-color:#ffee58;color:rgba(0,0,0,.87)}.yellow-500{background-color:#ffeb3b;color:rgba(0,0,0,.87)}.yellow-600{background-color:#fdd835;color:rgba(0,0,0,.87)}.yellow-700{background-color:#fbc02d;color:rgba(0,0,0,.87)}.yellow-800{background-color:#f9a825;color:rgba(0,0,0,.87)}.yellow-900{background-color:#f57f17;color:rgba(0,0,0,.87)}.yellow-A100{background-color:#ffff8d;color:rgba(0,0,0,.87)}.yellow-A200{background-color:#ff0;color:rgba(0,0,0,.87)}.yellow-A400{background-color:#ffea00;color:rgba(0,0,0,.87)}.yellow-A700{background-color:#ffd600}.amber,.yellow-A700{color:rgba(0,0,0,.87)}.amber{background-color:#ffc107}.amber-50{background-color:#fff8e1}.amber-50,.amber-100{color:rgba(0,0,0,.87)}.amber-100{background-color:#ffecb3}.amber-200{background-color:#ffe082;color:rgba(0,0,0,.87)}.amber-300{background-color:#ffd54f;color:rgba(0,0,0,.87)}.amber-400{background-color:#ffca28;color:rgba(0,0,0,.87)}.amber-500{background-color:#ffc107;color:rgba(0,0,0,.87)}.amber-600{background-color:#ffb300;color:rgba(0,0,0,.87)}.amber-700{background-color:#ffa000;color:rgba(0,0,0,.87)}.amber-800{background-color:#ff8f00;color:rgba(0,0,0,.87)}.amber-900{background-color:#ff6f00;color:rgba(0,0,0,.87)}.amber-A100{background-color:#ffe57f;color:rgba(0,0,0,.87)}.amber-A200{background-color:#ffd740;color:rgba(0,0,0,.87)}.amber-A400{background-color:#ffc400;color:rgba(0,0,0,.87)}.amber-A700{background-color:#ffab00}.amber-A700,.orange{color:rgba(0,0,0,.87)}.orange{background-color:#ff9800}.orange-50{background-color:#fff3e0;color:rgba(0,0,0,.87)}.orange-100{background-color:#ffe0b2;color:rgba(0,0,0,.87)}.orange-200{background-color:#ffcc80;color:rgba(0,0,0,.87)}.orange-300{background-color:#ffb74d;color:rgba(0,0,0,.87)}.orange-400{background-color:#ffa726;color:rgba(0,0,0,.87)}.orange-500{background-color:#ff9800;color:rgba(0,0,0,.87)}.orange-600{background-color:#fb8c00;color:rgba(0,0,0,.87)}.orange-700{background-color:#f57c00;color:rgba(0,0,0,.87)}.orange-800{background-color:#ef6c00}.orange-800,.orange-900{color:hsla(0,0%,100%,.87)}.orange-900{background-color:#e65100}.orange-A100{background-color:#ffd180;color:rgba(0,0,0,.87)}.orange-A200{background-color:#ffab40;color:rgba(0,0,0,.87)}.orange-A400{background-color:#ff9100;color:rgba(0,0,0,.87)}.orange-A700{background-color:#ff6d00;color:rgba(0,0,0,.87)}.deep-orange{background-color:#ff5722;color:hsla(0,0%,100%,.87)}.deep-orange-50{background-color:#fbe9e7;color:rgba(0,0,0,.87)}.deep-orange-100{background-color:#ffccbc;color:rgba(0,0,0,.87)}.deep-orange-200{background-color:#ffab91;color:rgba(0,0,0,.87)}.deep-orange-300{background-color:#ff8a65;color:rgba(0,0,0,.87)}.deep-orange-400{background-color:#ff7043;color:rgba(0,0,0,.87)}.deep-orange-500{background-color:#ff5722;color:hsla(0,0%,100%,.87)}.deep-orange-600{background-color:#f4511e;color:hsla(0,0%,100%,.87)}.deep-orange-700{background-color:#e64a19;color:hsla(0,0%,100%,.87)}.deep-orange-800{background-color:#d84315;color:hsla(0,0%,100%,.87)}.deep-orange-900{background-color:#bf360c;color:hsla(0,0%,100%,.87)}.deep-orange-A100{background-color:#ff9e80;color:rgba(0,0,0,.87)}.deep-orange-A200{background-color:#ff6e40;color:rgba(0,0,0,.87)}.deep-orange-A400{background-color:#ff3d00;color:hsla(0,0%,100%,.87)}.deep-orange-A700{background-color:#dd2c00}.brown,.deep-orange-A700{color:hsla(0,0%,100%,.87)}.brown{background-color:#795548}.brown-50{background-color:#efebe9}.brown-50,.brown-100{color:rgba(0,0,0,.87)}.brown-100{background-color:#d7ccc8}.brown-200{background-color:#bcaaa4;color:rgba(0,0,0,.87)}.brown-300{background-color:#a1887f}.brown-300,.brown-400{color:hsla(0,0%,100%,.87)}.brown-400{background-color:#8d6e63}.brown-500{background-color:#795548}.brown-500,.brown-600{color:hsla(0,0%,100%,.87)}.brown-600{background-color:#6d4c41}.brown-700{background-color:#5d4037}.brown-700,.brown-800{color:hsla(0,0%,100%,.87)}.brown-800{background-color:#4e342e}.brown-900{background-color:#3e2723}.blue-grey,.brown-900{color:hsla(0,0%,100%,.87)}.blue-grey{background-color:#607d8b}.blue-grey-50{background-color:#eceff1;color:rgba(0,0,0,.87)}.blue-grey-100{background-color:#cfd8dc;color:rgba(0,0,0,.87)}.blue-grey-200{background-color:#b0bec5;color:rgba(0,0,0,.87)}.blue-grey-300{background-color:#90a4ae;color:rgba(0,0,0,.87)}.blue-grey-400{background-color:#78909c;color:hsla(0,0%,100%,.87)}.blue-grey-500{background-color:#607d8b;color:hsla(0,0%,100%,.87)}.blue-grey-600{background-color:#546e7a;color:hsla(0,0%,100%,.87)}.blue-grey-700{background-color:#455a64;color:hsla(0,0%,100%,.87)}.blue-grey-800{background-color:#37474f;color:hsla(0,0%,100%,.87)}.blue-grey-900{background-color:#263238;color:hsla(0,0%,100%,.87)}.grey-50{background-color:#fafafa}.grey-50,.grey-100{color:rgba(0,0,0,.87)}.grey-100{background-color:#f5f5f5}.grey-200{background-color:#eee}.grey-200,.grey-300{color:rgba(0,0,0,.87)}.grey-300{background-color:#e0e0e0}.grey-400{background-color:#bdbdbd}.grey-400,.grey-500{color:rgba(0,0,0,.87)}.grey-500{background-color:#9e9e9e}.grey-600{background-color:#757575}.grey-600,.grey-700{color:hsla(0,0%,100%,.87)}.grey-700{background-color:#616161}.grey-800{background-color:#424242}.grey-800,.grey-900{color:hsla(0,0%,100%,.87)}.grey-900{background-color:#212121}.md-form-group{padding:18px 0 24px;position:relative}.md-input{background:transparent;position:relative;z-index:5;border:0;box-shadow:none;border-radius:0;border-bottom:1px solid hsla(0,0%,63%,.2);width:100%;height:34px;padding:2px;color:inherit}.md-input.focus,.md-input:focus{border-color:#0cc2aa;border-bottom-width:2px;padding-bottom:1px}.md-input.focus~label,.md-input:focus~label{color:#0cc2aa;opacity:1;top:0!important;font-size:.85em!important}.float-label .md-input~label{top:20px;font-size:1em}.float-label .md-input.has-value~label,.float-label .md-input.ng-dirty~label,.md-input~label{top:0;font-size:.85em}.md-input~label{transition:all .2s;position:absolute;z-index:0;opacity:.5;display:inline-block;left:0}.md-input.disabled,.md-input[disabled]{opacity:.5}textarea.md-input{height:auto}.md-input-white.focus,.md-input-white:focus{border-color:#fff}.md-input-white.focus~label,.md-input-white:focus~label{color:#fff}.md-input-msg{position:absolute;bottom:0;line-height:24px;font-size:.85em}.md-input-msg.right{right:0}.md-check{cursor:pointer;padding-left:1.25rem;margin:0;display:inline-block;position:relative}.md-check input{position:absolute;cursor:pointer;z-index:1;opacity:0;margin-left:-1.25rem}.md-check input:checked+i:before{border-width:0;background-color:inherit}.md-check input:checked+span .active{display:inherit}.md-check input[type=radio]+i,.md-check input[type=radio]+i:before{border-radius:50%}.md-check input[type=checkbox]:checked+i:after{transform:rotate(45deg);position:absolute;left:6px;top:2px;display:table;width:6px;height:12px;border:2px solid;border-top:0;border-left:0;content:\" \"}.md-check input[type=radio]:checked+i:after{position:absolute;left:6px;top:6px;display:table;width:6px;height:6px;background:#fff;border-radius:50%;content:\" \"}.md-check input[disabled]+i:before,.md-check input[disabled]:checked+i:before,fieldset[disabled] .md-check input+i:before{opacity:.5}.md-check>i{width:0;height:18px;line-height:1;margin-left:-20px;margin-top:1px;float:left;display:inline-block;vertical-align:middle;margin-right:28px;position:relative}.md-check>i:before{content:\"\";position:absolute;width:18px;height:100%;border:2px solid #9e9e9e;border-radius:2px}.md-check>i.no-icon:after{display:none!important}.md-switch{cursor:pointer;padding-left:36px;margin:0;min-height:20px}.md-switch input{position:absolute;cursor:pointer;width:36px;height:20px;z-index:1;opacity:0;margin-left:-36px}.md-switch input:checked+i:before{background:inherit;opacity:.5}.md-switch input:checked+i:after{background:inherit;left:16px}.md-switch input[disabled]+i:before,fieldset[disabled] .md-switch input+i:before{background-color:rgba(0,0,0,.12)}.md-switch input[disabled]+i:after,fieldset[disabled] .md-switch input+i:after{background-color:#bdbdbd}.md-switch i{width:0;height:18px;line-height:1;margin-left:-36px;margin-top:-2px;display:inline-block;vertical-align:middle;margin-right:44px;position:relative}.md-switch i:before{left:1px;width:34px;top:3px;height:14px;border-radius:8px;background-color:#9e9e9e}.md-switch i:after,.md-switch i:before{content:\"\";position:absolute;transition:all .2s}.md-switch i:after{margin:0;left:0;top:0;outline:none;height:20px;width:20px;border-radius:50%;background-color:#fff;box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.animated{animation-duration:.5s}[ui-view].ng-leave{display:none}[ui-view].ng-leave.smooth{display:block}.smooth.ng-animate{position:absolute;width:100%;height:100%;overflow:hidden}.fade-in-right-big.ng-enter{animation:fadeInRightBig .5s}.fade-in-right-big.ng-leave{animation:fadeOutLeftBig .5s}.fade-in-left-big.ng-enter{animation:fadeInLeftBig .5s}.fade-in-left-big.ng-leave{animation:fadeOutRightBig .5s}.fade-in-up-big.ng-enter{animation:fadeInUpBig .5s}.fade-in-up-big.ng-leave{animation:fadeOutUpBig .5s}.fade-in-down-big.ng-enter{animation:fadeInDownBig .5s}.fade-in-down-big.ng-leave{animation:fadeOutDownBig .5s}.fade-in.ng-enter{animation:fadeIn .5s}.fade-in.ng-leave{animation:fadeOut .5s}.fade-in-right.ng-enter{animation:fadeInRight .5s}.fade-in-right.ng-leave{animation:fadeOutLeft .5s}.fade-in-left.ng-enter{animation:fadeInLeft .5s}.fade-in-left.ng-leave{animation:fadeOutRight .5s}.fade-in-up.ng-enter{animation:fadeInUp .5s}.fade-in-up.ng-leave{animation:fadeOutUp .5s}.fade-in-down.ng-enter{animation:fadeInDown .5s}.fade-in-down.ng-leave{animation:fadeOutDown .5s}.datetimepicker{border-radius:4px;direction:ltr;display:block;margin-top:1px;user-select:none;width:320px}.datetimepicker>div{display:none}.datetimepicker .hour,.datetimepicker .minute{height:34px;line-height:34px;margin:0;width:25%}.datetimepicker .table{margin:0}.datetimepicker .table td,.datetimepicker .table th{border:0;border-radius:4px;height:20px;text-align:center}.datetimepicker .day:hover,.datetimepicker .hour:hover,.datetimepicker .left:hover,.datetimepicker .minute:hover,.datetimepicker .right:hover,.datetimepicker .switch:hover{background:#eee;cursor:pointer}.datetimepicker .disabled,.datetimepicker .disabled:hover{background:none;color:#ebebeb;cursor:default}.datetimepicker .active,.datetimepicker .active.disabled,.datetimepicker .active.disabled:hover,.datetimepicker .active:hover{background-color:#04c;background-image:linear-gradient(180deg,#08c,#04c);background-repeat:repeat-x;border-color:#04c #04c #002a80;color:#fff;filter:progid:dximagetransform.microsoft.gradient(startColorstr=\"#08c\",endColorstr=\"#04c\",GradientType=0);text-shadow:0 -1px 0 rgba(0,0,0,.25)}.datetimepicker .current,.datetimepicker .current.disabled,.datetimepicker .current.disabled:hover,.datetimepicker .current:hover{background-color:#e5e5e5}.datetimepicker .active.active,.datetimepicker .active.disabled,.datetimepicker .active.disabled.active,.datetimepicker .active.disabled.disabled,.datetimepicker .active.disabled:active,.datetimepicker .active.disabled:hover,.datetimepicker .active.disabled:hover.active,.datetimepicker .active.disabled:hover.disabled,.datetimepicker .active.disabled:hover:active,.datetimepicker .active.disabled:hover:hover,.datetimepicker .active:active,.datetimepicker .active:hover,.datetimepicker .active:hover.active,.datetimepicker .active:hover.disabled,.datetimepicker .active:hover:active,.datetimepicker .active:hover:hover,.datetimepicker span.active.disabled:hover[disabled],.datetimepicker span.active.disabled[disabled],.datetimepicker span.active:hover[disabled],.datetimepicker span.active[disabled],.datetimepicker td.active.disabled:hover[disabled],.datetimepicker td.active.disabled[disabled],.datetimepicker td.active:hover[disabled],.datetimepicker td.active[disabled]{background-color:#04c}.datetimepicker span{border-radius:4px;cursor:pointer;display:block;float:left;height:54px;line-height:54px;margin:1%;width:23%}.datetimepicker span:hover{background:#eee}.datetimepicker .future,.datetimepicker .past{color:#999}body{font-family:Tahoma,Roboto,Helvetica Neue,Helvetica,Arial,sans-serif}", ""]);
	
	// exports


/***/ }),
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 944,
		"./af.js": 944,
		"./ar": 945,
		"./ar-dz": 946,
		"./ar-dz.js": 946,
		"./ar-kw": 947,
		"./ar-kw.js": 947,
		"./ar-ly": 948,
		"./ar-ly.js": 948,
		"./ar-ma": 949,
		"./ar-ma.js": 949,
		"./ar-sa": 950,
		"./ar-sa.js": 950,
		"./ar-tn": 951,
		"./ar-tn.js": 951,
		"./ar.js": 945,
		"./az": 952,
		"./az.js": 952,
		"./be": 953,
		"./be.js": 953,
		"./bg": 954,
		"./bg.js": 954,
		"./bm": 955,
		"./bm.js": 955,
		"./bn": 956,
		"./bn-bd": 957,
		"./bn-bd.js": 957,
		"./bn.js": 956,
		"./bo": 958,
		"./bo.js": 958,
		"./br": 959,
		"./br.js": 959,
		"./bs": 960,
		"./bs.js": 960,
		"./ca": 961,
		"./ca.js": 961,
		"./cs": 962,
		"./cs.js": 962,
		"./cv": 963,
		"./cv.js": 963,
		"./cy": 964,
		"./cy.js": 964,
		"./da": 965,
		"./da.js": 965,
		"./de": 966,
		"./de-at": 967,
		"./de-at.js": 967,
		"./de-ch": 968,
		"./de-ch.js": 968,
		"./de.js": 966,
		"./dv": 969,
		"./dv.js": 969,
		"./el": 970,
		"./el.js": 970,
		"./en-au": 971,
		"./en-au.js": 971,
		"./en-ca": 972,
		"./en-ca.js": 972,
		"./en-gb": 973,
		"./en-gb.js": 973,
		"./en-ie": 974,
		"./en-ie.js": 974,
		"./en-il": 975,
		"./en-il.js": 975,
		"./en-in": 976,
		"./en-in.js": 976,
		"./en-nz": 977,
		"./en-nz.js": 977,
		"./en-sg": 978,
		"./en-sg.js": 978,
		"./eo": 979,
		"./eo.js": 979,
		"./es": 980,
		"./es-do": 981,
		"./es-do.js": 981,
		"./es-mx": 982,
		"./es-mx.js": 982,
		"./es-us": 983,
		"./es-us.js": 983,
		"./es.js": 980,
		"./et": 984,
		"./et.js": 984,
		"./eu": 985,
		"./eu.js": 985,
		"./fa": 986,
		"./fa.js": 986,
		"./fi": 987,
		"./fi.js": 987,
		"./fil": 988,
		"./fil.js": 988,
		"./fo": 989,
		"./fo.js": 989,
		"./fr": 990,
		"./fr-ca": 991,
		"./fr-ca.js": 991,
		"./fr-ch": 992,
		"./fr-ch.js": 992,
		"./fr.js": 990,
		"./fy": 993,
		"./fy.js": 993,
		"./ga": 994,
		"./ga.js": 994,
		"./gd": 995,
		"./gd.js": 995,
		"./gl": 996,
		"./gl.js": 996,
		"./gom-deva": 997,
		"./gom-deva.js": 997,
		"./gom-latn": 998,
		"./gom-latn.js": 998,
		"./gu": 999,
		"./gu.js": 999,
		"./he": 1000,
		"./he.js": 1000,
		"./hi": 1001,
		"./hi.js": 1001,
		"./hr": 1002,
		"./hr.js": 1002,
		"./hu": 1003,
		"./hu.js": 1003,
		"./hy-am": 1004,
		"./hy-am.js": 1004,
		"./id": 1005,
		"./id.js": 1005,
		"./is": 1006,
		"./is.js": 1006,
		"./it": 1007,
		"./it-ch": 1008,
		"./it-ch.js": 1008,
		"./it.js": 1007,
		"./ja": 1009,
		"./ja.js": 1009,
		"./jv": 1010,
		"./jv.js": 1010,
		"./ka": 1011,
		"./ka.js": 1011,
		"./kk": 1012,
		"./kk.js": 1012,
		"./km": 1013,
		"./km.js": 1013,
		"./kn": 1014,
		"./kn.js": 1014,
		"./ko": 1015,
		"./ko.js": 1015,
		"./ku": 1016,
		"./ku.js": 1016,
		"./ky": 1017,
		"./ky.js": 1017,
		"./lb": 1018,
		"./lb.js": 1018,
		"./lo": 1019,
		"./lo.js": 1019,
		"./lt": 1020,
		"./lt.js": 1020,
		"./lv": 1021,
		"./lv.js": 1021,
		"./me": 1022,
		"./me.js": 1022,
		"./mi": 1023,
		"./mi.js": 1023,
		"./mk": 1024,
		"./mk.js": 1024,
		"./ml": 1025,
		"./ml.js": 1025,
		"./mn": 1026,
		"./mn.js": 1026,
		"./mr": 1027,
		"./mr.js": 1027,
		"./ms": 1028,
		"./ms-my": 1029,
		"./ms-my.js": 1029,
		"./ms.js": 1028,
		"./mt": 1030,
		"./mt.js": 1030,
		"./my": 1031,
		"./my.js": 1031,
		"./nb": 1032,
		"./nb.js": 1032,
		"./ne": 1033,
		"./ne.js": 1033,
		"./nl": 1034,
		"./nl-be": 1035,
		"./nl-be.js": 1035,
		"./nl.js": 1034,
		"./nn": 1036,
		"./nn.js": 1036,
		"./oc-lnc": 1037,
		"./oc-lnc.js": 1037,
		"./pa-in": 1038,
		"./pa-in.js": 1038,
		"./pl": 1039,
		"./pl.js": 1039,
		"./pt": 1040,
		"./pt-br": 1041,
		"./pt-br.js": 1041,
		"./pt.js": 1040,
		"./ro": 1042,
		"./ro.js": 1042,
		"./ru": 1043,
		"./ru.js": 1043,
		"./sd": 1044,
		"./sd.js": 1044,
		"./se": 1045,
		"./se.js": 1045,
		"./si": 1046,
		"./si.js": 1046,
		"./sk": 1047,
		"./sk.js": 1047,
		"./sl": 1048,
		"./sl.js": 1048,
		"./sq": 1049,
		"./sq.js": 1049,
		"./sr": 1050,
		"./sr-cyrl": 1051,
		"./sr-cyrl.js": 1051,
		"./sr.js": 1050,
		"./ss": 1052,
		"./ss.js": 1052,
		"./sv": 1053,
		"./sv.js": 1053,
		"./sw": 1054,
		"./sw.js": 1054,
		"./ta": 1055,
		"./ta.js": 1055,
		"./te": 1056,
		"./te.js": 1056,
		"./tet": 1057,
		"./tet.js": 1057,
		"./tg": 1058,
		"./tg.js": 1058,
		"./th": 1059,
		"./th.js": 1059,
		"./tk": 1060,
		"./tk.js": 1060,
		"./tl-ph": 1061,
		"./tl-ph.js": 1061,
		"./tlh": 1062,
		"./tlh.js": 1062,
		"./tr": 1063,
		"./tr.js": 1063,
		"./tzl": 1064,
		"./tzl.js": 1064,
		"./tzm": 1065,
		"./tzm-latn": 1066,
		"./tzm-latn.js": 1066,
		"./tzm.js": 1065,
		"./ug-cn": 1067,
		"./ug-cn.js": 1067,
		"./uk": 1068,
		"./uk.js": 1068,
		"./ur": 1069,
		"./ur.js": 1069,
		"./uz": 1070,
		"./uz-latn": 1071,
		"./uz-latn.js": 1071,
		"./uz.js": 1070,
		"./vi": 1072,
		"./vi.js": 1072,
		"./x-pseudo": 1073,
		"./x-pseudo.js": 1073,
		"./yo": 1074,
		"./yo.js": 1074,
		"./zh-cn": 1075,
		"./zh-cn.js": 1075,
		"./zh-hk": 1076,
		"./zh-hk.js": 1076,
		"./zh-mo": 1077,
		"./zh-mo.js": 1077,
		"./zh-tw": 1078,
		"./zh-tw.js": 1078
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 943;


/***/ }),
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */
/***/ (function(module, exports) {

	module.exports = {
		"START_AUTOSCROLL": "Ξεκίνημα αυτόματου scroll σελίδας",
		"STOP_AUTOSCROLL": "Σταμάτημα αυτόματου scroll σελίδας",
		"CHANGE_MATCH": "Αλλαγή αγώνα",
		"MATCH_ID": "ID αγώνα",
		"MATCH_RESULTS": "Αποτελέσματα αγώνων",
		"MOBILE_SCORING_ROUND_1_OPEN": "Επιτρέπεται σκορ από κινητό (Γύρος 1)",
		"MOBILE_SCORING_ROUND_2_OPEN": "Επιτρέπεται σκορ από κινητό (Γύρος 2)",
		"ADD_SHOTS_VISUAL": "Παρακολούθηση στόχων",
		"TARGET_ONE": "Στόχος Νο1",
		"TARGET_TWO": "Στόχος Νο2",
		"DIRECTION": "Κατέυθυνση",
		"NO": "Οχι",
		"YES": "Ναι",
		"FRONT": "Εμπρός",
		"BACK": "Πίσω",
		"CREATED_AT": "Δημιουργήθηκε",
		"UPDATED_AT": "Ενημερώθηκε",
		"DELETE_TRAINING_ENTRY": "Διαγραφή εισόδου προπονητηρίου?",
		"AVAILABLE": "Διαθέσιμο για χρήση",
		"NOT_AVAILABLE": "Μή διαθέσιμο",
		"SELECT_PLAYER": "Επιλέξτε αθλητή",
		"SELECT_TARGET": "Επιλέξτε στόχο",
		"SELECT_LEAGUE": "Επιλέξτε κατηγορία",
		"SELECT_LEAGUES": "Επιλέξτε κατηγορίες",
		"SELECT_MATCH": "Επιλέξτε αγώνα",
		"SELECT_TEAM": "Επιλέξτε σύλλογο",
		"SELECT_SEX": "Επιλέξτε φύλλο",
		"SELECT_PAYMENT": "Επιλέξτε είδος πληρωμής",
		"PLAYERS_PER_TARGET": "Αθλητές άνα στόχο",
		"MATCH_ENTRIES_LIMIT": "Όριο συμμετοχών",
		"UPDATE_PLAYER_LEAGUE": "Αλλαγή κατηγορίας",
		"REGISTRATIONS": "Συμμετοχές",
		"REGISTRATION_OPEN": "Δηλώσεις συμμετοχών ανοιχτές",
		"REGISTRATION_CLOSED": "Δηλώσεις συμμετοχών κλειστές",
		"MOVE_MATCH": "Μεταφορά σε αγώνα",
		"NEW_MATCH": "Αγώνας για μεταφορά",
		"LEAGUES_LIST": "Συμμετοχές Άνα κατηγορία",
		"PLAYERS_LIST": "Συμμετοχές Αλφαβητικά",
		"TEAMS_LIST": "Συμμετοχές Άνα Σύλλογο",
		"TARGETS_LIST": "Συμμετοχές Άνα Στόχο",
		"QUALIFICATION": "Κατάταξη",
		"QR": "QR",
		"MEDALS": "Μετάλλια",
		"PRINTS": "Εκτυπώσεις",
		"DOWNLOAD": "Κατέβασμα",
		"ELIMINATION_ROUNDS": "Ολυμπιακοί Γύροι",
		"ELIMINATION_INDIVIDUAL": "Ατομικά",
		"ELIMINATION_TEAM": "Ομαδικά",
		"ELIMINATION_MIXED_TEAM": "Μικτά Ομαδικά",
		"ELIMINATION_PARTICIPANTS": "Συμμετοχές",
		"SELECT_ELIMINATION_PARTICIPANTS": "Επιλέξτε συμμετοχές",
		"NEXT_ROUND": "Επόμενος Γύρος",
		"PRINT_PDF": "Εκτύπωση",
		"STARTING_ROUND": "Αρχή",
		"CURRENT_ROUND": "Κατάσταση",
		"ADD_ELIMINATION_LEAGUE": "Δημιουργία Κατηγορίας",
		"ELIMINATION_INDIVIDUAL_LEAGUES": "Κατηγορίες Ατομικών Ολυμπιακών Γύρων",
		"ELIMINATION_TEAM_LEAGUES": "Κατηγορίες Ομαδικών Ολυμπιακών Γύρων",
		"ELIMINATION_MIXED_TEAM_LEAGUES": "Κατηγορίες Μικτών Ομαδικών Ολυμπιακών Γύρων",
		"CREATE": "Δημιουργία",
		"PLAYER_ONE": "Αθλητής Νο1",
		"PLAYER_TWO": "Αθλητής Νο2",
		"PLAYER_THREE": "Αθλητής Νο3",
		"UPDATE_TEAM_LEAGUE_PLAYERS": "Ενημέρωση αθλητών ομάδας",
		"FINALIZE_ROUND_ONE": "Ενημέρωση γύρου 1",
		"FINALIZE_ROUND_TWO": "Ενημέρωση γύρου 2",
		"FINALIZE_MATCH": "Ενημέρωση αγώνα",
		"TARGETS_WITH_EMPTY_SHOTS": "Στόχοι που λείπουν βολές",
		"MALE": "Άντρας",
		"FEMALE": "Γυναίκα",
		"PLAYER_PAYMENTS_FULFILLMENT": "Οικονομικές οφειλές",
		"REMOVE": "Αφαίρεση",
		"ADD": "Προσθήκη",
		"ADD_PLAYER_TO_MATCH": "Προσθήκη αθλητή στον αγώνα",
		"CURRENT_PLAYERS": "Τρέχουσες Συμμετοχές",
		"MATCH_ELIGIBILITY_EXPLAIN_TEXT": "Δεν μπορείτε να δηλώσετε τον αθλητή στον αγώνα για τους εξής λόγους:",
		"PRINT_REGISTRATIONS_PDF": "Εκτύπωση PDF τρέχουσας δήλωσης",
		"REGISTRATION_IS_CLOSED": "Οι δηλώσεις συμμετοχών έχουν κλείσει.",
		"ADD_SHOTS": "Προσθήκη Βολών",
		"ROUND_ONE": "Γύρος 1ος",
		"ROUND_TWO": "Γύρος 2ος",
		"CLEAR_ROUND": "Καθαρισμός Βολών Γύρου",
		"FINAl_SCORES_ROW": "Τελικά Σκορ",
		"ADD_SHOTS_INDIVIDUAL": "Προσθήκη Βολών Ατομικών",
		"REQUIRED_BY_TEAM": "Συνδρομή Συλλόγου",
		"REQUIRED_BY_PLAYER": "Συνδρομή Αθλητή",
		"ADD_NEW_PAYMENT": "Προσθήκη νέου είδος πληρωμής",
		"ADD_TEAM_PAYMENT": "Προσθήκη πληρωμής ομάδας",
		"ADD_PLAYER_PAYMENT": "Προσθήκη πληρωμής αθλητή",
		"PAYMENT": "Είδος Πληρωμής",
		"AMOUNT": "Ποσό",
		"STAFF": "Προσωπικό",
		"EDIT_STAFF": "Επεξεργασία Προσωπικού",
		"STAFF_PROFILE": "Προφίλ Προσωπικού",
		"SELECT_ROUND": "Επιλέξτα Γύρο",
		"FINAL_SHOT": "S.O.",
		"ADD_SHOTS_TEAM": "Προσθήκη Βολών Ομαδικών",
		"ADD_SHOTS_MIXED_TEAM": "Προσθήκη Βολών Μικτών Ομαδικών",
		"MATCH_NAME": "Όνομα Αγώνας",
		"MATCH_SORT_NAME": "Συντομογραφία",
		"MATCH_HOST": "Διοργανωτής",
		"MATCH_JUDGE": "Κριτές (Παλιό)",
		"MATCH_REPRESENTER": "Εκπρόσωπος",
		"MATCH_COMMITTEE": "Αγωνόδικος Επιτροπή",
		"MATCH_OFFICIAL": "Επίσημος Αγώνας",
		"MATCH_LOCATION": "Τοποθεσία",
		"MATCH_CUP": "Κύπελλο",
		"MATCH_CHAMPIONSHIP": "Πρωτάθλημα",
		"MATCH_TYPE": "Είδος Αγώνα",
		"MATCH_LEAGUES": "Κατηγορίες Αγώνα",
		"LEAGUE_CAT": "Είδος",
		"EXIT_GAME": "Έξοδος",
		"MATCH_REGISTRATION_START": "Έναρξη Συμμετοχών",
		"MATCH_REGISTRATION_END": "Λήξη Συμμετοχών",
		"EDIT_MATCH": "Επεξεργασία Αγώνα",
		"LEAGUE_TYPE": "Είδος",
		"LEAGUE_SEX": "Φύλλο",
		"LEAGUE_ELIMINATIONS_ELIGIBILITY": "Ολυμπιακοί Γύροι",
		"DISTANCE_INDOOR": "Απόσταση Εσ. Χώρου",
		"DISTANCE_OUTDOOR": "Απόσταση Εξ. Χώρου",
		"LEAGUE_SORT_NAME": "Συντομογραφία",
		"LEAGUE_CODE": "Κωδικός",
		"LEAGUE_ORDER": "Σειρά",
		"EDIT_LEAGUE": "Επεξεργασία Κατηγορίας",
		"SCHOOL": "Σχολική",
		"AGE": "Ηλικία ( ίσο ή μεγαλύτερο )",
		"CREATE_LEAGUE": "Δημιουργία Κατηγορίας",
		"CREATE_MATCH": "Δημιουργία Αγώνα",
		"PICK": "Επιλογή",
		"DOWNLOAD_CARD": "Κάρτα",
		"DOWNLOAD_TRAINING_CARD": "Κάρτα Προπονητηρίου",
		"TRAINING_ENTRIES": "Εισόδοι Προπονητηρίου",
		"ENDED": "Τελείωσε",
		"PAUSED": "Σε παύση",
		"PAUSE": "Παύση",
		"UNPAUSE": "Συνέχεια",
		"END": "Λήξη",
		"START": "Εκκίνηση",
		"START_ENTRY": "Εξαναγκαστική Εκκίνηση",
		"PAUSE_TRAINING_ENTRY": "Θέλετε σίγουρα να κάνετε παύση της εισόδου?",
		"END_TRAINING_ENTRY": "Θέλετε σίγουρα να κάνετε λήξετε την είσοδο?",
		"UNPAUSE_TRAINING_ENTRY": "Θέλετε σίγουρα να κάνετε συνεχίσετε την είσοδο?",
		"ADD_TRAINING_ENTRIES": "Προσθήκη εισόδων προπονητηρίου",
		"START_TRAINING_ENTRY": "Θέλετε να κάνετε χρήση της εισόδου?",
		"TRAINING_CENTER": "Προπονητήριο",
		"OAKA_TRAINING_CENTER": "Προπονητήριο OAKA",
		"CURRENT_ACTIVE_INSIDE": "Εντός προπονητηρίου",
		"INFORMATION": "Πληροφορίες",
		"SORT_NAME": "Συντομογραφία",
		"POSTAL_CODE": "Τ.Κ.",
		"VAT": "Α.Φ.Μ.",
		"OFFICIAL": "Official",
		"IMAGE": "Εικόνα",
		"SELECT_FILE": "Επιλέξτε εικόνα",
		"MAP_LOCATION": "Τοποθεσία",
		"CREATE_TEAM": "Δημιουργία Ομάδας",
		"SELECT_YEAR": "Επιλέξτε χρονιά",
		"SELECT_STATE": "Επιλέξτε νομό",
		"SELECT_COUNTY": "Επιλέξτε δήμο",
		"SELECT_REGION": "Επιλέξτε χώρα",
		"GO_TO_PROFILE": "Προφίλ",
		"MATCHES": "Αγώνες",
		"REPORTS": "Reports",
		"PAYMENTS": "Πληρωμές",
		"PAYMENT_ITEMS": "Είδη Πληρωμών",
		"TEAM_PAYMENTS": "Πληρωμές Συλλόγων",
		"MENU": "Μενού",
		"DASHBOARD": "Πίνακας Ελέγχου",
		"LOGOUT": "Έξοδος",
		"SELECT": "Επιλογή",
		"ACTIONS": "Επιλογές",
		"ABOUT": "Σχετικά",
		"TEAM_PROFILE": "Προφίλ Ομάδας",
		"FILTERS": "Φίλτρα",
		"TEAM_PAYMENTS_LIST": "Κινήσεις Συλλόγων",
		"PLAYER_PAYMENTS_LIST": "Κινήσεις Αθλητών",
		"DATE_FROM": "Ημερομηνία από",
		"DATE_TO": "Ημερομηνία εώς",
		"EDIT_TEAM_PAYMENT": "Επεξεργασία Κίνησης Συλλόγου",
		"EDIT_PLAYER_PAYMENT": "Επεξεργασία Κίνησης Αθλητή",
		"PRINT_RESULTS": "Εκτύπωση Κινήσεων",
		"SELECT_NATIONALITY": "Επιλέξτε Εθνικότητα",
		"SELECT_CITIZENSHIP": "Επιλέξτε Υπήκοότητα",
		"BIRTH_DATE": "Ημερομηνία Γέννησης",
		"ACTIVE": "Ενεργός",
		"FATHER": "Όνομα Πατρός",
		"MOTHER": "Όνομα Μητρός",
		"PLAYER_PROFILE": "Προφίλ Αθλητή",
		"PLAYER_PAYMENT_REPORT": "Καρτέλα Πληρωμών Αθλητή",
		"TRANSFER_PLAYER": "Μεταγραφή Αθλητή",
		"SELECT_NEW_TEAM": "Επιλέξτα νέο σύλλογο",
		"NEW_TRANSFER_PLAYER": "Νέα Μεταγραφή Αθλητή",
		"EDIT_TRANSFER_PLAYER": "Επεξεργασία Μεταγραφής Αθλητή",
		"OLD_TEAM": "Παλιός Σύλλογος",
		"NEW_TEAM": "Νέος Σύλλογος",
		"OLD_HEALTH_SORT": "Παλιό Δ.Υ.",
		"NEW_HEALTH_SORT": "Νέο Δ.Υ.",
		"ERROR": "Κάτι πήγε στραβά...",
		"ENTER": "Είσοδος",
		"CONFIRM": "Επιβεβαίωση",
		"CONFIRM_DELETE_TEAM": "Είστε σίγουρος θέλετε να διαγράψετε αυτό τον σύλλογο?",
		"CONFIRM_DELETE_PLAYER": "Είστε σίγουρος θέλετε να διαγράψετε αυτό τον αθλητή?",
		"CONFIRM_DELETE_LEAGUE": "Είστε σίγουρος θέλετε να διαγράψετε αυτή την κατηγορία?",
		"CONFIRM_DELETE_MATCH": "Είστε σίγουρος θέλετε να διαγράψετε αυτό τον αγώνα?",
		"CONFIRM_DELETE_PAYMENT": "Είστε σίγουρος θέλετε να διαγράψετε αυτό το είδος πληρωμής?",
		"CONFIRM_CLEAR_TARGETS": "Είστε σίγουρος θέλετε να καθαρίσετε τους στόχους?",
		"CONFIRM_REMOVE_LEAGUE_FROM_MATCH": "Είστε σίγουρος θέλετε να αφαιρέσετε την κατηγορία από τον αγώνα?",
		"CONFIRM_MOVE_LEAGUES": "Είστε σίγουρος θέλετε να μεταφέρετε τις κατηγορίες?",
		"CONFIRM_DELETE_ELIMINATION_MATCH": "Είστε σίγουρος θέλετε να διαγράψετε τον ολυμπιακό γύρο?",
		"CONFIRM_REMOVE_PLAYER_FROM_MATCH": "Είστε σίγουρος θέλετε να αφαιρέσετε τον αθλητή από τον αγώνα?",
		"CHANGE_TEAM_PASSWORD": "Αλλαγή Κωδικού Συλλόγου",
		"CHANGE_PASSWORD": "Αλλαγή Κωδικού",
		"NEW_PASSWORD": "Κωδικός",
		"NEW_PASSWORD_CONFIRMATION": "Κωδικός (Επιβεβαίωση)",
		"AUTHORIZATION_KEY": "Κλειδί Ασφαλείας",
		"ROLES": "Ρόλοι",
		"DISPLAY_NAME": "Όνομα",
		"DESCRIPTION": "Περιγραφή",
		"EDIT_ROLE": "Επεξεργασία Ρόλου",
		"CREATE_ROLE": "Δημιουργία Ρόλου",
		"SELECT_PERMISSIONS": "Επιλέξτε Δικαιώματα",
		"USERS": "Χρήστες",
		"EDIT_USER": "Επεξεργασία Χρήστη",
		"CREATE_USER": "Δημιουργία Χρήστη",
		"SELECT_ROLE": "Επιλέξτε Ρόλο",
		"ROLE": "Ρόλος",
		"CHANGE_USER_PASSWORD": "Αλλαγή Κωδικού Χρήστη",
		"WELCOME_TO": "Καλως ήρθες στο ",
		"ADD_REMOVE_PLAYERS": "Προσθήκη / Αφαίρεση Αθλητών",
		"CREATE_PLAYER": "Προσθήκη Αθλητή",
		"LOAD_ALL_PLAYERS": "Όλοι οι αθλητές",
		"SIGN_IN": "Είσοδος",
		"USER": "Χρήστης",
		"YOUR_EMAIL": "Το email σας",
		"RETURN_TO": "Επιστροφή στην ",
		"FORGOT_YOUR_PASSWORD": "Ξεχάσατε τον κωδικό σας?",
		"FORGOT_PASSWORD_ENTER_EMAIL": "Βάλτε το email σας και θα σας στείλουμε οδηγίες να αλλάξετε τον κωδικό σας.",
		"RECOVER_SUCCESS": "Εάν βρεθεί λογαριασμός με το συγκεκριμένο email θα σταλεί μήνυμα με οδηγίες.",
		"RESET_PASSWORD": "Νέος Κωδικός",
		"LOAD_FINANCIAL_OK_PLAYERS": "Ενεργοί Αθλητές ( Χωρίς Οικονομικές Εκκρεμότητες )",
		"AD_BLOCK_MESSAGE": "Παρακαλούμε για την σωστή λειτουργία απενεργοποιήστε το adBlocker για την ιστοσελίδα αυτή.",
		"CONTRACT_DATE": "Ημερομηνία λήξης σύμβασης",
		"HAS_COACH": "Διαθέτει προπονητή?",
		"TARGETS_BOARDS": "Πινάκια Στόχων",
		"JUDGES": "Κριτές",
		"EDIT_JUDGE": "Επεξεργασία Κριτή",
		"CREATE_JUDGE": "Δημιουργία Κριτή",
		"JUDGE_PROFILE": "Προφιλ Κριτή",
		"CONFIRM_DELETE_JUDGE": "Είστε σίγουρος θέλετε να διαγράψετε αυτό τον κριτή?",
		"SELECT_JUDGES": "Επιλέξτε κριτές",
		"COACHES": "Προπονητές",
		"EDIT_COACH": "Επεξεργασία Προνοπητή",
		"CREATE_COACH": "Δημιουργία Προνοπητή",
		"COACH_PROFILE": "Προφιλ Προνοπητή",
		"CONFIRM_DELETE_COACH": "Είστε σίγουρος θέλετε να διαγράψετε αυτό τον προπονητή?",
		"TRAINERS": "Εκπαιδευτές",
		"EDIT_TRAINER": "Επεξεργασία Εκπαιδευτή",
		"CREATE_TRAINER": "Δημιουργία Εκπαιδευτή",
		"TRAINER_PROFILE": "Προφιλ Εκπαιδευτή",
		"CONFIRM_DELETE_TRAINER": "Είστε σίγουρος θέλετε να διαγράψετε αυτό τον εκπαιδευτή?",
		"PRINT_GAME_PDF": "Εκτύπωση PDF Κατάταξης εώς τώρα",
		"PRINT_GAME_PDF_AFTER_GAME": "Εκτύπωση PDF Κατάταξης",
		"PRINT_GAME_PLAYERS_PDF": "Εκτύπωση PDF αθλητών",
		"PRINT": "Εκτυπώσεις",
		"GAME_LOGOUT": "Έξοδος από αγώνα",
		"LIMBS": "Limbs",
		"RISER": "Riser",
		"ARROWS": "Βέλη",
		"EQUIPMENT": "Εξοπλισμός",
		"FROM": "από",
		"POSITION": "Θέση",
		"ADD_SHOTS_TO_GAME": "Προσθήκη βολών στον αγώνα",
		"HOST": "Διοργανωτής",
		"SEARCH_GAME_NAME": "Αναζήτηση αγώνα με όνομα",
		"SORT_LEAGUE_NAME": "Συντομογραφία",
		"SEARCH_LEAGUE_NAME": "Αναζήτηση κατηγορίας με όνομα",
		"ADD_PLAYERS_TO_TEAM": "Προσθήλη αθλητών στον σύλλογο",
		"PLAYER": "Αθλητή",
		"USERNAME": "Username",
		"PASSWORD": "Κωδικός",
		"SEARCH_TEAM_NAME": "Αναζήτηση συλλόγου με όνομα",
		"PROFILE": "Προφίλ",
		"LIST_PLAYERS": "Αναζήτηση αθλητή",
		"LIST_TEAMS": "Αναζήτηση συλλόγου",
		"LIST_GAMES": "Αναζήτηση αγώνα",
		"LIST_LEAGUES": "Αναζήτηση κατηγορίας",
		"INDEX": "Αρχική Σελίδα",
		"C": "Γ",
		"SUBMIT": "Υποβολή",
		"SUBMIT_NEXT": "Υποβολή και επόμενος στόχος",
		"SUBMIT_EXIT": "Υποβολή και έξοδος",
		"ERROR_MONKEYS": "Πρόβλημα, έχουμε βάλει τις μαίμουδες μας και δουλέυουν σκληρά να το λύσουν.",
		"SUCCESS": "Επιτυχία",
		"EXISTS": "Υπάρχει ήδη",
		"ROUND_1": "Γύρος 1ος",
		"ROUND_2": "Γύρος 2ος",
		"PLAYERS": "Αθλητές",
		"ADD_PLAYER": "Προσθήκη νέου αθλητή",
		"EDIT_PLAYER": "Επεξεργασία αθλητή",
		"DELETE_PLAYER": "Διαγραφή αθλητή",
		"TEAMS": "Συλλόγοι",
		"ADD_TEAM": "Προσθήκη συλλόγου",
		"EDIT_TEAM": "Επεξεργασία συλλόγου",
		"DELETE_TEAM": "Διαγραφή συλλόγου",
		"GAME": "Αγώνας",
		"ADD_GAME": "Προσθήκη αγώνα",
		"EDIT_GAME_LEAGUES": "Επεξεργασία κατηγοριών παιχνιδιού",
		"EDIT_GAME": "Επεξεργασία Αγώνα",
		"DELETE_GAME": "Διαγραφή Αγώνα",
		"ADD_PLAYERS_TO_MATCH": "Δηλωση αθλητων σε αγωνα",
		"REMOVE_PLAYERS_FROM_MATCH": "Αφαίρεση παιχτών απο αγώνα",
		"ADD_SHOTS_P1": "Προσθήκη βολών",
		"ADD_SHOTS_P2": "Προσθήκη βολών (Τρόπος 2)",
		"ADD_SHOTS_P3": "Προσθήκη βολών (Τρόπος 3)",
		"UPDATE_GAME": "Ενημέρωση Παιχνιδιού",
		"ADD_LEAGUE": "Προσθήκη Κατηγορίας",
		"REMOVE_LEAGUE": "Αφαίρεση Κατηγορίας",
		"DELETE_LEAGUE": "Διαγραφή Κατηγορίας",
		"STATS": "Στατιστικά",
		"GAME_STATS": "Στατιστικά Παιχνιδιού",
		"STATS_FOR_TEAM": "Στατιστικά συλλόγου",
		"STATS_FOR_PLAYER": "Στατιστικά αθλητών",
		"LIVESCORES": "Αποτελέσματα",
		"MENU_SETTINGS": "Ρυθμίσεις Μενού",
		"OVERVIEW": "Γενική όψη Παιχνιδιού",
		"OLYMPIC": "Ολυμπιακός Γύρος",
		"ADD_OLYMPIC_SHOTS": "Προσθήκη βολών Ολ/γύρου",
		"EDIT_GAME_LEAGUES_PLAYERS": "Επεξεργασία κατηγοριών παιχνιδιού για τους παίχτες",
		"PICK_LEAGUE_DEL": "Επιλογή κατηγορίας για διαγραφή",
		"PICK_LEAGUE_ADD": "Επιλογή κατηγορίας για προσθήκη",
		"TRUELIVE_ALL": "ΑΠΟΤΕΛΕΣΜΑΤΑ LIVE (ΟΛΕΣ ΚΑΤΗΓΟΡΙΕΣ)",
		"TRUELIVE_CAT": "ΑΠΟΤΕΛΕΣΜΑΤΑ LIVE (ΕΠΙΛΕΞΤΕ ΚΑΤΗΓΟΡΙΕΣ)",
		"PRINT_GAME_PDF_MEDALS": "Εκτύπωση PDF μεταλίων του αγώνα",
		"PRINT_GAME_PDF_MEDALS_OLYMPIC": "Εκτύπωση PDF μεταλίων του αγώνα με Ολυμπιακό Γύρο",
		"SELECT_ALL": "Επιλογή Όλων",
		"CHECK_THIS_FOR_ALL": "Επιλέξτε αυτό για όλες τις κατηγορίες",
		"GO_BACK": "Επιστροφή πίσω",
		"FXs": "Σύνολο Χ",
		"ROUNDS": "Γύροι",
		"FINAL_SCORES": "Τελικά Σκορ",
		"PLAYER/ER": "Αθηλητής/τρια",
		"O/I": "Ο/η",
		"EMPTY_SHOTS": "έχει κενές βολές στον στόχο ",
		"PRINT_GAME_DETAILS": "Εκτύπωση λεπτομεριών παιχνιδιού",
		"NUMBER": "Νο",
		"PRINT_GAME_PLAYERS": "Εκτύπωση όλων των παιχτών / αλφαβητικη λίστα",
		"ALPHA_LIST_GAME": "Αλφαβητική Λίστα Με Στόχους",
		"PRINT_GAME_TARGETS": "Εκτύπωση όλων των στόχων",
		"ALL_TARGETS": "Λίστα βάση στόχων",
		"PRINT_GAME_PLAYERS_TEAMS": "Εκτύπωση όλων των παιχτών / αλφαβητικη λίστα συλλόγων",
		"MONEY_CHECK": "Έλεγχος",
		"LIST_BY_TEAM": "Λίστα αθλητών ανα συλλόγο",
		"PDF_RIGHTS": "*Προσοχή, τα στοιχεία σε αυτό το έντυπο μπορεί να διαφέρουν απο τα πραγματικά του αγώνα. Σε καμία περίπτωση αυτό το έντυπο δεν αντιπροσωπέυει την ΕΟΤ.",
		"GREEK": "Ελληνικά",
		"GAME_RESULTS": "Προσωπικά Αποτελέσματα Αγώνα",
		"MRS": "Αγαπητέ κύριε/κυρία",
		"HERE_ARE": "Σας αποστέλνουμε τα αποτελέσματα στον αγώνα που συμμετειχατε ",
		"HERE_ARE_TEAM": "Σας αποστέλνουμε τα αποτελέσματα στον αγώνα που συμμετειχε το σωματείο σας ",
		"CUSTOM": "Custom",
		"ARROW_NOW": "Αρ. Βελών",
		"SETTINGS": "Ρυθμίσεις",
		"DEGREE_SETTINGS": "Ρυθμίσεις επαίνων",
		"FIELD_1": "Πεδίο 1",
		"FIELD_2": "Πεδίο 2",
		"FIELD_3": "Πεδίο 3",
		"PRINT_DEGREES": "Εκτύπωση επαίνων",
		"PRINT_DEGREES_QUALIFICATION": "Εκτύπωση επαίνων Ατομικό (Βάση Κατάταξης)",
		"PRINT_DEGREES_OL_TEAM": "Εκτύπωση επαίνων Ομαδικό (Βάση Ολ/Γύρων)",
		"PRINT_DEGREES_QUAL_TEAM": "Εκτύπωση επαίνων Ομαδικό (Βάση Κατάταξης)",
		"PRINT_DEGREES_INDIVIDUAL": "Εκτύπωση επαίνων Ατομικό (Βάση Ολ/Γύρων)",
		"PRINT_DEGREES_OL_MIXED": "Εκτύπωση επαίνων Μικτό Ομαδικό (Βάση Ολ/Γύρων)",
		"PRINT_DEGREES_QUAL_MIXED": "Εκτύπωση επαίνων Μικτό Ομαδικό (Βάση Κατάταξης)",
		"DEGREE_TEXT": "Πεδίο στον έπαινο",
		"NO_FOR_OLYMPIC": "Αριθμός ατόμων για ολυμπιακό γύρο",
		"SUGGESTED": "προτεινομενο",
		"THERE_ARE_TOTAL": "Υπάρχουν συνολικά ",
		"EXPORT_GAME": "Εξαγωγή παιχνιδιού",
		"ONE_PLAYER": "Ενός αθλητή",
		"ALL_PLAYERS": "Όλων των αθλητών",
		"ADD_WITH_FILE": "Προσθήκη με αρχείο",
		"ADD_WITH_DETAILS": "Προσθήκη με λεπτομέριες",
		"ADD_WITHOUT_DETAILS": "Προσθήκη χωρίς λεπτομέριες",
		"IMPORT_GAME": "Εισαγωγή Αγώνα",
		"DEGREE_TEXT_2": "Πεδίο στο έπαινο 2",
		"TEAM_SORT_NAME": "Συντομογραφία Ονόματος",
		"TEAM_S_NAME": "Συν. συλλόγου",
		"SEND_PLAYER_EMAILS": "Αποστολή e-mail παιχτών",
		"ABOUT_ME": "Σχετικά με μένα",
		"INFO": "Πληροφορίες",
		"FOR": "για",
		"BIRTHDATE": "Ημερομηνία Γέννησης",
		"GAME_HISTORY": "Ιστορικό παιχνιδίων",
		"SEND_MESSAGE": "Αποστολή Μηνύματος",
		"FILE_EXPLORER": "Αρχεία",
		"COACH_OF": "προπονητή/τρια του συλλόγου ",
		"RECURVE": "Ολυμπιακό",
		"RECURVE_M_W": "Ολυμπιακό Ανδρών - Γυναικών",
		"RECURVE_YM_YW": "Ολυμπιακό Νέων Ανδρών - Νέων Γυναικών",
		"RECURVE_JM_JW": "Ολυμπιακό Εφήβων - Νεανίδων",
		"COMPOUND": "Σύνθετο",
		"COMPOUND_M_W": "Σύνθετο Ανδρών - Γυναικών",
		"COMPOUND_YM_YW": "Σύνθετο Νέων Ανδρών - Νέων Γυναικών",
		"COMPOUND_JM_JW": "Σύνθετο Εφήβων - Νεανίδων",
		"TEENS": "Εφήβων",
		"NEANIDWN": "Νεανίδων",
		"NO_RESULTS": "Δεν βρέθηκαν αποτελέσματα",
		"INDIVIDUAL_OLYMPIC": "Ατομικό Ολυμπιακό",
		"TEAM_OLYMPIC": "Ομαδικό Ολυμπικό",
		"NO_FOR_OLYMPIC_TEAMS": "Αριθμός ομάδων για ολυμπιακό γύρο",
		"PICK_CATEGORY": "Επιλέξτε κατηγορία",
		"NOT_ENOUGH_PLAYERS": "Ο συλλόγος δεν έχει αρκετούς αθλητες ώστε να συμμετάσχει στον ολυμπιακό γύρο",
		"PLAYER_1": "Αθλητής 1",
		"PLAYER_2": "Αθλητής 2",
		"PLAYER_3": "Αθλητής 3",
		"MIXED_TEAM_OLYMPIC": "Μικτό Ομαδικό Ολυμπικό",
		"OL_TEAM": "Ομαδικό",
		"FINAL": "Τελικός",
		"PRINT_GAME_BOOK": "Εκτύπωση βιβλίου αγώνα",
		"MEDALS_FROM_QUALIFICATIONS": "Μετάλια βάση κατάταξης",
		"MEDALS_FROM_OLYMPIC": "Μετάλια βάση ολυμπιακού γύρου",
		"MEDAL": "Μετάλιο",
		"GOLD": "Χρυσό",
		"SILVER": "Αργυρό",
		"BRONZE": "Χάλκινο",
		"ENTRIES_BY_TEAM": "Συμμετοχές Ανα Συλλογο",
		"OLYMPIC_ROUNDS_INDIVIDUAL": "Ολυμπιακοί Γύροι Ατομικό",
		"QUALIFICATION_INDIVIDUAL": "Κατάταξη Ατομικό",
		"OLYMPIC_ROUNDS_TEAM": "Ολυμπιακοί Γύροι Ομαδικό",
		"QUALIFICATION_TEAM": "Κατάταξη Ομαδικό",
		"MIXED_TEAM": "Μικτό Ομαδικό",
		"INDIVIDUAL": "Ατομικό",
		"PRINT_OLYMPIC_ROUNDS": "Εκτύπωση Ολυμπιακών Γύρων",
		"MIXED": "Μικτό",
		"ADD_GAME_QUICKSTART": "Προσθήκη Αγώνα (Γρήγορο)",
		"TYPE": "Τύπος",
		"DATE_FILED": "Ημερομηνία κατάθεσης",
		"GGA_NUMBER": "Αριθμός ΓΓΑ",
		"LEVEL": "Level προπονητή",
		"COACH_LEVEL": "Level προπονητή",
		"JUDGE_LEVEL": "Level κριτή",
		"TRAINER_LEVEL": "Level εκπαιδευτή",
		"COACH_0_LEVEL": "ΠΡΟΠΟΝΗΤΗΣ",
		"COACH_A_LEVEL": "Α’ ΚΑΤΗΓΟΡΙΑΣ",
		"COACH_B_LEVEL": "Β’ ΚΑΤΗΓΟΡΙΑΣ",
		"COACH_C_LEVEL": "Γ’ ΚΑΤΗΓΟΡΙΑΣ",
		"TRAINER_0_LEVEL": "ΕΚΠΑΙΔΕΥΤΗΣ",
		"TRAINER_1_LEVEL": "LEVEL 1",
		"TRAINER_2_LEVEL": "LEVEL 2",
		"TRAINER_3_LEVEL": "LEVEL 3",
		"CL1": "CL1",
		"CL2": "CL2",
		"SELECT_LEVEL": "Επιλέξτε level",
		"JUDGE_STAFF": "ΔΙΟΙΚΗΣΗ",
		"JUDGE_INTERNATIONAL": "ΔΙΕΘΝΗΣ",
		"JUDGE_NATIONAL": "ΕΘΝΙΚΟΣ",
		"JUDGE_CANDIDATE": "ΔΟΚΙΜΟΣ",
		"INDOOR": "Εσωτερικού Χώρου",
		"OUTDOOR": "Εξωτερικού Χώρου",
		"indoor": "Εσωτερικού Χώρου",
		"outdoor": "Εξωτερικού Χώρου",
		"GAME_TYPE": "Τύπος Αγώνα",
		"GAME_DETAILS": "Λεπτομέριες Αγώνα",
		"GAME_LEAGUES": "Κατηγορίες Αγώνα",
		"GREAT": "Τέλεια",
		"PREVIOUS": "Προηγούμενο",
		"NEXT": "Επόμενο",
		"BIRTH_PLACE": "Τόπος Γεννήσεως",
		"STATE": "Νομός",
		"CITIZENSHIP": "Υπήκοότητα",
		"NATIONALITY": "Εθνικότητα",
		"EXPATRIATE": "Ομογενής",
		"CITY": "Πόλη",
		"ADT": "Αριθμός Δελτίου Ταυτότητας",
		"PASSPORT": "Διαβατήριο",
		"HEALTH": "Αριθμός Δελτίου Υγείας",
		"AMEA": "Para-Archery",
		"A_TARGET": "Τριπλέτα",
		"REGISTRATION_DATE": "Ημερομηνία Εγγραφής",
		"FULL_NAME": "Πλήρες όνομα",
		"NAME": "Όνομα",
		"IDENTIFY_DATE": "Ημερομηνία Αναγνώρισης",
		"IDENTIFY_CODE": "Κωδικός Αναγνώρισης",
		"COUNTY": "Δήμος",
		"FAX": "FAX",
		"WEB": "Ιστοσελίδα",
		"AFM": "Α.Φ.Μ.",
		"DOY": "Δ.Ο.Υ.",
		"COACH_EMAIL": "E-mail Προπονητή",
		"REGION": "Περιοχή",
		"CALENDAR": "Ημερολόγιο",
		"REG_DATE": "Ημ/ Εγγραφής",
		"LNAME": "Όνομα",
		"FNAME": "Επώνυμο",
		"STATUS": "Κατάσταση",
		"DETAILS": "Λεπτομέριες",
		"CLEAR_SHOTS": "Καθαρισμός Βολών",
		"SUBMIT_RETURN": "Υποβολή και επιστροφή",
		"QUALIFICATION_MIXED_TEAM": "Κατάταξη Μικτό Ομαδικό",
		"OLYMPIC_TEAM_MIXED": "Ολυμπιακοί Γύροι Μικτό Ομαδικό",
		"EMPTY_ALL_TARGETS": "Καθαρισμός Στόχων",
		"PRINT_OLMPIC_LAYOUT": "Olympic Rounds Layout",
		"PRODUCE_TARGETS": "Παραγωγή Στόχων",
		"TARGETS_NUMBER": "Αριθμός Διαθέσιμων Στόχων",
		"CHOOSE_PLAYERS": "Επιλογή Παιχτών",
		"VIEW_REGISTRATION": "Προβολή τρέχουσας δήλωσης",
		"LIST_ENTRIES": "Λίστα συμμετέχωντων",
		"DELETE": "Διαγραφή",
		"HOW_MANY": "Πόσες εισόδους?",
		"REGISTRATION_OPEN_DATE": "Έναρξη δηλώσεων συμμετοχής",
		"REGISTRATION_END_DATE": "Τέλος δηλώσεων συμμετοχής",
		"CLOSE_REGISTRATION": "Λήξη δηλώσεων σημμετοχών",
		"PRINT_ENTRIES_PDF": "Εκτύπωση PDF συμμετοχών",
		"PRINT_ENTRIES_PDF_SPECIFIC": "Εκτύπωση PDF συμμετοχών ( Ομάδας )",
		"GAME_ENTRIES": "Δήλωση συμμετοχών",
		"NOTES": "Σημειώσεις",
		"TARGETS": "Στόχοι",
		"TARGET": "Στόχος",
		"PLAYER_LEAGUES": "Κατηγορίες αθλητών",
		"ADD_SHOTS_OLYMPIC": "Προσθήκη βολών Ολ/ γύρων",
		"ADD_PLAYERS": "Προσθήκη αθλητών",
		"REMOVE_PLAYERS": "Αφαίρεση αθλητών",
		"PLAYERS_REGISTERD": "Δηλώσεις Συμμετοχής Αθλητών",
		"EDIT_PERMISSIONS": "Επεξεργασία δικαιωμάτων",
		"USER_ROLE": "Ρόλος",
		"EDIT_ROLES": "Επεξεργασία ρόλων",
		"CLOSED": "ΚΛΕΙΣΤΗ",
		"OPEN": "ΑΝΟΙΧΤΗ",
		"REGISTRATION_STATUS": "Η δήλωση συμμετοχών είναι ",
		"REGISTRAION_CLOSED_TEXT": "** Η δήλωση συμμετοχών είναι κλειστή. Δεν μπορείτε να πραγματοποιήσετε αλλαγές. Παρακαλούμε επικοινωνήστε μαζί μας στο info@archery.org.gr για οποιαδήποτε απορία έχετε.",
		"CURRENT_LIST": "Τρέχων δήλσωη",
		"ENTRIES_PDF": "Εκτύπωση δήλωσης",
		"REGISTRATION_CLOSED_TEXT_LIST": "**Παρακάτω είναι η λίστα με τους αθλητές που έχετε δηλώσει. Η δήλωση συμμετοχών είναι κλειστή. Δεν μπορείτε να πραγματοποιήσετε αλλαγές. Παρακαλούμε επικοινωνήστε μαζί μας στο info@archery.org.gr για οποιαδήποτε απορία έχετε.",
		"ENTRIES_PROOF": "** Παρακαλούμε εκτυπώστε και κρατήστε το αρχέιο με την λίστα αθλητών σας σαν απόδειξη",
		"GRATZ_TO": "Συγχαρητήρια στον/ην",
		"COMPETED_IN": "που αγωνίστηκε στην κατηγορία",
		"NOW_ELIGIBLE": "μπορεί πλέον να αγωνηστεί στην κατηγορία",
		"AFTER_SCOREING": "αφού έφερε σύνολο",
		"PASSED_LIMIT": "και πέρασε το όριο",
		"COMPANION": "Συνοδός",
		"SAVE_MATCH_TEAM_INFO": "ΑΠΟΘΗΚΕΥΣΗ ΣΥΝΟΔΩΝ",
		"CAPTAIN": "Αρχηγός",
		"REQUIRED_FIELDS": "Τα πεδία με * είναι υποχρεωτικά",
		"PLUGINS": "Plugins",
		"VALIDATE_PASSPORTS": "Επικύρωση Δελτίων (Τρέχων Ετος)",
		"VALIDATE_PASSPORT": "Επικύρωση Δελτίου Αθλητή (Τρέχων Ετος)",
		"FINANCIAL": "Χρηματοοικονομικά",
		"ADD_PAYMENT_REASON": "Προσθήκη Υπηρεσίας/Είδος",
		"PRICE": "Ποσό",
		"COMMENTS": "Σχόλια",
		"ADD_PAYMENT_TEAM": "Πληρωμές Συλλόγων",
		"ADD_PAYMENT_PLAYER": "Πληρωμές Αθλητών",
		"PAYMENT_REASON": "Περιγραφή Κίνησης",
		"ADD_PAYMENT": "Προσθήκη Πληρωμής",
		"REQUIRED_TEAM": "Απαιτούμενο για την συμμετοχή συλλόγου σε αγώνα",
		"REQUIRED_PLAYER": "Απαιτούμενο για την συμμετοχή αθλητών σε αγώνα",
		"YEAR": "Χρονιά",
		"ADD_NEW": "Προσθήκη Νέου",
		"EDIT_USERS": "Επεξεργασία Χρηστών",
		"PAYMENT_REPORT": "Καρτέλα Πληρωμών",
		"REPORT_OF_YEAR": "Καρτέλα πληρωμών έτους : ",
		"AMOUNT_PAID": "Ποσό κατάθεσης",
		"MOVEMENT_REPORT": "Καρτέλα κινήσεων",
		"TEAM_REPORT_NAME": "Επωνυμία : ",
		"TOTAL_MOVEMENTS": "Σύνολο Κινήσεων : ",
		"TOTAL_AMOUNT_MOVED": "Συνολικο ποσό : ",
		"PAYMENT_DATE": "Ημερομηνία Κίνησης",
		"STARTED_DATE": "Ώρα Εισόδου",
		"ENDED_DATE": "Ώρα Εξόδου",
		"CANCEL": "Άκυρο",
		"PAYMENT_SUCCESSFULL": "Ολοκληρώθηκε επιτυχώς",
		"PAYMENT_FAILED": "Δεν ολοκληρώθηκε η πληρωμή",
		"LIST_PAYMENT_MOVEMENTS_TEAMS": "Λίστα κινήσεων συλλόγων",
		"LIST_PAYMENT_MOVEMENTS_PLAYERS": "Λίστα κινήσεων αθλητών",
		"EDIT_PAYMENT": "Επεξεργασία Κίνησης",
		"CANCEL_PAYMENT": "Ακύρωση κίνησης",
		"PAYMENT_EDIT_SUCCESSFULL": "Η επεξεργασία ολοκληρώθηκε επιτυχώς",
		"PAYMENT_EDIT_FAIL": "Δεν ολοκληρώθηκε η επεξεργασία",
		"IMPORT_SCORES": "Εισαγωγή Σκόρ Απο Αρχείο",
		"PLAYER_PASSPORT": "Δελτίο Αθλητή",
		"VALID": "Έγκυρο",
		"NOT_VALID": "Μή έγκυρο",
		"PAID": "Πληρώθηκε",
		"NOT_PAID": "Δεν έχει πληρωθεί",
		"STUDENT": "Μαθητής",
		"STUDENT_TEAM": "Σχολική Ομάδα",
		"NATIONAL": "Εθνική",
		"NATIONAL_TEAM": "Εθνική Ομάδα",
		"AMEA_TEAM": "Ομάδα Α.Μ.Ε.Α",
		"TRANSFERS": "Μεταγραφές",
		"TRANSFER": "Μεταγραφή",
		"FROM_TEAM": "Από ",
		"TO_TEAM": "Σε ",
		"OLD_HEALTH": "Παλιό Δελτίο Υγείας",
		"NEW_HEALTH": "Καινούργιο Δελτίο Υγείας",
		"TRANSFER_SUCCESSFUL": "Η μεταγραφή ολοκληρώθηκε με επιτυχία",
		"TRANSFER_FAIL": "Η μεταγραφή δεν ολοκληρώθηκε",
		"NEW_TRANSFER": "Νέα Μεταγραφή",
		"ALREADY_PAID": "ΕΧΕΙ ΠΛΗΡΩΘΕΙ",
		"ALREADY_EXISTS": "ΥΠΑΡΧΕΙ ΗΔΗ",
		"FROM_TO_EMPTY_FOR_ALL": "Από - Μεχρι",
		"PAYMENT_REASON_EMPTY_FOR_ALL": "Λόγος πληρωμής ( Κενό για όλους )",
		"PICK_TEAM_EMPTY_FOR_ALL": "Επιλογή Συλλόγου ( Κενό για όλους )",
		"PICK_PLAYER_EMPTY_FOR_ALL": "Επιλογή Αθλητή ( Κενό για όλους )",
		"RESTORE_PAYMENT": "Επαναφορά Κίνησης",
		"PLAYER_ADDED_SUCCESSFUL_CODE": "Ο αθλητής προστέθηκε επιτυχώς. Ο αριθμός αναγνώρισης του είναι ",
		"PLAYER_ADDED_SUCCESSFUL": "Ο αθλητής προστέθηκε επιτυχώς.",
		"PLEASE_FILL_ALL_FIELDS": "Παρακαλούμε συμπληρώστε όλα τα πεδία με *",
		"PLAYER_NOT_ADDED": "Ο αθλητής δεν προστέθηκε. Παρακαλούμε προσπαθήστε ξανά",
		"SAME_PLAYER_DETECTED": "Εντοπίστηκε αθλητής με τα ίδια στοιχεία. Θέλετε να συνεχίσετε με την καταχώρυση ?",
		"PLEASE_FILL_FNAME": "Παρακαλούμε συμπληρώστε όνομα.",
		"PLEASE_FILL_LNAME": "Παρακαλούμε συμπληρώστε επώνυμο.",
		"PLEASE_FILL_TEAM": "Παρακαλούμε συμπληρώστε ομάδα.",
		"PLEASE_FILL_SEX": "Παρακαλούμε συμπληρώστε το φύλο.",
		"PLEASE_FILL_STATE": "Παρακαλούμε συμπληρώστε τον νομό.",
		"PLEASE_FILL_CITIZENSHIP": "Παρακαλούμε συμπληρώστε την υπηκοότητα.",
		"PLEASE_FILL_NATIONALITY": "Παρακαλούμε συμπληρώστε την εθνικότητα.",
		"LIST_TRANSFERS": "Λίστα Μεταγραφών",
		"TRANSFER_DATE": "Ημερομηνία Μεταγραφής",
		"EDIT_TARGETS": "Επεξεργασία στόχων",
		"TOTAL_ENTRIES": "Συνολικές Συμμετοχές",
		"UNIQUE_ENTRIES": "Μοναδικές Συμμετοχές",
		"PDF": "Εκτύπωση",
		"MATCH_OVERVIEW": "Match Overview",
		"OFFICIAL_SCORE": "Official σκορ",
		"ENTRIES": "Συμμετοχές",
		"REMOVED_PLAYER_FROM_YEAR": "Ακυρώθηκε η επικύρωση δελτίου του αθλητή για το έτος ",
		"RECEIVED_CARD": "Παραλαβή Κάρτας ( Τρέχων Έτος )",
		"FORFEITED": "Εγκατέλειψε / Δεν Προσήλθε",
		"TEAM_INFO": "Στοιχεία Ομάδας",
		"MOVE_GAME": "Μεταφορά Αγώνα",
		"MOVE_FRONT": "Μετακίνηση προς τα εμπρός",
		"MOVE_TARGETS": "Μετακίνηση στόχων",
		"DISTANCE": "Απόσταση",
		"FROM_TARGET": "Απο στόχο",
		"TO_TARGET": "Εώς στόχο",
		"MOVE_BACK": "Μετακίνηση προς τα πίσω",
		"TOTAL_PLAYERS": "Σύνολο Αθλητών",
		"TOP_SCORE_IN_LEAGUE": "Επίδοση",
		"TOTAL_ENTRIES_IN_LEAGUE": "Συμμετοχές",
		"AMS_CODE": "Κωδικός",
		"EOT": "ΕΛΛΗΝΙΚΗ ΟΜΟΣΠΟΝΔΙΑ ΤΟΞΟΒΟΛΙΑΣ",
		"REPORT_1": "Μητρώο Σωματείων",
		"REPORT_2": "Μητρώο Αθλητών/Σωματείο",
		"REPORT_3": "Εγγεγραμμένοι αθλητές / Σωματείο",
		"REPORT_4": "Διοργανώσεις και Συμμετοχές ",
		"REPORT_5": "Συμμετοχές Αθλητών ανά αγώνισμα και ηλικιακή κατηγορία",
		"REPORT_6": "Συμμετοχές Αθλητών ανά Σωματείο",
		"REPORT_7": "Επίδοσεις Αθλητών ανά Σωματείο, Κατηγορία Αγωνίσματος & Ηλικίας",
		"REPORT_8": "Λίστα Πολυνικών Αθλητών & Σωματείων",
		"REPORT_9": "Λίστα εισόδων προπονητήριο",
		"REPORT_10": "Καλύτερη Επίδοση Αθλητών ανά Σωματείο, Κατηγορία Αγωνίσματος & Ηλικίας",
		"REPORT_11": "Μητρώο Αθλητών (ΓΓΑ)",
		"REPORT_12": "Μητρώο Συλλόγων (ΓΓΑ)",
		"FOR_YEAR": "Για το έτος",
		"RECURVE_COMPOUND_POINTS": "ΓΕΝΙΚΗ ΒΑΘΜΟΛΟΓΙΑ ΣΥΛΛΟΓΩΝ ΕΤΟΥΣ ",
		"RECURVE_POINTS": "ΟΛΥΜΠΙΑΚΟ ΤΟΞΟ (RECURVE) ΣΥΛΛΟΓΟΙ",
		"COMPOUND_POINTS": "ΣΥΝΘΕΤΟ ΤΟΞΟ (COMPOUND) ΣΥΛΛΟΓΟΙ",
		"POINTS": "ΠΟΝΤΟΙ",
		"SUSPEND_REASON": "Λόγος",
		"SUSPEND_TEAM": "Suspend Σωματείο",
		"TEAM_IS_SUSPENDED": "Δεν μπορείτε να δηλώσετε αθλητές αυτή τη στιγμή.",
		"TEAM_IS_SUSPENDED_PROFILE": "Το σωματείο είναι suspended.",
		"OVERRIDE_AGE_LIMITS": "Override Age Limits",
		"PLAYER_MATCHES": "Αγώνες Αθλητή",
		"PLAYER_PAYMENTS": "Πληρωμές Αθλητή",
		"PASSPORTS": "Δελτία",
		"START_DATE": "Ημερομηνία Έναρξης",
		"DAYS_LEFT": "Μέρες που απομένουν",
		"VALID_UNTIL": "Ισχύει Μέχρι",
		"DAYS": "μέρες",
		"EXPIRED": "Έχει λήξει",
		"ADD_PASSPORT": "Προσθήκη Δελτίου",
		"LIMIT_INDOOR": "Όριο Κλειστού Χώρου",
		"LIMIT_OUTDOOR": "Όριο Ανοιχτού Χώρου",
		"OVERRIDE_LIMITS": "Override Limits ( Age & Score )",
		"OVERRIDE_CHECKS": "Override All Check",
		"MATCH_CODE": "Κωδικός Αγώνα",
		"PLAYER_NAME": "Όνομα αθλητή",
		"FIRST_NAME": "Όνομα",
		"LAST_NAME": "Επώνυμο",
		"SEX": "Φύλο",
		"MEN": "Άντρας",
		"WOMEN": "Γυναίκα",
		"OTHER": "Άλλο",
		"EMAIL": "E-mail",
		"BIRTH": "Ημερομηνία Γέννησης",
		"LEAGUE": "Κατηγορία",
		"TEAM": "Σύλλογος",
		"EDIT": "Επεξεργασία",
		"PICK_PLAYER": "Επιλογή αθλητή",
		"FATHER_NAME": "Όνομα Πατέρα",
		"MOTHER_NAME": "Όνομα Μητέρας",
		"CODE": "Αρ. Μητρώου",
		"TEAM_NAME": "Όνομα συλλόγου",
		"LOCATION": "Τοποθεσία",
		"PICK_TEAM": "Επιλογή συλλόγου",
		"ADDRESS": "Διεύθυνση",
		"EFOT_REG": "Κωδικός Ε.Ο.Τ.",
		"PC": "Ταχ. Κώδικας",
		"ADMIN": "Διαχειριστής",
		"COACH": "Προπονητής",
		"PHONE": "Τηλέφωνο",
		"TARGET_FROM": "Στόχοι από",
		"TARGET_TO": "εώς",
		"GAME_NAME": "Όνομα Αγώνα",
		"DATE": "Ημερομηνία",
		"LEAGUES": "Κατηγορίες",
		"PICK_GAME": "Επιλογή Αγώνα",
		"TARGET_NAME": "Στόχος",
		"ROUND": "Γύρος",
		"PICK_TARGET": "Επιλέξτε στόχο",
		"SHOT_1": "Βολή 1",
		"SHOT_2": "Βολή 2",
		"SHOT_3": "Βολή 3",
		"SHOT_4": "Βολή 4",
		"SHOT_5": "Βολή 5",
		"SHOT_6": "Βολή 6",
		"SHOT_7": "Βολή 7",
		"SHOT_8": "Βολή 8",
		"SHOT_9": "Βολή 9",
		"SHOT_10": "Βολή 10",
		"UPDATE_ROUND_1": "Ενημέρωση Γύρου 1",
		"UPDATE_ROUND_2": "Ενημέρωση Γύρου 2",
		"ARE_YOU_SURE_UPDATE_GAME": "Είστε σίγουρος ότι θέλετε να ενημερώσετε τον αγώνα?",
		"INFO_GAME": "Πληροφορίες Αγώνα",
		"JUDGE": "Κριτές",
		"REPRESENTER": "Εκπρόσωποι της ΕΟΤ",
		"COMMITTEE": "Αγωνόδικος Επιτροπή",
		"SWAP_PLAYERS": "Εναλλαγή παιχτών",
		"MOVE_PLAYER": "Μετακίνηση σε στόχο",
		"SWAP_TARGETS": "Εναλλαγή στόχων",
		"ORDER_BY": "Ταξινόμιση ανά",
		"SEARCH_NAME": "Αναζήτηση με όνομα αθλητή",
		"SEARCH_TEAM": "Αναζήτηση με συλλόγο",
		"PICK_ROUND": "Επιλογή Γύρου",
		"ARROW": "Βέλος",
		"LEAGUE_NAME": "Όνομα Κατηγορίας",
		"CATEGORY": "Κατηγορία",
		"CATEGORY_S": "Κατ.",
		"PICK_LEAGUE": "Επιλογή Κατηγορίας",
		"TOTAL_SCORE": "Συνολικό Σκόρ",
		"SHOT_NOW": "Αρ. Βολής",
		"TOTAL": "Σύνολο",
		"TOTAL/RANK": "Σύνολο/ Κατ",
		"TOTAL/RANKs": "Συνολ. Επίδοση",
		"TOTAL_SCORE_POINTS": "Πόντοι",
		"REAL_LIVESCORES": "Livescores",
		"SHOT_NUMBER_NOW": "Βολή τώρα",
		"SHOT_SCORE_SO_FAR": "Σκορ εώς τώρα",
		"RANK": "Κατ.",
		"ROUND_1/RANK": "Γύρος 1/ Κατ",
		"ROUND_2/RANK": "Γύρος 2/ Κατ",
		"ROUND_1/RANKs": "Γ.1",
		"ROUND_2/RANKs": "Γ.2",
		"10s": "10ρια",
		"9s": "9ρια",
		"10ss": "10",
		"9ss": "9",
		"INCREMENT_SCORE": "Προοδευτικό Σκορ",
		"FINAL_SCORE": "Τελικό Σκόρ",
		"SHOT_SCORE": "Σκόρ Βολής",
		"F10s": "Σύνολο 10ρια",
		"F9s": "Σύνολο 9ρια",
		"STOP_AUTOSCROLLING": "Stop Autoscrolling",
		"TOP_2_PLAYERS": "Καλύτεροι 2 παίχτες ανα κατηγορία",
		"START_AUTOSCREOLLING": "Start Autoscrolling",
		"MATCH_DATE": "Ημερομηνία Αγώνα",
		"DOWNLOAD_RESULTS": "Κατέβασμα αποτελεσμάτων PDF",
		"UPLOAD_RESULTS_PDF": "Ανέβασμα PDF αποτελεσμάτων",
		"CURRENT_RESULTS_PDF": "Τωρινό ανεβασμένο PDF",
		"IMPORT_OLD_GAMES": "Ανέβασμα παλαιότερων αγώνων",
		"EXTENSION_ERROR": "Δεν επιτρεπεται ο συγκεκριμενος τυπος αρχείου.",
		"PHOTO_SIZE_ERROR": "Φωτογραφίες μέχρι 2ΜΒ σε μέγεθος",
		"UNKNOWN": "Πρόβλημα στο ανέβασμα της φωτογραφίας.",
		"UPLOAD_FAILED": "Πρόβλημα στο ανέβασμα της φωτογραφίας.",
		"NO_IMAGE": "Επιλέξτε μια εικόνα πρώτα.",
		"ALL_ATHLETES": "Όλοι οι αθλητές",
		"ACTIVE_ATHLETES": "Ενεργοί αθλητές"
	};

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

	module.exports = {
		"START_AUTOSCROLL": "Start autoscroll",
		"STOP_AUTOSCROLL": "Stop autoscroll",
		"CHANGE_MATCH": "Change match",
		"MATCH_ID": "Match ID",
		"MATCH_RESULTS": "Match results",
		"MOBILE_SCORING_ROUND_1_OPEN": "Allow score from mobiles ( Round 1 )",
		"MOBILE_SCORING_ROUND_2_OPEN": "Allow score from mobiles ( Round 2 )",
		"ADD_SHOTS_VISUAL": "Target shots visual update",
		"TARGET_TWO": "Target #2",
		"DIRECTION": "Direction",
		"NO": "No",
		"YES": "Yes",
		"FRONT": "Front",
		"BACK": "Back",
		"CREATED_AT": "Created at",
		"UPDATED_AT": "Updated at",
		"DELETE_TRAINING_ENTRY": "Delete training entry?",
		"AVAILABLE": "Available",
		"NOT_AVAILABLE": "Not available",
		"SELECT_PLAYER": "Choose athlete",
		"SELECT_TARGET": "Choose target",
		"SELECT_LEAGUE": "Choose league",
		"SELECT_LEAGUES": "Choose leagues",
		"SELECT_MATCH": "Choose match",
		"SELECT_TEAM": "Choose team",
		"SELECT_SEX": "Choose sex",
		"SELECT_PAYMENT": "Choose payment",
		"PLAYERS_PER_TARGET": "Athletes per target",
		"MATCH_ENTRIES_LIMIT": "Match entries limit",
		"UPDATE_PLAYER_LEAGUE": "Update athlete league",
		"REGISTRATIONS": "Registrations",
		"REGISTRATION_OPEN": "Registration open",
		"REGISTRATION_CLOSED": "Registration closed",
		"MOVE_MATCH": "Move to match",
		"NEW_MATCH": "Match to move",
		"LEAGUES_LIST": "Registrations by league",
		"PLAYERS_LIST": "Registrations by athlete",
		"TEAMS_LIST": "Registrations by team",
		"TARGETS_LIST": "Registrations by targets",
		"QUALIFICATION": "Qualification",
		"QR": "QR",
		"MEDALS": "Medals",
		"PRINTS": "Prints",
		"DOWNLOAD": "Download",
		"ELIMINATION_ROUNDS": "Elimination Rounds",
		"ELIMINATION_INDIVIDUAL": "Individual",
		"ELIMINATION_TEAM": "Team",
		"ELIMINATION_MIXED_TEAM": "Mixed Team",
		"ELIMINATION_PARTICIPANTS": "Participants",
		"SELECT_ELIMINATION_PARTICIPANTS": "Select participants",
		"NEXT_ROUND": "Next round",
		"PRINT_PDF": "Print",
		"STARTING_ROUND": "Starting round",
		"CURRENT_ROUND": "Current round",
		"ADD_ELIMINATION_LEAGUE": "Add league",
		"ELIMINATION_INDIVIDUAL_LEAGUES": "Elimination individual leagues",
		"ELIMINATION_TEAM_LEAGUES": "Elimination team leagues",
		"ELIMINATION_MIXED_TEAM_LEAGUES": "Elimination mixed team leagues",
		"CREATE": "Create",
		"PLAYER_ONE": "Athlete #1",
		"PLAYER_TWO": "Athlete #2",
		"PLAYER_THREE": "Athlete #3",
		"UPDATE_TEAM_LEAGUE_PLAYERS": "Update team league players",
		"FINALIZE_ROUND_ONE": "Finalize round 1",
		"FINALIZE_ROUND_TWO": "Finalize round 2",
		"FINALIZE_MATCH": "Finalize match",
		"TARGETS_WITH_EMPTY_SHOTS": "Targets with missing shots",
		"MALE": "Male",
		"FEMALE": "Female",
		"PLAYER_PAYMENTS_FULFILLMENT": "Athlete payment fulfillments",
		"REMOVE": "Remove",
		"ADD": "Add",
		"ADD_PLAYER_TO_MATCH": "Add athlete to match",
		"CURRENT_PLAYERS": "Current athletes",
		"MATCH_ELIGIBILITY_EXPLAIN_TEXT": "You cannot register the athlete for this match for the following reasons:",
		"PRINT_REGISTRATIONS_PDF": "Print registrations",
		"REGISTRATION_IS_CLOSED": "Registrations are closed.",
		"ADD_SHOTS": "Add shots",
		"ROUND_ONE": "Round 1",
		"ROUND_TWO": "Round 2",
		"CLEAR_ROUND": "Clear round shots",
		"FINAl_SCORES_ROW": "Final scores",
		"ADD_SHOTS_INDIVIDUAL": "Add shots individuals",
		"REQUIRED_BY_TEAM": "Required by team",
		"REQUIRED_BY_PLAYER": "Required by athlete",
		"ADD_NEW_PAYMENT": "Add new payment",
		"ADD_TEAM_PAYMENT": "Add new team payment",
		"ADD_PLAYER_PAYMENT": "Add new athlete payment",
		"PAYMENT": "Payment",
		"AMOUNT": "Amount",
		"STAFF": "Staff",
		"EDIT_STAFF": "Edit staff",
		"STAFF_PROFILE": "Staff profile",
		"SELECT_ROUND": "Select round",
		"FINAL_SHOT": "S.O.",
		"ADD_SHOTS_TEAM": "Add shots team",
		"ADD_SHOTS_MIXED_TEAM": "Add shots mixed team",
		"MATCH_NAME": "Match name",
		"MATCH_SORT_NAME": "Sort name",
		"MATCH_HOST": "Host",
		"MATCH_JUDGE": "Judges",
		"MATCH_REPRESENTER": "Represented",
		"MATCH_COMMITTEE": "Committee",
		"MATCH_OFFICIAL": "Official",
		"MATCH_LOCATION": "Location",
		"MATCH_CUP": "Cup",
		"MATCH_CHAMPIONSHIP": "Championship",
		"MATCH_TYPE": "Type",
		"MATCH_LEAGUES": "Leagues",
		"LEAGUE_CAT": "League category",
		"EXIT_GAME": "Exit",
		"MATCH_REGISTRATION_START": "Registration Open Date",
		"MATCH_REGISTRATION_END": "Registration Close date",
		"EDIT_MATCH": "Edit match",
		"LEAGUE_TYPE": "Type",
		"LEAGUE_SEX": "Sex",
		"LEAGUE_ELIMINATIONS_ELIGIBILITY": "Elimination rounds",
		"DISTANCE_INDOOR": "Indoor distance",
		"DISTANCE_OUTDOOR": "Outdoor distance",
		"LEAGUE_SORT_NAME": "Sort name",
		"LEAGUE_CODE": "Code",
		"LEAGUE_ORDER": "Order",
		"EDIT_LEAGUE": "Edit league",
		"SCHOOL": "School",
		"AGE": "Age ( equal or greater )",
		"CREATE_LEAGUE": "Create league",
		"CREATE_MATCH": "Create match",
		"PICK": "Pick",
		"DOWNLOAD_CARD": "Card",
		"DOWNLOAD_TRAINING_CARD": "Training card",
		"TRAINING_ENTRIES": "Training entries",
		"ENDED": "Ended",
		"PAUSED": "Paused",
		"PAUSE": "Pause",
		"UNPAUSE": "Unpause",
		"END": "End",
		"START": "Start",
		"START_ENTRY": "Start",
		"PAUSE_TRAINING_ENTRY": "Are you sure you want to pause the entry?",
		"END_TRAINING_ENTRY": "Are you sure you want to end the entry?",
		"UNPAUSE_TRAINING_ENTRY": "Are you sure you want to un-pause the entry?",
		"ADD_TRAINING_ENTRIES": "Add training entries",
		"START_TRAINING_ENTRY": "Are you sure you want to use the entry?",
		"TRAINING_CENTER": "Training center",
		"OAKA_TRAINING_CENTER": "Training center",
		"CURRENT_ACTIVE_INSIDE": "Currently inside training center",
		"INFORMATION": "Information",
		"SORT_NAME": "Sort name",
		"POSTAL_CODE": "P.C.",
		"VAT": "VAT",
		"OFFICIAL": "Official",
		"IMAGE": "Image",
		"SELECT_FILE": "Choose file",
		"MAP_LOCATION": "Location",
		"CREATE_TEAM": "Create team",
		"SELECT_YEAR": "Select year",
		"SELECT_STATE": "Select state",
		"SELECT_COUNTY": "Select county",
		"SELECT_REGION": "Select region",
		"GO_TO_PROFILE": "Profile",
		"MATCHES": "Matches",
		"REPORTS": "Reports",
		"PAYMENTS": "Payments",
		"PAYMENT_ITEMS": "Payments",
		"TEAM_PAYMENTS": "Team payments",
		"MENU": "Menu",
		"DASHBOARD": "Dashboard",
		"LOGOUT": "Logout",
		"SELECT": "Select",
		"ACTIONS": "Actions",
		"ABOUT": "About",
		"TEAM_PROFILE": "Team profile",
		"FILTERS": "Filters",
		"TEAM_PAYMENTS_LIST": "Team payments",
		"PLAYER_PAYMENTS_LIST": "Athlete payments",
		"DATE_FROM": "Date from",
		"DATE_TO": "Date to",
		"EDIT_TEAM_PAYMENT": "Edit team payment",
		"EDIT_PLAYER_PAYMENT": "Edit athlete payment",
		"PRINT_RESULTS": "Print results",
		"SELECT_NATIONALITY": "Select nationality",
		"SELECT_CITIZENSHIP": "Select citizenship",
		"BIRTH_DATE": "Birthdate",
		"ACTIVE": "Active",
		"FATHER": "Father",
		"MOTHER": "Mother",
		"PLAYER_PROFILE": "Athlete profile",
		"PLAYER_PAYMENT_REPORT": "Athlete payment report",
		"TRANSFER_PLAYER": "Athlete transfer",
		"SELECT_NEW_TEAM": "Select new team",
		"NEW_TRANSFER_PLAYER": "New athlete transfer",
		"EDIT_TRANSFER_PLAYER": "Edit athlete transfer",
		"OLD_TEAM": "Old team",
		"NEW_TEAM": "New team",
		"OLD_HEALTH_SORT": "Old health number",
		"NEW_HEALTH_SORT": "New health number",
		"ERROR": "Something went wrong...",
		"ENTER": "Enter",
		"CONFIRM": "Confirm",
		"CONFIRM_DELETE_TEAM": "Are you sure you want to delete this team?",
		"CONFIRM_DELETE_PLAYER": "Are you sure you want to delete this athlete?",
		"CONFIRM_DELETE_LEAGUE": "Are you sure you want to delete this league?",
		"CONFIRM_DELETE_MATCH": "Are you sure you want to delete this match?",
		"CONFIRM_DELETE_PAYMENT": "Are you sure you want to delete this payment?",
		"CONFIRM_CLEAR_TARGETS": "Are you sure you want to clear the targets?",
		"CONFIRM_REMOVE_LEAGUE_FROM_MATCH": "Are you sure you want to remove this league from the match?",
		"CONFIRM_MOVE_LEAGUES": "Are you sure you want to move these leagues?",
		"CONFIRM_DELETE_ELIMINATION_MATCH": "Are you sure you want to delete this elimination match?",
		"CONFIRM_REMOVE_PLAYER_FROM_MATCH": "Are you sure you want to remove this athlete from the match?",
		"CHANGE_TEAM_PASSWORD": "Change team password",
		"CHANGE_PASSWORD": "Change password",
		"NEW_PASSWORD": "New password",
		"NEW_PASSWORD_CONFIRMATION": "New password (confirm)",
		"AUTHORIZATION_KEY": "Authorization key",
		"ROLES": "Roles",
		"DISPLAY_NAME": "Name",
		"DESCRIPTION": "Description",
		"EDIT_ROLE": "Edit role",
		"CREATE_ROLE": "New role",
		"SELECT_PERMISSIONS": "Select permissions",
		"USERS": "Users",
		"EDIT_USER": "Edit user",
		"CREATE_USER": "New user",
		"SELECT_ROLE": "Select role",
		"ROLE": "Role",
		"CHANGE_USER_PASSWORD": "Change user password",
		"WELCOME_TO": "Welcome to ",
		"ADD_REMOVE_PLAYERS": "Add/remove athletes",
		"CREATE_PLAYER": "Add athlete",
		"LOAD_ALL_PLAYERS": "All athletes",
		"SIGN_IN": "Sign in",
		"USER": "User",
		"YOUR_EMAIL": "Your email",
		"RETURN_TO": "Return to ",
		"FORGOT_YOUR_PASSWORD": "Forgot your password?",
		"FORGOT_PASSWORD_ENTER_EMAIL": "Enter your email and we'll forward an email with instructions.",
		"RECOVER_SUCCESS": "If the user is found an email will be sent.",
		"RESET_PASSWORD": "New password",
		"LOAD_FINANCIAL_OK_PLAYERS": "Active athletes ( Financial OK )",
		"AD_BLOCK_MESSAGE": "Please for the correct usage disable the ad blocker in your browser.",
		"CONTRACT_DATE": "Contract expiration date",
		"HAS_COACH": "Have coach?",
		"TARGETS_BOARDS": "Target boards",
		"JUDGES": "Judges",
		"EDIT_JUDGE": "Edit judge",
		"CREATE_JUDGE": "Add judge",
		"JUDGE_PROFILE": "Judge profile",
		"CONFIRM_DELETE_JUDGE": "Are you sure you want to delete this judge?",
		"SELECT_JUDGES": "Select judges",
		"COACHES": "Coaches",
		"EDIT_COACH": "Edit coach",
		"CREATE_COACH": "Add coach",
		"COACH_PROFILE": "Coach profile",
		"CONFIRM_DELETE_COACH": "Are you sure you want to delete this coach?",
		"TRAINERS": "Part-time Trainers",
		"EDIT_TRAINER": "Edit part-time trainer",
		"CREATE_TRAINER": "Add part-time trainer",
		"TRAINER_PROFILE": "Part-time Trainer profile",
		"CONFIRM_DELETE_TRAINER": "Are you sure you want to delete this part-time trainer?",
		"PRINT_GAME_PDF": "Print qualification",
		"PRINT_GAME_PDF_AFTER_GAME": "Print qualification",
		"PRINT_GAME_PLAYERS_PDF": "Print athletes",
		"PRINT": "Prints",
		"GAME_LOGOUT": "Exit match",
		"LIMBS": "Limbs",
		"RISER": "Riser",
		"ARROWS": "Arrows",
		"EQUIPMENT": "Equipment",
		"FROM": "From",
		"POSITION": "Position",
		"ADD_SHOTS_TO_GAME": "Add shots to match",
		"HOST": "Host",
		"SEARCH_GAME_NAME": "Search...",
		"SORT_LEAGUE_NAME": "Sort name",
		"SEARCH_LEAGUE_NAME": "Search...",
		"ADD_PLAYERS_TO_TEAM": "Add athletes to team",
		"PLAYER": "Athlete",
		"USERNAME": "Username",
		"PASSWORD": "Password",
		"SEARCH_TEAM_NAME": "Search...",
		"PROFILE": "Profile",
		"LIST_PLAYERS": "List athletes",
		"LIST_TEAMS": "List teams",
		"LIST_GAMES": "List matches",
		"LIST_LEAGUES": "List leagues",
		"INDEX": "Homepage",
		"C": "C",
		"SUBMIT": "Submit",
		"SUBMIT_NEXT": "Submit and next target",
		"SUBMIT_EXIT": "Submit and exit",
		"ERROR_MONKEYS": "Oops, something went wrong",
		"SUCCESS": "Success",
		"EXISTS": "Already exists",
		"ROUND_1": "Round 1",
		"ROUND_2": "Round 2",
		"PLAYERS": "Athletes",
		"ADD_PLAYER": "Add athlete",
		"EDIT_PLAYER": "Edit athlete",
		"DELETE_PLAYER": "Delete athlete",
		"TEAMS": "Teams",
		"ADD_TEAM": "Add team",
		"EDIT_TEAM": "Edit team",
		"DELETE_TEAM": "Delete team",
		"GAME": "Match",
		"ADD_GAME": "Add match",
		"EDIT_GAME_LEAGUES": "Edit match leagues",
		"EDIT_GAME": "Edit match",
		"DELETE_GAME": "Delete match",
		"ADD_PLAYERS_TO_MATCH": "Add athletes to match",
		"REMOVE_PLAYERS_FROM_MATCH": "Remove athletes from match",
		"ADD_SHOTS_P1": "Add shots",
		"ADD_SHOTS_P2": "Add shots",
		"ADD_SHOTS_P3": "Add shots",
		"UPDATE_GAME": "Update match",
		"ADD_LEAGUE": "Add league",
		"REMOVE_LEAGUE": "Remove league",
		"DELETE_LEAGUE": "Delete league",
		"STATS": "Stats",
		"GAME_STATS": "Match stats",
		"STATS_FOR_TEAM": "Team stats",
		"STATS_FOR_PLAYER": "Athlete stats",
		"LIVESCORES": "Live scores",
		"MENU_SETTINGS": "Menu Settings",
		"OVERVIEW": "Match overview",
		"OLYMPIC": "Elimination Rounds",
		"ADD_OLYMPIC_SHOTS": "Add elimination round shots",
		"EDIT_GAME_LEAGUES_PLAYERS": "Edit athlete league for match",
		"PICK_LEAGUE_DEL": "Select league to delete",
		"PICK_LEAGUE_ADD": "Select league to add",
		"TRUELIVE_ALL": "Results",
		"TRUELIVE_CAT": "Results",
		"PRINT_GAME_PDF_MEDALS": "Print Medals",
		"PRINT_GAME_PDF_MEDALS_OLYMPIC": "Print Medals",
		"SELECT_ALL": "Select all",
		"CHECK_THIS_FOR_ALL": "Check this for all leagues",
		"GO_BACK": "Go back",
		"FXs": "Total Xs",
		"ROUNDS": "Rounds",
		"FINAL_SCORES": "Final scores",
		"PLAYER/ER": "Athlete",
		"O/I": "",
		"EMPTY_SHOTS": "has empty shots on target ",
		"PRINT_GAME_DETAILS": "Print match details",
		"NUMBER": "#",
		"PRINT_GAME_PLAYERS": "Print match athletes",
		"ALPHA_LIST_GAME": "Print match athletes with targets",
		"PRINT_GAME_TARGETS": "Print targets",
		"ALL_TARGETS": "All targets",
		"PRINT_GAME_PLAYERS_TEAMS": "Print athletes by team",
		"MONEY_CHECK": "Check",
		"LIST_BY_TEAM": "Athletes by team",
		"PDF_RIGHTS": "*Careful, results might be different from actual shots",
		"GREEK": "Greek",
		"GAME_RESULTS": "Personal Match Results",
		"MRS": "Dear Mr/Ms",
		"HERE_ARE": "Here are the results of the competition you took place in ",
		"HERE_ARE_TEAM": "Here are the results of the competition your club took place in ",
		"CUSTOM": "Custom",
		"ARROW_NOW": "Arrow No",
		"SETTINGS": "Settings",
		"DEGREE_SETTINGS": "Degree Settings",
		"FIELD_1": "Field 1",
		"FIELD_2": "Field 2",
		"FIELD_3": "Field 3",
		"PRINT_DEGREES": "Print Degrees",
		"NO_FOR_OLYMPIC": "Number of athletes for elimination round",
		"SUGGESTED": "suggested",
		"THERE_ARE_TOTAL": "Total ",
		"EXPORT_GAME": "Export match",
		"ONE_PLAYER": "One athlete",
		"ALL_PLAYERS": "All athletes",
		"ADD_WITH_FILE": "Add with file",
		"ADD_WITH_DETAILS": "Add with details",
		"ADD_WITHOUT_DETAILS": "Add without details",
		"IMPORT_GAME": "Import match",
		"TEAM_SORT_NAME": "Sort name",
		"TEAM_S_NAME": "Team",
		"SEND_PLAYER_EMAILS": "Email Athletes",
		"ABOUT_ME": "About me",
		"INFO": "Information",
		"FOR": "for",
		"BIRTHDATE": "Birthdate",
		"GAME_HISTORY": "Match history",
		"SEND_MESSAGE": "Send message",
		"FILE_EXPLORER": "Files",
		"COACH_OF": "coach of ",
		"RECURVE": "Recurve",
		"RECURVE_M_W": "Recurve Men - Women",
		"RECURVE_YM_YW": "Recurve Cadet Men - Women",
		"RECURVE_JM_JW": "Recurve Junior Men - Women",
		"COMPOUND": "Compound",
		"COMPOUND_M_W": "Compound Men - Women",
		"COMPOUND_YM_YW": "Compound Cadet Men - Women",
		"COMPOUND_JM_JW": "Compound Junior Men - Women",
		"TEENS": "Boys",
		"NEANIDWN": "Girls",
		"NO_RESULTS": "No results found",
		"INDIVIDUAL_OLYMPIC": "Individual elimination rounds",
		"TEAM_OLYMPIC": "Team elimination rounds",
		"NO_FOR_OLYMPIC_TEAMS": "# of teams for elimination rounds",
		"PICK_CATEGORY": "Select league",
		"NOT_ENOUGH_PLAYERS": "Team does not have enough athletes to participate",
		"PLAYER_1": "Athlete 1",
		"PLAYER_2": "Athlete 2",
		"PLAYER_3": "Athlete 3",
		"MIXED_TEAM_OLYMPIC": "Mixed Team elimination rounds",
		"OL_TEAM": "Team",
		"FINAL": "Final",
		"PRINT_GAME_BOOK": "Print match book",
		"MEDALS_FROM_QUALIFICATIONS": "Medals from qualification",
		"MEDALS_FROM_OLYMPIC": "Medals from elimination rounds",
		"MEDAL": "Medal",
		"GOLD": "Gold",
		"SILVER": "Silver",
		"BRONZE": "Bronze",
		"ENTRIES_BY_TEAM": "Registrations by team",
		"OLYMPIC_ROUNDS_INDIVIDUAL": "Individual eliminations",
		"QUALIFICATION_INDIVIDUAL": "Qualification individuals",
		"OLYMPIC_ROUNDS_TEAM": "Team eliminations",
		"QUALIFICATION_TEAM": "Qualifications team",
		"MIXED_TEAM": "Mixed Team",
		"INDIVIDUAL": "Individual",
		"PRINT_OLYMPIC_ROUNDS": "Print elimination rounds",
		"MIXED": "Mixed",
		"ADD_GAME_QUICKSTART": "Add match",
		"TYPE": "Type",
		"DATE_FILED": "Date filed",
		"GGA_NUMBER": "Official number",
		"LEVEL": "Level",
		"COACH_LEVEL": "Coach level",
		"JUDGE_LEVEL": "Judge level",
		"TRAINER_LEVEL": "Part-time Trainer level",
		"COACH_0_LEVEL": "Coach",
		"COACH_A_LEVEL": "A CATEGORY",
		"COACH_B_LEVEL": "B CATEGORY",
		"COACH_C_LEVEL": "C CATEGORY",
		"TRAINER_0_LEVEL": "Part-time Trainer",
		"TRAINER_1_LEVEL": "LEVEL 1",
		"TRAINER_2_LEVEL": "LEVEL 2",
		"TRAINER_3_LEVEL": "LEVEL 3",
		"CL1": "CL1",
		"CL2": "CL2",
		"TEAM_ENTRIES_LIST": "Entries Per Team",
		"ATHLETES_SCORECARDS": "Athletes Scorecards",
		"SELECT_LEVEL": "Select level",
		"JUDGE_STAFF": "Judge",
		"JUDGE_INTERNATIONAL": "International",
		"JUDGE_NATIONAL": "National",
		"JUDGE_CANDIDATE": "Candidate",
		"INDOOR": "Indoor",
		"OUTDOOR": "Outdoor",
		"indoor": "Indoor",
		"outdoor": "Outdoor",
		"GAME_TYPE": "Match type",
		"GAME_DETAILS": "Match details",
		"GAME_LEAGUES": "League details",
		"GREAT": "Great",
		"PREVIOUS": "Previous",
		"NEXT": "Next",
		"BIRTH_PLACE": "Birth place",
		"STATE": "State",
		"CITIZENSHIP": "Citizenship",
		"NATIONALITY": "Nationality",
		"EXPATRIATE": "Expatriate",
		"CITY": "City",
		"ADT": "ADT",
		"PASSPORT": "Passport",
		"HEALTH": "Health Code",
		"AMEA": "Para-Archery",
		"REGISTRATION_DATE": "Registration Date",
		"FULL_NAME": "Full name",
		"NAME": "Name",
		"IDENTIFY_DATE": "Identification date",
		"IDENTIFY_CODE": "Identification code",
		"COUNTY": "County",
		"FAX": "FAX",
		"WEB": "Website",
		"AFM": "VAT",
		"DOY": "VAT Location",
		"COACH_EMAIL": "E-mail Coach",
		"REGION": "Region",
		"CALENDAR": "Calendar",
		"REG_DATE": "Registration Date",
		"LNAME": "Last name",
		"FNAME": "First name",
		"STATUS": "Status",
		"DETAILS": "Details",
		"CLEAR_SHOTS": "Clear shots",
		"SUBMIT_RETURN": "Submit and return",
		"QUALIFICATION_MIXED_TEAM": "Qualification Mixed Team",
		"OLYMPIC_TEAM_MIXED": "Eliminations Mixed Team",
		"EMPTY_ALL_TARGETS": "Clear all targets",
		"PRINT_OLMPIC_LAYOUT": "Print eliminations layout",
		"PRODUCE_TARGETS": "Product Targets",
		"TARGETS_NUMBER": "Number of targets",
		"CHOOSE_PLAYERS": "Select athletes",
		"VIEW_REGISTRATION": "View registrations",
		"LIST_ENTRIES": "List of registrations",
		"DELETE": "Delete",
		"HOW_MANY": "How many?",
		"REGISTRATION_OPEN_DATE": "Registration open date",
		"REGISTRATION_END_DATE": "Registration ending date",
		"CLOSE_REGISTRATION": "Close registrations",
		"PRINT_ENTRIES_PDF": "Print registrations",
		"PRINT_ENTRIES_PDF_SPECIFIC": "Print team registrations",
		"GAME_ENTRIES": "Registrations",
		"NOTES": "Notes",
		"TARGETS": "Targets",
		"TARGET": "Target",
		"PLAYER_LEAGUES": "Athlete leagues",
		"ADD_SHOTS_OLYMPIC": "Add elimination round shots",
		"ADD_PLAYERS": "Add athletes",
		"REMOVE_PLAYERS": "Remove athletes",
		"PLAYERS_REGISTERD": "Athletes registrations",
		"EDIT_PERMISSIONS": "Edit permissions",
		"USER_ROLE": "Role",
		"EDIT_ROLES": "Edit roles",
		"CLOSED": "CLOSED",
		"OPEN": "OPEN",
		"REGISTRATION_STATUS": "Registration status is ",
		"REGISTRAION_CLOSED_TEXT": "** Registrations are closed. You cannot make any changes. Please contact XXX@XXX.XXX for any requests.",
		"CURRENT_LIST": "Current list",
		"ENTRIES_PDF": "Print registrations",
		"REGISTRATION_CLOSED_TEXT_LIST": "**Below is the list with the athletes that you have registered. The regstraion is now closed. You cannot make any changes. Please contact us for any kind of information you might need.",
		"ENTRIES_PROOF": "** Please print or have this with you at the match",
		"GRATZ_TO": "Congratulations to",
		"COMPETED_IN": "for competing in",
		"NOW_ELIGIBLE": "can now compete in",
		"AFTER_SCOREING": "after shooting",
		"PASSED_LIMIT": "and surpassing",
		"COMPANION": "Companion",
		"SAVE_MATCH_TEAM_INFO": "Save companions",
		"CAPTAIN": "Captain",
		"REQUIRED_FIELDS": "Fields with * are required",
		"PLUGINS": "Plugins",
		"VALIDATE_PASSPORTS": "Validate cards ( current year )",
		"VALIDATE_PASSPORT": "Validate card ( current year )",
		"FINANCIAL": "Financial",
		"ADD_PAYMENT_REASON": "Add payment",
		"PRICE": "Price",
		"COMMENTS": "Comments",
		"ADD_PAYMENT_TEAM": "Team payments",
		"ADD_PAYMENT_PLAYER": "Athlete payments",
		"PAYMENT_REASON": "Payment description",
		"ADD_PAYMENT": "Add payment",
		"REQUIRED_TEAM": "Required by teams to participate in matches",
		"REQUIRED_PLAYER": "Required by athletes to participate in matches",
		"YEAR": "Year",
		"ADD_NEW": "Add new",
		"EDIT_USERS": "Edit users",
		"PAYMENT_REPORT": "Payment report",
		"REPORT_OF_YEAR": "Payment report for year : ",
		"AMOUNT_PAID": "Amount paid",
		"MOVEMENT_REPORT": "Movements report",
		"TEAM_REPORT_NAME": "Name : ",
		"TOTAL_MOVEMENTS": "Total movements : ",
		"TOTAL_AMOUNT_MOVED": "Total amount : ",
		"PAYMENT_DATE": "Movement date",
		"STARTED_DATE": "Time started",
		"ENDED_DATE": "Time ended",
		"CANCEL": "Cancel",
		"PAYMENT_SUCCESSFULL": "Successful",
		"PAYMENT_FAILED": "Payment failed",
		"LIST_PAYMENT_MOVEMENTS_TEAMS": "Team payments",
		"LIST_PAYMENT_MOVEMENTS_PLAYERS": "Athletes payments",
		"EDIT_PAYMENT": "Edit payment",
		"CANCEL_PAYMENT": "Cancel payment",
		"PAYMENT_EDIT_SUCCESSFULL": "Edit was successful",
		"PAYMENT_EDIT_FAIL": "Edit failed",
		"IMPORT_SCORES": "Import scores",
		"PLAYER_PASSPORT": "Athlete passport",
		"VALID": "Valid",
		"NOT_VALID": "Not valid",
		"PAID": "Paid",
		"NOT_PAID": "Not paid",
		"STUDENT": "Student",
		"STUDENT_TEAM": "Student team",
		"NATIONAL": "National",
		"NATIONAL_TEAM": "National team",
		"AMEA_TEAM": "Team Î‘.Îœ.Î•.Î‘",
		"TRANSFERS": "Transfers",
		"TRANSFER": "Transfer",
		"FROM_TEAM": "From ",
		"TO_TEAM": "To ",
		"OLD_HEALTH": "Old passport",
		"NEW_HEALTH": "New passport",
		"TRANSFER_SUCCESSFUL": "Transfer successful",
		"TRANSFER_FAIL": "Transfer failed",
		"NEW_TRANSFER": "New transfer",
		"ALREADY_PAID": "Already paid",
		"ALREADY_EXISTS": "Already exists",
		"FROM_TO_EMPTY_FOR_ALL": "From - To",
		"PAYMENT_REASON_EMPTY_FOR_ALL": "Payment ( blank for all )",
		"PICK_TEAM_EMPTY_FOR_ALL": "Team ( blank for all )",
		"PICK_PLAYER_EMPTY_FOR_ALL": "Athlete ( blank for all )",
		"RESTORE_PAYMENT": "Restore payment",
		"LIST_TRANSFERS": "Transfers",
		"TRANSFER_DATE": "Date of transfer",
		"EDIT_TARGETS": "Edit targets",
		"TOTAL_ENTRIES": "Total entries",
		"UNIQUE_ENTRIES": "Unique entries",
		"PDF": "PDF",
		"MATCH_OVERVIEW": "Match Overview",
		"OFFICIAL_SCORE": "Official score",
		"ENTRIES": "Entries",
		"FORFEITED": "Forfeited/No show",
		"TEAM_INFO": "Team Info",
		"MOVE_GAME": "Move match",
		"MOVE_FRONT": "Move front",
		"MOVE_TARGETS": "Move targets",
		"DISTANCE": "Distance",
		"FROM_TARGET": "From target",
		"TO_TARGET": "To target",
		"MOVE_BACK": "Move back",
		"TOTAL_PLAYERS": "Total athletes",
		"TOP_SCORE_IN_LEAGUE": "Score",
		"TOTAL_ENTRIES_IN_LEAGUE": "Entries",
		"AMS_CODE": "Code",
		"EOT": "Saudi Archery Federation",
		"REPORT_1": "Athletes per Team",
		"REPORT_2": "Teams",
		"REPORT_3": "Registered athletes per team",
		"REPORT_4": "Matches and entries",
		"REPORT_5": "Athletes entries per league",
		"REPORT_6": "Athletes entries per team",
		"REPORT_7": "Athletes scores",
		"REPORT_8": "Most win athletes/teams",
		"REPORT_9": "Training center entries",
		"REPORT_10": "Best shootings per athlete/team/league",
		"REPORT_11": "Athletes #2",
		"REPORT_12": "Teams #2",
		"REPORT_13": "Medals",
		"FOR_YEAR": "For year",
		"SUSPEND_REASON": "Reason",
		"SUSPEND_TEAM": "Suspend Team",
		"TEAM_IS_SUSPENDED": "You cannot register athletes at this moment.",
		"TEAM_IS_SUSPENDED_PROFILE": "This team is suspended.",
		"OVERRIDE_AGE_LIMITS": "Override Age Limits",
		"PLAYER_MATCHES": "Athlete matches",
		"PLAYER_PAYMENTS": "Athlete payments",
		"PASSPORTS": "Passports",
		"START_DATE": "Start date",
		"DAYS_LEFT": "Days left",
		"VALID_UNTIL": "Valid until",
		"DAYS": "days",
		"EXPIRED": "Is expired",
		"ADD_PASSPORT": "Add passport",
		"LIMIT_INDOOR": "Indoor limit",
		"LIMIT_OUTDOOR": "Outdoor limit",
		"OVERRIDE_LIMITS": "Override Limits ( Age & Score )",
		"OVERRIDE_CHECKS": "Override All Check",
		"MATCH_CODE": "Match code",
		"PLAYER_NAME": "Athlete name",
		"FIRST_NAME": "First Name",
		"LAST_NAME": "Last Name",
		"SEX": "Sex",
		"MEN": "Male",
		"WOMEN": "Female",
		"OTHER": "Other",
		"EMAIL": "E-mail",
		"BIRTH": "Birthdate",
		"LEAGUE": "League",
		"TEAM": "Team",
		"EDIT": "Edit",
		"PICK_PLAYER": "Select athlete",
		"FATHER_NAME": "Father name",
		"MOTHER_NAME": "Mother name",
		"CODE": "Code",
		"TEAM_NAME": "Team name",
		"LOCATION": "Location",
		"PICK_TEAM": "Pick team",
		"ADDRESS": "Address",
		"EFOT_REG": "Organization code",
		"PC": "Postal Code",
		"ADMIN": "Admin",
		"COACH": "Coach",
		"PHONE": "Phone",
		"TARGET_FROM": "Targets from",
		"TARGET_TO": "to",
		"GAME_NAME": "Match name",
		"DATE": "Date",
		"LEAGUES": "Leagues",
		"PICK_GAME": "Select match",
		"TARGET_NAME": "Target",
		"ROUND": "Round",
		"PICK_TARGET": "Pick target",
		"SHOT_1": "Shot 1",
		"SHOT_2": "Shot 2",
		"SHOT_3": "Shot 3",
		"SHOT_4": "Shot 4",
		"SHOT_5": "Shot 5",
		"SHOT_6": "Shot 6",
		"SHOT_7": "Shot 7",
		"SHOT_8": "Shot 8",
		"SHOT_9": "Shot 9",
		"SHOT_10": "Shot 10",
		"UPDATE_ROUND_1": "Update Round 1",
		"UPDATE_ROUND_2": "Update Round 2",
		"ARE_YOU_SURE_UPDATE_GAME": "Are you sure you want to update the match?",
		"INFO_GAME": "Match info",
		"JUDGE": "Judges",
		"REPRESENTER": "Represented",
		"COMMITTEE": "Committee",
		"SWAP_PLAYERS": "Swap athletes",
		"MOVE_PLAYER": "Move to target",
		"SWAP_TARGETS": "Swap targets",
		"ORDER_BY": "Sort by",
		"SEARCH_NAME": "Search by athlete",
		"SEARCH_TEAM": "Search by team",
		"PICK_ROUND": "Select round",
		"ARROW": "Arrow",
		"LEAGUE_NAME": "League",
		"CATEGORY": "League",
		"CATEGORY_S": "Leag.",
		"PICK_LEAGUE": "Select league",
		"TOTAL_SCORE": "Total score",
		"SHOT_NOW": "Shot No",
		"TOTAL": "Total",
		"TOTAL/RANK": "Total/ Rank",
		"TOTAL/RANKs": "Total",
		"TOTAL_SCORE_POINTS": "Points",
		"REAL_LIVESCORES": "Live scores",
		"SHOT_NUMBER_NOW": "shot now",
		"SHOT_SCORE_SO_FAR": "Score so far",
		"RANK": "Rank",
		"ROUND_1/RANK": "Round 1/ Rank",
		"ROUND_2/RANK": "Rank 2/ Rank",
		"ROUND_1/RANKs": "R.1",
		"ROUND_2/RANKs": "R.2",
		"10s": "10s",
		"9s": "9s",
		"10ss": "10",
		"9ss": "9",
		"INCREMENT_SCORE": "Increment score",
		"FINAL_SCORE": "Final score",
		"SHOT_SCORE": "Shot score",
		"F10s": "Total 10s",
		"F9s": "Total 9s",
		"STOP_AUTOSCROLLING": "Stop Autoscrolling",
		"TOP_2_PLAYERS": "Best 2 athletes per league",
		"START_AUTOSCREOLLING": "Start Autoscrolling",
		"MATCH_DATE": "Match date",
		"DOWNLOAD_RESULTS": "Download results",
		"UPLOAD_RESULTS_PDF": "Update results",
		"CURRENT_RESULTS_PDF": "Current results",
		"IMPORT_OLD_GAMES": "Import old matches",
		"EXTENSION_ERROR": "File extension is not allowed.",
		"PHOTO_SIZE_ERROR": "Photos up to 2ÎœÎ’",
		"UNKNOWN": "Unknown error on upload.",
		"UPLOAD_FAILED": "Upload failed.",
		"NO_IMAGE": "Select an image first.",
		"ALL_ATHLETES": "All athletes",
		"ACTIVE_ATHLETES": "Active athletes",
		"RECURVE_LEVEL": "Recurve level",
		"COMPOUND_LEVEL": "Compound level",
		"BOW_TYPE": "Bow",
		"MIXED_LEAGUE": "Mixed League",
		"TARGET_BOARDS": "Target Boards",
		"STARTING_FROM_TARGET": "Starting from",
		"trainingCenters": "Training Centers",
		"TITLE": "Title",
		"CREATE_TRAINING_CENTER": "Create training center",
		"EDIT_TRAINING_CENTER": "Edit training center",
		"TRAINING_CENTERS": "Training Centers",
		"CONFIRM_DELETE_TRAINING_CENTER": "Delete training center?",
		"SELECT_TRAINING_CENTER": "Select training center",
		"editRoles": "Edit roles",
		"addPlayer": "Add athlete",
		"editPlayer": "Edit athlete",
		"deletePlayer": "Delete athlete",
		"addTeam": "Add club",
		"editTeam": "Edit club",
		"deleteTeam": "Delete club",
		"addLeague": "Add league",
		"editLeague": "Edit league",
		"deleteLeague": "Delete league",
		"addGame": "Add event",
		"editGame": "Edit event",
		"deleteGame": "Delete event",
		"editGameTargets": "Edit event targets",
		"editGameLeagues": "Edit event leagues",
		"editGamePlayerLeague": "Edit event leagues for athletes",
		"addPlayersToMatch": "Add athletes to event",
		"removePlayersFromMatch": "Remove athletes from event",
		"addShotsToGame": "Add shots to event",
		"gameUpdate": "Update event",
		"olympic": "Elimination Rounds",
		"addShotsToOlympic": "Add shots to elimination rounds",
		"calendar": "Calendar",
		"files": "Files",
		"stats": "Statistics",
		"viewAllPlayers": "View all athletes",
		"viewAllTeams": "View all clubs",
		"viewAllLeagues": "View all leagues",
		"settings": "Settings",
		"livescores": "Livescore",
		"passportValidate": "Update document",
		"viewFinancial": "View Financial Statements",
		"addPaymentReason": "Add payment reason",
		"addPaymentTeam": "Add club payment",
		"addPaymentPlayer": "Add athlete payment",
		"changeTeamPassword": "Change club password",
		"viewAllMovementsTeams": "View all club payments",
		"playerTransfers": "Transfers",
		"viewAllMovementsPlayers": "View all athlete payments",
		"makePlayerTransfer": "Add-Edit athlete transfer",
		"viewAllTransfers": "View all transfers",
		"moveGame": "Transfer event",
		"checkInPlayerToMatch": "Check in athlete to event",
		"matchPrints": "Event prints",
		"viewReports": "View reports",
		"viewUsers": "View users",
		"editUsers": "Edit users",
		"overrideMatchFilters": "Override event filters",
		"viewAllJudges": "View all judges",
		"addJudge": "Add judge",
		"editJudge": "Edit judge",
		"deleteJudge": "Delete judge",
		"viewAllCoaches": "View all coaches",
		"addCoach": "Add coach",
		"editCoach": "Edit coach",
		"deleteCoach": "Delete coach",
		"viewAllTrainers": "View all part-time trainers",
		"addTrainer": "Add part-time trainer",
		"editTrainer": "Edit part-time trainer",
		"deleteTrainer": "Delete part-time trainer",
		"viewAllTrainingEntries": "View all training centers entries",
		"addTrainingEntry": "Add training center entry",
		"editTrainingEntry": "Edit training center entry",
		"deleteTrainingEntry": "Delete training center entry",
		"viewAllStaff": "View all staff",
		"addStaff": "Add staff",
		"editStaff": "Edit staff",
		"deleteStaff": "Delete staff",
		"viewAllTrainingCenters": "View Training Centers",
		"addTrainingCenter": "Add new training center",
		"editTrainingCenter": "Edit Training Center",
		"deleteTrainingCenter": "Delete Training Center",
		"ATHLETES_MATCH_CARDS": "Athletes match cards",
		"CERTIFICATES": "Certificates",
		"PLAYER_AGE": "Age",
		"AGE_FROM": "Age (From)",
		"AGE_TO": "Age (To)",
		"paraArchery": "Para Archery",
		"MATCH_CITY": "City",
		"MATCH_END_DATE": "Match End date",
		"ATHLETE_MATCH_ENTRY_CARDS": "Athlete Match Entry Cards",
		"BOARDS": "Boards",
		"ADD_SHOTS_VISUAL_ELIMINATIONS": "Eliminations Visual"
	};

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

	module.exports = {
		"10s": "10s",
		"10ss": "10",
		"9s": "9s",
		"9ss": "9",
		"ABOUT": "عن",
		"ABOUT_ME": "عني",
		"ACTIONS": "الاحداث",
		"ACTIVE": "فعال",
		"ACTIVE_ATHLETES": "الرياضيين الفاعلين",
		"ADD": "إضافة",
		"ADDRESS": "العنوان",
		"ADD_ELIMINATION_LEAGUE": "إضافة دوري",
		"ADD_GAME": "إضافة مباراة",
		"ADD_GAME_QUICKSTART": "إضافة مباراة",
		"ADD_LEAGUE": "إضافة فئة",
		"ADD_NEW": "إضافة جديد",
		"ADD_NEW_PAYMENT": "إضافة دفعة جديدة",
		"ADD_OLYMPIC_SHOTS": "إضافة رميات جولات تصفيات",
		"ADD_PASSPORT": "إضافة جواز سفر",
		"ADD_PAYMENT": "إضافة دفعة",
		"ADD_PAYMENT_PLAYER": "دفعات اللاعب",
		"ADD_PAYMENT_REASON": "إضافة سبب الدفعة",
		"ADD_PAYMENT_TEAM": "دفعات الفريق",
		"ADD_PLAYER": "إضافة لاعب",
		"ADD_PLAYERS": "إضافة لاعبين",
		"ADD_PLAYERS_TO_MATCH": "إضافة لاعبين للبطولة",
		"ADD_PLAYERS_TO_TEAM": "إضافة لاعبين للفريق",
		"ADD_PLAYER_PAYMENT": "إضافة دفعة جديدة للاعب",
		"ADD_PLAYER_TO_MATCH": "إضافة لاعب للبطولة",
		"ADD_REMOVE_PLAYERS": "إضافة/حذف لاعبين",
		"ADD_SHOTS": "إضافة رميات",
		"ADD_SHOTS_INDIVIDUAL": "إضافة رميات للاعبين الافراد",
		"ADD_SHOTS_MIXED_TEAM": "إضافة رميات للفريق المختلط",
		"ADD_SHOTS_OLYMPIC": "إضافة رميات جولات ",
		"ADD_SHOTS_P1": "إضافة رميات لاعب 1",
		"ADD_SHOTS_P2": "إضافة رميات لاعب 2",
		"ADD_SHOTS_P3": "إضافة رميات لاعب 3",
		"ADD_SHOTS_TEAM": "إضافة رميات الفريق",
		"ADD_SHOTS_TO_GAME": "إضافة رميات للمباراة",
		"ADD_SHOTS_VISUAL": "تحديث بصري للرميات على الهدف",
		"ADD_TEAM": "إضافة فريق",
		"ADD_TEAM_PAYMENT": "إضافة دفعة جديدة للفريق",
		"ADD_TRAINING_ENTRIES": "إضافة التسجيل للتدريب",
		"ADD_WITHOUT_DETAILS": "إضافة بدون تفاصيل",
		"ADD_WITH_DETAILS": "إضافة مع التفاصيل",
		"ADD_WITH_FILE": "إضافة مع ملف",
		"ADMIN": "المدير",
		"ADT": "ADT",
		"AD_BLOCK_MESSAGE": "للاستخدام الصحيح يرجى تعطيل مانع الإعلانات في متصفحك.",
		"AFM": "ضريبه القيمه المضافه",
		"AFTER_SCOREING": "بعد نهاية الرمي",
		"AGE": "العمر ( يساوي او اكبر )",
		"ALL_ATHLETES": "جميع الرياضيين",
		"ALL_PLAYERS": "جميع اللاعبين",
		"ALL_TARGETS": "جميع الاهداف",
		"ALPHA_LIST_GAME": "طباعة مباراة الرياضيين مع الأهداف",
		"ALREADY_ACTIVE_SESSION": "هناك بالفعل جلسة نشطة. إنهاء هذه أولاً",
		"AMEA": "ذوي الإعاقة",
		"AMEA_TEAM": "فريق بارا‘",
		"AMOUNT": "مبلغ",
		"AMOUNT_PAID": "المبلغ المدفوع",
		"AMS_CODE": "الكود",
		"ARCHER": "الرامي",
		"ARE_YOU_SURE_UPDATE_GAME": "هل أنت متأكد من تحديث المباراة?",
		"ARROW": "السهم",
		"ARROWS": "الاسهم",
		"ARROW_NOW": "السهم الان",
		"ATHLETE": "الرياضي",
		"ATHLETES_SCORECARDS": "الرياضيين بطاقات نتائج",
		"AUTHORIZATION_KEY": "رمز التفويض",
		"AVAILABLE": "متاح",
		"BACK": "العودة",
		"BIRTH": "تاريخ الميلاد",
		"BIRTHDATE": " تاريخ الميلاد",
		"BIRTH_DATE": " تاريخ الميلاد ",
		"BIRTH_PLACE": "مكان الميلاد",
		"BOW_TYPE": "نوع القوس",
		"BRONZE": "برونز",
		"C": "C",
		"CALENDAR": "التقويم",
		"CANCEL": "الغاء",
		"CANCEL_PAYMENT": "الغاء الدفعة",
		"CAPTAIN": "الكابتن",
		"CATEGORY": "فئة",
		"CATEGORY_S": "فئات",
		"CHANGE_MATCH": "تغيير البطولة",
		"CHANGE_PASSWORD": "تغيير كلمة المرور",
		"CHANGE_TEAM_PASSWORD": "تغيير كلمة مرور الفريق",
		"CHANGE_USER_PASSWORD": "تغيير كلمة مرور المستخدم",
		"CHECK_THIS_FOR_ALL": "تحقق من هذا لجميع البطولات",
		"CHOOSE_PLAYERS": "اختيار الرياضيين",
		"CITIZENSHIP": "مواطن",
		"CITY": "المدينة",
		"CL1": "CL1",
		"CL2": "CL2",
		"CLEAR_ROUND": "مسح رميات الجولة",
		"CLEAR_SHOTS": "مسح الرميات ",
		"CLOSED": "مغلق",
		"CLOSER_TO_CENTER": "أقرب إلى المركز",
		"CLOSE_REGISTRATION": "إغلاق التسجيلات",
		"COACH": "مدرب",
		"COACHES": "المدربين",
		"COACH_0_LEVEL": "مدرب مبتديء",
		"COACH_A_LEVEL": "مدرب مستوى أ",
		"COACH_B_LEVEL": "مدرب مستوى ب ",
		"COACH_C_LEVEL": "مدرب مستوى ج ",
		"COACH_EMAIL": "ايميل المدرب",
		"COACH_LEVEL": "مستوى المدرب",
		"COACH_OF": "مدرب الـ ",
		"COACH_PROFILE": "ملف المدرب",
		"CODE": "الكود",
		"COMMENTS": "الملاحظات ",
		"COMMITTEE": "اللجنة",
		"COMPANION": "المرافق",
		"COMPETED_IN": "للتنافس في",
		"COMPOUND": "قوس مركب",
		"COMPOUND_JM_JW": "قوس مركب للناشئين اولاد - بنات",
		"COMPOUND_LEVEL": "مستوى القوس المركب",
		"COMPOUND_M_W": " قوس مركب رجال - سيدات ",
		"COMPOUND_YM_YW": " قوس مركب للشباب اولاد - بنات ",
		"CONFIRM": "تأكيد",
		"CONFIRM_CLEAR_TARGETS": "هل أنت متأكد من أنك تريد مسح الأهداف؟",
		"CONFIRM_DELETE_COACH": "هل أنت متأكد من أنك تريد حذف هذا المدرب؟",
		"CONFIRM_DELETE_ELIMINATION_MATCH": "هل أنت متأكد من أنك تريد حذف الدور الاقصائي هذا؟",
		"CONFIRM_DELETE_JUDGE": "هل أنت متأكد من أنك تريد حذف هذا الحكم؟",
		"CONFIRM_DELETE_LEAGUE": "هل أنت متأكد من أنك تريد حذف هذا الفئة؟",
		"CONFIRM_DELETE_MATCH": "هل أنت متأكد من أنك تريد حذف هذه البطولة؟",
		"CONFIRM_DELETE_PAYMENT": "هل أنت متأكد من أنك تريد حذف هذه الدفعة؟",
		"CONFIRM_DELETE_PLAYER": "هل أنت متأكد من أنك تريد حذف هذا الرياضي؟",
		"CONFIRM_DELETE_TEAM": "هل أنت متأكد من أنك تريد حذف هذا الفريق؟",
		"CONFIRM_DELETE_TRAINER": "هل أنت متأكد من أنك تريد حذف هذا المدرب؟",
		"CONFIRM_DELETE_TRAINING_CENTER": "حذف مركز التدريب؟",
		"CONFIRM_MOVE_LEAGUES": "هل أنت متأكد من أنك تريد نقل هذه الفئات؟",
		"CONFIRM_REMOVE_LEAGUE_FROM_MATCH": "هل أنت متأكد من أنك تريد إزالة هذه الفئة من البطولة ؟",
		"CONFIRM_REMOVE_PLAYER_FROM_MATCH": "هل أنت متأكد من أنك تريد إزالة هذا الرياضي من البطولة؟",
		"CONTRACT_DATE": "تاريخ انتهاء العقد",
		"COUNTY": "المنطقة",
		"CREATE": "إنشاء",
		"CREATED_AT": "تم إنشائه في",
		"CREATE_COACH": "إضافة مدرب",
		"CREATE_JUDGE": "إضافة حكم",
		"CREATE_LEAGUE": "إنشاء فئة",
		"CREATE_MATCH": "إنشاء بطولة ",
		"CREATE_PLAYER": "إنشاء لاعب",
		"CREATE_ROLE": "قاعدة جديدة",
		"CREATE_TEAM": "إنشاء فريق",
		"CREATE_TRAINER": "إضافة مدرب ",
		"CREATE_TRAINING_CENTER": "إنشاء مركز تدريب",
		"CREATE_USER": "مستخدم جديد",
		"CURRENT_ACTIVE_INSIDE": "حاليا داخل مركز التدريب",
		"CURRENT_LIST": "القائمة الحالية",
		"CURRENT_PLAYERS": "الرياضيون الحاليون",
		"CURRENT_RESULTS_PDF": "النتائج الحالية",
		"CURRENT_ROUND": "الجولة الحالية",
		"CUSTOM": "مخصص",
		"DASHBOARD": "لوحة التحكم",
		"DATE": "التاريخ",
		"DATE_FILED": "حقل التاريخ",
		"DATE_FROM": "من تاريخ",
		"DATE_TO": "الى تاريخ",
		"DAYS": "الايام",
		"DAYS_LEFT": "الأيام المتبقية",
		"DEGREE_SETTINGS": "إعدادات الدرجة",
		"DELETE": "حذف",
		"DELETE_GAME": "حذف الجولة",
		"DELETE_LEAGUE": "حذف الفئة",
		"DELETE_PLAYER": "حذف رياضي",
		"DELETE_TEAM": "حذف الفريق",
		"DELETE_TRAINING_ENTRY": "حذف إدخال التدريب؟",
		"DESCRIPTION": "وصف",
		"DETAILS": "التفاصيل",
		"DIRECTION": "اتجاه",
		"DISPLAY_NAME": "اسم",
		"DISTANCE": "المسافة",
		"DISTANCE_INDOOR": "المسافة الداخلية",
		"DISTANCE_OUTDOOR": "المسافة الخارجية",
		"DOWNLOAD": "تحميل",
		"DOWNLOAD_CARD": "بطاقة",
		"DOWNLOAD_RESULTS": "تنزيل النتائج",
		"DOWNLOAD_TRAINING_CARD": "بطاقة التدريب",
		"DOY": "موقع ضريبة القيمة المضافة",
		"EDIT": "تعديل",
		"EDIT_COACH": "تعديل المدرب",
		"EDIT_GAME": "تعديل المباراة",
		"EDIT_GAME_LEAGUES": "تعديل مباريات الفئة",
		"EDIT_GAME_LEAGUES_PLAYERS": "تعديل لاعبي الفئة",
		"EDIT_JUDGE": "تعديل حكم",
		"EDIT_LEAGUE": "تعديل الفئة",
		"EDIT_MATCH": "تعديل البطولة",
		"EDIT_PAYMENT": "تعديل الدفعة",
		"EDIT_PERMISSIONS": "تعديل الصلاحيات",
		"EDIT_PLAYER": "تعديل الرياضي",
		"EDIT_PLAYER_PAYMENT": " تعديل دفعة الرياضي ",
		"EDIT_ROLE": "تعديل الدور",
		"EDIT_ROLES": "تعديل الأدوار",
		"EDIT_STAFF": "تعديل الموظفين",
		"EDIT_TARGETS": "تعديل الاهداف",
		"EDIT_TEAM": "تعديل الفريق",
		"EDIT_TEAM_PAYMENT": " تعديل دفعة الفريق ",
		"EDIT_TRAINER": " تعديل المدرب ",
		"EDIT_TRAINING_CENTER": " تعديل مركز التدريب",
		"EDIT_TRANSFER_PLAYER": "تعديل انتقال اللاعب",
		"EDIT_USER": "تعديل المستخدم",
		"EDIT_USERS": "تعديل المستخدمين",
		"EFOT_REG": "كود الجهة",
		"ELIMINATION_INDIVIDUAL": "تصفيات الافراد",
		"ELIMINATION_INDIVIDUAL_LEAGUES": "تصفيات الافراد فئات",
		"ELIMINATION_MIXED_TEAM": "تصفيات فرق المختلط",
		"ELIMINATION_MIXED_TEAM_LEAGUES": "فئة تصفيات فرق المختلط",
		"ELIMINATION_PARTICIPANTS": "المشاركون",
		"ELIMINATION_ROUNDS": "التصفيات",
		"ELIMINATION_TEAM": "تصفيات الفرق",
		"ELIMINATION_TEAM_LEAGUES": "فئات تصفيات الفرق",
		"EMAIL": "البريد الإلكتروني",
		"EMPTY_ALL_TARGETS": "مسح جميع الأهداف",
		"EMPTY_SHOTS": "لديه تسديدات فارغة على الهدف ",
		"END": "انهاء",
		"ENDED": "منتهي",
		"ENDED_DATE": "انتهى الوقت",
		"END_TRAINING_ENTRY": "هل أنت متأكد من أنك تريد إنهاء الإدخال؟",
		"ENTER": "ادخال",
		"ENTRIES": "المدخلات",
		"ENTRIES_BY_TEAM": "التسجيلات حسب الفريق",
		"ENTRIES_PDF": "طباعة التسجيلات",
		"ENTRIES_PROOF": "** يرجى طباعة هذا أو اصطحابه معك في المباراة",
		"EOT": "الاتحاد السعودي للسهام",
		"EQUIPMENT": "معدات",
		"ERROR": "حدث خطأ ما ...",
		"ERROR_MONKEYS": "عفوا ، حدث خطأ ما",
		"EXISTS": "موجود مسبقا",
		"EXIT_GAME": "خروج",
		"EXPATRIATE": "وافد",
		"EXPIRED": "منتهي الصلاحية",
		"EXPORT_GAME": "تصدير البطولة",
		"EXTENSION_ERROR": "امتداد الملف غير مسموح به.",
		"F10s": "مجموع ال10",
		"F9s": "مجموع ال9",
		"FATHER": "الأب",
		"FATHER_NAME": "اسم الأب",
		"FAX": "فاكس",
		"FEMALE": "أنثى",
		"FIELD_1": "الحقل 1",
		"FIELD_2": "الحقل 2",
		"FIELD_3": "الحقل 3",
		"FILE_EXPLORER": "الملفات",
		"FILTERS": "مرشحات",
		"FINAL": "نهائي",
		"FINALIZE_MATCH": "إنهاء البطولة",
		"FINALIZE_ROUND_ONE": "إنهاء الجولة 1",
		"FINALIZE_ROUND_TWO": " إنهاء الجولة 2",
		"FINAL_SCORE": "النتيجة النهائية",
		"FINAL_SCORES": "النتائج النهائية",
		"FINAL_SHOT": "الرمية الاخيرة",
		"FINANCIAL": "مالي",
		"FINAl_SCORES_ROW": "النتائج النهائية",
		"FIRST_NAME": "الاسم الأول",
		"FNAME": "الاسم الأول",
		"FOR": "من أجل",
		"FORFEITED": " عدم الحضور",
		"FORGOT_PASSWORD_ENTER_EMAIL": "أدخل بريدك الإلكتروني وسنقوم بإعادة توجيه رسالة بريد إلكتروني تحتوي على التعليمات.",
		"FORGOT_YOUR_PASSWORD": "هل نسيت كلمة المرور؟",
		"FOR_YEAR": "للسنة",
		"FROM": "من",
		"FROM_TARGET": "من الهدف",
		"FROM_TEAM": "من ",
		"FROM_TO_EMPTY_FOR_ALL": "من - إلى",
		"FRONT": "أمام",
		"FULL_NAME": "الاسم الكامل",
		"FXs": " Xsمجموع ",
		"GAME": "البطولة",
		"GAME_DETAILS": "تفاصيل البطولة",
		"GAME_ENTRIES": "التسجيلات",
		"GAME_HISTORY": "سجل البطولة",
		"GAME_LEAGUES": "تفاصيل الفئة",
		"GAME_LOGOUT": "تسجيل الخروج من البطولة",
		"GAME_NAME": "اسم البطولة",
		"GAME_RESULTS": "نتائج البطولة",
		"GAME_STATS": "احصائيات البطولة",
		"GAME_TYPE": "نوع البطولة",
		"GGA_NUMBER": "الرقم الرسمي",
		"GOLD": "ذهبي",
		"GO_BACK": "الرجوع للخلف",
		"GO_TO_PROFILE": "ملف تعريف",
		"GRATZ_TO": "تهانينا ل",
		"GREAT": "عظيم",
		"GREEK": "Greek",
		"HAS_COACH": "هل لديك مدرب؟",
		"HEALTH": "كود الصحة",
		"HERE_ARE": "فيما يلي نتائج المسابقة التي شاركت فيها ",
		"HERE_ARE_TEAM": "فيما يلي نتائج المسابقة التي شارك فيها ناديك ",
		"HOST": "مضيف",
		"HOW_MANY": "كم عدد؟",
		"IDENTIFY_CODE": "رمز التعريف",
		"IDENTIFY_DATE": "تاريخ الهوية",
		"IMAGE": "صورة",
		"IMPORT_GAME": "استيراد البطولة",
		"IMPORT_OLD_GAMES": "استيراد البطولات القديمة",
		"IMPORT_SCORES": "استيراد النتائج",
		"INCREMENT_SCORE": "درجة الزيادة",
		"INC_SCORE": "زيادة النتيجة",
		"INDEX": "الصفحة الرئيسية",
		"INDIVIDUAL": "فردي",
		"INDIVIDUAL_OLYMPIC": "جولات الإقصاء الفردية",
		"INDOOR": "داخلي",
		"INFO": "معلومات",
		"INFORMATION": "معلومات",
		"INFO_GAME": "معلومات البطولة",
		"JUDGE": "الحكم",
		"JUDGES": "الحكام",
		"JUDGE_CANDIDATE": "الحكم المرشح",
		"JUDGE_INTERNATIONAL": "حكم دولي",
		"JUDGE_LEVEL": "مستوى الحكم",
		"JUDGE_NATIONAL": "حكم محلي",
		"JUDGE_PROFILE": "ملف تعريف للحكم",
		"JUDGE_STAFF": "فريق التحكيم",
		"LAST_NAME": "اسم العائلة",
		"LEAGUE": "الفئة",
		"LEAGUES": "الفئات",
		"LEAGUES_LIST": "التسجيلات حسب الفئة",
		"LEAGUE_CAT": "تصنيف الفئة",
		"LEAGUE_CODE": "كود الفئة",
		"LEAGUE_ELIMINATIONS_ELIGIBILITY": " أهلية تصفيات الفئة ",
		"LEAGUE_NAME": "اسم الفئة",
		"LEAGUE_ORDER": "الترتيب",
		"LEAGUE_SEX": "الجنس",
		"LEAGUE_SORT_NAME": "اسم المختصر",
		"LEAGUE_TYPE": "النوع",
		"LEVEL": "المستوى",
		"LIMBS": "الاذرعة",
		"LIMIT_INDOOR": "حد البطولات الداخلية",
		"LIMIT_OUTDOOR": " حد البطولات الخارجية ",
		"LIST_BY_TEAM": "قائمة الفرق",
		"LIST_ENTRIES": "قائمة التسجيلات",
		"LIST_GAMES": "قائمة البطولات",
		"LIST_LEAGUES": "قائمة الفئات",
		"LIST_PAYMENT_MOVEMENTS_PLAYERS": "مدفوعات الرياضيين",
		"LIST_PAYMENT_MOVEMENTS_TEAMS": "مدفوعات الفريق",
		"LIST_PLAYERS": "قائمة الرياضيين",
		"LIST_TEAMS": "قائمة الفرق",
		"LIST_TRANSFERS": "قائمة الانتقالات",
		"LIVESCORES": "نتائج مباشرة",
		"LNAME": "اسم العائلة",
		"LOAD_ALL_PLAYERS": "تحميل جميع الرياضيين",
		"LOAD_FINANCIAL_OK_PLAYERS": "تحميل اللاعبين المسددين للرسوم ",
		"LOCATION": "مكان",
		"LOGOUT": "تسجيل خروج",
		"MALE": "ذكر",
		"MAP_LOCATION": "الموقع",
		"MATCHES": "البطولات",
		"MATCH_CHAMPIONSHIP": "البطولة",
		"MATCH_CODE": "كود البطولة",
		"MATCH_COMMITTEE": "لجنة البطولة",
		"MATCH_CUP": "كاس البطولة",
		"MATCH_DATE": "تاريخ البطولة",
		"MATCH_ELIGIBILITY_EXPLAIN_TEXT": "لا يمكنك تسجيل الرياضي لهذه البطولة للأسباب التالية:",
		"MATCH_ENTRIES_LIMIT": "حد إدخالات البطولة",
		"MATCH_HOST": "مضيف",
		"MATCH_ID": "كود البطولة",
		"MATCH_JUDGE": "حكم البطولة",
		"MATCH_LEAGUES": "فئات البطولة",
		"MATCH_LOCATION": "موقع البطولة",
		"MATCH_NAME": "اسم البطولة",
		"MATCH_OFFICIAL": "اداري البطولة",
		"MATCH_OVERVIEW": "نظرة عامة على البطولة",
		"MATCH_REGISTRATION_END": "تاريخ إغلاق التسجيل",
		"MATCH_REGISTRATION_START": "تاريخ فتح باب التسجيل",
		"MATCH_REPRESENTER": "ممثل البطولة",
		"MATCH_RESULTS": "نتائج البطولة",
		"MATCH_SORT_NAME": "فرز الاسم",
		"MATCH_TYPE": "نوع",
		"MEDAL": "ميدالية",
		"MEDALS": "الميداليات",
		"MEDALS_FROM_OLYMPIC": "ميداليات من جولات الإقصاء",
		"MEDALS_FROM_QUALIFICATIONS": "ميداليات من التأهيل",
		"MEN": "ذكر",
		"MENU": "قائمة",
		"MENU_SETTINGS": "إعدادات القائمة",
		"MIXED": "مختلط",
		"MIXED_LEAGUE": "فئة المختلط",
		"MIXED_TEAM": "فرق المختلط",
		"MIXED_TEAM_OLYMPIC": "جولات إقصاء الفرق المختلطة",
		"MOBILE_SCORING_ROUND_1_OPEN": "السماح بالتسجيل من الهواتف المحمولة (الجولة 1)",
		"MOBILE_SCORING_ROUND_2_OPEN": "السماح بالتسجيل من الهواتف المحمولة ( الجولة 2 )",
		"MONEY_CHECK": "فحص",
		"MOTHER": "الأم",
		"MOTHER_NAME": "اسم الأم",
		"MOVEMENT_REPORT": "تقرير الحركات",
		"MOVE_BACK": "العودة إلى الخلف",
		"MOVE_FRONT": "التحرك للأمام",
		"MOVE_GAME": "نقل البطولة",
		"MOVE_MATCH": "نقل البطولة",
		"MOVE_PLAYER": "نقل الهدف",
		"MOVE_TARGETS": "نقل الأهداف",
		"MRS": "عزيزي السيد / السيدة",
		"NAME": "اسم",
		"NATIONAL": "وطني",
		"NATIONALITY": "الجنسية",
		"NATIONAL_TEAM": "الفريق الوطني",
		"NEANIDWN": "البنات",
		"NEW_HEALTH": "جواز سفر جديد",
		"NEW_HEALTH_SORT": "رقم صحي جديد",
		"NEW_MATCH": "بطولة جديدة",
		"NEW_PASSWORD": "كلمة مرور جديدة",
		"NEW_PASSWORD_CONFIRMATION": "كلمة مرور جديدة (تأكيد)",
		"NEW_TEAM": "فريق جديد",
		"NEW_TRANSFER": "نقل جديد",
		"NEW_TRANSFER_PLAYER": "انتقال رياضي جديد",
		"NEXT": "التالي",
		"NEXT_ROUND": "الجولة التالية",
		"NO": "لا",
		"NOTES": "ملاحظات",
		"NOT_AVAILABLE": "غير متوفر",
		"NOT_ENOUGH_PLAYERS": "الفريق ليس لديه ما يكفي من الرياضيين للمشاركة",
		"NOT_FOUND": "لم يتم العثور على استخدام الرمز",
		"NOT_PAID": "غير مدفوع",
		"NOT_VALID": "غير صالح",
		"NOW_ELIGIBLE": "يمكن الآن المنافسة في",
		"NO_FOR_OLYMPIC": "عدد الرياضيين لجولة الإقصاء",
		"NO_FOR_OLYMPIC_TEAMS": "# من الفرق لجولات الإقصاء",
		"NO_IMAGE": "حدد صورة أولا.",
		"NO_MORE_ENTRIES_AVAILABLE": "لا مزيد من الإدخالات المتاحة",
		"NO_RESULTS": "لم يتم العثور على نتائج",
		"NO_TEAM_YEAR_PAYMENT_MADE": "لم يقم النادي الرياضي بالدفع السنوي",
		"NO_YEAR_PAYMENT_MADE": " لم يقم الرياضي بالدفع السنوي ",
		"NUMBER": "#",
		"O/I": "",
		"OAKA_TRAINING_CENTER": "مركز تدريب",
		"OFFICIAL": "رسمي",
		"OFFICIAL_SCORE": "النتيجة الرسمية",
		"OLD_HEALTH": "جواز السفر القديم",
		"OLD_HEALTH_SORT": "الرقم الصحي القديم",
		"OLD_TEAM": "الفريق القديم",
		"OLYMPIC": "جولات الإقصاء",
		"OLYMPIC_ROUNDS_INDIVIDUAL": "الإقصاءات الفردية",
		"OLYMPIC_ROUNDS_TEAM": "إقصاءات الفريق",
		"OLYMPIC_TEAM_MIXED": "إقصاءات فريق مختلط",
		"OL_TEAM": "فريق",
		"ONE_PLAYER": "رياضي واحد",
		"OPEN": "مفتوح",
		"ORDER_BY": "ترتيب حسب",
		"OTHER": "آخر",
		"OUTDOOR": "خارجي",
		"OVERRIDE_AGE_LIMITS": "تجاوز حدود العمر",
		"OVERRIDE_CHECKS": "تجاوز جميع المراجعات",
		"OVERRIDE_LIMITS": "حدود التجاوز (العمر والنتيجة)",
		"OVERVIEW": "نظرة عامة على البطولة",
		"PAID": "مدفوع",
		"PASSED_LIMIT": "تجاوز الحد",
		"PASSPORT": "جواز سفر",
		"PASSPORTS": "جوازات السفر",
		"PASSWORD": "كلمة المرور",
		"PAUSE": "ايقاف",
		"PAUSED": "متوقف",
		"PAUSE_TRAINING_ENTRY": "هل أنت متأكد من أنك تريد إيقاف الإدخال مؤقتا؟",
		"PAYMENT": "دفع",
		"PAYMENTS": "الدفعات",
		"PAYMENT_DATE": "تاريخ الحركة",
		"PAYMENT_EDIT_FAIL": "فشل التعديل",
		"PAYMENT_EDIT_SUCCESSFULL": "تم التعديل بنجاح",
		"PAYMENT_FAILED": "فشل الدفع",
		"PAYMENT_ITEMS": "المدفوعات",
		"PAYMENT_REASON": "وصف الدفع",
		"PAYMENT_REASON_EMPTY_FOR_ALL": "الدفع (فارغ للجميع)",
		"PAYMENT_REPORT": "تقرير الدفع",
		"PAYMENT_SUCCESSFULL": "ناجح",
		"PC": "الرمز البريدي",
		"PDF": "PDF",
		"PDF_RIGHTS": "* حذر ، قد تختلف النتائج عن اللقطات الفعلية",
		"PHONE": "الهاتف",
		"PHOTO_SIZE_ERROR": "صور تصل سعتها إلى 2 ميجابايت",
		"PICK": "اختار",
		"PICK_CATEGORY": "اختر التصنيف",
		"PICK_GAME": "اختر البطولة",
		"PICK_LEAGUE": "اختر الفئة",
		"PICK_LEAGUE_ADD": "حدد الفئة لإضافتها",
		"PICK_LEAGUE_DEL": " حدد الفئة لحذفها ",
		"PICK_PLAYER": "اختر لاعب",
		"PICK_PLAYER_EMPTY_FOR_ALL": " لاعب (فارغ للجميع)",
		"PICK_ROUND": "حدد الجولة",
		"PICK_TARGET": "اختر الهدف",
		"PICK_TEAM": "اختر الفريق",
		"PICK_TEAM_EMPTY_FOR_ALL": "فريق (فارغ للجميع)",
		"PLAYER": "اللاعب",
		"PLAYER/ER": "اللاعب",
		"PLAYERS": "اللاعبين",
		"PLAYERS_LIST": "التسجيلات حسب اللاعبين",
		"PLAYERS_PER_TARGET": "اللاعبين حسب الهدف",
		"PLAYERS_REGISTERD": "اللاعبين المسجلين",
		"PLAYER_1": "الرياضي 1",
		"PLAYER_2": "الرياضي 2",
		"PLAYER_3": "الرياضي 3",
		"PLAYER_LEAGUES": "بطولات اللاعب",
		"PLAYER_MATCHES": "بطولات اللاعبين",
		"PLAYER_NAME": "اسم اللاعب",
		"PLAYER_ONE": "الرياضي #1",
		"PLAYER_PASSPORT": "الرياضي جواز سفر",
		"PLAYER_PAYMENTS": "الرياضي مدفوعات",
		"PLAYER_PAYMENTS_FULFILLMENT": " وفاء الرياضي بالمدفوعات",
		"PLAYER_PAYMENTS_LIST": "الرياضي مدفوعات",
		"PLAYER_PAYMENT_REPORT": "الرياضي تقرير الدفع",
		"PLAYER_PROFILE": "الرياضي ملف تعريف",
		"PLAYER_THREE": "الرياضي #3",
		"PLAYER_TWO": "الرياضي #2",
		"PLUGINS": "الإضافات",
		"POSITION": "المنصب",
		"POSTAL_CODE": "الرمز البريدي",
		"PREVIOUS": "السابق",
		"PRICE": "المبلغ",
		"PRINT": "اطبع",
		"PRINTS": "طباعة",
		"PRINT_DEGREES": "طباعة الدرجات",
		"PRINT_ENTRIES_PDF": "طباعة التسجيلات",
		"PRINT_ENTRIES_PDF_SPECIFIC": "طباعة تسجيلات الفريق",
		"PRINT_GAME_BOOK": "طباعة دفتر البطولة",
		"PRINT_GAME_DETAILS": "طباعة تفاصيل البطولة",
		"PRINT_GAME_PDF": "طباعة التصفيات",
		"PRINT_GAME_PDF_AFTER_GAME": "طباعة التصفيات بعد البطولة ",
		"PRINT_GAME_PDF_MEDALS": "طباعة الميداليات",
		"PRINT_GAME_PDF_MEDALS_OLYMPIC": "طباعة الميداليات",
		"PRINT_GAME_PLAYERS": "طباعة الرياضيين بالبطولة",
		"PRINT_GAME_PLAYERS_PDF": "طباعة اللاعبين",
		"PRINT_GAME_PLAYERS_TEAMS": "طباعة اللاعبين حسب الفرق",
		"PRINT_GAME_TARGETS": "طباعة الاهداف",
		"PRINT_OLMPIC_LAYOUT": "طباعة شجرة التصفيات",
		"PRINT_OLYMPIC_ROUNDS": " طباعة جولات التصفيات ",
		"PRINT_PDF": "طباعة",
		"PRINT_REGISTRATIONS_PDF": "طباعة التسجيلات",
		"PRINT_RESULTS": "طباعة النتائج",
		"PRODUCE_TARGETS": "Product Targets",
		"PROFILE": "الملف التعريفي",
		"QR": "QR",
		"QUALIFICATION": "التصفيات",
		"QUALIFICATION_INDIVIDUAL": "التصفيات الفردية",
		"QUALIFICATION_MIXED_TEAM": "تصفيات فرق المختلط",
		"QUALIFICATION_TEAM": "تصفيات الفرق",
		"RANK": "الترتيب",
		"REAL_LIVESCORES": "النتائج المباشرة",
		"RECOVER_SUCCESS": "إذا تم العثور على المستخدم يتم إرسال بريد إلكتروني.",
		"RECURVE": "القوس المحدب",
		"RECURVE_JM_JW": "القوس المحدب ناشئين اولاد - بنات",
		"RECURVE_LEVEL": "مستوى القوس المحدب",
		"RECURVE_M_W": "القوس المحدب رجال - نساء ",
		"RECURVE_YM_YW": " القوس المحدب شباب اولاد - بنات ",
		"REGION": "المنطقة",
		"REGISTRAION_CLOSED_TEXT": "التسجيل مغلق. لا يمكنك إجراء أي تغييرات. يرجى الاتصال info@saaf.sa لأية طلبات.",
		"REGISTRATIONS": "التسجيلات",
		"REGISTRATION_CLOSED": "التسجيل مغلق",
		"REGISTRATION_CLOSED_TEXT_LIST": "فيما يلي قائمة بالرياضيين الذين قمت بتسجيلهم. التسجيل مغلق الآن. لا يمكنك إجراء أي تغييرات. يرجى الاتصال بنا للحصول على أي نوع من المعلومات التي قد تحتاجها.",
		"REGISTRATION_DATE": "تاريخ التسجيل",
		"REGISTRATION_END_DATE": "تاريخ انتهاء التسجيل",
		"REGISTRATION_IS_CLOSED": "التسجيل مغلق.",
		"REGISTRATION_OPEN": "التسجيل مفتوح",
		"REGISTRATION_OPEN_DATE": "تاريخ فتح باب التسجيل",
		"REGISTRATION_STATUS": "حالة التسجيل هي ",
		"REG_DATE": "تاريخ التسجيل",
		"REMOVE": "إزالة",
		"REMOVE_LEAGUE": "إزالة البطولة",
		"REMOVE_PLAYERS": "إزالة الرياضيين",
		"REMOVE_PLAYERS_FROM_MATCH": "إزالة الرياضيين من البطولة",
		"REPORTS": "التقارير",
		"REPORT_1": "الرياضيين حسب الفريق",
		"REPORT_10": "أفضل رمايات لكل رياضي / فريق / فئة",
		"REPORT_11": "اللاعبين #2",
		"REPORT_12": "الفرق #2",
		"REPORT_2": "الفرق",
		"REPORT_3": "الرياضيون المسجلون لكل فريق",
		"REPORT_4": "البطولات والمدخلات",
		"REPORT_5": "اللاعبين المسجلين بالفئة",
		"REPORT_6": " اللاعبين المسجلين بالفرق ",
		"REPORT_7": "نتائج اللاعبين",
		"REPORT_8": "اكثر الرياضيين / الفرق الفائزة",
		"REPORT_9": "المسجلين بمركز التدريب",
		"REPORT_13": "Medals",
		"REPORT_OF_YEAR": "تقرير المدفوعات للسنة : ",
		"REPRESENTER": "الممثل",
		"REQUIRED_BY_PLAYER": "مطلوب من قبل الرياضي",
		"REQUIRED_BY_TEAM": "مطلوب من قبل الفريق",
		"REQUIRED_FIELDS": "الحقول التي تحتوي على * مطلوبة",
		"REQUIRED_PLAYER": "مطلوب من قبل الرياضيين للمشاركة في البطولات",
		"REQUIRED_TEAM": "مطلوب من قبل الفرق للمشاركة في البطولات",
		"RESET_PASSWORD": "كلمة مرور جديدة",
		"RESTORE_PAYMENT": "استعادة الدفع",
		"RETURN_TO": "عودة إلى ",
		"RISER": "مقبض",
		"ROLE": "الدور",
		"ROLES": "الادوار",
		"ROUND": "جولة",
		"ROUNDS": "جولات",
		"ROUND_1": "جولة 1",
		"ROUND_1/RANK": "الجولة 1 / الترتيب",
		"ROUND_1/RANKs": "الترتيب العام 1",
		"ROUND_2": " الجولة 2 ",
		"ROUND_2/RANK": " الجولة 2 / الترتيب ",
		"ROUND_2/RANKs": " الترتيب العام 2",
		"ROUND_ONE": " الجولة 1 ",
		"ROUND_TWO": " الجولة 2 ",
		"RUNNING_TOTAL": "المجموع الجاري حاليا",
		"SAVE_MATCH_TEAM_INFO": "حفظ معلومات الفرق بالبطولة",
		"SCHOOL": "المدرسة",
		"SEARCH_GAME_NAME": "بحث...",
		"SEARCH_LEAGUE_NAME": "بحث...",
		"SEARCH_NAME": "البحث حسب الرياضي",
		"SEARCH_TEAM": "البحث حسب الفريق",
		"SEARCH_TEAM_NAME": "بحث...",
		"SELECT": "اختار",
		"SELECT_ALL": "حدد الكل",
		"SELECT_CITIZENSHIP": "اختر الجنسية",
		"SELECT_COUNTY": "اختر المنطقة",
		"SELECT_ELIMINATION_PARTICIPANTS": "تحديد المشاركين",
		"SELECT_FILE": "اختر الملف",
		"SELECT_JUDGES": "اختيار الحكام",
		"SELECT_LEAGUE": "اختر الفئة",
		"SELECT_LEAGUES": "اختر الفئات ",
		"SELECT_LEVEL": "اختر الفئات ",
		"SELECT_MATCH": "اختر البطولة",
		"SELECT_NATIONALITY": "اختر الجنسية",
		"SELECT_NEW_TEAM": "اختر فريقا جديدا",
		"SELECT_PAYMENT": "اختر الدفع",
		"SELECT_PERMISSIONS": "تحديد الأذونات",
		"SELECT_PLAYER": "اختر اللاعب",
		"SELECT_REGION": "إختر المنطقة",
		"SELECT_ROLE": "حدد الدور",
		"SELECT_ROUND": "حدد الجولة",
		"SELECT_SEX": "اختر الجنس",
		"SELECT_STATE": "اختر الولاية",
		"SELECT_TARGET": "اختر الهدف",
		"SELECT_TEAM": "اختر الفريق",
		"SELECT_TRAINING_CENTER": "اختر مركز التدريب",
		"SELECT_YEAR": "اختر السنة",
		"SEND_MESSAGE": "ارسل رسالة",
		"SEND_PLAYER_EMAILS": "ارسل ايميل للاعبين",
		"SETTINGS": "الاعدادات",
		"SET_POINTS": "نقاط المجموعة",
		"SET_TOTAL": "اجمالي المجموعة",
		"SEX": "جنس",
		"SHOT_1": "الرمية 1",
		"SHOT_10": "الرمية 10",
		"SHOT_2": " الرمية 2",
		"SHOT_3": " الرمية 3",
		"SHOT_4": " الرمية 4",
		"SHOT_5": " الرمية 5",
		"SHOT_6": " الرمية 6",
		"SHOT_7": " الرمية 7",
		"SHOT_8": " الرمية 8",
		"SHOT_9": " الرمية 9",
		"SHOT_NOW": "الرمية الحالية",
		"SHOT_NUMBER_NOW": "رقم الرمية الحالية",
		"SHOT_SCORE": "نتيجة الرمية",
		"SHOT_SCORE_SO_FAR": "النتيجة حتى الآن",
		"SIGNER": "صاحب التوقيع",
		"SIGN_IN": "تسجيل الدخول",
		"SILVER": "فضي",
		"SORT_LEAGUE_NAME": "الفرز باسم البطولة",
		"SORT_NAME": "الفرز الاسم",
		"STAFF": " الموظفين",
		"STAFF_PROFILE": "ملف التعريفي للموظفين ",
		"START": "ابدأ",
		"STARTED_DATE": "بدأ الوقت",
		"STARTING_FROM_TARGET": "ابتداء من",
		"STARTING_ROUND": "جولة البداية",
		"START_AUTOSCREOLLING": "ابدأ بالتمرير التلقائي",
		"START_AUTOSCROLL": "ابدأ بالتمرير التلقائي",
		"START_DATE": "تاريخ البدء",
		"START_ENTRY": "بدء التسجيل",
		"START_TRAINING_ENTRY": "هل أنت متأكد من أنك تريد استخدام المدخلات؟",
		"STATE": "حالة",
		"STATS": "احصائيات",
		"STATS_FOR_PLAYER": "حالة اللاعب",
		"STATS_FOR_TEAM": "حالة الفريق",
		"STATUS": "الحالات",
		"STOP_AUTOSCROLL": "إيقاف التمرير التلقائي",
		"STOP_AUTOSCROLLING": "إيقاف التمرير التلقائي",
		"STUDENT": "طالب",
		"STUDENT_TEAM": "فريق الطلاب",
		"SUBMIT": "تسجيل",
		"SUBMIT_EXIT": "التسجيل ثم الخروج",
		"SUBMIT_NEXT": "التسجيل ثم الهدف التالي",
		"SUBMIT_RETURN": "التسجيل والرجوع",
		"SUCCESS": "نجاح",
		"SUGGESTED": "مقترح",
		"SUM": "مجموع",
		"SUSPEND_REASON": "سبب",
		"SUSPEND_TEAM": "تعليق الفريق",
		"SWAP_PLAYERS": "مبادلة الرياضيين",
		"SWAP_TARGETS": "أهداف المبادلة",
		"TARGET": "هدف",
		"TARGETS": "اهداف",
		"TARGETS_BOARDS": "لوحات الاهداف",
		"TARGETS_LIST": "التسجيلات حسب الأهداف",
		"TARGETS_NUMBER": "عدد الأهداف",
		"TARGETS_WITH_EMPTY_SHOTS": "الأهداف الخالية من الرميات",
		"TARGET_BOARDS": "لوحات الهدف",
		"TARGET_FROM": "الأهداف من",
		"TARGET_NAME": "رقم الهدف",
		"TARGET_TO": "الى",
		"TARGET_TWO": "#2 الهدف ",
		"TEAM": "فريق",
		"TEAMS": "الفرق",
		"TEAMS_LIST": "التسجيلات حسب الفريق",
		"TEAM_ENTRIES_LIST": "الإدخالات لكل فريق",
		"TEAM_INFO": "معلومات الفريق",
		"TEAM_IS_SUSPENDED": "لا يمكنك تسجيل الرياضيين في هذه اللحظة.",
		"TEAM_IS_SUSPENDED_PROFILE": "تم تعليق هذا الفريق.",
		"TEAM_NAME": "اسم الفريق",
		"TEAM_OLYMPIC": "جولات إقصاء الفريق",
		"TEAM_PAYMENTS": "مدفوعات الفريق",
		"TEAM_PAYMENTS_LIST": "مدفوعات الفريق",
		"TEAM_PROFILE": "ملف تعريف الفريق",
		"TEAM_REPORT_NAME": "اسم: ",
		"TEAM_SORT_NAME": "فرز الاسم",
		"TEAM_S_NAME": "فريق",
		"TEENS": "الاولاد",
		"THERE_ARE_TOTAL": "مجموع ",
		"TITLE": "عنوان",
		"TOP_2_PLAYERS": "أفضل 2 رياضيين لكل فئة",
		"TOP_SCORE_IN_LEAGUE": "اعلى نتيجة بالفئة",
		"TOTAL": "مجموع",
		"TOTAL/RANK": "المجموع / الترتيب",
		"TOTAL/RANKs": "مجموع",
		"TOTAL_AMOUNT_MOVED": "المبلغ الإجمالي : ",
		"TOTAL_ENTRIES": "إجمالي المدخلات",
		"TOTAL_ENTRIES_IN_LEAGUE": "اجمالي الادخالات بالفئة",
		"TOTAL_MOVEMENTS": "مجموع الحركات : ",
		"TOTAL_PLAYERS": "مجموع الرياضيين",
		"TOTAL_SCORE": "مجموع النقاط",
		"TOTAL_SCORE_POINTS": "النقاط",
		"TO_TARGET": "الى الهدف",
		"TO_TEAM": "الى ",
		"TRAINERS": "المدربين",
		"TRAINER_0_LEVEL": "مدرب مبتدئ",
		"TRAINER_1_LEVEL": "مدرب مستوى 1",
		"TRAINER_2_LEVEL": " مدرب مستوى 2",
		"TRAINER_3_LEVEL": " مدرب مستوى 3",
		"TRAINER_LEVEL": "مستوى المدرب",
		"TRAINER_PROFILE": "الملف الشخصي للمدرب",
		"TRAINING_CENTER": "مركز تدريب",
		"TRAINING_CENTERS": "مراكز التدريب",
		"TRAINING_ENTRIES": "إدخالات التدريب",
		"TRANSFER": "نقل",
		"TRANSFERS": "انتقالات",
		"TRANSFER_DATE": "تاريخ الانتقال",
		"TRANSFER_FAIL": "فشل النقل",
		"TRANSFER_PLAYER": "انتقال اللاعب",
		"TRANSFER_SUCCESSFUL": "تم النقل بنجاح",
		"TRUELIVE_ALL": "النتائج",
		"TRUELIVE_CAT": "النتائج",
		"TYPE": "نوع",
		"UNIQUE_ENTRIES": "إدخالات فريدة",
		"UNKNOWN": "خطأ غير معروف عند التحميل.",
		"UNPAUSE": "إلغاء الإيقاف المؤقت",
		"UNPAUSE_TRAINING_ENTRY": "هل أنت متأكد من أنك تريد إلغاء إيقاف الإدخال مؤقتا؟",
		"UPDATED_AT": "تم التحديث في",
		"UPDATE_GAME": "تحديث البطولة",
		"UPDATE_PLAYER_LEAGUE": "تحديث فئات الرياضيين",
		"UPDATE_ROUND_1": "تحديث الجولة 1",
		"UPDATE_ROUND_2": "تحديث الجولة 2",
		"UPDATE_TEAM_LEAGUE_PLAYERS": "تحديث فئات لاعبي الفريق",
		"UPLOAD_FAILED": "فشل التحميل.",
		"UPLOAD_RESULTS_PDF": "تحديث النتائج",
		"USER": "مستخدم",
		"USERNAME": "اسم المستخدم",
		"USERS": "المستخدمون",
		"USER_ROLE": "الدور",
		"VALID": "فعال",
		"VALIDATE_PASSPORT": "التحقق من فعالية البطاقة ( السنة الحالية )",
		"VALIDATE_PASSPORTS": "التحقق من صحة البطاقات ( السنة الحالية )",
		"VALID_UNTIL": "صالح حتى",
		"VAT": "ضريبه القيمه المضافه",
		"VIEW_REGISTRATION": "عرض التسجيلات",
		"WEB": "الموقع الإلكتروني",
		"WELCOME_TO": "مرحبا بكم في ",
		"WINNER": "الفائز",
		"WOMEN": "أنثى",
		"YEAR": "سنة",
		"YES": "نعم",
		"YOUR_EMAIL": "بريدك الإلكتروني",
		"addCoach": "إضافة مدرب",
		"addGame": "إضافة بطولة ",
		"addJudge": "إضافة حكم",
		"addLeague": "إضافة فئة ",
		"addPaymentPlayer": "إضافة دفعة للاعب",
		"addPaymentReason": "إضافة سبب الدفع",
		"addPaymentTeam": "إضافة دفعة للفريق",
		"addPlayer": "إضافة لاعب",
		"addPlayersToMatch": "إضافة رياضيين إلى البطولة",
		"addShotsToGame": "إضافة رميات إلى البطولة",
		"addShotsToOlympic": "إضافة رميات إلى جولات الإقصاء",
		"addStaff": "إضافة موظفين",
		"addTeam": "إضافة نادي",
		"addTrainer": "إضافة مدرب",
		"addTrainingCenter": "إضافة مركز تدريب جديد",
		"addTrainingEntry": "إضافة دخول مركز التدريب",
		"calendar": "تقويم",
		"changeTeamPassword": "تغيير كلمة مرور النادي",
		"checkInPlayerToMatch": "تسجيل اللاعب بالبطولة",
		"deleteCoach": "حذف المدرب",
		"deleteGame": "حذف الحدث",
		"deleteJudge": "حذف الحكم",
		"deleteLeague": "حذف الفئات",
		"deletePlayer": "حذف اللاعب",
		"deleteStaff": "حذف الموظف",
		"deleteTeam": "حذف النادي",
		"deleteTrainer": "حذف المدرب",
		"deleteTrainingCenter": "حذف مركز التدريب",
		"deleteTrainingEntry": "حذف إدخال مركز التدريب",
		"editCoach": "تعديل المدرب",
		"editGame": "تعديل البطولة",
		"editGameLeagues": "تعديلات فئات البطولة",
		"editGamePlayerLeague": "تعديلات فئات اللاعبين للبطولة",
		"editGameTargets": "تعديل أهداف البطولة",
		"editJudge": "تعديل الحكم",
		"editLeague": "تعديل الفئة",
		"editPlayer": "تعديل اللاعب",
		"editRoles": "تعديل الأدوار",
		"editStaff": "تعديل الموظفين",
		"editTeam": "تعديل النادي",
		"editTrainer": "تعديل المدرب",
		"editTrainingCenter": "تعديل مركز التدريب",
		"editTrainingEntry": "تعديل إدخال مركز التدريب",
		"editUsers": "تعديل المستخدمين",
		"files": "الملفات",
		"gameUpdate": "Update event",
		"indoor": "داخلي",
		"livescores": "النتيجة المباشرة",
		"makePlayerTransfer": "إضافة نقل رياضي",
		"matchPrints": "مطبوعات الفعالية",
		"moveGame": "نقل الفعالية",
		"olympic": "جولات الإقصاء",
		"outdoor": "خارجية",
		"overrideMatchFilters": "تجاوز فلاتر البطولة",
		"passportValidate": "تحديث المستند",
		"playerTransfers": "الانتقالات",
		"removePlayersFromMatch": "إزالة اللاعبين من البطولة",
		"settings": "اعدادات",
		"stats": "الاحصاءات",
		"trainingCenters": "مراكز التدريب",
		"viewAllCoaches": "عرض جميع المدربين",
		"viewAllJudges": "عرض جميع الحكام",
		"viewAllLeagues": "عرض جميع الفئات",
		"viewAllMovementsPlayers": "عرض جميع مدفوعات اللاعبين",
		"viewAllMovementsTeams": "عرض جميع مدفوعات النادي",
		"viewAllPlayers": "عرض جميع اللاعبين",
		"viewAllStaff": "عرض جميع الموظفين",
		"viewAllTeams": "عرض جميع الأندية",
		"viewAllTrainers": "عرض جميع المدربين",
		"viewAllTrainingCenters": "عرض مراكز التدريب",
		"viewAllTrainingEntries": "عرض جميع إدخالات مراكز التدريب",
		"viewAllTransfers": "عرض جميع الانتقالات",
		"viewFinancial": "عرض البيانات المالية",
		"viewReports": "عرض التقارير",
		"viewUsers": "عرض المستخدمين",
		"PLAYER_AGE": "Age",
		"AGE_FROM": "Age (From)",
		"AGE_TO": "Age (To)",
		"paraArchery": "ذوي الإعاقة",
		"CERTIFICATES": "Certificates",
		"MATCH_CITY": "City",
		"MATCH_END_DATE": "Match End date",
		"ATHLETE_MATCH_ENTRY_CARDS": "Athlete Match Entry Cards",
		"BOARDS": "Boards",
		"ADD_SHOTS_VISUAL_ELIMINATIONS": "Eliminations Visual"
	};

/***/ }),
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _app = __webpack_require__(922);
	
	var _app2 = _interopRequireDefault(_app);
	
	__webpack_require__(1100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appComponent = {
	  template: _app2.default
	};
	
	exports.default = appComponent;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1101);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app-rtl.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app-rtl.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(427)();
	// imports
	exports.i(__webpack_require__(925), "");
	exports.i(__webpack_require__(930), "");
	exports.i(__webpack_require__(931), "");
	
	// module
	exports.push([module.id, "body{height:100%;font:62.5% Roboto,sans-serif}.p-t-05{padding-top:.5rem}.p-b-05{padding-bottom:.5rem}.div-hover-grey:hover,.list-item-active{background:rgba(229,233,238,.68)}.cursor-pointer{cursor:pointer}.shot-input{font-weight:700;text-align:center;padding:.3rem!important}.opacity-05{opacity:.5}.m-t-05{margin-top:.5rem}.shot-label{font-size:15px!important;padding:7px 11px!important;color:#000!important;border:1px solid hsla(213,4%,55%,.68);background-color:#fff!important}.visual-shot-label{font-size:29px!important;min-width:57px;min-height:34px}.shot-check-icon{color:green;font-size:22px!important;padding-top:4px}.border-b-1{border:1px solid #000}.material-icons{font-family:Material Icons;font-weight:400;font-style:normal;font-size:18px;display:inline-block;width:1em;height:1em;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;vertical-align:-4px;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:\"liga\"}.ui-grid-pager-control button{padding:0 0 0 5px}.ui-grid-pager-control input{margin-right:4px;padding:0;text-align:center}.ui-grid-align-c{text-align:center}.p-t-5{padding-top:5px!important}.ngdialog.ngdialog-theme-default .ngdialog-content{max-width:300px!important;width:auto!important;background:#fff;border-color:hsla(210,8%,51%,.13);padding:0}.modal-error-icon{font-size:40px;color:red}.modal-success-icon{font-size:40px;color:#6cc788}.modal .ui-switch-md input:checked+i:after{margin-left:0!important}.m-t-14{margin-top:14px}.loading-bg-overlay{width:100%;height:100%;position:absolute;top:58px;z-index:1000;background-color:rgba(0,0,0,.4)}.ui-grid{height:82vh}.ui-grid-viewport .ui-grid-cell-contents:not(.no-wrap){word-wrap:break-word;white-space:normal!important}.ui-grid-cell-contents .buttons button{margin-left:.5rem}.ui-grid-cell,.ui-grid-row{height:auto!important}.ui-grid-row div[role=row]{display:flex;align-content:stretch}/*!\n * Bootstrap v4.0.0-alpha.4 (http://getbootstrap.com)\n * Copyright 2011-2016 The Bootstrap Authors\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v4.0.0 | MIT License | github.com/necolas/normalize.css */article,aside,details,figcaption,figure,footer,header,main,menu,nav,section,summary{display:block}progress{vertical-align:baseline}a:active,a:hover{outline-width:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}mark{background-color:#ff0}img{border-style:none}hr{overflow:visible}button,input,select,textarea{font:inherit}button,input,select{overflow:visible}[type=button],[type=reset],[type=submit],button{cursor:pointer}[disabled]{cursor:default}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}button:-moz-focusring,input:-moz-focusring{outline:1px dotted ButtonText}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;white-space:normal}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}@media print{*,:after,:before,:first-letter,:first-line{text-shadow:none!important;box-shadow:none!important}a,a:visited{text-decoration:underline}abbr[title]:after{content:\" (\" attr(title) \")\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.tag{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}@-ms-viewport{width:device-width}html{font-size:16px;-ms-overflow-style:scrollbar;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-size:1rem;line-height:1.5;color:#373a3c;background-color:#fff}[tabindex=\"-1\"]:focus{outline:none!important}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:.5rem}p{margin-top:0;margin-bottom:1rem}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #818a91}address{font-style:normal;line-height:inherit}address,dl,ol,ul{margin-bottom:1rem}dl,ol,ul{margin-top:0}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}dt{font-weight:700}dd{margin-bottom:.5rem;margin-left:0}blockquote{margin:0 0 1rem}a{color:#0275d8}a:focus,a:hover{color:#014c8c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}a:not([href]):not([tabindex]),a:not([href]):not([tabindex]):focus,a:not([href]):not([tabindex]):hover{color:inherit;text-decoration:none}a:not([href]):not([tabindex]):focus{outline:none}figure{margin:0 0 1rem}img{vertical-align:middle}[role=button]{cursor:pointer}[role=button],a,area,button,input,label,select,summary,textarea{touch-action:manipulation}table{background-color:transparent}caption{padding-top:.75rem;padding-bottom:.75rem;color:#818a91;caption-side:bottom}caption,th{text-align:left}label{display:inline-block;margin-bottom:.5rem}button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}button,input,select,textarea{margin:0;line-height:inherit;border-radius:0}input[type=checkbox]:disabled,input[type=radio]:disabled{cursor:not-allowed}input[type=date],input[type=datetime-local],input[type=month],input[type=time]{-webkit-appearance:listbox}textarea{resize:vertical}fieldset{min-width:0;padding:0;margin:0;border:0}legend{display:block;width:100%;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit}input[type=search]{-webkit-appearance:none}output{display:inline-block}[hidden]{display:none!important}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{margin-bottom:.5rem;font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1,h1{font-size:2.5rem}.h2,h2{font-size:2rem}.h3,h3{font-size:1.75rem}.h4,h4{font-size:1.5rem}.h5,h5{font-size:1.25rem}.h6,h6{font-size:1rem}.lead{font-size:1.25rem;font-weight:300}.display-1{font-size:6rem;font-weight:300}.display-2{font-size:5.5rem;font-weight:300}.display-3{font-size:4.5rem;font-weight:300}.display-4{font-size:3.5rem;font-weight:300}hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,.1)}.small,small{font-size:80%;font-weight:400}.mark,mark{padding:.2em;background-color:#fcf8e3}.list-unstyled{list-style:none}.list-inline-item{display:inline-block}.list-inline-item:not(:last-child){margin-right:5px}.initialism{font-size:90%;text-transform:uppercase}.blockquote{padding:.5rem 1rem;margin-bottom:1rem;font-size:1.25rem;border-left:.25rem solid #eceeef}.blockquote-footer{display:block;font-size:80%;color:#818a91}.blockquote-footer:before{content:\"\\2014   \\A0\"}.blockquote-reverse{padding-right:1rem;padding-left:0;text-align:right;border-right:.25rem solid #eceeef;border-left:0}.blockquote-reverse .blockquote-footer:before{content:\"\"}.blockquote-reverse .blockquote-footer:after{content:\"\\A0   \\2014\"}dl.row>dd+dt{clear:left}.carousel-inner>.carousel-item>a>img,.carousel-inner>.carousel-item>img,.img-fluid{display:block;max-width:100%;height:auto}.img-rounded{border-radius:.3rem}.img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #ddd;border-radius:.25rem;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}.figure{display:inline-block}.figure-img{margin-bottom:.5rem;line-height:1}.figure-caption{font-size:90%;color:#818a91}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace}code{color:#bd4147;background-color:#f7f7f9;border-radius:.25rem}code,kbd{padding:.2rem .4rem;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:.2rem}kbd kbd{padding:0;font-size:100%;font-weight:700}pre{display:block;margin-top:0;margin-bottom:1rem;font-size:90%;color:#373a3c}pre code{padding:0;font-size:inherit;color:inherit;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}.container:after{content:\"\";display:table;clear:both}@media (min-width:544px){.container{max-width:576px}}@media (min-width:768px){.container{max-width:720px}}@media (min-width:992px){.container{max-width:940px}}@media (min-width:1200px){.container{max-width:1140px}}.container-fluid{margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}.container-fluid:after{content:\"\";display:table;clear:both}.row{margin-left:-15px;margin-right:-15px}.row:after{content:\"\";display:table;clear:both}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1{float:left;width:8.33333%}.col-xs-2{float:left;width:16.66667%}.col-xs-3{float:left;width:25%}.col-xs-4{float:left;width:33.33333%}.col-xs-5{float:left;width:41.66667%}.col-xs-6{float:left;width:50%}.col-xs-7{float:left;width:58.33333%}.col-xs-8{float:left;width:66.66667%}.col-xs-9{float:left;width:75%}.col-xs-10{float:left;width:83.33333%}.col-xs-11{float:left;width:91.66667%}.col-xs-12{float:left;width:100%}.pull-xs-0{right:auto}.pull-xs-1{right:8.33333%}.pull-xs-2{right:16.66667%}.pull-xs-3{right:25%}.pull-xs-4{right:33.33333%}.pull-xs-5{right:41.66667%}.pull-xs-6{right:50%}.pull-xs-7{right:58.33333%}.pull-xs-8{right:66.66667%}.pull-xs-9{right:75%}.pull-xs-10{right:83.33333%}.pull-xs-11{right:91.66667%}.pull-xs-12{right:100%}.push-xs-0{left:auto}.push-xs-1{left:8.33333%}.push-xs-2{left:16.66667%}.push-xs-3{left:25%}.push-xs-4{left:33.33333%}.push-xs-5{left:41.66667%}.push-xs-6{left:50%}.push-xs-7{left:58.33333%}.push-xs-8{left:66.66667%}.push-xs-9{left:75%}.push-xs-10{left:83.33333%}.push-xs-11{left:91.66667%}.push-xs-12{left:100%}.offset-xs-1{margin-left:8.33333%}.offset-xs-2{margin-left:16.66667%}.offset-xs-3{margin-left:25%}.offset-xs-4{margin-left:33.33333%}.offset-xs-5{margin-left:41.66667%}.offset-xs-6{margin-left:50%}.offset-xs-7{margin-left:58.33333%}.offset-xs-8{margin-left:66.66667%}.offset-xs-9{margin-left:75%}.offset-xs-10{margin-left:83.33333%}.offset-xs-11{margin-left:91.66667%}@media (min-width:544px){.col-sm-1{float:left;width:8.33333%}.col-sm-2{float:left;width:16.66667%}.col-sm-3{float:left;width:25%}.col-sm-4{float:left;width:33.33333%}.col-sm-5{float:left;width:41.66667%}.col-sm-6{float:left;width:50%}.col-sm-7{float:left;width:58.33333%}.col-sm-8{float:left;width:66.66667%}.col-sm-9{float:left;width:75%}.col-sm-10{float:left;width:83.33333%}.col-sm-11{float:left;width:91.66667%}.col-sm-12{float:left;width:100%}.pull-sm-0{right:auto}.pull-sm-1{right:8.33333%}.pull-sm-2{right:16.66667%}.pull-sm-3{right:25%}.pull-sm-4{right:33.33333%}.pull-sm-5{right:41.66667%}.pull-sm-6{right:50%}.pull-sm-7{right:58.33333%}.pull-sm-8{right:66.66667%}.pull-sm-9{right:75%}.pull-sm-10{right:83.33333%}.pull-sm-11{right:91.66667%}.pull-sm-12{right:100%}.push-sm-0{left:auto}.push-sm-1{left:8.33333%}.push-sm-2{left:16.66667%}.push-sm-3{left:25%}.push-sm-4{left:33.33333%}.push-sm-5{left:41.66667%}.push-sm-6{left:50%}.push-sm-7{left:58.33333%}.push-sm-8{left:66.66667%}.push-sm-9{left:75%}.push-sm-10{left:83.33333%}.push-sm-11{left:91.66667%}.push-sm-12{left:100%}.offset-sm-0{margin-left:0}.offset-sm-1{margin-left:8.33333%}.offset-sm-2{margin-left:16.66667%}.offset-sm-3{margin-left:25%}.offset-sm-4{margin-left:33.33333%}.offset-sm-5{margin-left:41.66667%}.offset-sm-6{margin-left:50%}.offset-sm-7{margin-left:58.33333%}.offset-sm-8{margin-left:66.66667%}.offset-sm-9{margin-left:75%}.offset-sm-10{margin-left:83.33333%}.offset-sm-11{margin-left:91.66667%}}@media (min-width:768px){.col-md-1{float:left;width:8.33333%}.col-md-2{float:left;width:16.66667%}.col-md-3{float:left;width:25%}.col-md-4{float:left;width:33.33333%}.col-md-5{float:left;width:41.66667%}.col-md-6{float:left;width:50%}.col-md-7{float:left;width:58.33333%}.col-md-8{float:left;width:66.66667%}.col-md-9{float:left;width:75%}.col-md-10{float:left;width:83.33333%}.col-md-11{float:left;width:91.66667%}.col-md-12{float:left;width:100%}.pull-md-0{right:auto}.pull-md-1{right:8.33333%}.pull-md-2{right:16.66667%}.pull-md-3{right:25%}.pull-md-4{right:33.33333%}.pull-md-5{right:41.66667%}.pull-md-6{right:50%}.pull-md-7{right:58.33333%}.pull-md-8{right:66.66667%}.pull-md-9{right:75%}.pull-md-10{right:83.33333%}.pull-md-11{right:91.66667%}.pull-md-12{right:100%}.push-md-0{left:auto}.push-md-1{left:8.33333%}.push-md-2{left:16.66667%}.push-md-3{left:25%}.push-md-4{left:33.33333%}.push-md-5{left:41.66667%}.push-md-6{left:50%}.push-md-7{left:58.33333%}.push-md-8{left:66.66667%}.push-md-9{left:75%}.push-md-10{left:83.33333%}.push-md-11{left:91.66667%}.push-md-12{left:100%}.offset-md-0{margin-left:0}.offset-md-1{margin-left:8.33333%}.offset-md-2{margin-left:16.66667%}.offset-md-3{margin-left:25%}.offset-md-4{margin-left:33.33333%}.offset-md-5{margin-left:41.66667%}.offset-md-6{margin-left:50%}.offset-md-7{margin-left:58.33333%}.offset-md-8{margin-left:66.66667%}.offset-md-9{margin-left:75%}.offset-md-10{margin-left:83.33333%}.offset-md-11{margin-left:91.66667%}}@media (min-width:992px){.col-lg-1{float:left;width:8.33333%}.col-lg-2{float:left;width:16.66667%}.col-lg-3{float:left;width:25%}.col-lg-4{float:left;width:33.33333%}.col-lg-5{float:left;width:41.66667%}.col-lg-6{float:left;width:50%}.col-lg-7{float:left;width:58.33333%}.col-lg-8{float:left;width:66.66667%}.col-lg-9{float:left;width:75%}.col-lg-10{float:left;width:83.33333%}.col-lg-11{float:left;width:91.66667%}.col-lg-12{float:left;width:100%}.pull-lg-0{right:auto}.pull-lg-1{right:8.33333%}.pull-lg-2{right:16.66667%}.pull-lg-3{right:25%}.pull-lg-4{right:33.33333%}.pull-lg-5{right:41.66667%}.pull-lg-6{right:50%}.pull-lg-7{right:58.33333%}.pull-lg-8{right:66.66667%}.pull-lg-9{right:75%}.pull-lg-10{right:83.33333%}.pull-lg-11{right:91.66667%}.pull-lg-12{right:100%}.push-lg-0{left:auto}.push-lg-1{left:8.33333%}.push-lg-2{left:16.66667%}.push-lg-3{left:25%}.push-lg-4{left:33.33333%}.push-lg-5{left:41.66667%}.push-lg-6{left:50%}.push-lg-7{left:58.33333%}.push-lg-8{left:66.66667%}.push-lg-9{left:75%}.push-lg-10{left:83.33333%}.push-lg-11{left:91.66667%}.push-lg-12{left:100%}.offset-lg-0{margin-left:0}.offset-lg-1{margin-left:8.33333%}.offset-lg-2{margin-left:16.66667%}.offset-lg-3{margin-left:25%}.offset-lg-4{margin-left:33.33333%}.offset-lg-5{margin-left:41.66667%}.offset-lg-6{margin-left:50%}.offset-lg-7{margin-left:58.33333%}.offset-lg-8{margin-left:66.66667%}.offset-lg-9{margin-left:75%}.offset-lg-10{margin-left:83.33333%}.offset-lg-11{margin-left:91.66667%}}@media (min-width:1200px){.col-xl-1{float:left;width:8.33333%}.col-xl-2{float:left;width:16.66667%}.col-xl-3{float:left;width:25%}.col-xl-4{float:left;width:33.33333%}.col-xl-5{float:left;width:41.66667%}.col-xl-6{float:left;width:50%}.col-xl-7{float:left;width:58.33333%}.col-xl-8{float:left;width:66.66667%}.col-xl-9{float:left;width:75%}.col-xl-10{float:left;width:83.33333%}.col-xl-11{float:left;width:91.66667%}.col-xl-12{float:left;width:100%}.pull-xl-0{right:auto}.pull-xl-1{right:8.33333%}.pull-xl-2{right:16.66667%}.pull-xl-3{right:25%}.pull-xl-4{right:33.33333%}.pull-xl-5{right:41.66667%}.pull-xl-6{right:50%}.pull-xl-7{right:58.33333%}.pull-xl-8{right:66.66667%}.pull-xl-9{right:75%}.pull-xl-10{right:83.33333%}.pull-xl-11{right:91.66667%}.pull-xl-12{right:100%}.push-xl-0{left:auto}.push-xl-1{left:8.33333%}.push-xl-2{left:16.66667%}.push-xl-3{left:25%}.push-xl-4{left:33.33333%}.push-xl-5{left:41.66667%}.push-xl-6{left:50%}.push-xl-7{left:58.33333%}.push-xl-8{left:66.66667%}.push-xl-9{left:75%}.push-xl-10{left:83.33333%}.push-xl-11{left:91.66667%}.push-xl-12{left:100%}.offset-xl-0{margin-left:0}.offset-xl-1{margin-left:8.33333%}.offset-xl-2{margin-left:16.66667%}.offset-xl-3{margin-left:25%}.offset-xl-4{margin-left:33.33333%}.offset-xl-5{margin-left:41.66667%}.offset-xl-6{margin-left:50%}.offset-xl-7{margin-left:58.33333%}.offset-xl-8{margin-left:66.66667%}.offset-xl-9{margin-left:75%}.offset-xl-10{margin-left:83.33333%}.offset-xl-11{margin-left:91.66667%}}.table{width:100%;max-width:100%;margin-bottom:1rem}.table td,.table th{padding:.75rem;vertical-align:top;border-top:1px solid #eceeef}.table thead th{vertical-align:bottom;border-bottom:2px solid #eceeef}.table tbody+tbody{border-top:2px solid #eceeef}.table .table{background-color:#fff}.table-sm td,.table-sm th{padding:.3rem}.table-bordered,.table-bordered td,.table-bordered th{border:1px solid #eceeef}.table-bordered thead td,.table-bordered thead th{border-bottom-width:2px}.table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,.05)}.table-active,.table-active>td,.table-active>th,.table-hover .table-active:hover,.table-hover .table-active:hover>td,.table-hover .table-active:hover>th,.table-hover tbody tr:hover{background-color:rgba(0,0,0,.075)}.table-success,.table-success>td,.table-success>th{background-color:#dff0d8}.table-hover .table-success:hover,.table-hover .table-success:hover>td,.table-hover .table-success:hover>th{background-color:#d0e9c6}.table-info,.table-info>td,.table-info>th{background-color:#d9edf7}.table-hover .table-info:hover,.table-hover .table-info:hover>td,.table-hover .table-info:hover>th{background-color:#c4e3f3}.table-warning,.table-warning>td,.table-warning>th{background-color:#fcf8e3}.table-hover .table-warning:hover,.table-hover .table-warning:hover>td,.table-hover .table-warning:hover>th{background-color:#faf2cc}.table-danger,.table-danger>td,.table-danger>th{background-color:#f2dede}.table-hover .table-danger:hover,.table-hover .table-danger:hover>td,.table-hover .table-danger:hover>th{background-color:#ebcccc}.thead-inverse th{color:#fff;background-color:#373a3c}.thead-default th{color:#55595c;background-color:#eceeef}.table-inverse{color:#eceeef;background-color:#373a3c}.table-inverse td,.table-inverse th,.table-inverse thead th{border-color:#55595c}.table-inverse.table-bordered{border:0}.table-responsive{display:block;width:100%;min-height:.01%;overflow-x:auto}.table-reflow thead{float:left}.table-reflow tbody{display:block;white-space:nowrap}.table-reflow td,.table-reflow th{border-top:1px solid #eceeef;border-left:1px solid #eceeef}.table-reflow td:last-child,.table-reflow th:last-child{border-right:1px solid #eceeef}.table-reflow tbody:last-child tr:last-child td,.table-reflow tbody:last-child tr:last-child th,.table-reflow tfoot:last-child tr:last-child td,.table-reflow tfoot:last-child tr:last-child th,.table-reflow thead:last-child tr:last-child td,.table-reflow thead:last-child tr:last-child th{border-bottom:1px solid #eceeef}.table-reflow tr{float:left}.table-reflow tr td,.table-reflow tr th{display:block!important;border:1px solid #eceeef}.form-control{display:block;width:100%;padding:.5rem .75rem;font-size:1rem;line-height:1.25;color:#55595c;background-color:#fff;background-image:none;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.form-control::-ms-expand{background-color:transparent;border:0}.form-control:focus{color:#55595c;background-color:#fff;border-color:#66afe9;outline:none}.form-control::placeholder{color:#999;opacity:1}.form-control:disabled,.form-control[readonly]{background-color:#eceeef;opacity:1}.form-control:disabled{cursor:not-allowed}select.form-control:not([size]):not([multiple]){height:2.5rem}select.form-control:focus::-ms-value{color:#55595c;background-color:#fff}.form-control-file,.form-control-range{display:block}.col-form-label{padding-top:.5rem;padding-bottom:.5rem;margin-bottom:0}.col-form-label-lg{padding-top:.75rem;padding-bottom:.75rem;font-size:1.25rem}.col-form-label-sm{padding-top:.25rem;padding-bottom:.25rem;font-size:.875rem}.col-form-legend{font-size:1rem}.col-form-legend,.form-control-static{padding-top:.5rem;padding-bottom:.5rem;margin-bottom:0}.form-control-static{min-height:2.5rem}.form-control-static.form-control-lg,.form-control-static.form-control-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-right:0;padding-left:0}.form-control-sm,.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.input-group-sm>.input-group-btn>select.btn:not([size]):not([multiple]),.input-group-sm>select.form-control:not([size]):not([multiple]),.input-group-sm>select.input-group-addon:not([size]):not([multiple]),select.form-control-sm:not([size]):not([multiple]){height:1.8125rem}.form-control-lg,.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{padding:.75rem 1.5rem;font-size:1.25rem;border-radius:.3rem}.input-group-lg>.input-group-btn>select.btn:not([size]):not([multiple]),.input-group-lg>select.form-control:not([size]):not([multiple]),.input-group-lg>select.input-group-addon:not([size]):not([multiple]),select.form-control-lg:not([size]):not([multiple]){height:3.16667rem}.form-group{margin-bottom:1rem}.form-text{display:block;margin-top:.25rem}.form-check{position:relative;display:block;margin-bottom:.75rem}.form-check+.form-check{margin-top:-.25rem}.form-check.disabled .form-check-label{color:#818a91;cursor:not-allowed}.form-check-label{padding-left:1.25rem;margin-bottom:0;cursor:pointer}.form-check-input{position:absolute;margin-top:.25rem;margin-left:-1.25rem}.form-check-input:only-child{position:static}.form-check-inline{position:relative;display:inline-block;padding-left:1.25rem;margin-bottom:0;vertical-align:middle;cursor:pointer}.form-check-inline+.form-check-inline{margin-left:.75rem}.form-check-inline.disabled{cursor:not-allowed}.form-control-feedback{margin-top:.25rem}.form-control-danger,.form-control-success,.form-control-warning{padding-right:2.25rem;background-repeat:no-repeat;background-position:center right .625rem;background-size:1.25rem 1.25rem}.has-success .custom-control,.has-success .form-check-inline,.has-success .form-check-label,.has-success .form-control-feedback,.has-success .form-control-label{color:#5cb85c}.has-success .form-control{border-color:#5cb85c}.has-success .input-group-addon{color:#5cb85c;border-color:#5cb85c;background-color:#eaf6ea}.has-success .form-control-feedback{color:#5cb85c}.has-success .form-control-success{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%235cb85c' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3E%3C/svg%3E\")}.has-warning .custom-control,.has-warning .form-check-inline,.has-warning .form-check-label,.has-warning .form-control-feedback,.has-warning .form-control-label{color:#f0ad4e}.has-warning .form-control{border-color:#f0ad4e}.has-warning .input-group-addon{color:#f0ad4e;border-color:#f0ad4e;background-color:#fff}.has-warning .form-control-feedback{color:#f0ad4e}.has-warning .form-control-warning{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23f0ad4e' d='M4.4 5.324h-.8v-2.46h.8zm0 1.42h-.8V5.89h.8zM3.76.63L.04 7.075c-.115.2.016.425.26.426h7.397c.242 0 .372-.226.258-.426C6.726 4.924 5.47 2.79 4.253.63c-.113-.174-.39-.174-.494 0z'/%3E%3C/svg%3E\")}.has-danger .custom-control,.has-danger .form-check-inline,.has-danger .form-check-label,.has-danger .form-control-feedback,.has-danger .form-control-label{color:#d9534f}.has-danger .form-control{border-color:#d9534f}.has-danger .input-group-addon{color:#d9534f;border-color:#d9534f;background-color:#fdf7f7}.has-danger .form-control-feedback{color:#d9534f}.has-danger .form-control-danger{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23d9534f' viewBox='-2 -2 7 7'%3E%3Cpath stroke='%23d9534f' d='M0 0l3 3m0-3L0 3'/%3E%3Ccircle r='.5'/%3E%3Ccircle cx='3' r='.5'/%3E%3Ccircle cy='3' r='.5'/%3E%3Ccircle cx='3' cy='3' r='.5'/%3E%3C/svg%3E\")}@media (min-width:544px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .form-check,.form-inline .form-control-label{margin-bottom:0;vertical-align:middle}.form-inline .form-check{display:inline-block;margin-top:0}.form-inline .form-check-label{padding-left:0}.form-inline .form-check-input{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}.collapsing{height:0;overflow:hidden;transition-timing-function:ease;transition-duration:.35s;transition-property:height}.collapsing,.dropdown,.dropup{position:relative}.dropdown-toggle:after{display:inline-block;width:0;height:0;margin-left:.3em;vertical-align:middle;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-left:.3em solid transparent}.dropdown-toggle:focus{outline:0}.dropup .dropdown-toggle:after{border-top:0;border-bottom:.3em solid}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:1rem;color:#373a3c;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.dropdown-divider{height:1px;margin:.5rem 0;overflow:hidden;background-color:#e5e5e5}.dropdown-item{display:block;width:100%;padding:3px 20px;clear:both;font-weight:400;color:#373a3c;text-align:inherit;white-space:nowrap;background:none;border:0}.dropdown-item:focus,.dropdown-item:hover{color:#2b2d2f;text-decoration:none;background-color:#f5f5f5}.dropdown-item.active,.dropdown-item.active:focus,.dropdown-item.active:hover{color:#fff;text-decoration:none;background-color:#0275d8;outline:0}.dropdown-item.disabled,.dropdown-item.disabled:focus,.dropdown-item.disabled:hover{color:#818a91}.dropdown-item.disabled:focus,.dropdown-item.disabled:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:\"progid:DXImageTransform.Microsoft.gradient(enabled = false)\"}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-header{display:block;padding:5px 20px;font-size:.875rem;color:#818a91;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:.3em solid}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-.5rem}.btn-toolbar:after{content:\"\";display:table;clear:both}.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:.5rem}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.btn+.dropdown-toggle-split:after{margin-left:0}.btn-group-sm>.btn+.dropdown-toggle-split,.btn-sm+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.btn-group-lg>.btn+.dropdown-toggle-split,.btn-lg+.dropdown-toggle-split{padding-right:1.125rem;padding-left:1.125rem}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:.3em .3em 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 .3em .3em}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after{content:\"\";display:table;clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;width:100%;display:table;border-collapse:separate}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:active,.input-group .form-control:focus,.input-group .form-control:hover{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.25;color:#55595c;text-align:center;background-color:#eceeef;border:1px solid rgba(0,0,0,.15);border-radius:.25rem}.input-group-addon.form-control-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.input-group-addon.form-control-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:.75rem 1.5rem;font-size:1.25rem;border-radius:.3rem}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:not(:last-child),.input-group-btn:not(:first-child)>.btn-group:not(:last-child)>.btn,.input-group-btn:not(:first-child)>.btn:not(:last-child):not(.dropdown-toggle),.input-group-btn:not(:last-child)>.btn,.input-group-btn:not(:last-child)>.btn-group>.btn,.input-group-btn:not(:last-child)>.dropdown-toggle,.input-group .form-control:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:not(:last-child){border-right:0}.input-group-addon:not(:first-child),.input-group-btn:not(:first-child)>.btn,.input-group-btn:not(:first-child)>.btn-group>.btn,.input-group-btn:not(:first-child)>.dropdown-toggle,.input-group-btn:not(:last-child)>.btn-group:not(:first-child)>.btn,.input-group-btn:not(:last-child)>.btn:not(:first-child),.input-group .form-control:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.form-control+.input-group-addon:not(:first-child){border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:3}.input-group-btn:not(:last-child)>.btn,.input-group-btn:not(:last-child)>.btn-group{margin-right:-1px}.input-group-btn:not(:first-child)>.btn,.input-group-btn:not(:first-child)>.btn-group{z-index:2;margin-left:-1px}.input-group-btn:not(:first-child)>.btn-group:active,.input-group-btn:not(:first-child)>.btn-group:focus,.input-group-btn:not(:first-child)>.btn-group:hover,.input-group-btn:not(:first-child)>.btn:active,.input-group-btn:not(:first-child)>.btn:focus,.input-group-btn:not(:first-child)>.btn:hover{z-index:3}.custom-control{position:relative;display:inline;padding-left:1.5rem;cursor:pointer}.custom-control+.custom-control{margin-left:1rem}.custom-control-input{position:absolute;z-index:-1;opacity:0}.custom-control-input:checked~.custom-control-indicator{color:#fff;background-color:#0074d9}.custom-control-input:focus~.custom-control-indicator{box-shadow:0 0 0 .075rem #fff,0 0 0 .2rem #0074d9}.custom-control-input:active~.custom-control-indicator{color:#fff;background-color:#84c6ff}.custom-control-input:disabled~.custom-control-indicator{cursor:not-allowed;background-color:#eee}.custom-control-input:disabled~.custom-control-description{color:#767676;cursor:not-allowed}.custom-control-indicator{position:absolute;top:.0625rem;left:0;display:block;width:1rem;height:1rem;pointer-events:none;user-select:none;background-color:#ddd;background-repeat:no-repeat;background-position:50%;background-size:50% 50%}.custom-checkbox .custom-control-indicator{border-radius:.25rem}.custom-checkbox .custom-control-input:checked~.custom-control-indicator{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E\")}.custom-checkbox .custom-control-input:indeterminate~.custom-control-indicator{background-color:#0074d9;background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3E%3Cpath stroke='%23fff' d='M0 2h4'/%3E%3C/svg%3E\")}.custom-radio .custom-control-indicator{border-radius:50%}.custom-radio .custom-control-input:checked~.custom-control-indicator{background-image:url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E\")}.custom-controls-stacked .custom-control{display:inline}.custom-controls-stacked .custom-control:after{display:block;margin-bottom:.25rem;content:\"\"}.custom-controls-stacked .custom-control+.custom-control{margin-left:0}.custom-select{display:inline-block;max-width:100%;padding:.375rem 1.75rem .375rem .75rem;padding-right:.75rem\\9;color:#55595c;vertical-align:middle;background:#fff url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\") no-repeat right .75rem center;background-image:none\\9;background-size:8px 10px;border:1px solid rgba(0,0,0,.15);border-radius:.25rem;-moz-appearance:none;-webkit-appearance:none}.custom-select:focus{border-color:#51a7e8;outline:none}.custom-select:focus::-ms-value{color:#55595c;background-color:#fff}.custom-select:disabled{color:#818a91;cursor:not-allowed;background-color:#eceeef}.custom-select::-ms-expand{opacity:0}.custom-select-sm{padding-top:.375rem;padding-bottom:.375rem;font-size:75%}.custom-file{position:relative;display:inline-block;max-width:100%;height:2.5rem;cursor:pointer}.custom-file-input{min-width:14rem;max-width:100%;margin:0;filter:alpha(opacity=0);opacity:0}.custom-file-control{position:absolute;top:0;right:0;left:0;z-index:5;height:2.5rem;padding:.5rem 1rem;line-height:1.5;color:#555;user-select:none;background-color:#fff;border:1px solid #ddd;border-radius:.25rem}.custom-file-control:lang(en):after{content:\"Choose file...\"}.custom-file-control:before{position:absolute;top:-1px;right:-1px;bottom:-1px;z-index:6;display:block;height:2.5rem;padding:.5rem 1rem;line-height:1.5;color:#555;background-color:#eee;border:1px solid #ddd;border-radius:0 .25rem .25rem 0}.custom-file-control:lang(en):before{content:\"Browse\"}.nav{margin-bottom:0;list-style:none}.nav-link{display:inline-block}.nav-link:focus,.nav-link:hover{text-decoration:none}.nav-link.disabled{color:#818a91}.nav-link.disabled,.nav-link.disabled:focus,.nav-link.disabled:hover{color:#818a91;cursor:not-allowed;background-color:transparent}.nav-inline .nav-item{display:inline-block}.nav-inline .nav-item+.nav-item,.nav-inline .nav-link+.nav-link{margin-left:1rem}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs:after{content:\"\";display:table;clear:both}.nav-tabs .nav-item{float:left;margin-bottom:-1px}.nav-tabs .nav-item+.nav-item{margin-left:.2rem}.nav-tabs .nav-link{display:block;padding:.5em 1em;border:1px solid transparent;border-top-right-radius:.25rem;border-top-left-radius:.25rem}.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:#eceeef #eceeef #ddd}.nav-tabs .nav-link.disabled,.nav-tabs .nav-link.disabled:focus,.nav-tabs .nav-link.disabled:hover{color:#818a91;background-color:transparent;border-color:transparent}.nav-tabs .nav-item.open .nav-link,.nav-tabs .nav-item.open .nav-link:focus,.nav-tabs .nav-item.open .nav-link:hover,.nav-tabs .nav-link.active,.nav-tabs .nav-link.active:focus,.nav-tabs .nav-link.active:hover{color:#55595c;background-color:#fff;border-color:#ddd #ddd transparent}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.nav-pills:after{content:\"\";display:table;clear:both}.nav-pills .nav-item{float:left}.nav-pills .nav-item+.nav-item{margin-left:.2rem}.nav-pills .nav-link{display:block;padding:.5em 1em;border-radius:.25rem}.nav-pills .nav-item.open .nav-link,.nav-pills .nav-item.open .nav-link:focus,.nav-pills .nav-item.open .nav-link:hover,.nav-pills .nav-link.active,.nav-pills .nav-link.active:focus,.nav-pills .nav-link.active:hover{color:#fff;cursor:default;background-color:#0275d8}.nav-stacked .nav-item{display:block}.nav-stacked .nav-item+.nav-item{margin-top:.2rem;margin-left:0}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.navbar{position:relative;padding:.5rem 1rem}.navbar:after{content:\"\";display:table;clear:both}@media (min-width:544px){.navbar{border-radius:.25rem}}.navbar-full{z-index:1000}@media (min-width:544px){.navbar-full{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:544px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0}.navbar-fixed-bottom{bottom:0}.navbar-sticky-top{position:sticky;top:0;z-index:1030;width:100%}@media (min-width:544px){.navbar-sticky-top{border-radius:0}}.navbar-brand{float:left;padding-top:.25rem;padding-bottom:.25rem;margin-right:1rem;font-size:1.25rem}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}.navbar-divider{float:left;width:1px;padding-top:.425rem;padding-bottom:.425rem;margin-right:1rem;margin-left:1rem;overflow:hidden}.navbar-divider:before{content:\"\\A0\"}.navbar-toggler{padding:.5rem .75rem;font-size:1.25rem;line-height:1;background:none;border:1px solid transparent;border-radius:.25rem}.navbar-toggler:focus,.navbar-toggler:hover{text-decoration:none}.navbar-nav .nav-item{float:left}.navbar-nav .nav-link{display:block;padding-top:.425rem;padding-bottom:.425rem}.navbar-nav .nav-item+.nav-item,.navbar-nav .nav-link+.nav-link{margin-left:1rem}.navbar-light .navbar-brand,.navbar-light .navbar-brand:focus,.navbar-light .navbar-brand:hover{color:rgba(0,0,0,.8)}.navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,.3)}.navbar-light .navbar-nav .nav-link:focus,.navbar-light .navbar-nav .nav-link:hover{color:rgba(0,0,0,.6)}.navbar-light .navbar-nav .active>.nav-link,.navbar-light .navbar-nav .active>.nav-link:focus,.navbar-light .navbar-nav .active>.nav-link:hover,.navbar-light .navbar-nav .nav-link.active,.navbar-light .navbar-nav .nav-link.active:focus,.navbar-light .navbar-nav .nav-link.active:hover,.navbar-light .navbar-nav .nav-link.open,.navbar-light .navbar-nav .nav-link.open:focus,.navbar-light .navbar-nav .nav-link.open:hover,.navbar-light .navbar-nav .open>.nav-link,.navbar-light .navbar-nav .open>.nav-link:focus,.navbar-light .navbar-nav .open>.nav-link:hover{color:rgba(0,0,0,.8)}.navbar-light .navbar-divider{background-color:rgba(0,0,0,.075)}.navbar-dark .navbar-brand,.navbar-dark .navbar-brand:focus,.navbar-dark .navbar-brand:hover{color:#fff}.navbar-dark .navbar-nav .nav-link{color:hsla(0,0%,100%,.5)}.navbar-dark .navbar-nav .nav-link:focus,.navbar-dark .navbar-nav .nav-link:hover{color:hsla(0,0%,100%,.75)}.navbar-dark .navbar-nav .active>.nav-link,.navbar-dark .navbar-nav .active>.nav-link:focus,.navbar-dark .navbar-nav .active>.nav-link:hover,.navbar-dark .navbar-nav .nav-link.active,.navbar-dark .navbar-nav .nav-link.active:focus,.navbar-dark .navbar-nav .nav-link.active:hover,.navbar-dark .navbar-nav .nav-link.open,.navbar-dark .navbar-nav .nav-link.open:focus,.navbar-dark .navbar-nav .nav-link.open:hover,.navbar-dark .navbar-nav .open>.nav-link,.navbar-dark .navbar-nav .open>.nav-link:focus,.navbar-dark .navbar-nav .open>.nav-link:hover{color:#fff}.navbar-dark .navbar-divider{background-color:hsla(0,0%,100%,.075)}.navbar-toggleable-xs:after{content:\"\";display:table;clear:both}@media (max-width:543px){.navbar-toggleable-xs .navbar-nav .nav-item{float:none;margin-left:0}}@media (min-width:544px){.navbar-toggleable-xs{display:block!important}}.navbar-toggleable-sm:after{content:\"\";display:table;clear:both}@media (max-width:767px){.navbar-toggleable-sm .navbar-nav .nav-item{float:none;margin-left:0}}@media (min-width:768px){.navbar-toggleable-sm{display:block!important}}.navbar-toggleable-md:after{content:\"\";display:table;clear:both}@media (max-width:991px){.navbar-toggleable-md .navbar-nav .nav-item{float:none;margin-left:0}}@media (min-width:992px){.navbar-toggleable-md{display:block!important}}.card{position:relative;display:block;margin-bottom:.75rem;background-color:#fff;border-radius:.25rem;border:1px solid rgba(0,0,0,.125)}.card-block{padding:1.25rem}.card-block:after{content:\"\";display:table;clear:both}.card-title{margin-bottom:.75rem}.card-subtitle{margin-top:-.375rem}.card-subtitle,.card-text:last-child{margin-bottom:0}.card-link:hover{text-decoration:none}.card-link+.card-link{margin-left:1.25rem}.card>.list-group:first-child .list-group-item:first-child{border-top-right-radius:.25rem;border-top-left-radius:.25rem}.card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.card-header{padding:.75rem 1.25rem;background-color:#f5f5f5;border-bottom:1px solid rgba(0,0,0,.125)}.card-header:after{content:\"\";display:table;clear:both}.card-header:first-child{border-radius:.25rem .25rem 0 0}.card-footer{padding:.75rem 1.25rem;background-color:#f5f5f5;border-top:1px solid rgba(0,0,0,.125)}.card-footer:after{content:\"\";display:table;clear:both}.card-footer:last-child{border-radius:0 0 .25rem .25rem}.card-header-tabs{margin-bottom:-.75rem;border-bottom:0}.card-header-pills,.card-header-tabs{margin-right:-.625rem;margin-left:-.625rem}.card-primary{background-color:#0275d8;border-color:#0275d8}.card-primary .card-footer,.card-primary .card-header{background-color:transparent}.card-success{background-color:#5cb85c;border-color:#5cb85c}.card-success .card-footer,.card-success .card-header{background-color:transparent}.card-info{background-color:#5bc0de;border-color:#5bc0de}.card-info .card-footer,.card-info .card-header{background-color:transparent}.card-warning{background-color:#f0ad4e;border-color:#f0ad4e}.card-warning .card-footer,.card-warning .card-header{background-color:transparent}.card-danger{background-color:#d9534f;border-color:#d9534f}.card-danger .card-footer,.card-danger .card-header,.card-outline-primary{background-color:transparent}.card-outline-primary{border-color:#0275d8}.card-outline-secondary{background-color:transparent;border-color:#ccc}.card-outline-info{background-color:transparent;border-color:#5bc0de}.card-outline-success{background-color:transparent;border-color:#5cb85c}.card-outline-warning{background-color:transparent;border-color:#f0ad4e}.card-outline-danger{background-color:transparent;border-color:#d9534f}.card-inverse .card-footer,.card-inverse .card-header{border-color:hsla(0,0%,100%,.2)}.card-inverse .card-blockquote,.card-inverse .card-footer,.card-inverse .card-header,.card-inverse .card-title{color:#fff}.card-inverse .card-blockquote .blockquote-footer,.card-inverse .card-link,.card-inverse .card-subtitle,.card-inverse .card-text{color:hsla(0,0%,100%,.65)}.card-inverse .card-link:focus,.card-inverse .card-link:hover{color:#fff}.card-blockquote{padding:0;margin-bottom:0;border-left:0}.card-img{border-radius:.25rem}.card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem}.card-img-top{border-top-right-radius:.25rem;border-top-left-radius:.25rem}.card-img-bottom{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}@media (min-width:544px){.card-deck{display:table;width:100%;margin-bottom:.75rem;table-layout:fixed;border-spacing:1.25rem 0}.card-deck .card{display:table-cell;margin-bottom:0;vertical-align:top}.card-deck-wrapper{margin-right:-1.25rem;margin-left:-1.25rem}}@media (min-width:544px){.card-group{display:table;width:100%;table-layout:fixed}.card-group .card{display:table-cell;vertical-align:top}.card-group .card+.card{margin-left:0;border-left:0}.card-group .card:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.card-group .card:first-child .card-img-top{border-top-right-radius:0}.card-group .card:first-child .card-img-bottom{border-bottom-right-radius:0}.card-group .card:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.card-group .card:last-child .card-img-top{border-top-left-radius:0}.card-group .card:last-child .card-img-bottom{border-bottom-left-radius:0}.card-group .card:not(:first-child):not(:last-child),.card-group .card:not(:first-child):not(:last-child) .card-img-bottom,.card-group .card:not(:first-child):not(:last-child) .card-img-top{border-radius:0}}@media (min-width:544px){.card-columns{column-count:3;column-gap:1.25rem}.card-columns .card{width:100%}}.breadcrumb{padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#eceeef;border-radius:.25rem}.breadcrumb:after{content:\"\";display:table;clear:both}.breadcrumb-item{float:left}.breadcrumb-item+.breadcrumb-item:before{display:inline-block;padding-right:.5rem;padding-left:.5rem;color:#818a91;content:\"/\"}.breadcrumb-item+.breadcrumb-item:hover:before{text-decoration:underline;text-decoration:none}.breadcrumb-item.active{color:#818a91}.pagination{display:inline-block;padding-left:0;margin-top:1rem;margin-bottom:1rem;border-radius:.25rem}.page-item{display:inline}.page-item:first-child .page-link{margin-left:0;border-bottom-left-radius:.25rem;border-top-left-radius:.25rem}.page-item:last-child .page-link{border-bottom-right-radius:.25rem;border-top-right-radius:.25rem}.page-item.active .page-link,.page-item.active .page-link:focus,.page-item.active .page-link:hover{z-index:2;color:#fff;cursor:default;background-color:#0275d8;border-color:#0275d8}.page-item.disabled .page-link,.page-item.disabled .page-link:focus,.page-item.disabled .page-link:hover{color:#818a91;pointer-events:none;cursor:not-allowed;background-color:#fff;border-color:#ddd}.page-link{position:relative;float:left;padding:.5rem .75rem;margin-left:-1px;color:#0275d8;text-decoration:none;background-color:#fff;border:1px solid #ddd}.page-link:focus,.page-link:hover{color:#014c8c;background-color:#eceeef;border-color:#ddd}.pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem}.pagination-lg .page-item:first-child .page-link{border-bottom-left-radius:.3rem;border-top-left-radius:.3rem}.pagination-lg .page-item:last-child .page-link{border-bottom-right-radius:.3rem;border-top-right-radius:.3rem}.pagination-sm .page-link{padding:.275rem .75rem;font-size:.875rem}.pagination-sm .page-item:first-child .page-link{border-bottom-left-radius:.2rem;border-top-left-radius:.2rem}.pagination-sm .page-item:last-child .page-link{border-bottom-right-radius:.2rem;border-top-right-radius:.2rem}.tag{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}.tag:empty{display:none}.btn .tag{position:relative;top:-1px}a.tag:focus,a.tag:hover{color:#fff;text-decoration:none;cursor:pointer}.tag-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.tag-default{background-color:#818a91}.tag-default[href]:focus,.tag-default[href]:hover{background-color:#687077}.tag-primary{background-color:#0275d8}.tag-primary[href]:focus,.tag-primary[href]:hover{background-color:#025aa5}.tag-success{background-color:#5cb85c}.tag-success[href]:focus,.tag-success[href]:hover{background-color:#449d44}.tag-info{background-color:#5bc0de}.tag-info[href]:focus,.tag-info[href]:hover{background-color:#31b0d5}.tag-warning{background-color:#f0ad4e}.tag-warning[href]:focus,.tag-warning[href]:hover{background-color:#ec971f}.tag-danger{background-color:#d9534f}.tag-danger[href]:focus,.tag-danger[href]:hover{background-color:#c9302c}.jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#eceeef;border-radius:.3rem}@media (min-width:544px){.jumbotron{padding:4rem 2rem}}.jumbotron-hr{border-top-color:#d0d5d8}.jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.alert{padding:1rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.alert-heading{color:inherit}.alert-link{font-weight:700}.alert-dismissible{padding-right:2rem}.alert-dismissible .close{position:relative;top:-.125rem;right:-1rem;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d0e9c6;color:#3c763d}.alert-success hr{border-top-color:#c1e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bcdff1;color:#31708f}.alert-info hr{border-top-color:#a6d5ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faf2cc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7ecb5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebcccc;color:#a94442}.alert-danger hr{border-top-color:#e4b9b9}.alert-danger .alert-link{color:#843534}.progress{display:block;width:100%;height:1rem;margin-bottom:1rem}.progress[value]{background-color:#eee;border:0;appearance:none;border-radius:.25rem}.progress[value]::-ms-fill{background-color:#0074d9;border:0}.progress[value]::-moz-progress-bar{background-color:#0074d9;border-bottom-left-radius:.25rem;border-top-left-radius:.25rem}.progress[value]::-webkit-progress-value{background-color:#0074d9;border-bottom-left-radius:.25rem;border-top-left-radius:.25rem}.progress[value=\"100\"]::-moz-progress-bar{border-bottom-right-radius:.25rem;border-top-right-radius:.25rem}.progress[value=\"100\"]::-webkit-progress-value{border-bottom-right-radius:.25rem;border-top-right-radius:.25rem}.progress[value]::-webkit-progress-bar{background-color:#eee;border-radius:.25rem}.progress[value],base::-moz-progress-bar{background-color:#eee;border-radius:.25rem}@media screen and (min-width:0\\0){.progress{background-color:#eee;border-radius:.25rem}.progress-bar{display:inline-block;height:1rem;text-indent:-999rem;background-color:#0074d9;border-bottom-left-radius:.25rem;border-top-left-radius:.25rem}.progress[width=\"100%\"]{border-bottom-right-radius:.25rem;border-top-right-radius:.25rem}}.progress-striped[value]::-webkit-progress-value{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-striped[value]::-moz-progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}.progress-striped[value]::-ms-fill{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}@media screen and (min-width:0\\0){.progress-bar-striped{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:1rem 1rem}}.progress-animated[value]::-webkit-progress-value{animation:progress-bar-stripes 2s linear infinite}.progress-animated[value]::-moz-progress-bar{animation:progress-bar-stripes 2s linear infinite}@media screen and (min-width:0\\0){.progress-animated .progress-bar-striped{animation:progress-bar-stripes 2s linear infinite}}.progress-success[value]::-webkit-progress-value{background-color:#5cb85c}.progress-success[value]::-moz-progress-bar{background-color:#5cb85c}.progress-success[value]::-ms-fill{background-color:#5cb85c}@media screen and (min-width:0\\0){.progress-success .progress-bar{background-color:#5cb85c}}.progress-info[value]::-webkit-progress-value{background-color:#5bc0de}.progress-info[value]::-moz-progress-bar{background-color:#5bc0de}.progress-info[value]::-ms-fill{background-color:#5bc0de}@media screen and (min-width:0\\0){.progress-info .progress-bar{background-color:#5bc0de}}.progress-warning[value]::-webkit-progress-value{background-color:#f0ad4e}.progress-warning[value]::-moz-progress-bar{background-color:#f0ad4e}.progress-warning[value]::-ms-fill{background-color:#f0ad4e}@media screen and (min-width:0\\0){.progress-warning .progress-bar{background-color:#f0ad4e}}.progress-danger[value]::-webkit-progress-value{background-color:#d9534f}.progress-danger[value]::-moz-progress-bar{background-color:#d9534f}.progress-danger[value]::-ms-fill{background-color:#d9534f}@media screen and (min-width:0\\0){.progress-danger .progress-bar{background-color:#d9534f}}.media,.media-body{overflow:hidden}.media-body{width:10000px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right{padding-left:10px}.media-left{padding-right:10px}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:0}.list-group-item{position:relative;display:block;padding:.75rem 1.25rem;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:.25rem;border-top-left-radius:.25rem}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#818a91;cursor:not-allowed;background-color:#eceeef}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#818a91}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;text-decoration:none;background-color:#0275d8;border-color:#0275d8}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#a8d6fe}.list-group-flush .list-group-item{border-radius:0}.list-group-item-action{width:100%;color:#555;text-align:inherit}.list-group-item-action .list-group-item-heading{color:#333}.list-group-item-action:focus,.list-group-item-action:hover{color:#555;text-decoration:none;background-color:#f5f5f5}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-21by9{padding-bottom:42.85714%}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.embed-responsive-1by1{padding-bottom:100%}.close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;outline:0;-webkit-overflow-scrolling:touch}.modal.fade .modal-dialog{transition:transform .3s ease-out;transform:translateY(-25%)}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0}.modal-backdrop.in{opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after{content:\"\";display:table;clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.5}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after{content:\"\";display:table;clear:both}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:544px){.modal-dialog{max-width:600px;margin:30px auto}.modal-sm{max-width:300px}}@media (min-width:992px){.modal-lg{max-width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;font-size:.875rem;word-wrap:break-word;opacity:0}.tooltip.in{opacity:.9}.tooltip.bs-tether-element-attached-bottom,.tooltip.tooltip-top{padding:5px 0;margin-top:-3px}.tooltip.bs-tether-element-attached-bottom .tooltip-arrow,.tooltip.tooltip-top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.bs-tether-element-attached-left,.tooltip.tooltip-right{padding:0 5px;margin-left:3px}.tooltip.bs-tether-element-attached-left .tooltip-arrow,.tooltip.tooltip-right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.bs-tether-element-attached-top,.tooltip.tooltip-bottom{padding:5px 0;margin-top:3px}.tooltip.bs-tether-element-attached-top .tooltip-arrow,.tooltip.tooltip-bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bs-tether-element-attached-right,.tooltip.tooltip-left{padding:0 5px;margin-left:-3px}.tooltip.bs-tether-element-attached-right .tooltip-arrow,.tooltip.tooltip-left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;padding:1px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.5;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,.2);border-radius:.3rem}.popover.bs-tether-element-attached-bottom,.popover.popover-top{margin-top:-10px}.popover.bs-tether-element-attached-bottom .popover-arrow,.popover.popover-top .popover-arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.bs-tether-element-attached-bottom .popover-arrow:after,.popover.popover-top .popover-arrow:after{bottom:1px;margin-left:-10px;content:\"\";border-top-color:#fff;border-bottom-width:0}.popover.bs-tether-element-attached-left,.popover.popover-right{margin-left:10px}.popover.bs-tether-element-attached-left .popover-arrow,.popover.popover-right .popover-arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.bs-tether-element-attached-left .popover-arrow:after,.popover.popover-right .popover-arrow:after{bottom:-10px;left:1px;content:\"\";border-right-color:#fff;border-left-width:0}.popover.bs-tether-element-attached-top,.popover.popover-bottom{margin-top:10px}.popover.bs-tether-element-attached-top .popover-arrow,.popover.popover-bottom .popover-arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:rgba(0,0,0,.25)}.popover.bs-tether-element-attached-top .popover-arrow:after,.popover.popover-bottom .popover-arrow:after{top:1px;margin-left:-10px;content:\"\";border-top-width:0;border-bottom-color:#fff}.popover.bs-tether-element-attached-right,.popover.popover-left{margin-left:-10px}.popover.bs-tether-element-attached-right .popover-arrow,.popover.popover-left .popover-arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:rgba(0,0,0,.25)}.popover.bs-tether-element-attached-right .popover-arrow:after,.popover.popover-left .popover-arrow:after{right:1px;bottom:-10px;content:\"\";border-right-width:0;border-left-color:#fff}.popover-title{padding:8px 14px;margin:0;font-size:1rem;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:.2375rem .2375rem 0 0}.popover-title:empty{display:none}.popover-content{padding:9px 14px}.popover-arrow,.popover-arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover-arrow{border-width:11px}.popover-arrow:after{content:\"\";border-width:10px}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.carousel-item{position:relative;display:none;transition:left .6s ease-in-out}.carousel-inner>.carousel-item>a>img,.carousel-inner>.carousel-item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.carousel-item{transition:transform .6s ease-in-out;backface-visibility:hidden;perspective:1000px}.carousel-inner>.carousel-item.active.right,.carousel-inner>.carousel-item.next{left:0;transform:translate3d(100%,0,0)}.carousel-inner>.carousel-item.active.left,.carousel-inner>.carousel-item.prev{left:0;transform:translate3d(-100%,0,0)}.carousel-inner>.carousel-item.active,.carousel-inner>.carousel-item.next.left,.carousel-inner>.carousel-item.prev.right{left:0;transform:translateZ(0)}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);opacity:.5}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{right:0;left:auto;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;outline:0;opacity:.9}.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;width:20px;height:20px;margin-top:-10px;font-family:serif;line-height:1}.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media (min-width:544px){.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-15px;font-size:30px}.carousel-control .icon-prev{margin-left:-15px}.carousel-control .icon-next{margin-right:-15px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.bg-faded{background-color:#f7f7f9}.bg-primary{color:#fff!important;background-color:#0275d8!important}a.bg-primary:focus,a.bg-primary:hover{background-color:#025aa5!important}.bg-success{color:#fff!important;background-color:#5cb85c!important}a.bg-success:focus,a.bg-success:hover{background-color:#449d44!important}.bg-info{color:#fff!important;background-color:#5bc0de!important}a.bg-info:focus,a.bg-info:hover{background-color:#31b0d5!important}.bg-warning{color:#fff!important;background-color:#f0ad4e!important}a.bg-warning:focus,a.bg-warning:hover{background-color:#ec971f!important}.bg-danger{color:#fff!important;background-color:#d9534f!important}a.bg-danger:focus,a.bg-danger:hover{background-color:#c9302c!important}.bg-inverse{color:#fff!important;background-color:#373a3c!important}a.bg-inverse:focus,a.bg-inverse:hover{background-color:#1f2021!important}.clearfix:after{content:\"\";display:table;clear:both}.d-block{display:block!important}.d-inline-block{display:inline-block!important}.d-inline{display:inline!important}.pull-xs-left{float:left!important}.pull-xs-right{float:right!important}.pull-xs-none{float:none!important}@media (min-width:544px){.pull-sm-left{float:left!important}.pull-sm-right{float:right!important}.pull-sm-none{float:none!important}}@media (min-width:768px){.pull-md-left{float:left!important}.pull-md-right{float:right!important}.pull-md-none{float:none!important}}@media (min-width:992px){.pull-lg-left{float:left!important}.pull-lg-right{float:right!important}.pull-lg-none{float:none!important}}@media (min-width:1200px){.pull-xl-left{float:left!important}.pull-xl-right{float:right!important}.pull-xl-none{float:none!important}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}.w-100{width:100%!important}.m-x-auto{margin-right:auto!important;margin-left:auto!important}.m-a-0{margin:0!important}.m-t-0{margin-top:0!important}.m-r-0{margin-right:0!important}.m-b-0{margin-bottom:0!important}.m-l-0,.m-x-0{margin-left:0!important}.m-x-0{margin-right:0!important}.m-y-0{margin-top:0!important;margin-bottom:0!important}.m-a-1{margin:1rem!important}.m-t-1{margin-top:1rem!important}.m-r-1{margin-right:1rem!important}.m-b-1{margin-bottom:1rem!important}.m-l-1,.m-x-1{margin-left:1rem!important}.m-x-1{margin-right:1rem!important}.m-y-1{margin-top:1rem!important;margin-bottom:1rem!important}.m-a-2{margin:1.5rem!important}.m-t-2{margin-top:1.5rem!important}.m-r-2{margin-right:1.5rem!important}.m-b-2{margin-bottom:1.5rem!important}.m-l-2,.m-x-2{margin-left:1.5rem!important}.m-x-2{margin-right:1.5rem!important}.m-y-2{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.m-a-3{margin:3rem!important}.m-t-3{margin-top:3rem!important}.m-r-3{margin-right:3rem!important}.m-b-3{margin-bottom:3rem!important}.m-l-3,.m-x-3{margin-left:3rem!important}.m-x-3{margin-right:3rem!important}.m-y-3{margin-top:3rem!important;margin-bottom:3rem!important}.p-a-0{padding:0!important}.p-t-0{padding-top:0!important}.p-r-0{padding-right:0!important}.p-b-0{padding-bottom:0!important}.p-l-0,.p-x-0{padding-left:0!important}.p-x-0{padding-right:0!important}.p-y-0{padding-top:0!important;padding-bottom:0!important}.p-a-1{padding:1rem!important}.p-t-1{padding-top:1rem!important}.p-r-1{padding-right:1rem!important}.p-b-1{padding-bottom:1rem!important}.p-l-1,.p-x-1{padding-left:1rem!important}.p-x-1{padding-right:1rem!important}.p-y-1{padding-top:1rem!important;padding-bottom:1rem!important}.p-a-2{padding:1.5rem!important}.p-t-2{padding-top:1.5rem!important}.p-r-2{padding-right:1.5rem!important}.p-b-2{padding-bottom:1.5rem!important}.p-l-2,.p-x-2{padding-left:1.5rem!important}.p-x-2{padding-right:1.5rem!important}.p-y-2{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.p-a-3{padding:3rem!important}.p-t-3{padding-top:3rem!important}.p-r-3{padding-right:3rem!important}.p-b-3{padding-bottom:3rem!important}.p-l-3,.p-x-3{padding-left:3rem!important}.p-x-3{padding-right:3rem!important}.p-y-3{padding-top:3rem!important;padding-bottom:3rem!important}.pos-f-t{position:fixed;top:0;right:0;left:0;z-index:1030}.text-justify{text-align:justify!important}.text-nowrap{white-space:nowrap!important}.text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.text-xs-left{text-align:left!important}.text-xs-right{text-align:right!important}.text-xs-center{text-align:center!important}@media (min-width:544px){.text-sm-left{text-align:left!important}.text-sm-right{text-align:right!important}.text-sm-center{text-align:center!important}}@media (min-width:768px){.text-md-left{text-align:left!important}.text-md-right{text-align:right!important}.text-md-center{text-align:center!important}}@media (min-width:992px){.text-lg-left{text-align:left!important}.text-lg-right{text-align:right!important}.text-lg-center{text-align:center!important}}@media (min-width:1200px){.text-xl-left{text-align:left!important}.text-xl-right{text-align:right!important}.text-xl-center{text-align:center!important}}.text-lowercase{text-transform:lowercase!important}.text-uppercase{text-transform:uppercase!important}.text-capitalize{text-transform:capitalize!important}.font-weight-normal{font-weight:400}.font-weight-bold{font-weight:700}.font-italic{font-style:italic}.text-muted{color:#818a91!important}a.text-muted:focus,a.text-muted:hover{color:#687077!important}.text-primary{color:#0275d8!important}a.text-primary:focus,a.text-primary:hover{color:#025aa5!important}.text-success{color:#5cb85c!important}a.text-success:focus,a.text-success:hover{color:#449d44!important}.text-info{color:#5bc0de!important}a.text-info:focus,a.text-info:hover{color:#31b0d5!important}.text-warning{color:#f0ad4e!important}a.text-warning:focus,a.text-warning:hover{color:#ec971f!important}.text-danger{color:#d9534f!important}a.text-danger:focus,a.text-danger:hover{color:#c9302c!important}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.invisible{visibility:hidden!important}.hidden-xs-up{display:none!important}@media (max-width:543px){.hidden-xs-down{display:none!important}}@media (min-width:544px){.hidden-sm-up{display:none!important}}@media (max-width:767px){.hidden-sm-down{display:none!important}}@media (min-width:768px){.hidden-md-up{display:none!important}}@media (max-width:991px){.hidden-md-down{display:none!important}}@media (min-width:992px){.hidden-lg-up{display:none!important}}@media (max-width:1199px){.hidden-lg-down{display:none!important}}@media (min-width:1200px){.hidden-xl-up{display:none!important}}.hidden-xl-down,.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}body,html{direction:rtl}.text-left{text-align:right}.text-right{text-align:left}.list-unstyled{padding-right:0;padding-left:0}.list-inline{padding-left:0;list-style:none;margin-right:-5px;margin-left:0}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:right}.col-xs-pull-0{left:auto;right:auto}.col-xs-pull-1{left:8.33333%;right:auto}.col-xs-pull-2{left:16.66667%;right:auto}.col-xs-pull-3{left:25%;right:auto}.col-xs-pull-4{left:33.33333%;right:auto}.col-xs-pull-5{left:41.66667%;right:auto}.col-xs-pull-6{left:50%;right:auto}.col-xs-pull-7{left:58.33333%;right:auto}.col-xs-pull-8{left:66.66667%;right:auto}.col-xs-pull-9{left:75%;right:auto}.col-xs-pull-10{left:83.33333%;right:auto}.col-xs-pull-11{left:91.66667%;right:auto}.col-xs-pull-12{left:100%;right:auto}.col-xs-push-0{left:0;right:auto}.col-xs-push-1{left:0;right:8.33333%}.col-xs-push-2{left:0;right:16.66667%}.col-xs-push-3{left:0;right:25%}.col-xs-push-4{left:0;right:33.33333%}.col-xs-push-5{left:0;right:41.66667%}.col-xs-push-6{left:0;right:50%}.col-xs-push-7{left:0;right:58.33333%}.col-xs-push-8{left:0;right:66.66667%}.col-xs-push-9{left:0;right:75%}.col-xs-push-10{left:0;right:83.33333%}.col-xs-push-11{left:0;right:91.66667%}.col-xs-push-12{left:0;right:100%}.col-xs-offset-0{margin-left:0;margin-right:0}.col-xs-offset-1{margin-left:0;margin-right:8.33333%}.col-xs-offset-2{margin-left:0;margin-right:16.66667%}.col-xs-offset-3{margin-left:0;margin-right:25%}.col-xs-offset-4{margin-left:0;margin-right:33.33333%}.col-xs-offset-5{margin-left:0;margin-right:41.66667%}.col-xs-offset-6{margin-left:0;margin-right:50%}.col-xs-offset-7{margin-left:0;margin-right:58.33333%}.col-xs-offset-8{margin-left:0;margin-right:66.66667%}.col-xs-offset-9{margin-left:0;margin-right:75%}.col-xs-offset-10{margin-left:0;margin-right:83.33333%}.col-xs-offset-11{margin-left:0;margin-right:91.66667%}.col-xs-offset-12{margin-left:0;margin-right:100%}@media (min-width:544px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:right}.col-sm-pull-0{left:auto;right:auto}.col-sm-pull-1{left:8.33333%;right:auto}.col-sm-pull-2{left:16.66667%;right:auto}.col-sm-pull-3{left:25%;right:auto}.col-sm-pull-4{left:33.33333%;right:auto}.col-sm-pull-5{left:41.66667%;right:auto}.col-sm-pull-6{left:50%;right:auto}.col-sm-pull-7{left:58.33333%;right:auto}.col-sm-pull-8{left:66.66667%;right:auto}.col-sm-pull-9{left:75%;right:auto}.col-sm-pull-10{left:83.33333%;right:auto}.col-sm-pull-11{left:91.66667%;right:auto}.col-sm-pull-12{left:100%;right:auto}.col-sm-push-0{left:0;right:auto}.col-sm-push-1{left:0;right:8.33333%}.col-sm-push-2{left:0;right:16.66667%}.col-sm-push-3{left:0;right:25%}.col-sm-push-4{left:0;right:33.33333%}.col-sm-push-5{left:0;right:41.66667%}.col-sm-push-6{left:0;right:50%}.col-sm-push-7{left:0;right:58.33333%}.col-sm-push-8{left:0;right:66.66667%}.col-sm-push-9{left:0;right:75%}.col-sm-push-10{left:0;right:83.33333%}.col-sm-push-11{left:0;right:91.66667%}.col-sm-push-12{left:0;right:100%}.col-sm-offset-0{margin-left:0;margin-right:0}.col-sm-offset-1{margin-left:0;margin-right:8.33333%}.col-sm-offset-2{margin-left:0;margin-right:16.66667%}.col-sm-offset-3{margin-left:0;margin-right:25%}.col-sm-offset-4{margin-left:0;margin-right:33.33333%}.col-sm-offset-5{margin-left:0;margin-right:41.66667%}.col-sm-offset-6{margin-left:0;margin-right:50%}.col-sm-offset-7{margin-left:0;margin-right:58.33333%}.col-sm-offset-8{margin-left:0;margin-right:66.66667%}.col-sm-offset-9{margin-left:0;margin-right:75%}.col-sm-offset-10{margin-left:0;margin-right:83.33333%}.col-sm-offset-11{margin-left:0;margin-right:91.66667%}.col-sm-offset-12{margin-left:0;margin-right:100%}}@media (min-width:768px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:right}.col-md-pull-0{left:auto;right:auto}.col-md-pull-1{left:8.33333%;right:auto}.col-md-pull-2{left:16.66667%;right:auto}.col-md-pull-3{left:25%;right:auto}.col-md-pull-4{left:33.33333%;right:auto}.col-md-pull-5{left:41.66667%;right:auto}.col-md-pull-6{left:50%;right:auto}.col-md-pull-7{left:58.33333%;right:auto}.col-md-pull-8{left:66.66667%;right:auto}.col-md-pull-9{left:75%;right:auto}.col-md-pull-10{left:83.33333%;right:auto}.col-md-pull-11{left:91.66667%;right:auto}.col-md-pull-12{left:100%;right:auto}.col-md-push-0{left:0;right:auto}.col-md-push-1{left:0;right:8.33333%}.col-md-push-2{left:0;right:16.66667%}.col-md-push-3{left:0;right:25%}.col-md-push-4{left:0;right:33.33333%}.col-md-push-5{left:0;right:41.66667%}.col-md-push-6{left:0;right:50%}.col-md-push-7{left:0;right:58.33333%}.col-md-push-8{left:0;right:66.66667%}.col-md-push-9{left:0;right:75%}.col-md-push-10{left:0;right:83.33333%}.col-md-push-11{left:0;right:91.66667%}.col-md-push-12{left:0;right:100%}.col-md-offset-0{margin-left:0;margin-right:0}.col-md-offset-1{margin-left:0;margin-right:8.33333%}.col-md-offset-2{margin-left:0;margin-right:16.66667%}.col-md-offset-3{margin-left:0;margin-right:25%}.col-md-offset-4{margin-left:0;margin-right:33.33333%}.col-md-offset-5{margin-left:0;margin-right:41.66667%}.col-md-offset-6{margin-left:0;margin-right:50%}.col-md-offset-7{margin-left:0;margin-right:58.33333%}.col-md-offset-8{margin-left:0;margin-right:66.66667%}.col-md-offset-9{margin-left:0;margin-right:75%}.col-md-offset-10{margin-left:0;margin-right:83.33333%}.col-md-offset-11{margin-left:0;margin-right:91.66667%}.col-md-offset-12{margin-left:0;margin-right:100%}}@media (min-width:992px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:right}.col-lg-pull-0{left:auto;right:auto}.col-lg-pull-1{left:8.33333%;right:auto}.col-lg-pull-2{left:16.66667%;right:auto}.col-lg-pull-3{left:25%;right:auto}.col-lg-pull-4{left:33.33333%;right:auto}.col-lg-pull-5{left:41.66667%;right:auto}.col-lg-pull-6{left:50%;right:auto}.col-lg-pull-7{left:58.33333%;right:auto}.col-lg-pull-8{left:66.66667%;right:auto}.col-lg-pull-9{left:75%;right:auto}.col-lg-pull-10{left:83.33333%;right:auto}.col-lg-pull-11{left:91.66667%;right:auto}.col-lg-pull-12{left:100%;right:auto}.col-lg-push-0{left:0;right:auto}.col-lg-push-1{left:0;right:8.33333%}.col-lg-push-2{left:0;right:16.66667%}.col-lg-push-3{left:0;right:25%}.col-lg-push-4{left:0;right:33.33333%}.col-lg-push-5{left:0;right:41.66667%}.col-lg-push-6{left:0;right:50%}.col-lg-push-7{left:0;right:58.33333%}.col-lg-push-8{left:0;right:66.66667%}.col-lg-push-9{left:0;right:75%}.col-lg-push-10{left:0;right:83.33333%}.col-lg-push-11{left:0;right:91.66667%}.col-lg-push-12{left:0;right:100%}.col-lg-offset-0{margin-left:0;margin-right:0}.col-lg-offset-1{margin-left:0;margin-right:8.33333%}.col-lg-offset-2{margin-left:0;margin-right:16.66667%}.col-lg-offset-3{margin-left:0;margin-right:25%}.col-lg-offset-4{margin-left:0;margin-right:33.33333%}.col-lg-offset-5{margin-left:0;margin-right:41.66667%}.col-lg-offset-6{margin-left:0;margin-right:50%}.col-lg-offset-7{margin-left:0;margin-right:58.33333%}.col-lg-offset-8{margin-left:0;margin-right:66.66667%}.col-lg-offset-9{margin-left:0;margin-right:75%}.col-lg-offset-10{margin-left:0;margin-right:83.33333%}.col-lg-offset-11{margin-left:0;margin-right:91.66667%}.col-lg-offset-12{margin-left:0;margin-right:100%}}@media (min-width:1200px){.col-xl-1,.col-xl-2,.col-xl-3,.col-xl-4,.col-xl-5,.col-xl-6,.col-xl-7,.col-xl-8,.col-xl-9,.col-xl-10,.col-xl-11,.col-xl-12{float:right}.col-xl-pull-0{left:auto;right:auto}.col-xl-pull-1{left:8.33333%;right:auto}.col-xl-pull-2{left:16.66667%;right:auto}.col-xl-pull-3{left:25%;right:auto}.col-xl-pull-4{left:33.33333%;right:auto}.col-xl-pull-5{left:41.66667%;right:auto}.col-xl-pull-6{left:50%;right:auto}.col-xl-pull-7{left:58.33333%;right:auto}.col-xl-pull-8{left:66.66667%;right:auto}.col-xl-pull-9{left:75%;right:auto}.col-xl-pull-10{left:83.33333%;right:auto}.col-xl-pull-11{left:91.66667%;right:auto}.col-xl-pull-12{left:100%;right:auto}.col-xl-push-0{left:0;right:auto}.col-xl-push-1{left:0;right:8.33333%}.col-xl-push-2{left:0;right:16.66667%}.col-xl-push-3{left:0;right:25%}.col-xl-push-4{left:0;right:33.33333%}.col-xl-push-5{left:0;right:41.66667%}.col-xl-push-6{left:0;right:50%}.col-xl-push-7{left:0;right:58.33333%}.col-xl-push-8{left:0;right:66.66667%}.col-xl-push-9{left:0;right:75%}.col-xl-push-10{left:0;right:83.33333%}.col-xl-push-11{left:0;right:91.66667%}.col-xl-push-12{left:0;right:100%}.col-xl-offset-0{margin-left:0;margin-right:0}.col-xl-offset-1{margin-left:0;margin-right:8.33333%}.col-xl-offset-2{margin-left:0;margin-right:16.66667%}.col-xl-offset-3{margin-left:0;margin-right:25%}.col-xl-offset-4{margin-left:0;margin-right:33.33333%}.col-xl-offset-5{margin-left:0;margin-right:41.66667%}.col-xl-offset-6{margin-left:0;margin-right:50%}.col-xl-offset-7{margin-left:0;margin-right:58.33333%}.col-xl-offset-8{margin-left:0;margin-right:66.66667%}.col-xl-offset-9{margin-left:0;margin-right:75%}.col-xl-offset-10{margin-left:0;margin-right:83.33333%}.col-xl-offset-11{margin-left:0;margin-right:91.66667%}.col-xl-offset-12{margin-left:0;margin-right:100%}}caption,th{text-align:right}.checkbox label,.radio label{padding-right:1.25rem;padding-left:0}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{margin-right:-1.25rem;margin-left:auto}.checkbox-inline,.radio-inline{padding-right:1.25rem;padding-left:0}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-right:.75rem;margin-left:0}.form-control-danger,.form-control-success,.form-control-warning{background-position:center left .5625rem;padding-right:.75rem;padding-left:2.25rem}.dropdown-menu{right:0;left:auto;float:left;text-align:right}.dropdown-menu.pull-right{left:0;right:auto;float:right}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.btn-group-vertical>.btn,.btn-group>.btn{float:right}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-right:-1px;margin-left:0}.btn-toolbar{margin-right:-5px;margin-left:0}.btn-toolbar .btn-group,.btn-toolbar .input-group{float:right}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-right:5px;margin-left:0}.btn-group>.btn:first-child{margin-right:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:.25rem;border-bottom-right-radius:.25rem;border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:.25rem;border-bottom-left-radius:.25rem;border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group{float:right}.btn-group.btn-group-justified>.btn,.btn-group.btn-group-justified>.btn-group{float:none}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child>.btn:last-child,.btn-group>.btn-group:first-child>.dropdown-toggle{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem;border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group:last-child>.btn:first-child{border-top-left-radius:.25rem;border-bottom-left-radius:.25rem;border-bottom-right-radius:0;border-top-right-radius:0}.btn .caret{margin-right:0}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-right:0}.input-group .form-control{float:right}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:.25rem;border-top-right-radius:.25rem;border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:first-child{border-left:0;border-right-style:solid;border-right-width:1px}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:.25rem;border-top-left-radius:.25rem;border-bottom-right-radius:0;border-top-right-radius:0}.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:last-child{border-left-style:solid;border-left-width:1px;border-right:0}.input-group-btn>.btn+.btn{margin-right:-1px;margin-left:auto}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-left:-1px;margin-right:auto}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{margin-right:-1px;margin-left:auto}.nav{padding-right:0;padding-left:0}.nav-tabs .nav-item,.nav-tabs>li{float:right}.nav-tabs>li>a{margin-left:auto;margin-right:-2px;border-radius:.25rem .25rem 0 0}.nav-pills .nav-item,.nav-pills>li{float:right}.nav-pills>li+li{margin-right:2px;margin-left:auto}.nav-stacked .nav-item,.nav-stacked>li{float:none}.nav-stacked>li+li{margin-right:0;margin-left:auto}.nav-justified>.dropdown .dropdown-menu{right:auto}.navbar-brand{float:right;margin-left:1rem;margin-right:0}.navbar-nav,.navbar-nav .nav-item{float:right}.navbar-nav .nav-item+.nav-item{margin-left:0;margin-right:1rem}.breadcrumb>li{float:right}.pagination{padding-right:0}.pagination .page-item .page-link,.pagination .page-item>a,.pagination .page-item>span,.pagination>li .page-link,.pagination>li>a,.pagination>li>span{float:right;margin-right:-1px;margin-left:0}.pagination .page-item:first-child>a,.pagination .page-item:first-child>span,.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-right-radius:.25rem;border-top-right-radius:.25rem;border-bottom-left-radius:0;border-top-left-radius:0}.pagination .page-item:last-child>a,.pagination .page-item:last-child>span,.pagination>li:last-child>a,.pagination>li:last-child>span{margin-right:-1px;border-bottom-left-radius:.25rem;border-top-left-radius:.25rem;border-bottom-right-radius:0;border-top-right-radius:0}.pager{padding-right:0}.pager .pager-next{float:left}.pager .pager-prev{float:right}.nav-pills>li>a>.badge{margin-left:0;margin-right:3px}.list-group-item>.badge{float:left}.list-group-item>.badge+.badge{margin-left:5px;margin-right:auto}.alert-dismissable,.alert-dismissible{padding-left:21rem;padding-right:1rem}.progress-bar{float:right}.media-right{padding-right:10px;padding-left:0}.media-left{padding-left:10px;padding-right:0}.list-group{padding-right:0;padding-left:0}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object{right:0;left:auto}.close{float:left}.modal-footer{text-align:left}.popover{left:auto;text-align:right}.popover.popover-top>.popover-arrow{right:50%;left:auto;margin-right:-11px;margin-left:auto}.popover.popover-top>.popover-arrow:after{margin-right:-10px;margin-left:auto}.popover.popover-bottom>.popover-arrow{right:50%;left:auto;margin-right:-11px;margin-left:auto}.popover.popover-bottom>.popover-arrow:after{margin-right:-10px;margin-left:auto}.carousel-indicators{right:50%;left:0;margin-right:-30%;margin-left:0;padding-right:0}.pull-right{float:left!important}.pull-left{float:right!important}.btn{display:inline-block;font-weight:400;line-height:1.25;text-align:center;white-space:nowrap;vertical-align:middle;cursor:pointer;user-select:none;border:1px solid transparent;padding:.5rem 1rem;font-size:1rem;border-radius:.25rem}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0}.btn.disabled,.btn:disabled{cursor:not-allowed;opacity:.65}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-primary{color:#fff;background-color:#0275d8;border-color:#0275d8}.btn-primary.focus,.btn-primary:focus,.btn-primary:hover{color:#fff;background-color:#025aa5;border-color:#01549b}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle{color:#fff;background-color:#025aa5;border-color:#01549b;background-image:none}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover{color:#fff;background-color:#014682;border-color:#01315a}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary:disabled.focus,.btn-primary:disabled:focus,.btn-primary:disabled:hover{background-color:#0275d8;border-color:#0275d8}.btn-secondary{color:#373a3c;background-color:#fff;border-color:#ccc}.btn-secondary.focus,.btn-secondary:focus,.btn-secondary:hover{color:#373a3c;background-color:#e6e6e6;border-color:#adadad}.btn-secondary.active,.btn-secondary:active,.open>.btn-secondary.dropdown-toggle{color:#373a3c;background-color:#e6e6e6;border-color:#adadad;background-image:none}.btn-secondary.active.focus,.btn-secondary.active:focus,.btn-secondary.active:hover,.btn-secondary:active.focus,.btn-secondary:active:focus,.btn-secondary:active:hover,.open>.btn-secondary.dropdown-toggle.focus,.open>.btn-secondary.dropdown-toggle:focus,.open>.btn-secondary.dropdown-toggle:hover{color:#373a3c;background-color:#d4d4d4;border-color:#8c8c8c}.btn-secondary.disabled.focus,.btn-secondary.disabled:focus,.btn-secondary.disabled:hover,.btn-secondary:disabled.focus,.btn-secondary:disabled:focus,.btn-secondary:disabled:hover{background-color:#fff;border-color:#ccc}.btn-info{color:#fff;background-color:#5bc0de;border-color:#5bc0de}.btn-info.focus,.btn-info:focus,.btn-info:hover{color:#fff;background-color:#31b0d5;border-color:#2aabd2}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;border-color:#2aabd2;background-image:none}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1f7e9a}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info:disabled.focus,.btn-info:disabled:focus,.btn-info:disabled:hover{background-color:#5bc0de;border-color:#5bc0de}.btn-success{color:#fff;background-color:#5cb85c;border-color:#5cb85c}.btn-success.focus,.btn-success:focus,.btn-success:hover{color:#fff;background-color:#449d44;border-color:#419641}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;border-color:#419641;background-image:none}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#2d672d}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success:disabled.focus,.btn-success:disabled:focus,.btn-success:disabled:hover{background-color:#5cb85c;border-color:#5cb85c}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#f0ad4e}.btn-warning.focus,.btn-warning:focus,.btn-warning:hover{color:#fff;background-color:#ec971f;border-color:#eb9316}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#ec971f;border-color:#eb9316;background-image:none}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#b06d0f}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning:disabled.focus,.btn-warning:disabled:focus,.btn-warning:disabled:hover{background-color:#f0ad4e;border-color:#f0ad4e}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d9534f}.btn-danger.focus,.btn-danger:focus,.btn-danger:hover{color:#fff;background-color:#c9302c;border-color:#c12e2a}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#c9302c;border-color:#c12e2a;background-image:none}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#8b211e}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger:disabled.focus,.btn-danger:disabled:focus,.btn-danger:disabled:hover{background-color:#d9534f;border-color:#d9534f}.btn-outline-primary{color:#0275d8;background-image:none;background-color:transparent;border-color:#0275d8}.btn-outline-primary.active,.btn-outline-primary.focus,.btn-outline-primary:active,.btn-outline-primary:focus,.btn-outline-primary:hover,.open>.btn-outline-primary.dropdown-toggle{color:#fff;background-color:#0275d8;border-color:#0275d8}.btn-outline-primary.active.focus,.btn-outline-primary.active:focus,.btn-outline-primary.active:hover,.btn-outline-primary:active.focus,.btn-outline-primary:active:focus,.btn-outline-primary:active:hover,.open>.btn-outline-primary.dropdown-toggle.focus,.open>.btn-outline-primary.dropdown-toggle:focus,.open>.btn-outline-primary.dropdown-toggle:hover{color:#fff;background-color:#014682;border-color:#01315a}.btn-outline-primary.disabled.focus,.btn-outline-primary.disabled:focus,.btn-outline-primary.disabled:hover,.btn-outline-primary:disabled.focus,.btn-outline-primary:disabled:focus,.btn-outline-primary:disabled:hover{border-color:#43a7fd}.btn-outline-secondary{color:#ccc;background-image:none;background-color:transparent;border-color:#ccc}.btn-outline-secondary.active,.btn-outline-secondary.focus,.btn-outline-secondary:active,.btn-outline-secondary:focus,.btn-outline-secondary:hover,.open>.btn-outline-secondary.dropdown-toggle{color:#fff;background-color:#ccc;border-color:#ccc}.btn-outline-secondary.active.focus,.btn-outline-secondary.active:focus,.btn-outline-secondary.active:hover,.btn-outline-secondary:active.focus,.btn-outline-secondary:active:focus,.btn-outline-secondary:active:hover,.open>.btn-outline-secondary.dropdown-toggle.focus,.open>.btn-outline-secondary.dropdown-toggle:focus,.open>.btn-outline-secondary.dropdown-toggle:hover{color:#fff;background-color:#a1a1a1;border-color:#8c8c8c}.btn-outline-secondary.disabled.focus,.btn-outline-secondary.disabled:focus,.btn-outline-secondary.disabled:hover,.btn-outline-secondary:disabled.focus,.btn-outline-secondary:disabled:focus,.btn-outline-secondary:disabled:hover{border-color:#fff}.btn-outline-info{color:#5bc0de;background-image:none;background-color:transparent;border-color:#5bc0de}.btn-outline-info.active,.btn-outline-info.focus,.btn-outline-info:active,.btn-outline-info:focus,.btn-outline-info:hover,.open>.btn-outline-info.dropdown-toggle{color:#fff;background-color:#5bc0de;border-color:#5bc0de}.btn-outline-info.active.focus,.btn-outline-info.active:focus,.btn-outline-info.active:hover,.btn-outline-info:active.focus,.btn-outline-info:active:focus,.btn-outline-info:active:hover,.open>.btn-outline-info.dropdown-toggle.focus,.open>.btn-outline-info.dropdown-toggle:focus,.open>.btn-outline-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1f7e9a}.btn-outline-info.disabled.focus,.btn-outline-info.disabled:focus,.btn-outline-info.disabled:hover,.btn-outline-info:disabled.focus,.btn-outline-info:disabled:focus,.btn-outline-info:disabled:hover{border-color:#b0e1ef}.btn-outline-success{color:#5cb85c;background-image:none;background-color:transparent;border-color:#5cb85c}.btn-outline-success.active,.btn-outline-success.focus,.btn-outline-success:active,.btn-outline-success:focus,.btn-outline-success:hover,.open>.btn-outline-success.dropdown-toggle{color:#fff;background-color:#5cb85c;border-color:#5cb85c}.btn-outline-success.active.focus,.btn-outline-success.active:focus,.btn-outline-success.active:hover,.btn-outline-success:active.focus,.btn-outline-success:active:focus,.btn-outline-success:active:hover,.open>.btn-outline-success.dropdown-toggle.focus,.open>.btn-outline-success.dropdown-toggle:focus,.open>.btn-outline-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#2d672d}.btn-outline-success.disabled.focus,.btn-outline-success.disabled:focus,.btn-outline-success.disabled:hover,.btn-outline-success:disabled.focus,.btn-outline-success:disabled:focus,.btn-outline-success:disabled:hover{border-color:#a3d7a3}.btn-outline-warning{color:#f0ad4e;background-image:none;background-color:transparent;border-color:#f0ad4e}.btn-outline-warning.active,.btn-outline-warning.focus,.btn-outline-warning:active,.btn-outline-warning:focus,.btn-outline-warning:hover,.open>.btn-outline-warning.dropdown-toggle{color:#fff;background-color:#f0ad4e;border-color:#f0ad4e}.btn-outline-warning.active.focus,.btn-outline-warning.active:focus,.btn-outline-warning.active:hover,.btn-outline-warning:active.focus,.btn-outline-warning:active:focus,.btn-outline-warning:active:hover,.open>.btn-outline-warning.dropdown-toggle.focus,.open>.btn-outline-warning.dropdown-toggle:focus,.open>.btn-outline-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#b06d0f}.btn-outline-warning.disabled.focus,.btn-outline-warning.disabled:focus,.btn-outline-warning.disabled:hover,.btn-outline-warning:disabled.focus,.btn-outline-warning:disabled:focus,.btn-outline-warning:disabled:hover{border-color:#f8d9ac}.btn-outline-danger{color:#d9534f;background-image:none;background-color:transparent;border-color:#d9534f}.btn-outline-danger.active,.btn-outline-danger.focus,.btn-outline-danger:active,.btn-outline-danger:focus,.btn-outline-danger:hover,.open>.btn-outline-danger.dropdown-toggle{color:#fff;background-color:#d9534f;border-color:#d9534f}.btn-outline-danger.active.focus,.btn-outline-danger.active:focus,.btn-outline-danger.active:hover,.btn-outline-danger:active.focus,.btn-outline-danger:active:focus,.btn-outline-danger:active:hover,.open>.btn-outline-danger.dropdown-toggle.focus,.open>.btn-outline-danger.dropdown-toggle:focus,.open>.btn-outline-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#8b211e}.btn-outline-danger.disabled.focus,.btn-outline-danger.disabled:focus,.btn-outline-danger.disabled:hover,.btn-outline-danger:disabled.focus,.btn-outline-danger:disabled:focus,.btn-outline-danger:disabled:hover{border-color:#eba5a3}.btn-link{font-weight:400;color:#0275d8;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link:disabled{background-color:transparent}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#014c8c;text-decoration:underline;background-color:transparent}.btn-link:disabled:focus,.btn-link:disabled:hover{color:#818a91;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:.75rem 1.5rem;font-size:1.25rem;border-radius:.3rem}.btn-group-sm>.btn,.btn-sm{padding:.25rem .5rem;font-size:.875rem;border-radius:.2rem}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:.5rem}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}/*!\n * ui-select\n * http://github.com/angular-ui/ui-select\n * Version: 0.19.8 - 2017-04-18T05:43:43.881Z\n * License: MIT\n */.ui-select-highlight{font-weight:700}.ui-select-offscreen{clip:rect(0 0 0 0)!important;width:1px!important;height:1px!important;border:0!important;margin:0!important;padding:0!important;overflow:hidden!important;position:absolute!important;outline:0!important;left:0!important;top:0!important}.ui-select-choices-row:hover{background-color:#f5f5f5}.ng-dirty.ng-invalid>a.select2-choice{border-color:#d44950}.select2-result-single{padding-left:0}.select2-locked>.select2-search-choice-close,.select-locked>.ui-select-match-close{display:none}body>.select2-container.open{z-index:9999}.ui-select-container.select2.direction-up .ui-select-match,.ui-select-container[theme=select2].direction-up .ui-select-match{border-radius:4px;border-top-left-radius:0;border-top-right-radius:0}.ui-select-container.select2.direction-up .ui-select-dropdown,.ui-select-container[theme=select2].direction-up .ui-select-dropdown{border-radius:4px;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-width:1px;border-top-style:solid;box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-4px}.ui-select-container.select2.direction-up .ui-select-dropdown .select2-search,.ui-select-container[theme=select2].direction-up .ui-select-dropdown .select2-search{margin-top:4px}.ui-select-container.select2.direction-up.select2-dropdown-open .ui-select-match,.ui-select-container[theme=select2].direction-up.select2-dropdown-open .ui-select-match{border-bottom-color:#5897fb}.ui-select-container[theme=select2] .ui-select-dropdown .ui-select-search-hidden,.ui-select-container[theme=select2] .ui-select-dropdown .ui-select-search-hidden input{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0}.selectize-input.selectize-focus{border-color:#007fbb!important}.selectize-control.single>.selectize-input>input{width:100%}.selectize-control.multi>.selectize-input>input{margin:0!important}.selectize-control>.selectize-dropdown{width:100%}.ng-dirty.ng-invalid>div.selectize-input{border-color:#d44950}.ui-select-container[theme=selectize].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25);margin-top:-2px}.ui-select-container[theme=selectize] input.ui-select-search-hidden{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0;width:0}.btn-default-focus{color:#333;background-color:#ebebeb;border-color:#adadad;text-decoration:none;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.ui-select-bootstrap .ui-select-toggle{position:relative}.ui-select-bootstrap .ui-select-toggle>.caret{position:absolute;height:10px;top:50%;right:10px;margin-top:-2px}.input-group>.ui-select-bootstrap.dropdown{position:static}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control{border-radius:4px;border-top-right-radius:0;border-bottom-right-radius:0}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control.direction-up{border-radius:4px!important;border-top-right-radius:0!important;border-bottom-right-radius:0!important}.ui-select-bootstrap .ui-select-search-hidden{opacity:0;height:0;min-height:0;padding:0;margin:0;border:0}.ui-select-bootstrap>.ui-select-match>.btn{text-align:left!important}.ui-select-bootstrap>.ui-select-match>.caret{position:absolute;top:45%;right:15px}.ui-select-bootstrap>.ui-select-choices,.ui-select-bootstrap>.ui-select-no-choice{width:100%;height:auto;max-height:200px;overflow-x:hidden;margin-top:-1px}body>.ui-select-bootstrap.open{z-index:1000}.ui-select-multiple.ui-select-bootstrap{height:auto;padding:3px 3px 0}.ui-select-multiple.ui-select-bootstrap input.ui-select-search{background-color:transparent!important;border:none;outline:none;height:1.666666em;margin-bottom:3px}.ui-select-multiple.ui-select-bootstrap .ui-select-match .close{font-size:1.6em;line-height:.75}.ui-select-multiple.ui-select-bootstrap .ui-select-match-item{outline:0;margin:0 3px 3px 0}.ui-select-multiple .ui-select-match-item{position:relative}.ui-select-multiple .ui-select-match-item.dropping .ui-select-match-close{pointer-events:none}.ui-select-multiple:hover .ui-select-match-item.dropping-before:before{content:\"\";position:absolute;top:0;right:100%;height:100%;margin-right:2px;border-left:1px solid #428bca}.ui-select-multiple:hover .ui-select-match-item.dropping-after:after{content:\"\";position:absolute;top:0;left:100%;height:100%;margin-left:2px;border-right:1px solid #428bca}.ui-select-bootstrap .ui-select-choices-row>span{cursor:pointer;display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.ui-select-bootstrap .ui-select-choices-row>span:focus,.ui-select-bootstrap .ui-select-choices-row>span:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.ui-select-bootstrap .ui-select-choices-row.active>span{color:#fff;text-decoration:none;outline:0;background-color:#428bca}.ui-select-bootstrap .ui-select-choices-row.active.disabled>span,.ui-select-bootstrap .ui-select-choices-row.disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.ui-select-match.ng-hide-add,.ui-select-search.ng-hide-add{display:none!important}.ui-select-bootstrap.ng-dirty.ng-invalid>button.btn.ui-select-match{border-color:#d44950}.ui-select-container[theme=bootstrap].direction-up .ui-select-dropdown{box-shadow:0 -4px 8px rgba(0,0,0,.25)}.ui-select-bootstrap .ui-select-match-text{width:100%;padding-right:1em}.ui-select-bootstrap .ui-select-match-text span{display:inline-block;width:100%;overflow:hidden}.ui-select-bootstrap .ui-select-toggle>a.btn{position:absolute;height:10px;right:10px;margin-top:-2px}.ui-select-refreshing.glyphicon{position:absolute;right:0;padding:8px 27px}@keyframes ui-select-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.ui-select-spin{animation:ui-select-spin 2s infinite linear}.ui-select-refreshing.ng-animate{-webkit-animation:none 0s}.b-r-#fff{border-right-color:#fff}/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}.ui-grid,.ui-grid-cell,.ui-grid-footer-panel,.ui-grid-header,.ui-grid-header-cell,input[type=text].ui-grid-filter-input{border-color:hsla(210,4%,55%,.15)}.card .ui-grid{border-width:0;border-top-width:1px}.ui-grid-row:nth-child(2n) .ui-grid-cell{background-color:rgba(0,0,0,.025);border-bottom:1px solid hsla(210,4%,55%,.15);border-top:1px solid hsla(210,4%,55%,.15)}.ui-grid-row:nth-child(odd) .ui-grid-cell{background-color:transparent}.ui-grid-header-cell:not(:last-child) .ui-grid-vertical-bar{background-color:rgba(0,0,0,.025)}.ui-grid-footer-panel,.ui-grid-top-panel,input[type=text].ui-grid-filter-input{background:transparent}.ui-grid-cell,.ui-grid-row{min-height:36px}.ui-grid-cell-contents{padding:8px 15px}.ui-grid-column-menu-button{top:5px}.ui-grid-canvas,.ui-grid-header-canvas{width:100%!important}.ui-grid-menu .ui-grid-menu-inner{color:#333}/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\n\nCopyright (c) 2015 Daniel Eden\n*/.animated{animation-duration:1s;animation-fill-mode:both}.animated.infinite{animation-iteration-count:infinite}.animated.hinge{animation-duration:2s}.animated.bounceIn,.animated.bounceOut,.animated.flipOutX,.animated.flipOutY{animation-duration:.75s}@keyframes bounce{0%,20%,53%,80%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1);transform:translateZ(0)}40%,43%{transition-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-30px,0)}70%{transition-timing-function:cubic-bezier(.755,.05,.855,.06);transform:translate3d(0,-15px,0)}90%{transform:translate3d(0,-4px,0)}}.bounce{animation-name:bounce;transform-origin:center bottom}@keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.flash{animation-name:flash}@keyframes pulse{0%{transform:scaleX(1)}50%{transform:scale3d(1.05,1.05,1.05)}to{transform:scaleX(1)}}.pulse{animation-name:pulse}@keyframes rubberBand{0%{transform:scaleX(1)}30%{transform:scale3d(1.25,.75,1)}40%{transform:scale3d(.75,1.25,1)}50%{transform:scale3d(1.15,.85,1)}65%{transform:scale3d(.95,1.05,1)}75%{transform:scale3d(1.05,.95,1)}to{transform:scaleX(1)}}.rubberBand{animation-name:rubberBand}@keyframes shake{0%,to{transform:translateZ(0)}10%,30%,50%,70%,90%{transform:translate3d(-10px,0,0)}20%,40%,60%,80%{transform:translate3d(10px,0,0)}}.shake{animation-name:shake}@keyframes swing{20%{transform:rotate(15deg)}40%{transform:rotate(-10deg)}60%{transform:rotate(5deg)}80%{transform:rotate(-5deg)}to{transform:rotate(0deg)}}.swing{transform-origin:top center;animation-name:swing}@keyframes tada{0%{transform:scaleX(1)}10%,20%{transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{transform:scaleX(1)}}.tada{animation-name:tada}@keyframes wobble{0%{transform:none}15%{transform:translate3d(-25%,0,0) rotate(-5deg)}30%{transform:translate3d(20%,0,0) rotate(3deg)}45%{transform:translate3d(-15%,0,0) rotate(-3deg)}60%{transform:translate3d(10%,0,0) rotate(2deg)}75%{transform:translate3d(-5%,0,0) rotate(-1deg)}to{transform:none}}.wobble{animation-name:wobble}@keyframes bounceIn{0%,20%,40%,60%,80%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:scale3d(.3,.3,.3)}20%{transform:scale3d(1.1,1.1,1.1)}40%{transform:scale3d(.9,.9,.9)}60%{opacity:1;transform:scale3d(1.03,1.03,1.03)}80%{transform:scale3d(.97,.97,.97)}to{opacity:1;transform:scaleX(1)}}.bounceIn{animation-name:bounceIn}@keyframes bounceInDown{0%,60%,75%,90%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,-3000px,0)}60%{opacity:1;transform:translate3d(0,25px,0)}75%{transform:translate3d(0,-10px,0)}90%{transform:translate3d(0,5px,0)}to{transform:none}}.bounceInDown{animation-name:bounceInDown}@keyframes bounceInLeft{0%,60%,75%,90%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(-3000px,0,0)}60%{opacity:1;transform:translate3d(25px,0,0)}75%{transform:translate3d(-10px,0,0)}90%{transform:translate3d(5px,0,0)}to{transform:none}}.bounceInLeft{animation-name:bounceInLeft}@keyframes bounceInRight{0%,60%,75%,90%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(3000px,0,0)}60%{opacity:1;transform:translate3d(-25px,0,0)}75%{transform:translate3d(10px,0,0)}90%{transform:translate3d(-5px,0,0)}to{transform:none}}.bounceInRight{animation-name:bounceInRight}@keyframes bounceInUp{0%,60%,75%,90%,to{transition-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;transform:translate3d(0,3000px,0)}60%{opacity:1;transform:translate3d(0,-20px,0)}75%{transform:translate3d(0,10px,0)}90%{transform:translate3d(0,-5px,0)}to{transform:translateZ(0)}}.bounceInUp{animation-name:bounceInUp}@keyframes bounceOut{20%{transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;transform:scale3d(1.1,1.1,1.1)}to{opacity:0;transform:scale3d(.3,.3,.3)}}.bounceOut{animation-name:bounceOut}@keyframes bounceOutDown{20%{transform:translate3d(0,10px,0)}40%,45%{opacity:1;transform:translate3d(0,-20px,0)}to{opacity:0;transform:translate3d(0,2000px,0)}}.bounceOutDown{animation-name:bounceOutDown}@keyframes bounceOutLeft{20%{opacity:1;transform:translate3d(20px,0,0)}to{opacity:0;transform:translate3d(-2000px,0,0)}}.bounceOutLeft{animation-name:bounceOutLeft}@keyframes bounceOutRight{20%{opacity:1;transform:translate3d(-20px,0,0)}to{opacity:0;transform:translate3d(2000px,0,0)}}.bounceOutRight{animation-name:bounceOutRight}@keyframes bounceOutUp{20%{transform:translate3d(0,-10px,0)}40%,45%{opacity:1;transform:translate3d(0,20px,0)}to{opacity:0;transform:translate3d(0,-2000px,0)}}.bounceOutUp{animation-name:bounceOutUp}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{animation-name:fadeIn}@keyframes fadeInDown{0%{opacity:0;transform:translate3d(0,-100%,0)}to{opacity:1;transform:none}}.fadeInDown{animation-name:fadeInDown}@keyframes fadeInDownBig{0%{opacity:0;transform:translate3d(0,-2000px,0)}to{opacity:1;transform:none}}.fadeInDownBig{animation-name:fadeInDownBig}@keyframes fadeInLeft{0%{opacity:0;transform:translate3d(-100%,0,0)}to{opacity:1;transform:none}}.fadeInLeft{animation-name:fadeInLeft}@keyframes fadeInLeftBig{0%{opacity:0;transform:translate3d(-2000px,0,0)}to{opacity:1;transform:none}}.fadeInLeftBig{animation-name:fadeInLeftBig}@keyframes fadeInRight{0%{opacity:0;transform:translate3d(100%,0,0)}to{opacity:1;transform:none}}.fadeInRight{animation-name:fadeInRight}@keyframes fadeInRightBig{0%{opacity:0;transform:translate3d(2000px,0,0)}to{opacity:1;transform:none}}.fadeInRightBig{animation-name:fadeInRightBig}@keyframes fadeInUp{0%{opacity:0;transform:translate3d(0,100%,0)}to{opacity:1;transform:none}}.fadeInUp{animation-name:fadeInUp}@keyframes fadeInUpBig{0%{opacity:0;transform:translate3d(0,2000px,0)}to{opacity:1;transform:none}}.fadeInUpBig{animation-name:fadeInUpBig}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{animation-name:fadeOut}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;transform:translate3d(0,100%,0)}}.fadeOutDown{animation-name:fadeOutDown}@keyframes fadeOutDownBig{0%{opacity:1}to{opacity:0;transform:translate3d(0,2000px,0)}}.fadeOutDownBig{animation-name:fadeOutDownBig}@keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;transform:translate3d(-100%,0,0)}}.fadeOutLeft{animation-name:fadeOutLeft}@keyframes fadeOutLeftBig{0%{opacity:1}to{opacity:0;transform:translate3d(-2000px,0,0)}}.fadeOutLeftBig{animation-name:fadeOutLeftBig}@keyframes fadeOutRight{0%{opacity:1}to{opacity:0;transform:translate3d(100%,0,0)}}.fadeOutRight{animation-name:fadeOutRight}@keyframes fadeOutRightBig{0%{opacity:1}to{opacity:0;transform:translate3d(2000px,0,0)}}.fadeOutRightBig{animation-name:fadeOutRightBig}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;transform:translate3d(0,-100%,0)}}.fadeOutUp{animation-name:fadeOutUp}@keyframes fadeOutUpBig{0%{opacity:1}to{opacity:0;transform:translate3d(0,-2000px,0)}}.fadeOutUpBig{animation-name:fadeOutUpBig}@keyframes flip{0%{transform:perspective(400px) rotateY(-1turn);animation-timing-function:ease-out}40%{transform:perspective(400px) translateZ(150px) rotateY(-190deg);animation-timing-function:ease-out}50%{transform:perspective(400px) translateZ(150px) rotateY(-170deg);animation-timing-function:ease-in}80%{transform:perspective(400px) scale3d(.95,.95,.95);animation-timing-function:ease-in}to{transform:perspective(400px);animation-timing-function:ease-in}}.animated.flip{-webkit-backface-visibility:visible;backface-visibility:visible;animation-name:flip}@keyframes flipInX{0%{transform:perspective(400px) rotateX(90deg);transition-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateX(-20deg);transition-timing-function:ease-in}60%{transform:perspective(400px) rotateX(10deg);opacity:1}80%{transform:perspective(400px) rotateX(-5deg)}to{transform:perspective(400px)}}.flipInX{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;animation-name:flipInX}@keyframes flipInY{0%{transform:perspective(400px) rotateY(90deg);transition-timing-function:ease-in;opacity:0}40%{transform:perspective(400px) rotateY(-20deg);transition-timing-function:ease-in}60%{transform:perspective(400px) rotateY(10deg);opacity:1}80%{transform:perspective(400px) rotateY(-5deg)}to{transform:perspective(400px)}}.flipInY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;animation-name:flipInY}@keyframes flipOutX{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateX(-20deg);opacity:1}to{transform:perspective(400px) rotateX(90deg);opacity:0}}.flipOutX{animation-name:flipOutX;-webkit-backface-visibility:visible!important;backface-visibility:visible!important}@keyframes flipOutY{0%{transform:perspective(400px)}30%{transform:perspective(400px) rotateY(-15deg);opacity:1}to{transform:perspective(400px) rotateY(90deg);opacity:0}}.flipOutY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;animation-name:flipOutY}@keyframes lightSpeedIn{0%{transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{transform:skewX(20deg);opacity:1}80%{transform:skewX(-5deg);opacity:1}to{transform:none;opacity:1}}.lightSpeedIn{animation-name:lightSpeedIn;animation-timing-function:ease-out}@keyframes lightSpeedOut{0%{opacity:1}to{transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}.lightSpeedOut{animation-name:lightSpeedOut;animation-timing-function:ease-in}@keyframes rotateIn{0%{transform-origin:center;transform:rotate(-200deg);opacity:0}to{transform-origin:center;transform:none;opacity:1}}.rotateIn{animation-name:rotateIn}@keyframes rotateInDownLeft{0%{transform-origin:left bottom;transform:rotate(-45deg);opacity:0}to{transform-origin:left bottom;transform:none;opacity:1}}.rotateInDownLeft{animation-name:rotateInDownLeft}@keyframes rotateInDownRight{0%{transform-origin:right bottom;transform:rotate(45deg);opacity:0}to{transform-origin:right bottom;transform:none;opacity:1}}.rotateInDownRight{animation-name:rotateInDownRight}@keyframes rotateInUpLeft{0%{transform-origin:left bottom;transform:rotate(45deg);opacity:0}to{transform-origin:left bottom;transform:none;opacity:1}}.rotateInUpLeft{animation-name:rotateInUpLeft}@keyframes rotateInUpRight{0%{transform-origin:right bottom;transform:rotate(-90deg);opacity:0}to{transform-origin:right bottom;transform:none;opacity:1}}.rotateInUpRight{animation-name:rotateInUpRight}@keyframes rotateOut{0%{transform-origin:center;opacity:1}to{transform-origin:center;transform:rotate(200deg);opacity:0}}.rotateOut{animation-name:rotateOut}@keyframes rotateOutDownLeft{0%{transform-origin:left bottom;opacity:1}to{transform-origin:left bottom;transform:rotate(45deg);opacity:0}}.rotateOutDownLeft{animation-name:rotateOutDownLeft}@keyframes rotateOutDownRight{0%{transform-origin:right bottom;opacity:1}to{transform-origin:right bottom;transform:rotate(-45deg);opacity:0}}.rotateOutDownRight{animation-name:rotateOutDownRight}@keyframes rotateOutUpLeft{0%{transform-origin:left bottom;opacity:1}to{transform-origin:left bottom;transform:rotate(-45deg);opacity:0}}.rotateOutUpLeft{animation-name:rotateOutUpLeft}@keyframes rotateOutUpRight{0%{transform-origin:right bottom;opacity:1}to{transform-origin:right bottom;transform:rotate(90deg);opacity:0}}.rotateOutUpRight{animation-name:rotateOutUpRight}@keyframes hinge{0%{transform-origin:top left;animation-timing-function:ease-in-out}20%,60%{transform:rotate(80deg);transform-origin:top left;animation-timing-function:ease-in-out}40%,80%{transform:rotate(60deg);transform-origin:top left;animation-timing-function:ease-in-out;opacity:1}to{transform:translate3d(0,700px,0);opacity:0}}.hinge{animation-name:hinge}@keyframes rollIn{0%{opacity:0;transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;transform:none}}.rollIn{animation-name:rollIn}@keyframes rollOut{0%{opacity:1}to{opacity:0;transform:translate3d(100%,0,0) rotate(120deg)}}.rollOut{animation-name:rollOut}@keyframes zoomIn{0%{opacity:0;transform:scale3d(.3,.3,.3)}50%{opacity:1}}.zoomIn{animation-name:zoomIn}@keyframes zoomInDown{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInDown{animation-name:zoomInDown}@keyframes zoomInLeft{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInLeft{animation-name:zoomInLeft}@keyframes zoomInRight{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInRight{animation-name:zoomInRight}@keyframes zoomInUp{0%{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInUp{animation-name:zoomInUp}@keyframes zoomOut{0%{opacity:1}50%{opacity:0;transform:scale3d(.3,.3,.3)}to{opacity:0}}.zoomOut{animation-name:zoomOut}@keyframes zoomOutDown{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutDown{animation-name:zoomOutDown}@keyframes zoomOutLeft{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;transform:scale(.1) translate3d(-2000px,0,0);transform-origin:left center}}.zoomOutLeft{animation-name:zoomOutLeft}@keyframes zoomOutRight{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;transform:scale(.1) translate3d(2000px,0,0);transform-origin:right center}}.zoomOutRight{animation-name:zoomOutRight}@keyframes zoomOutUp{40%{opacity:1;transform:scale3d(.475,.475,.475) translate3d(0,60px,0);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform-origin:center bottom;animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutUp{animation-name:zoomOutUp}@keyframes slideInDown{0%{transform:translate3d(0,-100%,0);visibility:visible}to{transform:translateZ(0)}}.slideInDown{animation-name:slideInDown}@keyframes slideInLeft{0%{transform:translate3d(-100%,0,0);visibility:visible}to{transform:translateZ(0)}}.slideInLeft{animation-name:slideInLeft}@keyframes slideInRight{0%{transform:translate3d(100%,0,0);visibility:visible}to{transform:translateZ(0)}}.slideInRight{animation-name:slideInRight}@keyframes slideInUp{0%{transform:translate3d(0,100%,0);visibility:visible}to{transform:translateZ(0)}}.slideInUp{animation-name:slideInUp}@keyframes slideOutDown{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,100%,0)}}.slideOutDown{animation-name:slideOutDown}@keyframes slideOutLeft{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(-100%,0,0)}}.slideOutLeft{animation-name:slideOutLeft}@keyframes slideOutRight{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(100%,0,0)}}.slideOutRight{animation-name:slideOutRight}@keyframes slideOutUp{0%{transform:translateZ(0)}to{visibility:hidden;transform:translate3d(0,-100%,0)}}.slideOutUp{animation-name:slideOutUp}html{background-color:#e0e0e0}body{color:rgba(0,0,0,.87);font-size:.875rem;background-color:#f0f0f0;-webkit-font-smoothing:antialiased}:focus{outline:0!important}a{cursor:pointer;outline:0}a,a:focus,a:hover{color:inherit;text-decoration:none}button,pre{color:inherit}pre{background-color:#f8f8f8}blockquote,pre{border-color:hsla(210,8%,51%,.13)}small{font-size:90%}sup{position:relative;top:-1em;font-size:75%}.pull-center{position:absolute;left:50%}.close{font-size:1.3rem}.img-responsive{width:100%;height:auto}.text-center{text-align:center}.text-left{text-align:left}.text-right{text-align:right}.pull-left{float:left}.pull-right{float:right}.center-block{margin:0 auto}@media (max-width:767px){.pull-none-sm{float:none!important}}@media (max-width:543px){.pull-none-xs{float:none!important}}.label{display:inline-block;padding:.25em .5em;font-size:75%;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;font-weight:700;background-color:#b8b8b8;color:#fff;border-radius:.2rem}.label.no-bg{background-color:transparent;color:inherit}.label.up{position:relative;top:-10px;min-width:4px;min-height:4px;display:inline-block}.label-lg{font-size:1.33rem;padding:5px 9px}.label-sm{padding:.15em .35em}.label-xs{padding:.1em .25em}.list-group-item.active>.label,.nav-pills>.active>a>.label{color:rgba(0,0,0,.87)}.btn .label{position:relative;top:-1px}.btn{font-weight:500;outline:0!important}.btn:not([disabled]).active,.btn:not([disabled]):focus,.btn:not([disabled]):hover{box-shadow:inset 0 -10rem 0 hsla(0,0%,62%,.2)}.btn>i.pull-left,.btn>i.pull-right{line-height:1.5}.btn.rounded{padding-left:1.2em;padding-right:1.2em}.btn-md{padding:.4695rem .75rem;font-size:.9rem}.btn-xs{padding:.2195rem .5rem;font-size:.8rem}.btn-outline{border-width:1px;background-color:transparent;box-shadow:none!important}.btn.b-primary:focus,.btn.b-primary:hover,.btn.primary:focus,.btn.primary:hover{color:hsla(0,0%,100%,.87)!important;background-color:#0cc2aa}.btn.accent:focus,.btn.accent:hover,.btn.b-accent:focus,.btn.b-accent:hover{color:hsla(0,0%,100%,.87)!important;background-color:#a88add}.btn.b-warn:focus,.btn.b-warn:hover,.btn.warn:focus,.btn.warn:hover{color:hsla(0,0%,100%,.87)!important;background-color:#fcc100}.btn.b-success:focus,.btn.b-success:hover,.btn.success:focus,.btn.success:hover{color:hsla(0,0%,100%,.87)!important;background-color:#6cc788}.btn.b-info:focus,.btn.b-info:hover,.btn.info:focus,.btn.info:hover{color:hsla(0,0%,100%,.87)!important;background-color:#6887ff}.btn.b-warning:focus,.btn.b-warning:hover,.btn.warning:focus,.btn.warning:hover{color:hsla(0,0%,100%,.87)!important;background-color:#f77a99}.btn.b-danger:focus,.btn.b-danger:hover,.btn.danger:focus,.btn.danger:hover{color:hsla(0,0%,100%,.87)!important;background-color:#f44455}.btn.b-dark:focus,.btn.b-dark:hover,.btn.dark:focus,.btn.dark:hover{color:hsla(0,0%,100%,.87)!important;background-color:#2e3e4e}.btn.b-black:focus,.btn.b-black:hover,.btn.black:focus,.btn.black:hover{color:hsla(0,0%,100%,.87)!important;background-color:#2a2b3c}.btn.b-white:focus,.btn.b-white:hover{color:rgba(0,0,0,.87)!important;background-color:#fff}.btn.b-light:focus,.btn.b-light:hover{color:rgba(0,0,0,.87)!important;background-color:#f8f8f8}.btn-icon{text-align:center;padding:0!important;width:2.375rem;height:2.375rem;line-height:2.375rem;position:relative;overflow:hidden}.btn-icon i{position:absolute;top:0;width:100%;height:100%;display:block;line-height:inherit;border-radius:inherit;transition:all .3s}.btn-icon.btn-xs{width:1.5rem;height:1.5rem;line-height:1.5rem}.btn-group-sm>.btn-icon.btn,.btn-icon.btn-sm{width:1.775rem;height:1.775rem;line-height:1.775rem}.btn-group-lg>.btn-icon.btn,.btn-icon.btn-lg{width:3.167rem;height:3.167rem;line-height:3.167rem}.btn-icon.btn-social i:last-child{top:100%}.btn-icon.btn-social.active i:first-child,.btn-icon.btn-social:focus i:first-child,.btn-icon.btn-social:hover i:first-child{top:-100%}.btn-icon.btn-social.active i:last-child,.btn-icon.btn-social:focus i:last-child,.btn-icon.btn-social:hover i:last-child{top:0;color:#fff}.btn-icon.btn-social-colored i:first-child{color:#fff}.btn.btn-default,.btn.btn-secondary,.btn.white{border-color:hsla(210,8%,51%,.13)}.btn-default{background-color:#fff;color:rgba(0,0,0,.87)}.btn-groups .btn{margin-bottom:.25rem}.btn-fw{min-width:7rem}.card{border-color:hsla(210,8%,51%,.13)}.carousel-control .glyphicon{position:absolute;top:50%;left:50%;z-index:5;display:inline-block;margin-top:-10px;margin-left:-10px}.dropdown-menu{font-size:.875rem;color:rgba(0,0,0,.87);border-radius:3px;border:1px solid rgba(0,0,0,.1);transform-origin:top left}.dropdown-menu>li:not(.dropdown-item)>a{display:block;padding:3px 20px}.dropdown-menu>li:not(.dropdown-item)>a:focus,.dropdown-menu>li:not(.dropdown-item)>a:hover{background-color:rgba(0,0,0,.065)}.dropdown-menu>.divider{height:1px;margin:.5rem 0;overflow:hidden;background-color:hsla(210,8%,51%,.13)}.dropdown-menu .active{background-color:rgba(0,0,0,.065)}.dropdown-menu.pull-left{left:auto!important;right:100%}.dropdown-menu.pull-right{left:auto;right:0;transform-origin:top right}.dropdown-menu.pull-up{top:0}.dropdown-menu.pull-down{top:100%!important;left:0!important}.dropup .dropdown-menu{transform-origin:bottom left}.dropup .dropdown-menu.pull-right{transform-origin:bottom right}.dropdown-menu.datepicker,.dropdown-menu.timepicker{padding:6px;font-size:.8rem}.dropdown-menu.datepicker .btn,.dropdown-menu.timepicker .btn{font-size:.8rem}.dropdown-menu.datepicker .btn.btn-primary,.dropdown-menu.timepicker .btn.btn-primary{background-color:#6887ff;color:#fff}.dropdown-menu.datepicker .btn:not(:hover),.dropdown-menu.timepicker .btn:not(:hover){box-shadow:0 0 1px transparent}.dropdown-item{color:inherit}.dropdown-item:focus,.dropdown-item:hover{color:inherit;background-color:rgba(0,0,0,.065)}.dropdown-divider{background-color:hsla(210,8%,51%,.13)}.dropdown-menu-scale{display:block;opacity:0;transform:scale(.8);transition:all .25s cubic-bezier(.24,.22,.015,1.56);-webkit-backface-visibility:hidden;backface-visibility:hidden;pointer-events:none}.open>.dropdown-menu-scale{opacity:1;transform:scale(1);pointer-events:auto;display:block!important}.dropdown-header{padding:8px 16px}.dropdown-submenu{position:relative}.dropdown-submenu:focus>.dropdown-menu,.dropdown-submenu:hover>.dropdown-menu{display:block}.dropdown-submenu .dropdown-menu{left:100%;top:0;margin-top:-6px;margin-left:-1px}.dropup .dropdown-submenu>.dropdown-menu{top:auto;bottom:0;margin-bottom:-6px}.popover{color:rgba(0,0,0,.87)}@media (max-width:543px){.dropdown-menu.pull-none-xs{left:0}}.form-control{border-color:hsla(210,8%,51%,.2);border-radius:0}.form-control:focus{border-color:hsla(210,8%,51%,.3)}.form-control-label{padding-top:.5rem;padding-bottom:.5rem;margin-bottom:0}.custom-select{border-color:hsla(210,8%,51%,.13)}.form-control::-webkit-input-placeholder{color:inherit;opacity:.3}.form-control::-moz-placeholder{color:inherit;opacity:.3}.form-control:-ms-input-placeholder{color:inherit;opacity:.3}.form-control-spin{position:absolute;z-index:2;right:10px;top:50%;margin-top:-7px}.input-group-addon{border-color:hsla(210,8%,51%,.2)!important;background-color:transparent;color:inherit}.form-group-stack .form-control{margin-top:-1px;position:relative;border-radius:0}.form-group-stack .form-control:active,.form-group-stack .form-control:focus{z-index:1}.form-validation .form-control.ng-dirty.ng-invalid{border-color:#f44455}.form-validation .form-control.ng-dirty.ng-valid,.form-validation .form-control.ng-dirty.ng-valid:focus{border-color:#6cc788}.form-validation .ui-checks .ng-invalid.ng-dirty+i{border-color:#f44455}.form-file{position:relative}.form-file input{position:absolute;width:100%;height:100%;opacity:0}.input-group-sm>.form-control{min-height:1.95rem}.active-checked{opacity:0}input:checked+.active-checked{opacity:1}.list-group{border-radius:3px;background:#fff}.list-group.no-radius .list-group-item{border-radius:0!important}.list-group.no-borders .list-group-item{border:none}.list-group.no-border .list-group-item{border-width:1px 0}.list-group.no-border .list-group-item:first-child{border-top-width:0}.list-group.no-border .list-group-item:last-child{border-bottom-width:0}.list-group.no-bg .list-group-item{background-color:transparent}.list-group-item,.list-group.list-group-gap{background:transparent}.list-group-item{border-color:hsla(210,8%,51%,.065);padding:12px 16px;background-clip:padding-box}.list-group-item.media{margin-top:0}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{color:inherit;background-color:rgba(0,0,0,.065);border-color:hsla(210,8%,51%,.065);border-bottom-color:hsla(210,8%,51%,.065)}.list-group-item.active:focus a,.list-group-item.active:hover a,.list-group-item.active a{color:inherit}.list-group-item:first-child{border-top-color:hsla(210,8%,51%,.13)}.list-group-item:last-child{border-bottom-color:hsla(210,8%,51%,.13)}.list-group-alt .list-group-item.active:nth-child(2n+2),.list-group-alt .list-group-item:nth-child(2n+2){background-color:rgba(0,0,0,.065)}.list-group-lg .list-group-item{padding:16px 24px}.list-group-md .list-group-item{padding-top:16px;padding-bottom:16px}.list-group-sm .list-group-item{padding:10px 12px}.list-group-gap .list-group-item{margin-bottom:5px;border-radius:3px}.list-group-gap .list-group-item:first-child{border-top-color:hsla(210,8%,51%,.065)}.list-group-gap .list-group-item:last-child{border-bottom-color:hsla(210,8%,51%,.065)}a.list-group-item{color:inherit}a.list-group-item.hover,a.list-group-item:focus,a.list-group-item:hover{color:inherit;background-color:rgba(0,0,0,.065)}.modal .left{transform:translate3d(-100%,0,0)}.modal .left,.modal .right{transition:transform .4s cubic-bezier(.25,.8,.25,1)}.modal .right{transform:translate3d(100%,0,0)}.modal .top{transform:translate3d(0,-100%,0)}.modal .bottom,.modal .top{transition:transform .4s cubic-bezier(.25,.8,.25,1)}.modal .bottom{transform:translate3d(0,100%,0)}.modal.in .bottom,.modal.in .left,.modal.in .right,.modal.in .top{transform:translateZ(0)}.modal.inactive{bottom:auto}.modal-open-aside,.modal.inactive{overflow:visible}.modal>.left{left:0;right:auto}.modal>.left,.modal>.right{position:fixed;z-index:1055;top:0;bottom:0}.modal>.right{left:auto;right:0}.modal>.top{top:0;bottom:auto}.modal>.bottom,.modal>.top{position:fixed;z-index:1055;left:0;right:0}.modal>.bottom{top:auto;bottom:0}.modal-content,.modal-footer,.modal-header{border-color:hsla(210,8%,51%,.13)}.aside,.modal-content{color:rgba(0,0,0,.87)}.aside-header,.aside-header .close{color:inherit!important;background-color:transparent!important}.aside-footer,.aside-header{border-color:hsla(210,8%,51%,.13)!important}.aside-title{font-size:1.2rem;margin:.45rem 0}.modal.animate .modal-dialog{transform:translate(0)}.modal.animate .fade-right-big{animation:fadeOutLeftBig .5s}.modal.animate .fade-left-big{animation:fadeOutRightBig .5s}.modal.animate .fade-up-big{animation:fadeOutUpBig .5s}.modal.animate .fade-down-big{animation:fadeOutDownBig .5s}.modal.animate .fade-right{animation:fadeOutLeft .5s}.modal.animate .fade-left{animation:fadeOutRight .5s}.modal.animate .fade-up{animation:fadeOutUp .5s}.modal.animate .fade-down{animation:fadeOutDown .5s}.modal.animate .flip-x{animation:flipOutX .5s}.modal.animate .flip-y{animation:flipOutY .5s}.modal.animate .zoom{animation:zoomOut .5s}.modal.animate .roll{animation:rollOut .5s}.modal.animate .bounce{animation:bounceOut .5s}.modal.animate .rotate{animation:rotateOut .5s}.modal.animate.in .fade-right-big{animation:fadeInRightBig .5s}.modal.animate.in .fade-left-big{animation:fadeInLeftBig .5s}.modal.animate.in .fade-up-big{animation:fadeInUpBig .5s}.modal.animate.in .fade-down-big{animation:fadeInDownBig .5s}.modal.animate.in .fade-right{animation:fadeInRight .5s}.modal.animate.in .fade-left{animation:fadeInLeft .5s}.modal.animate.in .fade-up{animation:fadeInUp .5s}.modal.animate.in .fade-down{animation:fadeInDown .5s}.modal.animate.in .flip-x{animation:flipInX .5s}.modal.animate.in .flip-y{animation:flipInY .5s}.modal.animate.in .zoom{animation:zoomIn .5s}.modal.animate.in .roll{animation:rollIn .5s}.modal.animate.in .bounce{animation:bounceIn .5s}.modal.animate.in .rotate{animation:rotateIn .5s}.nav,.nav-item,.nav-link{border:inherit}.nav-link{position:relative}.nav-md .nav-link{padding:.5rem 1rem}.nav-sm .nav-link{padding:.25rem .75rem}.nav-xs .nav-link{padding:.15rem .5rem;font-size:90%}.nav-rounded .nav-link{border-radius:2rem}.nav-tabs{border-bottom-width:0;position:relative;z-index:1}.nav-tabs .nav-link{background:transparent!important;color:inherit!important}.nav-tabs .nav-link.active,.nav-tabs .nav-link.active:focus,.nav-tabs .nav-link.active:hover,.nav-tabs .nav-link:focus,.nav-tabs .nav-link:hover{border-color:hsla(210,8%,51%,.13);border-bottom-color:transparent}.tab-content.tab-alt .tab-pane{display:block;height:0;overflow:hidden}.tab-content.tab-alt .tab-pane.active{height:auto;overflow:visible}.nav-justified .nav-item{display:table-cell;width:1%;float:none!important;text-align:center}.nav-lists .nav-item{border-bottom:1px solid hsla(210,8%,51%,.13);background-clip:padding-box}.nav-active-border .nav-link:before{content:\"\";position:absolute;transition:all .2s ease-in-out;left:50%;right:50%;bottom:0;border-bottom-width:3px;border-bottom-style:solid;border-bottom-color:transparent}.nav-active-border .nav-link.active:before,.nav-active-border .nav-link:focus:before,.nav-active-border .nav-link:hover:before{left:0;right:0;border-bottom-color:inherit}.nav-active-border.top .nav-link:before{bottom:auto;top:0}.nav-active-border.left .nav-link{float:none}.nav-active-border.left .nav-link:before{border-bottom-width:0;right:auto;border-left-width:3px;border-left-style:solid;border-left-color:transparent;left:0;top:50%;bottom:50%}.nav-active-border.left .nav-link.active:before,.nav-active-border.left .nav-link:focus:before,.nav-active-border.left .nav-link:hover:before{top:0;bottom:0;border-left-color:inherit}.nav-active-border.left.right .nav-link:before{left:auto;right:0}.breadcrumb{background-color:rgba(0,0,0,.065)}.breadcrumb>li+li:before{content:\"/ \"}.navbar{border:none;margin:0;padding:0 1rem;flex-shrink:0;min-height:3.5rem}.navbar .up{margin:0 -.6em}.navbar .avatar{top:-2px}.navbar-item{margin-right:1rem;margin-bottom:0}.navbar-brand,.navbar-item,.navbar-nav>.nav-item>.nav-link,.navbar-nav>.nav-link{padding:0;line-height:3.5rem;white-space:nowrap}.navbar-md{min-height:4rem}.navbar-md .navbar-brand,.navbar-md .navbar-item,.navbar-md .navbar-nav>.nav-item>.nav-link,.navbar-md .navbar-nav>.nav-link{line-height:4rem}.navbar-sm{min-height:3rem}.navbar-sm .navbar-brand,.navbar-sm .navbar-item,.navbar-sm .navbar-nav>.nav-item>.nav-link,.navbar-sm .navbar-nav>.nav-link{line-height:3rem}.navbar-brand{padding:0;font-size:20px;font-weight:700}.navbar-brand:hover{text-decoration:none}.navbar-brand img,.navbar-brand svg{max-height:24px;vertical-align:-4px;display:inline-block}.navbar-brand>span{display:inline-block;line-height:.8;margin-left:10px}.navbar-brand.md img,.navbar-brand.md svg{max-height:32px;vertical-align:-8px}.navbar-brand.lg img,.navbar-brand.lg svg{max-height:48px;vertical-align:-16px}.pull-center .navbar-brand{margin-left:-50%;float:left}.navbar .collapse.in,.navbar .collapsing{clear:left;padding-bottom:1rem}.collapse.in .navbar-nav,.collapsing .navbar-nav{float:none!important}.collapse.in .navbar-nav:not(.navbar-nav-inline) .nav-item,.collapsing .navbar-nav:not(.navbar-nav-inline) .nav-item{float:none;margin:0}.collapse.in .navbar-nav:not(.navbar-nav-inline) .nav-link,.collapsing .navbar-nav:not(.navbar-nav-inline) .nav-link{display:block;line-height:2!important}.collapse.in .navbar-form,.collapsing .navbar-form{margin:0!important;padding:.5rem 0;float:none!important}.collapse.in .nav-active-border,.collapsing .nav-active-border{border-color:transparent}.collapse.in .dropdown-menu-scale,.collapsing .dropdown-menu-scale{display:none}.pager .page-item,.pager>li>a,.pager>li>span,.pagination .page-item,.pagination>li>a,.pagination>li>span{color:inherit!important;background-color:transparent!important;border-color:hsla(210,8%,51%,.13)!important}.pager .page-item:focus,.pager .page-item:hover,.pager>li>a:focus,.pager>li>a:hover,.pager>li>span:focus,.pager>li>span:hover,.pagination .page-item:focus,.pagination .page-item:hover,.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{border-color:hsla(210,8%,51%,.13);background-color:rgba(0,0,0,.065);color:inherit}.pager .page-item.active,.pager>.active>a,.pager>.active>span,.pagination .page-item.active,.pagination>.active>a,.pagination>.active>span{color:#fff!important;background-color:#0cc2aa!important;border-color:#0cc2aa!important}.pagination>li{display:inline;list-style:none}.pagination>li>a{position:relative;float:left;padding:.5rem .75rem;margin-left:-1px;line-height:1.5;color:#0275d8;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li>a:focus,.pagination>li>a:hover{color:#014c8c;background-color:#eceeef;border-color:#ddd}.pager{padding-left:0;margin-top:1rem;margin-bottom:1rem;text-align:center;list-style:none}.pager:after{content:\"\";display:table;clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:rgba(0,0,0,.065);border:1px solid hsla(210,8%,51%,.13);border-radius:500px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:rgba(0,0,0,.065)}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{cursor:inherit;background-color:rgba(0,0,0,.065)}.pager-next>a,.pager-next>span{float:right}.pager-prev>a,.pager-prev>span{float:left}.progress[value]::-webkit-progress-bar{background-color:rgba(0,0,0,.065)}.progress{border-radius:.25rem;overflow:hidden;background-color:rgba(0,0,0,.065)}.progress-bar{display:inline-block;float:left;height:100%;border-radius:.25rem;text-align:center;background-color:#0074d9;font-size:.8em;transition:width .6s ease}.progress-xxs{height:4px}.progress-xs{height:8px}.progress-sm{height:12px;font-size:.8em}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.col-0{clear:left}.row.no-gutter{margin-left:0;margin-right:0}.row.no-gutter [class*=col-]{padding-left:0;padding-right:0}.row{margin-left:-12px;margin-right:-12px}.row [class*=col-]{padding-left:12px;padding-right:12px}.row-sm{margin-left:-8px;margin-right:-8px}.row-sm [class*=col-]{padding-left:8px;padding-right:8px}.row-xs{margin-left:-4px;margin-right:-4px}.row-xs [class*=col-]{padding-left:4px;padding-right:4px}@media (max-width:991px){.row{margin-left:-8px;margin-right:-8px}.row [class*=col-]{padding-left:8px;padding-right:8px}.row-2 [class*=col]{width:50%;float:left}.row-2 .col-0{clear:none}.row-2 li:nth-child(odd){clear:left;margin-left:0}}@media (max-width:767px){.row{margin-left:-4px;margin-right:-4px}.row [class*=col-]{padding-left:4px;padding-right:4px}}.panel .table{border-color:hsla(210,8%,51%,.045)!important}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th{padding-left:16px;padding-right:16px;border-color:hsla(210,8%,51%,.045)}.table>thead>tr>th{padding:10px 16px;border-color:hsla(210,8%,51%,.045)}.table-condensed tbody>tr>td,.table-condensed tbody>tr>th,.table-condensed tfoot>tr>td,.table-condensed tfoot>tr>th,.table-condensed thead>tr>td,.table-condensed thead>tr>th{padding:5px}.table-bordered{border-color:hsla(210,8%,51%,.045)}.table-striped>tbody>tr:nth-child(odd){background-color:rgba(0,0,0,.025);background-clip:padding-box}.table-striped>thead>th{background-color:rgba(0,0,0,.025);border-right:1px solid hsla(210,8%,51%,.045)}.table-striped>thead>th:last-child{border-right:none}.table-hover tr:hover,.table td.active,.table th.active,.table tr.active{background-color:rgba(0,0,0,.065)!important}.arrow{position:absolute;z-index:10}.arrow:after,.arrow:before{position:absolute;left:0;content:\"\";display:block;width:0;height:0;border:9px solid transparent}.arrow:after{border-width:8px}.arrow.top{top:-9px;left:50%;margin-left:-9px}.arrow.top.pull-in{top:-4px}.arrow.top:before{border-bottom-color:hsla(210,8%,51%,.13);border-top-width:0}.arrow.top:after{top:1px;left:1px;border-top-color:transparent;border-right-color:transparent;border-bottom-color:inherit;border-left-color:transparent;border-top-width:0}.arrow.right{top:50%;right:0;margin-top:-9px}.arrow.right.pull-in{right:4px}.arrow.right:before{border-left-color:hsla(210,8%,51%,.13);border-right-width:0}.arrow.right:after{top:1px;left:0;border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:inherit;border-right-width:0}.arrow.bottom{bottom:0;left:50%;margin-left:-9px}.arrow.bottom.pull-in{bottom:4px}.arrow.bottom:before{border-top-color:hsla(210,8%,51%,.13);border-bottom-width:0}.arrow.bottom:after{top:0;left:1px;border-top-color:inherit;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;border-bottom-width:0}.arrow.left{top:50%;left:-9px;margin-top:-9px}.arrow.left.pull-in{left:-4px}.arrow.left:before{border-right-color:hsla(210,8%,51%,.13);border-left-width:0}.arrow.left:after{top:1px;left:1px;border-top-color:transparent;border-right-color:inherit;border-bottom-color:transparent;border-left-color:transparent;border-left-width:0}.arrow.pull-left{left:18px}.arrow.pull-right{left:auto;right:26px}.arrow.pull-top{top:18px}.arrow.pull-bottom{top:auto;bottom:26px}.arrow.b-accent:before,.arrow.b-danger:before,.arrow.b-dark:before,.arrow.b-info:before,.arrow.b-primary:before,.arrow.b-success:before,.arrow.b-warning:before{border-color:transparent}.avatar{position:relative;display:inline-block;width:40px;line-height:1;border-radius:500px;white-space:nowrap;font-weight:700}.avatar img{border-radius:500px;width:100%}.avatar i{position:absolute;left:0;top:0;width:10px;height:10px;margin:1px;border-width:2px;border-style:solid;border-radius:100%}.avatar i.bottom,.avatar i.right{left:auto;right:0}.avatar i.bottom,.avatar i.left{top:auto;bottom:0}.avatar i.on{background-color:#6cc788}.avatar i.off{background-color:#f8f8f8}.avatar i.away{background-color:#f77a99}.avatar i.busy{background-color:#f44455}.avatar.w-32 i{margin:0}.avatar.w-48 i{margin:2px}.avatar.w-56 i{margin:3px}.avatar.w-64 i{margin:4px}.avatar.w-96 i{margin:9px}.avatar.w-128 i{margin:14px}.row-col{display:table;table-layout:fixed;border-spacing:0;width:100%;height:100%}.row-col>[class*=\" col-\"],.row-col>[class*=col-]{vertical-align:top;float:none;padding:0;position:static}.row-row{display:table-row;height:100%}.row-cell{display:table-cell;vertical-align:top}.row-body{position:relative;height:100%;width:100%}.ie .row-body{display:table-cell;overflow:auto}.ie .row-body .row-inner{overflow:visible!important}.row-inner{position:absolute;top:0;bottom:0;left:0;right:0;overflow:auto;-webkit-overflow-scrolling:touch}.v-m{vertical-align:middle!important}.v-t{vertical-align:top!important}.v-b{vertical-align:bottom!important}.v-c{display:-ms-flexbox;display:flex;align-items:center}@media (min-width:992px){.row-col>[class*=\" col-lg\"],.row-col>[class*=col-lg]{display:table-cell;height:100%}}@media (min-width:768px){.row-col>[class*=\" col-md\"],.row-col>[class*=col-md]{display:table-cell;height:100%}}@media (min-width:544px){.row-col>[class*=\" col-sm\"],.row-col>[class*=col-sm]{display:table-cell;height:100%}}.row-col>[class*=\" col-xs\"],.row-col>[class*=col-xs]{display:table-cell;height:100%}@media (max-width:543px){.row-col-xs{display:block}.row-col-xs .row-body{overflow:visible!important}.row-col-xs .row-inner{position:static}}.box,.box-color{background-color:#fff;position:relative;margin-bottom:1.5rem}.box-header{position:relative;padding:1rem}.box-header h2,.box-header h3,.box-header h4{margin:0;font-size:18px;line-height:1}.box-header h3{font-size:16px}.box-header h4{font-size:15px}.box-header small{display:block;margin-top:4px;opacity:.6}.box-body,.box-footer{padding:1rem}.box-divider{border-bottom:1px solid hsla(210,8%,51%,.13);margin:0 16px;height:0}.box-tool{position:absolute;right:16px;top:14px}.box-shadow,.box-shadow .box,.box-shadow .box-color{box-shadow:0 2px 2px rgba(0,0,0,.03),0 1px 0 rgba(0,0,0,.03)}.box-shadow-z0,.box-shadow-z0 .box,.box-shadow-z0 .box-color{box-shadow:0 0 1px rgba(0,0,0,.15)}.box-shadow-z1,.box-shadow-z1 .box,.box-shadow-z1 .box-color{box-shadow:0 1px 2px rgba(0,0,0,.1),0 -1px 0 rgba(0,0,0,.02)}.box-shadow-z2,.box-shadow-z2 .box,.box-shadow-z2 .box-color{box-shadow:0 1px 2px rgba(0,0,0,.15),0 -1px 0 rgba(0,0,0,.02)}.box-shadow-z3,.box-shadow-z3 .box,.box-shadow-z3 .box-color{box-shadow:0 2px 4px rgba(0,0,0,.1),0 -1px 0 rgba(0,0,0,.02)}.box-shadow-z4,.box-shadow-z4 .box,.box-shadow-z4 .box-color{box-shadow:0 2px 5px rgba(0,0,0,.26),0 -1px 0 rgba(0,0,0,.02)}.box-radius-1x,.box-radius-1x .box,.box-radius-1x .box-color{border-radius:2px}.box-radius-2x,.box-radius-2x .box,.box-radius-2x .box-color{border-radius:3px}.box-radius-3x,.box-radius-3x .box,.box-radius-3x .box-color{border-radius:4px}.ui-check{position:relative;padding-left:20px;cursor:pointer}.ui-check input{opacity:0;position:absolute;z-index:-1}.ui-check input:checked+i:before{left:5px;top:5px;width:6px;height:6px;background-color:#0cc2aa}.ui-check input:checked+span .active{display:inherit}.ui-check input[type=radio]+i,.ui-check input[type=radio]+i:before{border-radius:50%}.ui-check input[disabled]+i,fieldset[disabled] .ui-check input+i{border-color:hsla(210,8%,56%,.2)}.ui-check input[disabled]+i:before,fieldset[disabled] .ui-check input+i:before{background-color:hsla(210,8%,56%,.2)}.ui-check>i{width:16px;height:16px;line-height:1;box-shadow:0 0 1px hsla(210,8%,51%,.35);margin-left:-20px;margin-top:-2px;display:inline-block;vertical-align:middle;margin-right:4px;background-clip:padding-box;position:relative}.ui-check>i:before{content:\"\";position:absolute;left:50%;top:50%;width:0;height:0;background-color:transparent}.ui-check>span{margin-left:-20px}.ui-check>span .active{display:none}.ui-check.ui-check-color input:checked+i:before{background-color:#fff}.ui-check-md input:checked+i:before{left:6px;top:6px}.ui-check-md>i{width:18px;height:18px}.ui-check-lg input:checked+i:before{width:12px;height:12px;left:9px;top:9px}.ui-check-lg>i{width:30px;height:30px}[layout]{box-sizing:border-box;display:-moz-flex;display:-ms-flexbox;display:flex}[layout=column]{-ms-flex-direction:column;flex-direction:column}[layout=row]{-ms-flex-direction:row;flex-direction:row}[layout-wrap]{-ms-flex-wrap:wrap;flex-wrap:wrap}[layout-fill]{margin:0;min-height:100%;width:100%}@-moz-document url-prefix(){[layout-fill]{margin:0;width:100%;min-height:auto;height:inherit}}[flex]{box-sizing:border-box;-ms-flex:1;flex:1}[flex-no-shrink]{flex-shrink:0}html{height:100%}body{height:auto;min-height:100%;position:relative}.app-aside{position:fixed!important;z-index:1030;float:left;height:100%}.app-content{box-shadow:none}.app-content:after{content:\"\";display:table;clear:both}.app-header{position:fixed;top:0;left:0;right:0;margin:inherit;z-index:1020}.app-header~.app-body{padding-top:3.5rem}.app-header.navbar-md~.app-body{padding-top:4rem}.app-header.navbar-sm~.app-body{padding-top:3rem}.app-body-inner{padding-top:inherit!important;padding-bottom:inherit!important;position:absolute;top:0;bottom:0;overflow:auto}.app-footer{position:absolute;left:0;right:0;bottom:0;z-index:1;margin:inherit}.app-footer:not(.hide)~.app-body{padding-bottom:3.125rem}.app-fixed{overflow:hidden}.app-fixed .app{height:100%}.app-fixed .app-content{position:relative;min-height:100%}.app-fixed .app-footer{margin-left:0}@media (min-width:992px){.app-aside{opacity:1;display:block!important}.app-aside,.app-aside .scroll{width:12.5rem}.app-aside.lg:not(.folded),.app-aside.lg:not(.folded) .scroll{width:13.75rem}.app-aside.lg:not(.hide)~.app-content{margin-left:13.75rem}.app-aside.sm:not(.folded),.app-aside.sm:not(.folded) .scroll{width:11.25rem}.app-aside.sm:not(.hide)~.app-content{margin-left:11.25rem}.app-aside.folded{width:4rem}.app-aside.folded:not(.hide)~.app-content{margin-left:4rem}.app-aside.folded.md{width:5rem}.app-aside.folded.md:not(.hide)~.app-content{margin-left:5rem}.app-aside:not(.hide)~.app-content{margin-left:12.5rem}.app-aside .left{position:absolute;right:0;transform:translateZ(0)}.hide-scroll{width:auto;margin-right:-17px;overflow-y:scroll;-webkit-overflow-scrolling:touch}}@media (max-width:991px){.app-aside.modal{width:100%;position:fixed;z-index:1050}.app-aside .left{position:fixed;width:304px}}@media print{.app-aside,.app-footer,.app-header,.switcher{display:none}}.ie9 .app-aside{position:static!important}.ie9 .app-aside .left{width:inherit;position:absolute}@media (max-width:991px){.app .container,body.container{max-width:100%;padding-left:0;padding-right:0}}@media (min-width:992px){body.container{box-shadow:0 1px 1px rgba(0,0,0,.1)}body.container,body.container .container{padding-left:0;padding-right:0}body.container .app-aside{left:inherit;right:auto}body.container .app-aside.lg~.app-content .app-header{width:45rem}body.container .app-aside.sm~.app-content .app-header{width:47.5rem}body.container .app-aside.folded~.app-content .app-header{width:54.75rem}body.container .app-aside.folded.md~.app-content .app-header{width:53.75rem}body.container .app-aside~.app-content .app-header{width:46.25rem}body.container .app-header{left:inherit;right:auto;margin-left:0;width:58.75rem}}@media (min-width:1200px){body.container .app-aside.lg~.app-content .app-header{width:57.5rem}body.container .app-aside.sm~.app-content .app-header{width:60rem}body.container .app-aside.folded~.app-content .app-header{width:67.25rem}body.container .app-aside.folded.md~.app-content .app-header{width:66.25rem}body.container .app-aside~.app-content .app-header{width:58.75rem}body.container .app-header{width:71.25rem}}.list{padding-left:0;padding-right:0;border-radius:3px}.list.no-border{padding-top:8px;padding-bottom:8px}.list-item{display:block;position:relative;padding:12px 16px}.list-item:after{content:\"\";display:table;clear:both}.list-item:last-child .list-body:after{border:none}.no-border .list-item{padding-top:8px;padding-bottom:8px}.no-padding .list-item{padding-left:0;padding-right:0}.list-left{float:left;padding-right:1rem}.list-left+.list-body{margin-left:56px}.list-body h3{font-size:16px;margin:0 0 3px;font-weight:400}.list-body:after{content:\"\";position:absolute;left:0;right:0;bottom:0;border-bottom:1px solid hsla(210,8%,51%,.065)}.inset .list-body:after{left:72px}.no-border .list-body:after{display:none}.pace{-webkit-pointer-events:none;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.pace-inactive{display:none}.pace .pace-progress{background:#0cc2aa;position:fixed;z-index:2000;top:0;right:100%;width:100%;height:2px}.pace .pace-activity{display:block;position:fixed;z-index:2000;top:5px;right:5px;width:14px;height:14px;border:2px solid transparent;border-top-color:#0cc2aa;border-left-color:#0cc2aa;border-radius:10px;animation:loading-bar-spinner .4s linear infinite}@keyframes loading-bar-spinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.navside{border:inherit}.navside ul{padding-left:0;padding-right:0;list-style:none}.navside [flex]{overflow:auto}.navside .nav{border:inherit}.navside .nav li{border:inherit;position:relative}.navside .nav li li a{line-height:2rem;padding-left:3.5rem}.navside .nav li li a .nav-text{padding:.4375rem 0}.navside .nav li li li a{padding-left:4.5rem}.navside .nav li li li li a{padding-left:5.5rem}.navside .nav li a{display:block;padding:0 1rem;line-height:2.25rem;position:relative}.navside .nav li a:after{content:\"\";display:table;clear:both}.navside .nav li.active,.navside .nav li a:focus,.navside .nav li a:hover{background-color:rgba(0,0,0,.065)}.navside .nav li.active>a{background-color:transparent}.navside .nav li.active>a .nav-caret i{transform:rotate(180deg)}.navside .nav-header{padding:0 1rem;line-height:2.25rem}.navside .nav-header:focus,.navside .nav-header:hover{background-color:transparent!important}.navside .nav-header:after{display:none}.navside .navbar-brand{float:none;margin-right:0}.nav-fold{padding:.75rem 1rem}.nav-text{display:block;line-height:1.125rem;padding:.5625rem 0}.nav>li>a .nav-text{font-weight:500}.nav-text small,.nav-text span{display:block}.navside .nav-text{opacity:.75}.navside .active>a>.nav-text,.navside a:focus>.nav-text,.navside a:hover>.nav-text{opacity:1}.navbar .nav-text{line-height:1;vertical-align:middle;display:inline-block;padding:0}.navbar .nav-text span.text-xs{margin-top:.25rem}.nav-icon{float:left;line-height:inherit;margin-right:1rem;top:0;min-width:1.5rem;text-align:center}.nav-icon i{position:relative}.nav-icon i img,.nav-icon i svg{display:none;position:absolute;left:0;top:0;width:100%;height:100%}.navbar .nav-icon{margin-right:.5rem}.nav-label{float:right;margin-left:1rem;font-style:normal;z-index:1}.navbar .nav-label{margin-left:.5rem}.nav-caret{float:right;margin-left:1rem;opacity:.45}.nav-caret i{transition:transform .3s ease-in-out}.navbar .nav-caret{margin-left:.5rem}.nav-sub{max-height:0;overflow:hidden;transition:max-height .4s ease 0s}.active>.nav-sub{max-height:50rem}@media (min-width:992px){.folded,.folded .scroll{width:4rem}.folded.md,.folded.md .scroll{width:5rem}.folded .hidden-folded,.folded .nav li ul{display:none}.folded .nav>li>a{text-align:center;padding-left:4px;padding-right:4px}.folded .nav>li>a .nav-caret,.folded .nav>li>a .nav-text{display:none}.folded .nav>li>a .nav-label{position:absolute;top:-6px;right:6px}.folded .nav>li>a .nav-icon{float:none;line-height:2.5rem;margin-left:0;margin-right:0;position:relative}.folded.show-text .nav>li>a .nav-text{display:block;margin-top:-18px;font-size:.85em}.folded .navbar{text-align:center;padding-left:4px;padding-right:4px}.folded .navbar-brand{float:none;margin:0}.folded .nav-stacked .nav{margin:0 12px}.folded .nav-fold{padding:8px 16px}.folded .nav-fold .pull-left{float:none!important;margin:0}.folded .nav-fold .pull-left img{width:100%;height:auto}.folded.nav-expand{transition:width .4s cubic-bezier(.25,.8,.25,1);-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow-x:hidden;overflow-y:auto;position:absolute}.folded.nav-expand.active,.folded.nav-expand.active .scroll,.folded.nav-expand:focus,.folded.nav-expand:focus .scroll,.folded.nav-expand:hover,.folded.nav-expand:hover .scroll{width:12.5rem!important}.folded.nav-expand.active>*,.folded.nav-expand:focus>*,.folded.nav-expand:hover>*{width:12.5rem}.folded.nav-expand.active .hidden-folded,.folded.nav-expand:focus .hidden-folded,.folded.nav-expand:hover .hidden-folded{display:block}.folded.nav-expand.active .hidden-folded.inline,.folded.nav-expand:focus .hidden-folded.inline,.folded.nav-expand:hover .hidden-folded.inline{display:inline-block}.folded.nav-expand.active .nav li ul,.folded.nav-expand:focus .nav li ul,.folded.nav-expand:hover .nav li ul{display:inherit}.folded.nav-expand.active .nav>li>a,.folded.nav-expand:focus .nav>li>a,.folded.nav-expand:hover .nav>li>a{text-align:left;padding-left:16px;padding-right:16px}.folded.nav-expand.active .nav>li>a .nav-caret,.folded.nav-expand.active .nav>li>a .nav-text,.folded.nav-expand:focus .nav>li>a .nav-caret,.folded.nav-expand:focus .nav>li>a .nav-text,.folded.nav-expand:hover .nav>li>a .nav-caret,.folded.nav-expand:hover .nav>li>a .nav-text{display:block}.folded.nav-expand.active .nav>li>a .nav-text,.folded.nav-expand:focus .nav>li>a .nav-text,.folded.nav-expand:hover .nav>li>a .nav-text{font-size:1em;margin:0}.folded.nav-expand.active .nav>li>a .nav-label,.folded.nav-expand:focus .nav>li>a .nav-label,.folded.nav-expand:hover .nav>li>a .nav-label{position:static}.folded.nav-expand.active .nav>li>a .nav-icon,.folded.nav-expand:focus .nav>li>a .nav-icon,.folded.nav-expand:hover .nav>li>a .nav-icon{float:left;line-height:inherit;margin-right:16px}.folded.nav-expand.active .navbar,.folded.nav-expand:focus .navbar,.folded.nav-expand:hover .navbar{text-align:left;padding-left:1rem;padding-right:1rem}.folded.nav-expand.active .nav-stacked .nav,.folded.nav-expand:focus .nav-stacked .nav,.folded.nav-expand:hover .nav-stacked .nav{margin:0 8px}.folded.nav-expand.active .nav-stacked .nav>li>a,.folded.nav-expand:focus .nav-stacked .nav>li>a,.folded.nav-expand:hover .nav-stacked .nav>li>a{padding:0 8px}.folded.nav-expand.active .nav-fold,.folded.nav-expand:focus .nav-fold,.folded.nav-expand:hover .nav-fold{padding:12px 16px}.folded.nav-expand.active .nav-fold .pull-left,.folded.nav-expand:focus .nav-fold .pull-left,.folded.nav-expand:hover .nav-fold .pull-left{float:left!important}.folded.nav-expand.active .nav-fold .pull-left img,.folded.nav-expand:focus .nav-fold .pull-left img,.folded.nav-expand:hover .nav-fold .pull-left img{height:auto}.folded.nav-expand.active .nav-fold .pull-left img.w-40,.folded.nav-expand:focus .nav-fold .pull-left img.w-40,.folded.nav-expand:hover .nav-fold .pull-left img.w-40{width:40px}.folded.nav-expand.active .nav-fold .pull-left img.w-48,.folded.nav-expand:focus .nav-fold .pull-left img.w-48,.folded.nav-expand:hover .nav-fold .pull-left img.w-48{width:48px}.folded.nav-dropdown.modal,.folded.nav-dropdown .row-body,.folded.nav-dropdown [flex],.nav-dropup.modal,.nav-dropup .row-body,.nav-dropup [flex]{overflow:visible!important}.folded.nav-dropdown .nav>li:focus>ul,.folded.nav-dropdown .nav>li:hover>ul,.nav-dropup .nav>li:focus>ul,.nav-dropup .nav>li:hover>ul{display:block}.folded.nav-dropdown .nav>li>ul,.nav-dropup .nav>li>ul{display:none;overflow:visible;max-height:999px;color:hsla(0,0%,100%,.87);background-color:rgba(0,0,0,.87);border-radius:2px;box-shadow:0 1px 3px rgba(0,0,0,.15);position:absolute;left:100%;top:0;padding:6px 0}.folded.nav-dropdown .nav>li>ul a,.nav-dropup .nav>li>ul a{padding-left:16px!important;padding-right:16px!important;min-width:160px}.folded.nav-dropdown .nav>li>ul li.active ul,.nav-dropup .nav>li>ul li.active ul{display:block}.folded.nav-dropdown .nav>li>ul .nav-text,.nav-dropup .nav>li>ul .nav-text{padding:6px 0!important}.folded.nav-dropdown .nav>li .nav-mega,.nav-dropup .nav>li .nav-mega{width:320px}.folded.nav-dropdown .nav>li .nav-mega>li,.nav-dropup .nav>li .nav-mega>li{width:160px;float:left}.folded.nav-dropdown .nav>li .nav-mega.nav-mega-3,.nav-dropup .nav>li .nav-mega.nav-mega-3{width:480px}}.nav-border .nav>li.active:after{content:\"\";position:absolute;top:0;bottom:0;border-left-color:inherit;border-left-width:3px;border-left-style:solid}.nav-stacked .nav{margin:0 8px}.nav-stacked .nav>li>a{line-height:2rem;padding:0 .5rem;margin:2px 0}.nav-stacked .nav>li>a .nav-text{padding:.4375rem 0}.nav-stacked .nav>li li a{padding-left:3rem}.nav-stacked .nav>li li li a{padding-left:4rem}.nav-stacked .nav>li li li li a{padding-left:5rem}.nav-stacked .nav>li.active>a{color:hsla(0,0%,100%,.87);background-color:#0cc2aa}.nav-stacked .nav li a{border-radius:3px}.nav-stacked .nav .nav-header{padding-left:8px;padding-right:8px}.nav-light .nav .nav-icon i img,.nav-light .nav .nav-icon i svg{display:block}.nav-center{text-align:center}.nav-center .nav-icon{display:none}.nav-center .nav-caret{position:absolute;right:10px}.nav-center .nav-label{position:absolute;padding-left:10px}.nav-center .nav a{padding-left:16px!important}.nav-center .nav-fold .pull-left{float:none!important;margin-bottom:10px;display:inline-block}.nav-active-bg .nav-link.active,.nav-active-bg .nav>li.active>a{color:rgba(0,0,0,.87)!important;background-color:#f0f0f0!important}.nav-active-dark .nav-link.active,.nav-active-dark .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#2e3e4e!important}.nav-active-black .nav-link.active,.nav-active-black .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#2a2b3c!important}.nav-active-primary .nav-link.active,.nav-active-primary .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#0cc2aa!important}.nav-active-accent .nav-link.active,.nav-active-accent .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#a88add!important}.nav-active-warn .nav-link.active,.nav-active-warn .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#fcc100!important}.nav-active-success .nav-link.active,.nav-active-success .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#6cc788!important}.nav-active-info .nav-link.active,.nav-active-info .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#6887ff!important}.nav-active-warning .nav-link.active,.nav-active-warning .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#f77a99!important}.nav-active-danger .nav-link.active,.nav-active-danger .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#f44455!important}.nav-active-light .nav-link.active,.nav-active-light .nav>li.active>a{color:rgba(0,0,0,.87)!important;background-color:#f8f8f8!important}.nav-active-white .nav-link.active,.nav-active-white .nav>li.active>a{color:rgba(0,0,0,.87)!important;background-color:#fff!important}.nav-active-red .nav-link.active,.nav-active-red .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#f44336!important}.nav-active-pink .nav-link.active,.nav-active-pink .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#e91e63!important}.nav-active-purple .nav-link.active,.nav-active-purple .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#9c27b0!important}.nav-active-deep-purple .nav-link.active,.nav-active-deep-purple .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#673ab7!important}.nav-active-indigo .nav-link.active,.nav-active-indigo .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#3f51b5!important}.nav-active-blue .nav-link.active,.nav-active-blue .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#2196f3!important}.nav-active-light-blue .nav-link.active,.nav-active-light-blue .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#03a9f4!important}.nav-active-cyan .nav-link.active,.nav-active-cyan .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#00bcd4!important}.nav-active-teal .nav-link.active,.nav-active-teal .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#009688!important}.nav-active-green .nav-link.active,.nav-active-green .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#4caf50!important}.nav-active-light-green .nav-link.active,.nav-active-light-green .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#8bc34a!important}.nav-active-lime .nav-link.active,.nav-active-lime .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#cddc39!important}.nav-active-yellow .nav-link.active,.nav-active-yellow .nav>li.active>a{color:rgba(0,0,0,.87)!important;background-color:#ffeb3b!important}.nav-active-amber .nav-link.active,.nav-active-amber .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#ffc107!important}.nav-active-orange .nav-link.active,.nav-active-orange .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#ff9800!important}.nav-active-deep-orange .nav-link.active,.nav-active-deep-orange .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#ff5722!important}.nav-active-brown .nav-link.active,.nav-active-brown .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#795548!important}.nav-active-blue-grey .nav-link.active,.nav-active-blue-grey .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#607d8b!important}.nav-active-grey .nav-link.active,.nav-active-grey .nav>li.active>a{color:hsla(0,0%,100%,.87)!important;background-color:#424242!important}.ui-icon{display:inline-block;text-align:center;height:1em;background:transparent!important}.ui-icon:before{position:relative;z-index:1}.ui-icon:after{content:\"\";border-width:1px;border-style:solid;border-color:inherit;border-radius:2em;width:2em;height:2em;top:-1.5em;display:block;position:relative;z-index:0;background-clip:padding-box}.ui-icon.b-2x:after{border-width:2px}.ui-icon.b-3x:after{border-width:3px}.ui-icon.ui-icon-sm:after{width:1.7em;height:1.7em;top:-1.35em}.ui-icon.primary:after{background-color:#0cc2aa}.ui-icon.success:after{background-color:#6cc788}.ui-icon.info:after{background-color:#6887ff}.ui-icon.warning:after{background-color:#f77a99}.ui-icon.danger:after{background-color:#f44455}.ui-icon.accent:after{background-color:#a88add}.ui-icon.dark:after{background-color:#2e3e4e}.ui-icon.light:after{background-color:#f8f8f8}.ui-icon.white:after{background-color:#fff}.item{position:relative}.item .top{top:0}.item .bottom,.item .top{position:absolute;right:0;left:0}.item .bottom{bottom:0}.item .center{top:42%}.item-overlay,.item .center{position:absolute;right:0;left:0}.item-overlay{display:none}.item-overlay.active,.item-overlay .item:focus,.item:hover .item-overlay{display:block}.item-overlay.w-full{text-align:center;top:0;bottom:0}.item-bg{position:absolute;width:100%;height:100%;overflow:hidden}.item-bg img{position:absolute;width:110%;left:50%;top:50%;margin-left:-55%;margin-top:-55%}.blur{-moz-filter:blur(3px);-o-filter:blur(3px);-ms-filter:blur(3px);filter:blur(3px)}.blur-5{-moz-filter:blur(5px);-o-filter:blur(5px);-ms-filter:blur(5px);filter:blur(5px)}.blur-5,.opacity{opacity:.5}.opacity-3{opacity:.3}.switcher{z-index:1050;position:fixed;top:78px;right:-240px;width:240px;transition:right .2s ease;border:1px solid hsla(0,0%,47%,.1);background-clip:padding-box}.switcher.active{right:-2px;z-index:1060}.switcher .sw-btn{position:absolute;left:-43px;top:-1px;padding:10px 15px;z-index:1045;border:1px solid hsla(0,0%,47%,.1);border-right-width:0;background-clip:padding-box}#sw-demo{top:118px}#sw-demo.active{top:78px}.list-icon i{margin-right:16px}.list-icon div{line-height:40px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.jqstooltip{background-color:rgba(0,0,0,.8)!important;border:1px solid #000!important;border-radius:3px;padding:5px 10px!important;box-sizing:content-box}.easyPieChart{position:relative;text-align:center}.easyPieChart>div{position:absolute;width:100%;line-height:1;top:40%}.easyPieChart>div img{margin-top:-4px}.easyPieChart canvas{vertical-align:middle}#flotTip,.flotTip{padding:4px 10px;background-color:rgba(0,0,0,.8)!important;border:1px solid #000!important;z-index:100;font-size:12px;color:#fff;border-radius:3px}.legendColorBox>div{border:none!important;margin:5px}.legendColorBox>div>div{border-radius:10px}.st-sort-ascent:before{content:\"\\25B2\"}.st-sort-descent:before{content:\"\\25BC\"}.st-selected td{background:rgba(0,0,0,.065)}.black .btn-default.form-control,.dark .btn-default.form-control,.grey .btn-default.form-control{background:transparent!important;background-color:hsla(0,0%,100%,.1)!important;color:inherit!important}.ui-select-bootstrap>.ui-select-choices{overflow-y:scroll}.box .dataTables_wrapper{padding-top:10px}.box .dataTables_wrapper>.row{margin:0}.box .dataTables_wrapper>.row>.col-sm-12{padding:0}.dataTables_wrapper.form-inline .form-control{width:auto}.footable-odd{background-color:rgba(0,0,0,.025)!important}.note-editor{border-width:0!important;overflow:visible!important;background-color:inherit}.note-toolbar .note-color .dropdown-toggle{padding-left:2px!important}.note-editor .note-editing-area .note-editable,.note-editor .note-statusbar{background-color:transparent!important;color:inherit!important}.note-toolbar{background-color:hsla(210,8%,51%,.1)}.ie .ie-show{display:block}.nav a.waves-effect{-webkit-mask-image:-webkit-radial-gradient(circle,#fff 100%,#000 0)}.sortable-placeholder{list-style:none;border:1px dashed #fff;min-height:40px}.streamline{position:relative;border-color:hsla(210,8%,51%,.13)}.streamline .sl-icon:before,.streamline .sl-item:before,.streamline:after{content:\"\";position:absolute;border-color:inherit;border-width:3px;border-style:solid;border-radius:50%;width:7px;height:7px;margin-left:-4px;left:0}.streamline:after{top:auto;bottom:0}.sl-icon{position:absolute;left:-10px;z-index:1;border:inherit}.sl-icon>i{width:20px;height:20px;text-align:center;display:table-cell;vertical-align:middle;color:#fff}.streamline .sl-icon:before{width:20px;height:20px;border-width:10px;margin:0!important;top:0!important}.sl-item{border-color:hsla(210,8%,51%,.13);position:relative;padding-bottom:1px}.sl-item:after{content:\"\";display:table;clear:both;top:2px;bottom:auto}.sl-item.b-l{margin-left:-1px}.sl-left{float:left;position:relative;z-index:1;margin-left:-20px;margin-bottom:24px}.sl-left img{max-width:40px}.sl-left+.sl-content{margin-left:36px}.sl-content{margin-left:24px;padding-bottom:16px}.sl-author{margin-bottom:10px}.sl-date{font-size:.85em}.sl-footer{margin-bottom:10px}.ui-switch{cursor:pointer;position:relative;display:inline-block;width:32px;height:18px;border-radius:30px;background-color:#6cc788;margin:0}.ui-switch input{position:absolute;opacity:0}.ui-switch input:checked+i:before{top:50%;bottom:50%;left:50%;right:5px;border-width:0;border-radius:5px}.ui-switch input:checked+i:after{margin-left:15px}.ui-switch i:before{top:-1px;bottom:-1px;left:-1px;right:-1px;border:1px solid #f0f0f0;border-radius:30px;transition:all .2s}.ui-switch i:after,.ui-switch i:before{content:\"\";position:absolute;background-color:#fff}.ui-switch i:after{width:16px;top:1px;bottom:1px;border-radius:50%;box-shadow:1px 1px 3px rgba(0,0,0,.25);transition:margin .3s}.ui-switch-md{width:40px;height:24px}.ui-switch-md input:checked+i:after{margin-left:17px}.ui-switch-md i:after{width:22px}.ui-switch-lg{width:50px;height:30px}.ui-switch-lg input:checked+i:after{margin-left:21px}.ui-switch-lg i:after{width:28px}.timeline{margin:0;padding:0}.tl-item{display:block}.tl-item:after{content:\"\";display:table;clear:both}.visible-left{display:none}.tl-wrap{display:block;margin-left:6em;padding:15px 0 15px 20px;border-style:solid;border-color:hsla(210,8%,51%,.13);border-width:0 0 0 2px}.tl-wrap:after{content:\"\";display:table;clear:both}.tl-wrap:before{content:\"\";top:15px;margin-left:-26px;width:10px;height:10px;border-color:inherit;border-width:3px;border-radius:50%;border-style:solid;background:#f8f8f8;box-shadow:0 0 0 4px #f0f0f0}.tl-date,.tl-wrap:before{position:relative;float:left}.tl-date{top:10px;margin-left:-7.5em;display:block;width:4.5em;text-align:right}.tl-content{display:inline-block;position:relative;padding-top:10px;padding-bottom:10px}.tl-content.block{display:block;width:100%}.tl-content.panel{margin-bottom:0}.tl-header{display:block;width:12em;text-align:center;margin-left:1px}.timeline-center .tl-item{margin-left:50%}.timeline-center .tl-item .tl-wrap{margin-left:-2px}.timeline-center .tl-header{width:auto;margin-left:-1px}.timeline-center .tl-left{margin-left:0;margin-right:50%}.timeline-center .tl-left .hidden-left{display:none!important}.timeline-center .tl-left .visible-left{display:inherit}.timeline-center .tl-left .tl-wrap{float:right;margin-right:0;border-left-width:0;border-right-width:2px;padding-left:0;padding-right:20px}.timeline-center .tl-left .tl-wrap:before{float:right;margin-left:0;margin-right:-26px}.timeline-center .tl-left .tl-date{float:right;margin-left:0;margin-right:-8.5em;text-align:left}.lter{background-color:hsla(0,0%,100%,.035)}.dker{background-color:rgba(0,0,0,.035)}.light{background-color:#f8f8f8}.dark-white,.white{background-color:#fff}.dark-white{color:rgba(0,0,0,.87)}.black{color:hsla(0,0%,100%,.87);background-color:#2a2b3c}.black .lt{background-color:#2f3044}.black .dk{background-color:#252635}.black .bg{background-color:#2a2b3c}.dark{color:hsla(0,0%,100%,.87);background-color:#2e3e4e}.dark .lt{background-color:#334456}.dark .dk{background-color:#293846}.dark .bg{background-color:#2e3e4e}.grey{color:hsla(0,0%,100%,.87);background-color:#424242}.grey .lt{background-color:#484848}.grey .dk{background-color:#3c3c3c}.grey .bg{background-color:#424242}.primary{color:hsla(0,0%,100%,.87);background-color:#0cc2aa}.primary .lt{background-color:#0dceb5}.primary .dk{background-color:#0bb69f}.primary .bg{background-color:#0cc2aa}.accent{color:hsla(0,0%,100%,.87);background-color:#a88add}.accent .lt{background-color:#af94e0}.accent .dk{background-color:#a180da}.accent .bg{background-color:#a88add}.warn{color:hsla(0,0%,100%,.87);background-color:#fcc100}.warn .lt{background-color:#ffc60a}.warn .dk{background-color:#efb700}.warn .bg{background-color:#fcc100}.success{color:hsla(0,0%,100%,.87);background-color:#6cc788}.success .lt{background-color:#75cb8f}.success .dk{background-color:#63c381}.success .bg{background-color:#6cc788}.info{color:hsla(0,0%,100%,.87);background-color:#6887ff}.info .lt{background-color:#7591ff}.info .dk{background-color:#5b7dff}.info .bg{background-color:#6887ff}.warning{color:hsla(0,0%,100%,.87);background-color:#f77a99}.warning .lt{background-color:#f886a2}.warning .dk{background-color:#f66e90}.warning .bg{background-color:#f77a99}.danger{color:hsla(0,0%,100%,.87);background-color:#f44455}.danger .lt{background-color:#f55060}.danger .dk{background-color:#f3384a}.danger .bg{background-color:#f44455}.blue .lt{background-color:#2d9cf4}.blue .dk{background-color:#1590f2}.blue .bg{background-color:#2196f3}.white-overlay{background-color:hsla(0,0%,100%,.85)}.black-overlay{background-color:rgba(0,0,0,.85)}.gd-overlay{background-color:transparent!important;background-image:linear-gradient(180deg,transparent 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=0)}.bg-auto:before{content:\"\";position:absolute;width:inherit;top:0;bottom:0;background-color:inherit;border:inherit}.bg-auto.b-l:before{margin-left:-1px}.bg-auto.b-r:before{margin-right:-1px}.bg-clip{background-clip:padding-box}.no-bg{background-color:transparent!important}@media (max-width:767px){.no-bg-xs{background-color:transparent}}.dark .box,.dark .white{background-color:#354759}.dark.app{background-color:#2e3e4e}.black .box,.black .white{background-color:#313347}.black.app{background-color:#2a2b3c}.grey .box,.grey .white{background-color:#4b4b4b}.grey.app{background-color:#424242}.black .form-control,.dark .form-control,.grey .form-control{background:transparent;background-color:hsla(0,0%,100%,.1);color:inherit}.black .form-control:focus,.dark .form-control:focus,.grey .form-control:focus{border-color:hsla(0,0%,100%,.125)}.black .input-group-btn .btn,.dark .input-group-btn .btn,.grey .input-group-btn .btn{background-color:hsla(0,0%,100%,.1)!important;color:inherit!important}.black .list-group,.dark .list-group,.grey .list-group{background-color:transparent}.pos-rlt{position:relative;z-index:1}.pos-abt{position:absolute}.pos-fix{position:fixed!important}.pos-stc{position:static!important}.block{display:block}.block.hide{display:none}.pull-none{float:none}.inline{display:inline-block}.inline-16{width:16px;height:16px}.inline-24{width:24px;height:24px}.active>.auto .inline,.active>.inline,.none{display:none}.active>.auto .none,.active>.none{display:inline-block}.hide{display:none!important}.show{display:block!important}.pointer{cursor:pointer}.circle,.rounded{border-radius:500px}.clear{display:block;overflow:hidden}.no-shadow{box-shadow:none!important}@media (max-width:767px){.pos-stc-sm{position:static!important}}@media (max-width:543px){.pos-stc-xs{position:static!important}}.no-border{border-color:transparent;border-width:0}.no-borders{border-width:0!important}.b{border-color:hsla(210,8%,51%,.13);background-clip:padding-box}.b-a{border:1px solid hsla(210,8%,51%,.13)}.b-t{border-top:1px solid hsla(210,8%,51%,.13)}.b-r{border-right:1px solid hsla(210,8%,51%,.13)}.b-b{border-bottom:1px solid hsla(210,8%,51%,.13)}.b-l{border-left:1px solid hsla(210,8%,51%,.13)}.b-2x{border-width:2px}.b-3x{border-width:3px}.b-4x{border-width:4px}.b-5x{border-width:5px}.b-t-2x{border-top-width:2px!important}.b-t-3x{border-top-width:3px!important}.b-t-4x{border-top-width:4px!important}.b-t-5x{border-top-width:5px!important}.b-r-2x{border-right-width:2px!important}.b-r-3x{border-right-width:3px!important}.b-r-4x{border-right-width:4px!important}.b-r-5x{border-right-width:5px!important}.b-b-2x{border-bottom-width:2px!important}.b-b-3x{border-bottom-width:3px!important}.b-b-4x{border-bottom-width:4px!important}.b-b-5x{border-bottom-width:5px!important}.b-l-2x{border-left-width:2px!important}.b-l-3x{border-left-width:3px!important}.b-l-4x{border-left-width:4px!important}.b-l-5x{border-left-width:5px!important}.b-primary{border-color:#0cc2aa}.b-t-primary{border-top-color:#0cc2aa}.b-r-#e7f9f7{border-right-color:#0cc2aa}.b-b-primary{border-bottom-color:#0cc2aa}.b-l-primary{border-left-color:#0cc2aa}.b-accent{border-color:#a88add}.b-t-accent{border-top-color:#a88add}.b-r-#f6f3fc{border-right-color:#a88add}.b-b-accent{border-bottom-color:#a88add}.b-l-accent{border-left-color:#a88add}.b-warn{border-color:#fcc100}.b-t-warn{border-top-color:#fcc100}.b-r-#fff9e6{border-right-color:#fcc100}.b-b-warn{border-bottom-color:#fcc100}.b-l-warn{border-left-color:#fcc100}.b-success{border-color:#6cc788}.b-t-success{border-top-color:#6cc788}.b-r-#f0f9f3{border-right-color:#6cc788}.b-b-success{border-bottom-color:#6cc788}.b-l-success{border-left-color:#6cc788}.b-info{border-color:#6887ff}.b-t-info{border-top-color:#6887ff}.b-r-#f0f3ff{border-right-color:#6887ff}.b-b-info{border-bottom-color:#6887ff}.b-l-info{border-left-color:#6887ff}.b-warning{border-color:#f77a99}.b-t-warning{border-top-color:#f77a99}.b-r-#fef2f5{border-right-color:#f77a99}.b-b-warning{border-bottom-color:#f77a99}.b-l-warning{border-left-color:#f77a99}.b-danger{border-color:#f44455}.b-t-danger{border-top-color:#f44455}.b-r-#feecee{border-right-color:#f44455}.b-b-danger{border-bottom-color:#f44455}.b-l-danger{border-left-color:#f44455}.b-light{border-color:#f8f8f8}.b-t-light{border-top-color:#f8f8f8}.b-r-#fefefe{border-right-color:#f8f8f8}.b-b-light{border-bottom-color:#f8f8f8}.b-l-light{border-left-color:#f8f8f8}.b-grey{border-color:#424242}.b-t-grey{border-top-color:#424242}.b-r-#ececec{border-right-color:#424242}.b-b-grey{border-bottom-color:#424242}.b-l-grey{border-left-color:#424242}.b-dark{border-color:#2e3e4e}.b-t-dark{border-top-color:#2e3e4e}.b-r-#eaeced{border-right-color:#2e3e4e}.b-b-dark{border-bottom-color:#2e3e4e}.b-l-dark{border-left-color:#2e3e4e}.b-black{border-color:#2a2b3c}.b-t-black{border-top-color:#2a2b3c}.b-r-#eaeaec{border-right-color:#2a2b3c}.b-b-black{border-bottom-color:#2a2b3c}.b-l-black{border-left-color:#2a2b3c}.b-white{border-color:#fff}.b-t-white{border-top-color:#fff}.b-r-white{border-right-color:#fff}.b-b-white{border-bottom-color:#fff}.b-l-white{border-left-color:#fff}.b-blue{border-color:#2196f3}.b-t-blue{border-top-color:#2196f3}.b-r-#e9f5fe{border-right-color:#2196f3}.b-b-blue{border-bottom-color:#2196f3}.b-l-blue{border-left-color:#2196f3}.no-b-t{border-top-width:0}.no-b-r{border-right-width:0}.no-b-b{border-bottom-width:0}.no-b-l{border-left-width:0}.b-dashed{border-style:dashed!important}@media (max-width:991px){.no-border-sm{border-width:0}}@media (max-width:767px){.no-border-xs{border-width:0}}.hover-action{display:none}.hover-rotate{transition:all .2s ease-in-out .1s}.hover-anchor:active .hover-action,.hover-anchor:focus .hover-action,.hover-anchor:hover .hover-action{display:inherit}.hover-anchor:active .hover-rotate,.hover-anchor:focus .hover-rotate,.hover-anchor:hover .hover-rotate{transform:rotate(45deg)}.hover-top:focus,.hover-top:hover{position:relative;z-index:1000}.m-a{margin:1rem!important}.m-t{margin-top:1rem!important}.m-r{margin-right:1rem!important}.m-b{margin-bottom:1rem!important}.m-l,.m-x{margin-left:1rem!important}.m-x{margin-right:1rem!important}.m-y{margin-top:1rem!important;margin-bottom:1rem!important}.m-a-lg{margin:3rem!important}.m-t-lg{margin-top:3rem!important}.m-r-lg{margin-right:3rem!important}.m-b-lg{margin-bottom:3rem!important}.m-l-lg,.m-x-lg{margin-left:3rem!important}.m-x-lg{margin-right:3rem!important}.m-y-lg{margin-top:3rem!important;margin-bottom:3rem!important}.m-a-md{margin:1.5rem!important}.m-t-md{margin-top:1.5rem!important}.m-r-md{margin-right:1.5rem!important}.m-b-md{margin-bottom:1.5rem!important}.m-l-md,.m-x-md{margin-left:1.5rem!important}.m-x-md{margin-right:1.5rem!important}.m-y-md{margin-top:1.5rem!important;margin-bottom:1.5rem!important}.m-a-sm{margin:.5rem!important}.m-t-sm{margin-top:.5rem!important}.m-r-sm{margin-right:.5rem!important}.m-b-sm{margin-bottom:.5rem!important}.m-l-sm,.m-x-sm{margin-left:.5rem!important}.m-x-sm{margin-right:.5rem!important}.m-y-sm{margin-top:.5rem!important;margin-bottom:.5rem!important}.m-a-xs{margin:.25rem!important}.m-t-xs{margin-top:.25rem!important}.m-r-xs{margin-right:.25rem!important}.m-b-xs{margin-bottom:.25rem!important}.m-l-xs,.m-x-xs{margin-left:.25rem!important}.m-x-xs{margin-right:.25rem!important}.m-y-xs{margin-top:.25rem!important;margin-bottom:.25rem!important}.p-a{padding:1rem!important}.p-t{padding-top:1rem!important}.p-r{padding-right:1rem!important}.p-b{padding-bottom:1rem!important}.p-l,.p-x{padding-left:1rem!important}.p-x{padding-right:1rem!important}.p-y{padding-top:1rem!important;padding-bottom:1rem!important}.p-a-lg{padding:3rem!important}.p-t-lg{padding-top:3rem!important}.p-r-lg{padding-right:3rem!important}.p-b-lg{padding-bottom:3rem!important}.p-l-lg,.p-x-lg{padding-left:3rem!important}.p-x-lg{padding-right:3rem!important}.p-y-lg{padding-top:3rem!important;padding-bottom:3rem!important}.p-a-md{padding:1.5rem!important}.p-t-md{padding-top:1.5rem!important}.p-r-md{padding-right:1.5rem!important}.p-b-md{padding-bottom:1.5rem!important}.p-l-md,.p-x-md{padding-left:1.5rem!important}.p-x-md{padding-right:1.5rem!important}.p-y-md{padding-top:1.5rem!important;padding-bottom:1.5rem!important}.p-a-sm{padding:.5rem!important}.p-t-sm{padding-top:.5rem!important}.p-r-sm{padding-right:.5rem!important}.p-b-sm{padding-bottom:.5rem!important}.p-l-sm,.p-x-sm{padding-left:.5rem!important}.p-x-sm{padding-right:.5rem!important}.p-y-sm{padding-top:.5rem!important;padding-bottom:.5rem!important}.p-a-xs{padding:.25rem!important}.p-t-xs{padding-top:.25rem!important}.p-r-xs{padding-right:.25rem!important}.p-b-xs{padding-bottom:.25rem!important}.p-l-xs,.p-x-xs{padding-left:.25rem!important}.p-x-xs{padding-right:.25rem!important}.p-y-xs{padding-top:.25rem!important;padding-bottom:.25rem!important}.padding{padding:1.5rem}.margin{margin-bottom:1.5rem}.padding-out{margin:-1.5rem}@media (max-width:991px){.padding{padding:1rem}.padding-out{margin:-1rem}.box,.box-color,.margin{margin-bottom:1rem}}@media (max-width:767px){.padding{padding:.5rem}.padding-out{margin:-.5rem}.box,.box-color,.margin{margin-bottom:.5rem}.no-padding-xs{padding:0}}.no-radius{border-radius:0!important}.no-r-t{border-top-left-radius:0}.no-r-r,.no-r-t{border-top-right-radius:0}.no-r-b,.no-r-r{border-bottom-right-radius:0}.no-r-b,.no-r-l{border-bottom-left-radius:0}.no-r-l{border-top-left-radius:0}.r{border-radius:3px}.r-t{border-top-left-radius:3px}.r-r,.r-t{border-top-right-radius:3px}.r-b,.r-r{border-bottom-right-radius:3px}.r-b,.r-l{border-bottom-left-radius:3px}.r-l{border-top-left-radius:3px}.r-2x{border-radius:6px}.r-3x{border-radius:9px}.scrollable{overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch}.scrollable.hover,.scrollable.hover>.row-inner{overflow-y:hidden}.scrollable.hover>*{margin-top:-1px}.scrollable.hover:active,.scrollable.hover:focus,.scrollable.hover:hover{overflow:visible;overflow-y:auto}.scrollable.hover:active>.row-inner,.scrollable.hover:focus>.row-inner,.scrollable.hover:hover>.row-inner{overflow-y:auto}.smart .scrollable,.smart .scrollable>.row-inner{overflow-y:auto!important}.scroll-x,.scroll-y{overflow:hidden;-webkit-overflow-scrolling:touch}.scroll-y{overflow-y:auto}.scroll-x{overflow-x:auto}a.primary:hover{background-color:#0bb69f}a.text-primary:hover{color:#0bb69f}.text-primary,.text-primary-hover a:hover{color:#0cc2aa!important}a.warn:hover{background-color:#efb700}a.text-warn:hover{color:#efb700}.text-warn,.text-warn-hover a:hover{color:#fcc100!important}a.accent:hover{background-color:#a180da}a.text-accent:hover{color:#a180da}.text-accent,.text-accent-hover a:hover{color:#a88add!important}a.success:hover{background-color:#63c381}a.text-success:hover{color:#63c381}.text-success,.text-success-hover a:hover{color:#6cc788!important}a.info:hover{background-color:#5b7dff}a.text-info:hover{color:#5b7dff}.text-info,.text-info-hover a:hover{color:#6887ff!important}a.warning:hover{background-color:#f66e90}a.text-warning:hover{color:#f66e90}.text-warning,.text-warning-hover a:hover{color:#f77a99!important}a.danger:hover{background-color:#f3384a}a.text-danger:hover{color:#f3384a}.text-danger,.text-danger-hover a:hover{color:#f44455!important}a.dark:hover{background-color:#293846}a.text-dark:hover{color:#293846}.text-dark,.text-dark-hover a:hover{color:#2e3e4e!important}a.blue:hover{background-color:#1590f2}a.text-blue:hover{color:#1590f2}.text-blue,.text-blue-hover a:hover{color:#2196f3!important}.text-white{color:#fff!important}.text-white-lt{color:hsla(0,0%,100%,.54)}.text-white-dk{color:hsla(0,0%,100%,.87)}.text-black{color:#000}.text-black-lt{color:rgba(0,0,0,.54)}.text-black-dk{color:rgba(0,0,0,.87)}.text-muted{color:inherit!important;opacity:.6}.text-color{color:rgba(0,0,0,.87)}._100{font-weight:100}._200{font-weight:200}._300{font-weight:300}._400{font-weight:400}._500{font-weight:500}._600{font-weight:600}._700{font-weight:700}._800{font-weight:800}.text{font-size:1rem}.text-xs{font-size:.75rem}.text-sm{font-size:.8rem}.text-md{font-size:1.125rem}.text-lg{font-size:1.5rem}.text-2x{font-size:2em}.text-3x{font-size:3em}.text-4x{font-size:4em}.l-h{line-height:1.5}.l-h-1x{line-height:1}.l-h-2x{line-height:2em}.l-s-1x{letter-spacing:1px}.l-s-2x{letter-spacing:2px}.l-s-3x{letter-spacing:3px}.l-s-4x{letter-spacing:4px}.l-s-n-1x{letter-spacing:-1px}.l-s-n-2x{letter-spacing:-2px}.l-s-n-3x{letter-spacing:-3px}.l-s-n-4x{letter-spacing:-4px}.h-1x{height:1.5;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.h-2x{height:2.625rem;-webkit-line-clamp:2}.h-2x,.h-3x{overflow:hidden;display:-webkit-box}.h-3x{height:3.9375rem;-webkit-line-clamp:3}.h-4x{height:5.25rem;overflow:hidden;display:-webkit-box;-webkit-line-clamp:4}.text-u-c{text-transform:uppercase}.text-l-t{text-decoration:line-through}.text-u-l{text-decoration:underline}.text-ellipsis{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.text-shadow{text-shadow:0 1px 0 rgba(0,0,0,.1)}.w-8{width:8px;height:8px}.w-8,.w-16{display:inline-block}.w-16{width:16px;height:16px}.w-18{width:18px;height:18px}.w-18,.w-20{display:inline-block}.w-20{width:20px;height:20px}.w-24{width:24px;height:24px}.w-24,.w-32{display:inline-block;text-align:center}.w-32{width:32px;height:32px;line-height:32px}.w-40{width:40px;height:40px;line-height:40px}.w-40,.w-48{display:inline-block;text-align:center}.w-48{width:48px;height:48px;line-height:48px}.w-56{width:56px;height:56px;line-height:56px;display:inline-block;text-align:center}.w-64{width:64px}.w-96{width:96px}.w-128{width:128px}.w-xxs{width:60px}.w-xs{width:90px}.w-sm{width:120px}.w{width:180px}.w-md{width:200px}.w-lg{width:240px}.w-xl{width:280px}.w-xxl{width:320px}.w-full{width:100%}.w-auto{width:auto}.h-auto{height:auto}.h-full{height:100%}.h-v{height:100vh}.h-v-5{height:50vh}@media (max-width:767px){.w-auto-sm{width:auto}.w-full-sm{width:100%}}@media (max-width:543px){.w-auto-xs{width:auto}.w-full-xs{width:100%}}.md-btn{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;outline:none;border:0;border-radius:3px;padding:6px;display:inline-block;white-space:nowrap;text-align:center;text-transform:uppercase;font-weight:700;font-style:inherit;font-variant:inherit;font-size:inherit;font-family:inherit;line-height:inherit;text-decoration:none;cursor:pointer;overflow:hidden;transition:box-shadow .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),transform .4s cubic-bezier(.25,.8,.25,1)}.md-flat{background:transparent}.md-btn.md-flat:not([disabled]):focus,.md-btn.md-flat:not([disabled]):hover{background-color:hsla(0,0%,62%,.2)}.md-btn-circle{width:28px;height:28px;border-radius:50%;padding:2px}.md-btn.md-fab[disabled],.md-btn.md-raised[disabled],.md-btn[disabled]{color:rgba(0,0,0,.26);background-color:transparent;cursor:not-allowed}.md-fab{line-height:44px}.md-fab-offset{margin-top:-20px;margin-bottom:-20px}.md-btn:focus{outline:none}.md-btn:hover{text-decoration:none}.md-btn.md-cornered{border-radius:0}.md-btn.md-icon{padding:0;background:none}.md-btn.md-fab,.md-btn.md-raised{transform:translateZ(0)}.md-btn.md-fab{z-index:20;width:56px;height:56px;border-radius:50%;overflow:hidden;transition:.2s linear;transition-property:transform,box-shadow}.md-btn.md-fab,.md-btn.md-raised:not([disabled]){box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.md-btn.md-fab:not([disabled]):focus,.md-btn.md-fab:not([disabled]):hover,.md-btn.md-raised:not([disabled]):focus,.md-btn.md-raised:not([disabled]):hover{box-shadow:0 4px 8px 0 rgba(0,0,0,.4);transform:translate3d(0,-1px,0)}.md-fab-bottom-right{top:auto;right:20px;bottom:20px;left:auto;position:absolute}.md-fab-bottom-left{top:auto;right:auto;bottom:20px;left:20px;position:absolute}.md-fab-top-right{right:20px;left:auto}.md-fab-top-left,.md-fab-top-right{top:20px;bottom:auto;position:absolute}.md-fab-top-left{right:auto;left:20px}.md-btn.md-fab.md-mini{width:40px;height:40px;line-height:28px}.red{background-color:#f44336;color:hsla(0,0%,100%,.87)}.red-50{background-color:#ffebee}.red-50,.red-100{color:rgba(0,0,0,.87)}.red-100{background-color:#ffcdd2}.red-200{background-color:#ef9a9a}.red-200,.red-300{color:rgba(0,0,0,.87)}.red-300{background-color:#e57373}.red-400{background-color:#ef5350;color:rgba(0,0,0,.87)}.red-500{background-color:#f44336}.red-500,.red-600{color:hsla(0,0%,100%,.87)}.red-600{background-color:#e53935}.red-700{background-color:#d32f2f}.red-700,.red-800{color:hsla(0,0%,100%,.87)}.red-800{background-color:#c62828}.red-900{background-color:#b71c1c;color:hsla(0,0%,100%,.87)}.red-A100{background-color:#ff8a80;color:rgba(0,0,0,.87)}.red-A200{background-color:#ff5252}.red-A200,.red-A400{color:hsla(0,0%,100%,.87)}.red-A400{background-color:#ff1744}.red-A700{background-color:#d50000}.pink,.red-A700{color:hsla(0,0%,100%,.87)}.pink{background-color:#e91e63}.pink-50{background-color:#fce4ec}.pink-50,.pink-100{color:rgba(0,0,0,.87)}.pink-100{background-color:#f8bbd0}.pink-200{background-color:#f48fb1}.pink-200,.pink-300{color:rgba(0,0,0,.87)}.pink-300{background-color:#f06292}.pink-400{background-color:#ec407a;color:rgba(0,0,0,.87)}.pink-500{background-color:#e91e63}.pink-500,.pink-600{color:hsla(0,0%,100%,.87)}.pink-600{background-color:#d81b60}.pink-700{background-color:#c2185b}.pink-700,.pink-800{color:hsla(0,0%,100%,.87)}.pink-800{background-color:#ad1457}.pink-900{background-color:#880e4f;color:hsla(0,0%,100%,.87)}.pink-A100{background-color:#ff80ab;color:rgba(0,0,0,.87)}.pink-A200{background-color:#ff4081}.pink-A200,.pink-A400{color:hsla(0,0%,100%,.87)}.pink-A400{background-color:#f50057}.pink-A700{background-color:#c51162}.pink-A700,.purple{color:hsla(0,0%,100%,.87)}.purple{background-color:#9c27b0}.purple-50{background-color:#f3e5f5;color:rgba(0,0,0,.87)}.purple-100{background-color:#e1bee7;color:rgba(0,0,0,.87)}.purple-200{background-color:#ce93d8;color:rgba(0,0,0,.87)}.purple-300{background-color:#ba68c8}.purple-300,.purple-400{color:hsla(0,0%,100%,.87)}.purple-400{background-color:#ab47bc}.purple-500{background-color:#9c27b0}.purple-500,.purple-600{color:hsla(0,0%,100%,.87)}.purple-600{background-color:#8e24aa}.purple-700{background-color:#7b1fa2}.purple-700,.purple-800{color:hsla(0,0%,100%,.87)}.purple-800{background-color:#6a1b9a}.purple-900{background-color:#4a148c;color:hsla(0,0%,100%,.87)}.purple-A100{background-color:#ea80fc;color:rgba(0,0,0,.87)}.purple-A200{background-color:#e040fb;color:hsla(0,0%,100%,.87)}.purple-A400{background-color:#d500f9;color:hsla(0,0%,100%,.87)}.purple-A700{background-color:#a0f;color:hsla(0,0%,100%,.87)}.deep-purple{background-color:#673ab7;color:hsla(0,0%,100%,.87)}.deep-purple-50{background-color:#ede7f6;color:rgba(0,0,0,.87)}.deep-purple-100{background-color:#d1c4e9;color:rgba(0,0,0,.87)}.deep-purple-200{background-color:#b39ddb;color:rgba(0,0,0,.87)}.deep-purple-300{background-color:#9575cd;color:hsla(0,0%,100%,.87)}.deep-purple-400{background-color:#7e57c2;color:hsla(0,0%,100%,.87)}.deep-purple-500{background-color:#673ab7;color:hsla(0,0%,100%,.87)}.deep-purple-600{background-color:#5e35b1;color:hsla(0,0%,100%,.87)}.deep-purple-700{background-color:#512da8;color:hsla(0,0%,100%,.87)}.deep-purple-800{background-color:#4527a0;color:hsla(0,0%,100%,.87)}.deep-purple-900{background-color:#311b92;color:hsla(0,0%,100%,.87)}.deep-purple-A100{background-color:#b388ff;color:rgba(0,0,0,.87)}.deep-purple-A200{background-color:#7c4dff;color:hsla(0,0%,100%,.87)}.deep-purple-A400{background-color:#651fff;color:hsla(0,0%,100%,.87)}.deep-purple-A700{background-color:#6200ea;color:hsla(0,0%,100%,.87)}.indigo{background-color:#3f51b5;color:hsla(0,0%,100%,.87)}.indigo-50{background-color:#e8eaf6;color:rgba(0,0,0,.87)}.indigo-100{background-color:#c5cae9;color:rgba(0,0,0,.87)}.indigo-200{background-color:#9fa8da;color:rgba(0,0,0,.87)}.indigo-300{background-color:#7986cb}.indigo-300,.indigo-400{color:hsla(0,0%,100%,.87)}.indigo-400{background-color:#5c6bc0}.indigo-500{background-color:#3f51b5}.indigo-500,.indigo-600{color:hsla(0,0%,100%,.87)}.indigo-600{background-color:#3949ab}.indigo-700{background-color:#303f9f}.indigo-700,.indigo-800{color:hsla(0,0%,100%,.87)}.indigo-800{background-color:#283593}.indigo-900{background-color:#1a237e;color:hsla(0,0%,100%,.87)}.indigo-A100{background-color:#8c9eff;color:rgba(0,0,0,.87)}.indigo-A200{background-color:#536dfe;color:hsla(0,0%,100%,.87)}.indigo-A400{background-color:#3d5afe;color:hsla(0,0%,100%,.87)}.indigo-A700{background-color:#304ffe}.blue,.indigo-A700{color:hsla(0,0%,100%,.87)}.blue{background-color:#2196f3}.blue-50{background-color:#e3f2fd}.blue-50,.blue-100{color:rgba(0,0,0,.87)}.blue-100{background-color:#bbdefb}.blue-200{background-color:#90caf9}.blue-200,.blue-300{color:rgba(0,0,0,.87)}.blue-300{background-color:#64b5f6}.blue-400{background-color:#42a5f5;color:rgba(0,0,0,.87)}.blue-500{background-color:#2196f3}.blue-500,.blue-600{color:hsla(0,0%,100%,.87)}.blue-600{background-color:#1e88e5}.blue-700{background-color:#1976d2}.blue-700,.blue-800{color:hsla(0,0%,100%,.87)}.blue-800{background-color:#1565c0}.blue-900{background-color:#0d47a1;color:hsla(0,0%,100%,.87)}.blue-A100{background-color:#82b1ff;color:rgba(0,0,0,.87)}.blue-A200{background-color:#448aff}.blue-A200,.blue-A400{color:hsla(0,0%,100%,.87)}.blue-A400{background-color:#2979ff}.blue-A700{background-color:#2962ff}.blue-A700,.light-blue{color:hsla(0,0%,100%,.87)}.light-blue{background-color:#03a9f4}.light-blue-50{background-color:#e1f5fe;color:rgba(0,0,0,.87)}.light-blue-100{background-color:#b3e5fc;color:rgba(0,0,0,.87)}.light-blue-200{background-color:#81d4fa;color:rgba(0,0,0,.87)}.light-blue-300{background-color:#4fc3f7;color:rgba(0,0,0,.87)}.light-blue-400{background-color:#29b6f6;color:rgba(0,0,0,.87)}.light-blue-500{background-color:#03a9f4;color:hsla(0,0%,100%,.87)}.light-blue-600{background-color:#039be5;color:hsla(0,0%,100%,.87)}.light-blue-700{background-color:#0288d1;color:hsla(0,0%,100%,.87)}.light-blue-800{background-color:#0277bd;color:hsla(0,0%,100%,.87)}.light-blue-900{background-color:#01579b;color:hsla(0,0%,100%,.87)}.light-blue-A100{background-color:#80d8ff;color:rgba(0,0,0,.87)}.light-blue-A200{background-color:#40c4ff;color:rgba(0,0,0,.87)}.light-blue-A400{background-color:#00b0ff;color:rgba(0,0,0,.87)}.light-blue-A700{background-color:#0091ea}.cyan,.light-blue-A700{color:hsla(0,0%,100%,.87)}.cyan{background-color:#00bcd4}.cyan-50{background-color:#e0f7fa}.cyan-50,.cyan-100{color:rgba(0,0,0,.87)}.cyan-100{background-color:#b2ebf2}.cyan-200{background-color:#80deea}.cyan-200,.cyan-300{color:rgba(0,0,0,.87)}.cyan-300{background-color:#4dd0e1}.cyan-400{background-color:#26c6da;color:rgba(0,0,0,.87)}.cyan-500{background-color:#00bcd4}.cyan-500,.cyan-600{color:hsla(0,0%,100%,.87)}.cyan-600{background-color:#00acc1}.cyan-700{background-color:#0097a7}.cyan-700,.cyan-800{color:hsla(0,0%,100%,.87)}.cyan-800{background-color:#00838f}.cyan-900{background-color:#006064;color:hsla(0,0%,100%,.87)}.cyan-A100{background-color:#84ffff;color:rgba(0,0,0,.87)}.cyan-A200{background-color:#18ffff;color:rgba(0,0,0,.87)}.cyan-A400{background-color:#00e5ff;color:rgba(0,0,0,.87)}.cyan-A700{background-color:#00b8d4;color:rgba(0,0,0,.87)}.teal{background-color:#009688;color:hsla(0,0%,100%,.87)}.teal-50{background-color:#e0f2f1}.teal-50,.teal-100{color:rgba(0,0,0,.87)}.teal-100{background-color:#b2dfdb}.teal-200{background-color:#80cbc4}.teal-200,.teal-300{color:rgba(0,0,0,.87)}.teal-300{background-color:#4db6ac}.teal-400{background-color:#26a69a;color:rgba(0,0,0,.87)}.teal-500{background-color:#009688}.teal-500,.teal-600{color:hsla(0,0%,100%,.87)}.teal-600{background-color:#00897b}.teal-700{background-color:#00796b}.teal-700,.teal-800{color:hsla(0,0%,100%,.87)}.teal-800{background-color:#00695c}.teal-900{background-color:#004d40;color:hsla(0,0%,100%,.87)}.teal-A100{background-color:#a7ffeb;color:rgba(0,0,0,.87)}.teal-A200{background-color:#64ffda;color:rgba(0,0,0,.87)}.teal-A400{background-color:#1de9b6;color:rgba(0,0,0,.87)}.teal-A700{background-color:#00bfa5;color:rgba(0,0,0,.87)}.green{background-color:#4caf50;color:hsla(0,0%,100%,.87)}.green-50{background-color:#e8f5e9}.green-50,.green-100{color:rgba(0,0,0,.87)}.green-100{background-color:#c8e6c9}.green-200{background-color:#a5d6a7;color:rgba(0,0,0,.87)}.green-300{background-color:#81c784;color:rgba(0,0,0,.87)}.green-400{background-color:#66bb6a;color:rgba(0,0,0,.87)}.green-500{background-color:#4caf50}.green-500,.green-600{color:hsla(0,0%,100%,.87)}.green-600{background-color:#43a047}.green-700{background-color:#388e3c}.green-700,.green-800{color:hsla(0,0%,100%,.87)}.green-800{background-color:#2e7d32}.green-900{background-color:#1b5e20;color:hsla(0,0%,100%,.87)}.green-A100{background-color:#b9f6ca;color:rgba(0,0,0,.87)}.green-A200{background-color:#69f0ae;color:rgba(0,0,0,.87)}.green-A400{background-color:#00e676;color:rgba(0,0,0,.87)}.green-A700{background-color:#00c853;color:rgba(0,0,0,.87)}.light-green{background-color:#8bc34a;color:rgba(0,0,0,.87)}.light-green-50{background-color:#f1f8e9;color:rgba(0,0,0,.87)}.light-green-100{background-color:#dcedc8;color:rgba(0,0,0,.87)}.light-green-200{background-color:#c5e1a5;color:rgba(0,0,0,.87)}.light-green-300{background-color:#aed581;color:rgba(0,0,0,.87)}.light-green-400{background-color:#9ccc65;color:rgba(0,0,0,.87)}.light-green-500{background-color:#8bc34a;color:rgba(0,0,0,.87)}.light-green-600{background-color:#7cb342;color:rgba(0,0,0,.87)}.light-green-700{background-color:#689f38;color:rgba(0,0,0,.87)}.light-green-800{background-color:#558b2f;color:hsla(0,0%,100%,.87)}.light-green-900{background-color:#33691e;color:hsla(0,0%,100%,.87)}.light-green-A100{background-color:#ccff90;color:rgba(0,0,0,.87)}.light-green-A200{background-color:#b2ff59;color:rgba(0,0,0,.87)}.light-green-A400{background-color:#76ff03;color:rgba(0,0,0,.87)}.light-green-A700{background-color:#64dd17;color:rgba(0,0,0,.87)}.lime{background-color:#cddc39}.lime,.lime-50{color:rgba(0,0,0,.87)}.lime-50{background-color:#f9fbe7}.lime-100{background-color:#f0f4c3}.lime-100,.lime-200{color:rgba(0,0,0,.87)}.lime-200{background-color:#e6ee9c}.lime-300{background-color:#dce775}.lime-300,.lime-400{color:rgba(0,0,0,.87)}.lime-400{background-color:#d4e157}.lime-500{background-color:#cddc39}.lime-500,.lime-600{color:rgba(0,0,0,.87)}.lime-600{background-color:#c0ca33}.lime-700{background-color:#afb42b}.lime-700,.lime-800{color:rgba(0,0,0,.87)}.lime-800{background-color:#9e9d24}.lime-900{background-color:#827717;color:hsla(0,0%,100%,.87)}.lime-A100{background-color:#f4ff81;color:rgba(0,0,0,.87)}.lime-A200{background-color:#eeff41;color:rgba(0,0,0,.87)}.lime-A400{background-color:#c6ff00;color:rgba(0,0,0,.87)}.lime-A700{background-color:#aeea00}.lime-A700,.yellow{color:rgba(0,0,0,.87)}.yellow{background-color:#ffeb3b}.yellow-50{background-color:#fffde7;color:rgba(0,0,0,.87)}.yellow-100{background-color:#fff9c4;color:rgba(0,0,0,.87)}.yellow-200{background-color:#fff59d;color:rgba(0,0,0,.87)}.yellow-300{background-color:#fff176;color:rgba(0,0,0,.87)}.yellow-400{background-color:#ffee58;color:rgba(0,0,0,.87)}.yellow-500{background-color:#ffeb3b;color:rgba(0,0,0,.87)}.yellow-600{background-color:#fdd835;color:rgba(0,0,0,.87)}.yellow-700{background-color:#fbc02d;color:rgba(0,0,0,.87)}.yellow-800{background-color:#f9a825;color:rgba(0,0,0,.87)}.yellow-900{background-color:#f57f17;color:rgba(0,0,0,.87)}.yellow-A100{background-color:#ffff8d;color:rgba(0,0,0,.87)}.yellow-A200{background-color:#ff0;color:rgba(0,0,0,.87)}.yellow-A400{background-color:#ffea00;color:rgba(0,0,0,.87)}.yellow-A700{background-color:#ffd600}.amber,.yellow-A700{color:rgba(0,0,0,.87)}.amber{background-color:#ffc107}.amber-50{background-color:#fff8e1}.amber-50,.amber-100{color:rgba(0,0,0,.87)}.amber-100{background-color:#ffecb3}.amber-200{background-color:#ffe082;color:rgba(0,0,0,.87)}.amber-300{background-color:#ffd54f;color:rgba(0,0,0,.87)}.amber-400{background-color:#ffca28;color:rgba(0,0,0,.87)}.amber-500{background-color:#ffc107;color:rgba(0,0,0,.87)}.amber-600{background-color:#ffb300;color:rgba(0,0,0,.87)}.amber-700{background-color:#ffa000;color:rgba(0,0,0,.87)}.amber-800{background-color:#ff8f00;color:rgba(0,0,0,.87)}.amber-900{background-color:#ff6f00;color:rgba(0,0,0,.87)}.amber-A100{background-color:#ffe57f;color:rgba(0,0,0,.87)}.amber-A200{background-color:#ffd740;color:rgba(0,0,0,.87)}.amber-A400{background-color:#ffc400;color:rgba(0,0,0,.87)}.amber-A700{background-color:#ffab00}.amber-A700,.orange{color:rgba(0,0,0,.87)}.orange{background-color:#ff9800}.orange-50{background-color:#fff3e0;color:rgba(0,0,0,.87)}.orange-100{background-color:#ffe0b2;color:rgba(0,0,0,.87)}.orange-200{background-color:#ffcc80;color:rgba(0,0,0,.87)}.orange-300{background-color:#ffb74d;color:rgba(0,0,0,.87)}.orange-400{background-color:#ffa726;color:rgba(0,0,0,.87)}.orange-500{background-color:#ff9800;color:rgba(0,0,0,.87)}.orange-600{background-color:#fb8c00;color:rgba(0,0,0,.87)}.orange-700{background-color:#f57c00;color:rgba(0,0,0,.87)}.orange-800{background-color:#ef6c00}.orange-800,.orange-900{color:hsla(0,0%,100%,.87)}.orange-900{background-color:#e65100}.orange-A100{background-color:#ffd180;color:rgba(0,0,0,.87)}.orange-A200{background-color:#ffab40;color:rgba(0,0,0,.87)}.orange-A400{background-color:#ff9100;color:rgba(0,0,0,.87)}.orange-A700{background-color:#ff6d00;color:rgba(0,0,0,.87)}.deep-orange{background-color:#ff5722;color:hsla(0,0%,100%,.87)}.deep-orange-50{background-color:#fbe9e7;color:rgba(0,0,0,.87)}.deep-orange-100{background-color:#ffccbc;color:rgba(0,0,0,.87)}.deep-orange-200{background-color:#ffab91;color:rgba(0,0,0,.87)}.deep-orange-300{background-color:#ff8a65;color:rgba(0,0,0,.87)}.deep-orange-400{background-color:#ff7043;color:rgba(0,0,0,.87)}.deep-orange-500{background-color:#ff5722;color:hsla(0,0%,100%,.87)}.deep-orange-600{background-color:#f4511e;color:hsla(0,0%,100%,.87)}.deep-orange-700{background-color:#e64a19;color:hsla(0,0%,100%,.87)}.deep-orange-800{background-color:#d84315;color:hsla(0,0%,100%,.87)}.deep-orange-900{background-color:#bf360c;color:hsla(0,0%,100%,.87)}.deep-orange-A100{background-color:#ff9e80;color:rgba(0,0,0,.87)}.deep-orange-A200{background-color:#ff6e40;color:rgba(0,0,0,.87)}.deep-orange-A400{background-color:#ff3d00;color:hsla(0,0%,100%,.87)}.deep-orange-A700{background-color:#dd2c00}.brown,.deep-orange-A700{color:hsla(0,0%,100%,.87)}.brown{background-color:#795548}.brown-50{background-color:#efebe9}.brown-50,.brown-100{color:rgba(0,0,0,.87)}.brown-100{background-color:#d7ccc8}.brown-200{background-color:#bcaaa4;color:rgba(0,0,0,.87)}.brown-300{background-color:#a1887f}.brown-300,.brown-400{color:hsla(0,0%,100%,.87)}.brown-400{background-color:#8d6e63}.brown-500{background-color:#795548}.brown-500,.brown-600{color:hsla(0,0%,100%,.87)}.brown-600{background-color:#6d4c41}.brown-700{background-color:#5d4037}.brown-700,.brown-800{color:hsla(0,0%,100%,.87)}.brown-800{background-color:#4e342e}.brown-900{background-color:#3e2723}.blue-grey,.brown-900{color:hsla(0,0%,100%,.87)}.blue-grey{background-color:#607d8b}.blue-grey-50{background-color:#eceff1;color:rgba(0,0,0,.87)}.blue-grey-100{background-color:#cfd8dc;color:rgba(0,0,0,.87)}.blue-grey-200{background-color:#b0bec5;color:rgba(0,0,0,.87)}.blue-grey-300{background-color:#90a4ae;color:rgba(0,0,0,.87)}.blue-grey-400{background-color:#78909c;color:hsla(0,0%,100%,.87)}.blue-grey-500{background-color:#607d8b;color:hsla(0,0%,100%,.87)}.blue-grey-600{background-color:#546e7a;color:hsla(0,0%,100%,.87)}.blue-grey-700{background-color:#455a64;color:hsla(0,0%,100%,.87)}.blue-grey-800{background-color:#37474f;color:hsla(0,0%,100%,.87)}.blue-grey-900{background-color:#263238;color:hsla(0,0%,100%,.87)}.grey-50{background-color:#fafafa}.grey-50,.grey-100{color:rgba(0,0,0,.87)}.grey-100{background-color:#f5f5f5}.grey-200{background-color:#eee}.grey-200,.grey-300{color:rgba(0,0,0,.87)}.grey-300{background-color:#e0e0e0}.grey-400{background-color:#bdbdbd}.grey-400,.grey-500{color:rgba(0,0,0,.87)}.grey-500{background-color:#9e9e9e}.grey-600{background-color:#757575}.grey-600,.grey-700{color:hsla(0,0%,100%,.87)}.grey-700{background-color:#616161}.grey-800{background-color:#424242}.grey-800,.grey-900{color:hsla(0,0%,100%,.87)}.grey-900{background-color:#212121}.md-form-group{padding:18px 0 24px;position:relative}.md-input{background:transparent;position:relative;z-index:5;border:0;box-shadow:none;border-radius:0;border-bottom:1px solid hsla(0,0%,63%,.2);width:100%;height:34px;padding:2px;color:inherit}.md-input.focus,.md-input:focus{border-color:#0cc2aa;border-bottom-width:2px;padding-bottom:1px}.md-input.focus~label,.md-input:focus~label{color:#0cc2aa;opacity:1;top:0!important;font-size:.85em!important}.float-label .md-input~label{top:20px;font-size:1em}.float-label .md-input.has-value~label,.float-label .md-input.ng-dirty~label,.md-input~label{top:0;font-size:.85em}.md-input~label{transition:all .2s;position:absolute;z-index:0;opacity:.5;display:inline-block;left:0}.md-input.disabled,.md-input[disabled]{opacity:.5}textarea.md-input{height:auto}.md-input-white.focus,.md-input-white:focus{border-color:#fff}.md-input-white.focus~label,.md-input-white:focus~label{color:#fff}.md-input-msg{position:absolute;bottom:0;line-height:24px;font-size:.85em}.md-input-msg.right{right:0}.md-check{cursor:pointer;padding-left:1.25rem;margin:0;display:inline-block;position:relative}.md-check input{position:absolute;cursor:pointer;z-index:1;opacity:0;margin-left:-1.25rem}.md-check input:checked+i:before{border-width:0;background-color:inherit}.md-check input:checked+span .active{display:inherit}.md-check input[type=radio]+i,.md-check input[type=radio]+i:before{border-radius:50%}.md-check input[type=checkbox]:checked+i:after{transform:rotate(45deg);position:absolute;left:6px;top:2px;display:table;width:6px;height:12px;border:2px solid;border-top:0;border-left:0;content:\" \"}.md-check input[type=radio]:checked+i:after{position:absolute;left:6px;top:6px;display:table;width:6px;height:6px;background:#fff;border-radius:50%;content:\" \"}.md-check input[disabled]+i:before,.md-check input[disabled]:checked+i:before,fieldset[disabled] .md-check input+i:before{opacity:.5}.md-check>i{width:0;height:18px;line-height:1;margin-left:-20px;margin-top:1px;float:left;display:inline-block;vertical-align:middle;margin-right:28px;position:relative}.md-check>i:before{content:\"\";position:absolute;width:18px;height:100%;border:2px solid #9e9e9e;border-radius:2px}.md-check>i.no-icon:after{display:none!important}.md-switch{cursor:pointer;padding-left:36px;margin:0;min-height:20px}.md-switch input{position:absolute;cursor:pointer;width:36px;height:20px;z-index:1;opacity:0;margin-left:-36px}.md-switch input:checked+i:before{background:inherit;opacity:.5}.md-switch input:checked+i:after{background:inherit;left:16px}.md-switch input[disabled]+i:before,fieldset[disabled] .md-switch input+i:before{background-color:rgba(0,0,0,.12)}.md-switch input[disabled]+i:after,fieldset[disabled] .md-switch input+i:after{background-color:#bdbdbd}.md-switch i{width:0;height:18px;line-height:1;margin-left:-36px;margin-top:-2px;display:inline-block;vertical-align:middle;margin-right:44px;position:relative}.md-switch i:before{left:1px;width:34px;top:3px;height:14px;border-radius:8px;background-color:#9e9e9e}.md-switch i:after,.md-switch i:before{content:\"\";position:absolute;transition:all .2s}.md-switch i:after{margin:0;left:0;top:0;outline:none;height:20px;width:20px;border-radius:50%;background-color:#fff;box-shadow:0 2px 5px 0 rgba(0,0,0,.26)}.animated{animation-duration:.5s}[ui-view].ng-leave{display:none}[ui-view].ng-leave.smooth{display:block}.smooth.ng-animate{position:absolute;width:100%;height:100%;overflow:hidden}.fade-in-right-big.ng-enter{animation:fadeInRightBig .5s}.fade-in-right-big.ng-leave{animation:fadeOutLeftBig .5s}.fade-in-left-big.ng-enter{animation:fadeInLeftBig .5s}.fade-in-left-big.ng-leave{animation:fadeOutRightBig .5s}.fade-in-up-big.ng-enter{animation:fadeInUpBig .5s}.fade-in-up-big.ng-leave{animation:fadeOutUpBig .5s}.fade-in-down-big.ng-enter{animation:fadeInDownBig .5s}.fade-in-down-big.ng-leave{animation:fadeOutDownBig .5s}.fade-in.ng-enter{animation:fadeIn .5s}.fade-in.ng-leave{animation:fadeOut .5s}.fade-in-right.ng-enter{animation:fadeInRight .5s}.fade-in-right.ng-leave{animation:fadeOutLeft .5s}.fade-in-left.ng-enter{animation:fadeInLeft .5s}.fade-in-left.ng-leave{animation:fadeOutRight .5s}.fade-in-up.ng-enter{animation:fadeInUp .5s}.fade-in-up.ng-leave{animation:fadeOutUp .5s}.fade-in-down.ng-enter{animation:fadeInDown .5s}.fade-in-down.ng-leave{animation:fadeOutDown .5s}.datetimepicker{border-radius:4px;direction:ltr;display:block;margin-top:1px;user-select:none;width:320px}.datetimepicker>div{display:none}.datetimepicker .hour,.datetimepicker .minute{height:34px;line-height:34px;margin:0;width:25%}.datetimepicker .table{margin:0}.datetimepicker .table td,.datetimepicker .table th{border:0;border-radius:4px;height:20px;text-align:center}.datetimepicker .day:hover,.datetimepicker .hour:hover,.datetimepicker .left:hover,.datetimepicker .minute:hover,.datetimepicker .right:hover,.datetimepicker .switch:hover{background:#eee;cursor:pointer}.datetimepicker .disabled,.datetimepicker .disabled:hover{background:none;color:#ebebeb;cursor:default}.datetimepicker .active,.datetimepicker .active.disabled,.datetimepicker .active.disabled:hover,.datetimepicker .active:hover{background-color:#04c;background-image:linear-gradient(180deg,#08c,#04c);background-repeat:repeat-x;border-color:#04c #04c #002a80;color:#fff;filter:progid:dximagetransform.microsoft.gradient(startColorstr=\"#08c\",endColorstr=\"#04c\",GradientType=0);text-shadow:0 -1px 0 rgba(0,0,0,.25)}.datetimepicker .current,.datetimepicker .current.disabled,.datetimepicker .current.disabled:hover,.datetimepicker .current:hover{background-color:#e5e5e5}.datetimepicker .active.active,.datetimepicker .active.disabled,.datetimepicker .active.disabled.active,.datetimepicker .active.disabled.disabled,.datetimepicker .active.disabled:active,.datetimepicker .active.disabled:hover,.datetimepicker .active.disabled:hover.active,.datetimepicker .active.disabled:hover.disabled,.datetimepicker .active.disabled:hover:active,.datetimepicker .active.disabled:hover:hover,.datetimepicker .active:active,.datetimepicker .active:hover,.datetimepicker .active:hover.active,.datetimepicker .active:hover.disabled,.datetimepicker .active:hover:active,.datetimepicker .active:hover:hover,.datetimepicker span.active.disabled:hover[disabled],.datetimepicker span.active.disabled[disabled],.datetimepicker span.active:hover[disabled],.datetimepicker span.active[disabled],.datetimepicker td.active.disabled:hover[disabled],.datetimepicker td.active.disabled[disabled],.datetimepicker td.active:hover[disabled],.datetimepicker td.active[disabled]{background-color:#04c}.datetimepicker span{border-radius:4px;cursor:pointer;display:block;float:left;height:54px;line-height:54px;margin:1%;width:23%}.datetimepicker span:hover{background:#eee}.datetimepicker .future,.datetimepicker .past{color:#999}body{font-family:Tahoma,Roboto,Helvetica Neue,Helvetica,Arial,sans-serif}.app-aside{left:auto!important}@media (min-width:992px){.app-aside.lg:not(.hide)~.app-content{margin-right:13.75rem}.app-aside.sm:not(.hide)~.app-content{margin-right:11.25rem}.app-aside.folded:not(.hide)~.app-content{margin-right:4rem}.app-aside.folded.md:not(.hide)~.app-content{margin-right:5rem}.app-aside:not(.hide)~.app-content{margin-right:12.5rem}.app-content{margin-left:auto!important}.hide-scroll{margin-right:0;margin-left:-17px}}@media (min-width:992px){body.container .app-header{margin-left:auto;margin-right:0}}.navside .nav li li a{padding-left:1rem;padding-right:3.5rem}.navside .nav li li li a{padding-left:1rem;padding-right:4.5rem}.navside .nav li li li li a{padding-left:1rem;padding-right:5.5rem}.nav-icon{float:right;margin-left:1rem;margin-right:inherit}.nav-caret,.nav-label{float:left;margin-right:1rem;margin-left:inherit}@media (min-width:992px){.folded.nav-expand.active .nav>li>a,.folded.nav-expand:focus .nav>li>a,.folded.nav-expand:hover .nav>li>a{text-align:right}.folded.nav-expand.active .nav>li>a .nav-icon,.folded.nav-expand:focus .nav>li>a .nav-icon,.folded.nav-expand:hover .nav>li>a .nav-icon{float:right;margin-left:16px;margin-right:0}.folded.nav-expand.active .navbar,.folded.nav-expand:focus .navbar,.folded.nav-expand:hover .navbar{text-align:right}.folded.nav-dropdown .nav>li>ul{left:auto;right:100%}}.navbar-brand>span{margin-left:0;margin-right:10px}.navbar-item{margin-right:inherit;margin-left:1rem}.m-r{margin-left:1rem!important;margin-right:auto!important}.m-l{margin-right:1rem!important;margin-left:auto!important}.m-r-lg{margin-left:3rem!important;margin-right:auto!important}.m-l-lg{margin-right:3rem!important;margin-left:auto!important}.m-r-md{margin-left:1.5rem!important;margin-right:auto!important}.m-l-md{margin-right:1.5rem!important;margin-left:auto!important}.m-r-sm{margin-left:.5rem!important;margin-right:auto!important}.m-l-sm{margin-right:.5rem!important;margin-left:auto!important}.m-r-xs{margin-left:.25rem!important;margin-right:auto!important}.m-l-xs{margin-right:.25rem!important;margin-left:auto!important}.box-tool{left:1rem;right:auto}.list-left{float:right;padding-left:1rem;padding-right:0}.list-left+.list-body{margin-left:0;margin-right:56px}.streamline{border-left-width:0;border-right-width:1px;border-right-style:solid}.streamline .sl-icon:before,.streamline .sl-item:before,.streamline:after{margin-left:0;margin-right:-4px;top:6px;left:auto;right:0}.sl-icon{left:auto;right:-10px}.sl-left{float:right;margin-right:-20px;margin-left:0}.sl-left+.sl-content{margin-right:36px;margin-left:auto}.sl-content{margin-left:0;margin-right:24px}.tl-wrap{margin-left:0;margin-right:6em;border-width:0 2px 0 0;padding:15px 20px 15px 0}.tl-wrap:before{float:right;margin-right:-26px}.timeline-center .tl-item{margin-right:50%;margin-left:0}.timeline-center .tl-wrap{margin-right:-2px!important}.tl-date{text-align:left;float:right;margin-right:-7.5em}.ui-check>i{margin-right:-20px;margin-left:4px}.ui-switch input:checked+i:after{margin-right:15px;margin-left:0}.ui-switch-md input:checked+i:after{margin-right:17px;margin-left:0}.ui-switch-lg input:checked+i:after{margin-right:21px;margin-left:0}.md-check{padding-left:0;padding-right:20px}.md-check input[type=checkbox]:checked+i:after,.md-check input[type=radio]:checked+i:after{left:auto;right:6px}.md-check>i{float:right;margin-left:28px;margin-right:-20px}.md-switch{padding-left:0;padding-right:36px}.md-switch>i{margin-right:0;margin-left:8px}.md-input~label{left:auto;right:0}.switcher{left:-240px;right:auto}.switcher .sw-btn{left:auto;right:-42px;border-right-width:1px;border-left-width:0}.switcher.active{left:-1px;right:auto}.app-rtl .rtl-pull-left{right:-120px}", ""]);
	
	// exports


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(__webpack_module_template_argument_0__);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(428)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./style.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./style.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js